/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 63);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Caml_array = __webpack_require__(9);

function app(_f, _args) {
  while(true) {
    var args = _args;
    var f = _f;
    var arity = f.length;
    var arity$1 = arity === 0 ? 1 : arity;
    var len = args.length;
    var d = arity$1 - len | 0;
    if (d === 0) {
      return f.apply(null, args);
    } else if (d < 0) {
      _args = Caml_array.caml_array_sub(args, arity$1, -d | 0);
      _f = f.apply(null, Caml_array.caml_array_sub(args, 0, arity$1));
      continue ;
      
    } else {
      return (function(f,args){
      return function (x) {
        return app(f, args.concat(/* array */[x]));
      }
      }(f,args));
    }
  };
}

function curry_1(o, a0, arity) {
  if (arity > 7 || arity < 0) {
    return app(o, /* array */[a0]);
  } else {
    switch (arity) {
      case 0 : 
      case 1 : 
          return o(a0);
      case 2 : 
          return (function (param) {
              return o(a0, param);
            });
      case 3 : 
          return (function (param, param$1) {
              return o(a0, param, param$1);
            });
      case 4 : 
          return (function (param, param$1, param$2) {
              return o(a0, param, param$1, param$2);
            });
      case 5 : 
          return (function (param, param$1, param$2, param$3) {
              return o(a0, param, param$1, param$2, param$3);
            });
      case 6 : 
          return (function (param, param$1, param$2, param$3, param$4) {
              return o(a0, param, param$1, param$2, param$3, param$4);
            });
      case 7 : 
          return (function (param, param$1, param$2, param$3, param$4, param$5) {
              return o(a0, param, param$1, param$2, param$3, param$4, param$5);
            });
      
    }
  }
}

function _1(o, a0) {
  var arity = o.length;
  if (arity === 1) {
    return o(a0);
  } else {
    return curry_1(o, a0, arity);
  }
}

function __1(o) {
  var arity = o.length;
  if (arity === 1) {
    return o;
  } else {
    return (function (a0) {
        return _1(o, a0);
      });
  }
}

function curry_2(o, a0, a1, arity) {
  if (arity > 7 || arity < 0) {
    return app(o, /* array */[
                a0,
                a1
              ]);
  } else {
    switch (arity) {
      case 0 : 
      case 1 : 
          return app(o(a0), /* array */[a1]);
      case 2 : 
          return o(a0, a1);
      case 3 : 
          return (function (param) {
              return o(a0, a1, param);
            });
      case 4 : 
          return (function (param, param$1) {
              return o(a0, a1, param, param$1);
            });
      case 5 : 
          return (function (param, param$1, param$2) {
              return o(a0, a1, param, param$1, param$2);
            });
      case 6 : 
          return (function (param, param$1, param$2, param$3) {
              return o(a0, a1, param, param$1, param$2, param$3);
            });
      case 7 : 
          return (function (param, param$1, param$2, param$3, param$4) {
              return o(a0, a1, param, param$1, param$2, param$3, param$4);
            });
      
    }
  }
}

function _2(o, a0, a1) {
  var arity = o.length;
  if (arity === 2) {
    return o(a0, a1);
  } else {
    return curry_2(o, a0, a1, arity);
  }
}

function __2(o) {
  var arity = o.length;
  if (arity === 2) {
    return o;
  } else {
    return (function (a0, a1) {
        return _2(o, a0, a1);
      });
  }
}

function curry_3(o, a0, a1, a2, arity) {
  var exit = 0;
  if (arity > 7 || arity < 0) {
    return app(o, /* array */[
                a0,
                a1,
                a2
              ]);
  } else {
    switch (arity) {
      case 0 : 
      case 1 : 
          exit = 1;
          break;
      case 2 : 
          return app(o(a0, a1), /* array */[a2]);
      case 3 : 
          return o(a0, a1, a2);
      case 4 : 
          return (function (param) {
              return o(a0, a1, a2, param);
            });
      case 5 : 
          return (function (param, param$1) {
              return o(a0, a1, a2, param, param$1);
            });
      case 6 : 
          return (function (param, param$1, param$2) {
              return o(a0, a1, a2, param, param$1, param$2);
            });
      case 7 : 
          return (function (param, param$1, param$2, param$3) {
              return o(a0, a1, a2, param, param$1, param$2, param$3);
            });
      
    }
  }
  if (exit === 1) {
    return app(o(a0), /* array */[
                a1,
                a2
              ]);
  }
  
}

function _3(o, a0, a1, a2) {
  var arity = o.length;
  if (arity === 3) {
    return o(a0, a1, a2);
  } else {
    return curry_3(o, a0, a1, a2, arity);
  }
}

function __3(o) {
  var arity = o.length;
  if (arity === 3) {
    return o;
  } else {
    return (function (a0, a1, a2) {
        return _3(o, a0, a1, a2);
      });
  }
}

function curry_4(o, a0, a1, a2, a3, arity) {
  var exit = 0;
  if (arity > 7 || arity < 0) {
    return app(o, /* array */[
                a0,
                a1,
                a2,
                a3
              ]);
  } else {
    switch (arity) {
      case 0 : 
      case 1 : 
          exit = 1;
          break;
      case 2 : 
          return app(o(a0, a1), /* array */[
                      a2,
                      a3
                    ]);
      case 3 : 
          return app(o(a0, a1, a2), /* array */[a3]);
      case 4 : 
          return o(a0, a1, a2, a3);
      case 5 : 
          return (function (param) {
              return o(a0, a1, a2, a3, param);
            });
      case 6 : 
          return (function (param, param$1) {
              return o(a0, a1, a2, a3, param, param$1);
            });
      case 7 : 
          return (function (param, param$1, param$2) {
              return o(a0, a1, a2, a3, param, param$1, param$2);
            });
      
    }
  }
  if (exit === 1) {
    return app(o(a0), /* array */[
                a1,
                a2,
                a3
              ]);
  }
  
}

function _4(o, a0, a1, a2, a3) {
  var arity = o.length;
  if (arity === 4) {
    return o(a0, a1, a2, a3);
  } else {
    return curry_4(o, a0, a1, a2, a3, arity);
  }
}

function __4(o) {
  var arity = o.length;
  if (arity === 4) {
    return o;
  } else {
    return (function (a0, a1, a2, a3) {
        return _4(o, a0, a1, a2, a3);
      });
  }
}

function curry_5(o, a0, a1, a2, a3, a4, arity) {
  var exit = 0;
  if (arity > 7 || arity < 0) {
    return app(o, /* array */[
                a0,
                a1,
                a2,
                a3,
                a4
              ]);
  } else {
    switch (arity) {
      case 0 : 
      case 1 : 
          exit = 1;
          break;
      case 2 : 
          return app(o(a0, a1), /* array */[
                      a2,
                      a3,
                      a4
                    ]);
      case 3 : 
          return app(o(a0, a1, a2), /* array */[
                      a3,
                      a4
                    ]);
      case 4 : 
          return app(o(a0, a1, a2, a3), /* array */[a4]);
      case 5 : 
          return o(a0, a1, a2, a3, a4);
      case 6 : 
          return (function (param) {
              return o(a0, a1, a2, a3, a4, param);
            });
      case 7 : 
          return (function (param, param$1) {
              return o(a0, a1, a2, a3, a4, param, param$1);
            });
      
    }
  }
  if (exit === 1) {
    return app(o(a0), /* array */[
                a1,
                a2,
                a3,
                a4
              ]);
  }
  
}

function _5(o, a0, a1, a2, a3, a4) {
  var arity = o.length;
  if (arity === 5) {
    return o(a0, a1, a2, a3, a4);
  } else {
    return curry_5(o, a0, a1, a2, a3, a4, arity);
  }
}

function __5(o) {
  var arity = o.length;
  if (arity === 5) {
    return o;
  } else {
    return (function (a0, a1, a2, a3, a4) {
        return _5(o, a0, a1, a2, a3, a4);
      });
  }
}

function curry_6(o, a0, a1, a2, a3, a4, a5, arity) {
  var exit = 0;
  if (arity > 7 || arity < 0) {
    return app(o, /* array */[
                a0,
                a1,
                a2,
                a3,
                a4,
                a5
              ]);
  } else {
    switch (arity) {
      case 0 : 
      case 1 : 
          exit = 1;
          break;
      case 2 : 
          return app(o(a0, a1), /* array */[
                      a2,
                      a3,
                      a4,
                      a5
                    ]);
      case 3 : 
          return app(o(a0, a1, a2), /* array */[
                      a3,
                      a4,
                      a5
                    ]);
      case 4 : 
          return app(o(a0, a1, a2, a3), /* array */[
                      a4,
                      a5
                    ]);
      case 5 : 
          return app(o(a0, a1, a2, a3, a4), /* array */[a5]);
      case 6 : 
          return o(a0, a1, a2, a3, a4, a5);
      case 7 : 
          return (function (param) {
              return o(a0, a1, a2, a3, a4, a5, param);
            });
      
    }
  }
  if (exit === 1) {
    return app(o(a0), /* array */[
                a1,
                a2,
                a3,
                a4,
                a5
              ]);
  }
  
}

function _6(o, a0, a1, a2, a3, a4, a5) {
  var arity = o.length;
  if (arity === 6) {
    return o(a0, a1, a2, a3, a4, a5);
  } else {
    return curry_6(o, a0, a1, a2, a3, a4, a5, arity);
  }
}

function __6(o) {
  var arity = o.length;
  if (arity === 6) {
    return o;
  } else {
    return (function (a0, a1, a2, a3, a4, a5) {
        return _6(o, a0, a1, a2, a3, a4, a5);
      });
  }
}

function curry_7(o, a0, a1, a2, a3, a4, a5, a6, arity) {
  var exit = 0;
  if (arity > 7 || arity < 0) {
    return app(o, /* array */[
                a0,
                a1,
                a2,
                a3,
                a4,
                a5,
                a6
              ]);
  } else {
    switch (arity) {
      case 0 : 
      case 1 : 
          exit = 1;
          break;
      case 2 : 
          return app(o(a0, a1), /* array */[
                      a2,
                      a3,
                      a4,
                      a5,
                      a6
                    ]);
      case 3 : 
          return app(o(a0, a1, a2), /* array */[
                      a3,
                      a4,
                      a5,
                      a6
                    ]);
      case 4 : 
          return app(o(a0, a1, a2, a3), /* array */[
                      a4,
                      a5,
                      a6
                    ]);
      case 5 : 
          return app(o(a0, a1, a2, a3, a4), /* array */[
                      a5,
                      a6
                    ]);
      case 6 : 
          return app(o(a0, a1, a2, a3, a4, a5), /* array */[a6]);
      case 7 : 
          return o(a0, a1, a2, a3, a4, a5, a6);
      
    }
  }
  if (exit === 1) {
    return app(o(a0), /* array */[
                a1,
                a2,
                a3,
                a4,
                a5,
                a6
              ]);
  }
  
}

function _7(o, a0, a1, a2, a3, a4, a5, a6) {
  var arity = o.length;
  if (arity === 7) {
    return o(a0, a1, a2, a3, a4, a5, a6);
  } else {
    return curry_7(o, a0, a1, a2, a3, a4, a5, a6, arity);
  }
}

function __7(o) {
  var arity = o.length;
  if (arity === 7) {
    return o;
  } else {
    return (function (a0, a1, a2, a3, a4, a5, a6) {
        return _7(o, a0, a1, a2, a3, a4, a5, a6);
      });
  }
}

function curry_8(o, a0, a1, a2, a3, a4, a5, a6, a7, arity) {
  var exit = 0;
  if (arity > 7 || arity < 0) {
    return app(o, /* array */[
                a0,
                a1,
                a2,
                a3,
                a4,
                a5,
                a6,
                a7
              ]);
  } else {
    switch (arity) {
      case 0 : 
      case 1 : 
          exit = 1;
          break;
      case 2 : 
          return app(o(a0, a1), /* array */[
                      a2,
                      a3,
                      a4,
                      a5,
                      a6,
                      a7
                    ]);
      case 3 : 
          return app(o(a0, a1, a2), /* array */[
                      a3,
                      a4,
                      a5,
                      a6,
                      a7
                    ]);
      case 4 : 
          return app(o(a0, a1, a2, a3), /* array */[
                      a4,
                      a5,
                      a6,
                      a7
                    ]);
      case 5 : 
          return app(o(a0, a1, a2, a3, a4), /* array */[
                      a5,
                      a6,
                      a7
                    ]);
      case 6 : 
          return app(o(a0, a1, a2, a3, a4, a5), /* array */[
                      a6,
                      a7
                    ]);
      case 7 : 
          return app(o(a0, a1, a2, a3, a4, a5, a6), /* array */[a7]);
      
    }
  }
  if (exit === 1) {
    return app(o(a0), /* array */[
                a1,
                a2,
                a3,
                a4,
                a5,
                a6,
                a7
              ]);
  }
  
}

function _8(o, a0, a1, a2, a3, a4, a5, a6, a7) {
  var arity = o.length;
  if (arity === 8) {
    return o(a0, a1, a2, a3, a4, a5, a6, a7);
  } else {
    return curry_8(o, a0, a1, a2, a3, a4, a5, a6, a7, arity);
  }
}

function __8(o) {
  var arity = o.length;
  if (arity === 8) {
    return o;
  } else {
    return (function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return _8(o, a0, a1, a2, a3, a4, a5, a6, a7);
      });
  }
}

exports.app = app;
exports.curry_1 = curry_1;
exports._1 = _1;
exports.__1 = __1;
exports.curry_2 = curry_2;
exports._2 = _2;
exports.__2 = __2;
exports.curry_3 = curry_3;
exports._3 = _3;
exports.__3 = __3;
exports.curry_4 = curry_4;
exports._4 = _4;
exports.__4 = __4;
exports.curry_5 = curry_5;
exports._5 = _5;
exports.__5 = __5;
exports.curry_6 = curry_6;
exports._6 = _6;
exports.__6 = __6;
exports.curry_7 = curry_7;
exports._7 = _7;
exports.__7 = __7;
exports.curry_8 = curry_8;
exports._8 = _8;
exports.__8 = __8;
/* No side effect */


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(103);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var List = __webpack_require__(19);
var Curry = __webpack_require__(0);
var React = __webpack_require__(1);
var Caml_builtin_exceptions = __webpack_require__(3);
var ReasonReactOptimizedCreateClass = __webpack_require__(104);

function createDomElement(s, props, children) {
  var vararg = /* array */[
      s,
      props
    ].concat(children);
  return React.createElement.apply(null, vararg);
}

var magicNull = null;

function $$default() {
  return /* () */0;
}

function chain(handlerOne, handlerTwo, payload) {
  Curry._1(handlerOne, payload);
  return Curry._1(handlerTwo, payload);
}

var Callback = /* module */[
  /* default */$$default,
  /* chain */chain
];

function lifecycleNoUpdate() {
  return /* NoUpdate */0;
}

function lifecyclePreviousNextUnit() {
  return /* () */0;
}

function lifecyclePreviousCurrentReturnUnit() {
  return /* () */0;
}

function lifecycleReturnUnit() {
  return /* () */0;
}

function lifecycleReturnTrue() {
  return /* true */1;
}

function willReceivePropsDefault(param) {
  return param[/* state */2];
}

function renderDefault() {
  return "RenderNotImplemented";
}

function initialStateDefault() {
  return /* () */0;
}

function reducerDefault(_, _$1) {
  return /* NoUpdate */0;
}

function subscriptionsDefault() {
  return /* [] */0;
}

function convertPropsIfTheyreFromJs(props, jsPropsToReason, debugName) {
  var match = props.reasonProps;
  if (match == null) {
    if (jsPropsToReason) {
      return /* Element */[Curry._1(jsPropsToReason[0], props)];
    } else {
      throw [
            Caml_builtin_exceptions.invalid_argument,
            "A JS component called the Reason component " + (debugName + " which didn't implement the JS->Reason React props conversion.")
          ];
    }
  } else {
    return match;
  }
}

function createClass(debugName) {
  return ReasonReactOptimizedCreateClass.createClass({
              displayName: debugName,
              subscriptions: null,
              self: (function (state, retainedProps) {
                  var $$this = this ;
                  return /* record */[
                          /* handle */$$this.handleMethod,
                          /* reduce */$$this.reduceMethod,
                          /* state */state,
                          /* retainedProps */retainedProps,
                          /* send */$$this.sendMethod
                        ];
                }),
              transitionNextTotalState: (function (curTotalState, reasonStateUpdate) {
                  if (typeof reasonStateUpdate === "number") {
                    return curTotalState;
                  } else {
                    switch (reasonStateUpdate.tag | 0) {
                      case 0 : 
                          return {
                                  reasonState: reasonStateUpdate[0],
                                  reasonStateVersion: curTotalState.reasonStateVersion + 1 | 0,
                                  reasonStateVersionUsedToComputeSubelements: curTotalState.reasonStateVersionUsedToComputeSubelements,
                                  sideEffects: curTotalState.sideEffects
                                };
                      case 1 : 
                          return {
                                  reasonState: reasonStateUpdate[0],
                                  reasonStateVersion: curTotalState.reasonStateVersion + 1 | 0,
                                  reasonStateVersionUsedToComputeSubelements: curTotalState.reasonStateVersionUsedToComputeSubelements + 1 | 0,
                                  sideEffects: curTotalState.sideEffects
                                };
                      case 2 : 
                          return {
                                  reasonState: curTotalState.reasonState,
                                  reasonStateVersion: curTotalState.reasonStateVersion + 1 | 0,
                                  reasonStateVersionUsedToComputeSubelements: curTotalState.reasonStateVersionUsedToComputeSubelements + 1 | 0,
                                  sideEffects: /* :: */[
                                    reasonStateUpdate[0],
                                    curTotalState.sideEffects
                                  ]
                                };
                      case 3 : 
                          return {
                                  reasonState: reasonStateUpdate[0],
                                  reasonStateVersion: curTotalState.reasonStateVersion + 1 | 0,
                                  reasonStateVersionUsedToComputeSubelements: curTotalState.reasonStateVersionUsedToComputeSubelements,
                                  sideEffects: /* :: */[
                                    reasonStateUpdate[1],
                                    curTotalState.sideEffects
                                  ]
                                };
                      case 4 : 
                          return {
                                  reasonState: reasonStateUpdate[0],
                                  reasonStateVersion: curTotalState.reasonStateVersion + 1 | 0,
                                  reasonStateVersionUsedToComputeSubelements: curTotalState.reasonStateVersionUsedToComputeSubelements + 1 | 0,
                                  sideEffects: /* :: */[
                                    reasonStateUpdate[1],
                                    curTotalState.sideEffects
                                  ]
                                };
                      
                    }
                  }
                }),
              getInitialState: (function () {
                  var thisJs = (this);
                  var convertedReasonProps = convertPropsIfTheyreFromJs(thisJs.props, thisJs.jsPropsToReason, debugName);
                  var initialReasonState = Curry._1(convertedReasonProps[0][/* initialState */10], /* () */0);
                  return {
                          reasonState: initialReasonState,
                          reasonStateVersion: 1,
                          reasonStateVersionUsedToComputeSubelements: 1,
                          sideEffects: /* [] */0
                        };
                }),
              componentDidMount: (function () {
                  var $$this = this ;
                  var thisJs = (this);
                  var convertedReasonProps = convertPropsIfTheyreFromJs(thisJs.props, thisJs.jsPropsToReason, debugName);
                  var component = convertedReasonProps[0];
                  var curTotalState = thisJs.state;
                  var curReasonState = curTotalState.reasonState;
                  var self = $$this.self(curReasonState, component[/* retainedProps */11]);
                  if (component[/* subscriptions */13] !== subscriptionsDefault) {
                    var subscriptions = List.map((function (param) {
                            var unsubscribe = param[1];
                            var token = Curry._1(param[0], /* () */0);
                            return (function () {
                                return Curry._1(unsubscribe, token);
                              });
                          }), Curry._1(component[/* subscriptions */13], self));
                    $$this.subscriptions = subscriptions;
                  }
                  if (component[/* didMount */4] !== lifecycleNoUpdate) {
                    var reasonStateUpdate = Curry._1(component[/* didMount */4], self);
                    var nextTotalState = $$this.transitionNextTotalState(curTotalState, reasonStateUpdate);
                    if (nextTotalState.reasonStateVersion !== curTotalState.reasonStateVersion) {
                      return thisJs.setState(nextTotalState);
                    } else {
                      return 0;
                    }
                  } else {
                    return 0;
                  }
                }),
              componentDidUpdate: (function (prevProps, prevState) {
                  var $$this = this ;
                  var thisJs = (this);
                  var curState = thisJs.state;
                  var curReasonState = curState.reasonState;
                  var newJsProps = thisJs.props;
                  var newConvertedReasonProps = convertPropsIfTheyreFromJs(newJsProps, thisJs.jsPropsToReason, debugName);
                  var newComponent = newConvertedReasonProps[0];
                  if (newComponent[/* didUpdate */5] !== lifecyclePreviousCurrentReturnUnit) {
                    var match = +(prevProps === newJsProps);
                    var oldConvertedReasonProps = match !== 0 ? newConvertedReasonProps : convertPropsIfTheyreFromJs(prevProps, thisJs.jsPropsToReason, debugName);
                    var prevReasonState = prevState.reasonState;
                    var newSelf = $$this.self(curReasonState, newComponent[/* retainedProps */11]);
                    var oldSelf_000 = /* handle */newSelf[/* handle */0];
                    var oldSelf_001 = /* reduce */newSelf[/* reduce */1];
                    var oldSelf_003 = /* retainedProps */oldConvertedReasonProps[0][/* retainedProps */11];
                    var oldSelf_004 = /* send */newSelf[/* send */4];
                    var oldSelf = /* record */[
                      oldSelf_000,
                      oldSelf_001,
                      /* state */prevReasonState,
                      oldSelf_003,
                      oldSelf_004
                    ];
                    return Curry._1(newComponent[/* didUpdate */5], /* record */[
                                /* oldSelf */oldSelf,
                                /* newSelf */newSelf
                              ]);
                  } else {
                    return 0;
                  }
                }),
              componentWillUnmount: (function () {
                  var $$this = this ;
                  var thisJs = (this);
                  var convertedReasonProps = convertPropsIfTheyreFromJs(thisJs.props, thisJs.jsPropsToReason, debugName);
                  var component = convertedReasonProps[0];
                  var curState = thisJs.state;
                  var curReasonState = curState.reasonState;
                  if (component[/* willUnmount */6] !== lifecycleReturnUnit) {
                    Curry._1(component[/* willUnmount */6], $$this.self(curReasonState, component[/* retainedProps */11]));
                  }
                  var match = $$this.subscriptions;
                  if (match == null) {
                    return /* () */0;
                  } else {
                    return List.iter((function (unsubscribe) {
                                  return Curry._1(unsubscribe, /* () */0);
                                }), List.rev(match));
                  }
                }),
              componentWillUpdate: (function (nextProps, nextState) {
                  var $$this = this ;
                  var thisJs = (this);
                  var newConvertedReasonProps = convertPropsIfTheyreFromJs(nextProps, thisJs.jsPropsToReason, debugName);
                  var newComponent = newConvertedReasonProps[0];
                  if (newComponent[/* willUpdate */7] !== lifecyclePreviousNextUnit) {
                    var oldJsProps = thisJs.props;
                    var match = +(nextProps === oldJsProps);
                    var oldConvertedReasonProps = match !== 0 ? newConvertedReasonProps : convertPropsIfTheyreFromJs(oldJsProps, thisJs.jsPropsToReason, debugName);
                    var curState = thisJs.state;
                    var curReasonState = curState.reasonState;
                    var nextReasonState = nextState.reasonState;
                    var newSelf = $$this.self(nextReasonState, newComponent[/* retainedProps */11]);
                    var oldSelf_000 = /* handle */newSelf[/* handle */0];
                    var oldSelf_001 = /* reduce */newSelf[/* reduce */1];
                    var oldSelf_003 = /* retainedProps */oldConvertedReasonProps[0][/* retainedProps */11];
                    var oldSelf_004 = /* send */newSelf[/* send */4];
                    var oldSelf = /* record */[
                      oldSelf_000,
                      oldSelf_001,
                      /* state */curReasonState,
                      oldSelf_003,
                      oldSelf_004
                    ];
                    return Curry._1(newComponent[/* willUpdate */7], /* record */[
                                /* oldSelf */oldSelf,
                                /* newSelf */newSelf
                              ]);
                  } else {
                    return 0;
                  }
                }),
              componentWillReceiveProps: (function (nextProps) {
                  var $$this = this ;
                  var thisJs = (this);
                  var newConvertedReasonProps = convertPropsIfTheyreFromJs(nextProps, thisJs.jsPropsToReason, debugName);
                  var newComponent = newConvertedReasonProps[0];
                  if (newComponent[/* willReceiveProps */3] !== willReceivePropsDefault) {
                    var oldJsProps = thisJs.props;
                    var match = +(nextProps === oldJsProps);
                    var oldConvertedReasonProps = match !== 0 ? newConvertedReasonProps : convertPropsIfTheyreFromJs(oldJsProps, thisJs.jsPropsToReason, debugName);
                    var oldComponent = oldConvertedReasonProps[0];
                    return thisJs.setState((function (curTotalState, _) {
                                  var curReasonState = curTotalState.reasonState;
                                  var curReasonStateVersion = curTotalState.reasonStateVersion;
                                  var oldSelf = $$this.self(curReasonState, oldComponent[/* retainedProps */11]);
                                  var nextReasonState = Curry._1(newComponent[/* willReceiveProps */3], oldSelf);
                                  var match = +(nextReasonState !== curReasonState);
                                  var nextReasonStateVersion = match !== 0 ? curReasonStateVersion + 1 | 0 : curReasonStateVersion;
                                  if (nextReasonStateVersion !== curReasonStateVersion) {
                                    return {
                                            reasonState: nextReasonState,
                                            reasonStateVersion: nextReasonStateVersion,
                                            reasonStateVersionUsedToComputeSubelements: curTotalState.reasonStateVersionUsedToComputeSubelements,
                                            sideEffects: nextReasonState.sideEffects
                                          };
                                  } else {
                                    return curTotalState;
                                  }
                                }));
                  } else {
                    return 0;
                  }
                }),
              shouldComponentUpdate: (function (nextJsProps, nextState, _) {
                  var $$this = this ;
                  var thisJs = (this);
                  var curJsProps = thisJs.props;
                  var propsWarrantRerender = +(nextJsProps !== curJsProps);
                  var oldConvertedReasonProps = convertPropsIfTheyreFromJs(thisJs.props, thisJs.jsPropsToReason, debugName);
                  var match = +(nextJsProps === curJsProps);
                  var newConvertedReasonProps = match !== 0 ? oldConvertedReasonProps : convertPropsIfTheyreFromJs(nextJsProps, thisJs.jsPropsToReason, debugName);
                  var newComponent = newConvertedReasonProps[0];
                  var nextReasonStateVersion = nextState.reasonStateVersion;
                  var nextReasonStateVersionUsedToComputeSubelements = nextState.reasonStateVersionUsedToComputeSubelements;
                  var stateChangeWarrantsComputingSubelements = +(nextReasonStateVersionUsedToComputeSubelements !== nextReasonStateVersion);
                  var warrantsUpdate = propsWarrantRerender || stateChangeWarrantsComputingSubelements;
                  var nextReasonState = nextState.reasonState;
                  var newSelf = $$this.self(nextReasonState, newComponent[/* retainedProps */11]);
                  var ret;
                  if (warrantsUpdate && newComponent[/* shouldUpdate */8] !== lifecycleReturnTrue) {
                    var curState = thisJs.state;
                    var curReasonState = curState.reasonState;
                    var oldSelf_000 = /* handle */newSelf[/* handle */0];
                    var oldSelf_001 = /* reduce */newSelf[/* reduce */1];
                    var oldSelf_003 = /* retainedProps */oldConvertedReasonProps[0][/* retainedProps */11];
                    var oldSelf_004 = /* send */newSelf[/* send */4];
                    var oldSelf = /* record */[
                      oldSelf_000,
                      oldSelf_001,
                      /* state */curReasonState,
                      oldSelf_003,
                      oldSelf_004
                    ];
                    ret = Curry._1(newComponent[/* shouldUpdate */8], /* record */[
                          /* oldSelf */oldSelf,
                          /* newSelf */newSelf
                        ]);
                  } else {
                    ret = warrantsUpdate;
                  }
                  nextState.reasonStateVersionUsedToComputeSubelements = nextReasonStateVersion;
                  var nextSideEffects = List.rev(nextState.sideEffects);
                  if (nextSideEffects !== /* [] */0) {
                    List.iter((function (performSideEffects) {
                            return Curry._1(performSideEffects, newSelf);
                          }), nextSideEffects);
                    thisJs.setState((function (futureTotalState, _) {
                            var initialSegment = function (_acc, _n, _l) {
                              while(true) {
                                var l = _l;
                                var n = _n;
                                var acc = _acc;
                                if (l && n > 0) {
                                  _l = l[1];
                                  _n = n - 1 | 0;
                                  _acc = /* :: */[
                                    l[0],
                                    acc
                                  ];
                                  continue ;
                                  
                                } else {
                                  return List.rev(acc);
                                }
                              };
                            };
                            var n = List.length(futureTotalState.sideEffects) - List.length(nextState.sideEffects) | 0;
                            var newSideEffects = initialSegment(/* [] */0, n, futureTotalState.sideEffects);
                            return {
                                    reasonState: futureTotalState.reasonState,
                                    reasonStateVersion: futureTotalState.reasonStateVersion,
                                    reasonStateVersionUsedToComputeSubelements: futureTotalState.reasonStateVersionUsedToComputeSubelements,
                                    sideEffects: newSideEffects
                                  };
                          }));
                  }
                  return ret;
                }),
              handleMethod: (function (callback) {
                  var $$this = this ;
                  var thisJs = (this);
                  return (function (callbackPayload) {
                      var curState = thisJs.state;
                      var curReasonState = curState.reasonState;
                      var convertedReasonProps = convertPropsIfTheyreFromJs(thisJs.props, thisJs.jsPropsToReason, debugName);
                      return Curry._2(callback, callbackPayload, $$this.self(curReasonState, convertedReasonProps[0][/* retainedProps */11]));
                    });
                }),
              updateMethod: (function (callback) {
                  var $$this = this ;
                  var thisJs = (this);
                  return (function ($$event) {
                      var curTotalState = thisJs.state;
                      var curReasonState = curTotalState.reasonState;
                      var convertedReasonProps = convertPropsIfTheyreFromJs(thisJs.props, thisJs.jsPropsToReason, debugName);
                      var reasonStateUpdate = Curry._2(callback, $$event, $$this.self(curReasonState, convertedReasonProps[0][/* retainedProps */11]));
                      if (reasonStateUpdate === /* NoUpdate */0) {
                        return magicNull;
                      } else {
                        var nextTotalState = $$this.transitionNextTotalState(curTotalState, reasonStateUpdate);
                        if (nextTotalState.reasonStateVersion !== curTotalState.reasonStateVersion) {
                          return thisJs.setState(nextTotalState);
                        } else {
                          return 0;
                        }
                      }
                    });
                }),
              sendMethod: (function (action) {
                  var $$this = this ;
                  var thisJs = (this);
                  var convertedReasonProps = convertPropsIfTheyreFromJs(thisJs.props, thisJs.jsPropsToReason, debugName);
                  var component = convertedReasonProps[0];
                  if (component[/* reducer */12] !== reducerDefault) {
                    var partialStateApplication = Curry._1(component[/* reducer */12], action);
                    return thisJs.setState((function (curTotalState, _) {
                                  var curReasonState = curTotalState.reasonState;
                                  var reasonStateUpdate = Curry._1(partialStateApplication, curReasonState);
                                  if (reasonStateUpdate === /* NoUpdate */0) {
                                    return magicNull;
                                  } else {
                                    var nextTotalState = $$this.transitionNextTotalState(curTotalState, reasonStateUpdate);
                                    if (nextTotalState.reasonStateVersion !== curTotalState.reasonStateVersion) {
                                      return nextTotalState;
                                    } else {
                                      return magicNull;
                                    }
                                  }
                                }));
                  } else {
                    return 0;
                  }
                }),
              reduceMethod: (function (callback, payload) {
                  var $$this = this ;
                  return $$this.sendMethod(Curry._1(callback, payload));
                }),
              render: (function () {
                  var $$this = this ;
                  var thisJs = (this);
                  var convertedReasonProps = convertPropsIfTheyreFromJs(thisJs.props, thisJs.jsPropsToReason, debugName);
                  var created = convertedReasonProps[0];
                  var curState = thisJs.state;
                  var curReasonState = curState.reasonState;
                  return Curry._1(created[/* render */9], $$this.self(curReasonState, created[/* retainedProps */11]));
                })
            });
}

function basicComponent(debugName) {
  return /* record */[
          /* debugName */debugName,
          /* reactClassInternal */createClass(debugName),
          /* handedOffState : record */[/* contents : None */0],
          /* willReceiveProps */willReceivePropsDefault,
          /* didMount */lifecycleNoUpdate,
          /* didUpdate */lifecyclePreviousCurrentReturnUnit,
          /* willUnmount */lifecycleReturnUnit,
          /* willUpdate */lifecyclePreviousNextUnit,
          /* shouldUpdate */lifecycleReturnTrue,
          /* render */renderDefault,
          /* initialState */initialStateDefault,
          /* retainedProps : () */0,
          /* reducer */reducerDefault,
          /* subscriptions */subscriptionsDefault,
          /* jsElementWrapped : None */0
        ];
}

var statelessComponent = basicComponent;

var statelessComponentWithRetainedProps = basicComponent;

var reducerComponent = basicComponent;

var reducerComponentWithRetainedProps = basicComponent;

function element($staropt$star, $staropt$star$1, component) {
  var key = $staropt$star ? $staropt$star[0] : undefined;
  var ref = $staropt$star$1 ? $staropt$star$1[0] : undefined;
  var element$1 = /* Element */[component];
  var match = component[/* jsElementWrapped */14];
  if (match) {
    return Curry._2(match[0], key, ref);
  } else {
    return React.createElement(component[/* reactClassInternal */1], {
                key: key,
                ref: ref,
                reasonProps: element$1
              });
  }
}

function wrapReasonForJs(component, jsPropsToReason) {
  var tmp = component[/* reactClassInternal */1].prototype;
  tmp.jsPropsToReason = /* Some */[jsPropsToReason];
  return component[/* reactClassInternal */1];
}

var dummyInteropComponent = basicComponent("interop");

function wrapJsForReason(reactClass, props, children) {
  var jsElementWrapped = /* Some */[(function (param, param$1) {
        var reactClass$1 = reactClass;
        var props$1 = props;
        var children$1 = children;
        var key = param;
        var ref = param$1;
        var props$2 = Object.assign(Object.assign({ }, props$1), {
              ref: ref,
              key: key
            });
        var varargs = /* array */[
            reactClass$1,
            props$2
          ].concat(children$1);
        return React.createElement.apply(null, varargs);
      })];
  var newrecord = dummyInteropComponent.slice();
  newrecord[/* jsElementWrapped */14] = jsElementWrapped;
  return newrecord;
}

function path() {
  var match = typeof (window) === "undefined" ? undefined : (window);
  if (match !== undefined) {
    var raw = match.location.pathname;
    switch (raw) {
      case "" : 
      case "/" : 
          return /* [] */0;
      default:
        var raw$1 = raw.slice(1);
        var match$1 = raw$1[raw$1.length - 1 | 0];
        var raw$2 = match$1 === "/" ? raw$1.slice(0, -1) : raw$1;
        var a = raw$2.split("/");
        var _i = a.length - 1 | 0;
        var _res = /* [] */0;
        while(true) {
          var res = _res;
          var i = _i;
          if (i < 0) {
            return res;
          } else {
            _res = /* :: */[
              a[i],
              res
            ];
            _i = i - 1 | 0;
            continue ;
            
          }
        };
    }
  } else {
    return /* [] */0;
  }
}

function hash() {
  var match = typeof (window) === "undefined" ? undefined : (window);
  if (match !== undefined) {
    var raw = match.location.hash;
    switch (raw) {
      case "" : 
      case "#" : 
          return "";
      default:
        return raw.slice(1);
    }
  } else {
    return "";
  }
}

function search() {
  var match = typeof (window) === "undefined" ? undefined : (window);
  if (match !== undefined) {
    var raw = match.location.search;
    switch (raw) {
      case "" : 
      case "?" : 
          return "";
      default:
        return raw.slice(1);
    }
  } else {
    return "";
  }
}

function push(path) {
  var match = typeof (history) === "undefined" ? undefined : (history);
  var match$1 = typeof (window) === "undefined" ? undefined : (window);
  if (match !== undefined && match$1 !== undefined) {
    match.pushState((null), "", path);
    match$1.dispatchEvent(new Event("popstate"));
    return /* () */0;
  } else {
    return /* () */0;
  }
}

function url() {
  return /* record */[
          /* path */path(/* () */0),
          /* hash */hash(/* () */0),
          /* search */search(/* () */0)
        ];
}

function watchUrl(callback) {
  var match = typeof (window) === "undefined" ? undefined : (window);
  if (match !== undefined) {
    var watcherID = function () {
      return Curry._1(callback, url(/* () */0));
    };
    match.addEventListener("popstate", watcherID);
    return watcherID;
  } else {
    return (function () {
        return /* () */0;
      });
  }
}

function unwatchUrl(watcherID) {
  var match = typeof (window) === "undefined" ? undefined : (window);
  if (match !== undefined) {
    match.removeEventListener("popstate", watcherID);
    return /* () */0;
  } else {
    return /* () */0;
  }
}

var Router = [
  push,
  watchUrl,
  unwatchUrl,
  url
];

exports.Callback = Callback;
exports.statelessComponent = statelessComponent;
exports.statelessComponentWithRetainedProps = statelessComponentWithRetainedProps;
exports.reducerComponent = reducerComponent;
exports.reducerComponentWithRetainedProps = reducerComponentWithRetainedProps;
exports.element = element;
exports.wrapReasonForJs = wrapReasonForJs;
exports.createDomElement = createDomElement;
exports.wrapJsForReason = wrapJsForReason;
exports.Router = Router;
/* magicNull Not a pure module */


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var out_of_memory = /* tuple */[
  "Out_of_memory",
  0
];

var sys_error = /* tuple */[
  "Sys_error",
  -1
];

var failure = /* tuple */[
  "Failure",
  -2
];

var invalid_argument = /* tuple */[
  "Invalid_argument",
  -3
];

var end_of_file = /* tuple */[
  "End_of_file",
  -4
];

var division_by_zero = /* tuple */[
  "Division_by_zero",
  -5
];

var not_found = /* tuple */[
  "Not_found",
  -6
];

var match_failure = /* tuple */[
  "Match_failure",
  -7
];

var stack_overflow = /* tuple */[
  "Stack_overflow",
  -8
];

var sys_blocked_io = /* tuple */[
  "Sys_blocked_io",
  -9
];

var assert_failure = /* tuple */[
  "Assert_failure",
  -10
];

var undefined_recursive_module = /* tuple */[
  "Undefined_recursive_module",
  -11
];

out_of_memory.tag = 248;

sys_error.tag = 248;

failure.tag = 248;

invalid_argument.tag = 248;

end_of_file.tag = 248;

division_by_zero.tag = 248;

not_found.tag = 248;

match_failure.tag = 248;

stack_overflow.tag = 248;

sys_blocked_io.tag = 248;

assert_failure.tag = 248;

undefined_recursive_module.tag = 248;

exports.out_of_memory = out_of_memory;
exports.sys_error = sys_error;
exports.failure = failure;
exports.invalid_argument = invalid_argument;
exports.end_of_file = end_of_file;
exports.division_by_zero = division_by_zero;
exports.not_found = not_found;
exports.match_failure = match_failure;
exports.stack_overflow = stack_overflow;
exports.sys_blocked_io = sys_blocked_io;
exports.assert_failure = assert_failure;
exports.undefined_recursive_module = undefined_recursive_module;
/*  Not a pure module */


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var List = __webpack_require__(19);
var Glamor = __webpack_require__(36);
var Js_dict = __webpack_require__(40);

function join(separator, strings) {
  var _acc = "";
  var _strings = strings;
  while(true) {
    var strings$1 = _strings;
    var acc = _acc;
    if (strings$1) {
      var xs = strings$1[1];
      var x = strings$1[0];
      if (xs) {
        _strings = xs;
        _acc = acc + (x + separator);
        continue ;
        
      } else {
        return acc + x;
      }
    } else {
      return acc;
    }
  };
}

((
      function (styles) {
          const glamor = __webpack_require__(36);
          return glamor.css.apply(glamor, styles)
      }
  ));

function makeDict(ruleset) {
  var toJs = function (rule) {
    var variant = rule[0];
    if (variant !== -659583595) {
      if (variant >= 488687584) {
        if (variant >= 829240095) {
          var match = rule[1];
          return /* tuple */[
                  match[0],
                  makeDict(match[1])
                ];
        } else {
          return /* tuple */[
                  "boxShadow",
                  rule[1]
                ];
        }
      } else if (variant >= -434952966) {
        var match$1 = rule[1];
        return /* tuple */[
                match$1[0],
                match$1[1]
              ];
      } else {
        return /* tuple */[
                "animation",
                rule[1]
              ];
      }
    } else {
      return /* tuple */[
              "transition",
              rule[1]
            ];
    }
  };
  return Js_dict.fromList(List.map(toJs, ruleset));
}

function $$global(selector, rules) {
  Glamor.css.global(selector, makeDict(rules));
  return /* () */0;
}

function keyframes(frames) {
  var addStop = function (dict, param) {
    dict[String(param[0]) + "%"] = makeDict(param[1]);
    return dict;
  };
  return Glamor.css.keyframes(List.fold_left(addStop, { }, frames));
}

function style(rules) {
  return Glamor.css(makeDict(List.rev(rules))).toString();
}

function d(property, value) {
  return /* `declaration */[
          -434952966,
          /* tuple */[
            property,
            value
          ]
        ];
}

function func(name, args) {
  return name + ("(" + (join(", ", args) + ")"));
}

function string_of_float(f) {
  return "" + (String(f) + "");
}

function important(v) {
  if (typeof v === "number" || v[0] !== -434952966) {
    return v;
  } else {
    var match = v[1];
    return /* `declaration */[
            -434952966,
            /* tuple */[
              match[0],
              match[1] + " !important"
            ]
          ];
  }
}

function label(label$1) {
  return /* `declaration */[
          -434952966,
          /* tuple */[
            "label",
            label$1
          ]
        ];
}

function string_of_angle(param) {
  var variant = param[0];
  if (variant >= 4995526) {
    if (variant >= 5690837) {
      return string_of_float(param[1]) + "rad";
    } else {
      return String(param[1]) + "deg";
    }
  } else if (variant >= -855250051) {
    return string_of_float(param[1]) + "turn";
  } else {
    return string_of_float(param[1]) + "grad";
  }
}

function deg(x) {
  return /* `deg */[
          4995526,
          x
        ];
}

function rad(x) {
  return /* `rad */[
          5690837,
          x
        ];
}

function grad(x) {
  return /* `grad */[
          -999567410,
          x
        ];
}

function turn(x) {
  return /* `turn */[
          -855250051,
          x
        ];
}

function string_of_color(param) {
  if (typeof param === "number") {
    if (param >= 582626130) {
      return "transparent";
    } else {
      return "currentColor";
    }
  } else {
    var variant = param[0];
    if (variant !== -878128972) {
      if (variant >= 5197569) {
        if (variant >= 5692173) {
          var match = param[1];
          return "rgb(" + (join(", ", /* :: */[
                        String(match[0]),
                        /* :: */[
                          String(match[1]),
                          /* :: */[
                            String(match[2]),
                            /* [] */0
                          ]
                        ]
                      ]) + ")");
        } else {
          var match$1 = param[1];
          return "hsl(" + (join(", ", /* :: */[
                        String(match$1[0]),
                        /* :: */[
                          String(match$1[1]) + "%",
                          /* :: */[
                            String(match$1[2]) + "%",
                            /* [] */0
                          ]
                        ]
                      ]) + ")");
        }
      } else if (variant >= 5194459) {
        return "#" + param[1];
      } else {
        var match$2 = param[1];
        return "hsla(" + (join(", ", /* :: */[
                      String(match$2[0]),
                      /* :: */[
                        String(match$2[1]) + "%",
                        /* :: */[
                          String(match$2[2]) + "%",
                          /* :: */[
                            string_of_float(match$2[3]),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]) + ")");
      }
    } else {
      var match$3 = param[1];
      return "rgba(" + (join(", ", /* :: */[
                    String(match$3[0]),
                    /* :: */[
                      String(match$3[1]),
                      /* :: */[
                        String(match$3[2]),
                        /* :: */[
                          string_of_float(match$3[3]),
                          /* [] */0
                        ]
                      ]
                    ]
                  ]) + ")");
    }
  }
}

function rgb(r, g, b) {
  return /* `rgb */[
          5692173,
          /* tuple */[
            r,
            g,
            b
          ]
        ];
}

function rgba(r, g, b, a) {
  return /* `rgba */[
          -878128972,
          /* tuple */[
            r,
            g,
            b,
            a
          ]
        ];
}

function hsl(h, s, l) {
  return /* `hsl */[
          5197569,
          /* tuple */[
            h,
            s,
            l
          ]
        ];
}

function hsla(h, s, l, a) {
  return /* `hsla */[
          -988425664,
          /* tuple */[
            h,
            s,
            l,
            a
          ]
        ];
}

function hex(x) {
  return /* `hex */[
          5194459,
          x
        ];
}

function string_of_stops(stops) {
  return join(", ", List.map((function (param) {
                    return join(" ", /* :: */[
                                string_of_color(param[1]),
                                /* :: */[
                                  String(param[0]) + "%",
                                  /* [] */0
                                ]
                              ]);
                  }), stops));
}

function linearGradient(angle, stops) {
  return /* `linearGradient */[
          616379637,
          /* tuple */[
            angle,
            stops
          ]
        ];
}

function repeatingLinearGradient(angle, stops) {
  return /* `repeatingLinearGradient */[
          -160280644,
          /* tuple */[
            angle,
            stops
          ]
        ];
}

function radialGradient(stops) {
  return /* `radialGradient */[
          119548911,
          stops
        ];
}

function repeatingRadialGradient(stops) {
  return /* `repeatingRadialGradient */[
          -657111370,
          stops
        ];
}

function string_of_length(param) {
  if (typeof param === "number") {
    return "0";
  } else {
    var variant = param[0];
    if (variant >= 22643) {
      if (variant >= 25096) {
        if (variant >= 26433) {
          if (variant >= 5691738) {
            return string_of_float(param[1]) + "rem";
          } else {
            return string_of_float(param[1]) + "vw";
          }
        } else if (variant >= 26418) {
          return string_of_float(param[1]) + "vh";
        } else {
          return String(param[1]) + "px";
        }
      } else if (variant !== 24416) {
        if (variant >= 25092) {
          return String(param[1]) + "pt";
        } else {
          return string_of_float(param[1]) + "ex";
        }
      } else {
        return string_of_float(param[1]) + "mm";
      }
    } else if (variant >= -119887163) {
      if (variant >= 22186) {
        if (variant >= 22632) {
          return string_of_float(param[1]) + "em";
        } else {
          return string_of_float(param[1]) + "cm";
        }
      } else if (variant >= 22181) {
        return string_of_float(param[1]) + "ch";
      } else {
        return string_of_float(param[1]) + "%";
      }
    } else if (variant !== -833472530) {
      if (variant >= -833470756) {
        return string_of_float(param[1]) + "vmin";
      } else {
        var match = param[1];
        if (match[0] >= 5745024) {
          return "calc(" + (string_of_length(match[1]) + (" - " + (string_of_length(match[2]) + ")")));
        } else {
          return "calc(" + (string_of_length(match[1]) + (" + " + (string_of_length(match[2]) + ")")));
        }
      }
    } else {
      return string_of_float(param[1]) + "vmax";
    }
  }
}

function ch(x) {
  return /* `ch */[
          22181,
          x
        ];
}

function cm(x) {
  return /* `cm */[
          22186,
          x
        ];
}

function em(x) {
  return /* `em */[
          22632,
          x
        ];
}

function ex(x) {
  return /* `ex */[
          22643,
          x
        ];
}

function mm(x) {
  return /* `mm */[
          24416,
          x
        ];
}

function pct(x) {
  return /* `percent */[
          -119887163,
          x
        ];
}

function pt(x) {
  return /* `pt */[
          25092,
          x
        ];
}

function px(x) {
  return /* `px */[
          25096,
          x
        ];
}

function rem(x) {
  return /* `rem */[
          5691738,
          x
        ];
}

function vh(x) {
  return /* `vh */[
          26418,
          x
        ];
}

function vmax(x) {
  return /* `vmax */[
          -833472530,
          x
        ];
}

function vmin(x) {
  return /* `vmin */[
          -833470756,
          x
        ];
}

function vw(x) {
  return /* `vw */[
          26433,
          x
        ];
}

function $neg(a, b) {
  return /* `calc */[
          -1044768619,
          /* tuple */[
            /* sub */5745024,
            a,
            b
          ]
        ];
}

function $plus(a, b) {
  return /* `calc */[
          -1044768619,
          /* tuple */[
            /* add */4846113,
            a,
            b
          ]
        ];
}

var Calc = /* module */[
  /* - */$neg,
  /* + */$plus
];

function size(x, y) {
  return /* `size */[
          -866934591,
          /* tuple */[
            x,
            y
          ]
        ];
}

function count(x) {
  return /* `count */[
          -899463985,
          x
        ];
}

function cubicBesier(a, b, c, d) {
  return /* `cubicBezier */[
          -554785527,
          /* tuple */[
            a,
            b,
            c,
            d
          ]
        ];
}

function rotate(a) {
  return /* `rotate */[
          -887077285,
          a
        ];
}

function rotate3d(x, y, z, a) {
  return /* `rotate3d */[
          142802924,
          /* tuple */[
            x,
            y,
            z,
            a
          ]
        ];
}

function rotateX(a) {
  return /* `rotateX */[
          -249738851,
          a
        ];
}

function rotateY(a) {
  return /* `rotateY */[
          -249738850,
          a
        ];
}

function rotateZ(a) {
  return /* `rotateZ */[
          -249738849,
          a
        ];
}

function scale(x, y) {
  return /* `scale */[
          -120664438,
          /* tuple */[
            x,
            y
          ]
        ];
}

function scale3d(x, y, z) {
  return /* `scale3d */[
          -452513317,
          /* tuple */[
            x,
            y,
            z
          ]
        ];
}

function scaleX(x) {
  return /* `scaleX */[
          1009117838,
          x
        ];
}

function scaleY(x) {
  return /* `scaleY */[
          1009117839,
          x
        ];
}

function scaleZ(x) {
  return /* `scaleZ */[
          1009117840,
          x
        ];
}

function skew(x, y) {
  return /* `skew */[
          -866839798,
          /* tuple */[
            x,
            y
          ]
        ];
}

function skewX(a) {
  return /* `skewX */[
          -31746546,
          a
        ];
}

function skewY(a) {
  return /* `skewY */[
          -31746545,
          a
        ];
}

function steps(i, dir) {
  return /* `steps */[
          68058023,
          /* tuple */[
            i,
            dir
          ]
        ];
}

function translate(x, y) {
  return /* `translate */[
          -914368690,
          /* tuple */[
            x,
            y
          ]
        ];
}

function translate3d(x, y, z) {
  return /* `translate3d */[
          178189215,
          /* tuple */[
            x,
            y,
            z
          ]
        ];
}

function translateX(x) {
  return /* `translateX */[
          106728778,
          x
        ];
}

function translateY(y) {
  return /* `translateY */[
          106728779,
          y
        ];
}

function translateZ(z) {
  return /* `translateZ */[
          106728780,
          z
        ];
}

function url(x) {
  return /* `url */[
          5843823,
          x
        ];
}

function display(x) {
  return d("display", x >= -147785676 ? (
                x >= 423610969 ? (
                    x >= 888960333 ? "block" : "inline"
                  ) : (
                    x >= 53323314 ? "inline-flex" : "inline-block"
                  )
              ) : (
                x >= -922086728 ? "none" : "flex"
              ));
}

function position(x) {
  return d("position", x !== 10615156 ? (
                x >= 188263721 ? (
                    x >= 903134412 ? "relative" : "sticky"
                  ) : (
                    x >= 100392110 ? "static" : "absolute"
                  )
              ) : "fixed");
}

function top(x) {
  return d("top", string_of_length(x));
}

function bottom(x) {
  return d("bottom", string_of_length(x));
}

function left(x) {
  return d("left", string_of_length(x));
}

function right(x) {
  return d("right", string_of_length(x));
}

function flex(x) {
  return d("flex", String(x));
}

function flexGrow(x) {
  return d("flexGrow", String(x));
}

function flexShrink(x) {
  return d("flexShrink", String(x));
}

function flexBasis(x) {
  var tmp;
  if (typeof x === "number") {
    tmp = x >= -550577721 ? (
        x >= 60557045 ? (
            x >= 427265337 ? "content" : "max-content"
          ) : (
            x >= -195805336 ? "fit-content" : "min-content"
          )
      ) : (
        x !== -1011102077 ? (
            x >= -789508312 ? "0" : "auto"
          ) : "fill"
      );
  } else {
    var variant = x[0];
    if (variant >= 22643) {
      tmp = variant >= 25096 ? (
          variant >= 26433 ? (
              variant >= 5691738 ? string_of_float(x[1]) + "rem" : string_of_float(x[1]) + "vw"
            ) : (
              variant >= 26418 ? string_of_float(x[1]) + "vh" : String(x[1]) + "px"
            )
        ) : (
          variant !== 24416 ? (
              variant >= 25092 ? String(x[1]) + "pt" : string_of_float(x[1]) + "ex"
            ) : string_of_float(x[1]) + "mm"
        );
    } else if (variant >= -119887163) {
      tmp = variant >= 22186 ? (
          variant >= 22632 ? string_of_float(x[1]) + "em" : string_of_float(x[1]) + "cm"
        ) : (
          variant >= 22181 ? string_of_float(x[1]) + "ch" : string_of_float(x[1]) + "%"
        );
    } else if (variant !== -833472530) {
      if (variant >= -833470756) {
        tmp = string_of_float(x[1]) + "vmin";
      } else {
        var match = x[1];
        tmp = match[0] >= 5745024 ? "calc(" + (string_of_length(match[1]) + (" - " + (string_of_length(match[2]) + ")"))) : "calc(" + (string_of_length(match[1]) + (" + " + (string_of_length(match[2]) + ")")));
      }
    } else {
      tmp = string_of_float(x[1]) + "vmax";
    }
  }
  return d("flexBasis", tmp);
}

function flexDirection(x) {
  return d("flexDirection", x >= 135477484 ? (
                x >= 378951208 ? "row-reverse" : "column-reverse"
              ) : (
                x >= 5693978 ? "row" : "column"
              ));
}

function flexWrap(x) {
  return d("flexWrap", x !== -463121288 ? (
                x >= 867913355 ? "nowrap" : "wrap"
              ) : "wrap-reverse");
}

function order(x) {
  return d("order", String(x));
}

function string_of_margin(param) {
  if (typeof param === "number") {
    if (param >= -789508312) {
      return "0";
    } else {
      return "auto";
    }
  } else {
    var variant = param[0];
    if (variant >= 22643) {
      if (variant >= 25096) {
        if (variant >= 26433) {
          if (variant >= 5691738) {
            return string_of_float(param[1]) + "rem";
          } else {
            return string_of_float(param[1]) + "vw";
          }
        } else if (variant >= 26418) {
          return string_of_float(param[1]) + "vh";
        } else {
          return String(param[1]) + "px";
        }
      } else if (variant !== 24416) {
        if (variant >= 25092) {
          return String(param[1]) + "pt";
        } else {
          return string_of_float(param[1]) + "ex";
        }
      } else {
        return string_of_float(param[1]) + "mm";
      }
    } else if (variant >= -119887163) {
      if (variant >= 22186) {
        if (variant >= 22632) {
          return string_of_float(param[1]) + "em";
        } else {
          return string_of_float(param[1]) + "cm";
        }
      } else if (variant >= 22181) {
        return string_of_float(param[1]) + "ch";
      } else {
        return string_of_float(param[1]) + "%";
      }
    } else if (variant !== -833472530) {
      if (variant >= -833470756) {
        return string_of_float(param[1]) + "vmin";
      } else {
        var match = param[1];
        if (match[0] >= 5745024) {
          return "calc(" + (string_of_length(match[1]) + (" - " + (string_of_length(match[2]) + ")")));
        } else {
          return "calc(" + (string_of_length(match[1]) + (" + " + (string_of_length(match[2]) + ")")));
        }
      }
    } else {
      return string_of_float(param[1]) + "vmax";
    }
  }
}

function margin(x) {
  return d("margin", string_of_margin(x));
}

function margin2(v, h) {
  return d("margin", join(" ", List.map(string_of_margin, /* :: */[
                      v,
                      /* :: */[
                        h,
                        /* [] */0
                      ]
                    ])));
}

function margin3(top, h, bottom) {
  return d("margin", join(" ", List.map(string_of_margin, /* :: */[
                      top,
                      /* :: */[
                        h,
                        /* :: */[
                          bottom,
                          /* [] */0
                        ]
                      ]
                    ])));
}

function margin4(top, right, bottom, left) {
  return d("margin", join(" ", List.map(string_of_margin, /* :: */[
                      top,
                      /* :: */[
                        right,
                        /* :: */[
                          bottom,
                          /* :: */[
                            left,
                            /* [] */0
                          ]
                        ]
                      ]
                    ])));
}

function marginLeft(x) {
  return d("marginLeft", string_of_margin(x));
}

function marginRight(x) {
  return d("marginRight", string_of_margin(x));
}

function marginTop(x) {
  return d("marginTop", string_of_margin(x));
}

function marginBottom(x) {
  return d("marginBottom", string_of_margin(x));
}

function padding(x) {
  return d("padding", string_of_length(x));
}

function padding2(v, h) {
  return d("padding", join(" ", List.map(string_of_length, /* :: */[
                      v,
                      /* :: */[
                        h,
                        /* [] */0
                      ]
                    ])));
}

function padding3(top, h, bottom) {
  return d("padding", join(" ", List.map(string_of_length, /* :: */[
                      top,
                      /* :: */[
                        h,
                        /* :: */[
                          bottom,
                          /* [] */0
                        ]
                      ]
                    ])));
}

function padding4(top, right, bottom, left) {
  return d("padding", join(" ", List.map(string_of_length, /* :: */[
                      top,
                      /* :: */[
                        right,
                        /* :: */[
                          bottom,
                          /* :: */[
                            left,
                            /* [] */0
                          ]
                        ]
                      ]
                    ])));
}

function paddingLeft(x) {
  return d("paddingLeft", string_of_length(x));
}

function paddingRight(x) {
  return d("paddingRight", string_of_length(x));
}

function paddingTop(x) {
  return d("paddingTop", string_of_length(x));
}

function paddingBottom(x) {
  return d("paddingBottom", string_of_length(x));
}

function string_of_dimension(param) {
  if (typeof param === "number") {
    if (param >= -789508312) {
      return "0";
    } else {
      return "auto";
    }
  } else {
    var variant = param[0];
    if (variant >= 22643) {
      if (variant >= 25096) {
        if (variant >= 26433) {
          if (variant >= 5691738) {
            return string_of_float(param[1]) + "rem";
          } else {
            return string_of_float(param[1]) + "vw";
          }
        } else if (variant >= 26418) {
          return string_of_float(param[1]) + "vh";
        } else {
          return String(param[1]) + "px";
        }
      } else if (variant !== 24416) {
        if (variant >= 25092) {
          return String(param[1]) + "pt";
        } else {
          return string_of_float(param[1]) + "ex";
        }
      } else {
        return string_of_float(param[1]) + "mm";
      }
    } else if (variant >= -119887163) {
      if (variant >= 22186) {
        if (variant >= 22632) {
          return string_of_float(param[1]) + "em";
        } else {
          return string_of_float(param[1]) + "cm";
        }
      } else if (variant >= 22181) {
        return string_of_float(param[1]) + "ch";
      } else {
        return string_of_float(param[1]) + "%";
      }
    } else if (variant !== -833472530) {
      if (variant >= -833470756) {
        return string_of_float(param[1]) + "vmin";
      } else {
        var match = param[1];
        if (match[0] >= 5745024) {
          return "calc(" + (string_of_length(match[1]) + (" - " + (string_of_length(match[2]) + ")")));
        } else {
          return "calc(" + (string_of_length(match[1]) + (" + " + (string_of_length(match[2]) + ")")));
        }
      }
    } else {
      return string_of_float(param[1]) + "vmax";
    }
  }
}

function width(x) {
  return d("width", string_of_dimension(x));
}

function maxWidth(x) {
  return d("maxWidth", string_of_dimension(x));
}

function minWidth(x) {
  return d("minWidth", string_of_dimension(x));
}

function height(x) {
  return d("height", string_of_dimension(x));
}

function minHeight(x) {
  return d("minHeight", string_of_dimension(x));
}

function maxHeight(x) {
  return d("maxHeight", string_of_dimension(x));
}

function string_of_align(param) {
  if (param >= 98248149) {
    if (param >= 662439529) {
      if (param >= 924268066) {
        return "flex-end";
      } else {
        return "flex-start";
      }
    } else if (param >= 287825029) {
      return "baseline";
    } else {
      return "center";
    }
  } else if (param >= -162316795) {
    return "stretch";
  } else {
    return "auto";
  }
}

function alignItems(x) {
  return d("alignItems", string_of_align(x));
}

function alignSelf(x) {
  return d("alignSelf", string_of_align(x));
}

function string_of_justify(param) {
  if (param >= 98248149) {
    if (param >= 662439529) {
      if (param >= 924268066) {
        return "flex-end";
      } else {
        return "flex-start";
      }
    } else if (param >= 516682146) {
      return "space-between";
    } else {
      return "center";
    }
  } else if (param >= -162316795) {
    return "stretch";
  } else {
    return "space-around";
  }
}

function justifyContent(x) {
  return d("justifyContent", string_of_justify(x));
}

function alignContent(x) {
  return d("alignContent", string_of_justify(x));
}

function boxSizing(x) {
  return d("boxSizing", x >= 9307263 ? "border-box" : "content-box");
}

function $$float(x) {
  return d("float", x !== -922086728 ? (
                x >= -379319332 ? "right" : "left"
              ) : "none");
}

function clear(x) {
  return d("clear", x !== -944764921 ? (
                x >= -379319332 ? "right" : "both"
              ) : "left");
}

function string_of_overflow(param) {
  if (param >= -862584982) {
    if (param >= 589592690) {
      return "visible";
    } else {
      return "hidden";
    }
  } else if (param >= -949692403) {
    return "scroll";
  } else {
    return "auto";
  }
}

function overflow(x) {
  return d("overflow", string_of_overflow(x));
}

function overflowX(x) {
  return d("overflowX", string_of_overflow(x));
}

function overflowY(x) {
  return d("overflowY", string_of_overflow(x));
}

function zIndex(i) {
  return d("zIndex", String(i));
}

function backfaceVisibility(x) {
  return d("backfaceVisibility", x >= 589592690 ? "visible" : "hidden");
}

function visibility(x) {
  return d("visibility", x >= 589592690 ? "visible" : "hidden");
}

function boxShadow($staropt$star, $staropt$star$1, $staropt$star$2, $staropt$star$3, $staropt$star$4, color) {
  var x = $staropt$star ? $staropt$star[0] : /* zero */-789508312;
  var y = $staropt$star$1 ? $staropt$star$1[0] : /* zero */-789508312;
  var blur = $staropt$star$2 ? $staropt$star$2[0] : /* zero */-789508312;
  var spread = $staropt$star$3 ? $staropt$star$3[0] : /* zero */-789508312;
  var inset = $staropt$star$4 ? $staropt$star$4[0] : /* false */0;
  return /* `shadow */[
          488687584,
          join(" ", /* :: */[
                string_of_length(x),
                /* :: */[
                  string_of_length(y),
                  /* :: */[
                    string_of_length(blur),
                    /* :: */[
                      string_of_length(spread),
                      /* :: */[
                        string_of_color(color),
                        /* :: */[
                          inset !== 0 ? "inset" : "",
                          /* [] */0
                        ]
                      ]
                    ]
                  ]
                ]
              ])
        ];
}

function string_of_shadow(param) {
  return param[1];
}

function boxShadows(shadows) {
  return d("boxShadow", join(", ", List.map(string_of_shadow, shadows)));
}

function string_of_borderstyle(param) {
  if (param >= 568403505) {
    if (param >= 841979626) {
      return "dotted";
    } else {
      return "dashed";
    }
  } else if (param >= 12956715) {
    return "solid";
  } else {
    return "none";
  }
}

function border(px, style, color) {
  return d("border", join(" ", /* :: */[
                  string_of_length(px),
                  /* :: */[
                    string_of_borderstyle(style),
                    /* :: */[
                      string_of_color(color),
                      /* [] */0
                    ]
                  ]
                ]));
}

function borderWidth(x) {
  return d("borderWidth", string_of_length(x));
}

function borderStyle(x) {
  return d("borderStyle", string_of_borderstyle(x));
}

function borderColor(x) {
  return d("borderColor", string_of_color(x));
}

function borderLeft(px, style, color) {
  return d("borderLeft", join(" ", /* :: */[
                  string_of_length(px),
                  /* :: */[
                    string_of_borderstyle(style),
                    /* :: */[
                      string_of_color(color),
                      /* [] */0
                    ]
                  ]
                ]));
}

function borderLeftWidth(x) {
  return d("borderLeftWidth", string_of_length(x));
}

function borderLeftStyle(x) {
  return d("borderLeftStyle", string_of_borderstyle(x));
}

function borderLeftColor(x) {
  return d("borderLeftColor", string_of_color(x));
}

function borderRight(px, style, color) {
  return d("borderRight", join(" ", /* :: */[
                  string_of_length(px),
                  /* :: */[
                    string_of_borderstyle(style),
                    /* :: */[
                      string_of_color(color),
                      /* [] */0
                    ]
                  ]
                ]));
}

function borderRightWidth(x) {
  return d("borderRightWidth", string_of_length(x));
}

function borderRightColor(x) {
  return d("borderRightColor", string_of_color(x));
}

function borderRightStyle(x) {
  return d("borderRightStyle", string_of_borderstyle(x));
}

function borderTop(px, style, color) {
  return d("borderTop", join(" ", /* :: */[
                  string_of_length(px),
                  /* :: */[
                    string_of_borderstyle(style),
                    /* :: */[
                      string_of_color(color),
                      /* [] */0
                    ]
                  ]
                ]));
}

function borderTopWidth(x) {
  return d("borderTopWidth", string_of_length(x));
}

function borderTopStyle(x) {
  return d("borderTopStyle", string_of_borderstyle(x));
}

function borderTopColor(x) {
  return d("borderTopColor", string_of_color(x));
}

function borderBottom(px, style, color) {
  return d("borderBottom", join(" ", /* :: */[
                  string_of_length(px),
                  /* :: */[
                    string_of_borderstyle(style),
                    /* :: */[
                      string_of_color(color),
                      /* [] */0
                    ]
                  ]
                ]));
}

function borderBottomWidth(x) {
  return d("borderBottomWidth", string_of_length(x));
}

function borderBottomStyle(x) {
  return d("borderBottomStyle", string_of_borderstyle(x));
}

function borderBottomColor(x) {
  return d("borderBottomColor", string_of_color(x));
}

function borderRadius(i) {
  return d("borderRadius", string_of_length(i));
}

function borderTopLeftRadius(i) {
  return d("borderTopLeftRadius", string_of_length(i));
}

function borderTopRightRadius(i) {
  return d("borderTopRightRadius", string_of_length(i));
}

function borderBottomLeftRadius(i) {
  return d("borderBottomLeftRadius", string_of_length(i));
}

function borderBottomRightRadius(i) {
  return d("borderBottomRightRadius", string_of_length(i));
}

function background(x) {
  var tmp;
  if (typeof x === "number") {
    tmp = x !== 292050538 ? (
        x >= 582626130 ? "transparent" : "none"
      ) : "currentColor";
  } else {
    var variant = x[0];
    if (variant >= 5197569) {
      if (variant !== 5692173) {
        if (variant >= 119548911) {
          if (variant >= 616379637) {
            var match = x[1];
            tmp = "linear-gradient(" + (string_of_angle(match[0]) + (", " + (string_of_stops(match[1]) + ")")));
          } else {
            tmp = "radial-gradient(" + (string_of_stops(x[1]) + ")");
          }
        } else if (variant >= 5843823) {
          tmp = "url(" + (x[1] + ")");
        } else {
          var match$1 = x[1];
          tmp = "hsl(" + (join(", ", /* :: */[
                  String(match$1[0]),
                  /* :: */[
                    String(match$1[1]) + "%",
                    /* :: */[
                      String(match$1[2]) + "%",
                      /* [] */0
                    ]
                  ]
                ]) + ")");
        }
      } else {
        var match$2 = x[1];
        tmp = "rgb(" + (join(", ", /* :: */[
                String(match$2[0]),
                /* :: */[
                  String(match$2[1]),
                  /* :: */[
                    String(match$2[2]),
                    /* [] */0
                  ]
                ]
              ]) + ")");
      }
    } else if (variant !== -878128972) {
      if (variant >= -160280644) {
        if (variant >= 5194459) {
          tmp = "#" + x[1];
        } else {
          var match$3 = x[1];
          tmp = "repeating-linear-gradient(" + (string_of_angle(match$3[0]) + (", " + (string_of_stops(match$3[1]) + ")")));
        }
      } else if (variant >= -657111370) {
        tmp = "repeating-radial-gradient(" + (string_of_stops(x[1]) + ")");
      } else {
        var match$4 = x[1];
        tmp = "hsla(" + (join(", ", /* :: */[
                String(match$4[0]),
                /* :: */[
                  String(match$4[1]) + "%",
                  /* :: */[
                    String(match$4[2]) + "%",
                    /* :: */[
                      string_of_float(match$4[3]),
                      /* [] */0
                    ]
                  ]
                ]
              ]) + ")");
      }
    } else {
      var match$5 = x[1];
      tmp = "rgba(" + (join(", ", /* :: */[
              String(match$5[0]),
              /* :: */[
                String(match$5[1]),
                /* :: */[
                  String(match$5[2]),
                  /* :: */[
                    string_of_float(match$5[3]),
                    /* [] */0
                  ]
                ]
              ]
            ]) + ")");
    }
  }
  return d("background", tmp);
}

function backgroundColor(x) {
  return d("backgroundColor", string_of_color(x));
}

function backgroundImage(x) {
  var tmp;
  if (typeof x === "number") {
    tmp = "none";
  } else {
    var variant = x[0];
    if (variant !== -160280644) {
      if (variant >= 119548911) {
        if (variant >= 616379637) {
          var match = x[1];
          tmp = "linear-gradient(" + (string_of_angle(match[0]) + (", " + (string_of_stops(match[1]) + ")")));
        } else {
          tmp = "radial-gradient(" + (string_of_stops(x[1]) + ")");
        }
      } else {
        tmp = variant >= 5843823 ? "url(" + (x[1] + ")") : "repeating-radial-gradient(" + (string_of_stops(x[1]) + ")");
      }
    } else {
      var match$1 = x[1];
      tmp = "repeating-linear-gradient(" + (string_of_angle(match$1[0]) + (", " + (string_of_stops(match$1[1]) + ")")));
    }
  }
  return d("backgroundImage", tmp);
}

function backgroundAttachment(x) {
  return d("backgroundAttachment", x !== -118437525 ? (
                x >= 10615156 ? "fixed" : "scroll"
              ) : "local");
}

function backgroundClip(x) {
  return d("backgroundClip", x !== 9307263 ? (
                x >= 972575930 ? "padding-box" : "content-box"
              ) : "border-box");
}

function backgroundOrigin(x) {
  return d("backgroundOrigin", x !== 9307263 ? (
                x >= 972575930 ? "padding-box" : "content-box"
              ) : "border-box");
}

function backgroundPosition(x, y) {
  return d("backgroundPosition", string_of_length(x) + (" " + string_of_length(y)));
}

function backgroundRepeat(x) {
  return d("backgroundRepeat", x >= 646437021 ? (
                x >= 646437022 ? "repeat-y" : "repeat-x"
              ) : (
                x >= 108828507 ? "repeat" : "no-repeat"
              ));
}

function backgroundSize(x) {
  var tmp;
  if (typeof x === "number") {
    tmp = x !== -899416265 ? (
        x >= 427065300 ? "contain" : "auto"
      ) : "cover";
  } else {
    var match = x[1];
    tmp = string_of_length(match[0]) + (" " + string_of_length(match[1]));
  }
  return d("backgroundSize", tmp);
}

function cursor(x) {
  return d("cursor", x >= -459627717 ? (
                x >= 365450254 ? (
                    x !== 465819841 ? (
                        x >= 626862894 ? (
                            x >= 939907157 ? "not-allowed" : "context-menu"
                          ) : (
                            x >= 563171728 ? "alias" : "all-scroll"
                          )
                      ) : "default"
                  ) : (
                    x !== -88732200 ? (
                        x >= 103479213 ? (
                            x >= 180897442 ? "crosshair" : "progress"
                          ) : (
                            x >= -19620980 ? "grabbing" : "zoom-out"
                          )
                      ) : "zoom-in"
                  )
              ) : (
                x >= -933174511 ? (
                    x !== -922086728 ? (
                        x >= -822977931 ? (
                            x >= -786317123 ? "pointer" : "wait"
                          ) : (
                            x >= -856044371 ? "text" : "move"
                          )
                      ) : "none"
                  ) : (
                    x !== -1044569694 ? (
                        x >= -999567412 ? (
                            x >= -989121855 ? "help" : "grab"
                          ) : (
                            x >= -1044071499 ? "copy" : "auto"
                          )
                      ) : "cell"
                  )
              ));
}

function string_of_listStyleType(param) {
  if (param >= -484197732) {
    if (param >= 700345660) {
      if (param >= 787279419) {
        if (param >= 826920258) {
          return "upper-latin";
        } else {
          return "upper-roman";
        }
      } else if (param >= 739986499) {
        return "lower-latin";
      } else {
        return "lower-roman";
      }
    } else if (param >= -422333295) {
      return "decimal";
    } else {
      return "upper-alpha";
    }
  } else if (param !== -703761904) {
    if (param >= -655228771) {
      if (param >= -571131491) {
        return "lower-alpha";
      } else {
        return "square";
      }
    } else if (param >= -699686657) {
      return "lower-greek";
    } else {
      return "disc";
    }
  } else {
    return "circle";
  }
}

function string_of_listStylePosition(param) {
  if (param >= 501235708) {
    return "inside";
  } else {
    return "outside";
  }
}

function stirng_of_listStyleImage(param) {
  if (typeof param === "number") {
    return "none";
  } else {
    return func("url", /* :: */[
                param[1],
                /* [] */0
              ]);
  }
}

function listStyle(style, pos, img) {
  return d("listStyle", join(" ", /* :: */[
                  string_of_listStyleType(style),
                  /* :: */[
                    string_of_listStylePosition(pos),
                    /* :: */[
                      stirng_of_listStyleImage(img),
                      /* [] */0
                    ]
                  ]
                ]));
}

function listStyleType(x) {
  return d("listStyleType", string_of_listStyleType(x));
}

function listStylePosition(x) {
  return d("listStylePosition", string_of_listStylePosition(x));
}

function listStyleImage(x) {
  return d("listStyleImage", stirng_of_listStyleImage(x));
}

function opacity(x) {
  return d("opacity", string_of_float(x));
}

function string_of_outlineStyle(param) {
  if (param >= 472095738) {
    if (param !== 568403505) {
      if (param >= 852175633) {
        if (param >= 1042283741) {
          return "inset";
        } else {
          return "double";
        }
      } else if (param >= 841979626) {
        return "dotted";
      } else {
        return "grove";
      }
    } else {
      return "dashed";
    }
  } else if (param !== -862584982) {
    if (param >= 12956715) {
      if (param >= 209930196) {
        return "outset";
      } else {
        return "solid";
      }
    } else if (param >= -379468757) {
      return "ridge";
    } else {
      return "none";
    }
  } else {
    return "hidden";
  }
}

function outline(size, style, color) {
  return d("outline", join(" ", /* :: */[
                  string_of_length(size),
                  /* :: */[
                    string_of_outlineStyle(style),
                    /* :: */[
                      string_of_color(color),
                      /* [] */0
                    ]
                  ]
                ]));
}

function outlineStyle(x) {
  return d("outlineStyle", string_of_outlineStyle(x));
}

function outlineWidth(x) {
  return d("outlineWidth", string_of_length(x));
}

function outlineColor(x) {
  return d("outlineColor", string_of_color(x));
}

function outlineOffset(x) {
  return d("outlineOffset", string_of_length(x));
}

function color(x) {
  return d("color", string_of_color(x));
}

function fontFamily(x) {
  return d("fontFamily", x);
}

function fontSize(x) {
  return d("fontSize", string_of_length(x));
}

function fontVariant(x) {
  return d("fontVariant", x >= 812216871 ? "normal" : "small-caps");
}

function fontStyle(x) {
  return d("fontStyle", x !== 734792881 ? (
                x >= 812216871 ? "normal" : "italic"
              ) : "oblique");
}

function fontWeight(x) {
  return d("fontWeight", String(x));
}

function lineHeight(x) {
  return d("lineHeight", string_of_float(x));
}

function letterSpacing(x) {
  var tmp;
  if (typeof x === "number") {
    tmp = x !== -789508312 ? (
        x >= 812216871 ? "normal" : "auto"
      ) : "0";
  } else {
    var variant = x[0];
    if (variant >= 22643) {
      tmp = variant >= 25096 ? (
          variant >= 26433 ? (
              variant >= 5691738 ? string_of_float(x[1]) + "rem" : string_of_float(x[1]) + "vw"
            ) : (
              variant >= 26418 ? string_of_float(x[1]) + "vh" : String(x[1]) + "px"
            )
        ) : (
          variant !== 24416 ? (
              variant >= 25092 ? String(x[1]) + "pt" : string_of_float(x[1]) + "ex"
            ) : string_of_float(x[1]) + "mm"
        );
    } else if (variant >= -119887163) {
      tmp = variant >= 22186 ? (
          variant >= 22632 ? string_of_float(x[1]) + "em" : string_of_float(x[1]) + "cm"
        ) : (
          variant >= 22181 ? string_of_float(x[1]) + "ch" : string_of_float(x[1]) + "%"
        );
    } else if (variant !== -833472530) {
      if (variant >= -833470756) {
        tmp = string_of_float(x[1]) + "vmin";
      } else {
        var match = x[1];
        tmp = match[0] >= 5745024 ? "calc(" + (string_of_length(match[1]) + (" - " + (string_of_length(match[2]) + ")"))) : "calc(" + (string_of_length(match[1]) + (" + " + (string_of_length(match[2]) + ")")));
      }
    } else {
      tmp = string_of_float(x[1]) + "vmax";
    }
  }
  return d("letterSpacing", tmp);
}

function textAlign(x) {
  return d("textAlign", x >= 62250832 ? (
                x >= 98248149 ? "center" : "justify"
              ) : (
                x >= -379319332 ? "right" : "left"
              ));
}

function textDecoration(x) {
  return d("textDecoration", x >= 131142924 ? (
                x >= 412155569 ? "line-through" : "underline"
              ) : (
                x >= -922086728 ? "none" : "overline"
              ));
}

function textDecorationColor(x) {
  return d("textDecorationColor", string_of_color(x));
}

function textDecorationStyle(x) {
  return d("textDecorationStyle", x !== 12956715 ? (
                x >= 841979626 ? (
                    x >= 852175633 ? "double" : "dotted"
                  ) : (
                    x >= 568403505 ? "dashed" : "wavy"
                  )
              ) : "solid");
}

function textIndent(x) {
  return d("textIndent", string_of_length(x));
}

function textOverflow(x) {
  return d("textOverflow", typeof x === "number" ? (
                x >= 166888785 ? "ellipsis" : "clip"
              ) : x[1]);
}

function textShadow($staropt$star, $staropt$star$1, $staropt$star$2, color) {
  var x = $staropt$star ? $staropt$star[0] : /* zero */-789508312;
  var y = $staropt$star$1 ? $staropt$star$1[0] : /* zero */-789508312;
  var blur = $staropt$star$2 ? $staropt$star$2[0] : /* zero */-789508312;
  return d("textShadow", join(" ", /* :: */[
                  string_of_length(x),
                  /* :: */[
                    string_of_length(y),
                    /* :: */[
                      string_of_length(blur),
                      /* :: */[
                        string_of_color(color),
                        /* [] */0
                      ]
                    ]
                  ]
                ]));
}

function textTransform(x) {
  return d("textTransform", x >= -425349839 ? (
                x >= -415330030 ? "uppercase" : "lowercase"
              ) : (
                x >= -509867604 ? "capitalize" : "none"
              ));
}

function userSelect(x) {
  return d("userSelect", x >= -856044371 ? (
                x >= 4847905 ? "all" : "text"
              ) : (
                x >= -922086728 ? "none" : "auto"
              ));
}

function verticalAlign(x) {
  var tmp;
  if (typeof x === "number") {
    tmp = x >= 5793429 ? (
        x !== 79692155 ? (
            x >= 476669816 ? (
                x >= 516406248 ? "text-top" : "text-bottom"
              ) : (
                x >= 287825029 ? "baseline" : "top"
              )
          ) : "super"
      ) : (
        x !== -866200747 ? (
            x >= -445061397 ? (
                x >= 5745024 ? "sub" : "bottom"
              ) : (
                x >= -789508312 ? "0" : "auto"
              )
          ) : "middle"
      );
  } else {
    var variant = x[0];
    if (variant >= 22643) {
      tmp = variant >= 25096 ? (
          variant >= 26433 ? (
              variant >= 5691738 ? string_of_float(x[1]) + "rem" : string_of_float(x[1]) + "vw"
            ) : (
              variant >= 26418 ? string_of_float(x[1]) + "vh" : String(x[1]) + "px"
            )
        ) : (
          variant !== 24416 ? (
              variant >= 25092 ? String(x[1]) + "pt" : string_of_float(x[1]) + "ex"
            ) : string_of_float(x[1]) + "mm"
        );
    } else if (variant >= -119887163) {
      tmp = variant >= 22186 ? (
          variant >= 22632 ? string_of_float(x[1]) + "em" : string_of_float(x[1]) + "cm"
        ) : (
          variant >= 22181 ? string_of_float(x[1]) + "ch" : string_of_float(x[1]) + "%"
        );
    } else if (variant !== -833472530) {
      if (variant >= -833470756) {
        tmp = string_of_float(x[1]) + "vmin";
      } else {
        var match = x[1];
        tmp = match[0] >= 5745024 ? "calc(" + (string_of_length(match[1]) + (" - " + (string_of_length(match[2]) + ")"))) : "calc(" + (string_of_length(match[1]) + (" + " + (string_of_length(match[2]) + ")")));
      }
    } else {
      tmp = string_of_float(x[1]) + "vmax";
    }
  }
  return d("verticalAlign", tmp);
}

function whiteSpace(x) {
  return d("whiteSpace", x !== 538440119 ? (
                x >= 812216871 ? (
                    x >= 867913355 ? "nowrap" : "normal"
                  ) : (
                    x >= 660870029 ? "pre-wrap" : "pre"
                  )
              ) : "pre-line");
}

function wordBreak(x) {
  return d("wordBreak", x !== 812216871 ? (
                x >= 892748188 ? "keep-all" : "break-all"
              ) : "normal");
}

function wordSpacing(x) {
  var tmp;
  if (typeof x === "number") {
    tmp = x !== -789508312 ? (
        x >= 812216871 ? "normal" : "auto"
      ) : "0";
  } else {
    var variant = x[0];
    if (variant >= 22643) {
      tmp = variant >= 25096 ? (
          variant >= 26433 ? (
              variant >= 5691738 ? string_of_float(x[1]) + "rem" : string_of_float(x[1]) + "vw"
            ) : (
              variant >= 26418 ? string_of_float(x[1]) + "vh" : String(x[1]) + "px"
            )
        ) : (
          variant !== 24416 ? (
              variant >= 25092 ? String(x[1]) + "pt" : string_of_float(x[1]) + "ex"
            ) : string_of_float(x[1]) + "mm"
        );
    } else if (variant >= -119887163) {
      tmp = variant >= 22186 ? (
          variant >= 22632 ? string_of_float(x[1]) + "em" : string_of_float(x[1]) + "cm"
        ) : (
          variant >= 22181 ? string_of_float(x[1]) + "ch" : string_of_float(x[1]) + "%"
        );
    } else if (variant !== -833472530) {
      if (variant >= -833470756) {
        tmp = string_of_float(x[1]) + "vmin";
      } else {
        var match = x[1];
        tmp = match[0] >= 5745024 ? "calc(" + (string_of_length(match[1]) + (" - " + (string_of_length(match[2]) + ")"))) : "calc(" + (string_of_length(match[1]) + (" + " + (string_of_length(match[2]) + ")")));
      }
    } else {
      tmp = string_of_float(x[1]) + "vmax";
    }
  }
  return d("wordSpacing", tmp);
}

function wordWrap(x) {
  return d("wordWrap", x >= 1059921449 ? "break-word" : "normal");
}

function string_of_transform(param) {
  var variant = param[0];
  if (variant >= -120664438) {
    if (variant >= 106728778) {
      if (variant >= 178189215) {
        if (variant >= 1009117838) {
          switch (variant - 1009117838 | 0) {
            case 0 : 
                return func("scaleX", /* :: */[
                            string_of_float(param[1]),
                            /* [] */0
                          ]);
            case 1 : 
                return func("scaleY", /* :: */[
                            string_of_float(param[1]),
                            /* [] */0
                          ]);
            case 2 : 
                return func("scaleZ", /* :: */[
                            string_of_float(param[1]),
                            /* [] */0
                          ]);
            
          }
        } else {
          var match = param[1];
          return func("translate3d", List.map(string_of_length, /* :: */[
                          match[0],
                          /* :: */[
                            match[1],
                            /* :: */[
                              match[2],
                              /* [] */0
                            ]
                          ]
                        ]));
        }
      } else if (variant >= 142802924) {
        var match$1 = param[1];
        return func("rotate3d", /* :: */[
                    string_of_float(match$1[0]),
                    /* :: */[
                      string_of_float(match$1[1]),
                      /* :: */[
                        string_of_float(match$1[2]),
                        /* :: */[
                          string_of_angle(match$1[3]),
                          /* [] */0
                        ]
                      ]
                    ]
                  ]);
      } else {
        switch (variant - 106728778 | 0) {
          case 0 : 
              return func("translateX", /* :: */[
                          string_of_length(param[1]),
                          /* [] */0
                        ]);
          case 1 : 
              return func("translateY", /* :: */[
                          string_of_length(param[1]),
                          /* [] */0
                        ]);
          case 2 : 
              return func("translateZ", /* :: */[
                          string_of_length(param[1]),
                          /* [] */0
                        ]);
          
        }
      }
    } else if (variant !== -31746546) {
      if (variant >= -31746545) {
        return func("skewY", /* :: */[
                    string_of_angle(param[1]),
                    /* [] */0
                  ]);
      } else {
        var match$2 = param[1];
        return func("scale", List.map(string_of_float, /* :: */[
                        match$2[0],
                        /* :: */[
                          match$2[1],
                          /* [] */0
                        ]
                      ]));
      }
    } else {
      return func("skewX", /* :: */[
                  string_of_angle(param[1]),
                  /* [] */0
                ]);
    }
  } else if (variant >= -887077285) {
    if (variant >= -452513317) {
      if (variant >= -249738851) {
        switch (variant + 249738851 | 0) {
          case 0 : 
              return func("rotateX", /* :: */[
                          string_of_angle(param[1]),
                          /* [] */0
                        ]);
          case 1 : 
              return func("rotateY", /* :: */[
                          string_of_angle(param[1]),
                          /* [] */0
                        ]);
          case 2 : 
              return func("rotateZ", /* :: */[
                          string_of_angle(param[1]),
                          /* [] */0
                        ]);
          
        }
      } else {
        var match$3 = param[1];
        return func("scale3d", List.map(string_of_float, /* :: */[
                        match$3[0],
                        /* :: */[
                          match$3[1],
                          /* :: */[
                            match$3[2],
                            /* [] */0
                          ]
                        ]
                      ]));
      }
    } else if (variant >= -866839798) {
      var match$4 = param[1];
      return func("skew", List.map(string_of_angle, /* :: */[
                      match$4[0],
                      /* :: */[
                        match$4[1],
                        /* [] */0
                      ]
                    ]));
    } else {
      return func("rotate", /* :: */[
                  string_of_angle(param[1]),
                  /* [] */0
                ]);
    }
  } else if (variant >= -914368690) {
    var match$5 = param[1];
    return func("translate", /* :: */[
                string_of_length(match$5[0]),
                /* :: */[
                  string_of_length(match$5[1]),
                  /* [] */0
                ]
              ]);
  } else {
    return func("perspective", /* :: */[
                String(param[1]),
                /* [] */0
              ]);
  }
}

function transform(x) {
  return d("transform", string_of_transform(x));
}

function transforms(xs) {
  return d("transform", join(" ", List.map(string_of_transform, xs)));
}

function transformOrigin(x, y) {
  return d("transformOrigin", join(" ", List.map(string_of_length, /* :: */[
                      x,
                      /* :: */[
                        y,
                        /* [] */0
                      ]
                    ])));
}

function transformOrigin3d(x, y, z) {
  return d("transformOrigin", join(" ", List.map(string_of_length, /* :: */[
                      x,
                      /* :: */[
                        y,
                        /* :: */[
                          z,
                          /* [] */0
                        ]
                      ]
                    ])));
}

function transformStyle(x) {
  return d("transformStyle", x >= 589702045 ? "preserve-3d" : "flat");
}

function perspective(x) {
  var tmp;
  if (typeof x === "number") {
    tmp = x >= -789508312 ? "0" : "none";
  } else {
    var variant = x[0];
    if (variant >= 22643) {
      tmp = variant >= 25096 ? (
          variant >= 26433 ? (
              variant >= 5691738 ? string_of_float(x[1]) + "rem" : string_of_float(x[1]) + "vw"
            ) : (
              variant >= 26418 ? string_of_float(x[1]) + "vh" : String(x[1]) + "px"
            )
        ) : (
          variant !== 24416 ? (
              variant >= 25092 ? String(x[1]) + "pt" : string_of_float(x[1]) + "ex"
            ) : string_of_float(x[1]) + "mm"
        );
    } else if (variant >= -119887163) {
      tmp = variant >= 22186 ? (
          variant >= 22632 ? string_of_float(x[1]) + "em" : string_of_float(x[1]) + "cm"
        ) : (
          variant >= 22181 ? string_of_float(x[1]) + "ch" : string_of_float(x[1]) + "%"
        );
    } else if (variant !== -833472530) {
      if (variant >= -833470756) {
        tmp = string_of_float(x[1]) + "vmin";
      } else {
        var match = x[1];
        tmp = match[0] >= 5745024 ? "calc(" + (string_of_length(match[1]) + (" - " + (string_of_length(match[2]) + ")"))) : "calc(" + (string_of_length(match[1]) + (" + " + (string_of_length(match[2]) + ")")));
      }
    } else {
      tmp = string_of_float(x[1]) + "vmax";
    }
  }
  return d("parspective", tmp);
}

function string_of_timingFunction(param) {
  if (typeof param === "number") {
    if (param >= -193525386) {
      if (param >= 138027891) {
        return "ease-out";
      } else if (param >= 20933615) {
        return "step-end";
      } else {
        return "step-start";
      }
    } else if (param !== -960651557) {
      if (param >= -325037595) {
        return "linear";
      } else {
        return "ease";
      }
    } else {
      return "ease-in-out";
    }
  } else if (param[0] >= 68058023) {
    var match = param[1];
    var i = match[0];
    if (match[1] >= 67859554) {
      return func("steps", /* :: */[
                  String(i),
                  /* :: */[
                    "start",
                    /* [] */0
                  ]
                ]);
    } else {
      return func("steps", /* :: */[
                  String(i),
                  /* :: */[
                    "end",
                    /* [] */0
                  ]
                ]);
    }
  } else {
    var match$1 = param[1];
    return func("cubic-bezier", List.map(string_of_float, /* :: */[
                    match$1[0],
                    /* :: */[
                      match$1[1],
                      /* :: */[
                        match$1[2],
                        /* :: */[
                          match$1[3],
                          /* [] */0
                        ]
                      ]
                    ]
                  ]));
  }
}

function transition($staropt$star, $staropt$star$1, $staropt$star$2, property) {
  var duration = $staropt$star ? $staropt$star[0] : 0;
  var delay = $staropt$star$1 ? $staropt$star$1[0] : 0;
  var timingFunction = $staropt$star$2 ? $staropt$star$2[0] : /* ease */-1022587922;
  return /* `transition */[
          -659583595,
          join(" ", /* :: */[
                String(duration) + "ms",
                /* :: */[
                  string_of_timingFunction(timingFunction),
                  /* :: */[
                    String(delay) + "ms",
                    /* :: */[
                      property,
                      /* [] */0
                    ]
                  ]
                ]
              ])
        ];
}

function transitions(xs) {
  return d("transition", join(", ", List.map((function (param) {
                        return param[1];
                      }), xs)));
}

function transitionDelay(i) {
  return d("transitionDelay", String(i) + "ms");
}

function transitionDuration(i) {
  return d("transitionDuration", String(i) + "ms");
}

function transitionTimingFunction(x) {
  return d("transitionTimingFunction", string_of_timingFunction(x));
}

function transitionProperty(x) {
  return d("transitionProperty", x);
}

function perspectiveOrigin(x, y) {
  return d("perspectiveOrigin", join(" ", List.map(string_of_length, /* :: */[
                      x,
                      /* :: */[
                        y,
                        /* [] */0
                      ]
                    ])));
}

function string_of_animationDirection(param) {
  if (param >= 812216871) {
    if (param >= 892586298) {
      return "alternate";
    } else {
      return "normal";
    }
  } else if (param >= 545428232) {
    return "alternate-reverse";
  } else {
    return "reverse";
  }
}

function string_of_animationFillMode(param) {
  if (param >= 245861168) {
    if (param >= 733653774) {
      return "forwards";
    } else {
      return "backwards";
    }
  } else if (param >= -922086728) {
    return "none";
  } else {
    return "both";
  }
}

function string_of_animationIterationCount(param) {
  if (typeof param === "number") {
    return "infinite";
  } else {
    return String(param[1]);
  }
}

function string_of_animationPlayState(param) {
  if (param >= -276545362) {
    return "paused";
  } else {
    return "running";
  }
}

function animation($staropt$star, $staropt$star$1, $staropt$star$2, $staropt$star$3, $staropt$star$4, $staropt$star$5, $staropt$star$6, name) {
  var duration = $staropt$star ? $staropt$star[0] : 0;
  var delay = $staropt$star$1 ? $staropt$star$1[0] : 0;
  var direction = $staropt$star$2 ? $staropt$star$2[0] : /* normal */812216871;
  var timingFunction = $staropt$star$3 ? $staropt$star$3[0] : /* ease */-1022587922;
  var fillMode = $staropt$star$4 ? $staropt$star$4[0] : /* none */-922086728;
  var playState = $staropt$star$5 ? $staropt$star$5[0] : /* running */-345412097;
  var iterationCount = $staropt$star$6 ? $staropt$star$6[0] : /* `count */[
      -899463985,
      1
    ];
  return /* `animation */[
          -885723388,
          join(" ", /* :: */[
                name,
                /* :: */[
                  String(duration) + "ms",
                  /* :: */[
                    string_of_timingFunction(timingFunction),
                    /* :: */[
                      String(delay) + "ms",
                      /* :: */[
                        string_of_animationIterationCount(iterationCount),
                        /* :: */[
                          string_of_animationDirection(direction),
                          /* :: */[
                            string_of_animationFillMode(fillMode),
                            /* :: */[
                              string_of_animationPlayState(playState),
                              /* [] */0
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ])
        ];
}

function string_of_animation(param) {
  return param[1];
}

function animations(xs) {
  return d("animation", join(", ", List.map(string_of_animation, xs)));
}

function animationDelay(x) {
  return d("animationDelay", String(x) + "ms");
}

function animationDirection(x) {
  return d("animationDirection", string_of_animationDirection(x));
}

function animationDuration(x) {
  return d("animationDuration", String(x) + "ms");
}

function animationFillMode(x) {
  return d("animationFillMode", string_of_animationFillMode(x));
}

function animationIterationCount(x) {
  return d("animationIterationCount", string_of_animationIterationCount(x));
}

function animationName(x) {
  return d("animationName", x);
}

function animationPlayState(x) {
  return d("animationPlayState", string_of_animationPlayState(x));
}

function animationTimingFunction(x) {
  return d("animationTimingFunction", string_of_timingFunction(x));
}

function selector(selector$1, rules) {
  return /* `selector */[
          829240095,
          /* tuple */[
            selector$1,
            rules
          ]
        ];
}

function active(param) {
  return selector(":active", param);
}

function after(param) {
  return selector("::after", param);
}

function before(param) {
  return selector("::before", param);
}

function children(param) {
  return selector(" > *", param);
}

function disabled(param) {
  return selector(":disabled", param);
}

function firstChild(param) {
  return selector(":first-child", param);
}

function firstOfType(param) {
  return selector(":first-of-type", param);
}

function focus(param) {
  return selector(":focus", param);
}

function hover(param) {
  return selector(":hover", param);
}

function lastChild(param) {
  return selector(":last-child", param);
}

function lastOfType(param) {
  return selector(":last-of-type", param);
}

function link(param) {
  return selector(":link", param);
}

function readOnly(param) {
  return selector(":read-only", param);
}

function required(param) {
  return selector(":required", param);
}

function visited(param) {
  return selector(":visited", param);
}

function enabled(param) {
  return selector(":enabled", param);
}

function noContent(param) {
  return selector(":empty", param);
}

function $$default(param) {
  return selector(":default", param);
}

function anyLink(param) {
  return selector(":any-link", param);
}

function onlyChild(param) {
  return selector(":only-child", param);
}

function onlyOfType(param) {
  return selector(":only-of-type", param);
}

function optional(param) {
  return selector(":optional", param);
}

function invalid(param) {
  return selector(":invalid", param);
}

function outOfRange(param) {
  return selector(":out-of-range", param);
}

function target(param) {
  return selector(":target", param);
}

function firstLine(param) {
  return selector("::first-line", param);
}

function firstLetter(param) {
  return selector("::first-letter", param);
}

function selection(param) {
  return selector("::selection", param);
}

function media(query, rules) {
  return /* `selector */[
          829240095,
          /* tuple */[
            "@media " + query,
            rules
          ]
        ];
}

function fill(color) {
  return d("fill", string_of_color(color));
}

function fillOpacity(opacity) {
  return d("fillOpacity", string_of_float(opacity));
}

function fillRule(x) {
  return d("fillRule", x >= 110563029 ? "evenodd" : "nonzero");
}

function stroke(color) {
  return d("stroke", string_of_color(color));
}

function strokeWidth(length) {
  return d("strokeWidth", string_of_length(length));
}

function strokeOpacity(opacity) {
  return d("strokeOpacity", string_of_float(opacity));
}

function strokeMiterlimit(x) {
  return d("strokeMiterlimit", string_of_float(x));
}

function strokeLinecap(x) {
  return d("strokeLinecap", x !== -655228771 ? (
                x >= -312084402 ? "round" : "butt"
              ) : "square");
}

function strokeLinejoin(x) {
  return d("strokeLinejoin", x !== 141361157 ? (
                x >= 811681914 ? "bevel" : "round"
              ) : "miter");
}

function stopColor(c) {
  return d("stopColor", string_of_color(c));
}

function stopOpacity(o) {
  return d("stopOpacity", string_of_float(o));
}

var empty = /* [] */0;

var merge = List.concat;

var transparent = /* transparent */582626130;

var currentColor = /* currentColor */292050538;

var aliceblue = /* `hex */[
  5194459,
  "F0F8FF"
];

var antiquewhite = /* `hex */[
  5194459,
  "FAEBD7"
];

var aqua = /* `hex */[
  5194459,
  "00FFFF"
];

var aquamarine = /* `hex */[
  5194459,
  "7FFFD4"
];

var azure = /* `hex */[
  5194459,
  "F0FFFF"
];

var beige = /* `hex */[
  5194459,
  "F5F5DC"
];

var bisque = /* `hex */[
  5194459,
  "FFE4C4"
];

var black = /* `hex */[
  5194459,
  "000000"
];

var blanchedalmond = /* `hex */[
  5194459,
  "FFEBCD"
];

var blue = /* `hex */[
  5194459,
  "0000FF"
];

var blueviolet = /* `hex */[
  5194459,
  "8A2BE2"
];

var brown = /* `hex */[
  5194459,
  "A52A2A"
];

var burlywood = /* `hex */[
  5194459,
  "DEB887"
];

var cadetblue = /* `hex */[
  5194459,
  "5F9EA0"
];

var chartreuse = /* `hex */[
  5194459,
  "7FFF00"
];

var chocolate = /* `hex */[
  5194459,
  "D2691E"
];

var coral = /* `hex */[
  5194459,
  "FF7F50"
];

var cornflowerblue = /* `hex */[
  5194459,
  "6495ED"
];

var cornsilk = /* `hex */[
  5194459,
  "FFF8DC"
];

var crimson = /* `hex */[
  5194459,
  "DC143C"
];

var cyan = /* `hex */[
  5194459,
  "00FFFF"
];

var darkblue = /* `hex */[
  5194459,
  "00008B"
];

var darkcyan = /* `hex */[
  5194459,
  "008B8B"
];

var darkgoldenrod = /* `hex */[
  5194459,
  "B8860B"
];

var darkgray = /* `hex */[
  5194459,
  "A9A9A9"
];

var darkgrey = /* `hex */[
  5194459,
  "A9A9A9"
];

var darkgreen = /* `hex */[
  5194459,
  "006400"
];

var darkkhaki = /* `hex */[
  5194459,
  "BDB76B"
];

var darkmagenta = /* `hex */[
  5194459,
  "8B008B"
];

var darkolivegreen = /* `hex */[
  5194459,
  "556B2F"
];

var darkorange = /* `hex */[
  5194459,
  "FF8C00"
];

var darkorchid = /* `hex */[
  5194459,
  "9932CC"
];

var darkred = /* `hex */[
  5194459,
  "8B0000"
];

var darksalmon = /* `hex */[
  5194459,
  "E9967A"
];

var darkseagreen = /* `hex */[
  5194459,
  "8FBC8F"
];

var darkslateblue = /* `hex */[
  5194459,
  "483D8B"
];

var darkslategray = /* `hex */[
  5194459,
  "2F4F4F"
];

var darkslategrey = /* `hex */[
  5194459,
  "2F4F4F"
];

var darkturquoise = /* `hex */[
  5194459,
  "00CED1"
];

var darkviolet = /* `hex */[
  5194459,
  "9400D3"
];

var deeppink = /* `hex */[
  5194459,
  "FF1493"
];

var deepskyblue = /* `hex */[
  5194459,
  "00BFFF"
];

var dimgray = /* `hex */[
  5194459,
  "696969"
];

var dimgrey = /* `hex */[
  5194459,
  "696969"
];

var dodgerblue = /* `hex */[
  5194459,
  "1E90FF"
];

var firebrick = /* `hex */[
  5194459,
  "B22222"
];

var floralwhite = /* `hex */[
  5194459,
  "FFFAF0"
];

var forestgreen = /* `hex */[
  5194459,
  "228B22"
];

var fuchsia = /* `hex */[
  5194459,
  "FF00FF"
];

var gainsboro = /* `hex */[
  5194459,
  "DCDCDC"
];

var ghostwhite = /* `hex */[
  5194459,
  "F8F8FF"
];

var gold = /* `hex */[
  5194459,
  "FFD700"
];

var goldenrod = /* `hex */[
  5194459,
  "DAA520"
];

var gray = /* `hex */[
  5194459,
  "808080"
];

var grey = /* `hex */[
  5194459,
  "808080"
];

var green = /* `hex */[
  5194459,
  "008000"
];

var greenyellow = /* `hex */[
  5194459,
  "ADFF2F"
];

var honeydew = /* `hex */[
  5194459,
  "F0FFF0"
];

var hotpink = /* `hex */[
  5194459,
  "FF69B4"
];

var indianred = /* `hex */[
  5194459,
  "CD5C5C"
];

var indigo = /* `hex */[
  5194459,
  "4B0082"
];

var ivory = /* `hex */[
  5194459,
  "FFFFF0"
];

var khaki = /* `hex */[
  5194459,
  "F0E68C"
];

var lavender = /* `hex */[
  5194459,
  "E6E6FA"
];

var lavenderblush = /* `hex */[
  5194459,
  "FFF0F5"
];

var lawngreen = /* `hex */[
  5194459,
  "7CFC00"
];

var lemonchiffon = /* `hex */[
  5194459,
  "FFFACD"
];

var lightblue = /* `hex */[
  5194459,
  "ADD8E6"
];

var lightcoral = /* `hex */[
  5194459,
  "F08080"
];

var lightcyan = /* `hex */[
  5194459,
  "E0FFFF"
];

var lightgoldenrodyellow = /* `hex */[
  5194459,
  "FAFAD2"
];

var lightgray = /* `hex */[
  5194459,
  "D3D3D3"
];

var lightgrey = /* `hex */[
  5194459,
  "D3D3D3"
];

var lightgreen = /* `hex */[
  5194459,
  "90EE90"
];

var lightpink = /* `hex */[
  5194459,
  "FFB6C1"
];

var lightsalmon = /* `hex */[
  5194459,
  "FFA07A"
];

var lightseagreen = /* `hex */[
  5194459,
  "20B2AA"
];

var lightskyblue = /* `hex */[
  5194459,
  "87CEFA"
];

var lightslategray = /* `hex */[
  5194459,
  "778899"
];

var lightslategrey = /* `hex */[
  5194459,
  "778899"
];

var lightsteelblue = /* `hex */[
  5194459,
  "B0C4DE"
];

var lightyellow = /* `hex */[
  5194459,
  "FFFFE0"
];

var lime = /* `hex */[
  5194459,
  "00FF00"
];

var limegreen = /* `hex */[
  5194459,
  "32CD32"
];

var linen = /* `hex */[
  5194459,
  "FAF0E6"
];

var magenta = /* `hex */[
  5194459,
  "FF00FF"
];

var maroon = /* `hex */[
  5194459,
  "800000"
];

var mediumaquamarine = /* `hex */[
  5194459,
  "66CDAA"
];

var mediumblue = /* `hex */[
  5194459,
  "0000CD"
];

var mediumorchid = /* `hex */[
  5194459,
  "BA55D3"
];

var mediumpurple = /* `hex */[
  5194459,
  "9370DB"
];

var mediumseagreen = /* `hex */[
  5194459,
  "3CB371"
];

var mediumslateblue = /* `hex */[
  5194459,
  "7B68EE"
];

var mediumspringgreen = /* `hex */[
  5194459,
  "00FA9A"
];

var mediumturquoise = /* `hex */[
  5194459,
  "48D1CC"
];

var mediumvioletred = /* `hex */[
  5194459,
  "C71585"
];

var midnightblue = /* `hex */[
  5194459,
  "191970"
];

var mintcream = /* `hex */[
  5194459,
  "F5FFFA"
];

var mistyrose = /* `hex */[
  5194459,
  "FFE4E1"
];

var moccasin = /* `hex */[
  5194459,
  "FFE4B5"
];

var navajowhite = /* `hex */[
  5194459,
  "FFDEAD"
];

var navy = /* `hex */[
  5194459,
  "000080"
];

var oldlace = /* `hex */[
  5194459,
  "FDF5E6"
];

var olive = /* `hex */[
  5194459,
  "808000"
];

var olivedrab = /* `hex */[
  5194459,
  "6B8E23"
];

var orange = /* `hex */[
  5194459,
  "FFA500"
];

var orangered = /* `hex */[
  5194459,
  "FF4500"
];

var orchid = /* `hex */[
  5194459,
  "DA70D6"
];

var palegoldenrod = /* `hex */[
  5194459,
  "EEE8AA"
];

var palegreen = /* `hex */[
  5194459,
  "98FB98"
];

var paleturquoise = /* `hex */[
  5194459,
  "AFEEEE"
];

var palevioletred = /* `hex */[
  5194459,
  "DB7093"
];

var papayawhip = /* `hex */[
  5194459,
  "FFEFD5"
];

var peachpuff = /* `hex */[
  5194459,
  "FFDAB9"
];

var peru = /* `hex */[
  5194459,
  "CD853F"
];

var pink = /* `hex */[
  5194459,
  "FFC0CB"
];

var plum = /* `hex */[
  5194459,
  "DDA0DD"
];

var powderblue = /* `hex */[
  5194459,
  "B0E0E6"
];

var purple = /* `hex */[
  5194459,
  "800080"
];

var rebeccapurple = /* `hex */[
  5194459,
  "663399"
];

var red = /* `hex */[
  5194459,
  "FF0000"
];

var rosybrown = /* `hex */[
  5194459,
  "BC8F8F"
];

var royalblue = /* `hex */[
  5194459,
  "4169E1"
];

var saddlebrown = /* `hex */[
  5194459,
  "8B4513"
];

var salmon = /* `hex */[
  5194459,
  "FA8072"
];

var sandybrown = /* `hex */[
  5194459,
  "F4A460"
];

var seagreen = /* `hex */[
  5194459,
  "2E8B57"
];

var seashell = /* `hex */[
  5194459,
  "FFF5EE"
];

var sienna = /* `hex */[
  5194459,
  "A0522D"
];

var silver = /* `hex */[
  5194459,
  "C0C0C0"
];

var skyblue = /* `hex */[
  5194459,
  "87CEEB"
];

var slateblue = /* `hex */[
  5194459,
  "6A5ACD"
];

var slategray = /* `hex */[
  5194459,
  "708090"
];

var slategrey = /* `hex */[
  5194459,
  "708090"
];

var snow = /* `hex */[
  5194459,
  "FFFAFA"
];

var springgreen = /* `hex */[
  5194459,
  "00FF7F"
];

var steelblue = /* `hex */[
  5194459,
  "4682B4"
];

var tan = /* `hex */[
  5194459,
  "D2B48C"
];

var teal = /* `hex */[
  5194459,
  "008080"
];

var thistle = /* `hex */[
  5194459,
  "D8BFD8"
];

var tomato = /* `hex */[
  5194459,
  "FF6347"
];

var turquoise = /* `hex */[
  5194459,
  "40E0D0"
];

var violet = /* `hex */[
  5194459,
  "EE82EE"
];

var wheat = /* `hex */[
  5194459,
  "F5DEB3"
];

var white = /* `hex */[
  5194459,
  "FFFFFF"
];

var whitesmoke = /* `hex */[
  5194459,
  "F5F5F5"
];

var yellow = /* `hex */[
  5194459,
  "FFFF00"
];

var yellowgreen = /* `hex */[
  5194459,
  "9ACD3"
];

var zero = /* zero */-789508312;

var solid = /* solid */12956715;

var dotted = /* dotted */841979626;

var dashed = /* dashed */568403505;

var none = /* none */-922086728;

var auto = /* auto */-1065951377;

var hidden = /* hidden */-862584982;

var visible = /* visible */589592690;

var local = /* local */-118437525;

var scroll = /* scroll */-949692403;

var paddingBox = /* paddingBox */972575930;

var borderBox = /* borderBox */9307263;

var contentBox = /* contentBox */-1008848302;

var noRepeat = /* noRepeat */-695430532;

var repeat = /* repeat */108828507;

var repeatX = /* repeatX */646437021;

var repeatY = /* repeatY */646437022;

var contain = /* contain */427065300;

var cover = /* cover */-899416265;

var row = /* row */5693978;

var rowReverse = /* rowReverse */378951208;

var column = /* column */-963948842;

var columnReverse = /* columnReverse */135477484;

var wrap = /* wrap */-822134326;

var nowrap = /* nowrap */867913355;

var wrapReverse = /* wrapReverse */-463121288;

var flexBox = /* flex */-1010954439;

var block = /* block */888960333;

var inline = /* inline */423610969;

var inlineBlock = /* inlineBlock */-147785676;

var absolute = /* absolute */-1013592457;

var relative = /* relative */903134412;

var $$static = /* static */100392110;

var fixed = /* fixed */10615156;

var sticky = /* sticky */188263721;

var flexStart = /* flexStart */662439529;

var flexEnd = /* flexEnd */924268066;

var center = /* center */98248149;

var stretch = /* stretch */-162316795;

var spaceBetween = /* spaceBetween */516682146;

var spaceAround = /* spaceAround */-485895757;

var baseline = /* baseline */287825029;

var forwards = /* forwards */733653774;

var backwards = /* backwards */245861168;

var both = /* both */-1055160191;

var infinite = /* infinite */-630647084;

var paused = /* paused */-276545362;

var running = /* running */-345412097;

var inside = /* inside */501235708;

var outside = /* outside */-430011099;

var italic = /* italic */107228912;

var oblique = /* oblique */734792881;

var underline = /* underline */131142924;

var overline = /* overline */-986651832;

var lineThrough = /* lineThough */-512623793;

var clip = /* clip */-1044222256;

var ellipsis = /* ellipsis */166888785;

var wavy = /* wavy */-822975027;

var $$double = /* double */852175633;

var uppercase = /* uppercase */-415330030;

var lowercase = /* lowercase */-425349839;

var capitalize = /* capitalize */-509867604;

var sub = /* sub */5745024;

var $$super = /* super */79692155;

var textTop = /* textTop */516406248;

var textBottom = /* textBottom */476669816;

var middle = /* middle */-866200747;

var normal = /* normal */812216871;

var breakAll = /* breakAll */-323760734;

var keepAll = /* keepAll */892748188;

var breakWord = /* breakWord */1059921449;

var reverse = /* reverse */452737314;

var alternate = /* alternate */892586298;

var alternateReverse = /* alternateReverse */545428232;

var fill$1 = /* fill */-1011102077;

var content = /* content */427265337;

var maxContent = /* maxContent */60557045;

var minContent = /* minContent */-550577721;

var fitContent = /* fitContent */-195805336;

var all = /* all */4847905;

var text = /* text */-856044371;

var linear = /* linear */-325037595;

var ease = /* ease */-1022587922;

var easeIn = /* easeIn */138027891;

var easeOut = /* easeOut */715748672;

var easeInOut = /* easeInOut */-960651557;

var stepStart = /* stepStart */-193525386;

var stepEnd = /* stepEnd */20933615;

var round = /* round */-312084402;

var miter = /* miter */141361157;

var bevel = /* bevel */811681914;

var butt = /* butt */-1054861805;

var square = /* square */-655228771;

var unsafe = d;

var SVG = [
  fill,
  fillRule,
  fillOpacity,
  stroke,
  strokeLinecap,
  strokeLinejoin,
  strokeMiterlimit,
  strokeWidth,
  strokeOpacity,
  stopColor,
  stopOpacity
];

exports.empty = empty;
exports.merge = merge;
exports.style = style;
exports.$$global = $$global;
exports.important = important;
exports.label = label;
exports.deg = deg;
exports.rad = rad;
exports.grad = grad;
exports.turn = turn;
exports.rgb = rgb;
exports.rgba = rgba;
exports.hsl = hsl;
exports.hsla = hsla;
exports.hex = hex;
exports.transparent = transparent;
exports.currentColor = currentColor;
exports.linearGradient = linearGradient;
exports.repeatingLinearGradient = repeatingLinearGradient;
exports.radialGradient = radialGradient;
exports.repeatingRadialGradient = repeatingRadialGradient;
exports.aliceblue = aliceblue;
exports.antiquewhite = antiquewhite;
exports.aqua = aqua;
exports.aquamarine = aquamarine;
exports.azure = azure;
exports.beige = beige;
exports.bisque = bisque;
exports.black = black;
exports.blanchedalmond = blanchedalmond;
exports.blue = blue;
exports.blueviolet = blueviolet;
exports.brown = brown;
exports.burlywood = burlywood;
exports.cadetblue = cadetblue;
exports.chartreuse = chartreuse;
exports.chocolate = chocolate;
exports.coral = coral;
exports.cornflowerblue = cornflowerblue;
exports.cornsilk = cornsilk;
exports.crimson = crimson;
exports.cyan = cyan;
exports.darkblue = darkblue;
exports.darkcyan = darkcyan;
exports.darkgoldenrod = darkgoldenrod;
exports.darkgray = darkgray;
exports.darkgrey = darkgrey;
exports.darkgreen = darkgreen;
exports.darkkhaki = darkkhaki;
exports.darkmagenta = darkmagenta;
exports.darkolivegreen = darkolivegreen;
exports.darkorange = darkorange;
exports.darkorchid = darkorchid;
exports.darkred = darkred;
exports.darksalmon = darksalmon;
exports.darkseagreen = darkseagreen;
exports.darkslateblue = darkslateblue;
exports.darkslategray = darkslategray;
exports.darkslategrey = darkslategrey;
exports.darkturquoise = darkturquoise;
exports.darkviolet = darkviolet;
exports.deeppink = deeppink;
exports.deepskyblue = deepskyblue;
exports.dimgray = dimgray;
exports.dimgrey = dimgrey;
exports.dodgerblue = dodgerblue;
exports.firebrick = firebrick;
exports.floralwhite = floralwhite;
exports.forestgreen = forestgreen;
exports.fuchsia = fuchsia;
exports.gainsboro = gainsboro;
exports.ghostwhite = ghostwhite;
exports.gold = gold;
exports.goldenrod = goldenrod;
exports.gray = gray;
exports.grey = grey;
exports.green = green;
exports.greenyellow = greenyellow;
exports.honeydew = honeydew;
exports.hotpink = hotpink;
exports.indianred = indianred;
exports.indigo = indigo;
exports.ivory = ivory;
exports.khaki = khaki;
exports.lavender = lavender;
exports.lavenderblush = lavenderblush;
exports.lawngreen = lawngreen;
exports.lemonchiffon = lemonchiffon;
exports.lightblue = lightblue;
exports.lightcoral = lightcoral;
exports.lightcyan = lightcyan;
exports.lightgoldenrodyellow = lightgoldenrodyellow;
exports.lightgray = lightgray;
exports.lightgrey = lightgrey;
exports.lightgreen = lightgreen;
exports.lightpink = lightpink;
exports.lightsalmon = lightsalmon;
exports.lightseagreen = lightseagreen;
exports.lightskyblue = lightskyblue;
exports.lightslategray = lightslategray;
exports.lightslategrey = lightslategrey;
exports.lightsteelblue = lightsteelblue;
exports.lightyellow = lightyellow;
exports.lime = lime;
exports.limegreen = limegreen;
exports.linen = linen;
exports.magenta = magenta;
exports.maroon = maroon;
exports.mediumaquamarine = mediumaquamarine;
exports.mediumblue = mediumblue;
exports.mediumorchid = mediumorchid;
exports.mediumpurple = mediumpurple;
exports.mediumseagreen = mediumseagreen;
exports.mediumslateblue = mediumslateblue;
exports.mediumspringgreen = mediumspringgreen;
exports.mediumturquoise = mediumturquoise;
exports.mediumvioletred = mediumvioletred;
exports.midnightblue = midnightblue;
exports.mintcream = mintcream;
exports.mistyrose = mistyrose;
exports.moccasin = moccasin;
exports.navajowhite = navajowhite;
exports.navy = navy;
exports.oldlace = oldlace;
exports.olive = olive;
exports.olivedrab = olivedrab;
exports.orange = orange;
exports.orangered = orangered;
exports.orchid = orchid;
exports.palegoldenrod = palegoldenrod;
exports.palegreen = palegreen;
exports.paleturquoise = paleturquoise;
exports.palevioletred = palevioletred;
exports.papayawhip = papayawhip;
exports.peachpuff = peachpuff;
exports.peru = peru;
exports.pink = pink;
exports.plum = plum;
exports.powderblue = powderblue;
exports.purple = purple;
exports.rebeccapurple = rebeccapurple;
exports.red = red;
exports.rosybrown = rosybrown;
exports.royalblue = royalblue;
exports.saddlebrown = saddlebrown;
exports.salmon = salmon;
exports.sandybrown = sandybrown;
exports.seagreen = seagreen;
exports.seashell = seashell;
exports.sienna = sienna;
exports.silver = silver;
exports.skyblue = skyblue;
exports.slateblue = slateblue;
exports.slategray = slategray;
exports.slategrey = slategrey;
exports.snow = snow;
exports.springgreen = springgreen;
exports.steelblue = steelblue;
exports.tan = tan;
exports.teal = teal;
exports.thistle = thistle;
exports.tomato = tomato;
exports.turquoise = turquoise;
exports.violet = violet;
exports.wheat = wheat;
exports.white = white;
exports.whitesmoke = whitesmoke;
exports.yellow = yellow;
exports.yellowgreen = yellowgreen;
exports.ch = ch;
exports.cm = cm;
exports.em = em;
exports.ex = ex;
exports.mm = mm;
exports.pct = pct;
exports.pt = pt;
exports.px = px;
exports.rem = rem;
exports.vh = vh;
exports.vmax = vmax;
exports.vmin = vmin;
exports.vw = vw;
exports.zero = zero;
exports.Calc = Calc;
exports.size = size;
exports.solid = solid;
exports.dotted = dotted;
exports.dashed = dashed;
exports.url = url;
exports.none = none;
exports.auto = auto;
exports.hidden = hidden;
exports.visible = visible;
exports.local = local;
exports.scroll = scroll;
exports.paddingBox = paddingBox;
exports.borderBox = borderBox;
exports.contentBox = contentBox;
exports.noRepeat = noRepeat;
exports.repeat = repeat;
exports.repeatX = repeatX;
exports.repeatY = repeatY;
exports.contain = contain;
exports.cover = cover;
exports.row = row;
exports.rowReverse = rowReverse;
exports.column = column;
exports.columnReverse = columnReverse;
exports.wrap = wrap;
exports.nowrap = nowrap;
exports.wrapReverse = wrapReverse;
exports.flexBox = flexBox;
exports.block = block;
exports.inline = inline;
exports.inlineBlock = inlineBlock;
exports.absolute = absolute;
exports.relative = relative;
exports.$$static = $$static;
exports.fixed = fixed;
exports.sticky = sticky;
exports.flexStart = flexStart;
exports.flexEnd = flexEnd;
exports.center = center;
exports.stretch = stretch;
exports.spaceBetween = spaceBetween;
exports.spaceAround = spaceAround;
exports.baseline = baseline;
exports.forwards = forwards;
exports.backwards = backwards;
exports.both = both;
exports.infinite = infinite;
exports.count = count;
exports.paused = paused;
exports.running = running;
exports.inside = inside;
exports.outside = outside;
exports.translate = translate;
exports.translate3d = translate3d;
exports.translateX = translateX;
exports.translateY = translateY;
exports.translateZ = translateZ;
exports.scale = scale;
exports.scale3d = scale3d;
exports.scaleX = scaleX;
exports.scaleY = scaleY;
exports.scaleZ = scaleZ;
exports.rotate = rotate;
exports.rotate3d = rotate3d;
exports.rotateX = rotateX;
exports.rotateY = rotateY;
exports.rotateZ = rotateZ;
exports.skew = skew;
exports.skewX = skewX;
exports.skewY = skewY;
exports.italic = italic;
exports.oblique = oblique;
exports.underline = underline;
exports.overline = overline;
exports.lineThrough = lineThrough;
exports.clip = clip;
exports.ellipsis = ellipsis;
exports.wavy = wavy;
exports.$$double = $$double;
exports.uppercase = uppercase;
exports.lowercase = lowercase;
exports.capitalize = capitalize;
exports.sub = sub;
exports.$$super = $$super;
exports.textTop = textTop;
exports.textBottom = textBottom;
exports.middle = middle;
exports.normal = normal;
exports.breakAll = breakAll;
exports.keepAll = keepAll;
exports.breakWord = breakWord;
exports.reverse = reverse;
exports.alternate = alternate;
exports.alternateReverse = alternateReverse;
exports.fill = fill$1;
exports.content = content;
exports.maxContent = maxContent;
exports.minContent = minContent;
exports.fitContent = fitContent;
exports.all = all;
exports.text = text;
exports.linear = linear;
exports.ease = ease;
exports.easeIn = easeIn;
exports.easeOut = easeOut;
exports.easeInOut = easeInOut;
exports.stepStart = stepStart;
exports.stepEnd = stepEnd;
exports.steps = steps;
exports.cubicBesier = cubicBesier;
exports.round = round;
exports.miter = miter;
exports.bevel = bevel;
exports.butt = butt;
exports.square = square;
exports.unsafe = unsafe;
exports.display = display;
exports.position = position;
exports.top = top;
exports.bottom = bottom;
exports.left = left;
exports.right = right;
exports.flex = flex;
exports.flexGrow = flexGrow;
exports.flexShrink = flexShrink;
exports.flexBasis = flexBasis;
exports.flexDirection = flexDirection;
exports.flexWrap = flexWrap;
exports.order = order;
exports.width = width;
exports.minWidth = minWidth;
exports.maxWidth = maxWidth;
exports.height = height;
exports.minHeight = minHeight;
exports.maxHeight = maxHeight;
exports.margin = margin;
exports.margin2 = margin2;
exports.margin3 = margin3;
exports.margin4 = margin4;
exports.marginLeft = marginLeft;
exports.marginRight = marginRight;
exports.marginTop = marginTop;
exports.marginBottom = marginBottom;
exports.padding = padding;
exports.padding2 = padding2;
exports.padding3 = padding3;
exports.padding4 = padding4;
exports.paddingLeft = paddingLeft;
exports.paddingRight = paddingRight;
exports.paddingTop = paddingTop;
exports.paddingBottom = paddingBottom;
exports.alignContent = alignContent;
exports.alignItems = alignItems;
exports.alignSelf = alignSelf;
exports.justifyContent = justifyContent;
exports.boxSizing = boxSizing;
exports.$$float = $$float;
exports.clear = clear;
exports.overflow = overflow;
exports.overflowX = overflowX;
exports.overflowY = overflowY;
exports.zIndex = zIndex;
exports.backfaceVisibility = backfaceVisibility;
exports.visibility = visibility;
exports.border = border;
exports.borderWidth = borderWidth;
exports.borderStyle = borderStyle;
exports.borderColor = borderColor;
exports.borderTop = borderTop;
exports.borderTopWidth = borderTopWidth;
exports.borderTopStyle = borderTopStyle;
exports.borderTopColor = borderTopColor;
exports.borderBottom = borderBottom;
exports.borderBottomWidth = borderBottomWidth;
exports.borderBottomStyle = borderBottomStyle;
exports.borderBottomColor = borderBottomColor;
exports.borderLeft = borderLeft;
exports.borderLeftWidth = borderLeftWidth;
exports.borderLeftStyle = borderLeftStyle;
exports.borderLeftColor = borderLeftColor;
exports.borderRight = borderRight;
exports.borderRightWidth = borderRightWidth;
exports.borderRightStyle = borderRightStyle;
exports.borderRightColor = borderRightColor;
exports.borderRadius = borderRadius;
exports.borderTopLeftRadius = borderTopLeftRadius;
exports.borderTopRightRadius = borderTopRightRadius;
exports.borderBottomLeftRadius = borderBottomLeftRadius;
exports.borderBottomRightRadius = borderBottomRightRadius;
exports.boxShadow = boxShadow;
exports.boxShadows = boxShadows;
exports.background = background;
exports.backgroundColor = backgroundColor;
exports.backgroundImage = backgroundImage;
exports.backgroundAttachment = backgroundAttachment;
exports.backgroundClip = backgroundClip;
exports.backgroundOrigin = backgroundOrigin;
exports.backgroundPosition = backgroundPosition;
exports.backgroundRepeat = backgroundRepeat;
exports.backgroundSize = backgroundSize;
exports.cursor = cursor;
exports.listStyle = listStyle;
exports.listStyleType = listStyleType;
exports.listStylePosition = listStylePosition;
exports.listStyleImage = listStyleImage;
exports.opacity = opacity;
exports.outline = outline;
exports.outlineStyle = outlineStyle;
exports.outlineWidth = outlineWidth;
exports.outlineColor = outlineColor;
exports.outlineOffset = outlineOffset;
exports.color = color;
exports.fontFamily = fontFamily;
exports.fontSize = fontSize;
exports.fontVariant = fontVariant;
exports.fontStyle = fontStyle;
exports.fontWeight = fontWeight;
exports.letterSpacing = letterSpacing;
exports.lineHeight = lineHeight;
exports.textAlign = textAlign;
exports.textDecoration = textDecoration;
exports.textDecorationColor = textDecorationColor;
exports.textDecorationStyle = textDecorationStyle;
exports.textIndent = textIndent;
exports.textOverflow = textOverflow;
exports.textShadow = textShadow;
exports.textTransform = textTransform;
exports.userSelect = userSelect;
exports.verticalAlign = verticalAlign;
exports.whiteSpace = whiteSpace;
exports.wordBreak = wordBreak;
exports.wordSpacing = wordSpacing;
exports.wordWrap = wordWrap;
exports.transform = transform;
exports.transforms = transforms;
exports.transformOrigin = transformOrigin;
exports.transformOrigin3d = transformOrigin3d;
exports.transformStyle = transformStyle;
exports.perspective = perspective;
exports.perspectiveOrigin = perspectiveOrigin;
exports.transition = transition;
exports.transitions = transitions;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionTimingFunction = transitionTimingFunction;
exports.transitionProperty = transitionProperty;
exports.keyframes = keyframes;
exports.animation = animation;
exports.animations = animations;
exports.animationDelay = animationDelay;
exports.animationDirection = animationDirection;
exports.animationDuration = animationDuration;
exports.animationFillMode = animationFillMode;
exports.animationIterationCount = animationIterationCount;
exports.animationName = animationName;
exports.animationPlayState = animationPlayState;
exports.animationTimingFunction = animationTimingFunction;
exports.selector = selector;
exports.active = active;
exports.after = after;
exports.before = before;
exports.children = children;
exports.disabled = disabled;
exports.firstChild = firstChild;
exports.firstOfType = firstOfType;
exports.focus = focus;
exports.hover = hover;
exports.lastChild = lastChild;
exports.lastOfType = lastOfType;
exports.link = link;
exports.readOnly = readOnly;
exports.required = required;
exports.visited = visited;
exports.enabled = enabled;
exports.noContent = noContent;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
exports.anyLink = anyLink;
exports.onlyChild = onlyChild;
exports.onlyOfType = onlyOfType;
exports.optional = optional;
exports.invalid = invalid;
exports.outOfRange = outOfRange;
exports.target = target;
exports.firstLine = firstLine;
exports.firstLetter = firstLetter;
exports.selection = selection;
exports.media = media;
exports.SVG = SVG;
/*  Not a pure module */


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



function __(tag, block) {
  block.tag = tag;
  return block;
}

exports.__ = __;
/* No side effect */


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);

var greyDark3 = /* `hex */[
  5194459,
  "E7E7E7"
];

Css.$$global("h1", /* :: */[
      Css.color(/* `hex */[
            5194459,
            "FF328C"
          ]),
      /* :: */[
        Css.fontSize(Css.px(26)),
        /* :: */[
          Css.textTransform(/* uppercase */-415330030),
          /* :: */[
            Css.fontWeight(700),
            /* [] */0
          ]
        ]
      ]
    ]);

Css.$$global("h2", /* :: */[
      Css.color(/* `hex */[
            5194459,
            "F66297"
          ]),
      /* :: */[
        Css.fontSize(Css.px(22)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

Css.$$global("h3", /* :: */[
      Css.color(/* `hex */[
            5194459,
            "F66297"
          ]),
      /* :: */[
        Css.fontSize(Css.px(20)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

Css.$$global("h4", /* :: */[
      Css.color(/* `hex */[
            5194459,
            "FF328C"
          ]),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

Css.$$global("body", /* :: */[
      Css.color(Css.hex("1D2129")),
      /* :: */[
        Css.fontSize(Css.px(16)),
        /* :: */[
          Css.fontWeight(400),
          /* :: */[
            Css.lineHeight(1.5),
            /* [] */0
          ]
        ]
      ]
    ]);

Css.$$global("button", /* :: */[
      Css.cursor(/* pointer */-786317123),
      /* [] */0
    ]);

Css.$$global("div", /* :: */[
      Css.display(Css.flexBox),
      /* [] */0
    ]);

Css.$$global("a", /* :: */[
      Css.textDecoration(/* underline */131142924),
      /* :: */[
        Css.selector("&:hover", /* :: */[
              Css.textDecoration(/* none */-922086728),
              /* [] */0
            ]),
        /* :: */[
          Css.color(/* `hex */[
                5194459,
                "00C9C8"
              ]),
          /* [] */0
        ]
      ]
    ]);

Css.$$global("a:hover", /* :: */[
      Css.textDecoration(/* none */-922086728),
      /* [] */0
    ]);

var main = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.flexDirection(Css.row),
        /* :: */[
          Css.alignItems(Css.stretch),
          /* :: */[
            Css.justifyContent(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    92.0
                  ]),
              /* :: */[
                Css.maxWidth(Css.px(500)),
                /* :: */[
                  Css.background(/* `hex */[
                        5194459,
                        "FCEBEC"
                      ]),
                  /* :: */[
                    Css.minHeight(Css.px(500)),
                    /* :: */[
                      Css.paddingBottom(Css.px(30)),
                      /* :: */[
                        Css.margin4(Css.px(0), Css.px(10), Css.px(30), Css.px(10)),
                        /* :: */[
                          Css.paddingLeft(Css.px(10)),
                          /* :: */[
                            Css.paddingRight(Css.px(10)),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.padding4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
        /* :: */[
          Css.textAlign(Css.center),
          /* :: */[
            Css.display(Css.flexBox),
            /* :: */[
              Css.flexDirection(Css.column),
              /* :: */[
                Css.alignItems(Css.center),
                /* :: */[
                  Css.background(Css.white),
                  /* :: */[
                    Css.width(/* `percent */[
                          -119887163,
                          100.0
                        ]),
                    /* :: */[
                      Css.borderBottomLeftRadius(Css.px(8)),
                      /* :: */[
                        Css.borderBottomRightRadius(Css.px(8)),
                        /* :: */[
                          Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(3)], /* None */0, /* None */0, Css.rgba(224, 44, 123, 0.2)),
                          /* [] */0
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var buttonBasics_000 = Css.textAlign(Css.center);

var buttonBasics_001 = /* :: */[
  Css.whiteSpace(Css.nowrap),
  /* :: */[
    Css.borderRadius(Css.px(50)),
    /* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.fontWeight(700),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.flexDirection(Css.row),
            /* :: */[
              Css.justifyContent(Css.center),
              /* [] */0
            ]
          ]
        ]
      ]
    ]
  ]
];

var buttonBasics = /* :: */[
  buttonBasics_000,
  buttonBasics_001
];

var greenButtonRaw_000 = Css.selector("&:hover", /* :: */[
      Css.color(greyDark3),
      /* [] */0
    ]);

var greenButtonRaw_001 = /* :: */[
  Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
  /* :: */[
    Css.fontSize(Css.px(20)),
    /* :: */[
      Css.minWidth(Css.px(170)),
      /* :: */[
        Css.height(Css.px(40)),
        /* :: */[
          Css.background(/* `linearGradient */[
                616379637,
                /* tuple */[
                  /* `deg */[
                    4995526,
                    76
                  ],
                  /* :: */[
                    /* tuple */[
                      5,
                      Css.hex("80e7e7")
                    ],
                    /* :: */[
                      /* tuple */[
                        93,
                        Css.hex("00a2a1")
                      ],
                      /* [] */0
                    ]
                  ]
                ]
              ]),
          /* :: */[
            Css.color(Css.white),
            /* :: */[
              Css.textTransform(Css.uppercase),
              /* :: */[
                Css.border(Css.px(1), /* solid */12956715, Css.hex("80E7E7")),
                buttonBasics
              ]
            ]
          ]
        ]
      ]
    ]
  ]
];

var greenButtonRaw = /* :: */[
  greenButtonRaw_000,
  greenButtonRaw_001
];

function greenButton() {
  return Css.style(greenButtonRaw);
}

function greenButtonDisabled() {
  return Css.style(/* :: */[
              Css.opacity(0.4),
              greenButtonRaw
            ]);
}

var greenSecondaryButtonRaw_000 = Css.selector("&:hover", /* :: */[
      Css.background(/* `hex */[
            5194459,
            "E2F2F2"
          ]),
      /* [] */0
    ]);

var greenSecondaryButtonRaw_001 = /* :: */[
  Css.minWidth(Css.px(135)),
  /* :: */[
    Css.fontSize(Css.px(16)),
    /* :: */[
      Css.height(Css.px(30)),
      /* :: */[
        Css.background(Css.white),
        /* :: */[
          Css.color(/* `hex */[
                5194459,
                "66B3B5"
              ]),
          /* :: */[
            Css.border(Css.px(1), /* solid */12956715, Css.hex("66B3B5")),
            buttonBasics
          ]
        ]
      ]
    ]
  ]
];

var greenSecondaryButtonRaw = /* :: */[
  greenSecondaryButtonRaw_000,
  greenSecondaryButtonRaw_001
];

var redButtonWideRaw_000 = Css.selector("&:hover", /* :: */[
      Css.background(/* `hex */[
            5194459,
            "FFEEEF"
          ]),
      /* [] */0
    ]);

var redButtonWideRaw_001 = /* :: */[
  Css.minWidth(Css.px(120)),
  /* :: */[
    Css.fontSize(Css.px(16)),
    /* :: */[
      Css.height(Css.px(20)),
      /* :: */[
        Css.background(Css.white),
        /* :: */[
          Css.color(Css.hex("FF328C")),
          /* :: */[
            Css.border(Css.px(1), /* solid */12956715, Css.hex("FF328C")),
            buttonBasics
          ]
        ]
      ]
    ]
  ]
];

var redButtonWideRaw = /* :: */[
  redButtonWideRaw_000,
  redButtonWideRaw_001
];

var redButtonWideDisabledRaw_000 = Css.color(Css.hex("FABCD2"));

var redButtonWideDisabledRaw = /* :: */[
  redButtonWideDisabledRaw_000,
  redButtonWideRaw
];

var redButtonNarrowRaw_000 = Css.width(Css.px(80));

var redButtonNarrowRaw = /* :: */[
  redButtonNarrowRaw_000,
  redButtonWideRaw
];

var redButtonNarrowDisabledRaw_000 = Css.color(Css.hex("FABCD2"));

var redButtonNarrowDisabledRaw = /* :: */[
  redButtonNarrowDisabledRaw_000,
  redButtonNarrowRaw
];

function simpleButton() {
  return Css.style(greenButtonRaw);
}

function simpleButtonReset() {
  return Css.style(/* :: */[
              Css.marginBottom(Css.px(10)),
              greenButtonRaw
            ]);
}

function simpleButtonWhiteSpaceBelow() {
  return Css.style(/* :: */[
              Css.marginBottom(Css.px(90)),
              greenButtonRaw
            ]);
}

function slimButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(10.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.maxWidth(Css.em(20.0)),
                  greenButtonRaw
                ]
              ]
            ]);
}

function verySlimButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(8.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.maxWidth(Css.em(16.0)),
                  /* :: */[
                    Css.minHeight(Css.em(2.0)),
                    /* :: */[
                      Css.marginRight(Css.px(10)),
                      /* :: */[
                        Css.marginLeft(Css.px(10)),
                        greenButtonRaw
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var textColor = /* `hex */[
  5194459,
  "F66297"
];

var headColor = /* `hex */[
  5194459,
  "FF328C"
];

var pink1 = /* `hex */[
  5194459,
  "F43086"
];

var pink2 = /* `hex */[
  5194459,
  "F67AA6"
];

var pink3 = /* `hex */[
  5194459,
  "F67AA6"
];

var pink4 = /* `hex */[
  5194459,
  "F997C2"
];

var pink5 = /* `hex */[
  5194459,
  "FABCD2"
];

var pink6 = /* `hex */[
  5194459,
  "FFEEEF"
];

var blue1 = /* `hex */[
  5194459,
  "00A2A1"
];

var blue2 = /* `hex */[
  5194459,
  "05EDD6"
];

var blue3 = /* `hex */[
  5194459,
  "00CFCE"
];

var blue4 = /* `hex */[
  5194459,
  "80D0D0"
];

var blue5 = /* `hex */[
  5194459,
  "82F6EA"
];

var blue6 = /* `hex */[
  5194459,
  "80E7E7"
];

var greyDark1 = /* `hex */[
  5194459,
  "747474"
];

var greyDark2 = /* `hex */[
  5194459,
  "A4A4A4"
];

var greyLight1 = /* `hex */[
  5194459,
  "FAFAFA"
];

var greyLight2 = /* `hex */[
  5194459,
  "EFEFEF"
];

var greyLight3 = /* `hex */[
  5194459,
  "E6E6E6"
];

var standardFontSize = /* `px */[
  25096,
  16
];

var smallFontSize = /* `px */[
  25096,
  12
];

exports.textColor = textColor;
exports.headColor = headColor;
exports.pink1 = pink1;
exports.pink2 = pink2;
exports.pink3 = pink3;
exports.pink4 = pink4;
exports.pink5 = pink5;
exports.pink6 = pink6;
exports.blue1 = blue1;
exports.blue2 = blue2;
exports.blue3 = blue3;
exports.blue4 = blue4;
exports.blue5 = blue5;
exports.blue6 = blue6;
exports.greyDark1 = greyDark1;
exports.greyDark2 = greyDark2;
exports.greyDark3 = greyDark3;
exports.greyLight1 = greyLight1;
exports.greyLight2 = greyLight2;
exports.greyLight3 = greyLight3;
exports.standardFontSize = standardFontSize;
exports.smallFontSize = smallFontSize;
exports.main = main;
exports.contentBox = contentBox;
exports.buttonBasics = buttonBasics;
exports.greenButtonRaw = greenButtonRaw;
exports.greenButton = greenButton;
exports.greenButtonDisabled = greenButtonDisabled;
exports.greenSecondaryButtonRaw = greenSecondaryButtonRaw;
exports.redButtonWideRaw = redButtonWideRaw;
exports.redButtonWideDisabledRaw = redButtonWideDisabledRaw;
exports.redButtonNarrowRaw = redButtonNarrowRaw;
exports.redButtonNarrowDisabledRaw = redButtonNarrowDisabledRaw;
exports.simpleButton = simpleButton;
exports.simpleButtonReset = simpleButtonReset;
exports.simpleButtonWhiteSpaceBelow = simpleButtonWhiteSpaceBelow;
exports.slimButton = slimButton;
exports.verySlimButton = verySlimButton;
/*  Not a pure module */


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Json = __webpack_require__(42);
var Seed = __webpack_require__(17);
var $$Array = __webpack_require__(12);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Fetch = __webpack_require__(25);
var Js_exn = __webpack_require__(10);
var Printf = __webpack_require__(44);
var FoodSeed = __webpack_require__(47);
var Caml_array = __webpack_require__(9);
var Caml_int32 = __webpack_require__(11);
var Pervasives = __webpack_require__(21);
var Caml_format = __webpack_require__(8);
var Json_decode = __webpack_require__(48);
var Json_encode = __webpack_require__(23);
var ReasonReact = __webpack_require__(2);
var Js_primitive = __webpack_require__(49);
var SupportFuncs = __webpack_require__(50);
var Caml_builtin_exceptions = __webpack_require__(3);

var dataUrl = "https://shopify.ilpt.de/api/apps/me?shop=ilptbook.myshopify.com";

function getBearer() {
  var match = localStorage.getItem("access_token");
  if (match !== null) {
    return match;
  } else {
    SupportFuncs.handleLogout(/* () */0);
    console.log("bearer missing. logging out.");
    return "fail, bearer missing";
  }
}

function jsonParse(vals) {
  try {
    return JSON.parse(vals);
  }
  catch (exn){
    return Pervasives.failwith("Error parsing JSON string");
  }
}

var networkSyncStatusSeed = /* array */[
  /* array */[
    "new",
    "0.0",
    "start_date_timestamp"
  ],
  /* array */[
    "new",
    "0.0",
    "wizard_result"
  ],
  /* array */[
    "new",
    "0.0",
    "levels"
  ],
  /* array */[
    "new",
    "0.0",
    "reps"
  ],
  /* array */[
    "new",
    "0.0",
    "points"
  ],
  /* array */[
    "new",
    "0.0",
    "completed"
  ],
  /* array */[
    "new",
    "0.0",
    "food_plan"
  ],
  /* array */[
    "new",
    "0.0",
    "bonus_done"
  ],
  /* array */[
    "new",
    "0.0",
    "knowledge_read"
  ]
];

function checkSync(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array((function (param) {
            return Json_decode.array(Json_decode.string, param);
          }), jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("sync parsing issue failure ", x[1]);
      return /* None */0;
    } else {
      console.log("sync parsing issue", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readSyncSettingsFromLs() {
  var exit = 0;
  var val;
  try {
    val = Js_primitive.null_to_opt(localStorage.getItem("network_sync_status"));
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    console.log("localStorage issue", x);
    return /* None */0;
  }
  if (exit === 1) {
    if (val) {
      var exit$1 = 0;
      var val$1;
      try {
        val$1 = /* Some */[jsonParse(val[0])];
        exit$1 = 2;
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === Caml_builtin_exceptions.failure) {
          console.log("sync checking exception: ", exn[1]);
          return /* None */0;
        } else {
          throw exn;
        }
      }
      if (exit$1 === 2) {
        if (val$1) {
          return checkSync(val$1[0]);
        } else {
          return /* None */0;
        }
      }
      
    } else {
      return /* None */0;
    }
  }
  
}

function pullSyncConfig() {
  var match = readSyncSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return networkSyncStatusSeed;
  }
}

function checkSyncConfigMissing() {
  var match = readSyncSettingsFromLs(/* () */0);
  if (match) {
    return /* None */0;
  } else {
    return /* Some */[networkSyncStatusSeed];
  }
}

function writeSyncStatusToLs(payload) {
  var syncRes = Json.stringify(payload);
  console.log("writeSyncStatusToLs");
  localStorage.setItem("network_sync_status", syncRes);
  return /* () */0;
}

function initializeSyncStatus2() {
  var res = checkSyncConfigMissing(/* () */0);
  if (res) {
    var syncRes = Json.stringify(res[0]);
    console.log("initializeSyncStatus2", syncRes);
    localStorage.setItem("network_sync_status", syncRes);
    return /* () */0;
  } else {
    console.log("sync config not missing");
    return /* () */0;
  }
}

function setEntryFresh(entry) {
  var res = pullSyncConfig(/* () */0);
  console.log("setEntryFresh");
  Caml_array.caml_array_set(Caml_array.caml_array_get(res, entry), 0, "fresh");
  Caml_array.caml_array_set(Caml_array.caml_array_get(res, entry), 1, Curry._1(Printf.sprintf(/* Format */[
                /* Float */Block.__(8, [
                    /* Float_f */0,
                    /* No_padding */0,
                    /* Lit_precision */[1],
                    /* End_of_format */0
                  ]),
                "%.1f"
              ]), Date.now()));
  var syncRes = Json.stringify(res);
  localStorage.setItem("network_sync_status", syncRes);
  return /* () */0;
}

function setEntrySynced(entry, stamp) {
  var res = pullSyncConfig(/* () */0);
  console.log("set entry synced: ", entry);
  Caml_array.caml_array_set(Caml_array.caml_array_get(res, entry), 0, "synced");
  Caml_array.caml_array_set(Caml_array.caml_array_get(res, entry), 1, Curry._1(Printf.sprintf(/* Format */[
                /* Float */Block.__(8, [
                    /* Float_f */0,
                    /* No_padding */0,
                    /* Lit_precision */[1],
                    /* End_of_format */0
                  ]),
                "%.1f"
              ]), stamp));
  var syncRes = Json.stringify(res);
  localStorage.setItem("network_sync_status", syncRes);
  return /* () */0;
}

function setEntrySyncedString(entry, stamp) {
  var res = pullSyncConfig(/* () */0);
  console.log("set entry synced string: ", entry);
  Caml_array.caml_array_set(Caml_array.caml_array_get(res, entry), 0, "synced");
  Caml_array.caml_array_set(Caml_array.caml_array_get(res, entry), 1, stamp);
  var syncRes = Json.stringify(res);
  console.log("set entry synced string syncRes: ", syncRes);
  localStorage.setItem("network_sync_status", syncRes);
  return /* () */0;
}

function getUrlParamCode(reqType) {
  var url = ReasonReact.Router[/* dangerouslyGetInitialUrl */3](/* () */0);
  var search = url[/* search */2];
  var codeFromUrl = function (myString) {
    var param = new RegExp("token=(\\w+)").exec(myString);
    if (param !== null) {
      return Js_primitive.null_undefined_to_opt(Caml_array.caml_array_get(param, 1));
    } else {
      return /* None */0;
    }
  };
  var cleanCode = function () {
    var match = codeFromUrl(search);
    if (match) {
      return match[0];
    } else {
      return "";
    }
  };
  var cleanCodeString = cleanCode(/* () */0);
  var emailFromUrl = function (myString) {
    var param = new RegExp("email=(.+)").exec(myString);
    if (param !== null) {
      return Js_primitive.null_undefined_to_opt(Caml_array.caml_array_get(param, 1));
    } else {
      return /* None */0;
    }
  };
  var emailRes = function () {
    var match = emailFromUrl(search);
    if (match) {
      return match[0];
    } else {
      return "";
    }
  };
  var emailAdr = emailRes(/* () */0);
  var cleanR = (
      function(a) {
        return decodeURIComponent(a);
        }
      );
  var cleanEmail = Curry._1(cleanR, emailAdr);
  if (reqType !== 0) {
    return cleanEmail;
  } else {
    return cleanCodeString;
  }
}

function decodePayload(json) {
  return Json_decode.field("payload", Json_decode.string, json);
}

function decodeEmail(json) {
  return Json_decode.field("email", Json_decode.string, json);
}

function storeEmail(email) {
  console.log("email: ", email);
  var emailRes = Json.stringify(email);
  localStorage.setItem("email", emailRes);
  return /* () */0;
}

function checkEmail(jsonVal) {
  var exit = 0;
  var returnString;
  try {
    returnString = Json_decode.string(jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("email parsing failure: ", x[1]);
      return /* None */0;
    } else {
      console.log("email parsing issue: ", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnString];
  }
  
}

function readEmailFromLs() {
  var match = localStorage.getItem("email");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("email checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkEmail(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullEmail() {
  var match = readEmailFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return "";
  }
}

function jsonParse$1(vals) {
  try {
    return JSON.parse(vals);
  }
  catch (exn){
    return Pervasives.failwith("Error parsing JSON string");
  }
}

function successFuncPush(data) {
  return Promise.resolve(data).then((function (prim) {
                    return prim.json();
                  })).then((function (json) {
                  Json_decode.field("payload", Json_decode.string, json);
                  return Promise.resolve((console.log("data push real success"), /* () */0));
                })).catch((function (err) {
                return Promise.resolve((console.log("network call response parse error", err), /* () */0));
              }));
}

function issueFunc(data) {
  return Promise.resolve(data).then((function () {
                  console.log("Call error!", data);
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("Login error exception", err), /* () */0));
              }));
}

function issueFunc2(data) {
  return Promise.resolve(data).then((function () {
                  console.log("Other error!");
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("Other http error exception", err), /* () */0));
              }));
}

function pushData(dataType, payload, arrNumber) {
  console.log("initiating data push of: ", dataType);
  var stamp = Date.now();
  var requestPayload = Json_encode.object_(/* :: */[
        /* tuple */[
          dataType,
          payload
        ],
        /* :: */[
          /* tuple */[
            "update_" + dataType,
            Curry._1(Printf.sprintf(/* Format */[
                      /* Float */Block.__(8, [
                          /* Float_f */0,
                          /* No_padding */0,
                          /* Lit_precision */[1],
                          /* End_of_format */0
                        ]),
                      "%.1f"
                    ]), stamp)
          ],
          /* [] */0
        ]
      ]);
  var requestPayloadContainer = Json_encode.object_(/* :: */[
        /* tuple */[
          "payload",
          JSON.stringify(requestPayload)
        ],
        /* [] */0
      ]);
  fetch(dataUrl, Fetch.RequestInit[/* make */0](/* Some */[/* Put */3], /* Some */[{
                    "Content-Type": "application/json",
                    Accept: "application.json",
                    Authorization: "Bearer " + getBearer(/* () */0)
                  }], /* Some */[JSON.stringify(requestPayloadContainer)], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0)).then((function (data) {
            var statusCode = data.status;
            console.log("https status: ", statusCode);
            var switcher = statusCode - 400 | 0;
            if (switcher === 0 || switcher === 1) {
              if (switcher !== 0) {
                console.log("issue 401: ", data);
                return issueFunc(data);
              } else {
                console.log("issue 400: ", data);
                return issueFunc(data);
              }
            } else if (switcher !== -200) {
              console.log("network isse: ", data);
              return issueFunc2(data);
            } else {
              setEntrySynced(arrNumber, stamp);
              return successFuncPush(data);
            }
          })).catch((function (err) {
          return Promise.resolve((console.log("api error push: ", err), /* () */0));
        }));
  return /* () */0;
}

function decodePayloadKeyStart(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, Json_decode.string, json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message start fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message start exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyWizard(theKey, json) {
  var res = function (json) {
    return /* record */[
            /* weight */Json_decode.field("weight", Json_decode.$$int, json),
            /* cals */Json_decode.field("cals", Json_decode.$$int, json),
            /* duration */Json_decode.field("duration", Json_decode.$$int, json)
          ];
  };
  var value;
  var exit = 0;
  var myObj;
  try {
    myObj = Json_decode.field(theKey, res, json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message wizard exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myObj];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr;
  try {
    myArr = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyLevels(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, (function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array(Json_decode.$$int, param);
                        }), param);
          }), json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message levels fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message levels exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message levels date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message levels date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyReps(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, (function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array((function (param) {
                                        return Json_decode.array(Json_decode.$$int, param);
                                      }), param);
                        }), param);
          }), json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message reps fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message reps exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message reps date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message reps date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyPoints(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, (function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array((function (param) {
                                        return Json_decode.array(Json_decode.$$int, param);
                                      }), param);
                        }), param);
          }), json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message points fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message points exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message points date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message points date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyCompleted(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, (function (param) {
            return Json_decode.array(Json_decode.bool, param);
          }), json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message completed fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message completed exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message completed date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message completed date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyFood(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, (function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array((function (param) {
                                        return Json_decode.array(Json_decode.string, param);
                                      }), param);
                        }), param);
          }), json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message food fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message food exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message date food exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyBonus(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, (function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array(Json_decode.bool, param);
                        }), param);
          }), json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message bonus exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyKnowledge(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, (function (param) {
            return Json_decode.array(Json_decode.bool, param);
          }), json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message read fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message read exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message read date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message read date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function readWizardResultFromLs(rawJson) {
  try {
    var json = rawJson;
    return /* record */[
            /* weight */Json_decode.field("weight", Json_decode.$$int, json),
            /* cals */Json_decode.field("cals", Json_decode.$$int, json),
            /* duration */Json_decode.field("duration", Json_decode.$$int, json)
          ];
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    console.log("exception in unpack", x);
    ReasonReact.Router[/* push */0]("/wizard/1");
    return /* record */[
            /* weight */0,
            /* cals */0,
            /* duration */0
          ];
  }
}

function readWizardResultFromLsOption(rawJson) {
  var res = function (json) {
    return /* record */[
            /* weight */Json_decode.field("weight", Json_decode.$$int, json),
            /* cals */Json_decode.field("cals", Json_decode.$$int, json),
            /* duration */Json_decode.field("duration", Json_decode.$$int, json)
          ];
  };
  var exit = 0;
  var result;
  try {
    result = res(rawJson);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    console.log("exception in unpack", x);
    return /* None */0;
  }
  if (exit === 1) {
    var match = +(result[/* weight */0] === 0);
    if (match !== 0) {
      return /* None */0;
    } else {
      return /* Some */[result];
    }
  }
  
}

function getWeight() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("getWeight exception", exn[1]);
        return 0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        return readWizardResultFromLs(x[0])[/* weight */0];
      } else {
        return 0;
      }
    }
    
  } else {
    return 0;
  }
}

function getDuration() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("getDuration exception", exn[1]);
        return 0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        return readWizardResultFromLs(x[0])[/* duration */2];
      } else {
        return 0;
      }
    }
    
  } else {
    return 0;
  }
}

function getCals() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("getDuration exception", exn[1]);
        return 0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        var match$1 = readWizardResultFromLs(x[0])[/* cals */1];
        if (match$1 !== 1100) {
          if (match$1 !== 1300) {
            if (match$1 !== 1500) {
              return 0;
            } else {
              return 1500;
            }
          } else {
            return 1300;
          }
        } else {
          return 1100;
        }
      } else {
        return 0;
      }
    }
    
  } else {
    return 0;
  }
}

function pullWizardConfig() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("exception in unpack", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        return readWizardResultFromLsOption(x[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function wizardEncoder(weight, cals, duration) {
  return Json_encode.object_(/* :: */[
              /* tuple */[
                "weight",
                weight
              ],
              /* :: */[
                /* tuple */[
                  "cals",
                  cals
                ],
                /* :: */[
                  /* tuple */[
                    "duration",
                    duration
                  ],
                  /* [] */0
                ]
              ]
            ]);
}

function pushWizard(w, c, d) {
  pushData("wizard_result", wizardEncoder(w, c, d), 1);
  console.log("wizard data maybe pushed to server");
  return /* () */0;
}

function setLocalWizard(w, c, d) {
  var wizardRes = JSON.stringify(wizardEncoder(w, c, d));
  localStorage.setItem("wizard_result", wizardRes);
  setEntryFresh(1);
  console.log("wizard data set fresh");
  return /* () */0;
}

function safeWizardResultToLs(param) {
  var d = param[2];
  var c = param[1];
  var w = param[0];
  setLocalWizard(w, c, d);
  return pushWizard(w, c, d);
}

function updateWizardResultToLS(d) {
  var w = getWeight(/* () */0);
  var c = getCals(/* () */0);
  setLocalWizard(w, c, d);
  return pushWizard(w, c, d);
}

function updateWizardCalsResultToLS(c) {
  var w = getWeight(/* () */0);
  var d = getDuration(/* () */0);
  setLocalWizard(w, c, d);
  return pushWizard(w, c, d);
}

function pushStart(start) {
  pushData("start_date_timestamp", Curry._1(Printf.sprintf(/* Format */[
                /* Float */Block.__(8, [
                    /* Float_f */0,
                    /* No_padding */0,
                    /* Lit_precision */[1],
                    /* End_of_format */0
                  ]),
                "%.1f"
              ]), start), 0);
  console.log("start date pushed to server");
  return /* () */0;
}

function setLocalStart(start) {
  localStorage.setItem("start_date_timestamp", Curry._1(Printf.sprintf(/* Format */[
                /* Float */Block.__(8, [
                    /* Float_f */0,
                    /* No_padding */0,
                    /* Lit_precision */[1],
                    /* End_of_format */0
                  ]),
                "%.1f"
              ]), start));
  return setEntryFresh(0);
}

function setLocalStartString(start) {
  localStorage.setItem("start_date_timestamp", start);
  return setEntryFresh(0);
}

function saveFirstWorkoutDate() {
  var now = Date.now();
  setLocalStart(now);
  return pushStart(now);
}

function resetStartDate() {
  setLocalStart(0.0);
  return pushStart(0.0);
}

function pullStart() {
  var match = localStorage.getItem("start_date_timestamp");
  if (match !== null) {
    try {
      return Caml_format.caml_float_of_string(match);
    }
    catch (exn){
      console.log("issue with startDate conversion to float");
      return 1.0;
    }
  } else {
    return 0.0;
  }
}

function checkLevels(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array((function (param) {
            return Json_decode.array(Json_decode.$$int, param);
          }), jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("expiry parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("expiry parsing issue!", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readLevelSettingsFromLs() {
  var match = localStorage.getItem("levels");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("levels in checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkLevels(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullLevelConfig() {
  var match = readLevelSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return Seed.workoutLevels;
  }
}

function pushLevels(levels) {
  pushData("levels", levels, 2);
  console.log("levels data pushed to server");
  return /* () */0;
}

function setLocalLevels(allLev) {
  var levelRes = Json.stringify(allLev);
  localStorage.setItem("levels", levelRes);
  return setEntryFresh(2);
}

function safeLevelSettingsToLs(lev, allLev, ind) {
  var newLevels = $$Array.copy(allLev);
  Caml_array.caml_array_set(newLevels, ind, lev);
  setLocalLevels(newLevels);
  return pushLevels(newLevels);
}

function resetLevels() {
  setLocalLevels(Seed.workoutLevels);
  return pushLevels(Seed.workoutLevels);
}

function checkReps(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array((function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array(Json_decode.$$int, param);
                        }), param);
          }), jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("expiry parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("expiry parsing issue!", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readRepsSettingsFromLs() {
  var match = localStorage.getItem("reps");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("reps checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkReps(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullRepsConfig() {
  var match = readRepsSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return Seed.workoutReps;
  }
}

function checkPoints(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array((function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array(Json_decode.$$int, param);
                        }), param);
          }), jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("expiry parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("expiry parsing issue!", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readPointsSettingsFromLs() {
  var match = localStorage.getItem("points");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("Points checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkPoints(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullPointsConfig() {
  var match = readPointsSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return Seed.workoutReps;
  }
}

function calcPointsOverall(points) {
  var res1 = function (arr) {
    return $$Array.fold_left((function (x, y) {
                  return x + y | 0;
                }), 0, arr);
  };
  var res2 = function (arr) {
    return $$Array.fold_left((function (x, y) {
                  return x + res1(y) | 0;
                }), 0, arr);
  };
  var arr = points;
  return $$Array.fold_left((function (x, y) {
                return x + res2(y) | 0;
              }), 0, arr);
}

function calcPointsWeek(week) {
  var start = Caml_int32.imul(6, week) - 6 | 0;
  return calcPointsOverall($$Array.sub(pullPointsConfig(/* () */0), start, 6));
}

function pushReps(reps) {
  return pushData("reps", reps, 3);
}

function setLocalReps(reps) {
  var repsRes = Json.stringify(reps);
  localStorage.setItem("reps", repsRes);
  return setEntryFresh(3);
}

function pushPoints(points) {
  return pushData("points", points, 4);
}

function setLocalPoints(points) {
  var repsResPoints = Json.stringify(points);
  localStorage.setItem("points", repsResPoints);
  return setEntryFresh(4);
}

function storePoints(workoutIndex, round, pair, exCur1, exCur2, levels) {
  var newArrPoints = pullPointsConfig(/* () */0);
  Caml_array.caml_array_set(Caml_array.caml_array_get(Caml_array.caml_array_get(newArrPoints, workoutIndex), round - 1 | 0), (pair << 1) - 2 | 0, Caml_int32.imul(exCur1, Caml_array.caml_array_get(levels, (pair << 1) - 2 | 0)));
  Caml_array.caml_array_set(Caml_array.caml_array_get(Caml_array.caml_array_get(newArrPoints, workoutIndex), round - 1 | 0), (pair << 1) - 1 | 0, Caml_int32.imul(exCur2, Caml_array.caml_array_get(levels, (pair << 1) - 1 | 0)));
  setLocalPoints(newArrPoints);
  return pushPoints(newArrPoints);
}

function resetSinglePoints(workoutIndex) {
  var newArrPoints = pullPointsConfig(/* () */0);
  Caml_array.caml_array_set(newArrPoints, workoutIndex, Caml_array.caml_array_get(Seed.workoutReps, workoutIndex));
  setLocalPoints(newArrPoints);
  return pushPoints(newArrPoints);
}

function storeReps(workoutIndex, round, pair, exCur1, exCur2, _) {
  var newArr = pullRepsConfig(/* () */0);
  Caml_array.caml_array_set(Caml_array.caml_array_get(Caml_array.caml_array_get(newArr, workoutIndex), round - 1 | 0), (pair << 1) - 2 | 0, exCur1);
  Caml_array.caml_array_set(Caml_array.caml_array_get(Caml_array.caml_array_get(newArr, workoutIndex), round - 1 | 0), (pair << 1) - 1 | 0, exCur2);
  setLocalReps(newArr);
  return pushReps(newArr);
}

function resetSingleReps(workoutIndex) {
  var newArr = pullRepsConfig(/* () */0);
  Caml_array.caml_array_set(newArr, workoutIndex, Caml_array.caml_array_get(Seed.workoutReps, workoutIndex));
  setLocalReps(newArr);
  return pushReps(newArr);
}

function storePointsAndReps(workoutIndex, round, pair, exCur1, exCur2, levels) {
  storePoints(workoutIndex, round, pair, exCur1, exCur2, levels);
  return storeReps(workoutIndex, round, pair, exCur1, exCur2, levels);
}

function resetPointsAndReps() {
  setLocalReps(Seed.workoutReps);
  pushReps(Seed.workoutReps);
  setLocalPoints(Seed.workoutReps);
  return pushPoints(Seed.workoutReps);
}

function checkCompleted(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array(Json_decode.bool, jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("completion parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("completion parsing issue!", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readCompletedSettingsFromLs() {
  var match = localStorage.getItem("completed");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("Completion checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkCompleted(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullCompletedConfig() {
  var match = readCompletedSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return Seed.completedArray;
  }
}

function pushCompleted(completed) {
  var compRes = completed.map(Json_encode.bool);
  return pushData("completed", compRes, 5);
}

function setLocalCompleted(completed) {
  var compRes = Json.stringify(completed.map(Json_encode.bool));
  localStorage.setItem("completed", compRes);
  return setEntryFresh(5);
}

function storeCompletedWorkout(workoutIndex) {
  var completedArray = pullCompletedConfig(/* () */0);
  Caml_array.caml_array_set(completedArray, workoutIndex, /* true */1);
  setLocalCompleted(completedArray);
  return pushCompleted(completedArray);
}

function resetSingleCompletedWorkout(workoutIndex) {
  var completedArray = pullCompletedConfig(/* () */0);
  Caml_array.caml_array_set(completedArray, workoutIndex, /* false */0);
  setLocalCompleted(completedArray);
  return pushCompleted(completedArray);
}

function resetCompleted() {
  setLocalCompleted(Seed.completedArray);
  return pushCompleted(Seed.completedArray);
}

function check16Completed() {
  var data = pullCompletedConfig(/* () */0);
  var sumOfDone = $$Array.fold_left((function (summer, el) {
          var match = +(el === /* true */1);
          var elInt = match !== 0 ? 1 : 0;
          return summer + elInt | 0;
        }), 0, data);
  var match = +(sumOfDone === 16);
  if (match !== 0) {
    return /* true */1;
  } else {
    return /* false */0;
  }
}

function checkKnowledge(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array(Json_decode.bool, jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("read parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("read parsing issue!", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readKnowledgeSettingsFromLs() {
  var match = localStorage.getItem("knowledge_read");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("read checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkKnowledge(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullKnowledgeConfig() {
  var match = readKnowledgeSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return Seed.knowledgeRead;
  }
}

function pushKnowledge(read) {
  var readRes = read.map(Json_encode.bool);
  return pushData("knowledge_read", readRes, 8);
}

function setLocalKnowledge(read) {
  var readRes = Json.stringify(read.map(Json_encode.bool));
  localStorage.setItem("knowledge_read", readRes);
  return setEntryFresh(8);
}

function storeKnowledgeRead(index) {
  var knowledgeArray = pullKnowledgeConfig(/* () */0);
  Caml_array.caml_array_set(knowledgeArray, index, /* true */1);
  setLocalKnowledge(knowledgeArray);
  return pushKnowledge(knowledgeArray);
}

function resetKnowledge() {
  setLocalKnowledge(Seed.knowledgeRead);
  return pushKnowledge(Seed.knowledgeRead);
}

function checkFood(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array((function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array(Json_decode.string, param);
                        }), param);
          }), jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("food parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("food parsing issue", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readFoodSettingsFromLs() {
  var match = localStorage.getItem("food_plan");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("food checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkFood(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullFoodConfig() {
  var match = readFoodSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return FoodSeed.foodPlanSeed;
  }
}

function getStageNumber(stage) {
  switch (stage) {
    case "breakfast" : 
        return 0;
    case "dinner" : 
        return 3;
    case "lunch" : 
        return 2;
    case "snack" : 
        return 1;
    default:
      return 0;
  }
}

function pushFood(food) {
  var foodRes = Json.stringify(food);
  pushData("food_plan", jsonParse$1(foodRes), 6);
  console.log("bonus data pushed to server maybe");
  return /* () */0;
}

function setLocalFood(food) {
  var foodRes = Json.stringify(food);
  localStorage.setItem("food_plan", foodRes);
  return setEntryFresh(6);
}

function writeFoodToLs(day, stage, foodType, payload) {
  var stageNum = getStageNumber(stage);
  var food = pullFoodConfig(/* () */0);
  Caml_array.caml_array_set(Caml_array.caml_array_get(Caml_array.caml_array_get(food, day - 1 | 0), stageNum), foodType - 1 | 0, payload);
  setLocalFood(food);
  return pushFood(food);
}

function resetFood() {
  setLocalFood(FoodSeed.foodPlanSeed);
  return pushFood(FoodSeed.foodPlanSeed);
}

function getStageFood(day, stage) {
  var food = pullFoodConfig(/* () */0);
  var stageNum = getStageNumber(stage);
  return Caml_array.caml_array_get(Caml_array.caml_array_get(food, day - 1 | 0), stageNum);
}

function checkBonus(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array((function (param) {
            return Json_decode.array(Json_decode.bool, param);
          }), jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("bonus parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("bonus parsing issue", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readBonusSettingsFromLs() {
  var match = localStorage.getItem("bonus_done");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("bonus checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkBonus(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullBonusConfig() {
  var match = readBonusSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return Seed.bonusDone;
  }
}

function pushBonus(bonus) {
  var bonusRes = bonus.map((function (x) {
          return x.map(Json_encode.bool);
        }));
  pushData("bonus_done", bonusRes, 7);
  console.log("bonus data pushed to server");
  return /* () */0;
}

function setLocalBonus(networkPayload) {
  var bonusRes = Json.stringify(networkPayload.map((function (x) {
              return x.map(Json_encode.bool);
            })));
  localStorage.setItem("bonus_done", bonusRes);
  return setEntryFresh(7);
}

function writeBonusToLs(week, payload) {
  var bonus = pullBonusConfig(/* () */0);
  Caml_array.caml_array_set(bonus, Caml_format.caml_int_of_string(week) - 1 | 0, payload);
  setLocalBonus(bonus);
  return pushBonus(bonus);
}

function resetBonus() {
  setLocalBonus(Seed.bonusDone);
  return pushBonus(Seed.bonusDone);
}

function syncStart(networkPayload) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 0), 1);
  var serverDate = networkPayload[/* syncDate */1];
  var start = pullStart(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("serverdate: ", sDate);
      console.log("pushing start data up");
      pushStart(start);
    }
    if (localDate < sDate) {
      console.log("pulling start data down");
      var match = networkPayload[/* value */0];
      if (match) {
        setLocalStartString(match[0]);
        console.log("set start entry synced");
        setEntrySyncedString(0, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushStart(start);
    }
    
  }
  return /* () */0;
}

function pushWizardMaybe(wizard) {
  if (wizard) {
    var res = wizard[0];
    return pushWizard(res[/* weight */0], res[/* cals */1], res[/* duration */2]);
  } else {
    return ReasonReact.Router[/* push */0]("/wizard/1");
  }
}

function syncWizard(networkPayload) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 1), 1);
  var serverDate = networkPayload[/* syncDate */1];
  var wizard = pullWizardConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("pushing wizard * data up");
      pushWizardMaybe(wizard);
    }
    if (localDate < sDate) {
      console.log("pulling wizard * data down");
      var match = networkPayload[/* value */0];
      if (match) {
        var res = match[0];
        setLocalWizard(res[/* weight */0], res[/* cals */1], res[/* duration */2]);
        console.log("server data for wizard synced to local");
        setEntrySyncedString(1, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushWizardMaybe(wizard);
    } else {
      ReasonReact.Router[/* push */0]("/wizard/1");
    }
  }
  return /* () */0;
}

function syncLevels(networkPayload) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 2), 1);
  var serverDate = networkPayload[/* syncDate */1];
  var levels = pullLevelConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("pushing level data up");
      pushLevels(levels);
    }
    if (localDate < sDate) {
      console.log("pulling level data down");
      var match = networkPayload[/* value */0];
      if (match) {
        setLocalLevels(match[0]);
        console.log("pulling levels data down success");
        setEntrySyncedString(2, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushLevels(levels);
    }
    
  }
  return /* () */0;
}

function syncPoints(networkPayload2) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 4), 1);
  var serverDate = networkPayload2[/* syncDate */1];
  var points = pullPointsConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    console.log("serverdate: ", sDate);
    console.log("localdate: ", localDate);
    if (localDate > sDate) {
      console.log("pushing points data up");
      console.log("serverdate: ", sDate);
      console.log("localdate: ", localDate);
      pushPoints(points);
    }
    if (localDate < sDate) {
      console.log("pulling points data down");
      var match = networkPayload2[/* value */0];
      if (match) {
        setLocalPoints(match[0]);
        console.log("pulling points data down success");
        setEntrySyncedString(4, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushPoints(points);
    }
    
  }
  return /* () */0;
}

function syncReps(networkPayload2) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 3), 1);
  var serverDate = networkPayload2[/* syncDate */1];
  var reps = pullRepsConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("pushing reps data up");
      pushReps(reps);
    }
    if (localDate < sDate) {
      console.log("pulling reps data down");
      var match = networkPayload2[/* value */0];
      if (match) {
        setLocalReps(match[0]);
        setEntrySyncedString(3, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushReps(reps);
    }
    
  }
  return /* () */0;
}

function syncCompleted(networkPayload2) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 5), 1);
  var serverDate = networkPayload2[/* syncDate */1];
  var completed = pullCompletedConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("pushing completed data up");
      pushCompleted(completed);
    }
    if (localDate < sDate) {
      console.log("pulling completed data down");
      var match = networkPayload2[/* value */0];
      if (match) {
        setLocalCompleted(match[0]);
        console.log("pulling completed data down success");
        setEntrySyncedString(5, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushCompleted(completed);
    }
    
  }
  return /* () */0;
}

function syncFood(networkPayload2) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 6), 1);
  var serverDate = networkPayload2[/* syncDate */1];
  var food = pullFoodConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("pushing data up");
      pushFood(food);
    }
    if (localDate < sDate) {
      console.log("pulling food data down");
      var match = networkPayload2[/* value */0];
      if (match) {
        setLocalFood(match[0]);
        console.log("pulling food data down success");
        setEntrySyncedString(6, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushFood(food);
    }
    
  }
  return /* () */0;
}

function syncBonus(networkPayload) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 7), 1);
  var serverDate = networkPayload[/* syncDate */1];
  var bonus = pullBonusConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("pushing data up");
      pushBonus(bonus);
    }
    if (localDate < sDate) {
      console.log("pulling bonus data down");
      var match = networkPayload[/* value */0];
      if (match) {
        setLocalBonus(match[0]);
        console.log("pulling bonus data down success");
        setEntrySyncedString(7, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushBonus(bonus);
    }
    
  }
  return /* () */0;
}

function syncKnowledge(networkPayload2) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 8), 1);
  var serverDate = networkPayload2[/* syncDate */1];
  var read = pullKnowledgeConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("pushing read data up");
      pushKnowledge(read);
    }
    if (localDate < sDate) {
      console.log("pulling read data down");
      var match = networkPayload2[/* value */0];
      if (match) {
        setLocalKnowledge(match[0]);
        console.log("pulling read data down success");
        setEntrySyncedString(8, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushKnowledge(read);
    }
    
  }
  return /* () */0;
}

function syncStartWrapper(data) {
  return syncStart(decodePayloadKeyStart("start_date_timestamp", data));
}

function syncWizardWrapper(data) {
  return syncWizard(decodePayloadKeyWizard("wizard_result", data));
}

function syncLevelsWrapper(data) {
  return syncLevels(decodePayloadKeyLevels("levels", data));
}

function syncRepsAndPointsWrapper(data) {
  syncReps(decodePayloadKeyReps("reps", data));
  return syncPoints(decodePayloadKeyPoints("points", data));
}

function syncCompletedWrapper(data) {
  return syncCompleted(decodePayloadKeyCompleted("completed", data));
}

function syncFoodWrapper(data) {
  return syncFood(decodePayloadKeyFood("food_plan", data));
}

function syncBonusWrapper(data) {
  return syncBonus(decodePayloadKeyBonus("bonus_done", data));
}

function syncKnowledgeWrapper(data) {
  return syncKnowledge(decodePayloadKeyKnowledge("knowledge_read", data));
}

function successSyncAllRunner(data, cb) {
  return Promise.resolve(data).then((function (prim) {
                    return prim.json();
                  })).then((function (json) {
                  var email = Json_decode.field("email", Json_decode.string, json);
                  storeEmail(email);
                  console.log("get Email from LS: ", pullEmail(/* () */0));
                  var parsed = jsonParse$1(Json_decode.field("payload", Json_decode.string, json));
                  syncStart(decodePayloadKeyStart("start_date_timestamp", parsed));
                  syncWizard(decodePayloadKeyWizard("wizard_result", parsed));
                  syncLevels(decodePayloadKeyLevels("levels", parsed));
                  syncRepsAndPointsWrapper(parsed);
                  syncCompleted(decodePayloadKeyCompleted("completed", parsed));
                  syncFood(decodePayloadKeyFood("food_plan", parsed));
                  syncBonus(decodePayloadKeyBonus("bonus_done", parsed));
                  syncKnowledge(decodePayloadKeyKnowledge("knowledge_read", parsed));
                  console.log("all synced");
                  Curry._1(cb, /* () */0);
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                console.log("network call response parse error", err);
                Curry._1(cb, /* () */0);
                return Promise.resolve(/* () */0);
              }));
}

function redirectToDash() {
  console.log("+++ Redirecting to dash +++");
  return ReasonReact.Router[/* push */0]("/dashboard");
}

function successSyncAll(data) {
  return successSyncAllRunner(data, redirectToDash);
}

var successSyncAllNoRedirect = successSyncAllRunner;

function resetAll() {
  console.log("resetting");
  resetStartDate(/* () */0);
  safeWizardResultToLs(/* tuple */[
        0,
        0,
        0
      ]);
  setLocalLevels(Seed.workoutLevels);
  pushLevels(Seed.workoutLevels);
  resetPointsAndReps(/* () */0);
  setLocalCompleted(Seed.completedArray);
  pushCompleted(Seed.completedArray);
  setLocalFood(FoodSeed.foodPlanSeed);
  pushFood(FoodSeed.foodPlanSeed);
  setLocalBonus(Seed.bonusDone);
  pushBonus(Seed.bonusDone);
  setLocalKnowledge(Seed.knowledgeRead);
  return pushKnowledge(Seed.knowledgeRead);
}

function pullData(dataType, cb) {
  console.log("initiating data pull of all or: ", dataType);
  var match = +(dataType === "");
  var urlParams = match !== 0 ? "" : "&payload=" + (dataType + (",update_" + dataType));
  var url = dataUrl + urlParams;
  fetch(url, Fetch.RequestInit[/* make */0](/* Some */[/* Get */0], /* Some */[{
                    Accept: "application.json",
                    Authorization: "Bearer " + getBearer(/* () */0)
                  }], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0)).then((function (data) {
            var statusCode = data.status;
            console.log("https status in pull: ", statusCode);
            var switcher = statusCode - 400 | 0;
            if (switcher === 0 || switcher === 1) {
              if (switcher !== 0) {
                console.log("issue 401: ", data);
                return issueFunc(data);
              } else {
                console.log("issue 400: ", data);
                return issueFunc(data);
              }
            } else if (switcher !== -200) {
              console.log("network isse: ", data);
              return issueFunc2(data);
            } else {
              console.log("success pulling data", data);
              return Curry._1(cb, data);
            }
          })).catch((function (err) {
          return Promise.resolve((console.log("api error pull: ", err), /* () */0));
        }));
  return /* () */0;
}

var clientId = "1";

var clientSecret = "pie8Eu2JmeanoJe6ab2eiCaekeiGooD6";

var mBBClientId = "2";

var mBBClientSecret = "64fe59360a1142f5ac43c585c35c43c6";

var grantType = "password";

var loginUrl = "https://shopify.ilpt.de/api/access_token?shop=ilptbook.myshopify.com";

var registerUrl = "https://shopify.ilpt.de/api/apps/?shop=ilptbook.myshopify.com";

var resetUrl = "https://shopify.ilpt.de/api/apps/password-reset?shop=ilptbook.myshopify.com&product=mbb-ebook";

var resetExecUrl = "https://shopify.ilpt.de/api/apps/password-reset?shop=ilptbook.myshopify.com";

exports.clientId = clientId;
exports.clientSecret = clientSecret;
exports.mBBClientId = mBBClientId;
exports.mBBClientSecret = mBBClientSecret;
exports.grantType = grantType;
exports.loginUrl = loginUrl;
exports.registerUrl = registerUrl;
exports.resetUrl = resetUrl;
exports.resetExecUrl = resetExecUrl;
exports.dataUrl = dataUrl;
exports.getBearer = getBearer;
exports.networkSyncStatusSeed = networkSyncStatusSeed;
exports.checkSync = checkSync;
exports.readSyncSettingsFromLs = readSyncSettingsFromLs;
exports.pullSyncConfig = pullSyncConfig;
exports.checkSyncConfigMissing = checkSyncConfigMissing;
exports.writeSyncStatusToLs = writeSyncStatusToLs;
exports.initializeSyncStatus2 = initializeSyncStatus2;
exports.setEntryFresh = setEntryFresh;
exports.setEntrySynced = setEntrySynced;
exports.setEntrySyncedString = setEntrySyncedString;
exports.getUrlParamCode = getUrlParamCode;
exports.decodePayload = decodePayload;
exports.decodeEmail = decodeEmail;
exports.storeEmail = storeEmail;
exports.checkEmail = checkEmail;
exports.readEmailFromLs = readEmailFromLs;
exports.pullEmail = pullEmail;
exports.jsonParse = jsonParse$1;
exports.successFuncPush = successFuncPush;
exports.issueFunc = issueFunc;
exports.issueFunc2 = issueFunc2;
exports.pushData = pushData;
exports.decodePayloadKeyStart = decodePayloadKeyStart;
exports.decodePayloadKeyWizard = decodePayloadKeyWizard;
exports.decodePayloadKeyLevels = decodePayloadKeyLevels;
exports.decodePayloadKeyReps = decodePayloadKeyReps;
exports.decodePayloadKeyPoints = decodePayloadKeyPoints;
exports.decodePayloadKeyCompleted = decodePayloadKeyCompleted;
exports.decodePayloadKeyFood = decodePayloadKeyFood;
exports.decodePayloadKeyBonus = decodePayloadKeyBonus;
exports.decodePayloadKeyKnowledge = decodePayloadKeyKnowledge;
exports.readWizardResultFromLs = readWizardResultFromLs;
exports.readWizardResultFromLsOption = readWizardResultFromLsOption;
exports.getWeight = getWeight;
exports.getDuration = getDuration;
exports.getCals = getCals;
exports.pullWizardConfig = pullWizardConfig;
exports.wizardEncoder = wizardEncoder;
exports.pushWizard = pushWizard;
exports.setLocalWizard = setLocalWizard;
exports.safeWizardResultToLs = safeWizardResultToLs;
exports.updateWizardResultToLS = updateWizardResultToLS;
exports.updateWizardCalsResultToLS = updateWizardCalsResultToLS;
exports.pushStart = pushStart;
exports.setLocalStart = setLocalStart;
exports.setLocalStartString = setLocalStartString;
exports.saveFirstWorkoutDate = saveFirstWorkoutDate;
exports.resetStartDate = resetStartDate;
exports.pullStart = pullStart;
exports.checkLevels = checkLevels;
exports.readLevelSettingsFromLs = readLevelSettingsFromLs;
exports.pullLevelConfig = pullLevelConfig;
exports.pushLevels = pushLevels;
exports.setLocalLevels = setLocalLevels;
exports.safeLevelSettingsToLs = safeLevelSettingsToLs;
exports.resetLevels = resetLevels;
exports.checkReps = checkReps;
exports.readRepsSettingsFromLs = readRepsSettingsFromLs;
exports.pullRepsConfig = pullRepsConfig;
exports.checkPoints = checkPoints;
exports.readPointsSettingsFromLs = readPointsSettingsFromLs;
exports.pullPointsConfig = pullPointsConfig;
exports.calcPointsOverall = calcPointsOverall;
exports.calcPointsWeek = calcPointsWeek;
exports.pushReps = pushReps;
exports.setLocalReps = setLocalReps;
exports.pushPoints = pushPoints;
exports.setLocalPoints = setLocalPoints;
exports.storePoints = storePoints;
exports.resetSinglePoints = resetSinglePoints;
exports.storeReps = storeReps;
exports.resetSingleReps = resetSingleReps;
exports.storePointsAndReps = storePointsAndReps;
exports.resetPointsAndReps = resetPointsAndReps;
exports.checkCompleted = checkCompleted;
exports.readCompletedSettingsFromLs = readCompletedSettingsFromLs;
exports.pullCompletedConfig = pullCompletedConfig;
exports.pushCompleted = pushCompleted;
exports.setLocalCompleted = setLocalCompleted;
exports.storeCompletedWorkout = storeCompletedWorkout;
exports.resetSingleCompletedWorkout = resetSingleCompletedWorkout;
exports.resetCompleted = resetCompleted;
exports.check16Completed = check16Completed;
exports.checkKnowledge = checkKnowledge;
exports.readKnowledgeSettingsFromLs = readKnowledgeSettingsFromLs;
exports.pullKnowledgeConfig = pullKnowledgeConfig;
exports.pushKnowledge = pushKnowledge;
exports.setLocalKnowledge = setLocalKnowledge;
exports.storeKnowledgeRead = storeKnowledgeRead;
exports.resetKnowledge = resetKnowledge;
exports.checkFood = checkFood;
exports.readFoodSettingsFromLs = readFoodSettingsFromLs;
exports.pullFoodConfig = pullFoodConfig;
exports.getStageNumber = getStageNumber;
exports.pushFood = pushFood;
exports.setLocalFood = setLocalFood;
exports.writeFoodToLs = writeFoodToLs;
exports.resetFood = resetFood;
exports.getStageFood = getStageFood;
exports.checkBonus = checkBonus;
exports.readBonusSettingsFromLs = readBonusSettingsFromLs;
exports.pullBonusConfig = pullBonusConfig;
exports.pushBonus = pushBonus;
exports.setLocalBonus = setLocalBonus;
exports.writeBonusToLs = writeBonusToLs;
exports.resetBonus = resetBonus;
exports.syncStart = syncStart;
exports.pushWizardMaybe = pushWizardMaybe;
exports.syncWizard = syncWizard;
exports.syncLevels = syncLevels;
exports.syncPoints = syncPoints;
exports.syncReps = syncReps;
exports.syncCompleted = syncCompleted;
exports.syncFood = syncFood;
exports.syncBonus = syncBonus;
exports.syncKnowledge = syncKnowledge;
exports.syncStartWrapper = syncStartWrapper;
exports.syncWizardWrapper = syncWizardWrapper;
exports.syncLevelsWrapper = syncLevelsWrapper;
exports.syncRepsAndPointsWrapper = syncRepsAndPointsWrapper;
exports.syncCompletedWrapper = syncCompletedWrapper;
exports.syncFoodWrapper = syncFoodWrapper;
exports.syncBonusWrapper = syncBonusWrapper;
exports.syncKnowledgeWrapper = syncKnowledgeWrapper;
exports.successSyncAllRunner = successSyncAllRunner;
exports.redirectToDash = redirectToDash;
exports.successSyncAll = successSyncAll;
exports.successSyncAllNoRedirect = successSyncAllNoRedirect;
exports.resetAll = resetAll;
exports.pullData = pullData;
/* FoodSeed Not a pure module */


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Curry = __webpack_require__(0);
var Caml_int32 = __webpack_require__(11);
var Caml_int64 = __webpack_require__(73);
var Caml_utils = __webpack_require__(34);
var Caml_builtin_exceptions = __webpack_require__(3);

function caml_failwith(s) {
  throw [
        Caml_builtin_exceptions.failure,
        s
      ];
}

function parse_digit(c) {
  if (c >= 65) {
    if (c >= 97) {
      if (c >= 123) {
        return -1;
      } else {
        return c - 87 | 0;
      }
    } else if (c >= 91) {
      return -1;
    } else {
      return c - 55 | 0;
    }
  } else if (c > 57 || c < 48) {
    return -1;
  } else {
    return c - /* "0" */48 | 0;
  }
}

function int_of_string_base(param) {
  switch (param) {
    case 0 : 
        return 8;
    case 1 : 
        return 16;
    case 2 : 
        return 10;
    case 3 : 
        return 2;
    
  }
}

function parse_sign_and_base(s) {
  var sign = 1;
  var base = /* Dec */2;
  var i = 0;
  if (s[i] === "-") {
    sign = -1;
    i = i + 1 | 0;
  }
  var match = s.charCodeAt(i);
  var match$1 = s.charCodeAt(i + 1 | 0);
  if (match === 48) {
    if (match$1 >= 89) {
      if (match$1 !== 98) {
        if (match$1 !== 111) {
          if (match$1 === 120) {
            base = /* Hex */1;
            i = i + 2 | 0;
          }
          
        } else {
          base = /* Oct */0;
          i = i + 2 | 0;
        }
      } else {
        base = /* Bin */3;
        i = i + 2 | 0;
      }
    } else if (match$1 !== 66) {
      if (match$1 !== 79) {
        if (match$1 >= 88) {
          base = /* Hex */1;
          i = i + 2 | 0;
        }
        
      } else {
        base = /* Oct */0;
        i = i + 2 | 0;
      }
    } else {
      base = /* Bin */3;
      i = i + 2 | 0;
    }
  }
  return /* tuple */[
          i,
          sign,
          base
        ];
}

function caml_int_of_string(s) {
  var match = parse_sign_and_base(s);
  var i = match[0];
  var base = int_of_string_base(match[2]);
  var threshold = 4294967295;
  var len = s.length;
  var c = i < len ? s.charCodeAt(i) : /* "\000" */0;
  var d = parse_digit(c);
  if (d < 0 || d >= base) {
    throw [
          Caml_builtin_exceptions.failure,
          "int_of_string"
        ];
  }
  var aux = function (_acc, _k) {
    while(true) {
      var k = _k;
      var acc = _acc;
      if (k === len) {
        return acc;
      } else {
        var a = s.charCodeAt(k);
        if (a === /* "_" */95) {
          _k = k + 1 | 0;
          continue ;
          
        } else {
          var v = parse_digit(a);
          if (v < 0 || v >= base) {
            throw [
                  Caml_builtin_exceptions.failure,
                  "int_of_string"
                ];
          } else {
            var acc$1 = base * acc + v;
            if (acc$1 > threshold) {
              throw [
                    Caml_builtin_exceptions.failure,
                    "int_of_string"
                  ];
            } else {
              _k = k + 1 | 0;
              _acc = acc$1;
              continue ;
              
            }
          }
        }
      }
    };
  };
  var res = match[1] * aux(d, i + 1 | 0);
  var or_res = res | 0;
  if (base === 10 && res !== or_res) {
    throw [
          Caml_builtin_exceptions.failure,
          "int_of_string"
        ];
  }
  return or_res;
}

function caml_int64_of_string(s) {
  var match = parse_sign_and_base(s);
  var hbase = match[2];
  var i = match[0];
  var base = Caml_int64.of_int32(int_of_string_base(hbase));
  var sign = Caml_int64.of_int32(match[1]);
  var threshold;
  switch (hbase) {
    case 0 : 
        threshold = /* int64 */[
          /* hi */536870911,
          /* lo */4294967295
        ];
        break;
    case 1 : 
        threshold = /* int64 */[
          /* hi */268435455,
          /* lo */4294967295
        ];
        break;
    case 2 : 
        threshold = /* int64 */[
          /* hi */429496729,
          /* lo */2576980377
        ];
        break;
    case 3 : 
        threshold = /* int64 */[
          /* hi */2147483647,
          /* lo */4294967295
        ];
        break;
    
  }
  var len = s.length;
  var c = i < len ? s.charCodeAt(i) : /* "\000" */0;
  var d = Caml_int64.of_int32(parse_digit(c));
  if (Caml_int64.lt(d, /* int64 */[
          /* hi */0,
          /* lo */0
        ]) || Caml_int64.ge(d, base)) {
    throw [
          Caml_builtin_exceptions.failure,
          "int64_of_string"
        ];
  }
  var aux = function (_acc, _k) {
    while(true) {
      var k = _k;
      var acc = _acc;
      if (k === len) {
        return acc;
      } else {
        var a = s.charCodeAt(k);
        if (a === /* "_" */95) {
          _k = k + 1 | 0;
          continue ;
          
        } else {
          var v = Caml_int64.of_int32(parse_digit(a));
          if (Caml_int64.lt(v, /* int64 */[
                  /* hi */0,
                  /* lo */0
                ]) || Caml_int64.ge(v, base) || Caml_int64.gt(acc, threshold)) {
            throw [
                  Caml_builtin_exceptions.failure,
                  "int64_of_string"
                ];
          } else {
            var acc$1 = Caml_int64.add(Caml_int64.mul(base, acc), v);
            _k = k + 1 | 0;
            _acc = acc$1;
            continue ;
            
          }
        }
      }
    };
  };
  var res = Caml_int64.mul(sign, aux(d, i + 1 | 0));
  var or_res = Caml_int64.or_(res, /* int64 */[
        /* hi */0,
        /* lo */0
      ]);
  if (Caml_int64.eq(base, /* int64 */[
          /* hi */0,
          /* lo */10
        ]) && Caml_int64.neq(res, or_res)) {
    throw [
          Caml_builtin_exceptions.failure,
          "int64_of_string"
        ];
  }
  return or_res;
}

function int_of_base(param) {
  switch (param) {
    case 0 : 
        return 8;
    case 1 : 
        return 16;
    case 2 : 
        return 10;
    
  }
}

function lowercase(c) {
  if (c >= /* "A" */65 && c <= /* "Z" */90 || c >= /* "\192" */192 && c <= /* "\214" */214 || c >= /* "\216" */216 && c <= /* "\222" */222) {
    return c + 32 | 0;
  } else {
    return c;
  }
}

function parse_format(fmt) {
  var len = fmt.length;
  if (len > 31) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "format_int: format too long"
        ];
  }
  var f = /* record */[
    /* justify */"+",
    /* signstyle */"-",
    /* filter */" ",
    /* alternate : false */0,
    /* base : Dec */2,
    /* signedconv : false */0,
    /* width */0,
    /* uppercase : false */0,
    /* sign */1,
    /* prec */-1,
    /* conv */"f"
  ];
  var _i = 0;
  while(true) {
    var i = _i;
    if (i >= len) {
      return f;
    } else {
      var c = fmt.charCodeAt(i);
      var exit = 0;
      if (c >= 69) {
        if (c >= 88) {
          if (c >= 121) {
            exit = 1;
          } else {
            switch (c - 88 | 0) {
              case 0 : 
                  f[/* base */4] = /* Hex */1;
                  f[/* uppercase */7] = /* true */1;
                  _i = i + 1 | 0;
                  continue ;
                  case 13 : 
              case 14 : 
              case 15 : 
                  exit = 5;
                  break;
              case 12 : 
              case 17 : 
                  exit = 4;
                  break;
              case 23 : 
                  f[/* base */4] = /* Oct */0;
                  _i = i + 1 | 0;
                  continue ;
                  case 29 : 
                  f[/* base */4] = /* Dec */2;
                  _i = i + 1 | 0;
                  continue ;
                  case 1 : 
              case 2 : 
              case 3 : 
              case 4 : 
              case 5 : 
              case 6 : 
              case 7 : 
              case 8 : 
              case 9 : 
              case 10 : 
              case 11 : 
              case 16 : 
              case 18 : 
              case 19 : 
              case 20 : 
              case 21 : 
              case 22 : 
              case 24 : 
              case 25 : 
              case 26 : 
              case 27 : 
              case 28 : 
              case 30 : 
              case 31 : 
                  exit = 1;
                  break;
              case 32 : 
                  f[/* base */4] = /* Hex */1;
                  _i = i + 1 | 0;
                  continue ;
                  
            }
          }
        } else if (c >= 72) {
          exit = 1;
        } else {
          f[/* signedconv */5] = /* true */1;
          f[/* uppercase */7] = /* true */1;
          f[/* conv */10] = String.fromCharCode(lowercase(c));
          _i = i + 1 | 0;
          continue ;
          
        }
      } else {
        var switcher = c - 32 | 0;
        if (switcher > 25 || switcher < 0) {
          exit = 1;
        } else {
          switch (switcher) {
            case 3 : 
                f[/* alternate */3] = /* true */1;
                _i = i + 1 | 0;
                continue ;
                case 0 : 
            case 11 : 
                exit = 2;
                break;
            case 13 : 
                f[/* justify */0] = "-";
                _i = i + 1 | 0;
                continue ;
                case 14 : 
                f[/* prec */9] = 0;
                var j = i + 1 | 0;
                while((function(j){
                    return function () {
                      var w = fmt.charCodeAt(j) - /* "0" */48 | 0;
                      return +(w >= 0 && w <= 9);
                    }
                    }(j))()) {
                  f[/* prec */9] = (Caml_int32.imul(f[/* prec */9], 10) + fmt.charCodeAt(j) | 0) - /* "0" */48 | 0;
                  j = j + 1 | 0;
                };
                _i = j;
                continue ;
                case 1 : 
            case 2 : 
            case 4 : 
            case 5 : 
            case 6 : 
            case 7 : 
            case 8 : 
            case 9 : 
            case 10 : 
            case 12 : 
            case 15 : 
                exit = 1;
                break;
            case 16 : 
                f[/* filter */2] = "0";
                _i = i + 1 | 0;
                continue ;
                case 17 : 
            case 18 : 
            case 19 : 
            case 20 : 
            case 21 : 
            case 22 : 
            case 23 : 
            case 24 : 
            case 25 : 
                exit = 3;
                break;
            
          }
        }
      }
      switch (exit) {
        case 1 : 
            _i = i + 1 | 0;
            continue ;
            case 2 : 
            f[/* signstyle */1] = String.fromCharCode(c);
            _i = i + 1 | 0;
            continue ;
            case 3 : 
            f[/* width */6] = 0;
            var j$1 = i;
            while((function(j$1){
                return function () {
                  var w = fmt.charCodeAt(j$1) - /* "0" */48 | 0;
                  return +(w >= 0 && w <= 9);
                }
                }(j$1))()) {
              f[/* width */6] = (Caml_int32.imul(f[/* width */6], 10) + fmt.charCodeAt(j$1) | 0) - /* "0" */48 | 0;
              j$1 = j$1 + 1 | 0;
            };
            _i = j$1;
            continue ;
            case 4 : 
            f[/* signedconv */5] = /* true */1;
            f[/* base */4] = /* Dec */2;
            _i = i + 1 | 0;
            continue ;
            case 5 : 
            f[/* signedconv */5] = /* true */1;
            f[/* conv */10] = String.fromCharCode(c);
            _i = i + 1 | 0;
            continue ;
            
      }
    }
  };
}

function finish_formatting(param, rawbuffer) {
  var justify = param[/* justify */0];
  var signstyle = param[/* signstyle */1];
  var filter = param[/* filter */2];
  var alternate = param[/* alternate */3];
  var base = param[/* base */4];
  var signedconv = param[/* signedconv */5];
  var width = param[/* width */6];
  var uppercase = param[/* uppercase */7];
  var sign = param[/* sign */8];
  var len = rawbuffer.length;
  if (signedconv && (sign < 0 || signstyle !== "-")) {
    len = len + 1 | 0;
  }
  if (alternate) {
    if (base === /* Oct */0) {
      len = len + 1 | 0;
    } else if (base === /* Hex */1) {
      len = len + 2 | 0;
    }
    
  }
  var buffer = "";
  if (justify === "+" && filter === " ") {
    for(var i = len ,i_finish = width - 1 | 0; i <= i_finish; ++i){
      buffer = buffer + filter;
    }
  }
  if (signedconv) {
    if (sign < 0) {
      buffer = buffer + "-";
    } else if (signstyle !== "-") {
      buffer = buffer + signstyle;
    }
    
  }
  if (alternate && base === /* Oct */0) {
    buffer = buffer + "0";
  }
  if (alternate && base === /* Hex */1) {
    buffer = buffer + "0x";
  }
  if (justify === "+" && filter === "0") {
    for(var i$1 = len ,i_finish$1 = width - 1 | 0; i$1 <= i_finish$1; ++i$1){
      buffer = buffer + filter;
    }
  }
  buffer = uppercase ? buffer + rawbuffer.toUpperCase() : buffer + rawbuffer;
  if (justify === "-") {
    for(var i$2 = len ,i_finish$2 = width - 1 | 0; i$2 <= i_finish$2; ++i$2){
      buffer = buffer + " ";
    }
  }
  return buffer;
}

function caml_format_int(fmt, i) {
  if (fmt === "%d") {
    return String(i);
  } else {
    var f = parse_format(fmt);
    var f$1 = f;
    var i$1 = i;
    var i$2 = i$1 < 0 ? (
        f$1[/* signedconv */5] ? (f$1[/* sign */8] = -1, -i$1) : (i$1 >>> 0)
      ) : i$1;
    var s = i$2.toString(int_of_base(f$1[/* base */4]));
    if (f$1[/* prec */9] >= 0) {
      f$1[/* filter */2] = " ";
      var n = f$1[/* prec */9] - s.length | 0;
      if (n > 0) {
        s = Caml_utils.repeat(n, "0") + s;
      }
      
    }
    return finish_formatting(f$1, s);
  }
}

function caml_int64_format(fmt, x) {
  var f = parse_format(fmt);
  var x$1 = f[/* signedconv */5] && Caml_int64.lt(x, /* int64 */[
        /* hi */0,
        /* lo */0
      ]) ? (f[/* sign */8] = -1, Caml_int64.neg(x)) : x;
  var s = "";
  var match = f[/* base */4];
  switch (match) {
    case 0 : 
        var wbase = /* int64 */[
          /* hi */0,
          /* lo */8
        ];
        var cvtbl = "01234567";
        if (Caml_int64.lt(x$1, /* int64 */[
                /* hi */0,
                /* lo */0
              ])) {
          var y = Caml_int64.discard_sign(x$1);
          var match$1 = Caml_int64.div_mod(y, wbase);
          var quotient = Caml_int64.add(/* int64 */[
                /* hi */268435456,
                /* lo */0
              ], match$1[0]);
          var modulus = match$1[1];
          s = String.fromCharCode(cvtbl.charCodeAt(modulus[1] | 0)) + s;
          while(Caml_int64.neq(quotient, /* int64 */[
                  /* hi */0,
                  /* lo */0
                ])) {
            var match$2 = Caml_int64.div_mod(quotient, wbase);
            quotient = match$2[0];
            modulus = match$2[1];
            s = String.fromCharCode(cvtbl.charCodeAt(modulus[1] | 0)) + s;
          };
        } else {
          var match$3 = Caml_int64.div_mod(x$1, wbase);
          var quotient$1 = match$3[0];
          var modulus$1 = match$3[1];
          s = String.fromCharCode(cvtbl.charCodeAt(modulus$1[1] | 0)) + s;
          while(Caml_int64.neq(quotient$1, /* int64 */[
                  /* hi */0,
                  /* lo */0
                ])) {
            var match$4 = Caml_int64.div_mod(quotient$1, wbase);
            quotient$1 = match$4[0];
            modulus$1 = match$4[1];
            s = String.fromCharCode(cvtbl.charCodeAt(modulus$1[1] | 0)) + s;
          };
        }
        break;
    case 1 : 
        s = Caml_int64.to_hex(x$1) + s;
        break;
    case 2 : 
        var wbase$1 = /* int64 */[
          /* hi */0,
          /* lo */10
        ];
        var cvtbl$1 = "0123456789";
        if (Caml_int64.lt(x$1, /* int64 */[
                /* hi */0,
                /* lo */0
              ])) {
          var y$1 = Caml_int64.discard_sign(x$1);
          var match$5 = Caml_int64.div_mod(y$1, wbase$1);
          var match$6 = Caml_int64.div_mod(Caml_int64.add(/* int64 */[
                    /* hi */0,
                    /* lo */8
                  ], match$5[1]), wbase$1);
          var quotient$2 = Caml_int64.add(Caml_int64.add(/* int64 */[
                    /* hi */214748364,
                    /* lo */3435973836
                  ], match$5[0]), match$6[0]);
          var modulus$2 = match$6[1];
          s = String.fromCharCode(cvtbl$1.charCodeAt(modulus$2[1] | 0)) + s;
          while(Caml_int64.neq(quotient$2, /* int64 */[
                  /* hi */0,
                  /* lo */0
                ])) {
            var match$7 = Caml_int64.div_mod(quotient$2, wbase$1);
            quotient$2 = match$7[0];
            modulus$2 = match$7[1];
            s = String.fromCharCode(cvtbl$1.charCodeAt(modulus$2[1] | 0)) + s;
          };
        } else {
          var match$8 = Caml_int64.div_mod(x$1, wbase$1);
          var quotient$3 = match$8[0];
          var modulus$3 = match$8[1];
          s = String.fromCharCode(cvtbl$1.charCodeAt(modulus$3[1] | 0)) + s;
          while(Caml_int64.neq(quotient$3, /* int64 */[
                  /* hi */0,
                  /* lo */0
                ])) {
            var match$9 = Caml_int64.div_mod(quotient$3, wbase$1);
            quotient$3 = match$9[0];
            modulus$3 = match$9[1];
            s = String.fromCharCode(cvtbl$1.charCodeAt(modulus$3[1] | 0)) + s;
          };
        }
        break;
    
  }
  if (f[/* prec */9] >= 0) {
    f[/* filter */2] = " ";
    var n = f[/* prec */9] - s.length | 0;
    if (n > 0) {
      s = Caml_utils.repeat(n, "0") + s;
    }
    
  }
  return finish_formatting(f, s);
}

function caml_format_float(fmt, x) {
  var f = parse_format(fmt);
  var prec = f[/* prec */9] < 0 ? 6 : f[/* prec */9];
  var x$1 = x < 0 ? (f[/* sign */8] = -1, -x) : x;
  var s = "";
  if (isNaN(x$1)) {
    s = "nan";
    f[/* filter */2] = " ";
  } else if (isFinite(x$1)) {
    var match = f[/* conv */10];
    switch (match) {
      case "e" : 
          s = x$1.toExponential(prec);
          var i = s.length;
          if (s[i - 3 | 0] === "e") {
            s = s.slice(0, i - 1 | 0) + ("0" + s.slice(i - 1 | 0));
          }
          break;
      case "f" : 
          s = x$1.toFixed(prec);
          break;
      case "g" : 
          var prec$1 = prec !== 0 ? prec : 1;
          s = x$1.toExponential(prec$1 - 1 | 0);
          var j = s.indexOf("e");
          var exp = Number(s.slice(j + 1 | 0)) | 0;
          if (exp < -4 || x$1 >= 1e21 || x$1.toFixed().length > prec$1) {
            var i$1 = j - 1 | 0;
            while(s[i$1] === "0") {
              i$1 = i$1 - 1 | 0;
            };
            if (s[i$1] === ".") {
              i$1 = i$1 - 1 | 0;
            }
            s = s.slice(0, i$1 + 1 | 0) + s.slice(j);
            var i$2 = s.length;
            if (s[i$2 - 3 | 0] === "e") {
              s = s.slice(0, i$2 - 1 | 0) + ("0" + s.slice(i$2 - 1 | 0));
            }
            
          } else {
            var p = prec$1;
            if (exp < 0) {
              p = p - (exp + 1 | 0) | 0;
              s = x$1.toFixed(p);
            } else {
              while((function () {
                      s = x$1.toFixed(p);
                      return +(s.length > (prec$1 + 1 | 0));
                    })()) {
                p = p - 1 | 0;
              };
            }
            if (p !== 0) {
              var k = s.length - 1 | 0;
              while(s[k] === "0") {
                k = k - 1 | 0;
              };
              if (s[k] === ".") {
                k = k - 1 | 0;
              }
              s = s.slice(0, k + 1 | 0);
            }
            
          }
          break;
      default:
        
    }
  } else {
    s = "inf";
    f[/* filter */2] = " ";
  }
  return finish_formatting(f, s);
}

var float_of_string = (
  function (s, caml_failwith) {
    var res = +s;
    if ((s.length > 0) && (res === res))
        return res;
    s = s.replace(/_/g, "");
    res = +s;
    if (((s.length > 0) && (res === res)) || /^[+-]?nan$/i.test(s)) {
        return res;
    }
    ;
    if (/^ *0x[0-9a-f_]+p[+-]?[0-9_]+/i.test(s)) {
        var pidx = s.indexOf('p');
        pidx = (pidx == -1) ? s.indexOf('P') : pidx;
        var exp = +s.substring(pidx + 1);
        res = +s.substring(0, pidx);
        return res * Math.pow(2, exp);
    }
    if (/^\+?inf(inity)?$/i.test(s))
        return Infinity;
    if (/^-inf(inity)?$/i.test(s))
        return -Infinity;
    caml_failwith("float_of_string");
}

);

function caml_float_of_string(s) {
  return Curry._2(float_of_string, s, caml_failwith);
}

var caml_nativeint_format = caml_format_int;

var caml_int32_format = caml_format_int;

var caml_int32_of_string = caml_int_of_string;

var caml_nativeint_of_string = caml_int_of_string;

exports.caml_format_float = caml_format_float;
exports.caml_format_int = caml_format_int;
exports.caml_nativeint_format = caml_nativeint_format;
exports.caml_int32_format = caml_int32_format;
exports.caml_float_of_string = caml_float_of_string;
exports.caml_int64_format = caml_int64_format;
exports.caml_int_of_string = caml_int_of_string;
exports.caml_int32_of_string = caml_int32_of_string;
exports.caml_int64_of_string = caml_int64_of_string;
exports.caml_nativeint_of_string = caml_nativeint_of_string;
/* float_of_string Not a pure module */


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Caml_builtin_exceptions = __webpack_require__(3);

function caml_array_sub(x, offset, len) {
  var result = new Array(len);
  var j = 0;
  var i = offset;
  while(j < len) {
    result[j] = x[i];
    j = j + 1 | 0;
    i = i + 1 | 0;
  };
  return result;
}

function len(_acc, _l) {
  while(true) {
    var l = _l;
    var acc = _acc;
    if (l) {
      _l = l[1];
      _acc = l[0].length + acc | 0;
      continue ;
      
    } else {
      return acc;
    }
  };
}

function fill(arr, _i, _l) {
  while(true) {
    var l = _l;
    var i = _i;
    if (l) {
      var x = l[0];
      var l$1 = x.length;
      var k = i;
      var j = 0;
      while(j < l$1) {
        arr[k] = x[j];
        k = k + 1 | 0;
        j = j + 1 | 0;
      };
      _l = l[1];
      _i = k;
      continue ;
      
    } else {
      return /* () */0;
    }
  };
}

function caml_array_concat(l) {
  var v = len(0, l);
  var result = new Array(v);
  fill(result, 0, l);
  return result;
}

function caml_array_set(xs, index, newval) {
  if (index < 0 || index >= xs.length) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "index out of bounds"
        ];
  } else {
    xs[index] = newval;
    return /* () */0;
  }
}

function caml_array_get(xs, index) {
  if (index < 0 || index >= xs.length) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "index out of bounds"
        ];
  } else {
    return xs[index];
  }
}

function caml_make_vect(len, init) {
  var b = new Array(len);
  for(var i = 0 ,i_finish = len - 1 | 0; i <= i_finish; ++i){
    b[i] = init;
  }
  return b;
}

function caml_make_float_vect(len) {
  var b = new Array(len);
  for(var i = 0 ,i_finish = len - 1 | 0; i <= i_finish; ++i){
    b[i] = 0;
  }
  return b;
}

function caml_array_blit(a1, i1, a2, i2, len) {
  if (i2 <= i1) {
    for(var j = 0 ,j_finish = len - 1 | 0; j <= j_finish; ++j){
      a2[j + i2 | 0] = a1[j + i1 | 0];
    }
    return /* () */0;
  } else {
    for(var j$1 = len - 1 | 0; j$1 >= 0; --j$1){
      a2[j$1 + i2 | 0] = a1[j$1 + i1 | 0];
    }
    return /* () */0;
  }
}

exports.caml_array_sub = caml_array_sub;
exports.caml_array_concat = caml_array_concat;
exports.caml_make_vect = caml_make_vect;
exports.caml_make_float_vect = caml_make_float_vect;
exports.caml_array_blit = caml_array_blit;
exports.caml_array_get = caml_array_get;
exports.caml_array_set = caml_array_set;
/* No side effect */


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Caml_exceptions = __webpack_require__(22);

var $$Error = Caml_exceptions.create("Js_exn.Error");

function internalToOCamlException(e) {
  if (Caml_exceptions.isCamlExceptionOrOpenVariant(e)) {
    return e;
  } else {
    return [
            $$Error,
            e
          ];
  }
}

function raiseError(str) {
  throw new Error(str);
}

function raiseEvalError(str) {
  throw new EvalError(str);
}

function raiseRangeError(str) {
  throw new RangeError(str);
}

function raiseReferenceError(str) {
  throw new ReferenceError(str);
}

function raiseSyntaxError(str) {
  throw new SyntaxError(str);
}

function raiseTypeError(str) {
  throw new TypeError(str);
}

function raiseUriError(str) {
  throw new URIError(str);
}

exports.$$Error = $$Error;
exports.internalToOCamlException = internalToOCamlException;
exports.raiseError = raiseError;
exports.raiseEvalError = raiseEvalError;
exports.raiseRangeError = raiseRangeError;
exports.raiseReferenceError = raiseReferenceError;
exports.raiseSyntaxError = raiseSyntaxError;
exports.raiseTypeError = raiseTypeError;
exports.raiseUriError = raiseUriError;
/* No side effect */


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Caml_builtin_exceptions = __webpack_require__(3);

function div(x, y) {
  if (y === 0) {
    throw Caml_builtin_exceptions.division_by_zero;
  } else {
    return x / y | 0;
  }
}

function mod_(x, y) {
  if (y === 0) {
    throw Caml_builtin_exceptions.division_by_zero;
  } else {
    return x % y;
  }
}

function caml_bswap16(x) {
  return ((x & 255) << 8) | ((x & 65280) >>> 8);
}

function caml_int32_bswap(x) {
  return ((x & 255) << 24) | ((x & 65280) << 8) | ((x & 16711680) >>> 8) | ((x & 4278190080) >>> 24);
}

var imul = ( Math.imul || function (x,y) {
  y |= 0; return ((((x >> 16) * y) << 16) + (x & 0xffff) * y)|0; 
}
);

var caml_nativeint_bswap = caml_int32_bswap;

exports.div = div;
exports.mod_ = mod_;
exports.caml_bswap16 = caml_bswap16;
exports.caml_int32_bswap = caml_int32_bswap;
exports.caml_nativeint_bswap = caml_nativeint_bswap;
exports.imul = imul;
/* imul Not a pure module */


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Curry = __webpack_require__(0);
var Js_exn = __webpack_require__(10);
var Caml_array = __webpack_require__(9);
var Caml_exceptions = __webpack_require__(22);
var Caml_builtin_exceptions = __webpack_require__(3);

function init(l, f) {
  if (l === 0) {
    return /* array */[];
  } else if (l < 0) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "Array.init"
        ];
  } else {
    var res = Caml_array.caml_make_vect(l, Curry._1(f, 0));
    for(var i = 1 ,i_finish = l - 1 | 0; i <= i_finish; ++i){
      res[i] = Curry._1(f, i);
    }
    return res;
  }
}

function make_matrix(sx, sy, init) {
  var res = Caml_array.caml_make_vect(sx, /* array */[]);
  for(var x = 0 ,x_finish = sx - 1 | 0; x <= x_finish; ++x){
    res[x] = Caml_array.caml_make_vect(sy, init);
  }
  return res;
}

function copy(a) {
  var l = a.length;
  if (l === 0) {
    return /* array */[];
  } else {
    return Caml_array.caml_array_sub(a, 0, l);
  }
}

function append(a1, a2) {
  var l1 = a1.length;
  if (l1 === 0) {
    return copy(a2);
  } else if (a2.length === 0) {
    return Caml_array.caml_array_sub(a1, 0, l1);
  } else {
    return a1.concat(a2);
  }
}

function sub(a, ofs, len) {
  if (len < 0 || ofs > (a.length - len | 0)) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "Array.sub"
        ];
  } else {
    return Caml_array.caml_array_sub(a, ofs, len);
  }
}

function fill(a, ofs, len, v) {
  if (ofs < 0 || len < 0 || ofs > (a.length - len | 0)) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "Array.fill"
        ];
  } else {
    for(var i = ofs ,i_finish = (ofs + len | 0) - 1 | 0; i <= i_finish; ++i){
      a[i] = v;
    }
    return /* () */0;
  }
}

function blit(a1, ofs1, a2, ofs2, len) {
  if (len < 0 || ofs1 < 0 || ofs1 > (a1.length - len | 0) || ofs2 < 0 || ofs2 > (a2.length - len | 0)) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "Array.blit"
        ];
  } else {
    return Caml_array.caml_array_blit(a1, ofs1, a2, ofs2, len);
  }
}

function iter(f, a) {
  for(var i = 0 ,i_finish = a.length - 1 | 0; i <= i_finish; ++i){
    Curry._1(f, a[i]);
  }
  return /* () */0;
}

function map(f, a) {
  var l = a.length;
  if (l === 0) {
    return /* array */[];
  } else {
    var r = Caml_array.caml_make_vect(l, Curry._1(f, a[0]));
    for(var i = 1 ,i_finish = l - 1 | 0; i <= i_finish; ++i){
      r[i] = Curry._1(f, a[i]);
    }
    return r;
  }
}

function iteri(f, a) {
  for(var i = 0 ,i_finish = a.length - 1 | 0; i <= i_finish; ++i){
    Curry._2(f, i, a[i]);
  }
  return /* () */0;
}

function mapi(f, a) {
  var l = a.length;
  if (l === 0) {
    return /* array */[];
  } else {
    var r = Caml_array.caml_make_vect(l, Curry._2(f, 0, a[0]));
    for(var i = 1 ,i_finish = l - 1 | 0; i <= i_finish; ++i){
      r[i] = Curry._2(f, i, a[i]);
    }
    return r;
  }
}

function to_list(a) {
  var _i = a.length - 1 | 0;
  var _res = /* [] */0;
  while(true) {
    var res = _res;
    var i = _i;
    if (i < 0) {
      return res;
    } else {
      _res = /* :: */[
        a[i],
        res
      ];
      _i = i - 1 | 0;
      continue ;
      
    }
  };
}

function list_length(_accu, _param) {
  while(true) {
    var param = _param;
    var accu = _accu;
    if (param) {
      _param = param[1];
      _accu = accu + 1 | 0;
      continue ;
      
    } else {
      return accu;
    }
  };
}

function of_list(l) {
  if (l) {
    var a = Caml_array.caml_make_vect(list_length(0, l), l[0]);
    var _i = 1;
    var _param = l[1];
    while(true) {
      var param = _param;
      var i = _i;
      if (param) {
        a[i] = param[0];
        _param = param[1];
        _i = i + 1 | 0;
        continue ;
        
      } else {
        return a;
      }
    };
  } else {
    return /* array */[];
  }
}

function fold_left(f, x, a) {
  var r = x;
  for(var i = 0 ,i_finish = a.length - 1 | 0; i <= i_finish; ++i){
    r = Curry._2(f, r, a[i]);
  }
  return r;
}

function fold_right(f, a, x) {
  var r = x;
  for(var i = a.length - 1 | 0; i >= 0; --i){
    r = Curry._2(f, a[i], r);
  }
  return r;
}

var Bottom = Caml_exceptions.create("Array.Bottom");

function sort(cmp, a) {
  var maxson = function (l, i) {
    var i31 = ((i + i | 0) + i | 0) + 1 | 0;
    var x = i31;
    if ((i31 + 2 | 0) < l) {
      if (Curry._2(cmp, Caml_array.caml_array_get(a, i31), Caml_array.caml_array_get(a, i31 + 1 | 0)) < 0) {
        x = i31 + 1 | 0;
      }
      if (Curry._2(cmp, Caml_array.caml_array_get(a, x), Caml_array.caml_array_get(a, i31 + 2 | 0)) < 0) {
        x = i31 + 2 | 0;
      }
      return x;
    } else if ((i31 + 1 | 0) < l && Curry._2(cmp, Caml_array.caml_array_get(a, i31), Caml_array.caml_array_get(a, i31 + 1 | 0)) < 0) {
      return i31 + 1 | 0;
    } else if (i31 < l) {
      return i31;
    } else {
      throw [
            Bottom,
            i
          ];
    }
  };
  var trickle = function (l, i, e) {
    try {
      var l$1 = l;
      var _i = i;
      var e$1 = e;
      while(true) {
        var i$1 = _i;
        var j = maxson(l$1, i$1);
        if (Curry._2(cmp, Caml_array.caml_array_get(a, j), e$1) > 0) {
          Caml_array.caml_array_set(a, i$1, Caml_array.caml_array_get(a, j));
          _i = j;
          continue ;
          
        } else {
          return Caml_array.caml_array_set(a, i$1, e$1);
        }
      };
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Bottom) {
        return Caml_array.caml_array_set(a, exn[1], e);
      } else {
        throw exn;
      }
    }
  };
  var bubble = function (l, i) {
    try {
      var l$1 = l;
      var _i = i;
      while(true) {
        var i$1 = _i;
        var j = maxson(l$1, i$1);
        Caml_array.caml_array_set(a, i$1, Caml_array.caml_array_get(a, j));
        _i = j;
        continue ;
        
      };
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Bottom) {
        return exn[1];
      } else {
        throw exn;
      }
    }
  };
  var trickleup = function (_i, e) {
    while(true) {
      var i = _i;
      var father = (i - 1 | 0) / 3 | 0;
      if (i === father) {
        throw [
              Caml_builtin_exceptions.assert_failure,
              [
                "array.ml",
                168,
                4
              ]
            ];
      }
      if (Curry._2(cmp, Caml_array.caml_array_get(a, father), e) < 0) {
        Caml_array.caml_array_set(a, i, Caml_array.caml_array_get(a, father));
        if (father > 0) {
          _i = father;
          continue ;
          
        } else {
          return Caml_array.caml_array_set(a, 0, e);
        }
      } else {
        return Caml_array.caml_array_set(a, i, e);
      }
    };
  };
  var l = a.length;
  for(var i = ((l + 1 | 0) / 3 | 0) - 1 | 0; i >= 0; --i){
    trickle(l, i, Caml_array.caml_array_get(a, i));
  }
  for(var i$1 = l - 1 | 0; i$1 >= 2; --i$1){
    var e = Caml_array.caml_array_get(a, i$1);
    Caml_array.caml_array_set(a, i$1, Caml_array.caml_array_get(a, 0));
    trickleup(bubble(i$1, 0), e);
  }
  if (l > 1) {
    var e$1 = Caml_array.caml_array_get(a, 1);
    Caml_array.caml_array_set(a, 1, Caml_array.caml_array_get(a, 0));
    return Caml_array.caml_array_set(a, 0, e$1);
  } else {
    return 0;
  }
}

function stable_sort(cmp, a) {
  var merge = function (src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs) {
    var src1r = src1ofs + src1len | 0;
    var src2r = src2ofs + src2len | 0;
    var _i1 = src1ofs;
    var _s1 = Caml_array.caml_array_get(a, src1ofs);
    var _i2 = src2ofs;
    var _s2 = Caml_array.caml_array_get(src2, src2ofs);
    var _d = dstofs;
    while(true) {
      var d = _d;
      var s2 = _s2;
      var i2 = _i2;
      var s1 = _s1;
      var i1 = _i1;
      if (Curry._2(cmp, s1, s2) <= 0) {
        Caml_array.caml_array_set(dst, d, s1);
        var i1$1 = i1 + 1 | 0;
        if (i1$1 < src1r) {
          _d = d + 1 | 0;
          _s1 = Caml_array.caml_array_get(a, i1$1);
          _i1 = i1$1;
          continue ;
          
        } else {
          return blit(src2, i2, dst, d + 1 | 0, src2r - i2 | 0);
        }
      } else {
        Caml_array.caml_array_set(dst, d, s2);
        var i2$1 = i2 + 1 | 0;
        if (i2$1 < src2r) {
          _d = d + 1 | 0;
          _s2 = Caml_array.caml_array_get(src2, i2$1);
          _i2 = i2$1;
          continue ;
          
        } else {
          return blit(a, i1, dst, d + 1 | 0, src1r - i1 | 0);
        }
      }
    };
  };
  var isortto = function (srcofs, dst, dstofs, len) {
    for(var i = 0 ,i_finish = len - 1 | 0; i <= i_finish; ++i){
      var e = Caml_array.caml_array_get(a, srcofs + i | 0);
      var j = (dstofs + i | 0) - 1 | 0;
      while(j >= dstofs && Curry._2(cmp, Caml_array.caml_array_get(dst, j), e) > 0) {
        Caml_array.caml_array_set(dst, j + 1 | 0, Caml_array.caml_array_get(dst, j));
        j = j - 1 | 0;
      };
      Caml_array.caml_array_set(dst, j + 1 | 0, e);
    }
    return /* () */0;
  };
  var sortto = function (srcofs, dst, dstofs, len) {
    if (len <= 5) {
      return isortto(srcofs, dst, dstofs, len);
    } else {
      var l1 = len / 2 | 0;
      var l2 = len - l1 | 0;
      sortto(srcofs + l1 | 0, dst, dstofs + l1 | 0, l2);
      sortto(srcofs, a, srcofs + l2 | 0, l1);
      return merge(srcofs + l2 | 0, l1, dst, dstofs + l1 | 0, l2, dst, dstofs);
    }
  };
  var l = a.length;
  if (l <= 5) {
    return isortto(0, a, 0, l);
  } else {
    var l1 = l / 2 | 0;
    var l2 = l - l1 | 0;
    var t = Caml_array.caml_make_vect(l2, Caml_array.caml_array_get(a, 0));
    sortto(l1, t, 0, l2);
    sortto(0, a, l2, l1);
    return merge(l2, l1, t, 0, l2, a, 0);
  }
}

var create_matrix = make_matrix;

var concat = Caml_array.caml_array_concat;

var fast_sort = stable_sort;

exports.init = init;
exports.make_matrix = make_matrix;
exports.create_matrix = create_matrix;
exports.append = append;
exports.concat = concat;
exports.sub = sub;
exports.copy = copy;
exports.fill = fill;
exports.blit = blit;
exports.to_list = to_list;
exports.of_list = of_list;
exports.iter = iter;
exports.map = map;
exports.iteri = iteri;
exports.mapi = mapi;
exports.fold_left = fold_left;
exports.fold_right = fold_right;
exports.sort = sort;
exports.stable_sort = stable_sort;
exports.fast_sort = fast_sort;
/* No side effect */


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var React = __webpack_require__(1);
var ReasonReact = __webpack_require__(2);

var component = ReasonReact.statelessComponent("Link");

function make(href, label, className, _) {
  var handleClick = function () {
    return ReasonReact.Router[/* push */0](href);
  };
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("a", {
                  className: className,
                  onClick: handleClick
                }, label);
    });
  return newrecord;
}

exports.component = component;
exports.make = make;
/* component Not a pure module */


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Json = __webpack_require__(42);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Js_exn = __webpack_require__(10);
var Printf = __webpack_require__(44);
var Network = __webpack_require__(7);
var Pervasives = __webpack_require__(21);
var Caml_format = __webpack_require__(8);
var Json_decode = __webpack_require__(48);
var Json_encode = __webpack_require__(23);
var Js_primitive = __webpack_require__(49);
var Caml_builtin_exceptions = __webpack_require__(3);

function jsonParse(vals) {
  try {
    return JSON.parse(vals);
  }
  catch (exn){
    return Pervasives.failwith("Error parsing JSON string");
  }
}

function decodedTokenData(json) {
  var a = Json_decode.field("expires_in", Json_decode.$$int, json);
  var b = Json_decode.field("access_token", Json_decode.string, json);
  var c = Json_decode.field("refresh_token", Json_decode.string, json);
  return /* record */[
          /* expiry */a,
          /* accessToken */b,
          /* refreshToken */c
        ];
}

function setAccessTokenandExpiry(tokenData) {
  localStorage.setItem("access_token", tokenData[/* accessToken */1]);
  localStorage.setItem("refresh_token", tokenData[/* refreshToken */2]);
  localStorage.setItem("token_timestamp", Curry._1(Printf.sprintf(/* Format */[
                /* Float */Block.__(8, [
                    /* Float_f */0,
                    /* No_padding */0,
                    /* Lit_precision */[1],
                    /* End_of_format */0
                  ]),
                "%.1f"
              ]), Date.now()));
  localStorage.setItem("token_expires_at", Curry._1(Printf.sprintf(/* Format */[
                /* Float */Block.__(8, [
                    /* Float_f */0,
                    /* No_padding */0,
                    /* Lit_precision */[1],
                    /* End_of_format */0
                  ]),
                "%.1f"
              ]), Date.now() + 1000.0 * 60.0 * 60.0 * 24.0 * 365.0));
  return tokenData;
}

function checkDate(jsonVal) {
  var expDate;
  var exit = 0;
  var floatNum;
  try {
    floatNum = Json_decode.$$float(jsonVal);
    exit = 1;
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      console.log("expiry parsing issue: ", exn[1]);
      expDate = /* None */0;
    } else {
      throw exn;
    }
  }
  if (exit === 1) {
    expDate = /* Some */[floatNum];
  }
  var actualDate = Date.now();
  if (expDate) {
    var match = +(expDate[0] - actualDate > 0.0);
    if (match !== 0) {
      return /* true */1;
    } else {
      return /* false */0;
    }
  } else {
    return /* false */0;
  }
}

function localStorageSupported() {
  var exit = 0;
  var val;
  try {
    val = Js_primitive.null_to_opt(localStorage.getItem("someentry"));
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    console.log("localStorage issue in support testing", x);
    return /* false */0;
  }
  if (exit === 1) {
    if (val) {
      try {
        return /* true */1;
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === Caml_builtin_exceptions.failure) {
          console.log("ls testing exception: ", exn[1]);
          return /* true */1;
        } else {
          throw exn;
        }
      }
    } else {
      return /* true */1;
    }
  }
  
}

function checkIfLoggedIn() {
  var exit = 0;
  var val;
  try {
    val = Js_primitive.null_to_opt(localStorage.getItem("token_expires_at"));
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    console.log("localStorage issue", x);
    return /* false */0;
  }
  if (exit === 1) {
    if (val) {
      var exit$1 = 0;
      var val$1;
      try {
        val$1 = /* Some */[jsonParse(val[0])];
        exit$1 = 2;
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === Caml_builtin_exceptions.failure) {
          console.log("logged in checking exception: ", exn[1]);
          return /* false */0;
        } else {
          throw exn;
        }
      }
      if (exit$1 === 2) {
        if (val$1) {
          return checkDate(val$1[0]);
        } else {
          return /* false */0;
        }
      }
      
    } else {
      return /* false */0;
    }
  }
  
}

function storeLoc(a, b, c, d, e) {
  console.log("store workout route", /* tuple */[
        a,
        b,
        c,
        d,
        e
      ]);
  var locRes = Json.stringify(/* array */[
        a,
        b,
        c,
        d,
        e
      ]);
  localStorage.setItem("loc", locRes);
  return /* () */0;
}

function clearLoc() {
  localStorage.removeItem("loc");
  return /* () */0;
}

function checkLoc(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array(Json_decode.string, jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("loc parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("loc parsing issue exception x", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readLocFromLs() {
  var exit = 0;
  var val;
  try {
    val = Js_primitive.null_to_opt(localStorage.getItem("loc"));
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    console.log("localStorage issue", x);
    return /* None */0;
  }
  if (exit === 1) {
    if (val) {
      var exit$1 = 0;
      var val$1;
      try {
        val$1 = /* Some */[jsonParse(val[0])];
        exit$1 = 2;
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === Caml_builtin_exceptions.failure) {
          console.log("loc checking exception: ", exn[1]);
          return /* None */0;
        } else {
          throw exn;
        }
      }
      if (exit$1 === 2) {
        if (val$1) {
          return checkLoc(val$1[0]);
        } else {
          return /* None */0;
        }
      }
      
    } else {
      return /* None */0;
    }
  }
  
}

function checkForLastRouteFromLs() {
  var match = readLocFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return /* array */[""];
  }
}

function calculateProgramDay() {
  var start_date_timestamp;
  var exit = 0;
  var val;
  try {
    val = Js_primitive.null_to_opt(localStorage.getItem("start_date_timestamp"));
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    console.log("localStorage issue", x);
    start_date_timestamp = 0.0;
  }
  if (exit === 1) {
    if (val) {
      try {
        start_date_timestamp = Caml_format.caml_float_of_string(val[0]);
      }
      catch (exn){
        console.log("issue with startDate conversion to float");
        start_date_timestamp = 1.0;
      }
    } else {
      start_date_timestamp = 0.0;
    }
  }
  if (start_date_timestamp > 2.0) {
    var tStart = new Date(start_date_timestamp);
    var dateHours = tStart.getHours();
    var dateMinutes = tStart.getMinutes();
    var diffH = 1000.0 * 60.0 * 60.0 * dateHours;
    var diffM = 1000.0 * 60.0 * dateMinutes;
    var adjustedStartDate = start_date_timestamp - diffH - diffM;
    var now = Date.now();
    var diff = now - adjustedStartDate;
    return diff / 1000.0 / 60.0 / 60.0 / 24.0 | 0;
  } else {
    return -1;
  }
}

function weekOfDay() {
  return (calculateProgramDay(/* () */0) / 7 | 0) + 1 | 0;
}

function weekDay() {
  return calculateProgramDay(/* () */0) % 7 + 1 | 0;
}

function fullDay() {
  return calculateProgramDay(/* () */0) + 1 | 0;
}

function fullDayMax28() {
  var res = calculateProgramDay(/* () */0) + 1 | 0;
  if (res > 28) {
    return 28;
  } else {
    return res;
  }
}

function getWeight() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("getWeight exception", exn[1]);
        return 0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        return Network.readWizardResultFromLs(x[0])[/* weight */0];
      } else {
        return 0;
      }
    }
    
  } else {
    return 0;
  }
}

function getDuration() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("getDuration exception", exn[1]);
        return 0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        return Network.readWizardResultFromLs(x[0])[/* duration */2];
      } else {
        return 0;
      }
    }
    
  } else {
    return 0;
  }
}

function getCals() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("getDuration exception", exn[1]);
        return 0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        var match$1 = Network.readWizardResultFromLs(x[0])[/* cals */1];
        if (match$1 !== 1100) {
          if (match$1 !== 1300) {
            if (match$1 !== 1500) {
              return 0;
            } else {
              return 1500;
            }
          } else {
            return 1300;
          }
        } else {
          return 1100;
        }
      } else {
        return 0;
      }
    }
    
  } else {
    return 0;
  }
}

function getCalsLevel() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("getDuration exception", exn[1]);
        return 0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        var match$1 = Network.readWizardResultFromLs(x[0])[/* cals */1];
        if (match$1 !== 1100) {
          if (match$1 !== 1300 && match$1 === 1500) {
            return 1;
          } else {
            return 0;
          }
        } else {
          return 2;
        }
      } else {
        return 0;
      }
    }
    
  } else {
    return 0;
  }
}

function store14() {
  console.log("set read14 to true", /* () */0);
  var doneRes = Json.stringify(Json_encode.bool(/* true */1));
  localStorage.setItem("read14", doneRes);
  return /* () */0;
}

function clear14() {
  localStorage.removeItem("read14");
  return /* () */0;
}

function check14(jsonVal) {
  var checkBool;
  try {
    checkBool = Json_decode.bool(jsonVal);
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("14 parsing issue: ", x[1]);
      checkBool = /* false */0;
    } else {
      console.log("14 parsing issue exception x", x);
      checkBool = /* false */0;
    }
  }
  console.log("checkbool", checkBool);
  return checkBool;
}

function show14() {
  var nextStepNeeded = +((calculateProgramDay(/* () */0) + 1 | 0) === 14 || (calculateProgramDay(/* () */0) + 1 | 0) === 15 || (calculateProgramDay(/* () */0) + 1 | 0) === 16);
  var calsCorrect = +(getCals(/* () */0) === 1300);
  var match = localStorage.getItem("read14");
  var lsVal;
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("14 checking exception: ", exn[1]);
        lsVal = /* false */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      lsVal = val ? check14(val[0]) : /* false */0;
    }
    
  } else {
    lsVal = /* false */0;
  }
  var match$1 = nextStepNeeded && 1 - lsVal && calsCorrect;
  if (match$1 !== 0) {
    return /* true */1;
  } else {
    return /* false */0;
  }
}

function store24() {
  console.log("set read24 to true", /* () */0);
  var doneRes = Json.stringify(Json_encode.bool(/* true */1));
  localStorage.setItem("read24", doneRes);
  return /* () */0;
}

function clear24() {
  localStorage.removeItem("read24");
  return /* () */0;
}

function check24(jsonVal) {
  var checkBool;
  try {
    checkBool = Json_decode.bool(jsonVal);
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("24 parsing issue: ", x[1]);
      checkBool = /* false */0;
    } else {
      console.log("24 parsing issue exception x", x);
      checkBool = /* false */0;
    }
  }
  console.log("checkbool", checkBool);
  return checkBool;
}

function show24() {
  var nextStepNeeded = +((calculateProgramDay(/* () */0) + 1 | 0) === 24 || (calculateProgramDay(/* () */0) + 1 | 0) === 25 || (calculateProgramDay(/* () */0) + 1 | 0) === 26);
  var calsCorrect = +(getCals(/* () */0) === 1500);
  var match = localStorage.getItem("read24");
  var lsVal;
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("24 checking exception: ", exn[1]);
        lsVal = /* false */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      lsVal = val ? check24(val[0]) : /* false */0;
    }
    
  } else {
    lsVal = /* false */0;
  }
  var match$1 = nextStepNeeded && 1 - lsVal && calsCorrect;
  if (match$1 !== 0) {
    return /* true */1;
  } else {
    return /* false */0;
  }
}

function storeWeightDiff(number) {
  console.log("set weightDiff to number", number);
  var newWeight = Json.stringify(number);
  localStorage.setItem("weight_diff", newWeight);
  return /* () */0;
}

function clearNewWeight() {
  localStorage.removeItem("weight_diff");
  return /* () */0;
}

function checkNewWeight(jsonVal) {
  var checkInt;
  var exit = 0;
  var returnVal;
  try {
    returnVal = Json_decode.$$int(jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("int weight parsing issue: ", x[1]);
      checkInt = /* None */0;
    } else {
      console.log("int weight parsing issue exception x", x);
      checkInt = /* None */0;
    }
  }
  if (exit === 1) {
    checkInt = /* Some */[returnVal];
  }
  console.log("checkInt", checkInt);
  return checkInt;
}

function getWeightDiff() {
  var match = localStorage.getItem("weight_diff");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("weight_diff checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkNewWeight(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

exports.jsonParse = jsonParse;
exports.decodedTokenData = decodedTokenData;
exports.setAccessTokenandExpiry = setAccessTokenandExpiry;
exports.checkDate = checkDate;
exports.localStorageSupported = localStorageSupported;
exports.checkIfLoggedIn = checkIfLoggedIn;
exports.storeLoc = storeLoc;
exports.clearLoc = clearLoc;
exports.checkLoc = checkLoc;
exports.readLocFromLs = readLocFromLs;
exports.checkForLastRouteFromLs = checkForLastRouteFromLs;
exports.calculateProgramDay = calculateProgramDay;
exports.weekOfDay = weekOfDay;
exports.weekDay = weekDay;
exports.fullDay = fullDay;
exports.fullDayMax28 = fullDayMax28;
exports.getWeight = getWeight;
exports.getDuration = getDuration;
exports.getCals = getCals;
exports.getCalsLevel = getCalsLevel;
exports.store14 = store14;
exports.clear14 = clear14;
exports.check14 = check14;
exports.show14 = show14;
exports.store24 = store24;
exports.clear24 = clear24;
exports.check24 = check24;
exports.show24 = show24;
exports.storeWeightDiff = storeWeightDiff;
exports.clearNewWeight = clearNewWeight;
exports.checkNewWeight = checkNewWeight;
exports.getWeightDiff = getWeightDiff;
/* Network Not a pure module */


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Block = __webpack_require__(5);
var Caml_primitive = __webpack_require__(20);
var Caml_builtin_exceptions = __webpack_require__(3);

function caml_obj_block(tag, size) {
  var v = new Array(size);
  v.tag = tag;
  return v;
}

function caml_obj_dup(x) {
  var len = x.length | 0;
  var v = new Array(len);
  for(var i = 0 ,i_finish = len - 1 | 0; i <= i_finish; ++i){
    v[i] = x[i];
  }
  v.tag = x.tag | 0;
  return v;
}

function caml_obj_truncate(x, new_size) {
  var len = x.length | 0;
  if (new_size <= 0 || new_size > len) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "Obj.truncate"
        ];
  } else if (len !== new_size) {
    for(var i = new_size ,i_finish = len - 1 | 0; i <= i_finish; ++i){
      x[i] = 0;
    }
    x.length = new_size;
    return /* () */0;
  } else {
    return 0;
  }
}

function caml_lazy_make_forward(x) {
  return Block.__(250, [x]);
}

function caml_update_dummy(x, y) {
  var len = y.length | 0;
  for(var i = 0 ,i_finish = len - 1 | 0; i <= i_finish; ++i){
    x[i] = y[i];
  }
  var y_tag = y.tag | 0;
  if (y_tag !== 0) {
    x.tag = y_tag;
    return /* () */0;
  } else {
    return 0;
  }
}

function caml_compare(_a, _b) {
  while(true) {
    var b = _b;
    var a = _a;
    if (a === b) {
      return 0;
    } else {
      var a_type = typeof a;
      var b_type = typeof b;
      if (a_type === "string") {
        return Caml_primitive.caml_string_compare(a, b);
      } else {
        var is_a_number = +(a_type === "number");
        var is_b_number = +(b_type === "number");
        if (is_a_number !== 0) {
          if (is_b_number !== 0) {
            return Caml_primitive.caml_int_compare(a, b);
          } else {
            return -1;
          }
        } else if (is_b_number !== 0) {
          return 1;
        } else if (a_type === "boolean" || a_type === "undefined" || a === null) {
          var x = a;
          var y = b;
          if (x === y) {
            return 0;
          } else if (x < y) {
            return -1;
          } else {
            return 1;
          }
        } else if (a_type === "function" || b_type === "function") {
          throw [
                Caml_builtin_exceptions.invalid_argument,
                "compare: functional value"
              ];
        } else {
          var tag_a = a.tag | 0;
          var tag_b = b.tag | 0;
          if (tag_a === 250) {
            _a = a[0];
            continue ;
            
          } else if (tag_b === 250) {
            _b = b[0];
            continue ;
            
          } else if (tag_a === 248) {
            return Caml_primitive.caml_int_compare(a[1], b[1]);
          } else if (tag_a === 251) {
            throw [
                  Caml_builtin_exceptions.invalid_argument,
                  "equal: abstract value"
                ];
          } else if (tag_a !== tag_b) {
            if (tag_a < tag_b) {
              return -1;
            } else {
              return 1;
            }
          } else {
            var len_a = a.length | 0;
            var len_b = b.length | 0;
            if (len_a === len_b) {
              var a$1 = a;
              var b$1 = b;
              var _i = 0;
              var same_length = len_a;
              while(true) {
                var i = _i;
                if (i === same_length) {
                  return 0;
                } else {
                  var res = caml_compare(a$1[i], b$1[i]);
                  if (res !== 0) {
                    return res;
                  } else {
                    _i = i + 1 | 0;
                    continue ;
                    
                  }
                }
              };
            } else if (len_a < len_b) {
              var a$2 = a;
              var b$2 = b;
              var _i$1 = 0;
              var short_length = len_a;
              while(true) {
                var i$1 = _i$1;
                if (i$1 === short_length) {
                  return -1;
                } else {
                  var res$1 = caml_compare(a$2[i$1], b$2[i$1]);
                  if (res$1 !== 0) {
                    return res$1;
                  } else {
                    _i$1 = i$1 + 1 | 0;
                    continue ;
                    
                  }
                }
              };
            } else {
              var a$3 = a;
              var b$3 = b;
              var _i$2 = 0;
              var short_length$1 = len_b;
              while(true) {
                var i$2 = _i$2;
                if (i$2 === short_length$1) {
                  return 1;
                } else {
                  var res$2 = caml_compare(a$3[i$2], b$3[i$2]);
                  if (res$2 !== 0) {
                    return res$2;
                  } else {
                    _i$2 = i$2 + 1 | 0;
                    continue ;
                    
                  }
                }
              };
            }
          }
        }
      }
    }
  };
}

function caml_equal(_a, _b) {
  while(true) {
    var b = _b;
    var a = _a;
    if (a === b) {
      return /* true */1;
    } else {
      var a_type = typeof a;
      if (a_type === "string" || a_type === "number" || a_type === "boolean" || a_type === "undefined" || a === null) {
        return /* false */0;
      } else {
        var b_type = typeof b;
        if (a_type === "function" || b_type === "function") {
          throw [
                Caml_builtin_exceptions.invalid_argument,
                "equal: functional value"
              ];
        } else if (b_type === "number" || b_type === "undefined" || b === null) {
          return /* false */0;
        } else {
          var tag_a = a.tag | 0;
          var tag_b = b.tag | 0;
          if (tag_a === 250) {
            _a = a[0];
            continue ;
            
          } else if (tag_b === 250) {
            _b = b[0];
            continue ;
            
          } else if (tag_a === 248) {
            return +(a[1] === b[1]);
          } else if (tag_a === 251) {
            throw [
                  Caml_builtin_exceptions.invalid_argument,
                  "equal: abstract value"
                ];
          } else if (tag_a !== tag_b) {
            return /* false */0;
          } else {
            var len_a = a.length | 0;
            var len_b = b.length | 0;
            if (len_a === len_b) {
              var a$1 = a;
              var b$1 = b;
              var _i = 0;
              var same_length = len_a;
              while(true) {
                var i = _i;
                if (i === same_length) {
                  return /* true */1;
                } else if (caml_equal(a$1[i], b$1[i])) {
                  _i = i + 1 | 0;
                  continue ;
                  
                } else {
                  return /* false */0;
                }
              };
            } else {
              return /* false */0;
            }
          }
        }
      }
    }
  };
}

function caml_equal_null(x, y) {
  if (y !== null) {
    return caml_equal(x, y);
  } else {
    return +(x === y);
  }
}

function caml_equal_undefined(x, y) {
  if (y !== undefined) {
    return caml_equal(x, y);
  } else {
    return +(x === y);
  }
}

function caml_equal_nullable(x, y) {
  if (y == null) {
    return +(x === y);
  } else {
    return caml_equal(x, y);
  }
}

function caml_notequal(a, b) {
  return 1 - caml_equal(a, b);
}

function caml_greaterequal(a, b) {
  return +(caml_compare(a, b) >= 0);
}

function caml_greaterthan(a, b) {
  return +(caml_compare(a, b) > 0);
}

function caml_lessequal(a, b) {
  return +(caml_compare(a, b) <= 0);
}

function caml_lessthan(a, b) {
  return +(caml_compare(a, b) < 0);
}

function caml_min(x, y) {
  if (caml_compare(x, y) <= 0) {
    return x;
  } else {
    return y;
  }
}

function caml_max(x, y) {
  if (caml_compare(x, y) >= 0) {
    return x;
  } else {
    return y;
  }
}

exports.caml_obj_block = caml_obj_block;
exports.caml_obj_dup = caml_obj_dup;
exports.caml_obj_truncate = caml_obj_truncate;
exports.caml_lazy_make_forward = caml_lazy_make_forward;
exports.caml_update_dummy = caml_update_dummy;
exports.caml_compare = caml_compare;
exports.caml_equal = caml_equal;
exports.caml_equal_null = caml_equal_null;
exports.caml_equal_undefined = caml_equal_undefined;
exports.caml_equal_nullable = caml_equal_nullable;
exports.caml_notequal = caml_notequal;
exports.caml_greaterequal = caml_greaterequal;
exports.caml_greaterthan = caml_greaterthan;
exports.caml_lessthan = caml_lessthan;
exports.caml_lessequal = caml_lessequal;
exports.caml_min = caml_min;
exports.caml_max = caml_max;
/* No side effect */


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Caml_builtin_exceptions = __webpack_require__(3);

function string_of_char(prim) {
  return String.fromCharCode(prim);
}

function caml_string_get(s, i) {
  if (i >= s.length || i < 0) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "index out of bounds"
        ];
  } else {
    return s.charCodeAt(i);
  }
}

function caml_create_string(len) {
  if (len < 0) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "String.create"
        ];
  } else {
    var result = new Array(len);
    for(var i = 0 ,i_finish = len - 1 | 0; i <= i_finish; ++i){
      result[i] = /* "\000" */0;
    }
    return result;
  }
}

function caml_fill_string(s, i, l, c) {
  if (l > 0) {
    for(var k = i ,k_finish = (l + i | 0) - 1 | 0; k <= k_finish; ++k){
      s[k] = c;
    }
    return /* () */0;
  } else {
    return 0;
  }
}

function caml_blit_string(s1, i1, s2, i2, len) {
  if (len > 0) {
    var off1 = s1.length - i1 | 0;
    if (len <= off1) {
      for(var i = 0 ,i_finish = len - 1 | 0; i <= i_finish; ++i){
        s2[i2 + i | 0] = s1.charCodeAt(i1 + i | 0);
      }
      return /* () */0;
    } else {
      for(var i$1 = 0 ,i_finish$1 = off1 - 1 | 0; i$1 <= i_finish$1; ++i$1){
        s2[i2 + i$1 | 0] = s1.charCodeAt(i1 + i$1 | 0);
      }
      for(var i$2 = off1 ,i_finish$2 = len - 1 | 0; i$2 <= i_finish$2; ++i$2){
        s2[i2 + i$2 | 0] = /* "\000" */0;
      }
      return /* () */0;
    }
  } else {
    return 0;
  }
}

function caml_blit_bytes(s1, i1, s2, i2, len) {
  if (len > 0) {
    if (s1 === s2) {
      var s1$1 = s1;
      var i1$1 = i1;
      var i2$1 = i2;
      var len$1 = len;
      if (i1$1 < i2$1) {
        var range_a = (s1$1.length - i2$1 | 0) - 1 | 0;
        var range_b = len$1 - 1 | 0;
        var range = range_a > range_b ? range_b : range_a;
        for(var j = range; j >= 0; --j){
          s1$1[i2$1 + j | 0] = s1$1[i1$1 + j | 0];
        }
        return /* () */0;
      } else if (i1$1 > i2$1) {
        var range_a$1 = (s1$1.length - i1$1 | 0) - 1 | 0;
        var range_b$1 = len$1 - 1 | 0;
        var range$1 = range_a$1 > range_b$1 ? range_b$1 : range_a$1;
        for(var k = 0; k <= range$1; ++k){
          s1$1[i2$1 + k | 0] = s1$1[i1$1 + k | 0];
        }
        return /* () */0;
      } else {
        return 0;
      }
    } else {
      var off1 = s1.length - i1 | 0;
      if (len <= off1) {
        for(var i = 0 ,i_finish = len - 1 | 0; i <= i_finish; ++i){
          s2[i2 + i | 0] = s1[i1 + i | 0];
        }
        return /* () */0;
      } else {
        for(var i$1 = 0 ,i_finish$1 = off1 - 1 | 0; i$1 <= i_finish$1; ++i$1){
          s2[i2 + i$1 | 0] = s1[i1 + i$1 | 0];
        }
        for(var i$2 = off1 ,i_finish$2 = len - 1 | 0; i$2 <= i_finish$2; ++i$2){
          s2[i2 + i$2 | 0] = /* "\000" */0;
        }
        return /* () */0;
      }
    }
  } else {
    return 0;
  }
}

function bytes_of_string(s) {
  var len = s.length;
  var res = new Array(len);
  for(var i = 0 ,i_finish = len - 1 | 0; i <= i_finish; ++i){
    res[i] = s.charCodeAt(i);
  }
  return res;
}

function bytes_to_string(a) {
  var bytes = a;
  var i = 0;
  var len = a.length;
  var s = "";
  var s_len = len;
  if (i === 0 && len <= 4096 && len === bytes.length) {
    return String.fromCharCode.apply(null,bytes);
  } else {
    var offset = 0;
    while(s_len > 0) {
      var next = s_len < 1024 ? s_len : 1024;
      var tmp_bytes = new Array(next);
      caml_blit_bytes(bytes, offset, tmp_bytes, 0, next);
      s = s + String.fromCharCode.apply(null,tmp_bytes);
      s_len = s_len - next | 0;
      offset = offset + next | 0;
    };
    return s;
  }
}

function caml_string_of_char_array(chars) {
  var len = chars.length;
  var bytes = new Array(len);
  for(var i = 0 ,i_finish = len - 1 | 0; i <= i_finish; ++i){
    bytes[i] = chars[i];
  }
  return bytes_to_string(bytes);
}

function caml_is_printable(c) {
  if (c > 31) {
    return +(c < 127);
  } else {
    return /* false */0;
  }
}

function caml_string_get16(s, i) {
  return s.charCodeAt(i) + (s.charCodeAt(i + 1 | 0) << 8) | 0;
}

function caml_string_get32(s, i) {
  return ((s.charCodeAt(i) + (s.charCodeAt(i + 1 | 0) << 8) | 0) + (s.charCodeAt(i + 2 | 0) << 16) | 0) + (s.charCodeAt(i + 3 | 0) << 24) | 0;
}

function get(s, i) {
  if (i < 0 || i >= s.length) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "index out of bounds"
        ];
  } else {
    return s.charCodeAt(i);
  }
}

exports.bytes_of_string = bytes_of_string;
exports.bytes_to_string = bytes_to_string;
exports.caml_is_printable = caml_is_printable;
exports.caml_string_of_char_array = caml_string_of_char_array;
exports.caml_string_get = caml_string_get;
exports.caml_create_string = caml_create_string;
exports.caml_fill_string = caml_fill_string;
exports.caml_blit_string = caml_blit_string;
exports.caml_blit_bytes = caml_blit_bytes;
exports.caml_string_get16 = caml_string_get16;
exports.caml_string_get32 = caml_string_get32;
exports.string_of_char = string_of_char;
exports.get = get;
/* No side effect */


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Caml_array = __webpack_require__(9);
var Caml_int32 = __webpack_require__(11);
var Caml_format = __webpack_require__(8);

var workoutLevels = /* array */[
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ]
];

var exercises = /* array */[
  /* record */[
    /* id */1,
    /* title */"Superman"
  ],
  /* record */[
    /* id */2,
    /* title */"Liegestütz"
  ],
  /* record */[
    /* id */3,
    /* title */"Türziehen"
  ],
  /* record */[
    /* id */4,
    /* title */"Dips"
  ],
  /* record */[
    /* id */5,
    /* title */"Enge Liegestütz"
  ],
  /* record */[
    /* id */6,
    /* title */"Planke"
  ],
  /* record */[
    /* id */7,
    /* title */"Sumokniebeuge auf Zehenspitzen"
  ],
  /* record */[
    /* id */8,
    /* title */"Hip Thrusts"
  ],
  /* record */[
    /* id */9,
    /* title */"Ausfallschritte seitlich"
  ],
  /* record */[
    /* id */10,
    /* title */"Seitliches Beinheben im Liegen"
  ],
  /* record */[
    /* id */11,
    /* title */"Kickbacks"
  ],
  /* record */[
    /* id */12,
    /* title */"Lunges"
  ],
  /* record */[
    /* id */13,
    /* title */"Liegestütz aus dem Stand"
  ],
  /* record */[
    /* id */14,
    /* title */"Hüftanheben im Unterarmstütz"
  ],
  /* record */[
    /* id */15,
    /* title */"Käfer"
  ],
  /* record */[
    /* id */16,
    /* title */"Superman around the world"
  ],
  /* record */[
    /* id */17,
    /* title */"Seitliches Aufdrehen"
  ],
  /* record */[
    /* id */18,
    /* title */"Burpees"
  ],
  /* record */[
    /* id */19,
    /* title */"Squats"
  ],
  /* record */[
    /* id */20,
    /* title */"Lunges Diagonal"
  ],
  /* record */[
    /* id */21,
    /* title */"Hüftstoß auf dem Rücken"
  ],
  /* record */[
    /* id */22,
    /* title */"Jumping Lunges"
  ],
  /* record */[
    /* id */23,
    /* title */"Einbeiniges Kreuzheben"
  ],
  /* record */[
    /* id */24,
    /* title */"Abduktion im Vierfüßlerstand"
  ],
  /* record */[
    /* id */25,
    /* title */"Crunches around the world"
  ],
  /* record */[
    /* id */26,
    /* title */"Einbeiniges Beinanheben auf dem Rücken"
  ],
  /* record */[
    /* id */27,
    /* title */"Cross Fit Sit Ups"
  ],
  /* record */[
    /* id */28,
    /* title */"Klappmesser mit gestreckten Beinen"
  ],
  /* record */[
    /* id */29,
    /* title */"Sit Ups mit erhöhten Beinen + Twist"
  ],
  /* record */[
    /* id */30,
    /* title */"Plank Jumping Jacks"
  ],
  /* record */[
    /* id */31,
    /* title */"Wall Sit"
  ],
  /* record */[
    /* id */32,
    /* title */"Einbeinige Kniebeuge"
  ],
  /* record */[
    /* id */33,
    /* title */"Good Mornings"
  ],
  /* record */[
    /* id */34,
    /* title */"Kniebeuge seitlich gehend"
  ],
  /* record */[
    /* id */35,
    /* title */"Seitl. Beinheben im Stehen"
  ],
  /* record */[
    /* id */36,
    /* title */"„König der Trottel“"
  ],
  /* record */[
    /* id */37,
    /* title */"Goblet Squats"
  ],
  /* record */[
    /* id */38,
    /* title */"Thomas Stretch"
  ],
  /* record */[
    /* id */39,
    /* title */"Brustkorbmobility an der Wand"
  ],
  /* record */[
    /* id */40,
    /* title */"Kniebeugeposition mit seitl. Aufdrehen"
  ],
  /* record */[
    /* id */41,
    /* title */"Kniebeuge mit Armöffnung oben an der Wand"
  ],
  /* record */[
    /* id */42,
    /* title */"Wirbelsäulenrotation im Liegen"
  ],
  /* record */[
    /* id */43,
    /* title */"Standwaage"
  ],
  /* record */[
    /* id */44,
    /* title */"Seestern"
  ],
  /* record */[
    /* id */45,
    /* title */"Dreipunkt-Beinscheren"
  ],
  /* record */[
    /* id */46,
    /* title */"Bodyrocks"
  ],
  /* record */[
    /* id */47,
    /* title */"Planking"
  ],
  /* record */[
    /* id */48,
    /* title */"Hüftheben (seitlich)"
  ]
];

var workoutMatrix = /* array */[
  /* array */[
    1,
    2,
    3,
    4,
    5,
    6
  ],
  /* array */[
    7,
    8,
    9,
    10,
    11,
    12
  ],
  /* array */[
    13,
    14,
    15,
    16,
    17,
    18
  ],
  /* array */[
    19,
    20,
    21,
    22,
    23,
    24
  ],
  /* array */[
    0,
    0,
    0,
    0,
    0,
    0
  ],
  /* array */[
    25,
    26,
    27,
    28,
    29,
    30
  ],
  /* array */[
    1,
    2,
    3,
    4,
    5,
    6
  ],
  /* array */[
    7,
    8,
    9,
    10,
    11,
    12
  ],
  /* array */[
    13,
    14,
    15,
    16,
    17,
    18
  ],
  /* array */[
    19,
    20,
    21,
    22,
    23,
    24
  ],
  /* array */[
    0,
    0,
    0,
    0,
    0,
    0
  ],
  /* array */[
    31,
    32,
    33,
    34,
    35,
    36
  ],
  /* array */[
    1,
    2,
    3,
    4,
    5,
    6
  ],
  /* array */[
    7,
    8,
    9,
    10,
    11,
    12
  ],
  /* array */[
    13,
    14,
    15,
    16,
    17,
    18
  ],
  /* array */[
    19,
    20,
    21,
    22,
    23,
    24
  ],
  /* array */[
    0,
    0,
    0,
    0,
    0,
    0
  ],
  /* array */[
    37,
    38,
    39,
    40,
    41,
    42
  ],
  /* array */[
    1,
    2,
    3,
    4,
    5,
    6
  ],
  /* array */[
    7,
    8,
    9,
    10,
    11,
    12
  ],
  /* array */[
    13,
    14,
    15,
    16,
    17,
    18
  ],
  /* array */[
    19,
    20,
    21,
    22,
    23,
    24
  ],
  /* array */[
    0,
    0,
    0,
    0,
    0,
    0
  ],
  /* array */[
    43,
    44,
    45,
    46,
    47,
    48
  ]
];

var workoutsStatus = /* array */[
  /* record */[
    /* id */1,
    /* complete : false */0,
    /* points */0
  ],
  /* record */[
    /* id */2,
    /* complete : false */0,
    /* points */0
  ],
  /* record */[
    /* id */3,
    /* complete : false */0,
    /* points */0
  ]
];

function getWorkoutTitles(week, workout) {
  var workoutIndex = Caml_int32.imul(Caml_format.caml_int_of_string(week) - 1 | 0, 6) + (Caml_format.caml_int_of_string(workout) - 1 | 0) | 0;
  return /* array */[
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 0) - 1 | 0)[/* title */1],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 1) - 1 | 0)[/* title */1],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 2) - 1 | 0)[/* title */1],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 3) - 1 | 0)[/* title */1],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 4) - 1 | 0)[/* title */1],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 5) - 1 | 0)[/* title */1]
        ];
}

function getWorkoutIds(week, workout) {
  var workoutIndex = Caml_int32.imul(Caml_format.caml_int_of_string(week) - 1 | 0, 6) + (Caml_format.caml_int_of_string(workout) - 1 | 0) | 0;
  return /* int array */[
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 0) - 1 | 0)[/* id */0],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 1) - 1 | 0)[/* id */0],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 2) - 1 | 0)[/* id */0],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 3) - 1 | 0)[/* id */0],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 4) - 1 | 0)[/* id */0],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 5) - 1 | 0)[/* id */0]
        ];
}

var workoutReps = /* array */[
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ]
];

var completedArray = /* array */[
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0
];

var bonusDone = /* array */[
  /* array */[
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0
  ],
  /* array */[
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0
  ],
  /* array */[
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0
  ],
  /* array */[
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0
  ]
];

var knowledgeRead = /* array */[
  /* true */1,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0
];

var knowledgeEntries = /* array */[
  /* record */[
    /* id */1,
    /* title */"",
    /* content */"Eine Zu- oder Abnahme auf der Waage hat nicht immer mit einer tatsächlichen Veränderung des Körperfettanteils zutun. Häufig haben andere Faktoren wie z.B. der Salzgehalt oder der Zyklus Einfluss auf das Gewicht.\n    Effektiver ist es deshalb, Umfänge mit dem Maßband zu messen und so Veränderungen über Zeit festzustellen."
  ],
  /* record */[
    /* id */2,
    /* title */"Motivationsbilder",
    /* content */"Um die Motivation aufrecht zu halten, empfehlen sich Bilder mit motivierenden Sprüchen. Hänge dir diese am besten gut sichtbar in deine Wohnung, verwende sie als Hintergrundbild für dein Handy oder folge motivierenden Social Media-Accounts.\n      "
  ],
  /* record */[
    /* id */3,
    /* title */"Volumenreiche Nahrungsauswahl",
    /* content */"Versuche Lebensmittel in deinen Ernährungsplan zu integrieren, die auf eine große Menge einen möglichst geringen Kaloriengehalt haben, wie zum Beispiel grünes Gemüse. Durch das hohe Volumen wirst du schneller und länger satt und nimmst so weniger Kalorien zu dir. Ein Beispiel: Schneide eine Zucchini mit einem Sparschäler in dünne, lange Streifen. 3 Minuten in der Pfanne dünsten. Salz, Pfeffer und Kräuter dazu. Fertig sind deine kalorienarmen, aber sättigenden Bandnudeln.\n      "
  ],
  /* record */[
    /* id */4,
    /* title */"Heißhunger",
    /* content */"Da Hunger oft mit Durst verwechselt wird, empfiehlt es sich, bei Heißhunger zunächst etwas zu trinken. Ansonsten können Kaugummis, kalorienfreie (Zero)-Getränke oder das kalorienarme Rocka Geschmackspulver SMACKTASTIC (z.B. im Kaffee oder Magerquark) helfen."
  ],
  /* record */[
    /* id */5,
    /* title */"Muskelkater",
    /* content */"Ungewohnte Bewegungen können zu Muskelkater führen, weshalb du sicher während der 28 Tage das ein oder andere Mal deine Muskeln mehr spüren wirst als gewollt. Muskelkater ist aber nicht weiter schlimm und du kannst Linderung verschaffen, etwa durch Wärme (z.B. durch einen Saunabesuch oder ein Bad), leichtes Dehnen oder eine aktive Ausdauereinheit, wie zum Beispiel das optionale Cardio-Workout in deiner App.  Hier kannst du gelegentlich nach dem Training eine Portion <a href=\"https://www.rockanutrition.de/products/hypertroph-hd-bubblegum?variant=35737154689\">Rocka Hypertroph HD</a> zu dir nehmen, denn bereits 2 g L-Carnitin können helfen, den Muskelkater zu verringern oder dem vorzubeugen."
  ],
  /* record */[
    /* id */6,
    /* title */"Shake ersetzen",
    /* content */"Ersetze deinen Shake doch mal durch die Rocka Pancakes, Muffins oder die Ice Cream. Diese Alternativen bringen Abwechslung in deinen Speiseplan und überzeugen durch nahezu identische Nährwerte. Die genauen Umrechnungsmengen findest du am Anfang deines Rezeptteils mit Rocka Produkten im eBook."
  ],
  /* record */[
    /* id */7,
    /* title */"Belohnungen",
    /* content */"Belohne dich am Ende deiner Challenge - aber nicht mit Süßem, sondern z. B. mit Dingen, die du dir sonst nicht gönnen würdest (neue Sportklamotten, Supplements, einen Kurztrip für danach, Wellness-Day usw). Es ist vor allem wichtig, dass du dir langfristige Ziele setzt. Dort angekommen, kannst du dich entsprechend belohnen! Teilziele können sich dabei unterstützen, aber auch ganz unabhängig von deinem großen Ziel eingeplant werden. So zum Beispiel kann ein Teilziel sein, dass du 3 cm Bauchumfang verlierst, dein langfristiges Ziel kann das Tragen deiner Lieblingshose sein, die dir bis vor 2 Jahren gepasst hat. Deine Motivation wird so auf einem hohen Level gehalten. "
  ],
  /* record */[
    /* id */8,
    /* title */"Zeitnahe Zwischenziele",
    /* content */"Oft kann uns ein großes Ziel in der Zukunft demotivieren weiterzumachen, da der Weg bis dorthin noch zu weit entfernt ist. Deshalb ist es wichtig, sich realistische, zeitnahe Zwischenziele zu setzen, die zu kleinen Erfolgserlebnissen führen und Motivation mit sich bringen."
  ],
  /* record */[
    /* id */9,
    /* title */"Notiere dir deine Trainingszeiten im Kalender",
    /* content */"Plane deine Woche im Voraus und richte dir früh genug Zeit für den Sport ein. So kann es nicht passieren, dass du dein wöchentliches Sportpensum nicht erreichst oder den Sport vor dir herschiebst."
  ],
  /* record */[
    /* id */10,
    /* title */"Ballaststoffe",
    /* content */"<div>Ballaststoffe wirken sich positiv auf die Verdauung und die Darmflora aus und können Krankheiten wie Diabetes oder Krebs vorbeugen. Da sie lange satt machen, spielen sie bei der Gewichtsreduktion eine große Rolle. Zu finden sind sie vor allem in in Vollkornprodukten, Hülsenfrüchten, Obst und Gemüse. Täglich sollte dein Ziel sein, mindestens 30 g Ballaststoffe zu dir zu nehmen. 5 Lebensmittel, die sich hierfür während der 28-Tage-Challenge anbieten (und ihr Ballaststoffanteil auf 100 g):</div>\n    Kidneybohnen (ungekocht): 21 g\n    Linsen (ungekocht): 19 g\n    Haferflocken: 10 g\n    Avocado: 7 g\n    Rosenkohl: 4 g\n    "
  ],
  /* record */[
    /* id */11,
    /* title */"Regeneration",
    /* content */"Regeneration ist mindestens genauso wichtig wie das Training selbst. Die Regeneration startet mit einem Cool-down (wie das funktioniert, kannst du im Trainingsteil deines eBooks nachlesen), beinhaltet aber auch die dem Training angepasste Ernährung, die Pausenzeiten zwischen den sportlichen Einheiten und vor allem den Schlaf. Im Schlaf läuft der Muskelaufbau ab und Schäden werden repariert. Schlafmangel führt zudem zu einem erhöhten Appetit und einer geringeren Leistungsfähigkeit beim Sport. Auch schnell verfügbares (=Whey-) Protein, sowie wertvolle Vitamine und Minerale können bei der Einnahme nach dem Workout eine regenerative Wirkung entfalten. Ein Snack-Shake nach dem Training, Omega 3-Kapseln (z.B. <a href=\"https://www.rockanutrition.de/collections/omega3\">Omega 3+ von Rocka</a> oder Vitamin D3 (z.B. von <a href=\"https://www.rockanutrition.de/products/vitamin-d-kapseln-120-stueck\">Rocka</a> sind also eine gute Idee."
  ],
  /* record */[
    /* id */12,
    /* title */"Vegane Burger",
    /* content */"Manchmal ist es gar nicht so einfach, aus der verfügbaren Auswahl an Lebensmitteln etwas Kreatives zu zaubern. Vielleicht gefällt dir ja die folgende Idee für vegane Burger: Einfach die erlaubte Menge an Kidneybohnen als Proteinquelle mit einer Gabel zerdrücken. Dann die erlaubte Menge an Haferflocken (Kohlenhydratquelle) dazugeben und zu einem Teig kneten. Gegebenenfalls Wasser hinzufügen, um eine homogene Masse zu erhalten. Würzen, Burger-Patties formen und in der Pfanne mit Öl (Fettquelle) anbraten."
  ],
  /* record */[
    /* id */13,
    /* title */"Gemüse lecker zubereiten",
    /* content */"1. Wie wäre es mit einem Nudelsalat aus Gurke? Dafür die Gurke mit einem Sparschäler in lange Streifen schneiden und mit einem Spritzer Zitronensaft, Salz, Pfeffer und Kräutern würzen.\n    2. Du isst gerne Kartoffelbrei? Warum statt den Kartoffeln nicht mal einfach Gemüse verwenden? Hier bieten sich zum Beispiel Brokkoli und Blumenkohl an. Einfach kochen, pürieren und würzen.\n    3. Kohlrabi sind ein super Pommes-Ersatz. Dafür die Kohlrabi in Pommesform schneiden, mit Pommesgewürz (alternativ z.B. Salz, Pfeffer, Paprika, Curry) würzen und in den Ofen geben.\n    "
  ],
  /* record */[
    /* id */14,
    /* title */"Whey-Eiskaffee",
    /* content */"Ab jetzt musst du auf einen leckeren Eiskaffee nicht mehr verzichten. Ein Protein-Eiskaffee schmeckt nicht nur köstlich, sondern kann während der 28-Tage Challenge problemlos als Snack eingesetzt werden. Dafür 30 g Whey mit einem Esslöffel Instant-Kaffeepulver (alternativ mit einem abgekühlten Kaffee oder Espresso), Wasser und Smacktastic in einen Mixer geben."
  ],
  /* record */[
    /* id */15,
    /* title */"Flüssigkeitszufuhr",
    /* content */"Trinken wir zu wenig, kann das Auswirkungen auf unsere sportliche Leistungsfähigkeit haben. Deshalb ist nicht nur deine gesamte Flüssigkeitszufuhr am Tag von Bedeutung, sondern auch ein hydrierter Start in dein Workout und das kontinuierliche Trinken währenddessen. Hierfür bietet sich vor allem Wasser an, aber auch Zero-Getränke und Kaffee in Maßen. Als Faustformel kannst du dich hier an mindestens 2 Liter pro Tag orientieren. "
  ],
  /* record */[
    /* id */16,
    /* title */"Suche dir einen Trainingsbuddy",
    /* content */"Denn gemeinsam kann man sich leichter motivieren, sich herausfordern und sich bei den einzelnen Übungen anfeuern oder unterstützen. Eine Freundin hat ebenfalls mit der 28-Tage-Challenge gestartet? Super! Mal sehen, wer in 30 Sekunden mehr Burpees schafft. In der Facebook-Army hast du die Möglichkeit, nach Gleichgesinnten - vielleicht aus derselben Umgebung - zu fragen."
  ],
  /* record */[
    /* id */17,
    /* title */"Miss dich nicht mit anderen",
    /* content */"… aber mit deinem gestrigen Ich. Es wird immer jemanden geben, der erfolgreicher ist als du. Jeder Mensch hat zudem unterschiedliche Voraussetzungen. Konzentriere dich deshalb nur auf dich selbst und versuche stetig über dich hinauszuwachsen."
  ],
  /* record */[
    /* id */18,
    /* title */"“Muscle-Mind Connection”",
    /* content */"Versuche den Muskel, den du beim Training ansteuerst, auch wirklich intensiv zu spüren, indem du dich auf ihn konzentrierst. Dieses Konzept hat Einfluss auf deinen Trainingserfolg, eine Verringerung des Verletzungsrisikos und vor allem verbessert es die Ausführung der Übung."
  ],
  /* record */[
    /* id */19,
    /* title */"Positiv denken",
    /* content */"Wir alle haben Zweifel. Doch wie wäre es, wenn du die ganzen negativen Stimmen in deinem Kopf durch positive ersetzen würdest. Sobald die innere Stimme sich mit einem Satz wie „Ich halte doch eh nichts durch“ meldet, rufe dir zugleich deine bisherigen Erfolge ins Gedächtnis und sage dir, dass du diszipliniert bist. Und sogar wenn das noch nicht der Fall sein sollte. Mit dieser Denkweise wird es schon bald Realität werden."
  ],
  /* record */[
    /* id */20,
    /* title */"Sportpause bei Krankheit",
    /* content */"Sport stärkt das Immunsystem. Solltest du nun doch einmal krank sein, lege unbedingt eine Sportpause ein, da sonst das Immunsystem noch mehr geschwächt wird und Krankheitserreger sich weiter ausbreiten können. "
  ],
  /* record */[
    /* id */21,
    /* title */"Verletzungen vorbeugen",
    /* content */"Sportverletzungen können einfach vorgebeugt werden. Am wichtigsten dafür ist es, sich vor dem Training gut aufzuwärmen. Dazu gehört sowohl das physische als auch das psychische Aufwärmen. Weißt du nicht genau, wie du das machst, schaue am besten nochmal in die Hinweise zum Training in deinem eBook. Unter “Warm-Up” findest du Anregungen dazu."
  ],
  /* record */[
    /* id */22,
    /* title */"EAA",
    /* content */"EAA steht für Essential Amino Acids. Bei den EAA handelt es sich um alle 8 essentiellen Aminosäuren: Leucin, Isoleucin, Valin, Lysin, Phenylalanin, Threonin, Methionin und das Tryptophan. Diese sind für den Muskelaufbau wichtig, in deinem Fall aber vor allem, um während der kalorienreduzierten Diät bereits existierende Muskulatur nicht zu verlieren. Außerdem verbessern sie die Regeneration und können so unter anderem Muskelkater effektiv vorbeugen. Bei der Verwendung eines EAA-Produkts sollte auf eine gute Löslichkeit und eine optimale Aminosäurenzusammensetzung geachtet werden. Beides liefern dir die Produkte von Rocka Nutrition. Zusätzlich sind sie ausgesprochen lecker im Geschmack (falls du eine schmackhafte Alternative zu Wasser haben willst), sogar vegan und frei von künstlichen Farbstoffen und Aspartam. Da sie nicht komplett kalorienfrei sind, solltest du täglich nicht mehr als 1-2 Portionen zu dir nehmen und diese am besten um dein Training herum. Für weitere Informationen zum Thema EAA kannst du dir gerne folgendes Video anschauen: <a href=\"https://www.youtube.com/watch?v=2aq1EEG-7ps\">Youtube</a>."
  ],
  /* record */[
    /* id */23,
    /* title */"Bewegung im Alltag",
    /* content */"Der wohl in Zeitschriften am häufigsten genannte Tipp, der so hilfreich ist, dass man ihn etliche Male wiederholen kann: Versuche Bewegung in deinen Alltag zu bringen, um so deinen Kalorienverbrauch zu steigern. Treppe statt Aufzug, häufiger zu Fuß gehen, eine Haltestelle früher aussteigen und laufen, mit Freunden spazieren gehen, statt in einem Café zu treffen. Kontrolliere die nächste Zeit doch mal mit einer Schrittzähler-App, wie viele Schritte du täglich zurücklegst. Versuche heute einmal auf 10.000 Schritte zu kommen. Und wenn du das geschafft hast, kannst du es direkt für die nächsten Tage beibehalten."
  ],
  /* record */[
    /* id */24,
    /* title */"Kalorienarme Saucen und Aufstriche",
    /* content */"Ersetze kalorienreiche Saucen und Aufstriche durch kalorienarme Alternativen wie die ROCKA SAUCE ZERO, die SMACKTASTIC CREAMS oder die SMACKTASTIC JAM. Du solltest nichtsdestotrotz eine bestimmte Menge nicht überschreiten (Sauce Zero: max. 2 EL pro Mahlzeit, Cream: max. 3 Portionen à 15 g pro Woche, Jam: max. 3 TL pro Tag)."
  ],
  /* record */[
    /* id */25,
    /* title */"Sei nicht zu streng zu dir selbst!",
    /* content */"Fast jeder von uns geht mit sich selbst viel strenger um als mit Freunden. Überlege dir deshalb immer, wenn du dich mal wieder verurteilst, ob du dasselbe, das du zu dir sagst, auch zu einem guten Freund sagen würdest. Und denke daran: Menschen können nicht konstant 100% geben."
  ],
  /* record */[
    /* id */26,
    /* title */"Fitness Lifestyle",
    /* content */"Fast jeder von uns geht mit sich selbst viel strenger um als mit Freunden. Überlege dir deshalb immer, wenn du dich mal wieder verurteilst, ob du dasselbe, das du zu dir sagst, auch zu einem guten Freund sagen würdest. Und denke daran: Menschen können nicht konstant 100% geben."
  ],
  /* record */[
    /* id */27,
    /* title */"Fitnessgerechte Ernährung im Restaurant",
    /* content */"Solltest du häufiger auswärts essen, empfiehlt es sich, auch hier auf fitnessgerechte Nahrung zurückzugreifen. Bestelle zum Beispiel mageres Fleisch oder Fisch mit Gemüsebeilage oder Salate und verzichte auf fettige Soßen."
  ],
  /* record */[
    /* id */28,
    /* title */"Wissen: Muskelaufbau vs. Fettverbrennung",
    /* content */"<div>Das Prinzip des Muskelaufbaus und der Fettverbrennung ist ganz einfach. Willst du zunehmen/Muskeln aufbauen, musst du in der Regel mehr Kalorien zu dir nehmen, als du eigentlich benötigst (Kalorienüberschuss).</div><div> Wenn du unter deinem Kalorienbedarf isst, also ein Kaloriendefizit fährst, verlierst du normalerweise Fett.</div>"
  ]
];

var exerciseImagesCount = /* array */[
  /* int array */[
    2,
    3,
    3
  ],
  /* int array */[
    2,
    2,
    2
  ],
  /* int array */[
    2,
    2,
    2
  ],
  /* int array */[
    2,
    2,
    2
  ],
  /* int array */[
    2,
    3,
    6
  ],
  /* int array */[
    2,
    2,
    4
  ],
  /* int array */[
    3,
    3,
    3
  ],
  /* int array */[
    2,
    2,
    3
  ],
  /* int array */[
    2,
    2,
    3
  ],
  /* int array */[
    2,
    2,
    3
  ],
  /* int array */[
    2,
    2,
    2
  ],
  /* int array */[
    2,
    3,
    3
  ],
  /* int array */[
    3,
    3,
    3
  ],
  /* int array */[
    2,
    2,
    3
  ],
  /* int array */[
    2,
    3,
    3
  ],
  /* int array */[
    3,
    3,
    3
  ],
  /* int array */[
    3,
    3,
    2
  ],
  /* int array */[
    3,
    3,
    4
  ],
  /* int array */[
    2,
    2,
    2
  ],
  /* int array */[
    2,
    2,
    3
  ],
  /* int array */[
    2,
    2,
    3
  ],
  /* int array */[
    3,
    3,
    6
  ],
  /* int array */[
    2,
    3,
    3
  ],
  /* int array */[
    2,
    2,
    2
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    1,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    3,
    0,
    0
  ],
  /* int array */[
    3,
    0,
    0
  ],
  /* int array */[
    1,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    1,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    3,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    1,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ]
];

var exerciseDescriptions = /* array */[
  /* record */[
    /* id */1,
    /* description : array */[
      "Lege dich bäuchlings auf den Boden, strecke deine Arme nach vorne und deine Beine nach hinten aus. Winkle beide Arme an, sodass sich dein Ober- und Unterarm in einem 90-Grad-Winkel zueinander befinden. Hebe die Arme und Beine nach oben an. Halte die Spannung am höchsten Punkt. Senke Arme und Beine zum Boden.",
      "Lege dich bäuchlings auf den Boden, strecke deine Arme nach vorne und deine Beine nach hinten aus. Hebe gleichzeitig beide Arme und beide Beine im ausgestreckten Zustand nach oben an. Halte die Spannung am höchsten Punkt. Senke die Arme und Beine zum Boden.",
      "Lege dich bäuchlings auf den Boden, strecke deine Arme nach vorne und deine Beine nach hinten aus. Hebe gleichzeitig beide Arme und beide Beine im ausgestreckten Zustand nach oben an. Grätsche beim Hochgehen die Beine. Halte die Spannung am höchsten Punkt. Senke die Arme und Beine zum Boden und schließe die Beine."
    ]
  ],
  /* record */[
    /* id */2,
    /* description : array */[
      "Stütze dich mit gestreckten Armen und dem Gesicht zum Boden schulterbreit oder etwas breiter auf deine Hände, die Beine liegen dabei nebeneinander oder sind leicht gegrätscht. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Setze deinen Körper dabei unter Spannung und lasse kein Hohlkreuz entstehen. Drücke dich wieder vom Boden hoch, bis die Arme fast vollkommen gestreckt sind. Führe die Übung auf den Knien aus.",
      "Stütze dich mit gestreckten Armen und dem Gesicht zum Boden schulterbreit oder etwas breiter auf deine Hände, die Beine liegen dabei nebeneinander oder sind leicht gegrätscht. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Setze deinen Körper dabei unter Spannung und lasse kein Hohlkreuz entstehen. Drücke dich wieder vom Boden hoch, bis die Arme fast vollkommen gestreckt sind. Führe die Übung auf den Fußspitzen aus.",
      "Stütze dich mit gestreckten Armen und dem Gesicht zum Boden schulterbreit oder etwas breiter auf deine Hände, die Beine liegen dabei nebeneinander oder sind leicht gegrätscht. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Setze deinen Körper dabei unter Spannung und lasse kein Hohlkreuz entstehen. Drücke dich wieder vom Boden hoch, bis die Arme fast vollkommen gestreckt sind. Deine Beine sind erhöht, zum Beispiel indem du sie auf einen Stuhl legst."
    ]
  ],
  /* record */[
    /* id */3,
    /* description : array */[
      "Umgreife die Türgriffe einer geöffneten Tür (benutze je nach Bedarf ein Handtuch, das du um den Türgriff legst) und platziere deine Füße links und rechts neben der Tür, deine Füße befinden sich unter den Türgriffen. Halte deine Beine nahezu gestreckt und lehne dich minimal zurück, dein Rücken bleibt gerade. Ziehe dich zur Tür und beuge deine Arme. Deine Ellenbogen gehen dicht am Körper entlang. Die Endposition ist erreicht, sobald die Brust die Tür berührt. Lasse dich nun kontrolliert in die Ausgangsposition zurück.",
      "Umgreife die Türgriffe einer geöffneten Tür (benutze je nach Bedarf ein Handtuch, das du um den Türgriff legst) und platziere deine Füße links und rechts neben der Tür, deine Füße befinden sich unter den Türgriffen. Beuge deine Beine nun leicht und lehne dich etwas nach hinten, dein Rücken bleibt gerade. Ziehe dich zur Tür und beuge deine Arme. Deine Ellenbogen gehen dicht am Körper entlang. Die Endposition ist erreicht, sobald die Brust die Tür berührt. Lasse dich nun kontrolliert in die Ausgangsposition zurück.",
      "Lege dich unter einen Tisch und strecke deine Arme senkrecht zur Tischkante nach oben. Umgreife nun die Kante des Tisches, deine Fersen bleiben auf dem Boden. Ziehe dich mit der Brust zur Tischkante, der Rücken bleibt gerade. Lasse dich kontrolliert in die Ausgangsposition zurück, indem du die Arme streckst."
    ]
  ],
  /* record */[
    /* id */4,
    /* description : array */[
      "Stütze dich in Schulterbreite mit deinen Händen auf den Rand einer Erhöhung. Stelle deine Füße auf den Boden. Ober- und Unterschenkel befinden sich in etwa im 90-Grad-Winkel zueinander. Beuge deine Arme so weit wie möglich. Drücke dich dann wieder nach oben.",
      "Stütze dich in Schulterbreite mit deinen Händen auf den Rand einer Erhöhung. Deine Beine sind ausgestreckt. Beuge deine Arme so weit wie möglich und drücke dich dann wieder nach oben.",
      "Stütze dich in Schulterbreite mit deinen Händen auf den Rand einer Erhöhung. Lege deine Fersen auf eine andere Erhöhung, zum Beispiel einen anderen Stuhl, sodass sich dein Körper in der Luft befindet. Deine Beine sind ausgestreckt. Beuge deine Arme so weit wie möglich und drücke dich dann wieder nach oben."
    ]
  ],
  /* record */[
    /* id */5,
    /* description : array */[
      "Gehe auf die Knie. Stütze dich mit gestreckten Armen und dem Gesicht zum Boden auf deine Hände. Diese liegen direkt nebeneinander, die Fingerspitzen sind geradeaus gerichtet. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Die Ellenbogen bleiben dabei dicht am Körper. Drücke dich vom Boden hoch, bis die Arme fast vollkommen gestreckt sind. Beuge die Arme erneut.",
      "Gehe auf die Knie. Stütze dich mit gestreckten Armen und dem Gesicht zum Boden auf deine Hände. Diese liegen direkt nebeneinander, die Fingerspitzen sind geradeaus gerichtet. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Die Ellenbogen bleiben dabei dicht am Körper. Nachdem du deine Arme gebeugt hast, legst du deinen Oberkörper auf dem Boden ab und klatscht die Hände einmal hinter deinem Rücken zusammen. Positioniere deine Hände erneut wie in der Ausgangsposition beschrieben und drücke dich vom Boden hoch.",
      "Gehe auf die Knie. Stütze dich mit gestreckten Armen und dem Gesicht zum Boden auf deine Hände. Diese liegen direkt nebeneinander, die Fingerspitzen sind geradeaus gerichtet. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Die Ellenbogen bleiben dabei dicht am Körper. Drücke dich zurück nach oben. Begib dich auf die Fußspitzen in die Liegestützposition. Lege nun zunächst deinen rechten, dann den linken Unterarm auf dem Boden ab, sodass sich deine Ellenbogen unter deinen Schultern befinden. Drücke dich mit dem einen, dann mit dem anderen Arm zurück in die Liegestützposition und führe erneut eine enge Liegestütze auf den Knien aus."
    ]
  ],
  /* record */[
    /* id */6,
    /* description : array */[
      "Du liegst bäuchlings auf dem Boden und stützt dich auf deine Unterarme, die sich parallel zueinander unter deinen Schultern befinden. Deine Beine sind in Hüftbreite gerade nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Halte die Position so lange wie möglich.",
      "Du liegst bäuchlings auf dem Boden und stützt dich auf deine Unterarme, die sich parallel zueinander unter deinen Schultern befinden. Deine Beine sind in Hüftbreite gerade nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Hebe deine Beine im Wechsel nach oben an.",
      "Du liegst bäuchlings auf dem Boden und stützt dich auf deine Unterarme, die sich parallel zueinander unter deinen Schultern befinden. Deine Beine sind in Hüftbreite gerade nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Steige mit den Armen abwechselnd auf."
    ]
  ],
  /* record */[
    /* id */7,
    /* description : array */[
      "Stelle deine Füße etwas breiter als hüftbreit auf. Versetze deinen Oberkörper unter Spannung, beuge deine Beine im Kniegelenk und schiebe dabei dein Gesäß nach hinten. Gehe so weit nach unten, wie es dir möglich ist. Richte dich wieder auf und gehe dabei auf die Zehenspitzen. Halte die Position im gestreckten Zustand für 3 Sekunden. Wiederhole die Bewegung und begib dich bei der Abbewegung zurück auf deine gesamte Fußsohle.",
      "Stelle deine Füße etwas breiter als hüftbreit auf. Versetze deinen Oberkörper unter Spannung, beuge deine Beine im Kniegelenk und schiebe dabei dein Gesäß nach hinten. Gehe so weit nach unten, wie es dir möglich ist. Mache dazwischen eine normale Sumokniebeuge, bei der du NICHT auf die Zehenspitzen gehst und die du auch NICHT 3 Sekunden lang hältst.",
      "Stelle deine Füße etwas breiter als hüftbreit auf. Versetze deinen Oberkörper unter Spannung, beuge deine Beine im Kniegelenk und schiebe dabei dein Gesäß nach hinten. Gehe so weit nach unten, wie es dir möglich ist. Richte dich wieder auf und gehe dabei auf die Zehenspitzen. Halte die Position im gestreckten Zustand für 3 Sekunden. Wiederhole die Bewegung und begib dich bei der Abbewegung zurück auf deine gesamte Fußsohle. Führe diese Bewegung 2 Mal aus. Anschließend machst du eine normale Sumokniebeuge,  bei der du NICHT auf die Zehenspitzen gehst und die du auch NICHT 3 Sekunden lang hältst."
    ]
  ],
  /* record */[
    /* id */8,
    /* description : array */[
      "Du liegst auf dem Rücken, deine Beine sind aufgestellt und deine Arme liegen entlang deines Körpers mit den Handflächen zum Boden. Drücke dein Becken so hoch wie möglich. Halte dein Becken für etwa 2 Sekunden oben unter Spannung. Lasse dein Becken wieder langsam heruntersinken, berühre jedoch nicht mehr den Boden und drücke es kurz vor dem Ablegen wieder hoch. Führe die Übung auf beiden Beinen aus.",
      "Du liegst auf dem Rücken, deine Beine sind aufgestellt und deine Arme liegen entlang deines Körpers mit den Handflächen zum Boden. Drücke dein Becken so hoch wie möglich. Halte dein Becken für etwa 2 Sekunden oben unter Spannung. Lasse dein Becken wieder langsam heruntersinken, berühre jedoch nicht mehr den Boden und drücke es kurz vor dem Ablegen wieder hoch. Hebe ein Bein vom Boden an. Wechsle bei jeder Wiederholung das angehobene Bein.",
      "Du liegst auf dem Rücken, deine Beine sind aufgestellt und deine Arme liegen entlang deines Körpers mit den Handflächen zum Boden. Drücke dein Becken so hoch wie möglich. Halte dein Becken für etwa 2 Sekunden oben unter Spannung. Lasse dein Becken wieder langsam heruntersinken, berühre jedoch nicht mehr den Boden und drücke es kurz vor dem Ablegen wieder hoch. Führe die Übung erst auf einem Bein, dann auf beiden Beinen und dann wieder auf einem Bein durch. Hebe das rechte und das linke Bein im Wechsel an."
    ]
  ],
  /* record */[
    /* id */9,
    /* description : array */[
      "Stelle dich schulterbreit hin und positioniere die Hände vor deinem Körper. Mache einen Schritt nach links und beuge schließlich das linke Knie. Schiebe dabei das Gesäß nach hinten und beuge den Oberkörper leicht nach vorne. Der Oberschenkel des gebeugten Beines sollte nun parallel zum Boden sein. Richte dich wieder auf und wiederhole die Bewegung mit dem anderen Bein.",
      "Stelle dich schulterbreit hin und positioniere die Hände vor deinem Körper. Mache einen Schritt nach links und beuge schließlich das linke Knie. Während du dein Gesäß nach hinten schiebst, streckst du deine Arme zur Seite aus, die Fingerspitzen zeigen nach oben und die Handflächen nach außen vom Körper weg. Dabei ziehst du mit den Fingerspitzen nach oben. Richte dich wieder auf und bringe deine Arme nach unten. Wiederhole die Bewegung mit dem anderen Bein.",
      "Stelle dich schulterbreit hin und positioniere die Hände vor deinem Körper. Strecke deine Arme über dem Kopf aus, die Handflächen berühren sich. Mache mit dem rechten Bein einen Schritt nach vorne und beuge dein rechtes Knie im 90-Grad-Winkel.  Strecke die Arme nun auf einer Linie zur Seite aus und kippe deinen Oberkörper nach rechts, sodass die rechte Hand den Boden berührt, die linke Hand zur Decke zeigt. Führe den Oberkörper zurück zur Mitte und bringe deine Arme zurück nach oben. Stoße dich mit dem rechten Bein am Boden ab und komme zurück in die Startposition, wiederhole die Bewegung mit dem anderen Bein."
    ]
  ],
  /* record */[
    /* id */10,
    /* description : array */[
      "Lege dich auf deine rechte Seite, deine Beine sind gestreckt und das linke Bein liegt auf dem rechten. Stemme deine linke Hand in die Hüfte, die rechte Hand stützt du unter den Kopf. Hebe dein linkes Bein nach oben an, bis es sich in etwa in einem 45-Grad-Winkel zu deinem anderen Bein befindet. Halte die Position kurz und bringe das linke Bein dann wieder nach unten, lege es aber nicht vollständig ab. Wiederhole die Ausführung. Nachdem du das Bein 10 Mal angehoben hast, wechselst du die Seite.",
      "Lege dich auf deine rechte Seite, deine Beine sind gestreckt und das linke Bein liegt auf dem rechten. Stemme deine linke Hand in die Hüfte und begib dich in den Seitstütz. Hierfür legst du deinen Unterarm auf dem Boden ab. Deine Hand zeigt in dieselbe Richtung wie dein Gesicht. Bringe dein Becken nach oben, dein Körper bildet eine gerade Linie. Hebe dein linkes Bein nach oben an, bis es sich in etwa in einem 45-Grad-Winkel zu deinem anderen Bein befindet. Halte die Position kurz und bringe das linke Bein dann wieder nach unten, lege es aber nicht vollständig ab. Wiederhole die Ausführung. Nachdem du das Bein 10 Mal angehoben hast, wechselst du die Seite.",
      "Lege dich auf deine rechte Seite, deine Beine sind gestreckt und das linke Bein liegt auf dem rechten. Stemme deine linke Hand in die Hüfte, du stützt dich dabei auf deinen rechten Unterarm. Hebe dein linkes Bein nach oben an, bis es sich in etwa in einem 45-Grad-Winkel zu deinem anderen Bein befindet. Halte die Position kurz und bringe das linke Bein dann wieder nach unten. Im Anschluss bringst du dein Becken nach oben und wieder nach unten. Wiederhole die Ausführung. Nachdem du das Bein und die Hüfte jeweils 10 Mal nach oben angehoben hast, wechselst du die Seite."
    ]
  ],
  /* record */[
    /* id */11,
    /* description : array */[
      "Gehe in den Vierfüßlerstand und stütze dich dabei auf deine Hände. Strecke das rechte Bein nach hinten aus, sodass es auf einer Linie mit dem Rücken ist. Ziehe die Zehenspitzen Richtung Schienbein und beuge das Knie, sodass Oberschenkel und Unterschenkel in einem rechten Winkel zueinander stehen. Kicke dein angewinkeltes Bein nun nach oben. Ziehe dein Knie kontrolliert zur Brust. Wiederhole die Bewegung mit dem linken Bein.",
      "Gehe in den Vierfüßlerstand und stütze dich dabei auf deine Hände. Strecke das rechte Bein nach hinten aus, sodass es auf einer Linie mit dem Rücken ist. Ziehe die Zehenspitzen Richtung Schienbein und beuge das Knie, sodass Oberschenkel und Unterschenkel in einem rechten Winkel zueinander stehen. Kicke dein angewinkeltes Bein nun nach oben. Bring es nun den halben Weg zurück nach unten und ziehe es erneut nach oben. Bringe dann das Knie kontrolliert zur Brust. Wiederhole die Bewegung mit dem linken Bein.",
      "Gehe in den Vierfüßlerstand und stütze dich dabei auf deine Hände. Strecke das rechte Bein nach hinten aus, sodass es auf einer Linie mit dem Rücken ist. Ziehe die Zehenspitzen Richtung Schienbein und beuge das Knie, sodass Oberschenkel und Unterschenkel in einem rechten Winkel zueinander stehen. Kicke dein angewinkeltes Bein nun nach oben. Ziehe dein Knie kontrolliert zur Brust. Strecke dein Bein nun gerade nach hinten aus und kicke es nach oben. Ziehe dann das Bein kontrolliert zurück und wiederhole die zwei Kicks mit dem anderen Bein."
    ]
  ],
  /* record */[
    /* id */12,
    /* description : array */[
      "Du stehst hüftbreit. Mache einen großen Schritt nach hinten und beuge das vordere Bein, sodass die Wade und der Oberschenkel dieses Beines einen 90-Grad-Winkel ergeben. Halte den Oberkörper dabei aufrecht. Drücke dich aus dem Gesäß zurück in den Stand und führe die gleiche Bewegung nun mit deinem anderen Bein durch.",
      "Du stehst hüftbreit. Mache einen großen Schritt nach hinten und beuge das vordere Bein, sodass die Wade und der Oberschenkel dieses Beines einen 90-Grad-Winkel ergeben. Halte den Oberkörper dabei aufrecht. Drücke dich mit dem vorderen Bein wieder nach oben. Ziehe das Knie des hinteren Beines Richtung Brust und stelle es schließlich wieder auf den Boden neben das andere Bein. Wiederhole die komplette Bewegung, indem du nun mit dem anderen Bein nach hinten gehst.",
      "Du stehst hüftbreit. Mache einen großen Schritt nach hinten und beuge das vordere Bein, sodass die Wade und der Oberschenkel dieses Beines einen 90-Grad-Winkel ergeben. Halte den Oberkörper dabei aufrecht. Drücke dich mit dem vorderen Bein wieder nach oben. Ziehe das Knie des hinteren Beines Richtung Brust und stelle es schließlich wieder auf den Boden neben das andere Bein. Während du das Knie anziehst, springst du mit dem anderen Bein nach oben."
    ]
  ],
  /* record */[
    /* id */13,
    /* description : array */[
      "Stelle dich aufrecht hin. Positioniere die Hände schulterbreit auf dem Boden (gehe dabei wenn nötig leicht in die Knie). Nimm eine Liegestützposition ein. Du gehst mit deinen Beinen also nach hinten und senkst dein Gesäß Richtung Boden. Begib dich auf die Knie. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Setze deinen Körper dabei unter Spannung und lasse kein Hohlkreuz entstehen. Drücke dich wieder vom Boden hoch, bis die Arme fast vollkommen gestreckt sind. Stelle dich erneut aufrecht hin.",
      "Stelle dich aufrecht hin. Positioniere die Hände schulterbreit auf dem Boden (gehe dabei wenn nötig leicht in die Knie). Laufe mit den Händen nach vorne in die Liegestützposition.\n        Begib dich auf die Knie. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Setze deinen Körper dabei unter Spannung und lasse kein Hohlkreuz entstehen. Drücke dich wieder vom Boden hoch, bis die Arme fast vollkommen gestreckt sind. Erhebe deine Knie, sodass du wieder in einer Liegestützposition bist und laufe nun mit den Händen zurück in den Stand.",
      "Stelle dich aufrecht hin. Positioniere die Hände schulterbreit auf dem Boden (gehe dabei wenn nötig leicht in die Knie). Laufe mit den Händen nach vorne in die Liegestützposition.\n        Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Setze deinen Körper dabei unter Spannung und lasse kein Hohlkreuz entstehen. Drücke dich wieder vom Boden hoch, bis die Arme fast vollkommen gestreckt sind. Laufe nun mit den Händen zurück in den Stand."
    ]
  ],
  /* record */[
    /* id */14,
    /* description : array */[
      "Stütze dich auf deine Unterarme, die sich parallel zueinander unter deinen Schultern befinden. Du befindest dich auf den Zehenspitzen und deine Beine sind gerade in Hüftbreite nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Hebe die Hüfte Richtung Decke, bis dein Körper ein umgedrehtes \"V\" ergibt. Komme zurück in die Ausgangsposition.",
      "Stütze dich auf deine Unterarme, die sich parallel zueinander unter deinen Schultern befinden. Du befindest dich auf den Zehenspitzen und deine Beine sind gerade in Hüftbreite nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Hebe ein Bein vom Boden ab und hebe die Hüfte Richtung Decke, bis dein Körper ein umgedrehtes \"V\" ergibt. Komme zurück in die Ausgangsposition. Wechsle das angehobene Bein bei jeder Wiederholung.",
      "Stütze dich auf deine Unterarme, die sich parallel zueinander unter deinen Schultern befinden. Du befindest dich auf den Zehenspitzen und deine Beine sind gerade in Hüftbreite nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Hebe die Hüfte zunächst in Richtung Decke, bis dein Körper ein umgedrehtes \"V\" ergibt. Führe nun einen Sprung mit seitwärts gespreizten Beinen aus und springe dann wieder mit den Beinen zur Mitte. Komme jetzt erst wieder zurück in die Ausgangsposition."
    ]
  ],
  /* record */[
    /* id */15,
    /* description : array */[
      "Lege dich gerade auf den Rücken, die Beine sind ausgestreckt. Platziere die Hände als Nackenstütze hinter dem Kopf. Hebe die Füße und winkle die Knie an, sodass sich dein Ober- und Unterschenkel in einem 90-Grad-Winkel zueinander befinden. Strecke ein Bein aus und ziehe das Knie des anderen Beines Richtung Brust. Probiere gleichzeitig mit dem gegenüberliegenden Ellenbogen dein Knie zu berühren, indem du eine Rotationsbewegung vom Ellenbogen hin zum Knie ausführst. Ziehe jetzt das ausgestreckte Bein Richtung Brust, strecke das andere Bein aus und führe eine Rotationsbewegung durch, sodass diesmal der Ellenbogen der anderen Seite das angezogene Knie berührt.",
      "Lege dich gerade auf den Rücken, die Beine sind ausgestreckt. Hebe die Füße und winkle die Knie an, sodass sich dein Ober- und Unterschenkel in einem 90-Grad-Winkel zueinander befinden. Strecke ein Bein aus und ziehe das Knie des anderen Beines Richtung Brust. Probiere gleichzeitig mit dem gegenüberliegenden Ellenbogen dein Knie zu berühren, indem du eine Rotationsbewegung vom Ellenbogen hin zum Knie ausführst. Wiederhole die Bewegung zur anderen Seite. Strecke danach die Hände vor dem Körper aus. Ziehe die Knie gleichzeitig so weit wie möglich Richtung Brust und umgreife sie mit deinen Armen. Strecke die Beine wieder aus, öffne die Arme und mache erneut eine Wiederholung.",
      "Lege dich gerade auf den Rücken, die Beine sind ausgestreckt. Platziere die Hände als Nackenstütze hinter dem Kopf. Hebe die Füße und winkle die Knie an, sodass sich dein Ober- und Unterschenkel in einem 90-Grad-Winkel zueinander befinden. Strecke ein Bein aus und ziehe das Knie des anderen Beines Richtung Brust. Probiere gleichzeitig mit dem gegenüberliegenden Ellenbogen dein Knie zu berühren, indem du eine Rotationsbewegung vom Ellenbogen hin zum Knie ausführst. Wiederhole die Bewegung zur anderen Seite. Strecke danach die Hände vor dem Körper aus. Ziehe die Knie gleichzeitig so weit wie möglich Richtung Brust und umgreife sie mit deinen Armen. Strecke die Beine halb aus und ziehe sie erneut an. Strecke nun die Beine ganz aus und öffne die Arme."
    ]
  ],
  /* record */[
    /* id */16,
    /* description : array */[
      "Lege dich bäuchlings auf den Boden, strecke deine Arme nach vorne und deine Beine nach hinten aus. Erhebe deinen Oberkörper vom Boden. Bringe deine gestreckten Arme neben deinen Körper und wieder zurück nach vorne. Wiederhole die Bewegung.",
      "Lege dich bäuchlings auf den Boden, strecke deine Arme nach vorne und deine Beine nach hinten aus. Erhebe deinen Oberkörper und deine Beine. Bringe deine gestreckten Arme neben deinen Körper und wieder zurück nach vorne. Wiederhole die Bewegung.",
      "Lege dich bäuchlings auf den Boden, strecke deine Arme nach vorne und deine Beine nach hinten aus. Erhebe deinen Oberkörper und deine Beine. Bringe deine gestreckten Arme neben deinen Körper und wieder zurück nach vorne. Senke Oberkörper und Beine zum Boden und erhebe sie erneut. Bringe die Arme erneut neben deinen Körper."
    ]
  ],
  /* record */[
    /* id */17,
    /* description : array */[
      "Lege dich auf deine rechte Seite, deine Beine sind leicht angewinkelt und das linke Bein liegt auf dem rechten. Lege nun deinen rechten Unterarm auf dem Boden ab, sodass du dich in einem Seitstütz befindest. Greife mit dem linken (oberen) Arm unter deinem Oberkörper durch, dein Körper folgt der Bewegung. Bringe nun denselben Arm zurück nach oben, dein Körper folgt der Bewegung erneut. Dein Arm befindet sich nun senkrecht zum Boden. Wiederhole die Bewegung mit demselben Arm. Im nächsten Satz wechselst du die Seite.",
      "Lege dich auf deine rechte Seite, deine Beine sind gestreckt, deine Knie berühren nicht den Boden und das linke Bein liegt auf dem rechten. Lege nun deinen rechten Unterarm auf dem Boden ab, sodass du dich in einem Seitstütz befindest. Greife mit dem linken (oberen) Arm unter deinem Oberkörper durch, dein Körper folgt der Bewegung. Bringe nun denselben Arm zurück nach oben, dein Körper folgt der Bewegung erneut. Dein Arm befindet sich nun senkrecht zum Boden. Wiederhole die Bewegung mit demselben Arm. Im nächsten Satz wechselst du die Seite.",
      "Positioniere dich in der Liegestützposition auf beiden Händen und auf den Füßen. Greife mit dem linken Arm unter deinem Oberkörper durch, dein Körper folgt der Bewegung. Bringe nun denselben Arm zurück nach oben, dein Körper folgt der Bewegung erneut. Dein Arm befindet sich nun senkrecht zum Boden. Wiederhole die Bewegung mit demselben Arm. Im nächsten Satz wechselst du die Seite."
    ]
  ],
  /* record */[
    /* id */18,
    /* description : array */[
      "Positioniere die Hände auf dem Boden. Strecke ein Bein nach hinten aus und lasse das andere Bein folgen. Die Füße stehen nun auf den Fußspitzen und du bist in der Liegestützposition. Ziehe nun ein Knie nach vorne, stelle den Fuß des angezogenen Beines auf und lasse den anderen Fuß folgen. Drücke dich aus den Armen und Beinen nach oben und strecke die Hände über dem Kopf aus.",
      "Platziere beide Hände vor dir auf dem Boden. Springe mit den Füßen nach hinten in den Liegestützstand. Springe nun mit den Füßen zwischen deine Hände und dann soweit wie möglich nach oben.",
      "Platziere beide Hände vor dir auf dem Boden. Springe mit den Füßen nach hinten in den Liegestützstand. Lass nun die Hüfte Richtung Boden sinken und von der Hüfte aufwärts, Wirbel für Wirbel den Körper den Boden berühren. Schließlich berührt die Brust den Boden und deine Hände befinden sich in etwa auf Höhe des Rippenbogens. Von hier aus drückst du nun deinen Oberkörper nach oben und lässt nach der Brust, Wirbel für Wirbel den Rest des Körpers in einer schlängelnden Bewegung folgen. Springe nun mit den Füßen zwischen deine Hände und dann soweit wie möglich nach oben."
    ]
  ],
  /* record */[
    /* id */19,
    /* description : array */[
      "Stelle dich in etwa hüftbreit hin und die Füße in einer Außenrotation ca. 30-45 Grad nach außen auf. Halte deine Arme vor oder neben deinem Körper. Schiebe deine Hüfte nach hinten. Knicke in den Knien ein. Schiebe die Knie nach außen und lasse das Gesäß nach unten und hinten wandern. Drück dich nun wieder nach oben und führe die Hüfte zurück nach vorne.",
      "Stelle dich in etwa hüftbreit hin und die Füße in einer Außenrotation ca. 30-45 Grad nach außen auf. Halte deine Arme vor oder neben deinem Körper. Schiebe deine Hüfte nach hinten. Knicke in den Knien ein. Schiebe die Knie nach außen und lasse das Gesäß nach unten und hinten wandern. Nachdem du den untersten Punkt erreicht hast, richtest du dich mit einem Sprung wieder auf.",
      "Stelle dich in etwa hüftbreit hin und die Füße in einer Außenrotation ca. 30-45 Grad nach außen auf. Halte deine Arme vor oder neben deinem Körper. Schiebe deine Hüfte nach hinten. Knicke in den Knien ein. Schiebe die Knie nach außen und lasse das Gesäß nach unten und hinten wandern. Leite am untersten Punkt die Aufwärtsbewegung ein, allerdings nicht bis zum aufrechten Stand, sondern so, dass deine Beine noch leicht gebeugt sind. Gehe dann erneut in die tiefste Position. Springe nun zurück in einen aufrechten Stand."
    ]
  ],
  /* record */[
    /* id */20,
    /* description : array */[
      "Stelle dich hüftbreit hin und halte deine Arme locker neben deinem Körper. Mache mit deinem rechten Bein einen großen Schritt nach diagonal vorne, also so, dass deine Beine nicht auf einer Linie sind, sondern das rechte Bein versetzt zum linken steht. Beuge das rechte Knie soweit, bis sich dein linkes Knie kurz vor dem Boden befindet. Drücke dich aus dem rechten Bein nach oben zurück in die Ausgangsposition und wiederhole die Bewegung mit dem anderen Bein.",
      "Stelle dich hüftbreit hin und halte deine Arme locker neben deinem Körper. Mache mit deinem rechten Bein einen großen Schritt nach diagonal vorne, also so, dass deine Beine nicht auf einer Linie sind, sondern das rechte Bein versetzt zum linken steht. Beuge das rechte Knie soweit, bis sich dein linkes Knie kurz vor dem Boden befindet. Drücke dich nun mit dem rechten Bein nach oben, allerdings so, dass das Bein noch leicht gebeugt ist und behalte die Fußposition bei. Beuge nun erneut das Knie des rechten Beines und komme so in die tiefste Position. Drücke dich erst jetzt zurück in die Ausgangsposition und wiederhole die Bewegung mit dem anderen Bein.",
      "Stelle dich hüftbreit hin und halte deine Arme locker neben deinem Körper. Mache mit deinem rechten Bein einen großen Schritt nach diagonal vorne, also so, dass deine Beine nicht auf einer Linie sind, sondern das rechte Bein versetzt zum linken steht. Beuge das rechte Knie soweit, bis sich dein linkes Knie kurz vor dem Boden befindet. Drücke dich in der tiefsten Position aus dem rechten Bein nach oben. Bevor du dein linkes Bein wieder neben dem rechten platzierst, ziehst du dein linkes Knie zur Brust. Erst dann stellst du dein Bein ab."
    ]
  ],
  /* record */[
    /* id */21,
    /* description : array */[
      "Lege dich auf den Rücken, deine Arme befinden sich neben deinem Körper, die Handflächen berühren den Boden. Hebe nun deine gestreckten Beine an, bis diese in einem 90-Grad-Winkel zu deinem Körper stehen. Hebe nun deine Hüfte vom Boden ab. Achte darauf, diese Bewegung kontrolliert und ohne Schwung durchzuführen. Lege deine Hüfte wieder ab.",
      "Lege dich auf den Rücken, deine Arme befinden sich neben deinem Körper, die Handflächen berühren den Boden. Hebe nun deine gestreckten Beine an, bis diese in einem 90-Grad-Winkel zu deinem Körper stehen. Hebe nun deine Hüfte vom Boden ab. Achte darauf, diese Bewegung kontrolliert und ohne Schwung durchzuführen. Bevor du die Hüfte ablegst, bewege sie wieder erneut nach oben und lege sie dann ab.",
      "Lege dich auf den Rücken, deine Arme befinden sich neben deinem Körper, die Handflächen berühren den Boden. Bringe dann deine Beine Richtung Boden. Hebe nun deine gestreckten Beine an, bis diese in einem 90-Grad-Winkel zu deinem Körper stehen. Hebe nun deine Hüfte vom Boden ab. Achte darauf, diese Bewegung kontrolliert und ohne Schwung durchzuführen. Lege die Beine jedoch nicht ab, sondern bringe sie kurz vor dem Boden erneut nach oben. Mache nun wieder einen Hüftstoß."
    ]
  ],
  /* record */[
    /* id */22,
    /* description : array */[
      "Du stehst hüftbreit. Mache einen großen Schritt nach vorne und beuge das vordere Bein, sodass die Wade und der Oberschenkel dieses Beines einen 90-Grad-Winkel ergeben. Halte den Oberkörper dabei aufrecht. Springe explosiv nach oben. Tausche in der Luft die Position deiner Beine und gehe nach der Landung auf dem Boden erneut in einen Ausfallschritt, nun befindet sich allerdings das andere Bein vorne. Springe erneut ab.",
      "Du stehst hüftbreit. Mache einen großen Schritt nach vorne und beuge das vordere Bein, sodass die Wade und der Oberschenkel dieses Beines einen 90-Grad-Winkel ergeben. Halte den Oberkörper dabei aufrecht. Springe explosiv nach oben. Tausche in der Luft die Position deiner Beine und gehe nach der Landung auf dem Boden erneut in einen Ausfallschritt, nun befindet sich allerdings das andere Bein vorne. Bevor du nun erneut abspringst, streckst du deine Beine aus und senkst sie daran anschließend wieder, sodass du dich nun erneut in einem Ausfallschritt befindest. Erst dann springst du ab und wiederholst die Ausführung mit dem anderen Bein vorne.",
      "Du stehst hüftbreit. Mache einen großen Schritt nach vorne und beuge das vordere Bein, sodass die Wade und der Oberschenkel dieses Beines einen 90-Grad-Winkel ergeben. Halte den Oberkörper dabei aufrecht. Du befindest dich in einem Ausfallschritt, dein rechtes Bein ist vorne. Springe nach oben und positioniere die Füße bei der Landung nebeneinander etwas breiter als hüftbreit auf dem Boden. Gehe in eine Kniebeuge. Beuge dafür deine Beine im Kniegelenk und schiebe dein Gesäß nach hinten. Gehe so weit nach unten, wie es dir möglich ist. Springe nun wieder nach oben und bringe das linke Bein nach vorne. Gehe in einen Ausfallschritt und springe erneut ab."
    ]
  ],
  /* record */[
    /* id */23,
    /* description : array */[
      "Stelle dich aufrecht hin, die Füße zeigen nach vorne. Beuge deinen Oberkörper mit geradem Rücken nach vorne. Dein Oberkörper befindet sich nun parallel zum Boden. Hebe gleichzeitig dein linkes Bein nach hinten oben an. Strecke beide Arme nach unten. Kehre zurück in die Ausgangsposition und wiederhole die Bewegung mit der anderen Seite.",
      "Stelle dich aufrecht hin, die Füße zeigen nach vorne. Beuge deinen Oberkörper mit geradem Rücken nach vorne. Dein Oberkörper befindet sich nun parallel zum Boden. Hebe gleichzeitig dein linkes Bein nach hinten oben an. Strecke beide Arme nach unten. Richte nun deinen Körper auf und ziehe das Knie des linken hinteren Beines zur Brust. Stelle es dann auf den Boden und wiederhole die Bewegung mit der anderen Seite.",
      "Stelle dich aufrecht hin, die Füße zeigen nach vorne. Beuge deinen Oberkörper mit geradem Rücken nach vorne. Dein Oberkörper befindet sich nun parallel zum Boden. Hebe gleichzeitig dein linkes Bein nach hinten oben an. Strecke beide Arme nach unten. Richte nun deinen Körper auf und mache mit dem hinteren Bein einen Schritt nach vorne. Beuge dein Knie, Ober- und Unterschenkel befindet sich in einem 90-Grad-Winkel. Deine Arme sind neben dem Körper. Drücke dich zurück in den Stand und wiederhole die Übung mit dem anderen Bein."
    ]
  ],
  /* record */[
    /* id */24,
    /* description : array */[
      "Gehe in den Vierfüßlerstand und stütze dich dabei auf deine Hände. Hebe dein rechtes Bein zur rechten Seite an, ohne es dabei auszustrecken. Dein Ober- und Unterschenkel befinden sich also immer in einem 90-Grad-Winkel zueinander. Halte das Bein kurz auf Hüfthöhe und senke es ab. Wiederhole die Bewegung mit dem linken Bein.",
      "Gehe in den Vierfüßlerstand und stütze dich dabei auf deine Hände. Dein Ober- und Unterschenkel befinden sich also immer in einem 90-Grad-Winkel zueinander. Hebe dein rechtes Bein zur rechten Seite an, ohne es dabei auszustrecken. Gleichzeitig mit deinem rechten Bein streckst du deinen linken Arm nach vorne aus, sodass er sich in einer Linie mit deinem Oberkörper befindet. Wiederhole die Ausführung mit deinem linken Bein und rechten Arm.",
      "Gehe in den Vierfüßlerstand und stütze dich dabei auf deine Hände. Dein Ober- und Unterschenkel befinden sich also immer in einem 90-Grad-Winkel zueinander. Hebe dein rechtes Bein zur rechten Seite an, ohne es dabei auszustrecken. Gleichzeitig mit deinem rechten Bein streckst du deinen rechten Arm nach vorne aus, sodass er sich in einer Linie mit deinem Oberkörper befindet. Wiederhole die Ausführung mit deinem linken Bein und linken Arm."
    ]
  ],
  /* record */[
    /* id */25,
    /* description : array */[
      "Lege dich auf den Rücken und verschränke die Arme als Nackenstütze hinter dem Kopf. Platziere die Fersen auf dem Boden und ziehe die Knie an. Rotiere jetzt in einer kreisförmigen Bewegung: erst mit dem linken Ellenbogen in die Richtung des rechten Knies, dann weiter zum linken Knie und zurück in die Ausgangsposition. Wiederhole nun die Bewegung in die andere Richtung.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */26,
    /* description : array */[
      "Lege dich auf den Rücken, deine Arme liegen neben deinem Körper. Hebe nun ein Bein an, bis es senkrecht zu deinem Körper steht. Das Bein ist dabei minimal angewinkelt, das andere Bein liegt auf der Matte. Senke das Bein bis kurz vor dem Boden und beginne dann die gleiche Bewegung mit dem anderen Bein.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */27,
    /* description : array */[
      "Lege dich auf den Rücken und führe deine Fußsohlen zusammen, deine Knie zeigen dabei nach außen. Ziehe den Bauch ein. Strecke deine Arme in die Richtung deiner Füße. Komme mit deinem Oberkörper nach oben und berühre bei jeder Bewegung mit deinen Händen die Füße. Senke den Oberkörper ab, indem du Wirbel für Wirbel abrollst und so in die Ausgangsposition zurückkehrst.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */28,
    /* description : array */[
      "Setze dich auf dein Gesäß und platziere die Fersen vor dir. Strecke die Hände vor dem Körper aus. Hebe die Beine vom Boden ab und lehne deinen Oberkörper nach hinten, halte dabei die Balance. Führe deinen Oberkörper gleichzeitig mit deinen Beinen nach oben. Lehne dich wieder zurück, bis du dich erneut in der Startposition befindest.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */29,
    /* description : array */[
      "Lege dich auf den Rücken, deine Beine befinden sich auf einer Erhöhung oder sind gegen die Wand gepresst. Deine Arme streckst du senkrecht zu deinem Körper nach oben, die Handflächen berühren sich. Löse die Schulterblätter explosiv vom Boden und wandere mit der linken Schulter in die Richtung deines rechten Knies. Senke den Oberkörper nun wieder ab und wiederhole die Bewegung auf die andere Seite.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */30,
    /* description : array */[
      "Lege dich bäuchlings auf den Boden und stütze dich auf deine Unterarme, die sich parallel zueinander unter deinen Schultern befinden. Deine Beine sind gerade in Hüftbreite nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Bringe die Beine nun im Sprung abwechselnd nach außen und wieder nach innen.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */31,
    /* description : array */[
      "Stelle dich an eine Wand, versetze deinen Oberkörper unter Spannung und beuge deine Beine im Kniegelenk, bis deine Waden und Oberschenkelrückseiten ungefähr einen 90-Grad-Winkel zueinander ergeben. Lehne dich mit dem Rücken vollständig gegen die Wand und halte die Position.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */32,
    /* description : array */[
      "Halte dich an der Wand oder einem stabilen Gegenstand fest. Strecke das Bein, das sich an der Seite der Wand befindet, nach vorne. Beuge nun das andere Bein und neige den Oberkörper nach vorne, der Oberschenkel befindet sich nun parallel zum Boden. Drücke dich aus dem Standbein nach oben und wiederhole die Bewegung. Wechsle im nächsten Intervall das Standbein.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */33,
    /* description : array */[
      "Stelle dich schulterbreit hin, deine Hände sind hinter deinem Kopf, die Ellenbogen gehen nach außen. Gehe leicht in die Knie. Schiebe deine Hüfte nach hinten, sodass du eine Dehnung in den hinteren Oberschenkeln spürst. Bringe deinen Oberkörper gleichzeitig nach vorne, bis deine Brust parallel zum Boden ist. Stelle dich wieder aufrecht hin und wiederhole die Bewegung.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */34,
    /* description : array */[
      "Stelle dich aufrecht hin. Mache einen Schritt nach links. Beuge dein linkes Knie, der Oberkörper kommt leicht nach vorne. Drücke dich aus dem gebeugten Bein nach oben, bis du wieder stehst. Wiederhole die Übung in die andere Richtung.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */35,
    /* description : array */[
      "Stelle dich schulterbreit hin. Hebe das rechte Bein auf 45 Grad zur rechten Seite an. Die Zehenspitzen sind angezogen. Halte die Position für wenige Sekunden und bringe das Bein zurück in die Ausgangsposition, setze es allerdings noch nicht ab. Führe nun deine rechte Ferse zum Gesäß, indem du dein Knie beugst. Halte diese Position ebenfalls für wenige Sekunden und setze das Bein dann ab. Wechsle nun das Bein.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */36,
    /* description : array */[
      "Stelle dich aufrecht hin und beuge deinen Unterschenkel nach oben, er ist nun parallel zum Boden.\n        Schließe die Augen und halte das Gleichgewicht. Du kannst die Übung erschweren, indem du deinen Kopf in den Nacken legst oder eine weiche Unterlage verwendest.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */37,
    /* description : array */[
      "Begib dich mit schulterbreitem Stand in eine Kniebeugeposition, während dein Körper aufrecht bleibt. Deine Arme befinden sich vor deinem Körper. Bewege dein rechtes Knie nach vorne zum Boden und verlagere dein Körpergewicht auf das andere Bein. Wechsle die Seite und bewege dann immer abwechselnd die Knie zum Boden und zurück. Halte dabei deinen Oberkörper so aufrecht wie möglich und bewege ausschließlich deine Beine bzw. Hüfte.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */38,
    /* description : array */[
      "Lege eine Matte vor eine freie Wand oder ein Sofa. Du befindest dich mit dem Rücken zur Wand/zum Sofa. Stelle ein Bein nach vorne auf, während das hintere Bein komplett gebeugt an der Wand bzw. dem Sofa steht und du eine Dehnung in deiner Oberschenkelvorderseite merkst. Das Kniegelenk des vorderen Beins ist ca. 90 Grad gebeugt, das hintere Bein liegt ca. 20-30 cm von der Wand entfernt auf dem Knie. Der Oberkörper ist dabei gerade, du kannst dich auf dem vorderen Bein etwas abstützen. In der Position hältst du die Spannung und solltest eine Dehnung im Oberschenkel bis hin zur Hüfte merken. Die Hüfte kannst du gelegentlich nach vorne bewegen und dein Gesäß anspannen, um eine stärkere Dehnung zu spüren.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */39,
    /* description : array */[
      "Stelle dich hüftbreit mit dem Blick zu einer Wand. Lege deine Handflächen auf Schulterhöhe an der Wand ab, die Fingerspitzen zeigen nach außen. Löse nun den rechten Arm von der Wand, strecke ihn seitlich auf Schulterhöhe neben dir aus und rotiere deinen kompletten Körper nach rechts. Dein Blick folgt dabei deinem Arm.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */40,
    /* description : array */[
      "Begib dich mit schulterbreitem Stand in eine Kniebeugeposition, während dein Körper aufrecht bleibt und sich deine Arme vor deinem Körper befinden. Greife mit deiner linken Hand deinen linken Fuß, um dich dort zu stabilisieren. Drehe nun deinen Oberkörper mit deiner gestreckten rechten Hand seitlich auf, der Oberkörper und Kopf folgen dem Arm. Atme bei der seitlichen Aufdrehung aus, bleibe dabei aufrecht mit geradem Rücken und drehe danach langsam zurück in die Ausgangsposition, um die Seite zu wechseln.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */41,
    /* description : array */[
      "Stelle dich gerade vor eine freie Wand und lege beide Hände mit den gesamten Handflächen schulterbreit an die Wand. Die Arme sind dabei parallel zum Boden und komplett gestreckt. Beuge nun deinen Körper und führe eine Kniebeuge aus. In der Bewegung bleiben beide Hände an der gleichen Position und die Arme bleiben dauerhaft gestreckt. Beuge dich so weit du kannst nach unten, bis die Hände in einer Linie mit deinem geraden Rücken sind und atme ein. Bewege deinen Körper wieder zurück in die Ausgangsposition und atme dabei aus.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */42,
    /* description : array */[
      "Lege dich seitlich auf eine Matte und winkle die Beine leicht an. Lege die Arme gestreckt vor dem Körper ab. Drehe deinen Oberkörper nun so weit es geht mit gestrecktem Arm seitlich zur anderen Seite auf. Nur der Oberkörper bewegt sich, während die Beine weiterhin leicht gebeugt auf der Matte liegen. Atme bei der Drehung aus und atme bei der Bewegung zur Ausgangsposition ein. Wechsle nach 10 Wiederholungen die Seite.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */43,
    /* description : array */[
      "Stelle dich zunächst aufrecht hin. Hebe nun ein Bein nach hinten vom Boden ab und leite so eine Abwärtsbewegung des Körpers nach vorne ein. Gleichzeitig streckst du deine Arme zur Seite aus. Körper, Bein und Arme sind nun auf einer Linie parallel zum Boden. Halte diese Position.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */44,
    /* description : array */[
      "Nimm eine Liegestützposition ein, deine Hände befinden sich unter der Brust. Der Rücken ist gerade. Dein Gewicht wird nun auf einen Arm verlagert, den anderen Arm streckst du senkrecht zum Boden nach oben. Dein Blick folgt der Hand und dein kompletter Körper routiert in die Richtung dieses Armes.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */45,
    /* description : array */[
      "Nimm eine Liegestützposition ein, deine Beine sind leicht gegrätscht, deine Hände befinden sich unter den Schultern. Entferne dein rechtes Bein wenige Zentimeter vom Boden, lass deine Zehen dabei angezogen. Führe deinen rechten Fuß in die Richtung des linken Fußes und anschließend wieder zurück. Führe dasselbe Bein nach oben und wieder zurück nach unten. Wiederhole die Bewegung.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */46,
    /* description : array */[
      "Nimm einen Seitstütz ein, deine Ellenbogen befinden sich unter den Schultern. Deine Beine sind gerade in Hüftbreite nach hinten ausgestreckt. Schiebe nun deinen Körper nach hinten. Indem du deine Zehen durchstreckst, schiebst du deinen Körper dann zurück nach vorne.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */47,
    /* description : array */[
      "Nimm einen Unterarmstütz ein. Du befindest dich hierfür auf den Unterarmen und Zehenspitzen. Deine Beine sind in Hüftbreite nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Halte diese Position.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */48,
    /* description : array */[
      "Lege dich seitlich auf den Boden. Stütze dich auf deinen Unterarm, sodass deine Hand nach vorne in Blickrichtung zeigt und sich dein Ellenbogen unter deiner Schulter befindet. Die Beine liegen parallel aufeinander und deine Zehen zeigen in Blickrichtung. Atme ein und drücke deinen Körper beim Ausatmen seitlich nach oben. Halte die Position für ein paar Sekunden und lasse deinen Körper beim Einatmen wieder herabsinken, ohne ihn vollständig auf dem Boden abzulegen. Im nächsten Intervall ist die andere Seite oben.",
      "",
      ""
    ]
  ]
];

exports.workoutLevels = workoutLevels;
exports.exercises = exercises;
exports.workoutMatrix = workoutMatrix;
exports.workoutsStatus = workoutsStatus;
exports.getWorkoutTitles = getWorkoutTitles;
exports.getWorkoutIds = getWorkoutIds;
exports.workoutReps = workoutReps;
exports.completedArray = completedArray;
exports.bonusDone = bonusDone;
exports.knowledgeRead = knowledgeRead;
exports.knowledgeEntries = knowledgeEntries;
exports.exerciseImagesCount = exerciseImagesCount;
exports.exerciseDescriptions = exerciseDescriptions;
/* No side effect */


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Curry = __webpack_require__(0);
var Caml_obj = __webpack_require__(15);
var Pervasives = __webpack_require__(21);
var Caml_builtin_exceptions = __webpack_require__(3);

function length(l) {
  var _len = 0;
  var _param = l;
  while(true) {
    var param = _param;
    var len = _len;
    if (param) {
      _param = param[1];
      _len = len + 1 | 0;
      continue ;
      
    } else {
      return len;
    }
  };
}

function hd(param) {
  if (param) {
    return param[0];
  } else {
    throw [
          Caml_builtin_exceptions.failure,
          "hd"
        ];
  }
}

function tl(param) {
  if (param) {
    return param[1];
  } else {
    throw [
          Caml_builtin_exceptions.failure,
          "tl"
        ];
  }
}

function nth(l, n) {
  if (n < 0) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "List.nth"
        ];
  } else {
    var _l = l;
    var _n = n;
    while(true) {
      var n$1 = _n;
      var l$1 = _l;
      if (l$1) {
        if (n$1 === 0) {
          return l$1[0];
        } else {
          _n = n$1 - 1 | 0;
          _l = l$1[1];
          continue ;
          
        }
      } else {
        throw [
              Caml_builtin_exceptions.failure,
              "nth"
            ];
      }
    };
  }
}

function rev_append(_l1, _l2) {
  while(true) {
    var l2 = _l2;
    var l1 = _l1;
    if (l1) {
      _l2 = /* :: */[
        l1[0],
        l2
      ];
      _l1 = l1[1];
      continue ;
      
    } else {
      return l2;
    }
  };
}

function rev(l) {
  return rev_append(l, /* [] */0);
}

function flatten(param) {
  if (param) {
    return Pervasives.$at(param[0], flatten(param[1]));
  } else {
    return /* [] */0;
  }
}

function map(f, param) {
  if (param) {
    var r = Curry._1(f, param[0]);
    return /* :: */[
            r,
            map(f, param[1])
          ];
  } else {
    return /* [] */0;
  }
}

function mapi(i, f, param) {
  if (param) {
    var r = Curry._2(f, i, param[0]);
    return /* :: */[
            r,
            mapi(i + 1 | 0, f, param[1])
          ];
  } else {
    return /* [] */0;
  }
}

function mapi$1(f, l) {
  return mapi(0, f, l);
}

function rev_map(f, l) {
  var _accu = /* [] */0;
  var _param = l;
  while(true) {
    var param = _param;
    var accu = _accu;
    if (param) {
      _param = param[1];
      _accu = /* :: */[
        Curry._1(f, param[0]),
        accu
      ];
      continue ;
      
    } else {
      return accu;
    }
  };
}

function iter(f, _param) {
  while(true) {
    var param = _param;
    if (param) {
      Curry._1(f, param[0]);
      _param = param[1];
      continue ;
      
    } else {
      return /* () */0;
    }
  };
}

function iteri(f, l) {
  var _i = 0;
  var f$1 = f;
  var _param = l;
  while(true) {
    var param = _param;
    var i = _i;
    if (param) {
      Curry._2(f$1, i, param[0]);
      _param = param[1];
      _i = i + 1 | 0;
      continue ;
      
    } else {
      return /* () */0;
    }
  };
}

function fold_left(f, _accu, _l) {
  while(true) {
    var l = _l;
    var accu = _accu;
    if (l) {
      _l = l[1];
      _accu = Curry._2(f, accu, l[0]);
      continue ;
      
    } else {
      return accu;
    }
  };
}

function fold_right(f, l, accu) {
  if (l) {
    return Curry._2(f, l[0], fold_right(f, l[1], accu));
  } else {
    return accu;
  }
}

function map2(f, l1, l2) {
  if (l1) {
    if (l2) {
      var r = Curry._2(f, l1[0], l2[0]);
      return /* :: */[
              r,
              map2(f, l1[1], l2[1])
            ];
    } else {
      throw [
            Caml_builtin_exceptions.invalid_argument,
            "List.map2"
          ];
    }
  } else if (l2) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "List.map2"
        ];
  } else {
    return /* [] */0;
  }
}

function rev_map2(f, l1, l2) {
  var _accu = /* [] */0;
  var _l1 = l1;
  var _l2 = l2;
  while(true) {
    var l2$1 = _l2;
    var l1$1 = _l1;
    var accu = _accu;
    if (l1$1) {
      if (l2$1) {
        _l2 = l2$1[1];
        _l1 = l1$1[1];
        _accu = /* :: */[
          Curry._2(f, l1$1[0], l2$1[0]),
          accu
        ];
        continue ;
        
      } else {
        throw [
              Caml_builtin_exceptions.invalid_argument,
              "List.rev_map2"
            ];
      }
    } else if (l2$1) {
      throw [
            Caml_builtin_exceptions.invalid_argument,
            "List.rev_map2"
          ];
    } else {
      return accu;
    }
  };
}

function iter2(f, _l1, _l2) {
  while(true) {
    var l2 = _l2;
    var l1 = _l1;
    if (l1) {
      if (l2) {
        Curry._2(f, l1[0], l2[0]);
        _l2 = l2[1];
        _l1 = l1[1];
        continue ;
        
      } else {
        throw [
              Caml_builtin_exceptions.invalid_argument,
              "List.iter2"
            ];
      }
    } else if (l2) {
      throw [
            Caml_builtin_exceptions.invalid_argument,
            "List.iter2"
          ];
    } else {
      return /* () */0;
    }
  };
}

function fold_left2(f, _accu, _l1, _l2) {
  while(true) {
    var l2 = _l2;
    var l1 = _l1;
    var accu = _accu;
    if (l1) {
      if (l2) {
        _l2 = l2[1];
        _l1 = l1[1];
        _accu = Curry._3(f, accu, l1[0], l2[0]);
        continue ;
        
      } else {
        throw [
              Caml_builtin_exceptions.invalid_argument,
              "List.fold_left2"
            ];
      }
    } else if (l2) {
      throw [
            Caml_builtin_exceptions.invalid_argument,
            "List.fold_left2"
          ];
    } else {
      return accu;
    }
  };
}

function fold_right2(f, l1, l2, accu) {
  if (l1) {
    if (l2) {
      return Curry._3(f, l1[0], l2[0], fold_right2(f, l1[1], l2[1], accu));
    } else {
      throw [
            Caml_builtin_exceptions.invalid_argument,
            "List.fold_right2"
          ];
    }
  } else if (l2) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "List.fold_right2"
        ];
  } else {
    return accu;
  }
}

function for_all(p, _param) {
  while(true) {
    var param = _param;
    if (param) {
      if (Curry._1(p, param[0])) {
        _param = param[1];
        continue ;
        
      } else {
        return /* false */0;
      }
    } else {
      return /* true */1;
    }
  };
}

function exists(p, _param) {
  while(true) {
    var param = _param;
    if (param) {
      if (Curry._1(p, param[0])) {
        return /* true */1;
      } else {
        _param = param[1];
        continue ;
        
      }
    } else {
      return /* false */0;
    }
  };
}

function for_all2(p, _l1, _l2) {
  while(true) {
    var l2 = _l2;
    var l1 = _l1;
    if (l1) {
      if (l2) {
        if (Curry._2(p, l1[0], l2[0])) {
          _l2 = l2[1];
          _l1 = l1[1];
          continue ;
          
        } else {
          return /* false */0;
        }
      } else {
        throw [
              Caml_builtin_exceptions.invalid_argument,
              "List.for_all2"
            ];
      }
    } else if (l2) {
      throw [
            Caml_builtin_exceptions.invalid_argument,
            "List.for_all2"
          ];
    } else {
      return /* true */1;
    }
  };
}

function exists2(p, _l1, _l2) {
  while(true) {
    var l2 = _l2;
    var l1 = _l1;
    if (l1) {
      if (l2) {
        if (Curry._2(p, l1[0], l2[0])) {
          return /* true */1;
        } else {
          _l2 = l2[1];
          _l1 = l1[1];
          continue ;
          
        }
      } else {
        throw [
              Caml_builtin_exceptions.invalid_argument,
              "List.exists2"
            ];
      }
    } else if (l2) {
      throw [
            Caml_builtin_exceptions.invalid_argument,
            "List.exists2"
          ];
    } else {
      return /* false */0;
    }
  };
}

function mem(x, _param) {
  while(true) {
    var param = _param;
    if (param) {
      if (Caml_obj.caml_equal(param[0], x)) {
        return /* true */1;
      } else {
        _param = param[1];
        continue ;
        
      }
    } else {
      return /* false */0;
    }
  };
}

function memq(x, _param) {
  while(true) {
    var param = _param;
    if (param) {
      if (param[0] === x) {
        return /* true */1;
      } else {
        _param = param[1];
        continue ;
        
      }
    } else {
      return /* false */0;
    }
  };
}

function assoc(x, _param) {
  while(true) {
    var param = _param;
    if (param) {
      var match = param[0];
      if (Caml_obj.caml_equal(match[0], x)) {
        return match[1];
      } else {
        _param = param[1];
        continue ;
        
      }
    } else {
      throw Caml_builtin_exceptions.not_found;
    }
  };
}

function assq(x, _param) {
  while(true) {
    var param = _param;
    if (param) {
      var match = param[0];
      if (match[0] === x) {
        return match[1];
      } else {
        _param = param[1];
        continue ;
        
      }
    } else {
      throw Caml_builtin_exceptions.not_found;
    }
  };
}

function mem_assoc(x, _param) {
  while(true) {
    var param = _param;
    if (param) {
      if (Caml_obj.caml_equal(param[0][0], x)) {
        return /* true */1;
      } else {
        _param = param[1];
        continue ;
        
      }
    } else {
      return /* false */0;
    }
  };
}

function mem_assq(x, _param) {
  while(true) {
    var param = _param;
    if (param) {
      if (param[0][0] === x) {
        return /* true */1;
      } else {
        _param = param[1];
        continue ;
        
      }
    } else {
      return /* false */0;
    }
  };
}

function remove_assoc(x, param) {
  if (param) {
    var l = param[1];
    var pair = param[0];
    if (Caml_obj.caml_equal(pair[0], x)) {
      return l;
    } else {
      return /* :: */[
              pair,
              remove_assoc(x, l)
            ];
    }
  } else {
    return /* [] */0;
  }
}

function remove_assq(x, param) {
  if (param) {
    var l = param[1];
    var pair = param[0];
    if (pair[0] === x) {
      return l;
    } else {
      return /* :: */[
              pair,
              remove_assq(x, l)
            ];
    }
  } else {
    return /* [] */0;
  }
}

function find(p, _param) {
  while(true) {
    var param = _param;
    if (param) {
      var x = param[0];
      if (Curry._1(p, x)) {
        return x;
      } else {
        _param = param[1];
        continue ;
        
      }
    } else {
      throw Caml_builtin_exceptions.not_found;
    }
  };
}

function find_all(p) {
  return (function (param) {
      var _accu = /* [] */0;
      var _param = param;
      while(true) {
        var param$1 = _param;
        var accu = _accu;
        if (param$1) {
          var l = param$1[1];
          var x = param$1[0];
          if (Curry._1(p, x)) {
            _param = l;
            _accu = /* :: */[
              x,
              accu
            ];
            continue ;
            
          } else {
            _param = l;
            continue ;
            
          }
        } else {
          return rev_append(accu, /* [] */0);
        }
      };
    });
}

function partition(p, l) {
  var _yes = /* [] */0;
  var _no = /* [] */0;
  var _param = l;
  while(true) {
    var param = _param;
    var no = _no;
    var yes = _yes;
    if (param) {
      var l$1 = param[1];
      var x = param[0];
      if (Curry._1(p, x)) {
        _param = l$1;
        _yes = /* :: */[
          x,
          yes
        ];
        continue ;
        
      } else {
        _param = l$1;
        _no = /* :: */[
          x,
          no
        ];
        continue ;
        
      }
    } else {
      return /* tuple */[
              rev_append(yes, /* [] */0),
              rev_append(no, /* [] */0)
            ];
    }
  };
}

function split(param) {
  if (param) {
    var match = param[0];
    var match$1 = split(param[1]);
    return /* tuple */[
            /* :: */[
              match[0],
              match$1[0]
            ],
            /* :: */[
              match[1],
              match$1[1]
            ]
          ];
  } else {
    return /* tuple */[
            /* [] */0,
            /* [] */0
          ];
  }
}

function combine(l1, l2) {
  if (l1) {
    if (l2) {
      return /* :: */[
              /* tuple */[
                l1[0],
                l2[0]
              ],
              combine(l1[1], l2[1])
            ];
    } else {
      throw [
            Caml_builtin_exceptions.invalid_argument,
            "List.combine"
          ];
    }
  } else if (l2) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "List.combine"
        ];
  } else {
    return /* [] */0;
  }
}

function merge(cmp, l1, l2) {
  if (l1) {
    if (l2) {
      var h2 = l2[0];
      var h1 = l1[0];
      if (Curry._2(cmp, h1, h2) <= 0) {
        return /* :: */[
                h1,
                merge(cmp, l1[1], l2)
              ];
      } else {
        return /* :: */[
                h2,
                merge(cmp, l1, l2[1])
              ];
      }
    } else {
      return l1;
    }
  } else {
    return l2;
  }
}

function chop(_k, _l) {
  while(true) {
    var l = _l;
    var k = _k;
    if (k === 0) {
      return l;
    } else if (l) {
      _l = l[1];
      _k = k - 1 | 0;
      continue ;
      
    } else {
      throw [
            Caml_builtin_exceptions.assert_failure,
            [
              "list.ml",
              223,
              11
            ]
          ];
    }
  };
}

function stable_sort(cmp, l) {
  var sort = function (n, l) {
    var exit = 0;
    if (n !== 2) {
      if (n !== 3 || !l) {
        exit = 1;
      } else {
        var match = l[1];
        if (match) {
          var match$1 = match[1];
          if (match$1) {
            var x3 = match$1[0];
            var x2 = match[0];
            var x1 = l[0];
            if (Curry._2(cmp, x1, x2) <= 0) {
              if (Curry._2(cmp, x2, x3) <= 0) {
                return /* :: */[
                        x1,
                        /* :: */[
                          x2,
                          /* :: */[
                            x3,
                            /* [] */0
                          ]
                        ]
                      ];
              } else if (Curry._2(cmp, x1, x3) <= 0) {
                return /* :: */[
                        x1,
                        /* :: */[
                          x3,
                          /* :: */[
                            x2,
                            /* [] */0
                          ]
                        ]
                      ];
              } else {
                return /* :: */[
                        x3,
                        /* :: */[
                          x1,
                          /* :: */[
                            x2,
                            /* [] */0
                          ]
                        ]
                      ];
              }
            } else if (Curry._2(cmp, x1, x3) <= 0) {
              return /* :: */[
                      x2,
                      /* :: */[
                        x1,
                        /* :: */[
                          x3,
                          /* [] */0
                        ]
                      ]
                    ];
            } else if (Curry._2(cmp, x2, x3) <= 0) {
              return /* :: */[
                      x2,
                      /* :: */[
                        x3,
                        /* :: */[
                          x1,
                          /* [] */0
                        ]
                      ]
                    ];
            } else {
              return /* :: */[
                      x3,
                      /* :: */[
                        x2,
                        /* :: */[
                          x1,
                          /* [] */0
                        ]
                      ]
                    ];
            }
          } else {
            exit = 1;
          }
        } else {
          exit = 1;
        }
      }
    } else if (l) {
      var match$2 = l[1];
      if (match$2) {
        var x2$1 = match$2[0];
        var x1$1 = l[0];
        if (Curry._2(cmp, x1$1, x2$1) <= 0) {
          return /* :: */[
                  x1$1,
                  /* :: */[
                    x2$1,
                    /* [] */0
                  ]
                ];
        } else {
          return /* :: */[
                  x2$1,
                  /* :: */[
                    x1$1,
                    /* [] */0
                  ]
                ];
        }
      } else {
        exit = 1;
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      var n1 = (n >> 1);
      var n2 = n - n1 | 0;
      var l2 = chop(n1, l);
      var s1 = rev_sort(n1, l);
      var s2 = rev_sort(n2, l2);
      var _l1 = s1;
      var _l2 = s2;
      var _accu = /* [] */0;
      while(true) {
        var accu = _accu;
        var l2$1 = _l2;
        var l1 = _l1;
        if (l1) {
          if (l2$1) {
            var h2 = l2$1[0];
            var h1 = l1[0];
            if (Curry._2(cmp, h1, h2) > 0) {
              _accu = /* :: */[
                h1,
                accu
              ];
              _l1 = l1[1];
              continue ;
              
            } else {
              _accu = /* :: */[
                h2,
                accu
              ];
              _l2 = l2$1[1];
              continue ;
              
            }
          } else {
            return rev_append(l1, accu);
          }
        } else {
          return rev_append(l2$1, accu);
        }
      };
    }
    
  };
  var rev_sort = function (n, l) {
    var exit = 0;
    if (n !== 2) {
      if (n !== 3 || !l) {
        exit = 1;
      } else {
        var match = l[1];
        if (match) {
          var match$1 = match[1];
          if (match$1) {
            var x3 = match$1[0];
            var x2 = match[0];
            var x1 = l[0];
            if (Curry._2(cmp, x1, x2) > 0) {
              if (Curry._2(cmp, x2, x3) > 0) {
                return /* :: */[
                        x1,
                        /* :: */[
                          x2,
                          /* :: */[
                            x3,
                            /* [] */0
                          ]
                        ]
                      ];
              } else if (Curry._2(cmp, x1, x3) > 0) {
                return /* :: */[
                        x1,
                        /* :: */[
                          x3,
                          /* :: */[
                            x2,
                            /* [] */0
                          ]
                        ]
                      ];
              } else {
                return /* :: */[
                        x3,
                        /* :: */[
                          x1,
                          /* :: */[
                            x2,
                            /* [] */0
                          ]
                        ]
                      ];
              }
            } else if (Curry._2(cmp, x1, x3) > 0) {
              return /* :: */[
                      x2,
                      /* :: */[
                        x1,
                        /* :: */[
                          x3,
                          /* [] */0
                        ]
                      ]
                    ];
            } else if (Curry._2(cmp, x2, x3) > 0) {
              return /* :: */[
                      x2,
                      /* :: */[
                        x3,
                        /* :: */[
                          x1,
                          /* [] */0
                        ]
                      ]
                    ];
            } else {
              return /* :: */[
                      x3,
                      /* :: */[
                        x2,
                        /* :: */[
                          x1,
                          /* [] */0
                        ]
                      ]
                    ];
            }
          } else {
            exit = 1;
          }
        } else {
          exit = 1;
        }
      }
    } else if (l) {
      var match$2 = l[1];
      if (match$2) {
        var x2$1 = match$2[0];
        var x1$1 = l[0];
        if (Curry._2(cmp, x1$1, x2$1) > 0) {
          return /* :: */[
                  x1$1,
                  /* :: */[
                    x2$1,
                    /* [] */0
                  ]
                ];
        } else {
          return /* :: */[
                  x2$1,
                  /* :: */[
                    x1$1,
                    /* [] */0
                  ]
                ];
        }
      } else {
        exit = 1;
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      var n1 = (n >> 1);
      var n2 = n - n1 | 0;
      var l2 = chop(n1, l);
      var s1 = sort(n1, l);
      var s2 = sort(n2, l2);
      var _l1 = s1;
      var _l2 = s2;
      var _accu = /* [] */0;
      while(true) {
        var accu = _accu;
        var l2$1 = _l2;
        var l1 = _l1;
        if (l1) {
          if (l2$1) {
            var h2 = l2$1[0];
            var h1 = l1[0];
            if (Curry._2(cmp, h1, h2) <= 0) {
              _accu = /* :: */[
                h1,
                accu
              ];
              _l1 = l1[1];
              continue ;
              
            } else {
              _accu = /* :: */[
                h2,
                accu
              ];
              _l2 = l2$1[1];
              continue ;
              
            }
          } else {
            return rev_append(l1, accu);
          }
        } else {
          return rev_append(l2$1, accu);
        }
      };
    }
    
  };
  var len = length(l);
  if (len < 2) {
    return l;
  } else {
    return sort(len, l);
  }
}

function sort_uniq(cmp, l) {
  var sort = function (n, l) {
    var exit = 0;
    if (n !== 2) {
      if (n !== 3 || !l) {
        exit = 1;
      } else {
        var match = l[1];
        if (match) {
          var match$1 = match[1];
          if (match$1) {
            var x3 = match$1[0];
            var x2 = match[0];
            var x1 = l[0];
            var c = Curry._2(cmp, x1, x2);
            if (c === 0) {
              var c$1 = Curry._2(cmp, x2, x3);
              if (c$1 === 0) {
                return /* :: */[
                        x2,
                        /* [] */0
                      ];
              } else if (c$1 < 0) {
                return /* :: */[
                        x2,
                        /* :: */[
                          x3,
                          /* [] */0
                        ]
                      ];
              } else {
                return /* :: */[
                        x3,
                        /* :: */[
                          x2,
                          /* [] */0
                        ]
                      ];
              }
            } else if (c < 0) {
              var c$2 = Curry._2(cmp, x2, x3);
              if (c$2 === 0) {
                return /* :: */[
                        x1,
                        /* :: */[
                          x2,
                          /* [] */0
                        ]
                      ];
              } else if (c$2 < 0) {
                return /* :: */[
                        x1,
                        /* :: */[
                          x2,
                          /* :: */[
                            x3,
                            /* [] */0
                          ]
                        ]
                      ];
              } else {
                var c$3 = Curry._2(cmp, x1, x3);
                if (c$3 === 0) {
                  return /* :: */[
                          x1,
                          /* :: */[
                            x2,
                            /* [] */0
                          ]
                        ];
                } else if (c$3 < 0) {
                  return /* :: */[
                          x1,
                          /* :: */[
                            x3,
                            /* :: */[
                              x2,
                              /* [] */0
                            ]
                          ]
                        ];
                } else {
                  return /* :: */[
                          x3,
                          /* :: */[
                            x1,
                            /* :: */[
                              x2,
                              /* [] */0
                            ]
                          ]
                        ];
                }
              }
            } else {
              var c$4 = Curry._2(cmp, x1, x3);
              if (c$4 === 0) {
                return /* :: */[
                        x2,
                        /* :: */[
                          x1,
                          /* [] */0
                        ]
                      ];
              } else if (c$4 < 0) {
                return /* :: */[
                        x2,
                        /* :: */[
                          x1,
                          /* :: */[
                            x3,
                            /* [] */0
                          ]
                        ]
                      ];
              } else {
                var c$5 = Curry._2(cmp, x2, x3);
                if (c$5 === 0) {
                  return /* :: */[
                          x2,
                          /* :: */[
                            x1,
                            /* [] */0
                          ]
                        ];
                } else if (c$5 < 0) {
                  return /* :: */[
                          x2,
                          /* :: */[
                            x3,
                            /* :: */[
                              x1,
                              /* [] */0
                            ]
                          ]
                        ];
                } else {
                  return /* :: */[
                          x3,
                          /* :: */[
                            x2,
                            /* :: */[
                              x1,
                              /* [] */0
                            ]
                          ]
                        ];
                }
              }
            }
          } else {
            exit = 1;
          }
        } else {
          exit = 1;
        }
      }
    } else if (l) {
      var match$2 = l[1];
      if (match$2) {
        var x2$1 = match$2[0];
        var x1$1 = l[0];
        var c$6 = Curry._2(cmp, x1$1, x2$1);
        if (c$6 === 0) {
          return /* :: */[
                  x1$1,
                  /* [] */0
                ];
        } else if (c$6 < 0) {
          return /* :: */[
                  x1$1,
                  /* :: */[
                    x2$1,
                    /* [] */0
                  ]
                ];
        } else {
          return /* :: */[
                  x2$1,
                  /* :: */[
                    x1$1,
                    /* [] */0
                  ]
                ];
        }
      } else {
        exit = 1;
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      var n1 = (n >> 1);
      var n2 = n - n1 | 0;
      var l2 = chop(n1, l);
      var s1 = rev_sort(n1, l);
      var s2 = rev_sort(n2, l2);
      var _l1 = s1;
      var _l2 = s2;
      var _accu = /* [] */0;
      while(true) {
        var accu = _accu;
        var l2$1 = _l2;
        var l1 = _l1;
        if (l1) {
          if (l2$1) {
            var t2 = l2$1[1];
            var h2 = l2$1[0];
            var t1 = l1[1];
            var h1 = l1[0];
            var c$7 = Curry._2(cmp, h1, h2);
            if (c$7 === 0) {
              _accu = /* :: */[
                h1,
                accu
              ];
              _l2 = t2;
              _l1 = t1;
              continue ;
              
            } else if (c$7 > 0) {
              _accu = /* :: */[
                h1,
                accu
              ];
              _l1 = t1;
              continue ;
              
            } else {
              _accu = /* :: */[
                h2,
                accu
              ];
              _l2 = t2;
              continue ;
              
            }
          } else {
            return rev_append(l1, accu);
          }
        } else {
          return rev_append(l2$1, accu);
        }
      };
    }
    
  };
  var rev_sort = function (n, l) {
    var exit = 0;
    if (n !== 2) {
      if (n !== 3 || !l) {
        exit = 1;
      } else {
        var match = l[1];
        if (match) {
          var match$1 = match[1];
          if (match$1) {
            var x3 = match$1[0];
            var x2 = match[0];
            var x1 = l[0];
            var c = Curry._2(cmp, x1, x2);
            if (c === 0) {
              var c$1 = Curry._2(cmp, x2, x3);
              if (c$1 === 0) {
                return /* :: */[
                        x2,
                        /* [] */0
                      ];
              } else if (c$1 > 0) {
                return /* :: */[
                        x2,
                        /* :: */[
                          x3,
                          /* [] */0
                        ]
                      ];
              } else {
                return /* :: */[
                        x3,
                        /* :: */[
                          x2,
                          /* [] */0
                        ]
                      ];
              }
            } else if (c > 0) {
              var c$2 = Curry._2(cmp, x2, x3);
              if (c$2 === 0) {
                return /* :: */[
                        x1,
                        /* :: */[
                          x2,
                          /* [] */0
                        ]
                      ];
              } else if (c$2 > 0) {
                return /* :: */[
                        x1,
                        /* :: */[
                          x2,
                          /* :: */[
                            x3,
                            /* [] */0
                          ]
                        ]
                      ];
              } else {
                var c$3 = Curry._2(cmp, x1, x3);
                if (c$3 === 0) {
                  return /* :: */[
                          x1,
                          /* :: */[
                            x2,
                            /* [] */0
                          ]
                        ];
                } else if (c$3 > 0) {
                  return /* :: */[
                          x1,
                          /* :: */[
                            x3,
                            /* :: */[
                              x2,
                              /* [] */0
                            ]
                          ]
                        ];
                } else {
                  return /* :: */[
                          x3,
                          /* :: */[
                            x1,
                            /* :: */[
                              x2,
                              /* [] */0
                            ]
                          ]
                        ];
                }
              }
            } else {
              var c$4 = Curry._2(cmp, x1, x3);
              if (c$4 === 0) {
                return /* :: */[
                        x2,
                        /* :: */[
                          x1,
                          /* [] */0
                        ]
                      ];
              } else if (c$4 > 0) {
                return /* :: */[
                        x2,
                        /* :: */[
                          x1,
                          /* :: */[
                            x3,
                            /* [] */0
                          ]
                        ]
                      ];
              } else {
                var c$5 = Curry._2(cmp, x2, x3);
                if (c$5 === 0) {
                  return /* :: */[
                          x2,
                          /* :: */[
                            x1,
                            /* [] */0
                          ]
                        ];
                } else if (c$5 > 0) {
                  return /* :: */[
                          x2,
                          /* :: */[
                            x3,
                            /* :: */[
                              x1,
                              /* [] */0
                            ]
                          ]
                        ];
                } else {
                  return /* :: */[
                          x3,
                          /* :: */[
                            x2,
                            /* :: */[
                              x1,
                              /* [] */0
                            ]
                          ]
                        ];
                }
              }
            }
          } else {
            exit = 1;
          }
        } else {
          exit = 1;
        }
      }
    } else if (l) {
      var match$2 = l[1];
      if (match$2) {
        var x2$1 = match$2[0];
        var x1$1 = l[0];
        var c$6 = Curry._2(cmp, x1$1, x2$1);
        if (c$6 === 0) {
          return /* :: */[
                  x1$1,
                  /* [] */0
                ];
        } else if (c$6 > 0) {
          return /* :: */[
                  x1$1,
                  /* :: */[
                    x2$1,
                    /* [] */0
                  ]
                ];
        } else {
          return /* :: */[
                  x2$1,
                  /* :: */[
                    x1$1,
                    /* [] */0
                  ]
                ];
        }
      } else {
        exit = 1;
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      var n1 = (n >> 1);
      var n2 = n - n1 | 0;
      var l2 = chop(n1, l);
      var s1 = sort(n1, l);
      var s2 = sort(n2, l2);
      var _l1 = s1;
      var _l2 = s2;
      var _accu = /* [] */0;
      while(true) {
        var accu = _accu;
        var l2$1 = _l2;
        var l1 = _l1;
        if (l1) {
          if (l2$1) {
            var t2 = l2$1[1];
            var h2 = l2$1[0];
            var t1 = l1[1];
            var h1 = l1[0];
            var c$7 = Curry._2(cmp, h1, h2);
            if (c$7 === 0) {
              _accu = /* :: */[
                h1,
                accu
              ];
              _l2 = t2;
              _l1 = t1;
              continue ;
              
            } else if (c$7 < 0) {
              _accu = /* :: */[
                h1,
                accu
              ];
              _l1 = t1;
              continue ;
              
            } else {
              _accu = /* :: */[
                h2,
                accu
              ];
              _l2 = t2;
              continue ;
              
            }
          } else {
            return rev_append(l1, accu);
          }
        } else {
          return rev_append(l2$1, accu);
        }
      };
    }
    
  };
  var len = length(l);
  if (len < 2) {
    return l;
  } else {
    return sort(len, l);
  }
}

var append = Pervasives.$at;

var concat = flatten;

var filter = find_all;

var sort = stable_sort;

var fast_sort = stable_sort;

exports.length = length;
exports.hd = hd;
exports.tl = tl;
exports.nth = nth;
exports.rev = rev;
exports.append = append;
exports.rev_append = rev_append;
exports.concat = concat;
exports.flatten = flatten;
exports.iter = iter;
exports.iteri = iteri;
exports.map = map;
exports.mapi = mapi$1;
exports.rev_map = rev_map;
exports.fold_left = fold_left;
exports.fold_right = fold_right;
exports.iter2 = iter2;
exports.map2 = map2;
exports.rev_map2 = rev_map2;
exports.fold_left2 = fold_left2;
exports.fold_right2 = fold_right2;
exports.for_all = for_all;
exports.exists = exists;
exports.for_all2 = for_all2;
exports.exists2 = exists2;
exports.mem = mem;
exports.memq = memq;
exports.find = find;
exports.filter = filter;
exports.find_all = find_all;
exports.partition = partition;
exports.assoc = assoc;
exports.assq = assq;
exports.mem_assoc = mem_assoc;
exports.mem_assq = mem_assq;
exports.remove_assoc = remove_assoc;
exports.remove_assq = remove_assq;
exports.split = split;
exports.combine = combine;
exports.sort = sort;
exports.stable_sort = stable_sort;
exports.fast_sort = fast_sort;
exports.sort_uniq = sort_uniq;
exports.merge = merge;
/* No side effect */


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



function caml_int_compare(x, y) {
  if (x < y) {
    return -1;
  } else if (x === y) {
    return 0;
  } else {
    return 1;
  }
}

function caml_float_compare(x, y) {
  if (x === y) {
    return 0;
  } else if (x < y) {
    return -1;
  } else if (x > y || x === x) {
    return 1;
  } else if (y === y) {
    return -1;
  } else {
    return 0;
  }
}

function caml_string_compare(s1, s2) {
  if (s1 === s2) {
    return 0;
  } else if (s1 < s2) {
    return -1;
  } else {
    return 1;
  }
}

function caml_int_min(x, y) {
  if (x < y) {
    return x;
  } else {
    return y;
  }
}

function caml_float_min(x, y) {
  if (x < y) {
    return x;
  } else {
    return y;
  }
}

function caml_string_min(x, y) {
  if (x < y) {
    return x;
  } else {
    return y;
  }
}

function caml_nativeint_min(x, y) {
  if (x < y) {
    return x;
  } else {
    return y;
  }
}

function caml_int32_min(x, y) {
  if (x < y) {
    return x;
  } else {
    return y;
  }
}

function caml_int_max(x, y) {
  if (x > y) {
    return x;
  } else {
    return y;
  }
}

function caml_float_max(x, y) {
  if (x > y) {
    return x;
  } else {
    return y;
  }
}

function caml_string_max(x, y) {
  if (x > y) {
    return x;
  } else {
    return y;
  }
}

function caml_nativeint_max(x, y) {
  if (x > y) {
    return x;
  } else {
    return y;
  }
}

function caml_int32_max(x, y) {
  if (x > y) {
    return x;
  } else {
    return y;
  }
}

var caml_nativeint_compare = caml_int_compare;

var caml_int32_compare = caml_int_compare;

exports.caml_int_compare = caml_int_compare;
exports.caml_float_compare = caml_float_compare;
exports.caml_nativeint_compare = caml_nativeint_compare;
exports.caml_string_compare = caml_string_compare;
exports.caml_int32_compare = caml_int32_compare;
exports.caml_int_min = caml_int_min;
exports.caml_float_min = caml_float_min;
exports.caml_string_min = caml_string_min;
exports.caml_nativeint_min = caml_nativeint_min;
exports.caml_int32_min = caml_int32_min;
exports.caml_int_max = caml_int_max;
exports.caml_float_max = caml_float_max;
exports.caml_string_max = caml_string_max;
exports.caml_nativeint_max = caml_nativeint_max;
exports.caml_int32_max = caml_int32_max;
/* No side effect */


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Curry = __webpack_require__(0);
var Caml_io = __webpack_require__(32);
var Caml_sys = __webpack_require__(72);
var Caml_format = __webpack_require__(8);
var Caml_string = __webpack_require__(16);
var Caml_exceptions = __webpack_require__(22);
var Caml_missing_polyfill = __webpack_require__(74);
var Caml_builtin_exceptions = __webpack_require__(3);
var CamlinternalFormatBasics = __webpack_require__(35);

function failwith(s) {
  throw [
        Caml_builtin_exceptions.failure,
        s
      ];
}

function invalid_arg(s) {
  throw [
        Caml_builtin_exceptions.invalid_argument,
        s
      ];
}

var Exit = Caml_exceptions.create("Pervasives.Exit");

function abs(x) {
  if (x >= 0) {
    return x;
  } else {
    return -x | 0;
  }
}

function lnot(x) {
  return x ^ -1;
}

var min_int = -2147483648;

function char_of_int(n) {
  if (n < 0 || n > 255) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "char_of_int"
        ];
  } else {
    return n;
  }
}

function string_of_bool(b) {
  if (b) {
    return "true";
  } else {
    return "false";
  }
}

function bool_of_string(param) {
  switch (param) {
    case "false" : 
        return /* false */0;
    case "true" : 
        return /* true */1;
    default:
      throw [
            Caml_builtin_exceptions.invalid_argument,
            "bool_of_string"
          ];
  }
}

function valid_float_lexem(s) {
  var l = s.length;
  var _i = 0;
  while(true) {
    var i = _i;
    if (i >= l) {
      return s + ".";
    } else {
      var match = Caml_string.get(s, i);
      if (match >= 48) {
        if (match >= 58) {
          return s;
        } else {
          _i = i + 1 | 0;
          continue ;
          
        }
      } else if (match !== 45) {
        return s;
      } else {
        _i = i + 1 | 0;
        continue ;
        
      }
    }
  };
}

function string_of_float(f) {
  return valid_float_lexem(Caml_format.caml_format_float("%.12g", f));
}

function $at(l1, l2) {
  if (l1) {
    return /* :: */[
            l1[0],
            $at(l1[1], l2)
          ];
  } else {
    return l2;
  }
}

var stdin = Caml_io.stdin;

var stdout = Caml_io.stdout;

var stderr = Caml_io.stderr;

function open_out_gen(_, _$1, _$2) {
  return Caml_io.caml_ml_open_descriptor_out(Caml_missing_polyfill.not_implemented("caml_sys_open not implemented by bucklescript yet\n"));
}

function open_out(name) {
  return open_out_gen(/* :: */[
              /* Open_wronly */1,
              /* :: */[
                /* Open_creat */3,
                /* :: */[
                  /* Open_trunc */4,
                  /* :: */[
                    /* Open_text */7,
                    /* [] */0
                  ]
                ]
              ]
            ], 438, name);
}

function open_out_bin(name) {
  return open_out_gen(/* :: */[
              /* Open_wronly */1,
              /* :: */[
                /* Open_creat */3,
                /* :: */[
                  /* Open_trunc */4,
                  /* :: */[
                    /* Open_binary */6,
                    /* [] */0
                  ]
                ]
              ]
            ], 438, name);
}

function flush_all() {
  var _param = Caml_io.caml_ml_out_channels_list(/* () */0);
  while(true) {
    var param = _param;
    if (param) {
      try {
        Caml_io.caml_ml_flush(param[0]);
      }
      catch (exn){
        
      }
      _param = param[1];
      continue ;
      
    } else {
      return /* () */0;
    }
  };
}

function output_bytes(oc, s) {
  return Caml_io.caml_ml_output(oc, s, 0, s.length);
}

function output_string(oc, s) {
  return Caml_io.caml_ml_output(oc, s, 0, s.length);
}

function output(oc, s, ofs, len) {
  if (ofs < 0 || len < 0 || ofs > (s.length - len | 0)) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "output"
        ];
  } else {
    return Caml_io.caml_ml_output(oc, s, ofs, len);
  }
}

function output_substring(oc, s, ofs, len) {
  if (ofs < 0 || len < 0 || ofs > (s.length - len | 0)) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "output_substring"
        ];
  } else {
    return Caml_io.caml_ml_output(oc, s, ofs, len);
  }
}

function output_value(_, _$1) {
  return Caml_missing_polyfill.not_implemented("caml_output_value not implemented by bucklescript yet\n");
}

function close_out(oc) {
  Caml_io.caml_ml_flush(oc);
  return Caml_missing_polyfill.not_implemented("caml_ml_close_channel not implemented by bucklescript yet\n");
}

function close_out_noerr(oc) {
  try {
    Caml_io.caml_ml_flush(oc);
  }
  catch (exn){
    
  }
  try {
    return Caml_missing_polyfill.not_implemented("caml_ml_close_channel not implemented by bucklescript yet\n");
  }
  catch (exn$1){
    return /* () */0;
  }
}

function open_in_gen(_, _$1, _$2) {
  return Caml_io.caml_ml_open_descriptor_in(Caml_missing_polyfill.not_implemented("caml_sys_open not implemented by bucklescript yet\n"));
}

function open_in(name) {
  return open_in_gen(/* :: */[
              /* Open_rdonly */0,
              /* :: */[
                /* Open_text */7,
                /* [] */0
              ]
            ], 0, name);
}

function open_in_bin(name) {
  return open_in_gen(/* :: */[
              /* Open_rdonly */0,
              /* :: */[
                /* Open_binary */6,
                /* [] */0
              ]
            ], 0, name);
}

function input(_, s, ofs, len) {
  if (ofs < 0 || len < 0 || ofs > (s.length - len | 0)) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "input"
        ];
  } else {
    return Caml_missing_polyfill.not_implemented("caml_ml_input not implemented by bucklescript yet\n");
  }
}

function unsafe_really_input(_, _$1, _ofs, _len) {
  while(true) {
    var len = _len;
    var ofs = _ofs;
    if (len <= 0) {
      return /* () */0;
    } else {
      var r = Caml_missing_polyfill.not_implemented("caml_ml_input not implemented by bucklescript yet\n");
      if (r === 0) {
        throw Caml_builtin_exceptions.end_of_file;
      } else {
        _len = len - r | 0;
        _ofs = ofs + r | 0;
        continue ;
        
      }
    }
  };
}

function really_input(ic, s, ofs, len) {
  if (ofs < 0 || len < 0 || ofs > (s.length - len | 0)) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "really_input"
        ];
  } else {
    return unsafe_really_input(ic, s, ofs, len);
  }
}

function really_input_string(ic, len) {
  var s = Caml_string.caml_create_string(len);
  really_input(ic, s, 0, len);
  return Caml_string.bytes_to_string(s);
}

function input_line(chan) {
  var build_result = function (buf, _pos, _param) {
    while(true) {
      var param = _param;
      var pos = _pos;
      if (param) {
        var hd = param[0];
        var len = hd.length;
        Caml_string.caml_blit_bytes(hd, 0, buf, pos - len | 0, len);
        _param = param[1];
        _pos = pos - len | 0;
        continue ;
        
      } else {
        return buf;
      }
    };
  };
  var scan = function (_accu, _len) {
    while(true) {
      var len = _len;
      var accu = _accu;
      var n = Caml_missing_polyfill.not_implemented("caml_ml_input_scan_line not implemented by bucklescript yet\n");
      if (n === 0) {
        if (accu) {
          return build_result(Caml_string.caml_create_string(len), len, accu);
        } else {
          throw Caml_builtin_exceptions.end_of_file;
        }
      } else if (n > 0) {
        var res = Caml_string.caml_create_string(n - 1 | 0);
        Caml_missing_polyfill.not_implemented("caml_ml_input not implemented by bucklescript yet\n");
        Caml_io.caml_ml_input_char(chan);
        if (accu) {
          var len$1 = (len + n | 0) - 1 | 0;
          return build_result(Caml_string.caml_create_string(len$1), len$1, /* :: */[
                      res,
                      accu
                    ]);
        } else {
          return res;
        }
      } else {
        var beg = Caml_string.caml_create_string(-n | 0);
        Caml_missing_polyfill.not_implemented("caml_ml_input not implemented by bucklescript yet\n");
        _len = len - n | 0;
        _accu = /* :: */[
          beg,
          accu
        ];
        continue ;
        
      }
    };
  };
  return Caml_string.bytes_to_string(scan(/* [] */0, 0));
}

function close_in_noerr() {
  try {
    return Caml_missing_polyfill.not_implemented("caml_ml_close_channel not implemented by bucklescript yet\n");
  }
  catch (exn){
    return /* () */0;
  }
}

function print_char(c) {
  return Caml_io.caml_ml_output_char(stdout, c);
}

function print_string(s) {
  return output_string(stdout, s);
}

function print_bytes(s) {
  return output_bytes(stdout, s);
}

function print_int(i) {
  return output_string(stdout, String(i));
}

function print_float(f) {
  return output_string(stdout, valid_float_lexem(Caml_format.caml_format_float("%.12g", f)));
}

function print_newline() {
  Caml_io.caml_ml_output_char(stdout, /* "\n" */10);
  return Caml_io.caml_ml_flush(stdout);
}

function prerr_char(c) {
  return Caml_io.caml_ml_output_char(stderr, c);
}

function prerr_string(s) {
  return output_string(stderr, s);
}

function prerr_bytes(s) {
  return output_bytes(stderr, s);
}

function prerr_int(i) {
  return output_string(stderr, String(i));
}

function prerr_float(f) {
  return output_string(stderr, valid_float_lexem(Caml_format.caml_format_float("%.12g", f)));
}

function prerr_newline() {
  Caml_io.caml_ml_output_char(stderr, /* "\n" */10);
  return Caml_io.caml_ml_flush(stderr);
}

function read_line() {
  Caml_io.caml_ml_flush(stdout);
  return input_line(stdin);
}

function read_int() {
  return Caml_format.caml_int_of_string((Caml_io.caml_ml_flush(stdout), input_line(stdin)));
}

function read_float() {
  return Caml_format.caml_float_of_string((Caml_io.caml_ml_flush(stdout), input_line(stdin)));
}

function string_of_format(param) {
  return param[1];
}

function $caret$caret(param, param$1) {
  return /* Format */[
          CamlinternalFormatBasics.concat_fmt(param[0], param$1[0]),
          param[1] + ("%," + param$1[1])
        ];
}

var exit_function = [flush_all];

function at_exit(f) {
  var g = exit_function[0];
  exit_function[0] = (function () {
      Curry._1(f, /* () */0);
      return Curry._1(g, /* () */0);
    });
  return /* () */0;
}

function do_at_exit() {
  return Curry._1(exit_function[0], /* () */0);
}

function exit(retcode) {
  do_at_exit(/* () */0);
  return Caml_sys.caml_sys_exit(retcode);
}

var max_int = 2147483647;

var epsilon_float = 2.220446049250313e-16;

var flush = Caml_io.caml_ml_flush;

var output_char = Caml_io.caml_ml_output_char;

var output_byte = Caml_io.caml_ml_output_char;

function output_binary_int(_, _$1) {
  return Caml_missing_polyfill.not_implemented("caml_ml_output_int not implemented by bucklescript yet\n");
}

function seek_out(_, _$1) {
  return Caml_missing_polyfill.not_implemented("caml_ml_seek_out not implemented by bucklescript yet\n");
}

function pos_out() {
  return Caml_missing_polyfill.not_implemented("caml_ml_pos_out not implemented by bucklescript yet\n");
}

function out_channel_length() {
  return Caml_missing_polyfill.not_implemented("caml_ml_channel_size not implemented by bucklescript yet\n");
}

function set_binary_mode_out(_, _$1) {
  return Caml_missing_polyfill.not_implemented("caml_ml_set_binary_mode not implemented by bucklescript yet\n");
}

var input_char = Caml_io.caml_ml_input_char;

var input_byte = Caml_io.caml_ml_input_char;

function input_binary_int() {
  return Caml_missing_polyfill.not_implemented("caml_ml_input_int not implemented by bucklescript yet\n");
}

function input_value() {
  return Caml_missing_polyfill.not_implemented("caml_input_value not implemented by bucklescript yet\n");
}

function seek_in(_, _$1) {
  return Caml_missing_polyfill.not_implemented("caml_ml_seek_in not implemented by bucklescript yet\n");
}

function pos_in() {
  return Caml_missing_polyfill.not_implemented("caml_ml_pos_in not implemented by bucklescript yet\n");
}

function in_channel_length() {
  return Caml_missing_polyfill.not_implemented("caml_ml_channel_size not implemented by bucklescript yet\n");
}

function close_in() {
  return Caml_missing_polyfill.not_implemented("caml_ml_close_channel not implemented by bucklescript yet\n");
}

function set_binary_mode_in(_, _$1) {
  return Caml_missing_polyfill.not_implemented("caml_ml_set_binary_mode not implemented by bucklescript yet\n");
}

function LargeFile_000(_, _$1) {
  return Caml_missing_polyfill.not_implemented("caml_ml_seek_out_64 not implemented by bucklescript yet\n");
}

function LargeFile_001() {
  return Caml_missing_polyfill.not_implemented("caml_ml_pos_out_64 not implemented by bucklescript yet\n");
}

function LargeFile_002() {
  return Caml_missing_polyfill.not_implemented("caml_ml_channel_size_64 not implemented by bucklescript yet\n");
}

function LargeFile_003(_, _$1) {
  return Caml_missing_polyfill.not_implemented("caml_ml_seek_in_64 not implemented by bucklescript yet\n");
}

function LargeFile_004() {
  return Caml_missing_polyfill.not_implemented("caml_ml_pos_in_64 not implemented by bucklescript yet\n");
}

function LargeFile_005() {
  return Caml_missing_polyfill.not_implemented("caml_ml_channel_size_64 not implemented by bucklescript yet\n");
}

var LargeFile = [
  LargeFile_000,
  LargeFile_001,
  LargeFile_002,
  LargeFile_003,
  LargeFile_004,
  LargeFile_005
];

exports.invalid_arg = invalid_arg;
exports.failwith = failwith;
exports.Exit = Exit;
exports.abs = abs;
exports.max_int = max_int;
exports.min_int = min_int;
exports.lnot = lnot;
exports.epsilon_float = epsilon_float;
exports.char_of_int = char_of_int;
exports.string_of_bool = string_of_bool;
exports.bool_of_string = bool_of_string;
exports.string_of_float = string_of_float;
exports.$at = $at;
exports.stdin = stdin;
exports.stdout = stdout;
exports.stderr = stderr;
exports.print_char = print_char;
exports.print_string = print_string;
exports.print_bytes = print_bytes;
exports.print_int = print_int;
exports.print_float = print_float;
exports.print_newline = print_newline;
exports.prerr_char = prerr_char;
exports.prerr_string = prerr_string;
exports.prerr_bytes = prerr_bytes;
exports.prerr_int = prerr_int;
exports.prerr_float = prerr_float;
exports.prerr_newline = prerr_newline;
exports.read_line = read_line;
exports.read_int = read_int;
exports.read_float = read_float;
exports.open_out = open_out;
exports.open_out_bin = open_out_bin;
exports.open_out_gen = open_out_gen;
exports.flush = flush;
exports.flush_all = flush_all;
exports.output_char = output_char;
exports.output_string = output_string;
exports.output_bytes = output_bytes;
exports.output = output;
exports.output_substring = output_substring;
exports.output_byte = output_byte;
exports.output_binary_int = output_binary_int;
exports.output_value = output_value;
exports.seek_out = seek_out;
exports.pos_out = pos_out;
exports.out_channel_length = out_channel_length;
exports.close_out = close_out;
exports.close_out_noerr = close_out_noerr;
exports.set_binary_mode_out = set_binary_mode_out;
exports.open_in = open_in;
exports.open_in_bin = open_in_bin;
exports.open_in_gen = open_in_gen;
exports.input_char = input_char;
exports.input_line = input_line;
exports.input = input;
exports.really_input = really_input;
exports.really_input_string = really_input_string;
exports.input_byte = input_byte;
exports.input_binary_int = input_binary_int;
exports.input_value = input_value;
exports.seek_in = seek_in;
exports.pos_in = pos_in;
exports.in_channel_length = in_channel_length;
exports.close_in = close_in;
exports.close_in_noerr = close_in_noerr;
exports.set_binary_mode_in = set_binary_mode_in;
exports.LargeFile = LargeFile;
exports.string_of_format = string_of_format;
exports.$caret$caret = $caret$caret;
exports.exit = exit;
exports.at_exit = at_exit;
exports.valid_float_lexem = valid_float_lexem;
exports.unsafe_really_input = unsafe_really_input;
exports.do_at_exit = do_at_exit;
/* No side effect */


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var id = [0];

function caml_set_oo_id(b) {
  b[1] = id[0];
  id[0] += 1;
  return b;
}

function get_id() {
  id[0] += 1;
  return id[0];
}

function create(str) {
  var v_001 = get_id(/* () */0);
  var v = /* tuple */[
    str,
    v_001
  ];
  v.tag = 248;
  return v;
}

function isCamlExceptionOrOpenVariant(e) {
  if (e === undefined) {
    return /* false */0;
  } else if (e.tag === 248) {
    return /* true */1;
  } else {
    var slot = e[0];
    if (slot !== undefined) {
      return +(slot.tag === 248);
    } else {
      return /* false */0;
    }
  }
}

exports.caml_set_oo_id = caml_set_oo_id;
exports.get_id = get_id;
exports.create = create;
exports.isCamlExceptionOrOpenVariant = isCamlExceptionOrOpenVariant;
/* No side effect */


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var List = __webpack_require__(19);
var $$Array = __webpack_require__(12);
var Curry = __webpack_require__(0);
var $$String = __webpack_require__(28);
var Js_dict = __webpack_require__(40);
var Js_boolean = __webpack_require__(43);

var bool = Js_boolean.to_js_boolean;

function $$char(c) {
  return $$String.make(1, c);
}

function date(d) {
  return d.toJSON();
}

function nullable(encode, param) {
  if (param) {
    return Curry._1(encode, param[0]);
  } else {
    return null;
  }
}

function withDefault(d, encode, param) {
  if (param) {
    return Curry._1(encode, param[0]);
  } else {
    return d;
  }
}

var object_ = Js_dict.fromList;

var array = $$Array.map;

function list(encode, l) {
  return $$Array.of_list(List.map(encode, l));
}

function pair(encodeA, encodeB, param) {
  return /* array */[
          Curry._1(encodeA, param[0]),
          Curry._1(encodeB, param[1])
        ];
}

function tuple3(encodeA, encodeB, encodeC, param) {
  return /* array */[
          Curry._1(encodeA, param[0]),
          Curry._1(encodeB, param[1]),
          Curry._1(encodeC, param[2])
        ];
}

function tuple4(encodeA, encodeB, encodeC, encodeD, param) {
  return /* array */[
          Curry._1(encodeA, param[0]),
          Curry._1(encodeB, param[1]),
          Curry._1(encodeC, param[2]),
          Curry._1(encodeD, param[3])
        ];
}

var tuple2 = pair;

var arrayOf = array;

exports.bool = bool;
exports.$$char = $$char;
exports.date = date;
exports.nullable = nullable;
exports.withDefault = withDefault;
exports.pair = pair;
exports.tuple2 = tuple2;
exports.tuple3 = tuple3;
exports.tuple4 = tuple4;
exports.object_ = object_;
exports.array = array;
exports.arrayOf = arrayOf;
exports.list = list;
/* Js_dict Not a pure module */


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Curry = __webpack_require__(0);
var Js_boolean = __webpack_require__(43);
var Caml_builtin_exceptions = __webpack_require__(3);

function encodeRequestMethod(param) {
  if (typeof param === "number") {
    switch (param) {
      case 0 : 
          return "GET";
      case 1 : 
          return "HEAD";
      case 2 : 
          return "POST";
      case 3 : 
          return "PUT";
      case 4 : 
          return "DELETE";
      case 5 : 
          return "CONNECT";
      case 6 : 
          return "OPTIONS";
      case 7 : 
          return "TRACE";
      case 8 : 
          return "PATCH";
      
    }
  } else {
    return param[0];
  }
}

function encodeReferrerPolicy(param) {
  switch (param) {
    case 0 : 
        return "";
    case 1 : 
        return "no-referrer";
    case 2 : 
        return "no-referrer-when-downgrade";
    case 3 : 
        return "same-origin";
    case 4 : 
        return "origin";
    case 5 : 
        return "strict-origin";
    case 6 : 
        return "origin-when-cross-origin";
    case 7 : 
        return "strict-origin-when-cross-origin";
    case 8 : 
        return "unsafe-url";
    
  }
}

function encodeRequestMode(param) {
  switch (param) {
    case 0 : 
        return "navigate";
    case 1 : 
        return "same-origin";
    case 2 : 
        return "no-cors";
    case 3 : 
        return "cors";
    
  }
}

function encodeRequestCredentials(param) {
  switch (param) {
    case 0 : 
        return "omit";
    case 1 : 
        return "same-origin";
    case 2 : 
        return "include";
    
  }
}

function encodeRequestCache(param) {
  switch (param) {
    case 0 : 
        return "default";
    case 1 : 
        return "no-store";
    case 2 : 
        return "reload";
    case 3 : 
        return "no-cache";
    case 4 : 
        return "force-cache";
    case 5 : 
        return "only-if-cached";
    
  }
}

function encodeRequestRedirect(param) {
  switch (param) {
    case 0 : 
        return "follow";
    case 1 : 
        return "error";
    case 2 : 
        return "manual";
    
  }
}

var HeadersInit = /* module */[];

var Headers = /* module */[];

var BodyInit = /* module */[];

function map(f, param) {
  if (param) {
    return /* Some */[Curry._1(f, param[0])];
  } else {
    return /* None */0;
  }
}

function make(method_, headers, body, referrer, $staropt$star, mode, credentials, cache, redirect, $staropt$star$1, keepalive) {
  var referrerPolicy = $staropt$star ? $staropt$star[0] : /* None */0;
  var integrity = $staropt$star$1 ? $staropt$star$1[0] : "";
  var partial_arg = map(Js_boolean.to_js_boolean, keepalive);
  var partial_arg$1 = /* Some */[integrity];
  var partial_arg$2 = map(encodeRequestRedirect, redirect);
  var partial_arg$3 = map(encodeRequestCache, cache);
  var partial_arg$4 = map(encodeRequestCredentials, credentials);
  var partial_arg$5 = map(encodeRequestMode, mode);
  var partial_arg$6 = /* Some */[encodeReferrerPolicy(referrerPolicy)];
  var partial_arg$7 = map(encodeRequestMethod, method_);
  return (function () {
      var tmp = { };
      if (partial_arg$7) {
        tmp.method = partial_arg$7[0];
      }
      if (headers) {
        tmp.headers = headers[0];
      }
      if (body) {
        tmp.body = body[0];
      }
      if (referrer) {
        tmp.referrer = referrer[0];
      }
      if (partial_arg$6) {
        tmp.referrerPolicy = partial_arg$6[0];
      }
      if (partial_arg$5) {
        tmp.mode = partial_arg$5[0];
      }
      if (partial_arg$4) {
        tmp.credentials = partial_arg$4[0];
      }
      if (partial_arg$3) {
        tmp.cache = partial_arg$3[0];
      }
      if (partial_arg$2) {
        tmp.redirect = partial_arg$2[0];
      }
      if (partial_arg$1) {
        tmp.integrity = partial_arg$1[0];
      }
      if (partial_arg) {
        tmp.keepalive = partial_arg[0];
      }
      return tmp;
    });
}

function method_(self) {
  var method_$1 = self.method;
  switch (method_$1) {
    case "CONNECT" : 
        return /* Connect */5;
    case "DELETE" : 
        return /* Delete */4;
    case "GET" : 
        return /* Get */0;
    case "HEAD" : 
        return /* Head */1;
    case "OPTIONS" : 
        return /* Options */6;
    case "PATCH" : 
        return /* Patch */8;
    case "POST" : 
        return /* Post */2;
    case "PUT" : 
        return /* Put */3;
    case "TRACE" : 
        return /* Trace */7;
    default:
      return /* Other */[method_$1];
  }
}

function type_(self) {
  var e = self.type;
  switch (e) {
    case "" : 
        return /* None */0;
    case "audio" : 
        return /* Audio */1;
    case "font" : 
        return /* Font */2;
    case "image" : 
        return /* Image */3;
    case "script" : 
        return /* Script */4;
    case "style" : 
        return /* Style */5;
    case "track" : 
        return /* Track */6;
    case "video" : 
        return /* Video */7;
    default:
      throw [
            Caml_builtin_exceptions.failure,
            "Unknown requestType: " + e
          ];
  }
}

function destination(self) {
  var e = self.destination;
  switch (e) {
    case "" : 
        return /* None */0;
    case "document" : 
        return /* Document */1;
    case "embed" : 
        return /* Embed */2;
    case "font" : 
        return /* Font */3;
    case "image" : 
        return /* Image */4;
    case "manifest" : 
        return /* Manifest */5;
    case "media" : 
        return /* Media */6;
    case "object" : 
        return /* Object */7;
    case "report" : 
        return /* Report */8;
    case "script" : 
        return /* Script */9;
    case "serviceworker" : 
        return /* ServiceWorker */10;
    case "sharedworder" : 
        return /* SharedWorker */11;
    case "style" : 
        return /* Style */12;
    case "worker" : 
        return /* Worker */13;
    case "xslt" : 
        return /* Xslt */14;
    default:
      throw [
            Caml_builtin_exceptions.failure,
            "Unknown requestDestination: " + e
          ];
  }
}

function referrerPolicy(self) {
  var e = self.referrerPolicy;
  switch (e) {
    case "" : 
        return /* None */0;
    case "no-referrer" : 
        return /* NoReferrer */1;
    case "no-referrer-when-downgrade" : 
        return /* NoReferrerWhenDowngrade */2;
    case "origin" : 
        return /* Origin */4;
    case "origin-when-cross-origin" : 
        return /* OriginWhenCrossOrigin */6;
    case "same-origin" : 
        return /* SameOrigin */3;
    case "strict-origin" : 
        return /* StrictOrigin */5;
    case "strict-origin-when-cross-origin" : 
        return /* StrictOriginWhenCrossOrigin */7;
    case "unsafe-url" : 
        return /* UnsafeUrl */8;
    default:
      throw [
            Caml_builtin_exceptions.failure,
            "Unknown referrerPolicy: " + e
          ];
  }
}

function mode(self) {
  var e = self.mode;
  switch (e) {
    case "cors" : 
        return /* CORS */3;
    case "navigate" : 
        return /* Navigate */0;
    case "no-cors" : 
        return /* NoCORS */2;
    case "same-origin" : 
        return /* SameOrigin */1;
    default:
      throw [
            Caml_builtin_exceptions.failure,
            "Unknown requestMode: " + e
          ];
  }
}

function credentials(self) {
  var e = self.credentials;
  switch (e) {
    case "include" : 
        return /* Include */2;
    case "omit" : 
        return /* Omit */0;
    case "same-origin" : 
        return /* SameOrigin */1;
    default:
      throw [
            Caml_builtin_exceptions.failure,
            "Unknown requestCredentials: " + e
          ];
  }
}

function cache(self) {
  var e = self.cache;
  switch (e) {
    case "default" : 
        return /* Default */0;
    case "force-cache" : 
        return /* ForceCache */4;
    case "no-cache" : 
        return /* NoCache */3;
    case "no-store" : 
        return /* NoStore */1;
    case "only-if-cached" : 
        return /* OnlyIfCached */5;
    case "reload" : 
        return /* Reload */2;
    default:
      throw [
            Caml_builtin_exceptions.failure,
            "Unknown requestCache: " + e
          ];
  }
}

function redirect(self) {
  var e = self.redirect;
  switch (e) {
    case "error" : 
        return /* Error */1;
    case "follow" : 
        return /* Follow */0;
    case "manual" : 
        return /* Manual */2;
    default:
      throw [
            Caml_builtin_exceptions.failure,
            "Unknown requestRedirect: " + e
          ];
  }
}

var Request = /* module */[
  /* method_ */method_,
  /* type_ */type_,
  /* destination */destination,
  /* referrerPolicy */referrerPolicy,
  /* mode */mode,
  /* credentials */credentials,
  /* cache */cache,
  /* redirect */redirect
];

var Response = /* module */[];

var Body = [];

var RequestInit = [make];

exports.HeadersInit = HeadersInit;
exports.Headers = Headers;
exports.BodyInit = BodyInit;
exports.Body = Body;
exports.RequestInit = RequestInit;
exports.Request = Request;
exports.Response = Response;
/* No side effect */


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Char = __webpack_require__(46);
var List = __webpack_require__(19);
var Curry = __webpack_require__(0);
var Caml_obj = __webpack_require__(15);
var Caml_int32 = __webpack_require__(11);
var Caml_string = __webpack_require__(16);
var Caml_primitive = __webpack_require__(20);
var Caml_builtin_exceptions = __webpack_require__(3);

function make(n, c) {
  var s = Caml_string.caml_create_string(n);
  Caml_string.caml_fill_string(s, 0, n, c);
  return s;
}

function init(n, f) {
  var s = Caml_string.caml_create_string(n);
  for(var i = 0 ,i_finish = n - 1 | 0; i <= i_finish; ++i){
    s[i] = Curry._1(f, i);
  }
  return s;
}

var empty = [];

function copy(s) {
  var len = s.length;
  var r = Caml_string.caml_create_string(len);
  Caml_string.caml_blit_bytes(s, 0, r, 0, len);
  return r;
}

function to_string(b) {
  return Caml_string.bytes_to_string(copy(b));
}

function of_string(s) {
  return copy(Caml_string.bytes_of_string(s));
}

function sub(s, ofs, len) {
  if (ofs < 0 || len < 0 || ofs > (s.length - len | 0)) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "String.sub / Bytes.sub"
        ];
  } else {
    var r = Caml_string.caml_create_string(len);
    Caml_string.caml_blit_bytes(s, ofs, r, 0, len);
    return r;
  }
}

function sub_string(b, ofs, len) {
  return Caml_string.bytes_to_string(sub(b, ofs, len));
}

function extend(s, left, right) {
  var len = (s.length + left | 0) + right | 0;
  var r = Caml_string.caml_create_string(len);
  var match = left < 0 ? /* tuple */[
      -left | 0,
      0
    ] : /* tuple */[
      0,
      left
    ];
  var dstoff = match[1];
  var srcoff = match[0];
  var cpylen = Caml_primitive.caml_int_min(s.length - srcoff | 0, len - dstoff | 0);
  if (cpylen > 0) {
    Caml_string.caml_blit_bytes(s, srcoff, r, dstoff, cpylen);
  }
  return r;
}

function fill(s, ofs, len, c) {
  if (ofs < 0 || len < 0 || ofs > (s.length - len | 0)) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "String.fill / Bytes.fill"
        ];
  } else {
    return Caml_string.caml_fill_string(s, ofs, len, c);
  }
}

function blit(s1, ofs1, s2, ofs2, len) {
  if (len < 0 || ofs1 < 0 || ofs1 > (s1.length - len | 0) || ofs2 < 0 || ofs2 > (s2.length - len | 0)) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "Bytes.blit"
        ];
  } else {
    return Caml_string.caml_blit_bytes(s1, ofs1, s2, ofs2, len);
  }
}

function blit_string(s1, ofs1, s2, ofs2, len) {
  if (len < 0 || ofs1 < 0 || ofs1 > (s1.length - len | 0) || ofs2 < 0 || ofs2 > (s2.length - len | 0)) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "String.blit / Bytes.blit_string"
        ];
  } else {
    return Caml_string.caml_blit_string(s1, ofs1, s2, ofs2, len);
  }
}

function iter(f, a) {
  for(var i = 0 ,i_finish = a.length - 1 | 0; i <= i_finish; ++i){
    Curry._1(f, a[i]);
  }
  return /* () */0;
}

function iteri(f, a) {
  for(var i = 0 ,i_finish = a.length - 1 | 0; i <= i_finish; ++i){
    Curry._2(f, i, a[i]);
  }
  return /* () */0;
}

function concat(sep, l) {
  if (l) {
    var hd = l[0];
    var num = [0];
    var len = [0];
    List.iter((function (s) {
            num[0] = num[0] + 1 | 0;
            len[0] = len[0] + s.length | 0;
            return /* () */0;
          }), l);
    var r = Caml_string.caml_create_string(len[0] + Caml_int32.imul(sep.length, num[0] - 1 | 0) | 0);
    Caml_string.caml_blit_bytes(hd, 0, r, 0, hd.length);
    var pos = [hd.length];
    List.iter((function (s) {
            Caml_string.caml_blit_bytes(sep, 0, r, pos[0], sep.length);
            pos[0] = pos[0] + sep.length | 0;
            Caml_string.caml_blit_bytes(s, 0, r, pos[0], s.length);
            pos[0] = pos[0] + s.length | 0;
            return /* () */0;
          }), l[1]);
    return r;
  } else {
    return empty;
  }
}

function cat(s1, s2) {
  var l1 = s1.length;
  var l2 = s2.length;
  var r = Caml_string.caml_create_string(l1 + l2 | 0);
  Caml_string.caml_blit_bytes(s1, 0, r, 0, l1);
  Caml_string.caml_blit_bytes(s2, 0, r, l1, l2);
  return r;
}

function is_space(param) {
  var switcher = param - 9 | 0;
  if (switcher > 4 || switcher < 0) {
    if (switcher !== 23) {
      return /* false */0;
    } else {
      return /* true */1;
    }
  } else if (switcher !== 2) {
    return /* true */1;
  } else {
    return /* false */0;
  }
}

function trim(s) {
  var len = s.length;
  var i = 0;
  while(i < len && is_space(s[i])) {
    i = i + 1 | 0;
  };
  var j = len - 1 | 0;
  while(j >= i && is_space(s[j])) {
    j = j - 1 | 0;
  };
  if (j >= i) {
    return sub(s, i, (j - i | 0) + 1 | 0);
  } else {
    return empty;
  }
}

function escaped(s) {
  var n = 0;
  for(var i = 0 ,i_finish = s.length - 1 | 0; i <= i_finish; ++i){
    var match = s[i];
    var tmp;
    if (match >= 32) {
      var switcher = match - 34 | 0;
      tmp = switcher > 58 || switcher < 0 ? (
          switcher >= 93 ? 4 : 1
        ) : (
          switcher > 57 || switcher < 1 ? 2 : 1
        );
    } else {
      tmp = match >= 11 ? (
          match !== 13 ? 4 : 2
        ) : (
          match >= 8 ? 2 : 4
        );
    }
    n = n + tmp | 0;
  }
  if (n === s.length) {
    return copy(s);
  } else {
    var s$prime = Caml_string.caml_create_string(n);
    n = 0;
    for(var i$1 = 0 ,i_finish$1 = s.length - 1 | 0; i$1 <= i_finish$1; ++i$1){
      var c = s[i$1];
      var exit = 0;
      if (c >= 35) {
        if (c !== 92) {
          if (c >= 127) {
            exit = 1;
          } else {
            s$prime[n] = c;
          }
        } else {
          exit = 2;
        }
      } else if (c >= 32) {
        if (c >= 34) {
          exit = 2;
        } else {
          s$prime[n] = c;
        }
      } else if (c >= 14) {
        exit = 1;
      } else {
        switch (c) {
          case 8 : 
              s$prime[n] = /* "\\" */92;
              n = n + 1 | 0;
              s$prime[n] = /* "b" */98;
              break;
          case 9 : 
              s$prime[n] = /* "\\" */92;
              n = n + 1 | 0;
              s$prime[n] = /* "t" */116;
              break;
          case 10 : 
              s$prime[n] = /* "\\" */92;
              n = n + 1 | 0;
              s$prime[n] = /* "n" */110;
              break;
          case 0 : 
          case 1 : 
          case 2 : 
          case 3 : 
          case 4 : 
          case 5 : 
          case 6 : 
          case 7 : 
          case 11 : 
          case 12 : 
              exit = 1;
              break;
          case 13 : 
              s$prime[n] = /* "\\" */92;
              n = n + 1 | 0;
              s$prime[n] = /* "r" */114;
              break;
          
        }
      }
      switch (exit) {
        case 1 : 
            s$prime[n] = /* "\\" */92;
            n = n + 1 | 0;
            s$prime[n] = 48 + (c / 100 | 0) | 0;
            n = n + 1 | 0;
            s$prime[n] = 48 + (c / 10 | 0) % 10 | 0;
            n = n + 1 | 0;
            s$prime[n] = 48 + c % 10 | 0;
            break;
        case 2 : 
            s$prime[n] = /* "\\" */92;
            n = n + 1 | 0;
            s$prime[n] = c;
            break;
        
      }
      n = n + 1 | 0;
    }
    return s$prime;
  }
}

function map(f, s) {
  var l = s.length;
  if (l === 0) {
    return s;
  } else {
    var r = Caml_string.caml_create_string(l);
    for(var i = 0 ,i_finish = l - 1 | 0; i <= i_finish; ++i){
      r[i] = Curry._1(f, s[i]);
    }
    return r;
  }
}

function mapi(f, s) {
  var l = s.length;
  if (l === 0) {
    return s;
  } else {
    var r = Caml_string.caml_create_string(l);
    for(var i = 0 ,i_finish = l - 1 | 0; i <= i_finish; ++i){
      r[i] = Curry._2(f, i, s[i]);
    }
    return r;
  }
}

function uppercase(s) {
  return map(Char.uppercase, s);
}

function lowercase(s) {
  return map(Char.lowercase, s);
}

function apply1(f, s) {
  if (s.length === 0) {
    return s;
  } else {
    var r = copy(s);
    r[0] = Curry._1(f, s[0]);
    return r;
  }
}

function capitalize(s) {
  return apply1(Char.uppercase, s);
}

function uncapitalize(s) {
  return apply1(Char.lowercase, s);
}

function index_rec(s, lim, _i, c) {
  while(true) {
    var i = _i;
    if (i >= lim) {
      throw Caml_builtin_exceptions.not_found;
    } else if (s[i] === c) {
      return i;
    } else {
      _i = i + 1 | 0;
      continue ;
      
    }
  };
}

function index(s, c) {
  return index_rec(s, s.length, 0, c);
}

function index_from(s, i, c) {
  var l = s.length;
  if (i < 0 || i > l) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "String.index_from / Bytes.index_from"
        ];
  } else {
    return index_rec(s, l, i, c);
  }
}

function rindex_rec(s, _i, c) {
  while(true) {
    var i = _i;
    if (i < 0) {
      throw Caml_builtin_exceptions.not_found;
    } else if (s[i] === c) {
      return i;
    } else {
      _i = i - 1 | 0;
      continue ;
      
    }
  };
}

function rindex(s, c) {
  return rindex_rec(s, s.length - 1 | 0, c);
}

function rindex_from(s, i, c) {
  if (i < -1 || i >= s.length) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "String.rindex_from / Bytes.rindex_from"
        ];
  } else {
    return rindex_rec(s, i, c);
  }
}

function contains_from(s, i, c) {
  var l = s.length;
  if (i < 0 || i > l) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "String.contains_from / Bytes.contains_from"
        ];
  } else {
    try {
      index_rec(s, l, i, c);
      return /* true */1;
    }
    catch (exn){
      if (exn === Caml_builtin_exceptions.not_found) {
        return /* false */0;
      } else {
        throw exn;
      }
    }
  }
}

function contains(s, c) {
  return contains_from(s, 0, c);
}

function rcontains_from(s, i, c) {
  if (i < 0 || i >= s.length) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "String.rcontains_from / Bytes.rcontains_from"
        ];
  } else {
    try {
      rindex_rec(s, i, c);
      return /* true */1;
    }
    catch (exn){
      if (exn === Caml_builtin_exceptions.not_found) {
        return /* false */0;
      } else {
        throw exn;
      }
    }
  }
}

var compare = Caml_obj.caml_compare;

var unsafe_to_string = Caml_string.bytes_to_string;

var unsafe_of_string = Caml_string.bytes_of_string;

exports.make = make;
exports.init = init;
exports.empty = empty;
exports.copy = copy;
exports.of_string = of_string;
exports.to_string = to_string;
exports.sub = sub;
exports.sub_string = sub_string;
exports.extend = extend;
exports.fill = fill;
exports.blit = blit;
exports.blit_string = blit_string;
exports.concat = concat;
exports.cat = cat;
exports.iter = iter;
exports.iteri = iteri;
exports.map = map;
exports.mapi = mapi;
exports.trim = trim;
exports.escaped = escaped;
exports.index = index;
exports.rindex = rindex;
exports.index_from = index_from;
exports.rindex_from = rindex_from;
exports.contains = contains;
exports.contains_from = contains_from;
exports.rcontains_from = rcontains_from;
exports.uppercase = uppercase;
exports.lowercase = lowercase;
exports.capitalize = capitalize;
exports.uncapitalize = uncapitalize;
exports.compare = compare;
exports.unsafe_to_string = unsafe_to_string;
exports.unsafe_of_string = unsafe_of_string;
/* No side effect */


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var List = __webpack_require__(19);
var Bytes = __webpack_require__(27);
var Caml_int32 = __webpack_require__(11);
var Caml_string = __webpack_require__(16);
var Caml_primitive = __webpack_require__(20);

function make(n, c) {
  return Caml_string.bytes_to_string(Bytes.make(n, c));
}

function init(n, f) {
  return Caml_string.bytes_to_string(Bytes.init(n, f));
}

function copy(s) {
  return Caml_string.bytes_to_string(Bytes.copy(Caml_string.bytes_of_string(s)));
}

function sub(s, ofs, len) {
  return Caml_string.bytes_to_string(Bytes.sub(Caml_string.bytes_of_string(s), ofs, len));
}

function concat(sep, l) {
  if (l) {
    var hd = l[0];
    var num = [0];
    var len = [0];
    List.iter((function (s) {
            num[0] = num[0] + 1 | 0;
            len[0] = len[0] + s.length | 0;
            return /* () */0;
          }), l);
    var r = Caml_string.caml_create_string(len[0] + Caml_int32.imul(sep.length, num[0] - 1 | 0) | 0);
    Caml_string.caml_blit_string(hd, 0, r, 0, hd.length);
    var pos = [hd.length];
    List.iter((function (s) {
            Caml_string.caml_blit_string(sep, 0, r, pos[0], sep.length);
            pos[0] = pos[0] + sep.length | 0;
            Caml_string.caml_blit_string(s, 0, r, pos[0], s.length);
            pos[0] = pos[0] + s.length | 0;
            return /* () */0;
          }), l[1]);
    return Caml_string.bytes_to_string(r);
  } else {
    return "";
  }
}

function iter(f, s) {
  return Bytes.iter(f, Caml_string.bytes_of_string(s));
}

function iteri(f, s) {
  return Bytes.iteri(f, Caml_string.bytes_of_string(s));
}

function map(f, s) {
  return Caml_string.bytes_to_string(Bytes.map(f, Caml_string.bytes_of_string(s)));
}

function mapi(f, s) {
  return Caml_string.bytes_to_string(Bytes.mapi(f, Caml_string.bytes_of_string(s)));
}

function is_space(param) {
  var switcher = param - 9 | 0;
  if (switcher > 4 || switcher < 0) {
    if (switcher !== 23) {
      return /* false */0;
    } else {
      return /* true */1;
    }
  } else if (switcher !== 2) {
    return /* true */1;
  } else {
    return /* false */0;
  }
}

function trim(s) {
  if (s === "" || !(is_space(s.charCodeAt(0)) || is_space(s.charCodeAt(s.length - 1 | 0)))) {
    return s;
  } else {
    return Caml_string.bytes_to_string(Bytes.trim(Caml_string.bytes_of_string(s)));
  }
}

function escaped(s) {
  var needs_escape = function (_i) {
    while(true) {
      var i = _i;
      if (i >= s.length) {
        return /* false */0;
      } else {
        var match = s.charCodeAt(i);
        if (match >= 32) {
          var switcher = match - 34 | 0;
          if (switcher > 58 || switcher < 0) {
            if (switcher >= 93) {
              return /* true */1;
            } else {
              _i = i + 1 | 0;
              continue ;
              
            }
          } else if (switcher > 57 || switcher < 1) {
            return /* true */1;
          } else {
            _i = i + 1 | 0;
            continue ;
            
          }
        } else {
          return /* true */1;
        }
      }
    };
  };
  if (needs_escape(0)) {
    return Caml_string.bytes_to_string(Bytes.escaped(Caml_string.bytes_of_string(s)));
  } else {
    return s;
  }
}

function index(s, c) {
  return Bytes.index(Caml_string.bytes_of_string(s), c);
}

function rindex(s, c) {
  return Bytes.rindex(Caml_string.bytes_of_string(s), c);
}

function index_from(s, i, c) {
  return Bytes.index_from(Caml_string.bytes_of_string(s), i, c);
}

function rindex_from(s, i, c) {
  return Bytes.rindex_from(Caml_string.bytes_of_string(s), i, c);
}

function contains(s, c) {
  return Bytes.contains(Caml_string.bytes_of_string(s), c);
}

function contains_from(s, i, c) {
  return Bytes.contains_from(Caml_string.bytes_of_string(s), i, c);
}

function rcontains_from(s, i, c) {
  return Bytes.rcontains_from(Caml_string.bytes_of_string(s), i, c);
}

function uppercase(s) {
  return Caml_string.bytes_to_string(Bytes.uppercase(Caml_string.bytes_of_string(s)));
}

function lowercase(s) {
  return Caml_string.bytes_to_string(Bytes.lowercase(Caml_string.bytes_of_string(s)));
}

function capitalize(s) {
  return Caml_string.bytes_to_string(Bytes.capitalize(Caml_string.bytes_of_string(s)));
}

function uncapitalize(s) {
  return Caml_string.bytes_to_string(Bytes.uncapitalize(Caml_string.bytes_of_string(s)));
}

var compare = Caml_primitive.caml_string_compare;

var fill = Bytes.fill;

var blit = Bytes.blit_string;

exports.make = make;
exports.init = init;
exports.copy = copy;
exports.sub = sub;
exports.fill = fill;
exports.blit = blit;
exports.concat = concat;
exports.iter = iter;
exports.iteri = iteri;
exports.map = map;
exports.mapi = mapi;
exports.trim = trim;
exports.escaped = escaped;
exports.index = index;
exports.rindex = rindex;
exports.index_from = index_from;
exports.rindex_from = rindex_from;
exports.contains = contains;
exports.contains_from = contains_from;
exports.rcontains_from = rcontains_from;
exports.uppercase = uppercase;
exports.lowercase = lowercase;
exports.capitalize = capitalize;
exports.uncapitalize = uncapitalize;
exports.compare = compare;
/* No side effect */


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mail_input.18a98bfb.svg";

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/info_icon.6ee9aaf1.svg";

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(66);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var Curry = __webpack_require__(0);
var Caml_builtin_exceptions = __webpack_require__(3);

function $caret(prim, prim$1) {
  return prim + prim$1;
}

var stdout = /* record */[
  /* buffer */"",
  /* output */(function (_, s) {
      var v = s.length - 1 | 0;
      if (( (typeof process !== "undefined") && process.stdout && process.stdout.write)) {
        return ( process.stdout.write )(s);
      } else if (s[v] === "\n") {
        console.log(s.slice(0, v));
        return /* () */0;
      } else {
        console.log(s);
        return /* () */0;
      }
    })
];

var stderr = /* record */[
  /* buffer */"",
  /* output */(function (_, s) {
      var v = s.length - 1 | 0;
      if (s[v] === "\n") {
        console.log(s.slice(0, v));
        return /* () */0;
      } else {
        console.log(s);
        return /* () */0;
      }
    })
];

function caml_ml_open_descriptor_in() {
  throw [
        Caml_builtin_exceptions.failure,
        "caml_ml_open_descriptor_in not implemented"
      ];
}

function caml_ml_open_descriptor_out() {
  throw [
        Caml_builtin_exceptions.failure,
        "caml_ml_open_descriptor_out not implemented"
      ];
}

function caml_ml_flush(oc) {
  if (oc[/* buffer */0] !== "") {
    Curry._2(oc[/* output */1], oc, oc[/* buffer */0]);
    oc[/* buffer */0] = "";
    return /* () */0;
  } else {
    return 0;
  }
}

var node_std_output = (function (s){
   return (typeof process !== "undefined") && process.stdout && (process.stdout.write(s), true);
   }
);

function caml_ml_output(oc, str, offset, len) {
  var str$1 = offset === 0 && len === str.length ? str : str.slice(offset, len);
  if (( (typeof process !== "undefined") && process.stdout && process.stdout.write ) && oc === stdout) {
    return ( process.stdout.write )(str$1);
  } else {
    var id = str$1.lastIndexOf("\n");
    if (id < 0) {
      oc[/* buffer */0] = oc[/* buffer */0] + str$1;
      return /* () */0;
    } else {
      oc[/* buffer */0] = oc[/* buffer */0] + str$1.slice(0, id + 1 | 0);
      caml_ml_flush(oc);
      oc[/* buffer */0] = oc[/* buffer */0] + str$1.slice(id + 1 | 0);
      return /* () */0;
    }
  }
}

function caml_ml_output_char(oc, $$char) {
  return caml_ml_output(oc, String.fromCharCode($$char), 0, 1);
}

function caml_ml_input(_, _$1, _$2, _$3) {
  throw [
        Caml_builtin_exceptions.failure,
        "caml_ml_input ic not implemented"
      ];
}

function caml_ml_input_char() {
  throw [
        Caml_builtin_exceptions.failure,
        "caml_ml_input_char not implemnted"
      ];
}

function caml_ml_out_channels_list() {
  return /* :: */[
          stdout,
          /* :: */[
            stderr,
            /* [] */0
          ]
        ];
}

var stdin = undefined;

exports.$caret = $caret;
exports.stdin = stdin;
exports.stdout = stdout;
exports.stderr = stderr;
exports.caml_ml_open_descriptor_in = caml_ml_open_descriptor_in;
exports.caml_ml_open_descriptor_out = caml_ml_open_descriptor_out;
exports.caml_ml_flush = caml_ml_flush;
exports.node_std_output = node_std_output;
exports.caml_ml_output = caml_ml_output;
exports.caml_ml_output_char = caml_ml_output_char;
exports.caml_ml_input = caml_ml_input;
exports.caml_ml_input_char = caml_ml_input_char;
exports.caml_ml_out_channels_list = caml_ml_out_channels_list;
/* node_std_output Not a pure module */

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var repeat = ( (String.prototype.repeat && function (count,self){return self.repeat(count)}) ||
                                                  function(count , self) {
        if (self.length == 0 || count == 0) {
            return '';
        }
        // Ensuring count is a 31-bit integer allows us to heavily optimize the
        // main part. But anyway, most current (August 2014) browsers can't handle
        // strings 1 << 28 chars or longer, so:
        if (self.length * count >= 1 << 28) {
            throw new RangeError('repeat count must not overflow maximum string size');
        }
        var rpt = '';
        for (;;) {
            if ((count & 1) == 1) {
                rpt += self;
            }
            count >>>= 1;
            if (count == 0) {
                break;
            }
            self += self;
        }
        return rpt;
    }
);

exports.repeat = repeat;
/* repeat Not a pure module */


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Block = __webpack_require__(5);

function erase_rel(param) {
  if (typeof param === "number") {
    return /* End_of_fmtty */0;
  } else {
    switch (param.tag | 0) {
      case 0 : 
          return /* Char_ty */Block.__(0, [erase_rel(param[0])]);
      case 1 : 
          return /* String_ty */Block.__(1, [erase_rel(param[0])]);
      case 2 : 
          return /* Int_ty */Block.__(2, [erase_rel(param[0])]);
      case 3 : 
          return /* Int32_ty */Block.__(3, [erase_rel(param[0])]);
      case 4 : 
          return /* Nativeint_ty */Block.__(4, [erase_rel(param[0])]);
      case 5 : 
          return /* Int64_ty */Block.__(5, [erase_rel(param[0])]);
      case 6 : 
          return /* Float_ty */Block.__(6, [erase_rel(param[0])]);
      case 7 : 
          return /* Bool_ty */Block.__(7, [erase_rel(param[0])]);
      case 8 : 
          return /* Format_arg_ty */Block.__(8, [
                    param[0],
                    erase_rel(param[1])
                  ]);
      case 9 : 
          var ty1 = param[0];
          return /* Format_subst_ty */Block.__(9, [
                    ty1,
                    ty1,
                    erase_rel(param[2])
                  ]);
      case 10 : 
          return /* Alpha_ty */Block.__(10, [erase_rel(param[0])]);
      case 11 : 
          return /* Theta_ty */Block.__(11, [erase_rel(param[0])]);
      case 12 : 
          return /* Any_ty */Block.__(12, [erase_rel(param[0])]);
      case 13 : 
          return /* Reader_ty */Block.__(13, [erase_rel(param[0])]);
      case 14 : 
          return /* Ignored_reader_ty */Block.__(14, [erase_rel(param[0])]);
      
    }
  }
}

function concat_fmtty(fmtty1, fmtty2) {
  if (typeof fmtty1 === "number") {
    return fmtty2;
  } else {
    switch (fmtty1.tag | 0) {
      case 0 : 
          return /* Char_ty */Block.__(0, [concat_fmtty(fmtty1[0], fmtty2)]);
      case 1 : 
          return /* String_ty */Block.__(1, [concat_fmtty(fmtty1[0], fmtty2)]);
      case 2 : 
          return /* Int_ty */Block.__(2, [concat_fmtty(fmtty1[0], fmtty2)]);
      case 3 : 
          return /* Int32_ty */Block.__(3, [concat_fmtty(fmtty1[0], fmtty2)]);
      case 4 : 
          return /* Nativeint_ty */Block.__(4, [concat_fmtty(fmtty1[0], fmtty2)]);
      case 5 : 
          return /* Int64_ty */Block.__(5, [concat_fmtty(fmtty1[0], fmtty2)]);
      case 6 : 
          return /* Float_ty */Block.__(6, [concat_fmtty(fmtty1[0], fmtty2)]);
      case 7 : 
          return /* Bool_ty */Block.__(7, [concat_fmtty(fmtty1[0], fmtty2)]);
      case 8 : 
          return /* Format_arg_ty */Block.__(8, [
                    fmtty1[0],
                    concat_fmtty(fmtty1[1], fmtty2)
                  ]);
      case 9 : 
          return /* Format_subst_ty */Block.__(9, [
                    fmtty1[0],
                    fmtty1[1],
                    concat_fmtty(fmtty1[2], fmtty2)
                  ]);
      case 10 : 
          return /* Alpha_ty */Block.__(10, [concat_fmtty(fmtty1[0], fmtty2)]);
      case 11 : 
          return /* Theta_ty */Block.__(11, [concat_fmtty(fmtty1[0], fmtty2)]);
      case 12 : 
          return /* Any_ty */Block.__(12, [concat_fmtty(fmtty1[0], fmtty2)]);
      case 13 : 
          return /* Reader_ty */Block.__(13, [concat_fmtty(fmtty1[0], fmtty2)]);
      case 14 : 
          return /* Ignored_reader_ty */Block.__(14, [concat_fmtty(fmtty1[0], fmtty2)]);
      
    }
  }
}

function concat_fmt(fmt1, fmt2) {
  if (typeof fmt1 === "number") {
    return fmt2;
  } else {
    switch (fmt1.tag | 0) {
      case 0 : 
          return /* Char */Block.__(0, [concat_fmt(fmt1[0], fmt2)]);
      case 1 : 
          return /* Caml_char */Block.__(1, [concat_fmt(fmt1[0], fmt2)]);
      case 2 : 
          return /* String */Block.__(2, [
                    fmt1[0],
                    concat_fmt(fmt1[1], fmt2)
                  ]);
      case 3 : 
          return /* Caml_string */Block.__(3, [
                    fmt1[0],
                    concat_fmt(fmt1[1], fmt2)
                  ]);
      case 4 : 
          return /* Int */Block.__(4, [
                    fmt1[0],
                    fmt1[1],
                    fmt1[2],
                    concat_fmt(fmt1[3], fmt2)
                  ]);
      case 5 : 
          return /* Int32 */Block.__(5, [
                    fmt1[0],
                    fmt1[1],
                    fmt1[2],
                    concat_fmt(fmt1[3], fmt2)
                  ]);
      case 6 : 
          return /* Nativeint */Block.__(6, [
                    fmt1[0],
                    fmt1[1],
                    fmt1[2],
                    concat_fmt(fmt1[3], fmt2)
                  ]);
      case 7 : 
          return /* Int64 */Block.__(7, [
                    fmt1[0],
                    fmt1[1],
                    fmt1[2],
                    concat_fmt(fmt1[3], fmt2)
                  ]);
      case 8 : 
          return /* Float */Block.__(8, [
                    fmt1[0],
                    fmt1[1],
                    fmt1[2],
                    concat_fmt(fmt1[3], fmt2)
                  ]);
      case 9 : 
          return /* Bool */Block.__(9, [concat_fmt(fmt1[0], fmt2)]);
      case 10 : 
          return /* Flush */Block.__(10, [concat_fmt(fmt1[0], fmt2)]);
      case 11 : 
          return /* String_literal */Block.__(11, [
                    fmt1[0],
                    concat_fmt(fmt1[1], fmt2)
                  ]);
      case 12 : 
          return /* Char_literal */Block.__(12, [
                    fmt1[0],
                    concat_fmt(fmt1[1], fmt2)
                  ]);
      case 13 : 
          return /* Format_arg */Block.__(13, [
                    fmt1[0],
                    fmt1[1],
                    concat_fmt(fmt1[2], fmt2)
                  ]);
      case 14 : 
          return /* Format_subst */Block.__(14, [
                    fmt1[0],
                    fmt1[1],
                    concat_fmt(fmt1[2], fmt2)
                  ]);
      case 15 : 
          return /* Alpha */Block.__(15, [concat_fmt(fmt1[0], fmt2)]);
      case 16 : 
          return /* Theta */Block.__(16, [concat_fmt(fmt1[0], fmt2)]);
      case 17 : 
          return /* Formatting_lit */Block.__(17, [
                    fmt1[0],
                    concat_fmt(fmt1[1], fmt2)
                  ]);
      case 18 : 
          return /* Formatting_gen */Block.__(18, [
                    fmt1[0],
                    concat_fmt(fmt1[1], fmt2)
                  ]);
      case 19 : 
          return /* Reader */Block.__(19, [concat_fmt(fmt1[0], fmt2)]);
      case 20 : 
          return /* Scan_char_set */Block.__(20, [
                    fmt1[0],
                    fmt1[1],
                    concat_fmt(fmt1[2], fmt2)
                  ]);
      case 21 : 
          return /* Scan_get_counter */Block.__(21, [
                    fmt1[0],
                    concat_fmt(fmt1[1], fmt2)
                  ]);
      case 22 : 
          return /* Scan_next_char */Block.__(22, [concat_fmt(fmt1[0], fmt2)]);
      case 23 : 
          return /* Ignored_param */Block.__(23, [
                    fmt1[0],
                    concat_fmt(fmt1[1], fmt2)
                  ]);
      case 24 : 
          return /* Custom */Block.__(24, [
                    fmt1[0],
                    fmt1[1],
                    concat_fmt(fmt1[2], fmt2)
                  ]);
      
    }
  }
}

exports.concat_fmtty = concat_fmtty;
exports.erase_rel = erase_rel;
exports.concat_fmt = concat_fmt;
/* No side effect */


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compose = exports.merge = exports.$ = exports.style = exports.presets = exports.keyframes = exports.fontFace = exports.insertGlobal = exports.insertRule = exports.plugins = exports.styleSheet = undefined;
exports.speedy = speedy;
exports.simulations = simulations;
exports.simulate = simulate;
exports.cssLabels = cssLabels;
exports.isLikeRule = isLikeRule;
exports.idFor = idFor;
exports.css = css;
exports.rehydrate = rehydrate;
exports.flush = flush;
exports.select = select;
exports.parent = parent;
exports.media = media;
exports.pseudo = pseudo;
exports.active = active;
exports.any = any;
exports.checked = checked;
exports.disabled = disabled;
exports.empty = empty;
exports.enabled = enabled;
exports._default = _default;
exports.first = first;
exports.firstChild = firstChild;
exports.firstOfType = firstOfType;
exports.fullscreen = fullscreen;
exports.focus = focus;
exports.hover = hover;
exports.indeterminate = indeterminate;
exports.inRange = inRange;
exports.invalid = invalid;
exports.lastChild = lastChild;
exports.lastOfType = lastOfType;
exports.left = left;
exports.link = link;
exports.onlyChild = onlyChild;
exports.onlyOfType = onlyOfType;
exports.optional = optional;
exports.outOfRange = outOfRange;
exports.readOnly = readOnly;
exports.readWrite = readWrite;
exports.required = required;
exports.right = right;
exports.root = root;
exports.scope = scope;
exports.target = target;
exports.valid = valid;
exports.visited = visited;
exports.dir = dir;
exports.lang = lang;
exports.not = not;
exports.nthChild = nthChild;
exports.nthLastChild = nthLastChild;
exports.nthLastOfType = nthLastOfType;
exports.nthOfType = nthOfType;
exports.after = after;
exports.before = before;
exports.firstLetter = firstLetter;
exports.firstLine = firstLine;
exports.selection = selection;
exports.backdrop = backdrop;
exports.placeholder = placeholder;
exports.cssFor = cssFor;
exports.attribsFor = attribsFor;

var _objectAssign = __webpack_require__(18);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _sheet = __webpack_require__(75);

var _CSSPropertyOperations = __webpack_require__(37);

var _clean = __webpack_require__(83);

var _clean2 = _interopRequireDefault(_clean);

var _plugins = __webpack_require__(84);

var _hash = __webpack_require__(101);

var _hash2 = _interopRequireDefault(_hash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/* stylesheet */


var styleSheet = exports.styleSheet = new _sheet.StyleSheet();
// an isomorphic StyleSheet shim. hides all the nitty gritty.

// /**************** LIFTOFF IN 3... 2... 1... ****************/
styleSheet.inject(); //eslint-disable-line indent
// /****************      TO THE MOOOOOOON     ****************/

// convenience function to toggle speedy
function speedy(bool) {
  return styleSheet.speedy(bool);
}

// plugins
// we include these by default
var plugins = exports.plugins = styleSheet.plugins = new _plugins.PluginSet([_plugins.prefixes, _plugins.contentWrap, _plugins.fallbacks]);
plugins.media = new _plugins.PluginSet(); // neat! media, font-face, keyframes
plugins.fontFace = new _plugins.PluginSet();
plugins.keyframes = new _plugins.PluginSet([_plugins.prefixes, _plugins.fallbacks]);

// define some constants

var isDev = "production" === 'development' || !"production";
var isTest = "production" === 'test';
var isBrowser = typeof window !== 'undefined';

/**** simulations  ****/

// a flag to enable simulation meta tags on dom nodes
// defaults to true in dev mode. recommend *not* to
// toggle often.
var canSimulate = isDev;

// we use these flags for issuing warnings when simulate is called
// in prod / in incorrect order
var warned1 = false,
    warned2 = false;

// toggles simulation activity. shouldn't be needed in most cases
function simulations() {
  var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  canSimulate = !!bool;
}

// use this on dom nodes to 'simulate' pseudoclasses
// <div {...hover({ color: 'red' })} {...simulate('hover', 'visited')}>...</div>
// you can even send in some weird ones, as long as it's in simple format
// and matches an existing rule on the element
// eg simulate('nthChild2', ':hover:active') etc
function simulate() {
  for (var _len = arguments.length, pseudos = Array(_len), _key = 0; _key < _len; _key++) {
    pseudos[_key] = arguments[_key];
  }

  pseudos = (0, _clean2.default)(pseudos);
  if (!pseudos) return {};
  if (!canSimulate) {
    if (!warned1) {
      console.warn('can\'t simulate without once calling simulations(true)'); //eslint-disable-line no-console
      warned1 = true;
    }
    if (!isDev && !isTest && !warned2) {
      console.warn('don\'t use simulation outside dev'); //eslint-disable-line no-console
      warned2 = true;
    }
    return {};
  }
  return pseudos.reduce(function (o, p) {
    return o['data-simulate-' + simple(p)] = '', o;
  }, {});
}

/**** labels ****/
// toggle for debug labels.
// *shouldn't* have to mess with this manually
var hasLabels = isDev;

function cssLabels(bool) {
  hasLabels = !!bool;
}

// takes a string, converts to lowercase, strips out nonalphanumeric.
function simple(str) {
  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return str.toLowerCase().replace(/[^a-z0-9]/g, char);
}

// hashes a string to something 'unique'
// we use this to generate ids for styles


function hashify(obj) {
  var str = JSON.stringify(obj);
  var toRet = (0, _hash2.default)(str).toString(36);
  if (obj.label && obj.label.length > 0 && isDev) {
    return simple(obj.label.join('.'), '-') + '-' + toRet;
  }
  return toRet;
}

// of shape { 'data-css-<id>': '' }
function isLikeRule(rule) {
  var keys = Object.keys(rule).filter(function (x) {
    return x !== 'toString';
  });
  if (keys.length !== 1) {
    return false;
  }
  return !!/data\-css\-([a-zA-Z0-9\-_]+)/.exec(keys[0]);
}

// extracts id from a { 'data-css-<id>': ''} like object
function idFor(rule) {
  var keys = Object.keys(rule).filter(function (x) {
    return x !== 'toString';
  });
  if (keys.length !== 1) throw new Error('not a rule');
  var regex = /data\-css\-([a-zA-Z0-9\-_]+)/;
  var match = regex.exec(keys[0]);
  if (!match) throw new Error('not a rule');
  return match[1];
}

// from https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61

// "Tokenizes" the selectors into parts relevant for the next function.
// Strings and comments are matched, but ignored afterwards.
// This is not a full tokenizers. It only recognizes comas, parentheses,
// strings and comments.
// regexp generated by scripts/regexps.js then trimmed by hand
var selectorTokenizer = /[(),]|"(?:\\.|[^"\n])*"|'(?:\\.|[^'\n])*'|\/\*[\s\S]*?\*\//g;

/**
 * This will split a coma-separated selector list into individual selectors,
 * ignoring comas in strings, comments and in :pseudo-selectors(parameter, lists).
 *
 * @param {string} selector
 * @return {string[]}
 */

function splitSelector(selector) {
  if (selector.indexOf(',') === -1) {
    return [selector];
  }

  var indices = [],
      res = [],
      inParen = 0,
      o;
  /*eslint-disable no-cond-assign*/
  while (o = selectorTokenizer.exec(selector)) {
    /*eslint-enable no-cond-assign*/
    switch (o[0]) {
      case '(':
        inParen++;break;
      case ')':
        inParen--;break;
      case ',':
        if (inParen) break;indices.push(o.index);
    }
  }
  for (o = indices.length; o--;) {
    res.unshift(selector.slice(indices[o] + 1));
    selector = selector.slice(0, indices[o]);
  }
  res.unshift(selector);
  return res;
}

function selector(id, path) {
  if (!id) {
    return path.replace(/\&/g, '');
  }
  if (!path) return '.css-' + id + ',[data-css-' + id + ']';

  var x = splitSelector(path).map(function (x) {
    return x.indexOf('&') >= 0 ? [x.replace(/\&/mg, '.css-' + id), x.replace(/\&/mg, '[data-css-' + id + ']')].join(',') // todo - make sure each sub selector has an &
    : '.css-' + id + x + ',[data-css-' + id + ']' + x;
  }).join(',');

  if (canSimulate && /^\&\:/.exec(path) && !/\s/.exec(path)) {
    x += ',.css-' + id + '[data-simulate-' + simple(path) + '],[data-css-' + id + '][data-simulate-' + simple(path) + ']';
  }
  return x;
}

// end https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61


function toCSS(_ref) {
  var selector = _ref.selector,
      style = _ref.style;

  var result = plugins.transform({ selector: selector, style: style });
  return result.selector + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
}

function deconstruct(style) {
  // we can be sure it's not infinitely nested here
  var plain = void 0,
      selects = void 0,
      medias = void 0,
      supports = void 0;
  Object.keys(style).forEach(function (key) {
    if (key.indexOf('&') >= 0) {
      selects = selects || {};
      selects[key] = style[key];
    } else if (key.indexOf('@media') === 0) {
      medias = medias || {};
      medias[key] = deconstruct(style[key]);
    } else if (key.indexOf('@supports') === 0) {
      supports = supports || {};
      supports[key] = deconstruct(style[key]);
    } else if (key === 'label') {
      if (style.label.length > 0) {
        plain = plain || {};
        plain.label = hasLabels ? style.label.join('.') : '';
      }
    } else {
      plain = plain || {};
      plain[key] = style[key];
    }
  });
  return { plain: plain, selects: selects, medias: medias, supports: supports };
}

function deconstructedStyleToCSS(id, style) {
  var css = [];

  // plugins here
  var plain = style.plain,
      selects = style.selects,
      medias = style.medias,
      supports = style.supports;

  if (plain) {
    css.push(toCSS({ style: plain, selector: selector(id) }));
  }
  if (selects) {
    Object.keys(selects).forEach(function (key) {
      return css.push(toCSS({ style: selects[key], selector: selector(id, key) }));
    });
  }
  if (medias) {
    Object.keys(medias).forEach(function (key) {
      return css.push(key + '{' + deconstructedStyleToCSS(id, medias[key]).join('') + '}');
    });
  }
  if (supports) {
    Object.keys(supports).forEach(function (key) {
      return css.push(key + '{' + deconstructedStyleToCSS(id, supports[key]).join('') + '}');
    });
  }
  return css;
}

// this cache to track which rules have
// been inserted into the stylesheet
var inserted = styleSheet.inserted = {};

// and helpers to insert rules into said styleSheet
function insert(spec) {
  if (!inserted[spec.id]) {
    inserted[spec.id] = true;
    var deconstructed = deconstruct(spec.style);
    var rules = deconstructedStyleToCSS(spec.id, deconstructed);
    inserted[spec.id] = isBrowser ? true : rules;
    rules.forEach(function (cssRule) {
      return styleSheet.insert(cssRule);
    });
  }
}

// a simple cache to store generated rules
var registered = styleSheet.registered = {};
function register(spec) {
  if (!registered[spec.id]) {
    registered[spec.id] = spec;
  }
}

function _getRegistered(rule) {
  if (isLikeRule(rule)) {
    var ret = registered[idFor(rule)];
    if (ret == null) {
      throw new Error('[glamor] an unexpected rule cache miss occurred. This is probably a sign of multiple glamor instances in your app. See https://github.com/threepointone/glamor/issues/79');
    }
    return ret;
  }
  return rule;
}

// todo - perf
var ruleCache = {};
function toRule(spec) {
  register(spec);
  insert(spec);

  if (ruleCache[spec.id]) {
    return ruleCache[spec.id];
  }

  var ret = _defineProperty({}, 'data-css-' + spec.id, hasLabels ? spec.label || '' : '');
  Object.defineProperty(ret, 'toString', {
    enumerable: false, value: function value() {
      return 'css-' + spec.id;
    }
  });
  ruleCache[spec.id] = ret;
  return ret;
}

function log() {
  //eslint-disable-line no-unused-vars
  console.log(this); //eslint-disable-line no-console
  return this;
}

function isSelector(key) {
  var possibles = [':', '.', '[', '>', ' '],
      found = false,
      ch = key.charAt(0);
  for (var i = 0; i < possibles.length; i++) {
    if (ch === possibles[i]) {
      found = true;
      break;
    }
  }
  return found || key.indexOf('&') >= 0;
}

function joinSelectors(a, b) {
  var as = splitSelector(a).map(function (a) {
    return !(a.indexOf('&') >= 0) ? '&' + a : a;
  });
  var bs = splitSelector(b).map(function (b) {
    return !(b.indexOf('&') >= 0) ? '&' + b : b;
  });

  return bs.reduce(function (arr, b) {
    return arr.concat(as.map(function (a) {
      return b.replace(/\&/g, a);
    }));
  }, []).join(',');
}

function joinMediaQueries(a, b) {
  return a ? '@media ' + a.substring(6) + ' and ' + b.substring(6) : b;
}

function isMediaQuery(key) {
  return key.indexOf('@media') === 0;
}

function isSupports(key) {
  return key.indexOf('@supports') === 0;
}

function joinSupports(a, b) {
  return a ? '@supports ' + a.substring(9) + ' and ' + b.substring(9) : b;
}

// flatten a nested array
function flatten(inArr) {
  var arr = [];
  for (var i = 0; i < inArr.length; i++) {
    if (Array.isArray(inArr[i])) arr = arr.concat(flatten(inArr[i]));else arr = arr.concat(inArr[i]);
  }
  return arr;
}

var prefixedPseudoSelectors = {
  '::placeholder': ['::-webkit-input-placeholder', '::-moz-placeholder', '::-ms-input-placeholder'],
  ':fullscreen': [':-webkit-full-screen', ':-moz-full-screen', ':-ms-fullscreen']

  // mutable! modifies dest.
};function build(dest, _ref2) {
  var _ref2$selector = _ref2.selector,
      selector = _ref2$selector === undefined ? '' : _ref2$selector,
      _ref2$mq = _ref2.mq,
      mq = _ref2$mq === undefined ? '' : _ref2$mq,
      _ref2$supp = _ref2.supp,
      supp = _ref2$supp === undefined ? '' : _ref2$supp,
      _ref2$src = _ref2.src,
      src = _ref2$src === undefined ? {} : _ref2$src;


  if (!Array.isArray(src)) {
    src = [src];
  }
  src = flatten(src);

  src.forEach(function (_src) {
    if (isLikeRule(_src)) {
      var reg = _getRegistered(_src);
      if (reg.type !== 'css') {
        throw new Error('cannot merge this rule');
      }
      _src = reg.style;
    }
    _src = (0, _clean2.default)(_src);
    if (_src && _src.composes) {
      build(dest, { selector: selector, mq: mq, supp: supp, src: _src.composes });
    }
    Object.keys(_src || {}).forEach(function (key) {
      if (isSelector(key)) {

        if (prefixedPseudoSelectors[key]) {
          prefixedPseudoSelectors[key].forEach(function (p) {
            return build(dest, { selector: joinSelectors(selector, p), mq: mq, supp: supp, src: _src[key] });
          });
        }

        build(dest, { selector: joinSelectors(selector, key), mq: mq, supp: supp, src: _src[key] });
      } else if (isMediaQuery(key)) {
        build(dest, { selector: selector, mq: joinMediaQueries(mq, key), supp: supp, src: _src[key] });
      } else if (isSupports(key)) {
        build(dest, { selector: selector, mq: mq, supp: joinSupports(supp, key), src: _src[key] });
      } else if (key === 'composes') {
        // ignore, we already dealth with it
      } else {
        var _dest = dest;
        if (supp) {
          _dest[supp] = _dest[supp] || {};
          _dest = _dest[supp];
        }
        if (mq) {
          _dest[mq] = _dest[mq] || {};
          _dest = _dest[mq];
        }
        if (selector) {
          _dest[selector] = _dest[selector] || {};
          _dest = _dest[selector];
        }

        if (key === 'label') {
          if (hasLabels) {
            dest.label = dest.label.concat(_src.label);
          }
        } else {
          _dest[key] = _src[key];
        }
      }
    });
  });
}

function _css(rules) {
  var style = { label: [] };
  build(style, { src: rules }); // mutative! but worth it.

  var spec = {
    id: hashify(style),
    style: style, label: hasLabels ? style.label.join('.') : '',
    type: 'css'
  };
  return toRule(spec);
}

var nullrule = {
  // 'data-css-nil': ''
};
Object.defineProperty(nullrule, 'toString', {
  enumerable: false, value: function value() {
    return 'css-nil';
  }
});

var inputCaches = typeof WeakMap !== 'undefined' ? [nullrule, new WeakMap(), new WeakMap(), new WeakMap()] : [nullrule];

var warnedWeakMapError = false;
function multiIndexCache(fn) {
  return function (args) {
    if (inputCaches[args.length]) {
      var coi = inputCaches[args.length];
      var ctr = 0;
      while (ctr < args.length - 1) {
        if (!coi.has(args[ctr])) {
          coi.set(args[ctr], new WeakMap());
        }
        coi = coi.get(args[ctr]);
        ctr++;
      }
      if (coi.has(args[args.length - 1])) {
        var ret = coi.get(args[ctr]);

        if (registered[ret.toString().substring(4)]) {
          // make sure it hasn't been flushed
          return ret;
        }
      }
    }
    var value = fn(args);
    if (inputCaches[args.length]) {
      var _ctr = 0,
          _coi = inputCaches[args.length];
      while (_ctr < args.length - 1) {
        _coi = _coi.get(args[_ctr]);
        _ctr++;
      }
      try {
        _coi.set(args[_ctr], value);
      } catch (err) {
        if (isDev && !warnedWeakMapError) {
          var _console;

          warnedWeakMapError = true;
          (_console = console).warn.apply(_console, ['failed setting the WeakMap cache for args:'].concat(_toConsumableArray(args))); // eslint-disable-line no-console
          console.warn('this should NOT happen, please file a bug on the github repo.'); // eslint-disable-line no-console
        }
      }
    }
    return value;
  };
}

var cachedCss = typeof WeakMap !== 'undefined' ? multiIndexCache(_css) : _css;

function css() {
  for (var _len2 = arguments.length, rules = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    rules[_key2] = arguments[_key2];
  }

  if (rules[0] && rules[0].length && rules[0].raw) {
    throw new Error('you forgot to include glamor/babel in your babel plugins.');
  }

  rules = (0, _clean2.default)(rules);
  if (!rules) {
    return nullrule;
  }

  return cachedCss(rules);
}

css.insert = function (css) {
  var spec = {
    id: hashify(css),
    css: css,
    type: 'raw'
  };
  register(spec);
  if (!inserted[spec.id]) {
    styleSheet.insert(spec.css);
    inserted[spec.id] = isBrowser ? true : [spec.css];
  }
};

var insertRule = exports.insertRule = css.insert;

css.global = function (selector, style) {
  style = (0, _clean2.default)(style);
  if (style) {
    return css.insert(toCSS({ selector: selector, style: style }));
  }
};

var insertGlobal = exports.insertGlobal = css.global;

function insertKeyframe(spec) {
  if (!inserted[spec.id]) {
    var inner = Object.keys(spec.keyframes).map(function (kf) {
      var result = plugins.keyframes.transform({ id: spec.id, name: kf, style: spec.keyframes[kf] });
      return result.name + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
    }).join('');

    var rules = ['-webkit-', '-moz-', '-o-', ''].map(function (prefix) {
      return '@' + prefix + 'keyframes ' + (spec.name + '_' + spec.id) + '{' + inner + '}';
    });
    rules.forEach(function (rule) {
      return styleSheet.insert(rule);
    });

    inserted[spec.id] = isBrowser ? true : rules;
  }
}
css.keyframes = function (name, kfs) {
  if (!kfs) {
    kfs = name, name = 'animation';
  }

  // do not ignore empty keyframe definitions for now.
  kfs = (0, _clean2.default)(kfs) || {};
  var spec = {
    id: hashify({ name: name, kfs: kfs }),
    type: 'keyframes',
    name: name,
    keyframes: kfs
  };
  register(spec);
  insertKeyframe(spec);
  return name + '_' + spec.id;
};

// we don't go all out for fonts as much, giving a simple font loading strategy
// use a fancier lib if you need moar power
css.fontFace = function (font) {
  font = (0, _clean2.default)(font);
  var spec = {
    id: hashify(font),
    type: 'font-face',
    font: font
  };
  register(spec);
  insertFontFace(spec);

  return font.fontFamily;
};

var fontFace = exports.fontFace = css.fontFace;
var keyframes = exports.keyframes = css.keyframes;

function insertFontFace(spec) {
  if (!inserted[spec.id]) {
    var rule = '@font-face{' + (0, _CSSPropertyOperations.createMarkupForStyles)(spec.font) + '}';
    styleSheet.insert(rule);
    inserted[spec.id] = isBrowser ? true : [rule];
  }
}

// rehydrate the insertion cache with ids sent from
// renderStatic / renderStaticOptimized
function rehydrate(ids) {
  // load up ids
  (0, _objectAssign2.default)(inserted, ids.reduce(function (o, i) {
    return o[i] = true, o;
  }, {}));
  // assume css loaded separately
}

// clears out the cache and empties the stylesheet
// best for tests, though there might be some value for SSR.

function flush() {
  inserted = styleSheet.inserted = {};
  registered = styleSheet.registered = {};
  ruleCache = {};
  styleSheet.flush();
  styleSheet.inject();
}

var presets = exports.presets = {
  mobile: '(min-width: 400px)',
  Mobile: '@media (min-width: 400px)',
  phablet: '(min-width: 550px)',
  Phablet: '@media (min-width: 550px)',
  tablet: '(min-width: 750px)',
  Tablet: '@media (min-width: 750px)',
  desktop: '(min-width: 1000px)',
  Desktop: '@media (min-width: 1000px)',
  hd: '(min-width: 1200px)',
  Hd: '@media (min-width: 1200px)'
};

var style = exports.style = css;

function select(selector) {
  for (var _len3 = arguments.length, styles = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    styles[_key3 - 1] = arguments[_key3];
  }

  if (!selector) {
    return style(styles);
  }
  return css(_defineProperty({}, selector, styles));
}
var $ = exports.$ = select;

function parent(selector) {
  for (var _len4 = arguments.length, styles = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    styles[_key4 - 1] = arguments[_key4];
  }

  return css(_defineProperty({}, selector + ' &', styles));
}

var merge = exports.merge = css;
var compose = exports.compose = css;

function media(query) {
  for (var _len5 = arguments.length, rules = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    rules[_key5 - 1] = arguments[_key5];
  }

  return css(_defineProperty({}, '@media ' + query, rules));
}

function pseudo(selector) {
  for (var _len6 = arguments.length, styles = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    styles[_key6 - 1] = arguments[_key6];
  }

  return css(_defineProperty({}, selector, styles));
}

// allllll the pseudoclasses

function active(x) {
  return pseudo(':active', x);
}

function any(x) {
  return pseudo(':any', x);
}

function checked(x) {
  return pseudo(':checked', x);
}

function disabled(x) {
  return pseudo(':disabled', x);
}

function empty(x) {
  return pseudo(':empty', x);
}

function enabled(x) {
  return pseudo(':enabled', x);
}

function _default(x) {
  return pseudo(':default', x); // note '_default' name
}

function first(x) {
  return pseudo(':first', x);
}

function firstChild(x) {
  return pseudo(':first-child', x);
}

function firstOfType(x) {
  return pseudo(':first-of-type', x);
}

function fullscreen(x) {
  return pseudo(':fullscreen', x);
}

function focus(x) {
  return pseudo(':focus', x);
}

function hover(x) {
  return pseudo(':hover', x);
}

function indeterminate(x) {
  return pseudo(':indeterminate', x);
}

function inRange(x) {
  return pseudo(':in-range', x);
}

function invalid(x) {
  return pseudo(':invalid', x);
}

function lastChild(x) {
  return pseudo(':last-child', x);
}

function lastOfType(x) {
  return pseudo(':last-of-type', x);
}

function left(x) {
  return pseudo(':left', x);
}

function link(x) {
  return pseudo(':link', x);
}

function onlyChild(x) {
  return pseudo(':only-child', x);
}

function onlyOfType(x) {
  return pseudo(':only-of-type', x);
}

function optional(x) {
  return pseudo(':optional', x);
}

function outOfRange(x) {
  return pseudo(':out-of-range', x);
}

function readOnly(x) {
  return pseudo(':read-only', x);
}

function readWrite(x) {
  return pseudo(':read-write', x);
}

function required(x) {
  return pseudo(':required', x);
}

function right(x) {
  return pseudo(':right', x);
}

function root(x) {
  return pseudo(':root', x);
}

function scope(x) {
  return pseudo(':scope', x);
}

function target(x) {
  return pseudo(':target', x);
}

function valid(x) {
  return pseudo(':valid', x);
}

function visited(x) {
  return pseudo(':visited', x);
}

// parameterized pseudoclasses
function dir(p, x) {
  return pseudo(':dir(' + p + ')', x);
}
function lang(p, x) {
  return pseudo(':lang(' + p + ')', x);
}
function not(p, x) {
  // should this be a plugin?
  var selector = p.split(',').map(function (x) {
    return x.trim();
  }).map(function (x) {
    return ':not(' + x + ')';
  });
  if (selector.length === 1) {
    return pseudo(':not(' + p + ')', x);
  }
  return select(selector.join(''), x);
}
function nthChild(p, x) {
  return pseudo(':nth-child(' + p + ')', x);
}
function nthLastChild(p, x) {
  return pseudo(':nth-last-child(' + p + ')', x);
}
function nthLastOfType(p, x) {
  return pseudo(':nth-last-of-type(' + p + ')', x);
}
function nthOfType(p, x) {
  return pseudo(':nth-of-type(' + p + ')', x);
}

// pseudoelements
function after(x) {
  return pseudo('::after', x);
}
function before(x) {
  return pseudo('::before', x);
}
function firstLetter(x) {
  return pseudo('::first-letter', x);
}
function firstLine(x) {
  return pseudo('::first-line', x);
}
function selection(x) {
  return pseudo('::selection', x);
}
function backdrop(x) {
  return pseudo('::backdrop', x);
}
function placeholder(x) {
  // https://github.com/threepointone/glamor/issues/14
  return css({ '::placeholder': x });
}

/*** helpers for web components ***/
// https://github.com/threepointone/glamor/issues/16

function cssFor() {
  for (var _len7 = arguments.length, rules = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    rules[_key7] = arguments[_key7];
  }

  rules = (0, _clean2.default)(rules);
  return rules ? rules.map(function (r) {
    var style = { label: [] };
    build(style, { src: r }); // mutative! but worth it.
    return deconstructedStyleToCSS(hashify(style), deconstruct(style)).join('');
  }).join('') : '';
}

function attribsFor() {
  for (var _len8 = arguments.length, rules = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    rules[_key8] = arguments[_key8];
  }

  rules = (0, _clean2.default)(rules);
  var htmlAttributes = rules ? rules.map(function (rule) {
    idFor(rule); // throwaway check for rule
    var key = Object.keys(rule)[0],
        value = rule[key];
    return key + '="' + (value || '') + '"';
  }).join(' ') : '';

  return htmlAttributes;
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processStyleName = undefined;
exports.createMarkupForStyles = createMarkupForStyles;

var _camelizeStyleName = __webpack_require__(76);

var _camelizeStyleName2 = _interopRequireDefault(_camelizeStyleName);

var _dangerousStyleValue = __webpack_require__(78);

var _dangerousStyleValue2 = _interopRequireDefault(_dangerousStyleValue);

var _hyphenateStyleName = __webpack_require__(80);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _memoizeStringOnly = __webpack_require__(82);

var _memoizeStringOnly2 = _interopRequireDefault(_memoizeStringOnly);

var _warning = __webpack_require__(38);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var processStyleName = exports.processStyleName = (0, _memoizeStringOnly2.default)(_hyphenateStyleName2.default); /**
                                                                                                                   * Copyright 2013-present, Facebook, Inc.
                                                                                                                   * All rights reserved.
                                                                                                                   *
                                                                                                                   * This source code is licensed under the BSD-style license found in the
                                                                                                                   * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                   * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                   *
                                                                                                                   * @providesModule CSSPropertyOperations
                                                                                                                   */

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported style property %s. Did you mean %s?%s', name, (0, _camelizeStyleName2.default)(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function checkRenderMessage(owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function warnValidStyle(name, value, component) {
    //eslint-disable-line no-var
    var owner = void 0;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */

function createMarkupForStyles(styles, component) {
  var serialized = '';
  for (var styleName in styles) {
    var isCustomProp = styleName.indexOf('--') === 0;
    if (!styles.hasOwnProperty(styleName)) {
      continue;
    }
    if (styleName === 'label') {
      continue;
    }
    var styleValue = styles[styleName];
    if (false) {
      warnValidStyle(styleName, styleValue, component);
    }
    if (styleValue != null) {
      if (isCustomProp) {
        serialized += styleName + ':' + styleValue + ';';
      } else {
        serialized += processStyleName(styleName) + ':';
        serialized += (0, _dangerousStyleValue2.default)(styleName, styleValue, component) + ';';
      }
    }
  }
  return serialized || null;
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(26);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var unsafeDeleteKey = (
  function(dict,key){
     delete dict[key];
     return 0
   }
);

function entries(dict) {
  var keys = Object.keys(dict);
  var l = keys.length;
  var values = new Array(l);
  for(var i = 0 ,i_finish = l - 1 | 0; i <= i_finish; ++i){
    var key = keys[i];
    values[i] = /* tuple */[
      key,
      dict[key]
    ];
  }
  return values;
}

function values(dict) {
  var keys = Object.keys(dict);
  var l = keys.length;
  var values$1 = new Array(l);
  for(var i = 0 ,i_finish = l - 1 | 0; i <= i_finish; ++i){
    values$1[i] = dict[keys[i]];
  }
  return values$1;
}

function fromList(entries) {
  var dict = { };
  var _param = entries;
  while(true) {
    var param = _param;
    if (param) {
      var match = param[0];
      dict[match[0]] = match[1];
      _param = param[1];
      continue ;
      
    } else {
      return dict;
    }
  };
}

function fromArray(entries) {
  var dict = { };
  var l = entries.length;
  for(var i = 0 ,i_finish = l - 1 | 0; i <= i_finish; ++i){
    var match = entries[i];
    dict[match[0]] = match[1];
  }
  return dict;
}

function map(f, source) {
  var target = { };
  var keys = Object.keys(source);
  var l = keys.length;
  for(var i = 0 ,i_finish = l - 1 | 0; i <= i_finish; ++i){
    var key = keys[i];
    target[key] = f(source[key]);
  }
  return target;
}

exports.unsafeDeleteKey = unsafeDeleteKey;
exports.entries = entries;
exports.values = values;
exports.fromList = fromList;
exports.fromArray = fromArray;
exports.map = map;
/* unsafeDeleteKey Not a pure module */


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Js_exn = __webpack_require__(10);
var Caml_exceptions = __webpack_require__(22);

var ParseError = Caml_exceptions.create("Json.ParseError");

function parse(s) {
  try {
    return /* Some */[JSON.parse(s)];
  }
  catch (exn){
    return /* None */0;
  }
}

function parseOrRaise(s) {
  try {
    return JSON.parse(s);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Js_exn.$$Error) {
      var match = exn[1].message;
      var message = match !== undefined ? match : "Unknown error";
      throw [
            ParseError,
            message
          ];
    } else {
      throw exn;
    }
  }
}

var Decode = 0;

var Encode = 0;

function stringify(prim) {
  return JSON.stringify(prim);
}

exports.Decode = Decode;
exports.Encode = Encode;
exports.ParseError = ParseError;
exports.parse = parse;
exports.parseOrRaise = parseOrRaise;
exports.stringify = stringify;
/* No side effect */


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



function to_js_boolean(b) {
  if (b) {
    return true;
  } else {
    return false;
  }
}

exports.to_js_boolean = to_js_boolean;
/* No side effect */


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Curry = __webpack_require__(0);
var Buffer = __webpack_require__(45);
var Pervasives = __webpack_require__(21);
var CamlinternalFormat = __webpack_require__(105);

function kfprintf(k, o, param) {
  return CamlinternalFormat.make_printf((function (o, acc) {
                CamlinternalFormat.output_acc(o, acc);
                return Curry._1(k, o);
              }), o, /* End_of_acc */0, param[0]);
}

function kbprintf(k, b, param) {
  return CamlinternalFormat.make_printf((function (b, acc) {
                CamlinternalFormat.bufput_acc(b, acc);
                return Curry._1(k, b);
              }), b, /* End_of_acc */0, param[0]);
}

function ikfprintf(k, oc, param) {
  return CamlinternalFormat.make_printf((function (oc, _) {
                return Curry._1(k, oc);
              }), oc, /* End_of_acc */0, param[0]);
}

function fprintf(oc, fmt) {
  return kfprintf((function () {
                return /* () */0;
              }), oc, fmt);
}

function bprintf(b, fmt) {
  return kbprintf((function () {
                return /* () */0;
              }), b, fmt);
}

function ifprintf(oc, fmt) {
  return ikfprintf((function () {
                return /* () */0;
              }), oc, fmt);
}

function printf(fmt) {
  return fprintf(Pervasives.stdout, fmt);
}

function eprintf(fmt) {
  return fprintf(Pervasives.stderr, fmt);
}

function ksprintf(k, param) {
  var k$prime = function (_, acc) {
    var buf = Buffer.create(64);
    CamlinternalFormat.strput_acc(buf, acc);
    return Curry._1(k, Buffer.contents(buf));
  };
  return CamlinternalFormat.make_printf(k$prime, /* () */0, /* End_of_acc */0, param[0]);
}

function sprintf(fmt) {
  return ksprintf((function (s) {
                return s;
              }), fmt);
}

var kprintf = ksprintf;

exports.fprintf = fprintf;
exports.printf = printf;
exports.eprintf = eprintf;
exports.sprintf = sprintf;
exports.bprintf = bprintf;
exports.ifprintf = ifprintf;
exports.kfprintf = kfprintf;
exports.ikfprintf = ikfprintf;
exports.ksprintf = ksprintf;
exports.kbprintf = kbprintf;
exports.kprintf = kprintf;
/* No side effect */


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Bytes = __webpack_require__(27);
var Curry = __webpack_require__(0);
var $$String = __webpack_require__(28);
var Pervasives = __webpack_require__(21);
var Caml_string = __webpack_require__(16);
var Caml_builtin_exceptions = __webpack_require__(3);

function create(n) {
  var n$1 = n < 1 ? 1 : n;
  var s = Caml_string.caml_create_string(n$1);
  return /* record */[
          /* buffer */s,
          /* position */0,
          /* length */n$1,
          /* initial_buffer */s
        ];
}

function contents(b) {
  return Bytes.sub_string(b[/* buffer */0], 0, b[/* position */1]);
}

function to_bytes(b) {
  return Bytes.sub(b[/* buffer */0], 0, b[/* position */1]);
}

function sub(b, ofs, len) {
  if (ofs < 0 || len < 0 || ofs > (b[/* position */1] - len | 0)) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "Buffer.sub"
        ];
  } else {
    return Bytes.sub_string(b[/* buffer */0], ofs, len);
  }
}

function blit(src, srcoff, dst, dstoff, len) {
  if (len < 0 || srcoff < 0 || srcoff > (src[/* position */1] - len | 0) || dstoff < 0 || dstoff > (dst.length - len | 0)) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "Buffer.blit"
        ];
  } else {
    return Bytes.blit(src[/* buffer */0], srcoff, dst, dstoff, len);
  }
}

function nth(b, ofs) {
  if (ofs < 0 || ofs >= b[/* position */1]) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "Buffer.nth"
        ];
  } else {
    return b[/* buffer */0][ofs];
  }
}

function length(b) {
  return b[/* position */1];
}

function clear(b) {
  b[/* position */1] = 0;
  return /* () */0;
}

function reset(b) {
  b[/* position */1] = 0;
  b[/* buffer */0] = b[/* initial_buffer */3];
  b[/* length */2] = b[/* buffer */0].length;
  return /* () */0;
}

function resize(b, more) {
  var len = b[/* length */2];
  var new_len = len;
  while((b[/* position */1] + more | 0) > new_len) {
    new_len = (new_len << 1);
  };
  var new_buffer = Caml_string.caml_create_string(new_len);
  Bytes.blit(b[/* buffer */0], 0, new_buffer, 0, b[/* position */1]);
  b[/* buffer */0] = new_buffer;
  b[/* length */2] = new_len;
  return /* () */0;
}

function add_char(b, c) {
  var pos = b[/* position */1];
  if (pos >= b[/* length */2]) {
    resize(b, 1);
  }
  b[/* buffer */0][pos] = c;
  b[/* position */1] = pos + 1 | 0;
  return /* () */0;
}

function add_substring(b, s, offset, len) {
  if (offset < 0 || len < 0 || (offset + len | 0) > s.length) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "Buffer.add_substring/add_subbytes"
        ];
  }
  var new_position = b[/* position */1] + len | 0;
  if (new_position > b[/* length */2]) {
    resize(b, len);
  }
  Bytes.blit_string(s, offset, b[/* buffer */0], b[/* position */1], len);
  b[/* position */1] = new_position;
  return /* () */0;
}

function add_subbytes(b, s, offset, len) {
  return add_substring(b, Caml_string.bytes_to_string(s), offset, len);
}

function add_string(b, s) {
  var len = s.length;
  var new_position = b[/* position */1] + len | 0;
  if (new_position > b[/* length */2]) {
    resize(b, len);
  }
  Bytes.blit_string(s, 0, b[/* buffer */0], b[/* position */1], len);
  b[/* position */1] = new_position;
  return /* () */0;
}

function add_bytes(b, s) {
  return add_string(b, Caml_string.bytes_to_string(s));
}

function add_buffer(b, bs) {
  return add_subbytes(b, bs[/* buffer */0], 0, bs[/* position */1]);
}

function add_channel(b, ic, len) {
  if (len < 0) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "Buffer.add_channel"
        ];
  }
  if ((b[/* position */1] + len | 0) > b[/* length */2]) {
    resize(b, len);
  }
  Pervasives.really_input(ic, b[/* buffer */0], b[/* position */1], len);
  b[/* position */1] = b[/* position */1] + len | 0;
  return /* () */0;
}

function output_buffer(oc, b) {
  return Pervasives.output(oc, b[/* buffer */0], 0, b[/* position */1]);
}

function closing(param) {
  if (param !== 40) {
    if (param !== 123) {
      throw [
            Caml_builtin_exceptions.assert_failure,
            [
              "buffer.ml",
              126,
              9
            ]
          ];
    } else {
      return /* "}" */125;
    }
  } else {
    return /* ")" */41;
  }
}

function advance_to_closing(opening, closing, k, s, start) {
  var _k = k;
  var _i = start;
  var lim = s.length;
  while(true) {
    var i = _i;
    var k$1 = _k;
    if (i >= lim) {
      throw Caml_builtin_exceptions.not_found;
    } else if (Caml_string.get(s, i) === opening) {
      _i = i + 1 | 0;
      _k = k$1 + 1 | 0;
      continue ;
      
    } else if (Caml_string.get(s, i) === closing) {
      if (k$1 === 0) {
        return i;
      } else {
        _i = i + 1 | 0;
        _k = k$1 - 1 | 0;
        continue ;
        
      }
    } else {
      _i = i + 1 | 0;
      continue ;
      
    }
  };
}

function advance_to_non_alpha(s, start) {
  var _i = start;
  var lim = s.length;
  while(true) {
    var i = _i;
    if (i >= lim) {
      return lim;
    } else {
      var match = Caml_string.get(s, i);
      var exit = 0;
      if (match >= 91) {
        if (match >= 97) {
          if (match >= 123) {
            return i;
          } else {
            exit = 1;
          }
        } else if (match !== 95) {
          return i;
        } else {
          exit = 1;
        }
      } else if (match >= 58) {
        if (match >= 65) {
          exit = 1;
        } else {
          return i;
        }
      } else if (match >= 48) {
        exit = 1;
      } else {
        return i;
      }
      if (exit === 1) {
        _i = i + 1 | 0;
        continue ;
        
      }
      
    }
  };
}

function find_ident(s, start, lim) {
  if (start >= lim) {
    throw Caml_builtin_exceptions.not_found;
  } else {
    var c = Caml_string.get(s, start);
    var exit = 0;
    if (c !== 40 && c !== 123) {
      var stop = advance_to_non_alpha(s, start + 1 | 0);
      return /* tuple */[
              $$String.sub(s, start, stop - start | 0),
              stop
            ];
    } else {
      exit = 1;
    }
    if (exit === 1) {
      var new_start = start + 1 | 0;
      var stop$1 = advance_to_closing(c, closing(c), 0, s, new_start);
      return /* tuple */[
              $$String.sub(s, new_start, (stop$1 - start | 0) - 1 | 0),
              stop$1 + 1 | 0
            ];
    }
    
  }
}

function add_substitute(b, f, s) {
  var lim = s.length;
  var _previous = /* " " */32;
  var _i = 0;
  while(true) {
    var i = _i;
    var previous = _previous;
    if (i < lim) {
      var current = Caml_string.get(s, i);
      if (current !== 36) {
        if (previous === /* "\\" */92) {
          add_char(b, /* "\\" */92);
          add_char(b, current);
          _i = i + 1 | 0;
          _previous = /* " " */32;
          continue ;
          
        } else if (current !== 92) {
          add_char(b, current);
          _i = i + 1 | 0;
          _previous = current;
          continue ;
          
        } else {
          _i = i + 1 | 0;
          _previous = current;
          continue ;
          
        }
      } else if (previous === /* "\\" */92) {
        add_char(b, current);
        _i = i + 1 | 0;
        _previous = /* " " */32;
        continue ;
        
      } else {
        var j = i + 1 | 0;
        var match = find_ident(s, j, lim);
        add_string(b, Curry._1(f, match[0]));
        _i = match[1];
        _previous = /* " " */32;
        continue ;
        
      }
    } else if (previous === /* "\\" */92) {
      return add_char(b, previous);
    } else {
      return 0;
    }
  };
}

exports.create = create;
exports.contents = contents;
exports.to_bytes = to_bytes;
exports.sub = sub;
exports.blit = blit;
exports.nth = nth;
exports.length = length;
exports.clear = clear;
exports.reset = reset;
exports.add_char = add_char;
exports.add_string = add_string;
exports.add_bytes = add_bytes;
exports.add_substring = add_substring;
exports.add_subbytes = add_subbytes;
exports.add_substitute = add_substitute;
exports.add_buffer = add_buffer;
exports.add_channel = add_channel;
exports.output_buffer = output_buffer;
/* No side effect */


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Caml_string = __webpack_require__(16);
var Caml_builtin_exceptions = __webpack_require__(3);

function chr(n) {
  if (n < 0 || n > 255) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "Char.chr"
        ];
  } else {
    return n;
  }
}

function escaped(c) {
  var exit = 0;
  if (c >= 40) {
    if (c !== 92) {
      exit = c >= 127 ? 1 : 2;
    } else {
      return "\\\\";
    }
  } else if (c >= 32) {
    if (c >= 39) {
      return "\\'";
    } else {
      exit = 2;
    }
  } else if (c >= 14) {
    exit = 1;
  } else {
    switch (c) {
      case 8 : 
          return "\\b";
      case 9 : 
          return "\\t";
      case 10 : 
          return "\\n";
      case 0 : 
      case 1 : 
      case 2 : 
      case 3 : 
      case 4 : 
      case 5 : 
      case 6 : 
      case 7 : 
      case 11 : 
      case 12 : 
          exit = 1;
          break;
      case 13 : 
          return "\\r";
      
    }
  }
  switch (exit) {
    case 1 : 
        var s = Caml_string.caml_create_string(4);
        s[0] = /* "\\" */92;
        s[1] = 48 + (c / 100 | 0) | 0;
        s[2] = 48 + (c / 10 | 0) % 10 | 0;
        s[3] = 48 + c % 10 | 0;
        return Caml_string.bytes_to_string(s);
    case 2 : 
        var s$1 = Caml_string.caml_create_string(1);
        s$1[0] = c;
        return Caml_string.bytes_to_string(s$1);
    
  }
}

function lowercase(c) {
  if (c >= /* "A" */65 && c <= /* "Z" */90 || c >= /* "\192" */192 && c <= /* "\214" */214 || c >= /* "\216" */216 && c <= /* "\222" */222) {
    return c + 32 | 0;
  } else {
    return c;
  }
}

function uppercase(c) {
  if (c >= /* "a" */97 && c <= /* "z" */122 || c >= /* "\224" */224 && c <= /* "\246" */246 || c >= /* "\248" */248 && c <= /* "\254" */254) {
    return c - 32 | 0;
  } else {
    return c;
  }
}

function compare(c1, c2) {
  return c1 - c2 | 0;
}

exports.chr = chr;
exports.escaped = escaped;
exports.lowercase = lowercase;
exports.uppercase = uppercase;
exports.compare = compare;
/* No side effect */


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE



var x = String.fromCharCode(160);

var carbs = /* array */[
  /* record */[
    /* id */1,
    /* name */"Reis",
    /* quantity : array */[
      "30" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */2,
    /* name */"Kartoffeln",
    /* quantity : array */[
      "140" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */3,
    /* name */"Nudeln",
    /* quantity : array */[
      "30" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */4,
    /* name */"Süßkartoffeln",
    /* quantity : array */[
      "120" + (String(x) + "") + "g",
      "90" + (String(x) + "") + "g",
      "90" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */5,
    /* name */"Quinoa",
    /* quantity : array */[
      "30" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */6,
    /* name */"Quinoaflocken",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */7,
    /* name */"Quinoa gepufft",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */8,
    /* name */"Amaranth gepufft",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */9,
    /* name */"Couscous",
    /* quantity : array */[
      "40" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */10,
    /* name */"Haferflocken",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */11,
    /* name */"Reiswaffeln",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */12,
    /* name */"Vollkornbrot",
    /* quantity : array */[
      "50" + (String(x) + "") + "g",
      "35" + (String(x) + "") + "g",
      "35" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */13,
    /* name */"Amaranth",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */14,
    /* name */"Knäckebrot",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */15,
    /* name */"(Dinkel-) Vollkornmehl",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */16,
    /* name */"Dinkelgrieß",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */17,
    /* name */"Bulgur",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */18,
    /* name */"Buchweizen",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */19,
    /* name */"Reispapier",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */20,
    /* name */"Haferkleie",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */23,
    /* name */"Hirse",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */24,
    /* name */"Polenta",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */21,
    /* name */"ROCKA-MAHLZEIT",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */22,
    /* name */"Rezeptbuch",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ]
];

var protein = /* array */[
  /* record */[
    /* id */1,
    /* name */"Hähnchen",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */2,
    /* name */"Garnelen",
    /* quantity : array */[
      "220" + (String(x) + "") + "g",
      "185" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */3,
    /* name */"Rinderfilet",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */4,
    /* name */"Magerquark",
    /* quantity : array */[
      "300" + (String(x) + "") + "g",
      "250" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */5,
    /* name */"",
    /* quantity : array */[
      "1 Ei + 8 Eiklar",
      "1 Ei + 6 Eiklar",
      "1 Ei + 4 Eiklar"
    ]
  ],
  /* record */[
    /* id */6,
    /* name */"Wildlachs",
    /* quantity : array */[
      "220" + (String(x) + "") + "g",
      "185" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */7,
    /* name */"Fettarmer Aufschnitt",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */8,
    /* name */"Soja-Filet-Stücke",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */9,
    /* name */"Proteinpulver",
    /* quantity : array */[
      "60" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */10,
    /* name */"Kalbsfilet",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */11,
    /* name */"Schweinefilet",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */12,
    /* name */"Lammfilet",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */13,
    /* name */"Thunfisch (in eigenem Saft)",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g",
      "110" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */14,
    /* name */"Forelle",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g",
      "110" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */15,
    /* name */"Seelachs",
    /* quantity : array */[
      "270" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "175" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */16,
    /* name */"Pangasius",
    /* quantity : array */[
      "300" + (String(x) + "") + "g",
      "250" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */17,
    /* name */"Dorade",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */18,
    /* name */"Harzer Käse",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "125" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */19,
    /* name */"Tofu",
    /* quantity : array */[
      "120" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "80" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */20,
    /* name */"Sojajoghurt ungesüßt",
    /* quantity : array */[
      "500" + (String(x) + "") + "g",
      "400" + (String(x) + "") + "g",
      "300" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */21,
    /* name */"Valess Geschnetzeltes",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */22,
    /* name */"Soja Hack",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "115" + (String(x) + "") + "g",
      "90" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */23,
    /* name */"Linsen",
    /* quantity : array */[
      "65" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */24,
    /* name */"Kidney Bohnen",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */25,
    /* name */"Kichererbsen",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "125" + (String(x) + "") + "g",
      "110" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */26,
    /* name */"Kräuterquark",
    /* quantity : array */[
      "270" + (String(x) + "") + "g",
      "220" + (String(x) + "") + "g",
      "180" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */27,
    /* name */"Joghurt 1,5%",
    /* quantity : array */[
      "325" + (String(x) + "") + "g",
      "275" + (String(x) + "") + "g",
      "225" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */28,
    /* name */"Hüttenkäse",
    /* quantity : array */[
      "300" + (String(x) + "") + "g",
      "250" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */29,
    /* name */"Frischkäse 0,2%",
    /* quantity : array */[
      "300" + (String(x) + "") + "g",
      "250" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */30,
    /* name */"Skyrella",
    /* quantity : array */[
      "170" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g",
      "115" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */31,
    /* name */"Tatar",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "125" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */32,
    /* name */"Linsennudeln",
    /* quantity : array */[
      "60" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */33,
    /* name */"Kichererbsennudeln",
    /* quantity : array */[
      "55" + (String(x) + "") + "g",
      "45" + (String(x) + "") + "g",
      "35" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */34,
    /* name */"Skyr",
    /* quantity : array */[
      "300" + (String(x) + "") + "g",
      "250" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */35,
    /* name */"Kichererbsen (getrocknet)",
    /* quantity : array */[
      "60" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */36,
    /* name */"Kidneybohnen (getrocknet)",
    /* quantity : array */[
      "70" + (String(x) + "") + "g",
      "55" + (String(x) + "") + "g",
      "45" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */37,
    /* name */"Weiße Bohnen (Abtropfgewicht)",
    /* quantity : array */[
      "225" + (String(x) + "") + "g",
      "180" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */38,
    /* name */"Schwarze Bohnen (Abtropfgewicht)",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */41,
    /* name */"Clean Protein Pancakes",
    /* quantity : array */[
      "60" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */42,
    /* name */"Clean Protein Muffins",
    /* quantity : array */[
      "60" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */43,
    /* name */"Clean Protein Waffles",
    /* quantity : array */[
      "55" + (String(x) + "") + "g",
      "45" + (String(x) + "") + "g",
      "35" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */44,
    /* name */"Smacktastic Ice Cream",
    /* quantity : array */[
      "65" + (String(x) + "") + "g",
      "55" + (String(x) + "") + "g",
      "45" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */45,
    /* name */"LikeMeat Filetstücke Hähnchen-Art",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */46,
    /* name */"LikeMeat Filetstücke Döner-Art",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "125" + (String(x) + "") + "g",
      "110" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */47,
    /* name */"LikeMeat Gyros Streifen",
    /* quantity : array */[
      "170" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */48,
    /* name */"LikeMeat Grilled Chicken Paprika",
    /* quantity : array */[
      "170" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */49,
    /* name */"Alnatura Seitan-Medaillons",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "125" + (String(x) + "") + "g",
      "110" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */50,
    /* name */"Dennree Seitan mariniert",
    /* quantity : array */[
      "160" + (String(x) + "") + "g",
      "135" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */51,
    /* name */"Bacon light <5% Fett",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */52,
    /* name */"Speckwürfel light <5% Fett",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */53,
    /* name */"Light Wiener <5% Fett",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */54,
    /* name */"Fettarmer Schinken <5% Fett",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */39,
    /* name */"ROCKA-MAHLZEIT",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */40,
    /* name */"Rezeptbuch",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ]
];

var fat = /* array */[
  /* record */[
    /* id */1,
    /* name */"Öl",
    /* quantity : array */[
      "2TL",
      "2TL",
      "2TL"
    ]
  ],
  /* record */[
    /* id */2,
    /* name */"Avocado",
    /* quantity : array */[
      "50" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */3,
    /* name */"Nüsse / Nussmus",
    /* quantity : array */[
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */4,
    /* name */"Eier",
    /* quantity : array */[
      "2",
      "2",
      "2"
    ]
  ],
  /* record */[
    /* id */5,
    /* name */"Chiasamen",
    /* quantity : array */[
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */6,
    /* name */"Leinsamen",
    /* quantity : array */[
      "20" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */7,
    /* name */"Oliven",
    /* quantity : array */[
      "50" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */8,
    /* name */"Kokosraspeln",
    /* quantity : array */[
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */11,
    /* name */"Sesam / Tahin",
    /* quantity : array */[
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */12,
    /* name */"Kerne",
    /* quantity : array */[
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */9,
    /* name */"ROCKA-MAHLZEIT",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */10,
    /* name */"Rezeptbuch",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ]
];

var veggies = /* array */[
  /* record */[
    /* id */1,
    /* name */"Blattsalat",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */2,
    /* name */"Zucchini",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */3,
    /* name */"Blumenkohl",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */4,
    /* name */"Gurke",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */5,
    /* name */"Champignons",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */6,
    /* name */"Rucola",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */7,
    /* name */"Blattspinat",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */8,
    /* name */"Radieschen",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */9,
    /* name */"Aubergine",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */10,
    /* name */"Porree",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */11,
    /* name */"Grüne Bohnen",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */12,
    /* name */"Tomaten",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */13,
    /* name */"Paprika grün",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */14,
    /* name */"Brokkoli",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */15,
    /* name */"Rosenkohl",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */18,
    /* name */"Artischoke",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */19,
    /* name */"Grünkohl",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */20,
    /* name */"Fenchel",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */21,
    /* name */"Sellerie",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */22,
    /* name */"Spargel",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */23,
    /* name */"Spitzkohl",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */24,
    /* name */"Rot-/Weißkohl",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */25,
    /* name */"Wirsing",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */26,
    /* name */"Lauch / Porree",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */16,
    /* name */"ROCKA-MAHLZEIT",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */17,
    /* name */"Rezeptbuch",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ]
];

var fruits = /* array */[
  /* record */[
    /* id */1,
    /* name */"Apfel",
    /* quantity : array */[
      "130" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */2,
    /* name */"Birnen",
    /* quantity : array */[
      "130" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */3,
    /* name */"Beeren",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */4,
    /* name */"Banane",
    /* quantity : array */[
      "75" + (String(x) + "") + "g",
      "75" + (String(x) + "") + "g",
      "75" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */5,
    /* name */"Erdbeeren",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */6,
    /* name */"Himbeeren",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */7,
    /* name */"Heidelbeeren",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */8,
    /* name */"Orange",
    /* quantity : array */[
      "130" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */9,
    /* name */"Mandarine",
    /* quantity : array */[
      "110" + (String(x) + "") + "g",
      "110" + (String(x) + "") + "g",
      "110" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */10,
    /* name */"Mango",
    /* quantity : array */[
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */11,
    /* name */"Ananas",
    /* quantity : array */[
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */12,
    /* name */"Kiwi",
    /* quantity : array */[
      "115" + (String(x) + "") + "g",
      "115" + (String(x) + "") + "g",
      "115" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */13,
    /* name */"Wassermelone",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */14,
    /* name */"Honigmelone",
    /* quantity : array */[
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */15,
    /* name */"Pfirsich",
    /* quantity : array */[
      "120" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */16,
    /* name */"Kirschen",
    /* quantity : array */[
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */17,
    /* name */"Grapefruit",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */18,
    /* name */"Weintrauben",
    /* quantity : array */[
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */19,
    /* name */"Pflaume",
    /* quantity : array */[
      "135" + (String(x) + "") + "g",
      "135" + (String(x) + "") + "g",
      "135" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */10,
    /* name */"ROCKA-MAHLZEIT",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */21,
    /* name */"Rezeptbuch",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ]
];

var snacks = /* array */[
  /* record */[
    /* id */1,
    /* name */"Proteinpulver",
    /* quantity : array */[
      "30" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */2,
    /* name */"Harzer Käse",
    /* quantity : array */[
      "95" + (String(x) + "") + "g",
      "95" + (String(x) + "") + "g",
      "95" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */3,
    /* name */"Hähnchenbrustfilet",
    /* quantity : array */[
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */4,
    /* name */"Magerquark",
    /* quantity : array */[
      "160" + (String(x) + "") + "g",
      "160" + (String(x) + "") + "g",
      "160" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */5,
    /* name */"Sojajoghurt",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "180" + (String(x) + "") + "g",
      "180" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */6,
    /* name */"Sojamilch Light",
    /* quantity : array */[
      "400" + (String(x) + "") + "ml",
      "400" + (String(x) + "") + "ml",
      "400" + (String(x) + "") + "ml"
    ]
  ],
  /* record */[
    /* id */7,
    /* name */"Milch 1,5%",
    /* quantity : array */[
      "200" + (String(x) + "") + "ml",
      "200" + (String(x) + "") + "ml",
      "200" + (String(x) + "") + "ml"
    ]
  ],
  /* record */[
    /* id */8,
    /* name */"",
    /* quantity : array */[
      "6" + (String(x) + "") + "Eiklar",
      "6" + (String(x) + "") + "Eiklar",
      "6" + (String(x) + "") + "Eiklar"
    ]
  ],
  /* record */[
    /* id */9,
    /* name */"Skyr",
    /* quantity : array */[
      "160" + (String(x) + "") + "g",
      "160" + (String(x) + "") + "g",
      "160" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */12,
    /* name */"Clean Protein Pancakes",
    /* quantity : array */[
      "30" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */13,
    /* name */"Clean Protein Muffins",
    /* quantity : array */[
      "30" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */14,
    /* name */"Clean Protein Waffles",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */15,
    /* name */"Smacktastic Ice Cream",
    /* quantity : array */[
      "40" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */16,
    /* name */"Mein Q Protein Quark",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "180" + (String(x) + "") + "g",
      "180" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */17,
    /* name */"Ehrmann High Protein Pudding",
    /* quantity : array */[
      "160" + (String(x) + "") + "g",
      "160" + (String(x) + "") + "g",
      "160" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */10,
    /* name */"ROCKA-MAHLZEIT",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */11,
    /* name */"Rezeptbuch",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ]
];

var foodPlanSeed = /* array */[
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ]
];

exports.x = x;
exports.carbs = carbs;
exports.protein = protein;
exports.fat = fat;
exports.veggies = veggies;
exports.fruits = fruits;
exports.snacks = snacks;
exports.foodPlanSeed = foodPlanSeed;
/* x Not a pure module */


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var List = __webpack_require__(19);
var $$Array = __webpack_require__(12);
var Curry = __webpack_require__(0);
var Js_exn = __webpack_require__(10);
var Caml_string = __webpack_require__(16);
var Caml_exceptions = __webpack_require__(22);
var Caml_builtin_exceptions = __webpack_require__(3);

function _isInteger(value) {
  if (isFinite(value)) {
    return +(Math.floor(value) === value);
  } else {
    return /* false */0;
  }
}

var DecodeError = Caml_exceptions.create("Json_decode.DecodeError");

function $$boolean(json) {
  if (typeof json === "boolean") {
    return json;
  } else {
    throw [
          DecodeError,
          "Expected boolean, got " + JSON.stringify(json)
        ];
  }
}

function bool(json) {
  return +$$boolean(json);
}

function $$float(json) {
  if (typeof json === "number") {
    return json;
  } else {
    throw [
          DecodeError,
          "Expected number, got " + JSON.stringify(json)
        ];
  }
}

function $$int(json) {
  var f = $$float(json);
  if (_isInteger(f)) {
    return f;
  } else {
    throw [
          DecodeError,
          "Expected integer, got " + JSON.stringify(json)
        ];
  }
}

function string(json) {
  if (typeof json === "string") {
    return json;
  } else {
    throw [
          DecodeError,
          "Expected string, got " + JSON.stringify(json)
        ];
  }
}

function $$char(json) {
  var s = string(json);
  if (s.length === 1) {
    return Caml_string.get(s, 0);
  } else {
    throw [
          DecodeError,
          "Expected single-character string, got " + JSON.stringify(json)
        ];
  }
}

function date(json) {
  return new Date(string(json));
}

function nullable(decode, json) {
  if (json === null) {
    return null;
  } else {
    return Curry._1(decode, json);
  }
}

function nullAs(value, json) {
  if (json === null) {
    return value;
  } else {
    throw [
          DecodeError,
          "Expected null, got " + JSON.stringify(json)
        ];
  }
}

function array(decode, json) {
  if (Array.isArray(json)) {
    var length = json.length;
    var target = new Array(length);
    for(var i = 0 ,i_finish = length - 1 | 0; i <= i_finish; ++i){
      var value;
      try {
        value = Curry._1(decode, json[i]);
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === DecodeError) {
          throw [
                DecodeError,
                exn[1] + ("\n\tin array at index " + String(i))
              ];
        } else {
          throw exn;
        }
      }
      target[i] = value;
    }
    return target;
  } else {
    throw [
          DecodeError,
          "Expected array, got " + JSON.stringify(json)
        ];
  }
}

function list(decode, json) {
  return $$Array.to_list(array(decode, json));
}

function pair(decodeA, decodeB, json) {
  if (Array.isArray(json)) {
    var length = json.length;
    if (length === 2) {
      try {
        return /* tuple */[
                Curry._1(decodeA, json[0]),
                Curry._1(decodeB, json[1])
              ];
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === DecodeError) {
          throw [
                DecodeError,
                exn[1] + "\n\tin pair/tuple2"
              ];
        } else {
          throw exn;
        }
      }
    } else {
      throw [
            DecodeError,
            "Expected array of length 2, got array of length " + (String(length) + "")
          ];
    }
  } else {
    throw [
          DecodeError,
          "Expected array, got " + JSON.stringify(json)
        ];
  }
}

function tuple3(decodeA, decodeB, decodeC, json) {
  if (Array.isArray(json)) {
    var length = json.length;
    if (length === 3) {
      try {
        return /* tuple */[
                Curry._1(decodeA, json[0]),
                Curry._1(decodeB, json[1]),
                Curry._1(decodeC, json[2])
              ];
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === DecodeError) {
          throw [
                DecodeError,
                exn[1] + "\n\tin tuple3"
              ];
        } else {
          throw exn;
        }
      }
    } else {
      throw [
            DecodeError,
            "Expected array of length 3, got array of length " + (String(length) + "")
          ];
    }
  } else {
    throw [
          DecodeError,
          "Expected array, got " + JSON.stringify(json)
        ];
  }
}

function tuple4(decodeA, decodeB, decodeC, decodeD, json) {
  if (Array.isArray(json)) {
    var length = json.length;
    if (length === 4) {
      try {
        return /* tuple */[
                Curry._1(decodeA, json[0]),
                Curry._1(decodeB, json[1]),
                Curry._1(decodeC, json[2]),
                Curry._1(decodeD, json[3])
              ];
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === DecodeError) {
          throw [
                DecodeError,
                exn[1] + "\n\tin tuple4"
              ];
        } else {
          throw exn;
        }
      }
    } else {
      throw [
            DecodeError,
            "Expected array of length 4, got array of length " + (String(length) + "")
          ];
    }
  } else {
    throw [
          DecodeError,
          "Expected array, got " + JSON.stringify(json)
        ];
  }
}

function dict(decode, json) {
  if (typeof json === "object" && !Array.isArray(json) && json !== null) {
    var keys = Object.keys(json);
    var l = keys.length;
    var target = { };
    for(var i = 0 ,i_finish = l - 1 | 0; i <= i_finish; ++i){
      var key = keys[i];
      var value;
      try {
        value = Curry._1(decode, json[key]);
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === DecodeError) {
          throw [
                DecodeError,
                exn[1] + "\n\tin dict"
              ];
        } else {
          throw exn;
        }
      }
      target[key] = value;
    }
    return target;
  } else {
    throw [
          DecodeError,
          "Expected object, got " + JSON.stringify(json)
        ];
  }
}

function field(key, decode, json) {
  if (typeof json === "object" && !Array.isArray(json) && json !== null) {
    var match = json[key];
    if (match !== undefined) {
      try {
        return Curry._1(decode, match);
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === DecodeError) {
          throw [
                DecodeError,
                exn[1] + ("\n\tat field '" + (key + "'"))
              ];
        } else {
          throw exn;
        }
      }
    } else {
      throw [
            DecodeError,
            "Expected field \'" + (String(key) + "\'")
          ];
    }
  } else {
    throw [
          DecodeError,
          "Expected object, got " + JSON.stringify(json)
        ];
  }
}

function at(key_path, decoder) {
  if (key_path) {
    var rest = key_path[1];
    var key = key_path[0];
    if (rest) {
      var partial_arg = at(rest, decoder);
      return (function (param) {
          return field(key, partial_arg, param);
        });
    } else {
      return (function (param) {
          return field(key, decoder, param);
        });
    }
  } else {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "Expected key_path to contain at least one element"
        ];
  }
}

function optional(decode, json) {
  try {
    return /* Some */[Curry._1(decode, json)];
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === DecodeError) {
      return /* None */0;
    } else {
      throw exn;
    }
  }
}

function oneOf(decoders, json) {
  var _decoders = decoders;
  var _errors = /* [] */0;
  while(true) {
    var errors = _errors;
    var decoders$1 = _decoders;
    if (decoders$1) {
      try {
        return Curry._1(decoders$1[0], json);
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === DecodeError) {
          _errors = /* :: */[
            exn[1],
            errors
          ];
          _decoders = decoders$1[1];
          continue ;
          
        } else {
          throw exn;
        }
      }
    } else {
      var revErrors = List.rev(errors);
      throw [
            DecodeError,
            "All decoders given to oneOf failed. Here are all the errors: " + (String(revErrors) + ". And the JSON being decoded: ") + JSON.stringify(json)
          ];
    }
  };
}

function either(a, b) {
  var partial_arg_001 = /* :: */[
    b,
    /* [] */0
  ];
  var partial_arg = /* :: */[
    a,
    partial_arg_001
  ];
  return (function (param) {
      return oneOf(partial_arg, param);
    });
}

function withDefault($$default, decode, json) {
  try {
    return Curry._1(decode, json);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === DecodeError) {
      return $$default;
    } else {
      throw exn;
    }
  }
}

function map(f, decode, json) {
  return Curry._1(f, Curry._1(decode, json));
}

function andThen(b, a, json) {
  return Curry._2(b, Curry._1(a, json), json);
}

var tuple2 = pair;

exports.DecodeError = DecodeError;
exports.$$boolean = $$boolean;
exports.bool = bool;
exports.$$float = $$float;
exports.$$int = $$int;
exports.string = string;
exports.$$char = $$char;
exports.date = date;
exports.nullable = nullable;
exports.nullAs = nullAs;
exports.array = array;
exports.list = list;
exports.pair = pair;
exports.tuple2 = tuple2;
exports.tuple3 = tuple3;
exports.tuple4 = tuple4;
exports.dict = dict;
exports.field = field;
exports.at = at;
exports.optional = optional;
exports.oneOf = oneOf;
exports.either = either;
exports.withDefault = withDefault;
exports.map = map;
exports.andThen = andThen;
/* No side effect */


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



function is_nil_undef(x) {
  if (x === null) {
    return /* true */1;
  } else {
    return +(x === undefined);
  }
}

function null_undefined_to_opt(x) {
  if (x === null || x === undefined) {
    return /* None */0;
  } else {
    return /* Some */[x];
  }
}

function undefined_to_opt(x) {
  if (x === undefined) {
    return /* None */0;
  } else {
    return /* Some */[x];
  }
}

function null_to_opt(x) {
  if (x === null) {
    return /* None */0;
  } else {
    return /* Some */[x];
  }
}

function option_get(x) {
  if (x) {
    return x[0];
  } else {
    return undefined;
  }
}

function option_get_unwrap(x) {
  if (x) {
    return x[0][1];
  } else {
    return undefined;
  }
}

exports.is_nil_undef = is_nil_undef;
exports.null_undefined_to_opt = null_undefined_to_opt;
exports.undefined_to_opt = undefined_to_opt;
exports.null_to_opt = null_to_opt;
exports.option_get = option_get;
exports.option_get_unwrap = option_get_unwrap;
/* No side effect */


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var ReasonReact = __webpack_require__(2);

function handleLogout() {
  localStorage.removeItem("start_date_timestamp");
  localStorage.removeItem("wizard_result");
  localStorage.removeItem("levels");
  localStorage.removeItem("points");
  localStorage.removeItem("reps");
  localStorage.removeItem("completed");
  localStorage.removeItem("bonus_done");
  localStorage.removeItem("food_plan");
  localStorage.removeItem("access_token");
  localStorage.removeItem("all_token_data");
  localStorage.removeItem("expires_in");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("token_timestamp");
  localStorage.removeItem("token_expires_at");
  localStorage.removeItem("errortest");
  localStorage.removeItem("email");
  localStorage.removeItem("network_sync_status");
  return ReasonReact.Router[/* push */0]("/login");
}

exports.handleLogout = handleLogout;
/* ReasonReact Not a pure module */


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/password_input.9047392c.svg";

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cta_arrow.216af87d.svg";

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lunch_icon.08295584.svg";

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/snack_icon.8d354284.svg";

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dinner_icon.116c0b7f.svg";

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/breakfast_icon.b1fb8d82.svg";

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var React = __webpack_require__(1);
var ReasonReact = __webpack_require__(2);

var component = ReasonReact.statelessComponent("Greeting");

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", undefined, React.createElement("svg", {
                      height: "278",
                      width: "154",
                      viewBox: "0 0 154 278"
                    }, React.createElement("title", undefined, "Scale_icon"), React.createElement("defs", undefined, React.createElement("filter", {
                              id: "a",
                              height: "117.5%",
                              width: "113.6%",
                              filterUnits: "objectBoundingBox",
                              x: "-6.8%",
                              y: "-6.2%"
                            }, React.createElement("feOffset", {
                                  dy: "2",
                                  in: "SourceAlpha",
                                  result: "shadowOffsetOuter1"
                                }), React.createElement("feGaussianBlur", {
                                  in: "shadowOffsetOuter1",
                                  result: "shadowBlurOuter1",
                                  stdDeviation: "2"
                                }), React.createElement("feColorMatrix", {
                                  in: "shadowBlurOuter1",
                                  result: "shadowMatrixOuter1",
                                  values: "0 0 0 0 0.86 0 0 0 0 0.7482 0 0 0 0 0.751926667 0 0 0 0.5 0"
                                }), React.createElement("feMerge", undefined, React.createElement("feMergeNode", {
                                      in: "shadowMatrixOuter1"
                                    }), React.createElement("feMergeNode", {
                                      in: "SourceGraphic"
                                    }))), React.createElement("linearGradient", {
                              id: "b",
                              x1: "45.552%",
                              x2: "-59.986%",
                              y1: "153.511%",
                              y2: "39.725%"
                            }, React.createElement("stop", {
                                  offset: "0%",
                                  stopColor: "#FFA1C3",
                                  stopOpacity: "0.1"
                                }), React.createElement("stop", {
                                  offset: "6.329%",
                                  stopColor: "snow"
                                }), React.createElement("stop", {
                                  offset: "90.05%",
                                  stopColor: "snow"
                                }), React.createElement("stop", {
                                  offset: "100%",
                                  stopColor: "#FFA1C3",
                                  stopOpacity: "0.1"
                                })), React.createElement("linearGradient", {
                              id: "c",
                              x1: "89.916%",
                              x2: "89.916%",
                              y1: ".128%",
                              y2: "100.277%"
                            }, React.createElement("stop", {
                                  offset: "0%",
                                  stopColor: "#73CECF"
                                }), React.createElement("stop", {
                                  offset: "100%",
                                  stopColor: "#66B3B5"
                                })), React.createElement("linearGradient", {
                              id: "d",
                              x1: "10.082%",
                              x2: "10.082%",
                              y1: ".128%",
                              y2: "100.277%"
                            }, React.createElement("stop", {
                                  offset: "0%",
                                  stopColor: "#73CECF"
                                }), React.createElement("stop", {
                                  offset: "100%",
                                  stopColor: "#66B3B5"
                                })), React.createElement("linearGradient", {
                              id: "e",
                              x1: "-4.118%",
                              x2: "-4.118%",
                              y1: ".007%",
                              y2: "99.937%"
                            }, React.createElement("stop", {
                                  offset: "0%",
                                  stopColor: "#80E7E7"
                                }), React.createElement("stop", {
                                  offset: "100%",
                                  stopColor: "#6FC6C7"
                                })), React.createElement("radialGradient", {
                              id: "f",
                              cx: "50.183%",
                              cy: "49.679%",
                              fx: "50.183%",
                              fy: "49.679%",
                              gradientTransform: "scale(.9958 1) rotate(-.37 .503 .17)",
                              r: "59.941%"
                            }, React.createElement("stop", {
                                  offset: "14.964%",
                                  stopColor: "#FF8D9F",
                                  stopOpacity: "0.3"
                                }), React.createElement("stop", {
                                  offset: "100%",
                                  stopColor: "#FFE6EA",
                                  stopOpacity: "0"
                                })), React.createElement("linearGradient", {
                              id: "g",
                              x1: "117.109%",
                              x2: "117.109%",
                              y1: "11.328%",
                              y2: "115.966%"
                            }, React.createElement("stop", {
                                  offset: "0%",
                                  stopColor: "#FEDDDE"
                                }), React.createElement("stop", {
                                  offset: "91.376%",
                                  stopColor: "#FEDDDE",
                                  stopOpacity: "0"
                                })), React.createElement("linearGradient", {
                              id: "h",
                              x1: "159.219%",
                              x2: "58.14%",
                              y1: "5.18%",
                              y2: "100.355%"
                            }, React.createElement("stop", {
                                  offset: "0%",
                                  stopColor: "#FEDDDE"
                                }), React.createElement("stop", {
                                  offset: "100%",
                                  stopColor: "#FEDDDE",
                                  stopOpacity: "0"
                                })), React.createElement("linearGradient", {
                              id: "i",
                              x1: "59.557%",
                              x2: "154.143%",
                              y1: "-11.273%",
                              y2: "81.449%"
                            }, React.createElement("stop", {
                                  offset: "0%",
                                  stopColor: "#FEDDDE"
                                }), React.createElement("stop", {
                                  offset: "91.152%",
                                  stopColor: "#FEDDDE",
                                  stopOpacity: "0"
                                }))), React.createElement("g", {
                          id: "Page-1",
                          fill: "none",
                          fillRule: "evenodd"
                        }, React.createElement("g", {
                              id: "Scale_icon",
                              transform: "translate(2)"
                            }, React.createElement("g", {
                                  id: "Scale",
                                  fillRule: "nonzero",
                                  filter: "url(#a)",
                                  transform: "translate(23 192)"
                                }, React.createElement("path", {
                                      id: "Shape",
                                      d: "M25.232 79.154c-1.854-.103-3.4-1.436-3.812-3.282-5.563-27.693-8.447-49.949-9.271-70.051-.103-2.154 1.545-4 3.708-4.206a394.082 394.082 0 0 1 71.29 0c2.164.206 3.812 2.052 3.71 4.206-.825 20.102-3.71 42.358-9.272 70.05-.413 1.847-1.958 3.18-3.812 3.283-17.308 1.128-34.924 1.128-52.54 0z",
                                      fill: "url(#b)"
                                    }), React.createElement("path", {
                                      d: "M72.723 4.898c-1.854-.103-3.605 1.23-3.914 3.076-1.237 6.36-5.976 11.488-12.157 13.334-1.648.513-2.678 1.948-2.678 3.59v46.974c0 1.025.412 1.949 1.133 2.667.721.718 1.751 1.128 2.781 1.128 5.667-.103 11.23-.308 16.896-.616 1.751-.102 3.193-1.333 3.502-3.076 4.533-24.308 7.212-44.308 8.242-62.462.103-2.051-1.442-3.795-3.503-4-3.502-.205-6.902-.513-10.302-.615zM45.526 76.179c1.134 0 2.267-.41 3.091-1.23.824-.821 1.34-1.95 1.34-3.078V24.794c0-1.948-1.237-3.59-3.091-4.205-2.885-.82-5.563-2.564-7.624-4.82a16.927 16.927 0 0 1-4.12-8.103c-.413-2.051-2.164-3.487-4.328-3.487h-.206c-3.4.205-6.902.41-10.302.718-2.37.205-4.12 2.154-4.017 4.615.927 18.257 3.605 38.052 8.344 62.564.412 1.95 2.06 3.385 4.018 3.488 5.563.307 11.23.512 16.895.615z",
                                      fill: "#FEDDDE",
                                      fillOpacity: "0.6"
                                    }), React.createElement("path", {
                                      d: "M65.1 3.667a37.88 37.88 0 0 0-13.496-2.462c-4.636 0-9.17.82-13.496 2.462-.618.205-1.133.923-1.03 1.64a15.024 15.024 0 0 0 4.43 9.847c2.678 2.564 6.284 4 10.096 4 3.811 0 7.314-1.436 10.096-4 2.678-2.564 4.326-6.052 4.43-9.846 0-.718-.413-1.436-1.03-1.641zM51.603 18.23c-7.418 0-13.393-5.847-13.702-13.026 0-.308.206-.615.515-.82 8.448-3.18 17.822-3.18 26.373 0 .31.102.515.41.515.82-.309 7.282-6.284 13.026-13.701 13.026z",
                                      fill: "#F67AA6",
                                      opacity: "0.1"
                                    }), React.createElement("path", {
                                      d: "M65.304 5.102c0-.308-.206-.615-.515-.82-8.448-3.18-17.823-3.18-26.373 0-.31.102-.516.41-.516.82.31 7.282 6.285 13.026 13.702 13.026 7.418 0 13.393-5.744 13.702-13.026z",
                                      fill: "#5E022A",
                                      fillOpacity: "0.1"
                                    }), React.createElement("path", {
                                      d: "M64.997 3.77A37.327 37.327 0 0 0 51.605 1.31c-4.533 0-9.066.82-13.393 2.462-.515.205-.927.717-.927 1.333.103 3.692 1.751 7.077 4.327 9.64 2.678 2.565 6.18 4 9.89 4 3.708 0 7.211-1.435 9.89-4 2.678-2.563 4.223-5.948 4.326-9.64.206-.616-.206-1.128-.72-1.333zM51.605 18.13c-7.418 0-13.393-5.847-13.702-13.026 0-.308.206-.616.515-.82 8.448-3.18 17.822-3.18 26.373 0 .31.102.515.41.515.82-.309 7.282-6.284 13.025-13.701 13.025z",
                                      fill: "#747474",
                                      opacity: "0.1"
                                    }), React.createElement("path", {
                                      d: "M38.52 8.692c3.4-3.384 7.932-5.333 13.083-5.333s9.684 1.949 13.084 5.333c-2.37 11.488-21.532 15.59-26.167 0z",
                                      fill: "#FFF"
                                    }), React.createElement("path", {
                                      d: "M59.227 8.487l.206.205-1.957 2.872-.31-.308 1.649-2.359h-.206c-.103 0-.206-.102-.206-.102l.206-.205c.103 0 .206.102.309.102.103-.102.206-.102.309-.205zM59.434 9.616c.206-.205.31-.41.516-.41.206-.103.309 0 .618.102.206.103.309.308.309.513 0 .205-.103.41-.31.615l-.927 1.334c-.206.307-.309.41-.515.512-.206.103-.412 0-.618-.102a.564.564 0 0 1-.309-.513c0-.205.103-.41.31-.718l.926-1.333zm.825.513c.206-.308.206-.513.103-.513l-.103-.103h-.103s-.103 0-.206.103c-.103 0-.103.102-.206.307l-.928 1.334c-.206.307-.206.41-.206.513 0 0 0 .102.103.102 0 0 .103 0 .103.103h.103c.103 0 .206-.103.412-.41l.928-1.436zM41.199 9.513l.206-.205 1.957 2.872-.309.205-1.648-2.36c0 .104 0 .104-.103.206 0 .103-.103.103-.206.205l-.103-.205c.103-.102.103-.205.206-.308v-.41zM42.536 8.692l.31-.205 1.338 2.051.206-.205.207.308-.207.205.413.513-.31.205-.412-.513-.72.41-.104-.307-.72-2.462zm1.34 2.051l-1.03-1.435.617 1.743.412-.308zM43.775 8.897c-.206-.205-.206-.513-.31-.615 0-.205.104-.308.31-.513.206-.103.412-.205.618-.103.206.103.309.206.515.513l.927 1.334c.206.307.31.512.31.718 0 .205-.104.41-.31.512-.206.103-.412.206-.618.103-.206-.103-.309-.308-.515-.513l-.927-1.436zm.824-.615c-.206-.308-.309-.41-.515-.308h-.103l-.103.103v.205c0 .102.103.205.206.308l.927 1.435c.206.308.31.41.412.41h.103l.103-.102v-.102c0-.103 0-.308-.206-.513L44.6 8.282z",
                                      fill: "#000",
                                      opacity: "0.1"
                                    }), React.createElement("path", {
                                      d: "M50.446 7.893c-.206-.206-.206-.514-.309-.616 0-.206.103-.309.309-.514.206-.103.411-.205.617-.103.206.103.309.206.515.514l.925 1.335c.206.308.31.514.31.719 0 .205-.104.41-.31.513-.205.103-.411.206-.617.103-.206-.103-.308-.308-.514-.513l-.926-1.438zm.823-.616c-.206-.309-.309-.411-.514-.309h-.103l-.103.103v.206c0 .102.103.205.206.308l.925 1.438c.206.308.31.41.412.41h.103l.103-.102v-.103c0-.103 0-.308-.206-.514l-.823-1.437z",
                                      fill: "#000",
                                      opacity: "0.1",
                                      transform: "rotate(33.888 51.475 8.252)"
                                    }), React.createElement("g", {
                                      id: "Group",
                                      fill: "#000",
                                      opacity: "0.1"
                                    }, React.createElement("path", {
                                          d: "M13.81.667h-.413v1.641h.412z",
                                          transform: "translate(38 3)"
                                        }), React.createElement("path", {
                                          d: "M12.68.643h-.206v.82h.206z",
                                          transform: "rotate(-3.363 83.07 -644.584)"
                                        }), React.createElement("path", {
                                          d: "M14.734.689h-.206v.82h.206z",
                                          transform: "rotate(3.363 -17.069 649.915)"
                                        }), React.createElement("path", {
                                          d: "M15.757.81h-.206v.821h.206z",
                                          transform: "rotate(6.727 9.53 326.081)"
                                        }), React.createElement("path", {
                                          d: "M16.87 1.046h-.206v.82h.206z",
                                          transform: "rotate(10.167 19.302 216.634)"
                                        }), React.createElement("path", {
                                          d: "M17.893 1.277h-.206v.821h.206z",
                                          transform: "rotate(13.554 24.565 163.16)"
                                        }), React.createElement("path", {
                                          d: "M18.802 1.579h-.206v.82h.206z",
                                          transform: "rotate(16.928 28.016 131.258)"
                                        }), React.createElement("path", {
                                          d: "M19.824 1.913h-.206v.821h.206z",
                                          transform: "rotate(20.312 30.744 109.979)"
                                        }), React.createElement("path", {
                                          d: "M20.828 2.364h-.206v.822h.206z",
                                          transform: "rotate(23.691 32.97 94.953)"
                                        }), React.createElement("path", {
                                          d: "M21.759 2.781h-.206v.822h.206z",
                                          transform: "rotate(27.061 34.82 83.736)"
                                        }), React.createElement("path", {
                                          d: "M22.663 3.316h-.205v.821h.205z",
                                          transform: "rotate(30.425 36.441 75.188)"
                                        }), React.createElement("path", {
                                          d: "M24.398 4.479h-.206V5.3h.206z",
                                          transform: "rotate(37.156 39.23 63.007)"
                                        }), React.createElement("path", {
                                          d: "M25.168 5.204h-.205v.822h.205z",
                                          transform: "rotate(40.522 40.399 58.676)"
                                        }), React.createElement("path", {
                                          d: "M25.88 5.888h-.206v.823h.205z",
                                          transform: "rotate(43.884 41.45 55.053)"
                                        }), React.createElement("path", {
                                          d: "M2.17 4.363h-.206v.822h.205z",
                                          transform: "rotate(142.839 20.96 12.75)"
                                        }), React.createElement("path", {
                                          d: "M1.32 4.991h-.205v.822h.205z",
                                          transform: "rotate(139.478 20.061 14.005)"
                                        }), React.createElement("path", {
                                          d: "M.498 5.75H.292v.821h.206z",
                                          transform: "rotate(136.12 19.188 15.403)"
                                        }), React.createElement("path", {
                                          d: "M11.652.72h-.206v.82h.206z",
                                          transform: "rotate(-6.727 56.467 -320.551)"
                                        }), React.createElement("path", {
                                          d: "M10.528.915h-.206v.82h.206z",
                                          transform: "rotate(-10.167 46.684 -210.674)"
                                        }), React.createElement("path", {
                                          d: "M9.5 1.096h-.205v.82H9.5z",
                                          transform: "rotate(-13.554 41.417 -156.787)"
                                        }), React.createElement("path", {
                                          d: "M8.58 1.357h-.206v.82h.206z",
                                          transform: "rotate(-16.928 37.954 -124.322)"
                                        }), React.createElement("path", {
                                          d: "M7.541 1.646h-.205v.821h.205z",
                                          transform: "rotate(-20.317 35.207 -102.39)"
                                        }), React.createElement("path", {
                                          d: "M6.52 2.054h-.206v.821h.206z",
                                          transform: "rotate(-23.686 32.967 -86.555)"
                                        }), React.createElement("path", {
                                          d: "M5.571 2.436h-.205v.821h.205z",
                                          transform: "rotate(-27.061 31.099 -74.519)"
                                        }), React.createElement("path", {
                                          d: "M4.643 2.923h-.206v.821h.206z",
                                          transform: "rotate(-30.425 29.453 -64.95)"
                                        }), React.createElement("path", {
                                          d: "M23.44 3.785h-.411v1.643h.411z",
                                          transform: "rotate(33.795 37.59 68.652)"
                                        }), React.createElement("path", {
                                          d: "M3.555 3.774h-.412v1.643h.412z",
                                          transform: "rotate(146.205 22.188 11.868)"
                                        })), React.createElement("path", {
                                      d: "M14 35.974l4.945 28.308H7.716c-1.03 0-1.854-.82-1.854-1.949l.618-11.282L.196 38.64c-.618-1.231.309-2.564 1.648-2.564H14v-.103z",
                                      fill: "url(#c)"
                                    }), React.createElement("path", {
                                      d: "M18.944 64.385l-6.078-4.205h5.357z",
                                      fill: "#539294"
                                    }), React.createElement("path", {
                                      d: "M89 35.974l-4.945 28.308h11.23c1.03 0 1.854-.82 1.854-1.949l-.618-11.282 6.284-12.513c.618-1.23-.31-2.564-1.649-2.564H89z",
                                      fill: "url(#d)"
                                    }), React.createElement("path", {
                                      d: "M10.084 30.436h82.417c1.133 0 1.957.923 1.751 2.051l-3.296 26.154c-.103.923-.928 1.539-1.752 1.539h-75.72a1.778 1.778 0 0 1-1.751-1.539l-3.4-26.154c-.103-1.128.721-2.051 1.751-2.051z",
                                      fill: "url(#e)"
                                    }), React.createElement("path", {
                                      d: "M84.055 64.385l6.8-4.205h-5.976z",
                                      fill: "#539294"
                                    })), React.createElement("path", {
                                  id: "BG",
                                  d: "M120.78 69.396s-55.749-8.343-60.13-9.32c.028 0 .071-.015.1-.015-.029 0-.086-.014-.114-.014 4.367-1.02 60.03-10.03 60.03-10.03l.113 19.38zm-60.187-9.32c-.014 0-.029 0-.043-.015 0 0-.014 0-.014.014 0 0 .014 0 .014.014.015-.014.029-.014.043-.014.014 0 .043.014.057.014h-.014c.156.043.241.071.241.071s-.056-.014-.184-.028l.184.07s-.085-.013-.27-.056c0 0 .014 0 .014.014-.014 0-.028-.014-.042-.014l.042.043c-.014 0-.014-.014-.028-.014.114.113.185.198.185.184 0 0-.043-.043-.114-.085.057.07.1.127.1.127s-.071-.07-.214-.198c0 .014.015.014.015.028l-.015-.014c0 .014.015.028.015.028-.015-.014-.029-.028-.029-.042.043.17.071.269.071.269s-.014-.043-.042-.113c.014.085.014.141.014.127 0 0-.029-.1-.086-.283v-.014-.043.014c0 .015-.014.015-.014.029 0 .014 0 .014.014.028V60.274c0-.014 0-.043-.014-.057 0-.014 0-.014.014-.028V60.16l-.014.015v-.015c-.014 0-.014.015-.028.015v-.015-.028-.014H60.408h-.014c0-.014.014-.014.014-.029h-.014l.014-.014c-.014 0-.014 0-.028-.014-.015 0-.015 0-.029.014h-.014c-.014 0-.043 0-.057-.014h.028-.014.043c-.185-.056-.299-.085-.285-.085 0 0 .043 0 .143.014-.072-.028-.128-.042-.114-.042 0 0 .1.028.27.056-.014-.014-.028-.014-.043-.028.015 0 .029.014.043.014l-.014-.014c.014 0 .014 0 .028.014a3.557 3.557 0 0 1-.199-.212s.057.042.142.099c-.056-.07-.1-.128-.1-.128s.072.071.186.17c0-.014-.014-.014-.014-.028l.042.043c0-.014-.014-.029-.014-.043v.014c-.043-.17-.057-.269-.057-.255 0 0 .029.071.071.184a1.572 1.572 0 0 0-.028-.184s.028.085.07.227v-.014c0 .014.015.042.015.056v.043s0 .014.014.014v-.014c0-.014 0-.014-.014-.028v-.014c0-.015.014-.029.014-.057 0-.029-.014-.071-.014-.114 0 .029-.014.071-.014.1-1.053-4.32-10.1-59.736-10.1-59.736L69.825 0s-8.364 55.5-9.346 59.877c.043-.156.071-.24.071-.227 0 0-.014.071-.028.213.057-.128.085-.199.085-.199s-.014.085-.057.227c1.28-4.278 21.281-56.775 21.281-56.775l16.913 9.576s-35.064 43.856-38.151 47.2c.1-.086.156-.157.156-.143 0 0-.056.071-.128.17.114-.084.171-.141.171-.141s-.057.056-.142.156c3.329-3.117 46.943-38.558 46.943-38.558l9.814 16.729s-52.49 20.54-56.771 21.885c.028-.014.07-.056.1-.07-.03.014-.086.028-.114.042a8.605 8.605 0 0 0-.043.042c.014 0 .028 0 .042-.014h.015c.156-.042.241-.056.227-.056 0 0-.07.028-.185.085.143-.014.214-.029.214-.029s-.086.029-.242.071c-.029 0-.043 0-.057.014zm-.17-.086c0-.014 0 0 0 0-.015-.014-.03-.014-.03-.028v.014c.015.014.015.014.03.014.014.014.014 0 0 0 .014.014.014.014 0 0l.014.014v.015c0-.014 0-.014-.015-.029.015 0 .015.014 0 0 .015-.014.015 0 0 0 0 0 .015 0 0 0zm-.043.057c.014 0 .014 0 0 0h0c.014 0 .014 0 0 0 0-.014-.015-.014-.015-.028h.043v-.014h-.014c-.014 0-.014 0-.029-.015l.015.014h-.015-.014c.014.029.029.029.029.043zm.028.07s.014 0 0 0c.014 0 .014 0 0 0 .014 0 .014 0 0 0 .014 0 .014 0 0 0zm.043 0s0-.013 0 0c0-.013 0-.013 0 0 0-.013 0-.013 0 0 0-.013 0-.013 0 0 0-.013 0-.013 0 0 0-.013 0-.013 0 0 0-.013 0-.013 0 0 0 0 0-.013 0 0zm.085-.027c-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014-.015-.014-.015h.014c-.014.014-.014.014 0 .014-.014 0-.014 0 0 0 0 0-.014 0 0 0 0 .015 0 0 0 0 0 .015 0 .015 0 0 0 .015.014.015.014.015h-.014l.014.014h-.014H60.565l-.015-.014h.015c-.015.014-.015 0-.029-.014l.014.014s0-.014-.014-.014zm-.043-.086l.015-.014c0-.014 0-.014.014-.028-.014.014-.014.014-.014.028l-.015.014zm-.014.029c0 .014.014.014 0 0 .014.014.014.014 0 0 .014.014.014.014 0 0 .014.014.014.014 0 0 .014.014.014.014 0 0 .014.014.014.014 0 0 .014.014.014.014 0 0l.014.014-.014-.014c.014.014.014.014 0 0l.014.014-.014-.014c.014.014.014.014 0 0 .014.014.014.014 0 0 .014 0 .014 0 0 0 .014 0 .014 0 0 0zm-.057 0c0 .014 0 .014 0 0v0s0 .014 0 0h0c.015 0 .015 0 0 0h0s.015 0 0 0c0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0zm.015.07c0-.014 0-.014 0 0 0-.014 0-.014 0 0 0 0 0-.014 0 0zm.056-.028s0-.014 0 0c0-.014 0-.014 0 0 0 0 0-.014 0 0zm0-.014c0-.014 0-.014 0 0-.014-.014-.014-.014 0 0-.014-.014-.014-.014 0 0-.014-.014-.014-.014 0 0 0-.014-.014-.014 0 0zm.015.014s0-.014 0 0c-.015-.014 0 0 0 0zm-.015.029c-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0 0 0-.014 0 0 0 0 .014 0 0 0 0 0 .014 0 .014 0 0 0 0 0 .014 0 0zm-.042 0c-.014 0-.014 0 0 0-.014 0-.014 0 0 0 0 0-.014 0 0 0zm.028-.057c0-.014 0-.014 0 0zm.029.07v-.013.014c0 .014 0 0 0 0 0 .014 0 .014 0 0v.028l.014.014s0-.014-.014-.042c.014.014.014.014 0 0 .014.014.014.014 0 0 0 .014 0 .014 0 0 0 .014 0 .014 0 0zm-.029.03s0-.015 0 0c0-.015 0-.015 0 0 0-.015 0-.015 0 0 0-.015 0-.015 0 0 0 0 0-.015 0 0 .014.013.014.028.029.042v-.014c0-.015-.015-.029-.029-.029zm-.014-.03c-.014 0-.014 0 0 0-.014 0 0 0 0 0zm-.014-.013c-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014.014-.014 0 0 0-.014.014-.014.014 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0zm-.014 0c-.015 0-.015 0 0 0-.015 0-.015 0 0 0 0 0-.015 0 0 0zm-.015-.029s0 .014 0 0c0 .014 0 0 0 0 0 .014 0 0 0 0 0 .014 0 .014.015.014-.015 0-.015-.014-.015-.014zm-.014-.014s.014 0 0 0c.014 0 .014 0 0 0 .014 0 .014 0 0 0 .014 0 .014 0 0 0 .014 0 .014 0 0 0 .014 0 .014 0 0 0 .014 0 .014 0 0 0 .014-.014.014 0 0 0 .014 0 .014-.014 0 0 .014-.014.014-.014 0 0 .014-.014.014-.014 0 0 .014 0 .014-.014 0 0 0-.014 0 0 0 0 0-.014 0-.014 0 0 0 0 0-.014 0 0zm.057-.028c.014 0 .014 0 0 0 .014 0 .014 0 0 0 .014 0 .014 0 0 0l.014.014c0-.014-.014-.014-.014-.014zm.014 0s0-.014 0 0c0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0h.014v-.014c-.014 0-.014 0-.014.014 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0-.014-.014-.014-.014 0 0-.014-.014-.014-.014 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0zm0-.029c0-.014 0-.014 0 0 .014-.014.014-.028.014-.028-.014 0-.014 0-.014.029 0-.015 0-.015 0 0zm.043 0s-.014.015 0 0c0 .015 0 .015 0 0 .014 0 .014 0 .014-.014l-.014.014zm.014.015l-.014.014s.014 0 .014-.014c.014 0 .029 0 .029-.014-.015.014-.029.014-.029.014zm0 .028v.014l.014-.014h-.014zm-.014.028s-.014 0 0 0c-.014 0-.014 0-.014-.014h-.015v.014h.029c-.014 0-.014 0 0 0 0 0-.014 0 0 0zm-.071.057c-.014 0-.014 0 0 0v-.014c-.014 0-.014 0 0 .014l-.014-.014.014.014c-.014-.014-.014-.014 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0-.014 0 0 0-.014 0 0 0 0 0s-.014 0 0 0zm-.057-.042s.014 0 0 0c.014 0 .014 0 0 0h0c.014 0 .014 0 0 0 0 0 .014 0 0 0zm-.071-.029c.014 0 .014 0 0 0 .014 0 .014 0 .028.014.014 0 .014-.014.029-.014h-.057c.014 0 .014 0 0 0 .014 0 .014 0 0 0zm.128-.056c0 .014 0 .014 0 0 0 .014 0 .014 0 0 0 .014 0 .014 0 0v.014c.014 0 0 0 0-.014 0 .014 0 .014 0 0 0 .014.014.014 0 0zm.156-.199a.432.432 0 0 0-.071.1c0 .014-.014.028-.014.056l.043-.043a.952.952 0 0 1 .042-.113zm-.199.213c0 .014 0 .014 0 0-.014 0-.014 0 0 0 0 0-.014 0 0 0zm-.057-.114c-3.072-3.244-38.72-46.731-38.72-46.731l16.785-9.788s20.626 52.256 21.964 56.52c-.015-.015-.043-.057-.057-.072 0 .029.014.057.028.071zm-.071.071C55.984 58.701 3.309 38.8 3.309 38.8l9.602-16.828s44.083 34.974 47.383 38.005a.109.109 0 0 1-.057-.028c.015.014.029.028.043.028zm-.014.1C55.899 61.095.293 70.09.293 70.09L.179 50.754s55.72 8.344 60.087 9.321h-.029.029zm.07.014c.015 0 .03 0 .044.014h.014c-.014.014-.029.014-.043.028H60.394l-.014.014c.014 0 .028-.014.042-.014v.014h.015c0 .014-.015.029-.015.043l.015-.014v.042c.014-.014.014-.028.028-.042v.085c-.057.17-.085.269-.071.269 0 0 0-.043.014-.1-.028.071-.043.1-.043.1s.029-.1.072-.284c0 0-.015.015-.015.029 0 .014-.014.014-.014.014 0-.014.014-.028.014-.043v-.014c-.014.014-.014.014-.028.014-.128.114-.2.184-.2.184s.03-.028.058-.085c-.057.043-.086.071-.086.057 0 0 .071-.07.185-.198.014-.014.014-.014.014-.029h-.014c-.014 0-.028.015-.043.015l.015-.014.014-.015c.014 0 .014-.014.014-.014-.199.043-.299.071-.299.071s.043-.014.114-.042c-.07.014-.114.014-.1.014 0 0 .1-.029.27-.085-.013-.014-.013-.014 0-.014-.013 0-.013 0 0 0-.013 0-.013 0 0 0zm-.042.084c-3.257 3.06-46.914 38.53-46.914 38.53L3.579 82.019s52.434-20.512 56.715-21.843c-.014 0 0 0 0 0s-.014 0 0 0zm.071.057C59.071 64.51 39.1 116.963 39.1 116.963l-16.871-9.576c-.014 0 35.108-43.87 38.137-47.156 0 .014 0 .014 0 0 0 .014 0 .014 0 0zm.1.029c1.024 4.348 10.057 59.734 10.057 59.734l-19.417.1s8.378-55.472 9.36-59.834v0zm.085-.029c3.073 3.258 38.72 46.746 38.72 46.746l-16.785 9.774S61.873 64.523 60.536 60.259c.014.015.014.029.029.029.014-.028 0-.043-.015-.057zm.072-.07c4.295 1.288 57.014 21.19 57.014 21.19l-9.63 16.829S63.921 63.206 60.62 60.174c.015.015.043.015.072.029-.015-.014-.043-.029-.072-.043z",
                                  fill: "url(#f)",
                                  fillOpacity: "0.5",
                                  transform: "translate(17)"
                                }), React.createElement("g", {
                                  className: "star",
                                  id: "Fireworks",
                                  transform: "translate(0 38)"
                                }, React.createElement("path", {
                                      id: "fire",
                                      d: "M82.513 60.152a1.846 1.846 0 0 1 1.985-1.676 1.845 1.845 0 0 1 1.657 2.007L78.84 142.33a2.03 2.03 0 0 1-.199.673 1.852 1.852 0 0 1-.359.477c-.02.018-.035.037-.055.055a1.853 1.853 0 0 1-.576.344c-.148.056-.3.097-.465.114a1.749 1.749 0 0 1-.327 0 1.794 1.794 0 0 1-.549-.148 1.827 1.827 0 0 1-.49-.31c-.02-.018-.037-.037-.055-.055a1.868 1.868 0 0 1-.386-.535 1.926 1.926 0 0 1-.177-.627L67.89 60.483a1.845 1.845 0 0 1 1.658-2.007 1.85 1.85 0 0 1 1.985 1.676l5.489 61.455 5.49-61.455zm3.68-7.065a1.839 1.839 0 0 1-1.834-1.843c0-1.018.822-1.843 1.835-1.843s1.834.825 1.834 1.843a1.839 1.839 0 0 1-1.834 1.843zm-9.17-1.229c-.885 0-1.602-5.272-1.602-6.161 0-.889.717-1.61 1.602-1.61.884 0 1.602.721 1.602 1.61 0 .889-.718 6.161-1.602 6.161zm-8.529 1.229a1.839 1.839 0 0 1-1.834-1.843c0-1.018.821-1.843 1.834-1.843 1.013 0 1.835.825 1.835 1.843a1.839 1.839 0 0 1-1.835 1.843z",
                                      fill: "url(#g)"
                                    }), React.createElement("path", {
                                      d: "M121.856 87.388c.897-.476 2-.129 2.47.77.47.904.13 2.022-.762 2.5-.32.174-23.583 13.18-31.347 51.862-.004.013-.012.024-.016.04a1.83 1.83 0 0 1-.21.54c-.006.009-.008.018-.013.026-.099.162-.227.3-.37.423-.02.018-.038.038-.06.055-.14.11-.298.199-.467.264-.03.012-.06.022-.091.033-.161.053-.328.092-.506.098l-.057.001h-.004c-.25 0-.487-.052-.705-.144-.043-.019-.08-.045-.121-.066-.063-.032-.128-.064-.187-.103-.048-.032-.09-.073-.135-.11-.045-.037-.092-.071-.134-.113-.04-.04-.074-.086-.11-.13-.038-.046-.08-.09-.113-.14-.031-.047-.055-.097-.081-.145-.03-.055-.063-.108-.087-.163-.024-.056-.039-.115-.057-.172-.019-.055-.038-.108-.05-.166-.016-.069-.02-.138-.027-.208-.005-.043-.016-.084-.018-.128v-.045-.022c-1.118-35.57 22.689-61.68 23.702-62.774a1.816 1.816 0 0 1 2.582-.084c.738.698.775 1.869.086 2.613-.192.207-15.416 16.947-20.847 41.151 10.326-26.054 26.892-35.213 27.735-35.663zm3.497-1.53c-.675 0-1.222-.55-1.222-1.228 0-.679.547-1.229 1.222-1.229.676 0 1.223.55 1.223 1.229s-.547 1.229-1.223 1.229zm-5.863-1.857c-.494-.431 1.65-3.721 2.08-4.217a1.18 1.18 0 0 1 1.67-.117c.493.43.545 1.182.116 1.678-.429.495-3.373 3.086-3.866 2.656z",
                                      fill: "url(#h)"
                                    }), React.createElement("path", {
                                      d: "M40.191 80.81a1.815 1.815 0 0 1 2.582.122c1.014 1.126 24.807 27.95 22.67 61.339-.003.027-.011.053-.014.081a1.818 1.818 0 0 1-.925 1.407 1.67 1.67 0 0 1-.147.078 2 2 0 0 1-.175.066c-.052.016-.102.033-.155.047-.065.014-.132.022-.198.03-.039.004-.076.015-.115.018l-.093.002h-.006c-.038 0-.076-.001-.116-.004-.038-.002-.074-.014-.11-.02-.065-.008-.129-.015-.192-.03-.055-.014-.107-.032-.16-.05-.058-.02-.115-.039-.172-.066a2.116 2.116 0 0 1-.3-.174 2.712 2.712 0 0 1-.13-.103 1.769 1.769 0 0 1-.344-.4 1.484 1.484 0 0 1-.16-.308 1.724 1.724 0 0 1-.127-.52c-.002-.026-.01-.052-.012-.077-1.589-30.875-32.725-53.18-33.039-53.403a1.862 1.862 0 0 1-.455-2.573 1.816 1.816 0 0 1 2.545-.46c.992.698 18.474 13.22 28.224 32.896-5.877-20.49-18.82-35.09-18.996-35.285a1.865 1.865 0 0 1 .12-2.612zm-15.656 3.755a1.839 1.839 0 0 1-1.834-1.843c0-1.018.821-1.843 1.834-1.843 1.013 0 1.835.825 1.835 1.843a1.839 1.839 0 0 1-1.835 1.843zm10.373-9.807c-.675 0-1.223-.55-1.223-1.228 0-.679.548-1.229 1.223-1.229.676 0 1.223.55 1.223 1.229 0 .678-.547 1.228-1.223 1.228z",
                                      fill: "url(#i)"
                                    }), React.createElement("path", {
                                      id: "Star",
                                      d: "M59.266 68.285l-3.34-.97 2.277-3.052a1.343 1.343 0 0 0-.257-1.866 1.306 1.306 0 0 0-1.844.26l-2.289 3.065-1.929-3.08a1.306 1.306 0 0 0-1.817-.412 1.34 1.34 0 0 0-.407 1.837l1.986 3.17-3.254.873a1.333 1.333 0 0 0-.935 1.63 1.319 1.319 0 0 0 1.61.945l3.37-.905.074 3.54a1.325 1.325 0 0 0 1.316 1.304h.028a1.326 1.326 0 0 0 1.29-1.359l-.072-3.428 3.466 1.008a1.319 1.319 0 0 0 1.63-.912 1.334 1.334 0 0 0-.903-1.648z",
                                      fill: "#FEDDDE"
                                    }), React.createElement("path", {
                                      d: "M116.606 43.633l-2.505-.728 1.708-2.289a1.008 1.008 0 0 0-.193-1.4.98.98 0 0 0-1.383.195l-1.716 2.3-1.447-2.31a.98.98 0 0 0-1.363-.31c-.46.295-.597.912-.306 1.378l1.49 2.378-2.44.654a1 1 0 0 0-.702 1.222.989.989 0 0 0 1.208.71l2.528-.68.055 2.656a.994.994 0 0 0 .987.978h.02a.994.994 0 0 0 .968-1.02l-.054-2.57 2.6.755c.09.027.183.04.273.04a.99.99 0 0 0 .948-.724 1 1 0 0 0-.676-1.235z",
                                      fill: "#FEDDDE"
                                    }), React.createElement("path", {
                                      d: "M127.269 59.092a.711.711 0 0 0 .534-.39l4.645-9.34a.705.705 0 0 1 1.268 0l4.645 9.34a.71.71 0 0 0 .534.39l10.493 1.505c.588.084.82.82.391 1.236l-7.542 7.302a.728.728 0 0 0-.209.648l1.814 10.328c.103.585-.497 1.038-1.02.77l-9.418-4.836a.7.7 0 0 0-.643.001l-9.312 4.833c-.52.27-1.121-.177-1.024-.762l1.715-10.337a.728.728 0 0 0-.21-.642l-7.545-7.305c-.43-.416-.197-1.152.39-1.236l10.494-1.505zM11.105 54.178a.71.71 0 0 0 .534-.39l4.645-9.34a.705.705 0 0 1 1.268 0l4.645 9.34a.71.71 0 0 0 .534.39l10.493 1.505c.588.084.82.82.391 1.236l-7.542 7.302a.728.728 0 0 0-.209.648l1.814 10.327c.103.586-.497 1.039-1.02.77l-9.418-4.835a.7.7 0 0 0-.643.001l-9.312 4.833c-.52.27-1.121-.177-1.024-.762l1.715-10.337a.728.728 0 0 0-.21-.642L.221 56.92c-.43-.416-.197-1.152.39-1.236l10.494-1.505z",
                                      fill: "#FFF",
                                      stroke: "#F67AA6",
                                      strokeWidth: "3"
                                    }), React.createElement("path", {
                                      d: "M69.67 14.405l-14.305 2.053c-.8.115-1.118 1.117-.532 1.684l10.285 9.959c.233.225.34.553.287.874l-2.338 14.093c-.133.797.686 1.406 1.395 1.038l12.694-6.588a.955.955 0 0 1 .877-.002l12.84 6.592c.712.366 1.53-.252 1.39-1.05L89.788 28.98a.992.992 0 0 1 .285-.883l10.281-9.955c.586-.567.269-1.57-.532-1.684l-14.304-2.052a.97.97 0 0 1-.73-.53L78.46 1.141a.962.962 0 0 0-1.73 0L70.4 13.875a.97.97 0 0 1-.73.53z",
                                      fill: "#FFF",
                                      stroke: "#F67AA6",
                                      strokeWidth: "4"
                                    }))))));
    });
  return newrecord;
}

exports.component = component;
exports.make = make;
/* component Not a pure module */


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/beep-07.d932c606.mp3";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/points_shield.ab7c339e.svg";

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/congratulation_bg.9a1d9bb9.svg";

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/round_icon.4c652688.svg";

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/plan_icon.6a9de9f7.svg";

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64);
module.exports = __webpack_require__(70);


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(65).enable();
  window.Promise = __webpack_require__(68);
}

// fetch() polyfill for making API calls.
__webpack_require__(69);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(18);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(31);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 67 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(31);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var App = __webpack_require__(71);
var ReactDOMRe = __webpack_require__(173);
var ReasonReact = __webpack_require__(2);
var RegisterServiceWorker = __webpack_require__(184);

((__webpack_require__(185)));

ReactDOMRe.renderToElementWithId(ReasonReact.element(/* None */0, /* None */0, App.make(/* array */[])), "root");

RegisterServiceWorker.default();

/*  Not a pure module */


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Week = __webpack_require__(102);
var $$Array = __webpack_require__(12);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Login = __webpack_require__(108);
var Reset = __webpack_require__(110);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Js_exn = __webpack_require__(10);
var Wizard = __webpack_require__(112);
var FoodDay = __webpack_require__(117);
var Network = __webpack_require__(7);
var Storage = __webpack_require__(14);
var Testing = __webpack_require__(119);
var Workout = __webpack_require__(121);
var FoodWeek = __webpack_require__(127);
var Js_types = __webpack_require__(128);
var Register = __webpack_require__(129);
var Settings = __webpack_require__(132);
var Dashboard = __webpack_require__(134);
var Knowledge = __webpack_require__(139);
var ResetExec = __webpack_require__(144);
var Caml_array = __webpack_require__(9);
var Caml_format = __webpack_require__(8);
var LogoutModal = __webpack_require__(145);
var ReasonReact = __webpack_require__(2);
var WorkoutView = __webpack_require__(146);
var WorkoutWeek = __webpack_require__(147);
var FoodDayStage = __webpack_require__(149);
var SupportFuncs = __webpack_require__(50);
var WorkoutConfig = __webpack_require__(156);
var KnowledgeEntry = __webpack_require__(158);
var WorkoutWeekBonus = __webpack_require__(159);
var WorkoutWeekCardio = __webpack_require__(164);
var Caml_builtin_exceptions = __webpack_require__(3);
var Logout_iconSvg = __webpack_require__(167);
var Mbb_logo_384Png = __webpack_require__(168);
var Dashboard_iconSvg = __webpack_require__(169);
var Logout_icon_hoverSvg = __webpack_require__(170);
var Dashboard_icon_hoverSvg = __webpack_require__(171);

((__webpack_require__(172)));

var app = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.textAlign(Css.center),
          /* :: */[
            Css.width(/* `percent */[
                  -119887163,
                  100.0
                ]),
            /* :: */[
              Css.background(Css.hex("FCEBEC")),
              /* :: */[
                Css.overflowY(/* auto */-1065951377),
                /* :: */[
                  Css.minHeight(/* `vh */[
                        26418,
                        100.0
                      ]),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var appHeader = Css.style(/* :: */[
      Css.backgroundColor(/* `hex */[
            5194459,
            "FFBFC2"
          ]),
      /* :: */[
        Css.height(Css.px(65)),
        /* :: */[
          Css.alignSelf(Css.stretch),
          /* :: */[
            Css.flexDirection(Css.row),
            /* :: */[
              Css.justifyContent(Css.center),
              /* :: */[
                Css.alignItems(Css.center),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var appHeaderContent = Css.style(/* :: */[
      Css.maxWidth(Css.px(500)),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.justifyContent(Css.spaceBetween),
            /* [] */0
          ]
        ]
      ]
    ]);

var appHeaderContentSlim = Css.style(/* :: */[
      Css.maxWidth(Css.px(500)),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.justifyContent(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var appHeaderLinkLeft = Css.style(/* :: */[
      Css.color(Css.white),
      /* :: */[
        Css.selector("&:active", /* :: */[
              Css.color(/* `hex */[
                    5194459,
                    "00C9C8"
                  ]),
              /* [] */0
            ]),
        /* :: */[
          Css.media("(hover)", /* :: */[
                Css.selector("&:hover", /* :: */[
                      Css.color(/* `hex */[
                            5194459,
                            "00C9C8"
                          ]),
                      /* [] */0
                    ]),
                /* [] */0
              ]),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.fontSize(Css.px(16)),
              /* :: */[
                Css.fontWeight(700),
                /* :: */[
                  Css.lineHeight(1.3),
                  /* :: */[
                    Css.textDecoration(/* none */-922086728),
                    /* :: */[
                      Css.cursor(/* pointer */-786317123),
                      /* :: */[
                        Css.marginLeft(Css.px(8)),
                        /* :: */[
                          Css.marginRight(Css.px(0)),
                          /* :: */[
                            Css.minWidth(Css.px(105)),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var appHeaderLinkRight = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.fontSize(Css.px(16)),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.lineHeight(1.3),
            /* :: */[
              Css.textDecoration(/* none */-922086728),
              /* :: */[
                Css.cursor(/* pointer */-786317123),
                /* :: */[
                  Css.color(Css.white),
                  /* :: */[
                    Css.marginLeft(Css.px(0)),
                    /* :: */[
                      Css.marginRight(Css.px(8)),
                      /* :: */[
                        Css.minWidth(Css.px(105)),
                        /* :: */[
                          Css.textAlign(/* right */-379319332),
                          /* [] */0
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var modal = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.fontSize(Css.px(16)),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.lineHeight(1.3),
            /* :: */[
              Css.textDecoration(/* none */-922086728),
              /* :: */[
                Css.cursor(/* pointer */-786317123),
                /* :: */[
                  Css.color(Css.white),
                  /* :: */[
                    Css.marginLeft(Css.px(0)),
                    /* :: */[
                      Css.marginRight(Css.px(8)),
                      /* :: */[
                        Css.minWidth(Css.px(105)),
                        /* :: */[
                          Css.textAlign(/* right */-379319332),
                          /* [] */0
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var iconStyle = Css.style(/* :: */[
      Css.fontSize(Css.px(20)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.2,
                1.2
              ]
            ]),
        /* :: */[
          Css.height(Css.px(20)),
          /* :: */[
            Css.marginTop(Css.px(5)),
            /* [] */0
          ]
        ]
      ]
    ]);

var headerTextEl = Css.style(/* :: */[
      Css.justifyContent(/* center */98248149),
      /* :: */[
        Css.textTransform(/* uppercase */-415330030),
        /* :: */[
          Css.fontSize(Css.px(12)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* app */app,
  /* appHeader */appHeader,
  /* appHeaderContent */appHeaderContent,
  /* appHeaderContentSlim */appHeaderContentSlim,
  /* appHeaderLinkLeft */appHeaderLinkLeft,
  /* appHeaderLinkRight */appHeaderLinkRight,
  /* modal */modal,
  /* iconStyle */iconStyle,
  /* headerTextEl */headerTextEl
];

function setInitialRoute() {
  var url = ReasonReact.Router[/* dangerouslyGetInitialUrl */3](/* () */0);
  var match = url[/* path */0];
  if (match) {
    switch (match[0]) {
      case "dashboard" : 
      case "login" : 
          return /* Knowledge */5;
      default:
        return /* Knowledge */5;
    }
  } else {
    return /* Knowledge */5;
  }
}

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      return 0;
    } else {
      throw exn;
    }
  }
}

var component = ReasonReact.reducerComponent("App");

function make() {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      var x = self[/* state */2][/* lastRoute */2];
      var match = +(self[/* state */2][/* lastRoute */2].length === 5) && self[/* state */2][/* loggedIn */1];
      if (match !== 0) {
        ReasonReact.Router[/* push */0]("/week/" + (Caml_array.caml_array_get(x, 0) + ("/workout/" + (Caml_array.caml_array_get(x, 1) + ("/" + (Caml_array.caml_array_get(x, 2) + ("/" + (Caml_array.caml_array_get(x, 3) + ("/" + Caml_array.caml_array_get(x, 4))))))))));
      } else {
        var match$1 = typeof (history) === "undefined" ? undefined : (history);
        var match$2 = typeof (window) === "undefined" ? undefined : (window);
        if (match$1 !== undefined) {
          if (match$2 !== undefined) {
            var match$3 = Js_types.classify(Event);
            if (typeof match$3 === "number") {
              if (match$3 === 3) {
                var ev = document.createEvent("Event");
                ev.initEvent("submit", true, true);
                console.log("IE fallback running");
              } else {
                match$2.dispatchEvent(new Event("popstate"));
              }
            } else if (match$3.tag === 3) {
              var ev$1 = document.createEvent("Event");
              ev$1.initEvent("submit", true, true);
              console.log("IE fallback2 running");
            } else {
              match$2.dispatchEvent(new Event("popstate"));
            }
          } else {
            console.log("no window");
          }
        } else {
          console.log("no history");
        }
      }
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var route = self[/* state */2][/* route */0];
      var handleClickDash = function () {
        Storage.clearLoc(/* () */0);
        return ReasonReact.Router[/* push */0]("/dashboard");
      };
      var handleClickLogout = function () {
        return Curry._1(self[/* send */4], /* ShowLogout */5);
      };
      var changeDashHover = function () {
        return Curry._1(self[/* send */4], /* DashHover */0);
      };
      var changeDashNonHover = function () {
        return Curry._1(self[/* send */4], /* DashNonHover */2);
      };
      var changeLogoutHover = function () {
        return Curry._1(self[/* send */4], /* LogoutHover */3);
      };
      var changeLogoutNonHover = function () {
        return Curry._1(self[/* send */4], /* LogoutNonHover */4);
      };
      var match = self[/* state */2][/* loggedIn */1];
      var match$1 = self[/* state */2][/* logoutVisible */5];
      var tmp;
      if (typeof route === "number") {
        switch (route) {
          case 0 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Login.make(/* array */[]));
              break;
          case 1 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Register.make(/* array */[]));
              break;
          case 2 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Reset.make(/* array */[]));
              break;
          case 3 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Dashboard.make(/* array */[]));
              break;
          case 4 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Settings.make(/* array */[]));
              break;
          case 5 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Knowledge.make(/* array */[]));
              break;
          case 6 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Testing.make(/* array */[]));
              break;
          case 7 : 
              tmp = React.createElement("p", undefined, "no route yet");
              break;
          
        }
      } else {
        switch (route.tag | 0) {
          case 0 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, ResetExec.make(route[0], /* array */[]));
              break;
          case 1 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Wizard.make(route[0], /* array */[]));
              break;
          case 2 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Week.make(route[0], /* array */[]));
              break;
          case 3 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, WorkoutWeek.make(route[0], /* array */[]));
              break;
          case 4 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, WorkoutWeekCardio.make(route[0], /* array */[]));
              break;
          case 5 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, WorkoutWeekBonus.make(route[0], /* array */[]));
              break;
          case 6 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, WorkoutConfig.make(route[0], route[1], /* array */[]));
              break;
          case 7 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, WorkoutView.make(route[0], route[1], /* array */[]));
              break;
          case 8 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Workout.make(route[0], route[1], route[2], route[3], route[4], /* array */[]));
              break;
          case 9 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, FoodWeek.make(route[0], /* array */[]));
              break;
          case 10 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, FoodDay.make(route[0], /* array */[]));
              break;
          case 11 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, FoodDayStage.make(route[0], route[1], /* array */[]));
              break;
          case 12 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, KnowledgeEntry.make(route[0], /* array */[]));
              break;
          
        }
      }
      return React.createElement("div", {
                  className: app
                }, React.createElement("div", {
                      className: appHeader
                    }, match !== 0 ? React.createElement("div", {
                            className: appHeaderContent
                          }, React.createElement("a", {
                                className: appHeaderLinkLeft,
                                onClick: handleClickDash,
                                onMouseOut: changeDashNonHover,
                                onMouseOver: changeDashHover
                              }, React.createElement("img", {
                                    className: iconStyle,
                                    alt: "",
                                    src: self[/* state */2][/* srcDash */3]
                                  }), React.createElement("div", {
                                    className: headerTextEl
                                  }, "Dashboard")), React.createElement("img", {
                                className: "App-logo",
                                alt: "logo",
                                src: Mbb_logo_384Png
                              }), React.createElement("a", {
                                className: appHeaderLinkLeft,
                                onClick: handleClickLogout,
                                onMouseOut: changeLogoutNonHover,
                                onMouseOver: changeLogoutHover
                              }, React.createElement("img", {
                                    className: iconStyle,
                                    alt: "",
                                    src: self[/* state */2][/* srcLogout */4]
                                  }), React.createElement("div", {
                                    className: headerTextEl
                                  }, "Logout"))) : React.createElement("div", {
                            className: appHeaderContentSlim
                          }, React.createElement("img", {
                                className: "App-logo",
                                alt: "logo",
                                src: Mbb_logo_384Png
                              }))), match$1 !== 0 ? ReasonReact.element(/* None */0, /* None */0, LogoutModal.make((function () {
                              return Curry._1(self[/* send */4], /* HideLogout */6);
                            }), (function () {
                              return Curry._1(self[/* send */4], /* HideLogoutAndLogout */7);
                            }), /* array */[])) : null, React.createElement("main", {
                      className: Theme.main
                    }, React.createElement("div", {
                          className: Theme.contentBox
                        }, tmp)));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* route */setInitialRoute(/* () */0),
              /* loggedIn */Storage.checkIfLoggedIn(/* () */0),
              /* lastRoute */Storage.checkForLastRouteFromLs(/* () */0),
              /* srcDash */Dashboard_iconSvg,
              /* srcLogout */Logout_iconSvg,
              /* logoutVisible : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              var newrecord = state.slice();
              return /* Update */Block.__(0, [(newrecord[/* srcDash */3] = Dashboard_icon_hoverSvg, newrecord)]);
          case 1 : 
              return /* Update */Block.__(0, [/* record */[
                          /* route */state[/* route */0],
                          /* loggedIn */state[/* loggedIn */1],
                          /* lastRoute */state[/* lastRoute */2],
                          /* srcDash */Dashboard_iconSvg,
                          /* srcLogout */Logout_iconSvg,
                          /* logoutVisible */state[/* logoutVisible */5]
                        ]]);
          case 2 : 
              var newrecord$1 = state.slice();
              return /* Update */Block.__(0, [(newrecord$1[/* srcDash */3] = Dashboard_iconSvg, newrecord$1)]);
          case 3 : 
              var newrecord$2 = state.slice();
              return /* Update */Block.__(0, [(newrecord$2[/* srcLogout */4] = Logout_icon_hoverSvg, newrecord$2)]);
          case 4 : 
              var newrecord$3 = state.slice();
              return /* Update */Block.__(0, [(newrecord$3[/* srcLogout */4] = Logout_iconSvg, newrecord$3)]);
          case 5 : 
              var newrecord$4 = state.slice();
              return /* Update */Block.__(0, [(newrecord$4[/* logoutVisible */5] = /* true */1, newrecord$4)]);
          case 6 : 
              var newrecord$5 = state.slice();
              return /* Update */Block.__(0, [(newrecord$5[/* logoutVisible */5] = /* false */0, newrecord$5)]);
          case 7 : 
              var newrecord$6 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$6[/* logoutVisible */5] = /* false */0, newrecord$6),
                        (function () {
                            return SupportFuncs.handleLogout(/* () */0);
                          })
                      ]);
          case 8 : 
              return /* SideEffects */Block.__(2, [(function () {
                            var syncStatus = Network.pullSyncConfig(/* () */0);
                            var syncIt = function () {
                              console.log("syncIt");
                              Network.initializeSyncStatus2(/* () */0);
                              return Network.pullData("", (function (data) {
                                            return Network.successSyncAllNoRedirect(data, (function () {
                                                          return /* () */0;
                                                        }));
                                          }));
                            };
                            var x = $$Array.to_list(syncStatus);
                            var exists = function (p, _param) {
                              while(true) {
                                var param = _param;
                                if (param) {
                                  if (Curry._1(p, param[0])) {
                                    return /* true */1;
                                  } else {
                                    _param = param[1];
                                    continue ;
                                    
                                  }
                                } else {
                                  return /* false */0;
                                }
                              };
                            };
                            var dirty = exists((function (item) {
                                    return +(Caml_array.caml_array_get(item, 0) === "fresh");
                                  }), x);
                            if (dirty) {
                              console.log("dirty");
                              syncIt(/* () */0);
                            }
                            return /* () */0;
                          })]);
          
        }
      } else if (action.tag) {
        var url = action[1];
        return /* UpdateWithSideEffects */Block.__(3, [
                  /* record */[
                    /* route */action[0],
                    /* loggedIn */Storage.checkIfLoggedIn(/* () */0),
                    /* lastRoute */state[/* lastRoute */2],
                    /* srcDash */state[/* srcDash */3],
                    /* srcLogout */state[/* srcLogout */4],
                    /* logoutVisible */state[/* logoutVisible */5]
                  ],
                  (function (self) {
                      if (url !== "nothing") {
                        console.log("pushing redirect: ", url);
                        return ReasonReact.Router[/* push */0]("/" + url);
                      } else {
                        console.log("pushing login ");
                        return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Login */0]));
                      }
                    })
                ]);
      } else {
        return /* UpdateWithSideEffects */Block.__(3, [
                  /* record */[
                    /* route */action[0],
                    /* loggedIn */Storage.checkIfLoggedIn(/* () */0),
                    /* lastRoute */state[/* lastRoute */2],
                    /* srcDash */Dashboard_iconSvg,
                    /* srcLogout */state[/* srcLogout */4],
                    /* logoutVisible */state[/* logoutVisible */5]
                  ],
                  (function () {
                      window.scrollTo(0, 0);
                      return /* () */0;
                    })
                ]);
      }
    });
  newrecord[/* subscriptions */13] = (function (self) {
      return /* :: */[
              /* Sub */[
                (function () {
                    return ReasonReact.Router[/* watchUrl */1]((function (url) {
                                  var match = url[/* path */0];
                                  var match$1 = Storage.checkIfLoggedIn(/* () */0);
                                  var exit = 0;
                                  if (match) {
                                    switch (match[0]) {
                                      case "" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else if (match$1 !== 0) {
                                            return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                          /* Dashboard */3,
                                                          "dashboard"
                                                        ]));
                                          } else {
                                            return ReasonReact.Router[/* push */0]("/login");
                                          }
                                          break;
                                      case "dashboard" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else if (match$1 !== 0) {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Dashboard */3]));
                                          } else {
                                            return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                          /* Login */0,
                                                          "login"
                                                        ]));
                                          }
                                          break;
                                      case "fallback" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Knowledge */5]));
                                          }
                                          break;
                                      case "foodday" : 
                                          var match$2 = match[1];
                                          if (match$2) {
                                            var match$3 = match$2[1];
                                            var day = match$2[0];
                                            if (match$3) {
                                              if (match$3[1]) {
                                                exit = 1;
                                              } else if (match$1 !== 0) {
                                                var stage = match$3[0];
                                                if (convToInt(day) > 0 && convToInt(day) < 29 && (stage === "breakfast" || stage === "snack" || stage === "lunch" || stage === "dinner")) {
                                                  return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* FoodDayStage */Block.__(11, [
                                                                    day,
                                                                    stage
                                                                  ])]));
                                                } else {
                                                  exit = 1;
                                                }
                                              } else {
                                                return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                              /* Login */0,
                                                              "login"
                                                            ]));
                                              }
                                            } else if (match$1 !== 0) {
                                              if (convToInt(day) === 0) {
                                                return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* FoodDay */Block.__(10, ["1"])]));
                                              } else if (convToInt(day) > 0 && convToInt(day) < 29) {
                                                return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* FoodDay */Block.__(10, [day])]));
                                              } else {
                                                exit = 1;
                                              }
                                            } else {
                                              return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                            /* Login */0,
                                                            "login"
                                                          ]));
                                            }
                                          } else {
                                            exit = 1;
                                          }
                                          break;
                                      case "knowledge" : 
                                          var match$4 = match[1];
                                          if (match$4) {
                                            if (match$4[1]) {
                                              exit = 1;
                                            } else if (match$1 !== 0) {
                                              var entry = match$4[0];
                                              if (convToInt(entry) > 0 && convToInt(entry) < 25) {
                                                return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* KnowledgeEntry */Block.__(12, [entry])]));
                                              } else {
                                                exit = 1;
                                              }
                                            } else {
                                              return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                            /* Login */0,
                                                            "login"
                                                          ]));
                                            }
                                          } else if (match$1 !== 0) {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Knowledge */5]));
                                          } else {
                                            return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                          /* Login */0,
                                                          "login"
                                                        ]));
                                          }
                                          break;
                                      case "login" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else if (match$1 !== 0) {
                                            return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                          /* Dashboard */3,
                                                          "dashboard"
                                                        ]));
                                          } else {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Login */0]));
                                          }
                                          break;
                                      case "password-reset" : 
                                          var match$5 = match[1];
                                          if (match$5) {
                                            if (match$5[1]) {
                                              exit = 1;
                                            } else {
                                              return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* ResetExec */Block.__(0, [match$5[0]])]));
                                            }
                                          } else {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* ResetExec */Block.__(0, [""])]));
                                          }
                                          break;
                                      case "register" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else if (match$1 !== 0) {
                                            return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                          /* Dashboard */3,
                                                          "dashboard"
                                                        ]));
                                          } else {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Register */1]));
                                          }
                                          break;
                                      case "reset" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Reset */2]));
                                          }
                                          break;
                                      case "settings" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else if (match$1 !== 0) {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Settings */4]));
                                          } else {
                                            return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                          /* Login */0,
                                                          "login"
                                                        ]));
                                          }
                                          break;
                                      case "testing" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else if (match$1 !== 0) {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Testing */6]));
                                          } else {
                                            return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                          /* Login */0,
                                                          "login"
                                                        ]));
                                          }
                                          break;
                                      case "week" : 
                                          var match$6 = match[1];
                                          if (match$6) {
                                            var match$7 = match$6[1];
                                            var week = match$6[0];
                                            if (match$7) {
                                              switch (match$7[0]) {
                                                case "bonus" : 
                                                    if (match$7[1]) {
                                                      exit = 1;
                                                    } else if (match$1 !== 0) {
                                                      if (week === "1" || week === "2" || week === "3" || week === "4") {
                                                        return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* WorkoutWeekBonus */Block.__(5, [week])]));
                                                      } else {
                                                        exit = 1;
                                                      }
                                                    } else {
                                                      return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                                    /* Login */0,
                                                                    "login"
                                                                  ]));
                                                    }
                                                    break;
                                                case "cardio" : 
                                                    if (match$7[1]) {
                                                      exit = 1;
                                                    } else if (match$1 !== 0) {
                                                      if (week === "1" || week === "2" || week === "3" || week === "4") {
                                                        return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* WorkoutWeekCardio */Block.__(4, [week])]));
                                                      } else {
                                                        exit = 1;
                                                      }
                                                    } else {
                                                      return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                                    /* Login */0,
                                                                    "login"
                                                                  ]));
                                                    }
                                                    break;
                                                case "foodweek" : 
                                                    if (match$7[1]) {
                                                      exit = 1;
                                                    } else if (match$1 !== 0) {
                                                      if (week === "1" || week === "2" || week === "3" || week === "4") {
                                                        return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* FoodWeek */Block.__(9, [week])]));
                                                      } else {
                                                        exit = 1;
                                                      }
                                                    } else {
                                                      return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                                    /* Login */0,
                                                                    "login"
                                                                  ]));
                                                    }
                                                    break;
                                                case "workout" : 
                                                    var match$8 = match$7[1];
                                                    if (match$8) {
                                                      var match$9 = match$8[1];
                                                      if (match$9) {
                                                        var round = match$9[0];
                                                        var workout = match$8[0];
                                                        var exit$1 = 0;
                                                        switch (round) {
                                                          case "config" : 
                                                              if (match$9[1]) {
                                                                exit$1 = 2;
                                                              } else if (match$1 !== 0) {
                                                                if (convToInt(workout) > 0 && convToInt(workout) < 5 && week === "1" || week === "2" || week === "3" || week === "4") {
                                                                  return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* WorkoutConfig */Block.__(6, [
                                                                                    week,
                                                                                    workout
                                                                                  ])]));
                                                                } else {
                                                                  exit = 1;
                                                                }
                                                              } else {
                                                                return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                                              /* Login */0,
                                                                              "login"
                                                                            ]));
                                                              }
                                                              break;
                                                          case "view" : 
                                                              if (match$9[1]) {
                                                                exit$1 = 2;
                                                              } else if (match$1 !== 0) {
                                                                if (convToInt(workout) > 0 && convToInt(workout) < 5 && week === "1" || week === "2" || week === "3" || week === "4") {
                                                                  return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* WorkoutView */Block.__(7, [
                                                                                    week,
                                                                                    workout
                                                                                  ])]));
                                                                } else {
                                                                  exit = 1;
                                                                }
                                                              } else {
                                                                return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                                              /* Login */0,
                                                                              "login"
                                                                            ]));
                                                              }
                                                              break;
                                                          default:
                                                            exit$1 = 2;
                                                        }
                                                        if (exit$1 === 2) {
                                                          var match$10 = match$9[1];
                                                          if (match$10) {
                                                            var match$11 = match$10[1];
                                                            if (match$11 && !match$11[1]) {
                                                              if (match$1 !== 0) {
                                                                var step = match$11[0];
                                                                var pair = match$10[0];
                                                                if (convToInt(workout) > 0 && convToInt(workout) < 5 && (week === "1" || week === "2" || week === "3" || week === "4") && (round === "1" || round === "2" || round === "3" || round === "4") && (pair === "1" || pair === "2" || pair === "3") && (step === "2" || step === "3" || step === "4" || step === "5" || step === "6" || step === "7")) {
                                                                  var match$12 = +(step !== "5" && step !== "6" && step !== "7");
                                                                  if (match$12 !== 0) {
                                                                    Storage.storeLoc(week, workout, round, pair, step);
                                                                  }
                                                                  return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Workout */Block.__(8, [
                                                                                    week,
                                                                                    workout,
                                                                                    round,
                                                                                    pair,
                                                                                    step
                                                                                  ])]));
                                                                } else {
                                                                  exit = 1;
                                                                }
                                                              } else {
                                                                return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                                              /* Login */0,
                                                                              "login"
                                                                            ]));
                                                              }
                                                            } else {
                                                              exit = 1;
                                                            }
                                                          } else {
                                                            exit = 1;
                                                          }
                                                        }
                                                        
                                                      } else {
                                                        exit = 1;
                                                      }
                                                    } else {
                                                      exit = 1;
                                                    }
                                                    break;
                                                case "workoutweek" : 
                                                    if (match$7[1]) {
                                                      exit = 1;
                                                    } else if (match$1 !== 0) {
                                                      if (week === "1" || week === "2" || week === "3" || week === "4") {
                                                        return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* WorkoutWeek */Block.__(3, [week])]));
                                                      } else {
                                                        exit = 1;
                                                      }
                                                    } else {
                                                      return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                                    /* Login */0,
                                                                    "login"
                                                                  ]));
                                                    }
                                                    break;
                                                default:
                                                  exit = 1;
                                              }
                                            } else if (match$1 !== 0) {
                                              if (week === "1" || week === "2" || week === "3" || week === "4") {
                                                return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Week */Block.__(2, [week])]));
                                              } else {
                                                exit = 1;
                                              }
                                            } else {
                                              return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                            /* Login */0,
                                                            "login"
                                                          ]));
                                            }
                                          } else {
                                            exit = 1;
                                          }
                                          break;
                                      case "wizard" : 
                                          var match$13 = match[1];
                                          if (match$13 && !match$13[1]) {
                                            if (match$1 !== 0) {
                                              return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Wizard */Block.__(1, [match$13[0]])]));
                                            } else {
                                              return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                            /* Login */0,
                                                            "login"
                                                          ]));
                                            }
                                          } else {
                                            exit = 1;
                                          }
                                          break;
                                      default:
                                        exit = 1;
                                    }
                                  } else {
                                    exit = 1;
                                  }
                                  if (exit === 1) {
                                    if (match$1 !== 0) {
                                      return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                    /* Dashboard */3,
                                                    "dashboard"
                                                  ]));
                                    } else {
                                      return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                    /* Login */0,
                                                    "login"
                                                  ]));
                                    }
                                  }
                                  
                                }));
                  }),
                ReasonReact.Router[/* unwatchUrl */2]
              ],
              /* :: */[
                /* Sub */[
                  (function () {
                      return setInterval((function () {
                                    return Curry._1(self[/* send */4], /* CheckFresh */8);
                                  }), 15000);
                    }),
                  (function (prim) {
                      clearInterval(prim);
                      return /* () */0;
                    })
                ],
                /* [] */0
              ]
            ];
    });
  return newrecord;
}

exports.Styles = Styles;
exports.setInitialRoute = setInitialRoute;
exports.convToInt = convToInt;
exports.component = component;
exports.make = make;
/*  Not a pure module */


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var Caml_builtin_exceptions = __webpack_require__(3);

function caml_sys_getenv(s) {
  var match = typeof (process) === "undefined" ? undefined : (process);
  if (match !== undefined) {
    var match$1 = match.env[s];
    if (match$1 !== undefined) {
      return match$1;
    } else {
      throw Caml_builtin_exceptions.not_found;
    }
  } else {
    throw Caml_builtin_exceptions.not_found;
  }
}

function caml_sys_time() {
  var match = typeof (process) === "undefined" ? undefined : (process);
  if (match !== undefined) {
    return match.uptime();
  } else {
    return -1;
  }
}

function caml_sys_random_seed() {
  return /* array */[((Date.now() | 0) ^ 4294967295) * Math.random() | 0];
}

function caml_sys_system_command() {
  return 127;
}

function caml_sys_getcwd() {
  var match = typeof (process) === "undefined" ? undefined : (process);
  if (match !== undefined) {
    return match.cwd();
  } else {
    return "/";
  }
}

function caml_sys_get_argv() {
  var match = typeof (process) === "undefined" ? undefined : (process);
  if (match !== undefined) {
    if (match.argv == null) {
      return /* tuple */[
              "",
              /* array */[""]
            ];
    } else {
      return /* tuple */[
              match.argv[0],
              match.argv
            ];
    }
  } else {
    return /* tuple */[
            "",
            /* array */[""]
          ];
  }
}

function caml_sys_exit(exit_code) {
  var match = typeof (process) === "undefined" ? undefined : (process);
  if (match !== undefined) {
    return match.exit(exit_code);
  } else {
    return /* () */0;
  }
}

function caml_sys_is_directory() {
  throw [
        Caml_builtin_exceptions.failure,
        "caml_sys_is_directory not implemented"
      ];
}

function caml_sys_file_exists() {
  throw [
        Caml_builtin_exceptions.failure,
        "caml_sys_file_exists not implemented"
      ];
}

exports.caml_sys_getenv = caml_sys_getenv;
exports.caml_sys_time = caml_sys_time;
exports.caml_sys_random_seed = caml_sys_random_seed;
exports.caml_sys_system_command = caml_sys_system_command;
exports.caml_sys_getcwd = caml_sys_getcwd;
exports.caml_sys_get_argv = caml_sys_get_argv;
exports.caml_sys_exit = caml_sys_exit;
exports.caml_sys_is_directory = caml_sys_is_directory;
exports.caml_sys_file_exists = caml_sys_file_exists;
/* No side effect */

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Caml_int32 = __webpack_require__(11);
var Caml_utils = __webpack_require__(34);
var Caml_primitive = __webpack_require__(20);
var Caml_builtin_exceptions = __webpack_require__(3);

var min_int = /* record */[
  /* hi */-2147483648,
  /* lo */0
];

var max_int = /* record */[
  /* hi */2147483647,
  /* lo */1
];

var one = /* record */[
  /* hi */0,
  /* lo */1
];

var zero = /* record */[
  /* hi */0,
  /* lo */0
];

var neg_one = /* record */[
  /* hi */-1,
  /* lo */4294967295
];

function neg_signed(x) {
  return +((x & 2147483648) !== 0);
}

function add(param, param$1) {
  var other_low_ = param$1[/* lo */1];
  var this_low_ = param[/* lo */1];
  var lo = this_low_ + other_low_ & 4294967295;
  var overflow = neg_signed(this_low_) && (neg_signed(other_low_) || !neg_signed(lo)) || neg_signed(other_low_) && !neg_signed(lo) ? 1 : 0;
  var hi = param[/* hi */0] + param$1[/* hi */0] + overflow & 4294967295;
  return /* record */[
          /* hi */hi,
          /* lo */(lo >>> 0)
        ];
}

function not(param) {
  var hi = param[/* hi */0] ^ -1;
  var lo = param[/* lo */1] ^ -1;
  return /* record */[
          /* hi */hi,
          /* lo */(lo >>> 0)
        ];
}

function eq(x, y) {
  if (x[/* hi */0] === y[/* hi */0]) {
    return +(x[/* lo */1] === y[/* lo */1]);
  } else {
    return /* false */0;
  }
}

function equal_null(x, y) {
  if (y !== null) {
    return eq(x, y);
  } else {
    return /* false */0;
  }
}

function equal_undefined(x, y) {
  if (y !== undefined) {
    return eq(x, y);
  } else {
    return /* false */0;
  }
}

function equal_nullable(x, y) {
  if (y == null) {
    return /* false */0;
  } else {
    return eq(x, y);
  }
}

function neg(x) {
  if (eq(x, min_int)) {
    return min_int;
  } else {
    return add(not(x), one);
  }
}

function sub(x, y) {
  return add(x, neg(y));
}

function lsl_(x, numBits) {
  if (numBits === 0) {
    return x;
  } else {
    var lo = x[/* lo */1];
    if (numBits >= 32) {
      return /* record */[
              /* hi */(lo << (numBits - 32 | 0)),
              /* lo */0
            ];
    } else {
      var hi = (lo >>> (32 - numBits | 0)) | (x[/* hi */0] << numBits);
      return /* record */[
              /* hi */hi,
              /* lo */((lo << numBits) >>> 0)
            ];
    }
  }
}

function lsr_(x, numBits) {
  if (numBits === 0) {
    return x;
  } else {
    var hi = x[/* hi */0];
    var offset = numBits - 32 | 0;
    if (offset === 0) {
      return /* record */[
              /* hi */0,
              /* lo */(hi >>> 0)
            ];
    } else if (offset > 0) {
      var lo = (hi >>> offset);
      return /* record */[
              /* hi */0,
              /* lo */(lo >>> 0)
            ];
    } else {
      var hi$1 = (hi >>> numBits);
      var lo$1 = (hi << (-offset | 0)) | (x[/* lo */1] >>> numBits);
      return /* record */[
              /* hi */hi$1,
              /* lo */(lo$1 >>> 0)
            ];
    }
  }
}

function asr_(x, numBits) {
  if (numBits === 0) {
    return x;
  } else {
    var hi = x[/* hi */0];
    if (numBits < 32) {
      var hi$1 = (hi >> numBits);
      var lo = (hi << (32 - numBits | 0)) | (x[/* lo */1] >>> numBits);
      return /* record */[
              /* hi */hi$1,
              /* lo */(lo >>> 0)
            ];
    } else {
      var lo$1 = (hi >> (numBits - 32 | 0));
      return /* record */[
              /* hi */hi >= 0 ? 0 : -1,
              /* lo */(lo$1 >>> 0)
            ];
    }
  }
}

function is_zero(param) {
  if (param[/* hi */0] !== 0 || param[/* lo */1] !== 0) {
    return /* false */0;
  } else {
    return /* true */1;
  }
}

function mul(_this, _other) {
  while(true) {
    var other = _other;
    var $$this = _this;
    var exit = 0;
    var lo;
    var this_hi = $$this[/* hi */0];
    var exit$1 = 0;
    var exit$2 = 0;
    var exit$3 = 0;
    if (this_hi !== 0 || $$this[/* lo */1] !== 0) {
      exit$3 = 4;
    } else {
      return zero;
    }
    if (exit$3 === 4) {
      if (other[/* hi */0] !== 0 || other[/* lo */1] !== 0) {
        exit$2 = 3;
      } else {
        return zero;
      }
    }
    if (exit$2 === 3) {
      if (this_hi !== -2147483648 || $$this[/* lo */1] !== 0) {
        exit$1 = 2;
      } else {
        lo = other[/* lo */1];
        exit = 1;
      }
    }
    if (exit$1 === 2) {
      var other_hi = other[/* hi */0];
      var lo$1 = $$this[/* lo */1];
      var exit$4 = 0;
      if (other_hi !== -2147483648 || other[/* lo */1] !== 0) {
        exit$4 = 3;
      } else {
        lo = lo$1;
        exit = 1;
      }
      if (exit$4 === 3) {
        var other_lo = other[/* lo */1];
        if (this_hi < 0) {
          if (other_hi < 0) {
            _other = neg(other);
            _this = neg($$this);
            continue ;
            
          } else {
            return neg(mul(neg($$this), other));
          }
        } else if (other_hi < 0) {
          return neg(mul($$this, neg(other)));
        } else {
          var a48 = (this_hi >>> 16);
          var a32 = this_hi & 65535;
          var a16 = (lo$1 >>> 16);
          var a00 = lo$1 & 65535;
          var b48 = (other_hi >>> 16);
          var b32 = other_hi & 65535;
          var b16 = (other_lo >>> 16);
          var b00 = other_lo & 65535;
          var c48 = 0;
          var c32 = 0;
          var c16 = 0;
          var c00 = a00 * b00;
          c16 = (c00 >>> 16) + a16 * b00;
          c32 = (c16 >>> 16);
          c16 = (c16 & 65535) + a00 * b16;
          c32 = c32 + (c16 >>> 16) + a32 * b00;
          c48 = (c32 >>> 16);
          c32 = (c32 & 65535) + a16 * b16;
          c48 += (c32 >>> 16);
          c32 = (c32 & 65535) + a00 * b32;
          c48 += (c32 >>> 16);
          c32 = c32 & 65535;
          c48 = c48 + (a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48) & 65535;
          var hi = c32 | (c48 << 16);
          var lo$2 = c00 & 65535 | ((c16 & 65535) << 16);
          return /* record */[
                  /* hi */hi,
                  /* lo */(lo$2 >>> 0)
                ];
        }
      }
      
    }
    if (exit === 1) {
      if ((lo & 1) === 0) {
        return zero;
      } else {
        return min_int;
      }
    }
    
  };
}

function swap(param) {
  var hi = Caml_int32.caml_int32_bswap(param[/* lo */1]);
  var lo = Caml_int32.caml_int32_bswap(param[/* hi */0]);
  return /* record */[
          /* hi */hi,
          /* lo */(lo >>> 0)
        ];
}

function xor(param, param$1) {
  return /* record */[
          /* hi */param[/* hi */0] ^ param$1[/* hi */0],
          /* lo */((param[/* lo */1] ^ param$1[/* lo */1]) >>> 0)
        ];
}

function or_(param, param$1) {
  return /* record */[
          /* hi */param[/* hi */0] | param$1[/* hi */0],
          /* lo */((param[/* lo */1] | param$1[/* lo */1]) >>> 0)
        ];
}

function and_(param, param$1) {
  return /* record */[
          /* hi */param[/* hi */0] & param$1[/* hi */0],
          /* lo */((param[/* lo */1] & param$1[/* lo */1]) >>> 0)
        ];
}

function ge(param, param$1) {
  var other_hi = param$1[/* hi */0];
  var hi = param[/* hi */0];
  if (hi > other_hi) {
    return /* true */1;
  } else if (hi < other_hi) {
    return /* false */0;
  } else {
    return +(param[/* lo */1] >= param$1[/* lo */1]);
  }
}

function neq(x, y) {
  return 1 - eq(x, y);
}

function lt(x, y) {
  return 1 - ge(x, y);
}

function gt(x, y) {
  if (x[/* hi */0] > y[/* hi */0]) {
    return /* true */1;
  } else if (x[/* hi */0] < y[/* hi */0]) {
    return /* false */0;
  } else {
    return +(x[/* lo */1] > y[/* lo */1]);
  }
}

function le(x, y) {
  return 1 - gt(x, y);
}

function min(x, y) {
  if (ge(x, y)) {
    return y;
  } else {
    return x;
  }
}

function max(x, y) {
  if (gt(x, y)) {
    return x;
  } else {
    return y;
  }
}

function to_float(param) {
  return param[/* hi */0] * (0x100000000) + param[/* lo */1];
}

var two_ptr_32_dbl = Math.pow(2, 32);

var two_ptr_63_dbl = Math.pow(2, 63);

var neg_two_ptr_63 = -Math.pow(2, 63);

function of_float(x) {
  if (isNaN(x) || !isFinite(x)) {
    return zero;
  } else if (x <= neg_two_ptr_63) {
    return min_int;
  } else if (x + 1 >= two_ptr_63_dbl) {
    return max_int;
  } else if (x < 0) {
    return neg(of_float(-x));
  } else {
    var hi = x / two_ptr_32_dbl | 0;
    var lo = x % two_ptr_32_dbl | 0;
    return /* record */[
            /* hi */hi,
            /* lo */(lo >>> 0)
          ];
  }
}

function div(_self, _other) {
  while(true) {
    var other = _other;
    var self = _self;
    var self_hi = self[/* hi */0];
    var exit = 0;
    var exit$1 = 0;
    if (other[/* hi */0] !== 0 || other[/* lo */1] !== 0) {
      exit$1 = 2;
    } else {
      throw Caml_builtin_exceptions.division_by_zero;
    }
    if (exit$1 === 2) {
      if (self_hi !== -2147483648) {
        if (self_hi !== 0 || self[/* lo */1] !== 0) {
          exit = 1;
        } else {
          return zero;
        }
      } else if (self[/* lo */1] !== 0) {
        exit = 1;
      } else if (eq(other, one) || eq(other, neg_one)) {
        return self;
      } else if (eq(other, min_int)) {
        return one;
      } else {
        var other_hi = other[/* hi */0];
        var half_this = asr_(self, 1);
        var approx = lsl_(div(half_this, other), 1);
        var exit$2 = 0;
        if (approx[/* hi */0] !== 0 || approx[/* lo */1] !== 0) {
          exit$2 = 3;
        } else if (other_hi < 0) {
          return one;
        } else {
          return neg(one);
        }
        if (exit$2 === 3) {
          var y = mul(other, approx);
          var rem = add(self, neg(y));
          return add(approx, div(rem, other));
        }
        
      }
    }
    if (exit === 1) {
      var other_hi$1 = other[/* hi */0];
      var exit$3 = 0;
      if (other_hi$1 !== -2147483648 || other[/* lo */1] !== 0) {
        exit$3 = 2;
      } else {
        return zero;
      }
      if (exit$3 === 2) {
        if (self_hi < 0) {
          if (other_hi$1 < 0) {
            _other = neg(other);
            _self = neg(self);
            continue ;
            
          } else {
            return neg(div(neg(self), other));
          }
        } else if (other_hi$1 < 0) {
          return neg(div(self, neg(other)));
        } else {
          var res = zero;
          var rem$1 = self;
          while(ge(rem$1, other)) {
            var approx$1 = Caml_primitive.caml_float_max(1, Math.floor(to_float(rem$1) / to_float(other)));
            var log2 = Math.ceil(Math.log(approx$1) / Math.LN2);
            var delta = log2 <= 48 ? 1 : Math.pow(2, log2 - 48);
            var approxRes = of_float(approx$1);
            var approxRem = mul(approxRes, other);
            while(approxRem[/* hi */0] < 0 || gt(approxRem, rem$1)) {
              approx$1 -= delta;
              approxRes = of_float(approx$1);
              approxRem = mul(approxRes, other);
            };
            if (is_zero(approxRes)) {
              approxRes = one;
            }
            res = add(res, approxRes);
            rem$1 = add(rem$1, neg(approxRem));
          };
          return res;
        }
      }
      
    }
    
  };
}

function mod_(self, other) {
  var y = mul(div(self, other), other);
  return add(self, neg(y));
}

function div_mod(self, other) {
  var quotient = div(self, other);
  var y = mul(quotient, other);
  return /* tuple */[
          quotient,
          add(self, neg(y))
        ];
}

function compare(self, other) {
  var v = Caml_primitive.caml_nativeint_compare(self[/* hi */0], other[/* hi */0]);
  if (v === 0) {
    return Caml_primitive.caml_nativeint_compare(self[/* lo */1], other[/* lo */1]);
  } else {
    return v;
  }
}

function of_int32(lo) {
  return /* record */[
          /* hi */lo < 0 ? -1 : 0,
          /* lo */(lo >>> 0)
        ];
}

function to_int32(x) {
  return x[/* lo */1] | 0;
}

function to_hex(x) {
  var aux = function (v) {
    return (v >>> 0).toString(16);
  };
  var match = x[/* hi */0];
  var match$1 = x[/* lo */1];
  var exit = 0;
  if (match !== 0 || match$1 !== 0) {
    exit = 1;
  } else {
    return "0";
  }
  if (exit === 1) {
    if (match$1 !== 0) {
      if (match !== 0) {
        var lo = aux(x[/* lo */1]);
        var pad = 8 - lo.length | 0;
        if (pad <= 0) {
          return aux(x[/* hi */0]) + lo;
        } else {
          return aux(x[/* hi */0]) + (Caml_utils.repeat(pad, "0") + lo);
        }
      } else {
        return aux(x[/* lo */1]);
      }
    } else {
      return aux(x[/* hi */0]) + "00000000";
    }
  }
  
}

function discard_sign(x) {
  return /* record */[
          /* hi */2147483647 & x[/* hi */0],
          /* lo */x[/* lo */1]
        ];
}

function float_of_bits(x) {
  var int32 = new Int32Array(/* array */[
        x[/* lo */1],
        x[/* hi */0]
      ]);
  return new Float64Array(int32.buffer)[0];
}

function bits_of_float(x) {
  var u = new Float64Array(/* float array */[x]);
  var int32 = new Int32Array(u.buffer);
  var x$1 = int32[1];
  var hi = x$1;
  var x$2 = int32[0];
  var lo = x$2;
  return /* record */[
          /* hi */hi,
          /* lo */(lo >>> 0)
        ];
}

function get64(s, i) {
  var hi = (s.charCodeAt(i + 4 | 0) << 32) | (s.charCodeAt(i + 5 | 0) << 40) | (s.charCodeAt(i + 6 | 0) << 48) | (s.charCodeAt(i + 7 | 0) << 56);
  var lo = s.charCodeAt(i) | (s.charCodeAt(i + 1 | 0) << 8) | (s.charCodeAt(i + 2 | 0) << 16) | (s.charCodeAt(i + 3 | 0) << 24);
  return /* record */[
          /* hi */hi,
          /* lo */(lo >>> 0)
        ];
}

exports.min_int = min_int;
exports.max_int = max_int;
exports.one = one;
exports.zero = zero;
exports.not = not;
exports.of_int32 = of_int32;
exports.to_int32 = to_int32;
exports.add = add;
exports.neg = neg;
exports.sub = sub;
exports.lsl_ = lsl_;
exports.lsr_ = lsr_;
exports.asr_ = asr_;
exports.is_zero = is_zero;
exports.mul = mul;
exports.xor = xor;
exports.or_ = or_;
exports.and_ = and_;
exports.swap = swap;
exports.ge = ge;
exports.eq = eq;
exports.neq = neq;
exports.lt = lt;
exports.gt = gt;
exports.le = le;
exports.equal_null = equal_null;
exports.equal_undefined = equal_undefined;
exports.equal_nullable = equal_nullable;
exports.min = min;
exports.max = max;
exports.to_float = to_float;
exports.of_float = of_float;
exports.div = div;
exports.mod_ = mod_;
exports.div_mod = div_mod;
exports.compare = compare;
exports.to_hex = to_hex;
exports.discard_sign = discard_sign;
exports.float_of_bits = float_of_bits;
exports.bits_of_float = bits_of_float;
exports.get64 = get64;
/* two_ptr_32_dbl Not a pure module */


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var not_implemented = (function (s){ throw new Error(s)});

exports.not_implemented = not_implemented;
/* not_implemented Not a pure module */


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleSheet = StyleSheet;

var _objectAssign = __webpack_require__(18);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* 

high performance StyleSheet for css-in-js systems 

- uses multiple style tags behind the scenes for millions of rules 
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side 


// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject() 
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }') 
- appends a css rule into the stylesheet 

styleSheet.flush() 
- empties the stylesheet of all its contents


*/

function last(arr) {
  return arr[arr.length - 1];
}

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }

  // this weirdness brought to you by firefox 
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}

var isBrowser = typeof window !== 'undefined';
var isDev = "production" === 'development' || !"production"; //(x => (x === 'development') || !x)(process.env.NODE_ENV)
var isTest = "production" === 'test';

var oldIE = function () {
  if (isBrowser) {
    var div = document.createElement('div');
    div.innerHTML = '<!--[if lt IE 10]><i></i><![endif]-->';
    return div.getElementsByTagName('i').length === 1;
  }
}();

function makeStyleTag() {
  var tag = document.createElement('style');
  tag.type = 'text/css';
  tag.setAttribute('data-glamor', '');
  tag.appendChild(document.createTextNode(''));
  (document.head || document.getElementsByTagName('head')[0]).appendChild(tag);
  return tag;
}

function StyleSheet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$speedy = _ref.speedy,
      speedy = _ref$speedy === undefined ? !isDev && !isTest : _ref$speedy,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === undefined ? isBrowser && oldIE ? 4000 : 65000 : _ref$maxLength;

  this.isSpeedy = speedy; // the big drawback here is that the css won't be editable in devtools
  this.sheet = undefined;
  this.tags = [];
  this.maxLength = maxLength;
  this.ctr = 0;
}

(0, _objectAssign2.default)(StyleSheet.prototype, {
  getSheet: function getSheet() {
    return sheetForTag(last(this.tags));
  },
  inject: function inject() {
    var _this = this;

    if (this.injected) {
      throw new Error('already injected stylesheet!');
    }
    if (isBrowser) {
      this.tags[0] = makeStyleTag();
    } else {
      // server side 'polyfill'. just enough behavior to be useful.
      this.sheet = {
        cssRules: [],
        insertRule: function insertRule(rule) {
          // enough 'spec compliance' to be able to extract the rules later  
          // in other words, just the cssText field 
          _this.sheet.cssRules.push({ cssText: rule });
        }
      };
    }
    this.injected = true;
  },
  speedy: function speedy(bool) {
    if (this.ctr !== 0) {
      throw new Error('cannot change speedy mode after inserting any rule to sheet. Either call speedy(' + bool + ') earlier in your app, or call flush() before speedy(' + bool + ')');
    }
    this.isSpeedy = !!bool;
  },
  _insert: function _insert(rule) {
    // this weirdness for perf, and chrome's weird bug 
    // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
    try {
      var sheet = this.getSheet();
      sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : sheet.cssRules.length);
    } catch (e) {
      if (isDev) {
        // might need beter dx for this 
        console.warn('whoops, illegal rule inserted', rule); //eslint-disable-line no-console
      }
    }
  },
  insert: function insert(rule) {

    if (isBrowser) {
      // this is the ultrafast version, works across browsers 
      if (this.isSpeedy && this.getSheet().insertRule) {
        this._insert(rule);
      }
      // more browser weirdness. I don't even know    
      // else if(this.tags.length > 0 && this.tags::last().styleSheet) {      
      //   this.tags::last().styleSheet.cssText+= rule
      // }
      else {
          if (rule.indexOf('@import') !== -1) {
            var tag = last(this.tags);
            tag.insertBefore(document.createTextNode(rule), tag.firstChild);
          } else {
            last(this.tags).appendChild(document.createTextNode(rule));
          }
        }
    } else {
      // server side is pretty simple         
      this.sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : this.sheet.cssRules.length);
    }

    this.ctr++;
    if (isBrowser && this.ctr % this.maxLength === 0) {
      this.tags.push(makeStyleTag());
    }
    return this.ctr - 1;
  },

  // commenting this out till we decide on v3's decision 
  // _replace(index, rule) {
  //   // this weirdness for perf, and chrome's weird bug 
  //   // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
  //   try {  
  //     let sheet = this.getSheet()        
  //     sheet.deleteRule(index) // todo - correct index here     
  //     sheet.insertRule(rule, index)
  //   }
  //   catch(e) {
  //     if(isDev) {
  //       // might need beter dx for this 
  //       console.warn('whoops, problem replacing rule', rule) //eslint-disable-line no-console
  //     }          
  //   }          

  // }
  // replace(index, rule) {
  //   if(isBrowser) {
  //     if(this.isSpeedy && this.getSheet().insertRule) {
  //       this._replace(index, rule)
  //     }
  //     else {
  //       let _slot = Math.floor((index  + this.maxLength) / this.maxLength) - 1        
  //       let _index = (index % this.maxLength) + 1
  //       let tag = this.tags[_slot]
  //       tag.replaceChild(document.createTextNode(rule), tag.childNodes[_index])
  //     }
  //   }
  //   else {
  //     let rules = this.sheet.cssRules
  //     this.sheet.cssRules = [ ...rules.slice(0, index), { cssText: rule }, ...rules.slice(index + 1) ]
  //   }
  // }
  delete: function _delete(index) {
    // we insert a blank rule when 'deleting' so previously returned indexes remain stable
    return this.replace(index, '');
  },
  flush: function flush() {
    if (isBrowser) {
      this.tags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
      });
      this.tags = [];
      this.sheet = null;
      this.ctr = 0;
      // todo - look for remnants in document.styleSheets
    } else {
      // simpler on server 
      this.sheet.cssRules = [];
    }
    this.injected = false;
  },
  rules: function rules() {
    if (!isBrowser) {
      return this.sheet.cssRules;
    }
    var arr = [];
    this.tags.forEach(function (tag) {
      return arr.splice.apply(arr, [arr.length, 0].concat(_toConsumableArray(Array.from(sheetForTag(tag).cssRules))));
    });
    return arr;
  }
});

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(77);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CSSProperty = __webpack_require__(79);

var _CSSProperty2 = _interopRequireDefault(_CSSProperty);

var _warning = __webpack_require__(38);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule dangerousStyleValue
 */

var isUnitlessNumber = _CSSProperty2.default.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

exports.default = dangerousStyleValue;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSProperty
 */

/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridColumn: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true

  /**
   * @param {string} prefix vendor-specific prefix, eg: Webkit
   * @param {string} key style name, eg: transitionDuration
   * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
   * WebkitTransitionDuration
   */
};function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

exports.default = CSSProperty;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(81);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = clean;
// Returns true for null, false, undefined and {}
function isFalsy(value) {
  return value === null || value === undefined || value === false || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.keys(value).length === 0;
}

function cleanObject(object) {
  if (isFalsy(object)) return null;
  if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') return object;

  var acc = {},
      keys = Object.keys(object),
      hasFalsy = false;
  for (var i = 0; i < keys.length; i++) {
    var value = object[keys[i]];
    var filteredValue = clean(value);
    if (filteredValue === null || filteredValue !== value) {
      hasFalsy = true;
    }
    if (filteredValue !== null) {
      acc[keys[i]] = filteredValue;
    }
  }
  return Object.keys(acc).length === 0 ? null : hasFalsy ? acc : object;
}

function cleanArray(rules) {
  var hasFalsy = false;
  var filtered = [];
  rules.forEach(function (rule) {
    var filteredRule = clean(rule);
    if (filteredRule === null || filteredRule !== rule) {
      hasFalsy = true;
    }
    if (filteredRule !== null) {
      filtered.push(filteredRule);
    }
  });
  return filtered.length == 0 ? null : hasFalsy ? filtered : rules;
}

// Takes style array or object provided by user and clears all the falsy data 
// If there is no styles left after filtration returns null
function clean(input) {
  return Array.isArray(input) ? cleanArray(input) : cleanObject(input);
}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.PluginSet = PluginSet;
exports.fallbacks = fallbacks;
exports.contentWrap = contentWrap;
exports.prefixes = prefixes;

var _objectAssign = __webpack_require__(18);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _CSSPropertyOperations = __webpack_require__(37);

var _prefixer = __webpack_require__(85);

var _prefixer2 = _interopRequireDefault(_prefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDev = function (x) {
  return x === 'development' || !x;
}("production");

function PluginSet(initial) {
  this.fns = initial || [];
}

(0, _objectAssign2.default)(PluginSet.prototype, {
  add: function add() {
    var _this = this;

    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    fns.forEach(function (fn) {
      if (_this.fns.indexOf(fn) >= 0) {
        if (isDev) {
          console.warn('adding the same plugin again, ignoring'); //eslint-disable-line no-console
        }
      } else {
        _this.fns = [fn].concat(_this.fns);
      }
    });
  },
  remove: function remove(fn) {
    this.fns = this.fns.filter(function (x) {
      return x !== fn;
    });
  },
  clear: function clear() {
    this.fns = [];
  },
  transform: function transform(o) {
    return this.fns.reduce(function (o, fn) {
      return fn(o);
    }, o);
  }
});

function fallbacks(node) {
  var hasArray = Object.keys(node.style).map(function (x) {
    return Array.isArray(node.style[x]);
  }).indexOf(true) >= 0;
  if (hasArray) {
    var style = node.style;

    var flattened = Object.keys(style).reduce(function (o, key) {
      o[key] = Array.isArray(style[key]) ? style[key].join('; ' + (0, _CSSPropertyOperations.processStyleName)(key) + ': ') : style[key];
      return o;
    }, {});
    // todo - 
    // flatten arrays which haven't been flattened yet 
    return (0, _objectAssign2.default)({}, node, { style: flattened });
  }
  return node;
}

var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit'];

function contentWrap(node) {
  if (node.style.content) {
    var cont = node.style.content;
    if (contentValues.indexOf(cont) >= 0) {
      return node;
    }
    if (/^(attr|calc|counters?|url)\(/.test(cont)) {
      return node;
    }
    if (cont.charAt(0) === cont.charAt(cont.length - 1) && (cont.charAt(0) === '"' || cont.charAt(0) === "'")) {
      return node;
    }
    return _extends({}, node, { style: _extends({}, node.style, { content: '"' + cont + '"' }) });
  }
  return node;
}

function prefixes(node) {
  return (0, _objectAssign2.default)({}, node, { style: (0, _prefixer2.default)(_extends({}, node.style)) });
}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixer;

var _staticData = __webpack_require__(86);

var _staticData2 = _interopRequireDefault(_staticData);

var _prefixProperty = __webpack_require__(87);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(88);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _cursor = __webpack_require__(89);

var _cursor2 = _interopRequireDefault(_cursor);

var _crossFade = __webpack_require__(90);

var _crossFade2 = _interopRequireDefault(_crossFade);

var _filter = __webpack_require__(91);

var _filter2 = _interopRequireDefault(_filter);

var _flex = __webpack_require__(92);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxOld = __webpack_require__(93);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(94);

var _gradient2 = _interopRequireDefault(_gradient);

var _imageSet = __webpack_require__(95);

var _imageSet2 = _interopRequireDefault(_imageSet);

var _position = __webpack_require__(96);

var _position2 = _interopRequireDefault(_position);

var _sizing = __webpack_require__(97);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(98);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default]; // custom facade for inline-style-prefixer

var prefixMap = _staticData2.default.prefixMap;

function prefixer(style) {
  for (var property in style) {
    var value = style[property];

    var processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

    // only modify the value if it was touched
    // by any plugin to prevent unnecessary mutations
    if (processedValue) {
      style[property] = processedValue;
    }

    (0, _prefixProperty2.default)(prefixMap, property, style);
  }
  return style;
}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var w = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];

exports.default = {
  plugins: [],
  prefixMap: { "appearance": wm, "userSelect": wmms, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "clipPath": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "filter": w, "fontFeatureSettings": w, "breakAfter": wmms, "breakBefore": wmms, "breakInside": wmms, "columnCount": wm, "columnFill": wm, "columnGap": wm, "columnRule": wm, "columnRuleColor": wm, "columnRuleStyle": wm, "columnRuleWidth": wm, "columns": wm, "columnSpan": wm, "columnWidth": wm, "writingMode": wms, "flex": w, "flexBasis": w, "flexDirection": w, "flexGrow": w, "flexFlow": w, "flexShrink": w, "flexWrap": w, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transform": w, "transformOrigin": w, "transformOriginX": w, "transformOriginY": w, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "hyphens": wmms, "flowInto": wms, "flowFrom": wms, "regionFragment": wms, "textAlignLast": m, "tabSize": m, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "borderImage": w, "borderImageOutset": w, "borderImageRepeat": w, "borderImageSlice": w, "borderImageSource": w, "borderImageWidth": w, "transitionDelay": w, "transitionDuration": w, "transitionProperty": w, "transitionTimingFunction": w }
};
module.exports = exports["default"];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(39);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var requiredPrefixes = prefixProperties[property];
    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;

var _isPrefixedValue = __webpack_require__(24);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;

var _isPrefixedValue = __webpack_require__(24);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(24);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;

var _isPrefixedValue = __webpack_require__(24);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
module.exports = exports['default'];

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(99);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(24);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(39);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(100);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = doHash;
// murmurhash2 via https://gist.github.com/raycmorgan/588423

function doHash(str, seed) {
  var m = 0x5bd1e995;
  var r = 24;
  var h = seed ^ str.length;
  var length = str.length;
  var currentIndex = 0;

  while (length >= 4) {
    var k = UInt32(str, currentIndex);

    k = Umul32(k, m);
    k ^= k >>> r;
    k = Umul32(k, m);

    h = Umul32(h, m);
    h ^= k;

    currentIndex += 4;
    length -= 4;
  }

  switch (length) {
    case 3:
      h ^= UInt16(str, currentIndex);
      h ^= str.charCodeAt(currentIndex + 2) << 16;
      h = Umul32(h, m);
      break;

    case 2:
      h ^= UInt16(str, currentIndex);
      h = Umul32(h, m);
      break;

    case 1:
      h ^= str.charCodeAt(currentIndex);
      h = Umul32(h, m);
      break;
  }

  h ^= h >>> 13;
  h = Umul32(h, m);
  h ^= h >>> 15;

  return h >>> 0;
}

function UInt32(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
}

function UInt16(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
}

function Umul32(n, m) {
  n = n | 0;
  m = m | 0;
  var nlo = n & 0xffff;
  var nhi = n >>> 16;
  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
  return res;
}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Link = __webpack_require__(13);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Network = __webpack_require__(7);
var ReasonReact = __webpack_require__(2);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.fontWeight(700),
        /* [] */0
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink
];

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("Week");

function make(week, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      var match = +(Network.pullWizardConfig(/* () */0) !== /* None */0);
      if (match === 0) {
        ReasonReact.Router[/* push */0]("/wizard/1");
      }
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("h1", undefined, "Woche " + week), React.createElement("button", {
                          className: "login-button",
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/week/" + (week + "/workoutweek"));
                            })
                        }, "Workouts"), React.createElement("button", {
                          className: "login-button",
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/foodday");
                            })
                        }, "Mahlzeiten")), ReasonReact.element(/* None */0, /* None */0, Link.make("/blank", "blank", someLink, /* array */[])));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(18),n=__webpack_require__(41),p=__webpack_require__(26),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

function _assign(prim, prim$1) {
  return Object.assign(prim, prim$1);
}

var emptyObject = { };


/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

// 'use strict';

// var _assign = require('object-assign');

// var emptyObject = require('emptyObject');
// var _invariant = require('invariant');

// if (process.env.NODE_ENV !== 'production') {
//   var warning = require('fbjs/lib/warning');
// }

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
// if (process.env.NODE_ENV !== 'production') {
//   ReactPropTypeLocationNames = {
//     prop: 'prop',
//     context: 'context',
//     childContext: 'child context'
//   };
// } else {
  ReactPropTypeLocationNames = {};
// }

;

var factory = (
function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      // if (process.env.NODE_ENV !== 'production') {
      //   validateTypeDef(Constructor, childContextTypes, 'childContext');
      // }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      // if (process.env.NODE_ENV !== 'production') {
      //   validateTypeDef(Constructor, contextTypes, 'context');
      // }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      // if (process.env.NODE_ENV !== 'production') {
      //   validateTypeDef(Constructor, propTypes, 'prop');
      // }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      // if (typeDef.hasOwnProperty(propName)) {
      //   // use a warning instead of an _invariant so components
      //   // don't show up in prod but only in __DEV__
      //   // if (process.env.NODE_ENV !== 'production') {
      //   //   warning(
      //   //     typeof typeDef[propName] === 'function',
      //   //     '%s: %s type `%s` is invalid; it must be a function, usually from ' +
      //   //       'React.PropTypes.',
      //   //     Constructor.displayName || 'ReactClass',
      //   //     ReactPropTypeLocationNames[location],
      //   //     propName
      //   //   );
      //   // }
      // }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      // _invariant(
      //   specPolicy === 'OVERRIDE_BASE',
      //   'ReactClassInterface: You are attempting to override ' +
      //     '`%s` from your class specification. Ensure that your method names ' +
      //     'do not overlap with React methods.',
      //   name
      // );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      // _invariant(
      //   specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
      //   'ReactClassInterface: You are attempting to define ' +
      //     '`%s` on your component more than once. This conflict may be due ' +
      //     'to a mixin.',
      //   name
      // );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      // if (process.env.NODE_ENV !== 'production') {
      //   var typeofSpec = typeof spec;
      //   var isMixinValid = typeofSpec === 'object' && spec !== null;
      //
      //   if (process.env.NODE_ENV !== 'production') {
      //     warning(
      //       isMixinValid,
      //       "%s: You're attempting to include a mixin that is either null " +
      //         'or not an object. Check the mixins included by the component, ' +
      //         'as well as any mixins they include themselves. ' +
      //         'Expected object but got %s.',
      //       Constructor.displayName || 'ReactClass',
      //       spec === null ? null : typeofSpec
      //     );
      //   }
      // }

      return;
    }

    // _invariant(
    //   typeof spec !== 'function',
    //   "ReactClass: You're attempting to " +
    //     'use a component class or function as a mixin. Instead, just use a ' +
    //     'regular object.'
    // );
    // _invariant(
    //   !isValidElement(spec),
    //   "ReactClass: You're attempting to " +
    //     'use a component as a mixin. Instead, just use a regular object.'
    // );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            // _invariant(
            //   isReactClassMethod &&
            //     (specPolicy === 'DEFINE_MANY_MERGED' ||
            //       specPolicy === 'DEFINE_MANY'),
            //   'ReactClass: Unexpected spec policy %s for key %s ' +
            //     'when mixing in component specs.',
            //   specPolicy,
            //   name
            // );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            // if (process.env.NODE_ENV !== 'production') {
            //   // Add verbose displayName to the function, which helps when looking
            //   // at profiling tools.
            //   if (typeof property === 'function' && spec.displayName) {
            //     proto[name].displayName = spec.displayName + '_' + name;
            //   }
            // }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      // _invariant(
      //   !isReserved,
      //   'ReactClass: You are attempting to define a reserved ' +
      //     'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
      //     'as an instance property instead; it will still be accessible on the ' +
      //     'constructor.',
      //   name
      // );

      var isInherited = name in Constructor;
      // _invariant(
      //   !isInherited,
      //   'ReactClass: You are attempting to define ' +
      //     '`%s` on your component more than once. This conflict may be ' +
      //     'due to a mixin.',
      //   name
      // );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    // _invariant(
    //   one && two && typeof one === 'object' && typeof two === 'object',
    //   'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    // );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        // _invariant(
        //   one[key] === undefined,
        //   'mergeIntoWithNoDuplicateKeys(): ' +
        //     'Tried to merge two objects with the same key: `%s`. This conflict ' +
        //     'may be due to a mixin; in particular, this may be caused by two ' +
        //     'getInitialState() or getDefaultProps() methods returning objects ' +
        //     'with clashing keys.',
        //   key
        // );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    // if (process.env.NODE_ENV !== 'production') {
    //   boundMethod.__reactBoundContext = component;
    //   boundMethod.__reactBoundMethod = method;
    //   boundMethod.__reactBoundArguments = null;
    //   var componentName = component.constructor.displayName;
    //   var _bind = boundMethod.bind;
    //   boundMethod.bind = function(newThis) {
    //     for (
    //       var _len = arguments.length,
    //         args = Array(_len > 1 ? _len - 1 : 0),
    //         _key = 1;
    //       _key < _len;
    //       _key++
    //     ) {
    //       args[_key - 1] = arguments[_key];
    //     }
    //
    //     // User is trying to bind() an autobound method; we effectively will
    //     // ignore the value of "this" that the user is trying to use, so
    //     // let's warn.
    //     if (newThis !== component && newThis !== null) {
    //       if (process.env.NODE_ENV !== 'production') {
    //         warning(
    //           false,
    //           'bind(): React component methods may only be bound to the ' +
    //             'component instance. See %s',
    //           componentName
    //         );
    //       }
    //     } else if (!args.length) {
    //       if (process.env.NODE_ENV !== 'production') {
    //         warning(
    //           false,
    //           'bind(): You are binding a component method to the component. ' +
    //             'React does this for you automatically in a high-performance ' +
    //             'way, so you can safely remove this call. See %s',
    //           componentName
    //         );
    //       }
    //       return boundMethod;
    //     }
    //     var reboundMethod = _bind.apply(boundMethod, arguments);
    //     reboundMethod.__reactBoundContext = component;
    //     reboundMethod.__reactBoundMethod = method;
    //     reboundMethod.__reactBoundArguments = args;
    //     return reboundMethod;
    //   };
    // }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      // if (process.env.NODE_ENV !== 'production') {
      //   warning(
      //     this.__didWarnIsMounted,
      //     '%s: isMounted is deprecated. Instead, make sure to clean up ' +
      //       'subscriptions and pending requests in componentWillUnmount to ' +
      //       'prevent memory leaks.',
      //     (this.constructor && this.constructor.displayName) ||
      //       this.name ||
      //       'Component'
      //   );
      //   this.__didWarnIsMounted = true;
      // }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      // if (process.env.NODE_ENV !== 'production') {
      //   warning(
      //     this instanceof Constructor,
      //     'Something is calling a React component directly. Use a factory or ' +
      //       'JSX instead. See: https://fb.me/react-legacyfactory'
      //   );
      // }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      // if (process.env.NODE_ENV !== 'production') {
      //   // We allow auto-mocks to proceed as if they're returning null.
      //   if (
      //     initialState === undefined &&
      //     this.getInitialState._isMockFunction
      //   ) {
      //     // This is probably bad practice. Consider warning here and
      //     // deprecating this convenience.
      //     initialState = null;
      //   }
      // }
      // _invariant(
      //   typeof initialState === 'object' && !Array.isArray(initialState),
      //   '%s.getInitialState(): must return an object or null',
      //   Constructor.displayName || 'ReactCompositeComponent'
      // );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    // if (process.env.NODE_ENV !== 'production') {
    //   // This is a tag to indicate that the use of these method names is ok,
    //   // since it's used with createClass. If it's not, then it's likely a
    //   // mistake so we'll warn you to use the static property, property
    //   // initializer or constructor respectively.
    //   if (Constructor.getDefaultProps) {
    //     Constructor.getDefaultProps.isReactClassApproved = {};
    //   }
    //   if (Constructor.prototype.getInitialState) {
    //     Constructor.prototype.getInitialState.isReactClassApproved = {};
    //   }
    // }

    // _invariant(
    //   Constructor.prototype.render,
    //   'createClass(...): Class specification must implement a `render` method.'
    // );

    // if (process.env.NODE_ENV !== 'production') {
    //   warning(
    //     !Constructor.prototype.componentShouldUpdate,
    //     '%s has a method called ' +
    //       'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
    //       'The name is phrased as a question because the function is ' +
    //       'expected to return a value.',
    //     spec.displayName || 'A component'
    //   );
    //   warning(
    //     !Constructor.prototype.componentWillRecieveProps,
    //     '%s has a method called ' +
    //       'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
    //     spec.displayName || 'A component'
    //   );
    // }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}
);

var reactNoopUpdateQueue = new React.Component().updater;

var createClass = factory(React.Component, React.isValidElement, reactNoopUpdateQueue);

exports._assign = _assign;
exports.emptyObject = emptyObject;
exports.factory = factory;
exports.reactNoopUpdateQueue = reactNoopUpdateQueue;
exports.createClass = createClass;
/*  Not a pure module */


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Char = __webpack_require__(46);
var Block = __webpack_require__(5);
var Bytes = __webpack_require__(27);
var Curry = __webpack_require__(0);
var Buffer = __webpack_require__(45);
var Js_exn = __webpack_require__(10);
var $$String = __webpack_require__(28);
var Caml_io = __webpack_require__(32);
var Caml_obj = __webpack_require__(15);
var Caml_bytes = __webpack_require__(106);
var Caml_float = __webpack_require__(107);
var Caml_int32 = __webpack_require__(11);
var Pervasives = __webpack_require__(21);
var Caml_format = __webpack_require__(8);
var Caml_string = __webpack_require__(16);
var Caml_primitive = __webpack_require__(20);
var Caml_exceptions = __webpack_require__(22);
var Caml_builtin_exceptions = __webpack_require__(3);
var CamlinternalFormatBasics = __webpack_require__(35);

function create_char_set() {
  return Bytes.make(32, /* "\000" */0);
}

function add_in_char_set(char_set, c) {
  var str_ind = (c >>> 3);
  var mask = (1 << (c & 7));
  char_set[str_ind] = Pervasives.char_of_int(Caml_bytes.get(char_set, str_ind) | mask);
  return /* () */0;
}

var freeze_char_set = Bytes.to_string;

function rev_char_set(char_set) {
  var char_set$prime = Bytes.make(32, /* "\000" */0);
  for(var i = 0; i <= 31; ++i){
    char_set$prime[i] = Pervasives.char_of_int(Caml_string.get(char_set, i) ^ 255);
  }
  return Caml_string.bytes_to_string(char_set$prime);
}

function is_in_char_set(char_set, c) {
  var str_ind = (c >>> 3);
  var mask = (1 << (c & 7));
  return +((Caml_string.get(char_set, str_ind) & mask) !== 0);
}

function pad_of_pad_opt(pad_opt) {
  if (pad_opt) {
    return /* Lit_padding */Block.__(0, [
              /* Right */1,
              pad_opt[0]
            ]);
  } else {
    return /* No_padding */0;
  }
}

function prec_of_prec_opt(prec_opt) {
  if (prec_opt) {
    return /* Lit_precision */[prec_opt[0]];
  } else {
    return /* No_precision */0;
  }
}

function param_format_of_ignored_format(ign, fmt) {
  if (typeof ign === "number") {
    switch (ign) {
      case 0 : 
          return /* Param_format_EBB */[/* Char */Block.__(0, [fmt])];
      case 1 : 
          return /* Param_format_EBB */[/* Caml_char */Block.__(1, [fmt])];
      case 2 : 
          return /* Param_format_EBB */[/* Bool */Block.__(9, [fmt])];
      case 3 : 
          return /* Param_format_EBB */[/* Reader */Block.__(19, [fmt])];
      case 4 : 
          return /* Param_format_EBB */[/* Scan_next_char */Block.__(22, [fmt])];
      
    }
  } else {
    switch (ign.tag | 0) {
      case 0 : 
          return /* Param_format_EBB */[/* String */Block.__(2, [
                      pad_of_pad_opt(ign[0]),
                      fmt
                    ])];
      case 1 : 
          return /* Param_format_EBB */[/* Caml_string */Block.__(3, [
                      pad_of_pad_opt(ign[0]),
                      fmt
                    ])];
      case 2 : 
          return /* Param_format_EBB */[/* Int */Block.__(4, [
                      ign[0],
                      pad_of_pad_opt(ign[1]),
                      /* No_precision */0,
                      fmt
                    ])];
      case 3 : 
          return /* Param_format_EBB */[/* Int32 */Block.__(5, [
                      ign[0],
                      pad_of_pad_opt(ign[1]),
                      /* No_precision */0,
                      fmt
                    ])];
      case 4 : 
          return /* Param_format_EBB */[/* Nativeint */Block.__(6, [
                      ign[0],
                      pad_of_pad_opt(ign[1]),
                      /* No_precision */0,
                      fmt
                    ])];
      case 5 : 
          return /* Param_format_EBB */[/* Int64 */Block.__(7, [
                      ign[0],
                      pad_of_pad_opt(ign[1]),
                      /* No_precision */0,
                      fmt
                    ])];
      case 6 : 
          return /* Param_format_EBB */[/* Float */Block.__(8, [
                      /* Float_f */0,
                      pad_of_pad_opt(ign[0]),
                      prec_of_prec_opt(ign[1]),
                      fmt
                    ])];
      case 7 : 
          return /* Param_format_EBB */[/* Format_arg */Block.__(13, [
                      ign[0],
                      ign[1],
                      fmt
                    ])];
      case 8 : 
          return /* Param_format_EBB */[/* Format_subst */Block.__(14, [
                      ign[0],
                      ign[1],
                      fmt
                    ])];
      case 9 : 
          return /* Param_format_EBB */[/* Scan_char_set */Block.__(20, [
                      ign[0],
                      ign[1],
                      fmt
                    ])];
      case 10 : 
          return /* Param_format_EBB */[/* Scan_get_counter */Block.__(21, [
                      ign[0],
                      fmt
                    ])];
      
    }
  }
}

function buffer_check_size(buf, overhead) {
  var len = buf[/* bytes */1].length;
  var min_len = buf[/* ind */0] + overhead | 0;
  if (min_len > len) {
    var new_len = Caml_primitive.caml_int_max((len << 1), min_len);
    var new_str = Caml_string.caml_create_string(new_len);
    Bytes.blit(buf[/* bytes */1], 0, new_str, 0, len);
    buf[/* bytes */1] = new_str;
    return /* () */0;
  } else {
    return 0;
  }
}

function buffer_add_char(buf, c) {
  buffer_check_size(buf, 1);
  buf[/* bytes */1][buf[/* ind */0]] = c;
  buf[/* ind */0] = buf[/* ind */0] + 1 | 0;
  return /* () */0;
}

function buffer_add_string(buf, s) {
  var str_len = s.length;
  buffer_check_size(buf, str_len);
  $$String.blit(s, 0, buf[/* bytes */1], buf[/* ind */0], str_len);
  buf[/* ind */0] = buf[/* ind */0] + str_len | 0;
  return /* () */0;
}

function buffer_contents(buf) {
  return Bytes.sub_string(buf[/* bytes */1], 0, buf[/* ind */0]);
}

function char_of_iconv(iconv) {
  switch (iconv) {
    case 0 : 
    case 1 : 
    case 2 : 
        return /* "d" */100;
    case 3 : 
    case 4 : 
    case 5 : 
        return /* "i" */105;
    case 6 : 
    case 7 : 
        return /* "x" */120;
    case 8 : 
    case 9 : 
        return /* "X" */88;
    case 10 : 
    case 11 : 
        return /* "o" */111;
    case 12 : 
        return /* "u" */117;
    
  }
}

function char_of_fconv(fconv) {
  switch (fconv) {
    case 0 : 
    case 1 : 
    case 2 : 
        return /* "f" */102;
    case 3 : 
    case 4 : 
    case 5 : 
        return /* "e" */101;
    case 6 : 
    case 7 : 
    case 8 : 
        return /* "E" */69;
    case 9 : 
    case 10 : 
    case 11 : 
        return /* "g" */103;
    case 12 : 
    case 13 : 
    case 14 : 
        return /* "G" */71;
    case 15 : 
        return /* "F" */70;
    
  }
}

function char_of_counter(counter) {
  switch (counter) {
    case 0 : 
        return /* "l" */108;
    case 1 : 
        return /* "n" */110;
    case 2 : 
        return /* "N" */78;
    
  }
}

function bprint_char_set(buf, char_set) {
  var print_char = function (buf, i) {
    var c = Pervasives.char_of_int(i);
    if (c !== 37) {
      if (c !== 64) {
        return buffer_add_char(buf, c);
      } else {
        buffer_add_char(buf, /* "%" */37);
        return buffer_add_char(buf, /* "@" */64);
      }
    } else {
      buffer_add_char(buf, /* "%" */37);
      return buffer_add_char(buf, /* "%" */37);
    }
  };
  var print_out = function (set, _i) {
    while(true) {
      var i = _i;
      if (i < 256) {
        if (is_in_char_set(set, Pervasives.char_of_int(i))) {
          var set$1 = set;
          var i$1 = i;
          var match = Pervasives.char_of_int(i$1);
          var switcher = match - 45 | 0;
          if (switcher > 48 || switcher < 0) {
            if (switcher >= 210) {
              return print_char(buf, 255);
            } else {
              return print_second(set$1, i$1 + 1 | 0);
            }
          } else if (switcher > 47 || switcher < 1) {
            return print_out(set$1, i$1 + 1 | 0);
          } else {
            return print_second(set$1, i$1 + 1 | 0);
          }
        } else {
          _i = i + 1 | 0;
          continue ;
          
        }
      } else {
        return 0;
      }
    };
  };
  var print_second = function (set, i) {
    if (is_in_char_set(set, Pervasives.char_of_int(i))) {
      var match = Pervasives.char_of_int(i);
      var exit = 0;
      var switcher = match - 45 | 0;
      if (switcher > 48 || switcher < 0) {
        if (switcher >= 210) {
          print_char(buf, 254);
          return print_char(buf, 255);
        } else {
          exit = 1;
        }
      } else if ((switcher > 47 || switcher < 1) && !is_in_char_set(set, Pervasives.char_of_int(i + 1 | 0))) {
        print_char(buf, i - 1 | 0);
        return print_out(set, i + 1 | 0);
      } else {
        exit = 1;
      }
      if (exit === 1) {
        if (is_in_char_set(set, Pervasives.char_of_int(i + 1 | 0))) {
          var set$1 = set;
          var i$1 = i - 1 | 0;
          var _j = i + 2 | 0;
          while(true) {
            var j = _j;
            if (j === 256 || !is_in_char_set(set$1, Pervasives.char_of_int(j))) {
              print_char(buf, i$1);
              print_char(buf, /* "-" */45);
              print_char(buf, j - 1 | 0);
              if (j < 256) {
                return print_out(set$1, j + 1 | 0);
              } else {
                return 0;
              }
            } else {
              _j = j + 1 | 0;
              continue ;
              
            }
          };
        } else {
          print_char(buf, i - 1 | 0);
          print_char(buf, i);
          return print_out(set, i + 2 | 0);
        }
      }
      
    } else {
      print_char(buf, i - 1 | 0);
      return print_out(set, i + 1 | 0);
    }
  };
  var print_start = function (set) {
    var is_alone = function (c) {
      var before = Char.chr(c - 1 | 0);
      var after = Char.chr(c + 1 | 0);
      if (is_in_char_set(set, c)) {
        return 1 - (is_in_char_set(set, before) && is_in_char_set(set, after));
      } else {
        return /* false */0;
      }
    };
    if (is_alone(/* "]" */93)) {
      buffer_add_char(buf, /* "]" */93);
    }
    print_out(set, 1);
    if (is_alone(/* "-" */45)) {
      return buffer_add_char(buf, /* "-" */45);
    } else {
      return 0;
    }
  };
  buffer_add_char(buf, /* "[" */91);
  print_start(is_in_char_set(char_set, /* "\000" */0) ? (buffer_add_char(buf, /* "^" */94), rev_char_set(char_set)) : char_set);
  return buffer_add_char(buf, /* "]" */93);
}

function bprint_padty(buf, padty) {
  switch (padty) {
    case 0 : 
        return buffer_add_char(buf, /* "-" */45);
    case 1 : 
        return /* () */0;
    case 2 : 
        return buffer_add_char(buf, /* "0" */48);
    
  }
}

function bprint_ignored_flag(buf, ign_flag) {
  if (ign_flag) {
    return buffer_add_char(buf, /* "_" */95);
  } else {
    return 0;
  }
}

function bprint_pad_opt(buf, pad_opt) {
  if (pad_opt) {
    return buffer_add_string(buf, String(pad_opt[0]));
  } else {
    return /* () */0;
  }
}

function bprint_padding(buf, pad) {
  if (typeof pad === "number") {
    return /* () */0;
  } else {
    bprint_padty(buf, pad[0]);
    if (pad.tag) {
      return buffer_add_char(buf, /* "*" */42);
    } else {
      return buffer_add_string(buf, String(pad[1]));
    }
  }
}

function bprint_precision(buf, prec) {
  if (typeof prec === "number") {
    if (prec !== 0) {
      return buffer_add_string(buf, ".*");
    } else {
      return /* () */0;
    }
  } else {
    buffer_add_char(buf, /* "." */46);
    return buffer_add_string(buf, String(prec[0]));
  }
}

function bprint_iconv_flag(buf, iconv) {
  switch (iconv) {
    case 1 : 
    case 4 : 
        return buffer_add_char(buf, /* "+" */43);
    case 2 : 
    case 5 : 
        return buffer_add_char(buf, /* " " */32);
    case 7 : 
    case 9 : 
    case 11 : 
        return buffer_add_char(buf, /* "#" */35);
    case 0 : 
    case 3 : 
    case 6 : 
    case 8 : 
    case 10 : 
    case 12 : 
        return /* () */0;
    
  }
}

function bprint_int_fmt(buf, ign_flag, iconv, pad, prec) {
  buffer_add_char(buf, /* "%" */37);
  bprint_ignored_flag(buf, ign_flag);
  bprint_iconv_flag(buf, iconv);
  bprint_padding(buf, pad);
  bprint_precision(buf, prec);
  return buffer_add_char(buf, char_of_iconv(iconv));
}

function bprint_altint_fmt(buf, ign_flag, iconv, pad, prec, c) {
  buffer_add_char(buf, /* "%" */37);
  bprint_ignored_flag(buf, ign_flag);
  bprint_iconv_flag(buf, iconv);
  bprint_padding(buf, pad);
  bprint_precision(buf, prec);
  buffer_add_char(buf, c);
  return buffer_add_char(buf, char_of_iconv(iconv));
}

function bprint_fconv_flag(buf, fconv) {
  switch (fconv) {
    case 1 : 
    case 4 : 
    case 7 : 
    case 10 : 
    case 13 : 
        return buffer_add_char(buf, /* "+" */43);
    case 2 : 
    case 5 : 
    case 8 : 
    case 11 : 
    case 14 : 
        return buffer_add_char(buf, /* " " */32);
    case 0 : 
    case 3 : 
    case 6 : 
    case 9 : 
    case 12 : 
    case 15 : 
        return /* () */0;
    
  }
}

function bprint_float_fmt(buf, ign_flag, fconv, pad, prec) {
  buffer_add_char(buf, /* "%" */37);
  bprint_ignored_flag(buf, ign_flag);
  bprint_fconv_flag(buf, fconv);
  bprint_padding(buf, pad);
  bprint_precision(buf, prec);
  return buffer_add_char(buf, char_of_fconv(fconv));
}

function string_of_formatting_lit(formatting_lit) {
  if (typeof formatting_lit === "number") {
    switch (formatting_lit) {
      case 0 : 
          return "@]";
      case 1 : 
          return "@}";
      case 2 : 
          return "@?";
      case 3 : 
          return "@\n";
      case 4 : 
          return "@.";
      case 5 : 
          return "@@";
      case 6 : 
          return "@%";
      
    }
  } else {
    switch (formatting_lit.tag | 0) {
      case 0 : 
      case 1 : 
          return formatting_lit[0];
      case 2 : 
          return "@" + Caml_string.bytes_to_string(Bytes.make(1, formatting_lit[0]));
      
    }
  }
}

function string_of_formatting_gen(formatting_gen) {
  return formatting_gen[0][1];
}

function bprint_char_literal(buf, chr) {
  if (chr !== 37) {
    return buffer_add_char(buf, chr);
  } else {
    return buffer_add_string(buf, "%%");
  }
}

function bprint_string_literal(buf, str) {
  for(var i = 0 ,i_finish = str.length - 1 | 0; i <= i_finish; ++i){
    bprint_char_literal(buf, Caml_string.get(str, i));
  }
  return /* () */0;
}

function bprint_fmtty(buf, _fmtty) {
  while(true) {
    var fmtty = _fmtty;
    if (typeof fmtty === "number") {
      return /* () */0;
    } else {
      switch (fmtty.tag | 0) {
        case 0 : 
            buffer_add_string(buf, "%c");
            _fmtty = fmtty[0];
            continue ;
            case 1 : 
            buffer_add_string(buf, "%s");
            _fmtty = fmtty[0];
            continue ;
            case 2 : 
            buffer_add_string(buf, "%i");
            _fmtty = fmtty[0];
            continue ;
            case 3 : 
            buffer_add_string(buf, "%li");
            _fmtty = fmtty[0];
            continue ;
            case 4 : 
            buffer_add_string(buf, "%ni");
            _fmtty = fmtty[0];
            continue ;
            case 5 : 
            buffer_add_string(buf, "%Li");
            _fmtty = fmtty[0];
            continue ;
            case 6 : 
            buffer_add_string(buf, "%f");
            _fmtty = fmtty[0];
            continue ;
            case 7 : 
            buffer_add_string(buf, "%B");
            _fmtty = fmtty[0];
            continue ;
            case 8 : 
            buffer_add_string(buf, "%{");
            bprint_fmtty(buf, fmtty[0]);
            buffer_add_string(buf, "%}");
            _fmtty = fmtty[1];
            continue ;
            case 9 : 
            buffer_add_string(buf, "%(");
            bprint_fmtty(buf, fmtty[0]);
            buffer_add_string(buf, "%)");
            _fmtty = fmtty[2];
            continue ;
            case 10 : 
            buffer_add_string(buf, "%a");
            _fmtty = fmtty[0];
            continue ;
            case 11 : 
            buffer_add_string(buf, "%t");
            _fmtty = fmtty[0];
            continue ;
            case 12 : 
            buffer_add_string(buf, "%?");
            _fmtty = fmtty[0];
            continue ;
            case 13 : 
            buffer_add_string(buf, "%r");
            _fmtty = fmtty[0];
            continue ;
            case 14 : 
            buffer_add_string(buf, "%_r");
            _fmtty = fmtty[0];
            continue ;
            
      }
    }
  };
}

function int_of_custom_arity(param) {
  if (param) {
    return 1 + int_of_custom_arity(param[0]) | 0;
  } else {
    return 0;
  }
}

function bprint_fmt(buf, fmt) {
  var _fmt = fmt;
  var _ign_flag = /* false */0;
  while(true) {
    var ign_flag = _ign_flag;
    var fmt$1 = _fmt;
    if (typeof fmt$1 === "number") {
      return /* () */0;
    } else {
      switch (fmt$1.tag | 0) {
        case 0 : 
            buffer_add_char(buf, /* "%" */37);
            bprint_ignored_flag(buf, ign_flag);
            buffer_add_char(buf, /* "c" */99);
            _ign_flag = /* false */0;
            _fmt = fmt$1[0];
            continue ;
            case 1 : 
            buffer_add_char(buf, /* "%" */37);
            bprint_ignored_flag(buf, ign_flag);
            buffer_add_char(buf, /* "C" */67);
            _ign_flag = /* false */0;
            _fmt = fmt$1[0];
            continue ;
            case 2 : 
            buffer_add_char(buf, /* "%" */37);
            bprint_ignored_flag(buf, ign_flag);
            bprint_padding(buf, fmt$1[0]);
            buffer_add_char(buf, /* "s" */115);
            _ign_flag = /* false */0;
            _fmt = fmt$1[1];
            continue ;
            case 3 : 
            buffer_add_char(buf, /* "%" */37);
            bprint_ignored_flag(buf, ign_flag);
            bprint_padding(buf, fmt$1[0]);
            buffer_add_char(buf, /* "S" */83);
            _ign_flag = /* false */0;
            _fmt = fmt$1[1];
            continue ;
            case 4 : 
            bprint_int_fmt(buf, ign_flag, fmt$1[0], fmt$1[1], fmt$1[2]);
            _ign_flag = /* false */0;
            _fmt = fmt$1[3];
            continue ;
            case 5 : 
            bprint_altint_fmt(buf, ign_flag, fmt$1[0], fmt$1[1], fmt$1[2], /* "l" */108);
            _ign_flag = /* false */0;
            _fmt = fmt$1[3];
            continue ;
            case 6 : 
            bprint_altint_fmt(buf, ign_flag, fmt$1[0], fmt$1[1], fmt$1[2], /* "n" */110);
            _ign_flag = /* false */0;
            _fmt = fmt$1[3];
            continue ;
            case 7 : 
            bprint_altint_fmt(buf, ign_flag, fmt$1[0], fmt$1[1], fmt$1[2], /* "L" */76);
            _ign_flag = /* false */0;
            _fmt = fmt$1[3];
            continue ;
            case 8 : 
            bprint_float_fmt(buf, ign_flag, fmt$1[0], fmt$1[1], fmt$1[2]);
            _ign_flag = /* false */0;
            _fmt = fmt$1[3];
            continue ;
            case 9 : 
            buffer_add_char(buf, /* "%" */37);
            bprint_ignored_flag(buf, ign_flag);
            buffer_add_char(buf, /* "B" */66);
            _ign_flag = /* false */0;
            _fmt = fmt$1[0];
            continue ;
            case 10 : 
            buffer_add_string(buf, "%!");
            _fmt = fmt$1[0];
            continue ;
            case 11 : 
            bprint_string_literal(buf, fmt$1[0]);
            _fmt = fmt$1[1];
            continue ;
            case 12 : 
            bprint_char_literal(buf, fmt$1[0]);
            _fmt = fmt$1[1];
            continue ;
            case 13 : 
            buffer_add_char(buf, /* "%" */37);
            bprint_ignored_flag(buf, ign_flag);
            bprint_pad_opt(buf, fmt$1[0]);
            buffer_add_char(buf, /* "{" */123);
            bprint_fmtty(buf, fmt$1[1]);
            buffer_add_char(buf, /* "%" */37);
            buffer_add_char(buf, /* "}" */125);
            _ign_flag = /* false */0;
            _fmt = fmt$1[2];
            continue ;
            case 14 : 
            buffer_add_char(buf, /* "%" */37);
            bprint_ignored_flag(buf, ign_flag);
            bprint_pad_opt(buf, fmt$1[0]);
            buffer_add_char(buf, /* "(" */40);
            bprint_fmtty(buf, fmt$1[1]);
            buffer_add_char(buf, /* "%" */37);
            buffer_add_char(buf, /* ")" */41);
            _ign_flag = /* false */0;
            _fmt = fmt$1[2];
            continue ;
            case 15 : 
            buffer_add_char(buf, /* "%" */37);
            bprint_ignored_flag(buf, ign_flag);
            buffer_add_char(buf, /* "a" */97);
            _ign_flag = /* false */0;
            _fmt = fmt$1[0];
            continue ;
            case 16 : 
            buffer_add_char(buf, /* "%" */37);
            bprint_ignored_flag(buf, ign_flag);
            buffer_add_char(buf, /* "t" */116);
            _ign_flag = /* false */0;
            _fmt = fmt$1[0];
            continue ;
            case 17 : 
            bprint_string_literal(buf, string_of_formatting_lit(fmt$1[0]));
            _fmt = fmt$1[1];
            continue ;
            case 18 : 
            bprint_string_literal(buf, "@{");
            bprint_string_literal(buf, string_of_formatting_gen(fmt$1[0]));
            _fmt = fmt$1[1];
            continue ;
            case 19 : 
            buffer_add_char(buf, /* "%" */37);
            bprint_ignored_flag(buf, ign_flag);
            buffer_add_char(buf, /* "r" */114);
            _ign_flag = /* false */0;
            _fmt = fmt$1[0];
            continue ;
            case 20 : 
            buffer_add_char(buf, /* "%" */37);
            bprint_ignored_flag(buf, ign_flag);
            bprint_pad_opt(buf, fmt$1[0]);
            bprint_char_set(buf, fmt$1[1]);
            _ign_flag = /* false */0;
            _fmt = fmt$1[2];
            continue ;
            case 21 : 
            buffer_add_char(buf, /* "%" */37);
            bprint_ignored_flag(buf, ign_flag);
            buffer_add_char(buf, char_of_counter(fmt$1[0]));
            _ign_flag = /* false */0;
            _fmt = fmt$1[1];
            continue ;
            case 22 : 
            buffer_add_char(buf, /* "%" */37);
            bprint_ignored_flag(buf, ign_flag);
            bprint_string_literal(buf, "0c");
            _ign_flag = /* false */0;
            _fmt = fmt$1[0];
            continue ;
            case 23 : 
            var match = param_format_of_ignored_format(fmt$1[0], fmt$1[1]);
            _ign_flag = /* true */1;
            _fmt = match[0];
            continue ;
            case 24 : 
            for(var _i = 1 ,_i_finish = int_of_custom_arity(fmt$1[0]); _i <= _i_finish; ++_i){
              buffer_add_char(buf, /* "%" */37);
              bprint_ignored_flag(buf, ign_flag);
              buffer_add_char(buf, /* "?" */63);
            }
            _ign_flag = /* false */0;
            _fmt = fmt$1[2];
            continue ;
            
      }
    }
  };
}

function string_of_fmt(fmt) {
  var buf = /* record */[
    /* ind */0,
    /* bytes */Caml_string.caml_create_string(16)
  ];
  bprint_fmt(buf, fmt);
  return buffer_contents(buf);
}

function symm(param) {
  if (typeof param === "number") {
    return /* End_of_fmtty */0;
  } else {
    switch (param.tag | 0) {
      case 0 : 
          return /* Char_ty */Block.__(0, [symm(param[0])]);
      case 1 : 
          return /* String_ty */Block.__(1, [symm(param[0])]);
      case 2 : 
          return /* Int_ty */Block.__(2, [symm(param[0])]);
      case 3 : 
          return /* Int32_ty */Block.__(3, [symm(param[0])]);
      case 4 : 
          return /* Nativeint_ty */Block.__(4, [symm(param[0])]);
      case 5 : 
          return /* Int64_ty */Block.__(5, [symm(param[0])]);
      case 6 : 
          return /* Float_ty */Block.__(6, [symm(param[0])]);
      case 7 : 
          return /* Bool_ty */Block.__(7, [symm(param[0])]);
      case 8 : 
          return /* Format_arg_ty */Block.__(8, [
                    param[0],
                    symm(param[1])
                  ]);
      case 9 : 
          return /* Format_subst_ty */Block.__(9, [
                    param[1],
                    param[0],
                    symm(param[2])
                  ]);
      case 10 : 
          return /* Alpha_ty */Block.__(10, [symm(param[0])]);
      case 11 : 
          return /* Theta_ty */Block.__(11, [symm(param[0])]);
      case 12 : 
          return /* Any_ty */Block.__(12, [symm(param[0])]);
      case 13 : 
          return /* Reader_ty */Block.__(13, [symm(param[0])]);
      case 14 : 
          return /* Ignored_reader_ty */Block.__(14, [symm(param[0])]);
      
    }
  }
}

function fmtty_rel_det(param) {
  if (typeof param === "number") {
    return /* tuple */[
            (function () {
                return /* Refl */0;
              }),
            (function () {
                return /* Refl */0;
              }),
            (function () {
                return /* Refl */0;
              }),
            (function () {
                return /* Refl */0;
              })
          ];
  } else {
    switch (param.tag | 0) {
      case 0 : 
          var match = fmtty_rel_det(param[0]);
          var af = match[1];
          var fa = match[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(af, /* Refl */0);
                      return /* Refl */0;
                    }),
                  match[2],
                  match[3]
                ];
      case 1 : 
          var match$1 = fmtty_rel_det(param[0]);
          var af$1 = match$1[1];
          var fa$1 = match$1[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa$1, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(af$1, /* Refl */0);
                      return /* Refl */0;
                    }),
                  match$1[2],
                  match$1[3]
                ];
      case 2 : 
          var match$2 = fmtty_rel_det(param[0]);
          var af$2 = match$2[1];
          var fa$2 = match$2[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa$2, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(af$2, /* Refl */0);
                      return /* Refl */0;
                    }),
                  match$2[2],
                  match$2[3]
                ];
      case 3 : 
          var match$3 = fmtty_rel_det(param[0]);
          var af$3 = match$3[1];
          var fa$3 = match$3[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa$3, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(af$3, /* Refl */0);
                      return /* Refl */0;
                    }),
                  match$3[2],
                  match$3[3]
                ];
      case 4 : 
          var match$4 = fmtty_rel_det(param[0]);
          var af$4 = match$4[1];
          var fa$4 = match$4[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa$4, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(af$4, /* Refl */0);
                      return /* Refl */0;
                    }),
                  match$4[2],
                  match$4[3]
                ];
      case 5 : 
          var match$5 = fmtty_rel_det(param[0]);
          var af$5 = match$5[1];
          var fa$5 = match$5[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa$5, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(af$5, /* Refl */0);
                      return /* Refl */0;
                    }),
                  match$5[2],
                  match$5[3]
                ];
      case 6 : 
          var match$6 = fmtty_rel_det(param[0]);
          var af$6 = match$6[1];
          var fa$6 = match$6[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa$6, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(af$6, /* Refl */0);
                      return /* Refl */0;
                    }),
                  match$6[2],
                  match$6[3]
                ];
      case 7 : 
          var match$7 = fmtty_rel_det(param[0]);
          var af$7 = match$7[1];
          var fa$7 = match$7[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa$7, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(af$7, /* Refl */0);
                      return /* Refl */0;
                    }),
                  match$7[2],
                  match$7[3]
                ];
      case 8 : 
          var match$8 = fmtty_rel_det(param[1]);
          var af$8 = match$8[1];
          var fa$8 = match$8[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa$8, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(af$8, /* Refl */0);
                      return /* Refl */0;
                    }),
                  match$8[2],
                  match$8[3]
                ];
      case 9 : 
          var match$9 = fmtty_rel_det(param[2]);
          var de = match$9[3];
          var ed = match$9[2];
          var af$9 = match$9[1];
          var fa$9 = match$9[0];
          var ty = trans(symm(param[0]), param[1]);
          var match$10 = fmtty_rel_det(ty);
          var jd = match$10[3];
          var dj = match$10[2];
          var ga = match$10[1];
          var ag = match$10[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa$9, /* Refl */0);
                      Curry._1(ag, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(ga, /* Refl */0);
                      Curry._1(af$9, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(ed, /* Refl */0);
                      Curry._1(dj, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(jd, /* Refl */0);
                      Curry._1(de, /* Refl */0);
                      return /* Refl */0;
                    })
                ];
      case 10 : 
          var match$11 = fmtty_rel_det(param[0]);
          var af$10 = match$11[1];
          var fa$10 = match$11[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa$10, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(af$10, /* Refl */0);
                      return /* Refl */0;
                    }),
                  match$11[2],
                  match$11[3]
                ];
      case 11 : 
          var match$12 = fmtty_rel_det(param[0]);
          var af$11 = match$12[1];
          var fa$11 = match$12[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa$11, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(af$11, /* Refl */0);
                      return /* Refl */0;
                    }),
                  match$12[2],
                  match$12[3]
                ];
      case 12 : 
          var match$13 = fmtty_rel_det(param[0]);
          var af$12 = match$13[1];
          var fa$12 = match$13[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa$12, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(af$12, /* Refl */0);
                      return /* Refl */0;
                    }),
                  match$13[2],
                  match$13[3]
                ];
      case 13 : 
          var match$14 = fmtty_rel_det(param[0]);
          var de$1 = match$14[3];
          var ed$1 = match$14[2];
          var af$13 = match$14[1];
          var fa$13 = match$14[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa$13, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(af$13, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(ed$1, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(de$1, /* Refl */0);
                      return /* Refl */0;
                    })
                ];
      case 14 : 
          var match$15 = fmtty_rel_det(param[0]);
          var de$2 = match$15[3];
          var ed$2 = match$15[2];
          var af$14 = match$15[1];
          var fa$14 = match$15[0];
          return /* tuple */[
                  (function () {
                      Curry._1(fa$14, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(af$14, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(ed$2, /* Refl */0);
                      return /* Refl */0;
                    }),
                  (function () {
                      Curry._1(de$2, /* Refl */0);
                      return /* Refl */0;
                    })
                ];
      
    }
  }
}

function trans(ty1, ty2) {
  var exit = 0;
  if (typeof ty1 === "number") {
    if (typeof ty2 === "number") {
      return /* End_of_fmtty */0;
    } else {
      switch (ty2.tag | 0) {
        case 8 : 
            exit = 6;
            break;
        case 9 : 
            exit = 7;
            break;
        case 10 : 
            exit = 1;
            break;
        case 11 : 
            exit = 2;
            break;
        case 12 : 
            exit = 3;
            break;
        case 13 : 
            exit = 4;
            break;
        case 14 : 
            exit = 5;
            break;
        default:
          throw [
                Caml_builtin_exceptions.assert_failure,
                [
                  "camlinternalFormat.ml",
                  816,
                  23
                ]
              ];
      }
    }
  } else {
    switch (ty1.tag | 0) {
      case 0 : 
          if (typeof ty2 === "number") {
            exit = 8;
          } else {
            switch (ty2.tag | 0) {
              case 0 : 
                  return /* Char_ty */Block.__(0, [trans(ty1[0], ty2[0])]);
              case 8 : 
                  exit = 6;
                  break;
              case 9 : 
                  exit = 7;
                  break;
              case 10 : 
                  exit = 1;
                  break;
              case 11 : 
                  exit = 2;
                  break;
              case 12 : 
                  exit = 3;
                  break;
              case 13 : 
                  exit = 4;
                  break;
              case 14 : 
                  exit = 5;
                  break;
              
            }
          }
          break;
      case 1 : 
          if (typeof ty2 === "number") {
            exit = 8;
          } else {
            switch (ty2.tag | 0) {
              case 1 : 
                  return /* String_ty */Block.__(1, [trans(ty1[0], ty2[0])]);
              case 8 : 
                  exit = 6;
                  break;
              case 9 : 
                  exit = 7;
                  break;
              case 10 : 
                  exit = 1;
                  break;
              case 11 : 
                  exit = 2;
                  break;
              case 12 : 
                  exit = 3;
                  break;
              case 13 : 
                  exit = 4;
                  break;
              case 14 : 
                  exit = 5;
                  break;
              
            }
          }
          break;
      case 2 : 
          if (typeof ty2 === "number") {
            exit = 8;
          } else {
            switch (ty2.tag | 0) {
              case 2 : 
                  return /* Int_ty */Block.__(2, [trans(ty1[0], ty2[0])]);
              case 8 : 
                  exit = 6;
                  break;
              case 9 : 
                  exit = 7;
                  break;
              case 10 : 
                  exit = 1;
                  break;
              case 11 : 
                  exit = 2;
                  break;
              case 12 : 
                  exit = 3;
                  break;
              case 13 : 
                  exit = 4;
                  break;
              case 14 : 
                  exit = 5;
                  break;
              
            }
          }
          break;
      case 3 : 
          if (typeof ty2 === "number") {
            exit = 8;
          } else {
            switch (ty2.tag | 0) {
              case 3 : 
                  return /* Int32_ty */Block.__(3, [trans(ty1[0], ty2[0])]);
              case 8 : 
                  exit = 6;
                  break;
              case 9 : 
                  exit = 7;
                  break;
              case 10 : 
                  exit = 1;
                  break;
              case 11 : 
                  exit = 2;
                  break;
              case 12 : 
                  exit = 3;
                  break;
              case 13 : 
                  exit = 4;
                  break;
              case 14 : 
                  exit = 5;
                  break;
              
            }
          }
          break;
      case 4 : 
          if (typeof ty2 === "number") {
            exit = 8;
          } else {
            switch (ty2.tag | 0) {
              case 4 : 
                  return /* Nativeint_ty */Block.__(4, [trans(ty1[0], ty2[0])]);
              case 8 : 
                  exit = 6;
                  break;
              case 9 : 
                  exit = 7;
                  break;
              case 10 : 
                  exit = 1;
                  break;
              case 11 : 
                  exit = 2;
                  break;
              case 12 : 
                  exit = 3;
                  break;
              case 13 : 
                  exit = 4;
                  break;
              case 14 : 
                  exit = 5;
                  break;
              
            }
          }
          break;
      case 5 : 
          if (typeof ty2 === "number") {
            exit = 8;
          } else {
            switch (ty2.tag | 0) {
              case 5 : 
                  return /* Int64_ty */Block.__(5, [trans(ty1[0], ty2[0])]);
              case 8 : 
                  exit = 6;
                  break;
              case 9 : 
                  exit = 7;
                  break;
              case 10 : 
                  exit = 1;
                  break;
              case 11 : 
                  exit = 2;
                  break;
              case 12 : 
                  exit = 3;
                  break;
              case 13 : 
                  exit = 4;
                  break;
              case 14 : 
                  exit = 5;
                  break;
              
            }
          }
          break;
      case 6 : 
          if (typeof ty2 === "number") {
            exit = 8;
          } else {
            switch (ty2.tag | 0) {
              case 6 : 
                  return /* Float_ty */Block.__(6, [trans(ty1[0], ty2[0])]);
              case 8 : 
                  exit = 6;
                  break;
              case 9 : 
                  exit = 7;
                  break;
              case 10 : 
                  exit = 1;
                  break;
              case 11 : 
                  exit = 2;
                  break;
              case 12 : 
                  exit = 3;
                  break;
              case 13 : 
                  exit = 4;
                  break;
              case 14 : 
                  exit = 5;
                  break;
              
            }
          }
          break;
      case 7 : 
          if (typeof ty2 === "number") {
            exit = 8;
          } else {
            switch (ty2.tag | 0) {
              case 7 : 
                  return /* Bool_ty */Block.__(7, [trans(ty1[0], ty2[0])]);
              case 8 : 
                  exit = 6;
                  break;
              case 9 : 
                  exit = 7;
                  break;
              case 10 : 
                  exit = 1;
                  break;
              case 11 : 
                  exit = 2;
                  break;
              case 12 : 
                  exit = 3;
                  break;
              case 13 : 
                  exit = 4;
                  break;
              case 14 : 
                  exit = 5;
                  break;
              
            }
          }
          break;
      case 8 : 
          if (typeof ty2 === "number") {
            throw [
                  Caml_builtin_exceptions.assert_failure,
                  [
                    "camlinternalFormat.ml",
                    802,
                    26
                  ]
                ];
          } else {
            switch (ty2.tag | 0) {
              case 8 : 
                  return /* Format_arg_ty */Block.__(8, [
                            trans(ty1[0], ty2[0]),
                            trans(ty1[1], ty2[1])
                          ]);
              case 10 : 
                  exit = 1;
                  break;
              case 11 : 
                  exit = 2;
                  break;
              case 12 : 
                  exit = 3;
                  break;
              case 13 : 
                  exit = 4;
                  break;
              case 14 : 
                  exit = 5;
                  break;
              default:
                throw [
                      Caml_builtin_exceptions.assert_failure,
                      [
                        "camlinternalFormat.ml",
                        802,
                        26
                      ]
                    ];
            }
          }
          break;
      case 9 : 
          if (typeof ty2 === "number") {
            throw [
                  Caml_builtin_exceptions.assert_failure,
                  [
                    "camlinternalFormat.ml",
                    812,
                    28
                  ]
                ];
          } else {
            switch (ty2.tag | 0) {
              case 8 : 
                  exit = 6;
                  break;
              case 9 : 
                  var ty = trans(symm(ty1[1]), ty2[0]);
                  var match = fmtty_rel_det(ty);
                  Curry._1(match[1], /* Refl */0);
                  Curry._1(match[3], /* Refl */0);
                  return /* Format_subst_ty */Block.__(9, [
                            ty1[0],
                            ty2[1],
                            trans(ty1[2], ty2[2])
                          ]);
              case 10 : 
                  exit = 1;
                  break;
              case 11 : 
                  exit = 2;
                  break;
              case 12 : 
                  exit = 3;
                  break;
              case 13 : 
                  exit = 4;
                  break;
              case 14 : 
                  exit = 5;
                  break;
              default:
                throw [
                      Caml_builtin_exceptions.assert_failure,
                      [
                        "camlinternalFormat.ml",
                        812,
                        28
                      ]
                    ];
            }
          }
          break;
      case 10 : 
          if (typeof ty2 === "number") {
            throw [
                  Caml_builtin_exceptions.assert_failure,
                  [
                    "camlinternalFormat.ml",
                    780,
                    21
                  ]
                ];
          } else if (ty2.tag === 10) {
            return /* Alpha_ty */Block.__(10, [trans(ty1[0], ty2[0])]);
          } else {
            throw [
                  Caml_builtin_exceptions.assert_failure,
                  [
                    "camlinternalFormat.ml",
                    780,
                    21
                  ]
                ];
          }
      case 11 : 
          if (typeof ty2 === "number") {
            throw [
                  Caml_builtin_exceptions.assert_failure,
                  [
                    "camlinternalFormat.ml",
                    784,
                    21
                  ]
                ];
          } else {
            switch (ty2.tag | 0) {
              case 10 : 
                  exit = 1;
                  break;
              case 11 : 
                  return /* Theta_ty */Block.__(11, [trans(ty1[0], ty2[0])]);
              default:
                throw [
                      Caml_builtin_exceptions.assert_failure,
                      [
                        "camlinternalFormat.ml",
                        784,
                        21
                      ]
                    ];
            }
          }
          break;
      case 12 : 
          if (typeof ty2 === "number") {
            throw [
                  Caml_builtin_exceptions.assert_failure,
                  [
                    "camlinternalFormat.ml",
                    788,
                    19
                  ]
                ];
          } else {
            switch (ty2.tag | 0) {
              case 10 : 
                  exit = 1;
                  break;
              case 11 : 
                  exit = 2;
                  break;
              case 12 : 
                  return /* Any_ty */Block.__(12, [trans(ty1[0], ty2[0])]);
              default:
                throw [
                      Caml_builtin_exceptions.assert_failure,
                      [
                        "camlinternalFormat.ml",
                        788,
                        19
                      ]
                    ];
            }
          }
          break;
      case 13 : 
          if (typeof ty2 === "number") {
            throw [
                  Caml_builtin_exceptions.assert_failure,
                  [
                    "camlinternalFormat.ml",
                    792,
                    22
                  ]
                ];
          } else {
            switch (ty2.tag | 0) {
              case 10 : 
                  exit = 1;
                  break;
              case 11 : 
                  exit = 2;
                  break;
              case 12 : 
                  exit = 3;
                  break;
              case 13 : 
                  return /* Reader_ty */Block.__(13, [trans(ty1[0], ty2[0])]);
              default:
                throw [
                      Caml_builtin_exceptions.assert_failure,
                      [
                        "camlinternalFormat.ml",
                        792,
                        22
                      ]
                    ];
            }
          }
          break;
      case 14 : 
          if (typeof ty2 === "number") {
            throw [
                  Caml_builtin_exceptions.assert_failure,
                  [
                    "camlinternalFormat.ml",
                    797,
                    30
                  ]
                ];
          } else {
            switch (ty2.tag | 0) {
              case 10 : 
                  exit = 1;
                  break;
              case 11 : 
                  exit = 2;
                  break;
              case 12 : 
                  exit = 3;
                  break;
              case 13 : 
                  exit = 4;
                  break;
              case 14 : 
                  return /* Ignored_reader_ty */Block.__(14, [trans(ty1[0], ty2[0])]);
              default:
                throw [
                      Caml_builtin_exceptions.assert_failure,
                      [
                        "camlinternalFormat.ml",
                        797,
                        30
                      ]
                    ];
            }
          }
          break;
      
    }
  }
  switch (exit) {
    case 1 : 
        throw [
              Caml_builtin_exceptions.assert_failure,
              [
                "camlinternalFormat.ml",
                781,
                21
              ]
            ];
    case 2 : 
        throw [
              Caml_builtin_exceptions.assert_failure,
              [
                "camlinternalFormat.ml",
                785,
                21
              ]
            ];
    case 3 : 
        throw [
              Caml_builtin_exceptions.assert_failure,
              [
                "camlinternalFormat.ml",
                789,
                19
              ]
            ];
    case 4 : 
        throw [
              Caml_builtin_exceptions.assert_failure,
              [
                "camlinternalFormat.ml",
                793,
                22
              ]
            ];
    case 5 : 
        throw [
              Caml_builtin_exceptions.assert_failure,
              [
                "camlinternalFormat.ml",
                798,
                30
              ]
            ];
    case 6 : 
        throw [
              Caml_builtin_exceptions.assert_failure,
              [
                "camlinternalFormat.ml",
                803,
                26
              ]
            ];
    case 7 : 
        throw [
              Caml_builtin_exceptions.assert_failure,
              [
                "camlinternalFormat.ml",
                813,
                28
              ]
            ];
    case 8 : 
        throw [
              Caml_builtin_exceptions.assert_failure,
              [
                "camlinternalFormat.ml",
                817,
                23
              ]
            ];
    
  }
}

function fmtty_of_formatting_gen(formatting_gen) {
  return fmtty_of_fmt(formatting_gen[0][0]);
}

function fmtty_of_fmt(_fmtty) {
  while(true) {
    var fmtty = _fmtty;
    var exit = 0;
    if (typeof fmtty === "number") {
      return /* End_of_fmtty */0;
    } else {
      switch (fmtty.tag | 0) {
        case 2 : 
        case 3 : 
            exit = 1;
            break;
        case 4 : 
            var ty_rest = fmtty_of_fmt(fmtty[3]);
            var prec_ty = fmtty_of_precision_fmtty(fmtty[2], /* Int_ty */Block.__(2, [ty_rest]));
            return fmtty_of_padding_fmtty(fmtty[1], prec_ty);
        case 5 : 
            var ty_rest$1 = fmtty_of_fmt(fmtty[3]);
            var prec_ty$1 = fmtty_of_precision_fmtty(fmtty[2], /* Int32_ty */Block.__(3, [ty_rest$1]));
            return fmtty_of_padding_fmtty(fmtty[1], prec_ty$1);
        case 6 : 
            var ty_rest$2 = fmtty_of_fmt(fmtty[3]);
            var prec_ty$2 = fmtty_of_precision_fmtty(fmtty[2], /* Nativeint_ty */Block.__(4, [ty_rest$2]));
            return fmtty_of_padding_fmtty(fmtty[1], prec_ty$2);
        case 7 : 
            var ty_rest$3 = fmtty_of_fmt(fmtty[3]);
            var prec_ty$3 = fmtty_of_precision_fmtty(fmtty[2], /* Int64_ty */Block.__(5, [ty_rest$3]));
            return fmtty_of_padding_fmtty(fmtty[1], prec_ty$3);
        case 8 : 
            var ty_rest$4 = fmtty_of_fmt(fmtty[3]);
            var prec_ty$4 = fmtty_of_precision_fmtty(fmtty[2], /* Float_ty */Block.__(6, [ty_rest$4]));
            return fmtty_of_padding_fmtty(fmtty[1], prec_ty$4);
        case 9 : 
            return /* Bool_ty */Block.__(7, [fmtty_of_fmt(fmtty[0])]);
        case 10 : 
            _fmtty = fmtty[0];
            continue ;
            case 13 : 
            return /* Format_arg_ty */Block.__(8, [
                      fmtty[1],
                      fmtty_of_fmt(fmtty[2])
                    ]);
        case 14 : 
            var ty = fmtty[1];
            return /* Format_subst_ty */Block.__(9, [
                      ty,
                      ty,
                      fmtty_of_fmt(fmtty[2])
                    ]);
        case 15 : 
            return /* Alpha_ty */Block.__(10, [fmtty_of_fmt(fmtty[0])]);
        case 16 : 
            return /* Theta_ty */Block.__(11, [fmtty_of_fmt(fmtty[0])]);
        case 18 : 
            return CamlinternalFormatBasics.concat_fmtty(fmtty_of_formatting_gen(fmtty[0]), fmtty_of_fmt(fmtty[1]));
        case 19 : 
            return /* Reader_ty */Block.__(13, [fmtty_of_fmt(fmtty[0])]);
        case 20 : 
            return /* String_ty */Block.__(1, [fmtty_of_fmt(fmtty[2])]);
        case 21 : 
            return /* Int_ty */Block.__(2, [fmtty_of_fmt(fmtty[1])]);
        case 0 : 
        case 1 : 
        case 22 : 
            return /* Char_ty */Block.__(0, [fmtty_of_fmt(fmtty[0])]);
        case 23 : 
            var ign = fmtty[0];
            var fmt = fmtty[1];
            if (typeof ign === "number") {
              if (ign === 3) {
                return /* Ignored_reader_ty */Block.__(14, [fmtty_of_fmt(fmt)]);
              } else {
                return fmtty_of_fmt(fmt);
              }
            } else if (ign.tag === 8) {
              return CamlinternalFormatBasics.concat_fmtty(ign[1], fmtty_of_fmt(fmt));
            } else {
              return fmtty_of_fmt(fmt);
            }
        case 24 : 
            return fmtty_of_custom(fmtty[0], fmtty_of_fmt(fmtty[2]));
        default:
          _fmtty = fmtty[1];
          continue ;
          
      }
    }
    if (exit === 1) {
      return fmtty_of_padding_fmtty(fmtty[0], /* String_ty */Block.__(1, [fmtty_of_fmt(fmtty[1])]));
    }
    
  };
}

function fmtty_of_custom(arity, fmtty) {
  if (arity) {
    return /* Any_ty */Block.__(12, [fmtty_of_custom(arity[0], fmtty)]);
  } else {
    return fmtty;
  }
}

function fmtty_of_padding_fmtty(pad, fmtty) {
  if (typeof pad === "number" || !pad.tag) {
    return fmtty;
  } else {
    return /* Int_ty */Block.__(2, [fmtty]);
  }
}

function fmtty_of_precision_fmtty(prec, fmtty) {
  if (typeof prec === "number" && prec !== 0) {
    return /* Int_ty */Block.__(2, [fmtty]);
  } else {
    return fmtty;
  }
}

var Type_mismatch = Caml_exceptions.create("CamlinternalFormat.Type_mismatch");

function type_padding(pad, fmtty) {
  if (typeof pad === "number") {
    return /* Padding_fmtty_EBB */[
            /* No_padding */0,
            fmtty
          ];
  } else if (pad.tag) {
    if (typeof fmtty === "number") {
      throw Type_mismatch;
    } else if (fmtty.tag === 2) {
      return /* Padding_fmtty_EBB */[
              /* Arg_padding */Block.__(1, [pad[0]]),
              fmtty[0]
            ];
    } else {
      throw Type_mismatch;
    }
  } else {
    return /* Padding_fmtty_EBB */[
            /* Lit_padding */Block.__(0, [
                pad[0],
                pad[1]
              ]),
            fmtty
          ];
  }
}

function type_padprec(pad, prec, fmtty) {
  var match = type_padding(pad, fmtty);
  if (typeof prec === "number") {
    if (prec !== 0) {
      var match$1 = match[1];
      if (typeof match$1 === "number") {
        throw Type_mismatch;
      } else if (match$1.tag === 2) {
        return /* Padprec_fmtty_EBB */[
                match[0],
                /* Arg_precision */1,
                match$1[0]
              ];
      } else {
        throw Type_mismatch;
      }
    } else {
      return /* Padprec_fmtty_EBB */[
              match[0],
              /* No_precision */0,
              match[1]
            ];
    }
  } else {
    return /* Padprec_fmtty_EBB */[
            match[0],
            /* Lit_precision */[prec[0]],
            match[1]
          ];
  }
}

function type_ignored_param_one(ign, fmt, fmtty) {
  var match = type_format_gen(fmt, fmtty);
  return /* Fmt_fmtty_EBB */[
          /* Ignored_param */Block.__(23, [
              ign,
              match[0]
            ]),
          match[1]
        ];
}

function type_format_gen(fmt, fmtty) {
  if (typeof fmt === "number") {
    return /* Fmt_fmtty_EBB */[
            /* End_of_format */0,
            fmtty
          ];
  } else {
    switch (fmt.tag | 0) {
      case 0 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag) {
            throw Type_mismatch;
          } else {
            var match = type_format_gen(fmt[0], fmtty[0]);
            return /* Fmt_fmtty_EBB */[
                    /* Char */Block.__(0, [match[0]]),
                    match[1]
                  ];
          }
      case 1 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag) {
            throw Type_mismatch;
          } else {
            var match$1 = type_format_gen(fmt[0], fmtty[0]);
            return /* Fmt_fmtty_EBB */[
                    /* Caml_char */Block.__(1, [match$1[0]]),
                    match$1[1]
                  ];
          }
      case 2 : 
          var match$2 = type_padding(fmt[0], fmtty);
          var match$3 = match$2[1];
          if (typeof match$3 === "number") {
            throw Type_mismatch;
          } else if (match$3.tag === 1) {
            var match$4 = type_format_gen(fmt[1], match$3[0]);
            return /* Fmt_fmtty_EBB */[
                    /* String */Block.__(2, [
                        match$2[0],
                        match$4[0]
                      ]),
                    match$4[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 3 : 
          var match$5 = type_padding(fmt[0], fmtty);
          var match$6 = match$5[1];
          if (typeof match$6 === "number") {
            throw Type_mismatch;
          } else if (match$6.tag === 1) {
            var match$7 = type_format_gen(fmt[1], match$6[0]);
            return /* Fmt_fmtty_EBB */[
                    /* Caml_string */Block.__(3, [
                        match$5[0],
                        match$7[0]
                      ]),
                    match$7[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 4 : 
          var match$8 = type_padprec(fmt[1], fmt[2], fmtty);
          var match$9 = match$8[2];
          if (typeof match$9 === "number") {
            throw Type_mismatch;
          } else if (match$9.tag === 2) {
            var match$10 = type_format_gen(fmt[3], match$9[0]);
            return /* Fmt_fmtty_EBB */[
                    /* Int */Block.__(4, [
                        fmt[0],
                        match$8[0],
                        match$8[1],
                        match$10[0]
                      ]),
                    match$10[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 5 : 
          var match$11 = type_padprec(fmt[1], fmt[2], fmtty);
          var match$12 = match$11[2];
          if (typeof match$12 === "number") {
            throw Type_mismatch;
          } else if (match$12.tag === 3) {
            var match$13 = type_format_gen(fmt[3], match$12[0]);
            return /* Fmt_fmtty_EBB */[
                    /* Int32 */Block.__(5, [
                        fmt[0],
                        match$11[0],
                        match$11[1],
                        match$13[0]
                      ]),
                    match$13[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 6 : 
          var match$14 = type_padprec(fmt[1], fmt[2], fmtty);
          var match$15 = match$14[2];
          if (typeof match$15 === "number") {
            throw Type_mismatch;
          } else if (match$15.tag === 4) {
            var match$16 = type_format_gen(fmt[3], match$15[0]);
            return /* Fmt_fmtty_EBB */[
                    /* Nativeint */Block.__(6, [
                        fmt[0],
                        match$14[0],
                        match$14[1],
                        match$16[0]
                      ]),
                    match$16[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 7 : 
          var match$17 = type_padprec(fmt[1], fmt[2], fmtty);
          var match$18 = match$17[2];
          if (typeof match$18 === "number") {
            throw Type_mismatch;
          } else if (match$18.tag === 5) {
            var match$19 = type_format_gen(fmt[3], match$18[0]);
            return /* Fmt_fmtty_EBB */[
                    /* Int64 */Block.__(7, [
                        fmt[0],
                        match$17[0],
                        match$17[1],
                        match$19[0]
                      ]),
                    match$19[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 8 : 
          var match$20 = type_padprec(fmt[1], fmt[2], fmtty);
          var match$21 = match$20[2];
          if (typeof match$21 === "number") {
            throw Type_mismatch;
          } else if (match$21.tag === 6) {
            var match$22 = type_format_gen(fmt[3], match$21[0]);
            return /* Fmt_fmtty_EBB */[
                    /* Float */Block.__(8, [
                        fmt[0],
                        match$20[0],
                        match$20[1],
                        match$22[0]
                      ]),
                    match$22[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 9 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 7) {
            var match$23 = type_format_gen(fmt[0], fmtty[0]);
            return /* Fmt_fmtty_EBB */[
                    /* Bool */Block.__(9, [match$23[0]]),
                    match$23[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 10 : 
          var match$24 = type_format_gen(fmt[0], fmtty);
          return /* Fmt_fmtty_EBB */[
                  /* Flush */Block.__(10, [match$24[0]]),
                  match$24[1]
                ];
      case 11 : 
          var match$25 = type_format_gen(fmt[1], fmtty);
          return /* Fmt_fmtty_EBB */[
                  /* String_literal */Block.__(11, [
                      fmt[0],
                      match$25[0]
                    ]),
                  match$25[1]
                ];
      case 12 : 
          var match$26 = type_format_gen(fmt[1], fmtty);
          return /* Fmt_fmtty_EBB */[
                  /* Char_literal */Block.__(12, [
                      fmt[0],
                      match$26[0]
                    ]),
                  match$26[1]
                ];
      case 13 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 8) {
            var sub_fmtty$prime = fmtty[0];
            if (Caml_obj.caml_notequal(/* Fmtty_EBB */[fmt[1]], /* Fmtty_EBB */[sub_fmtty$prime])) {
              throw Type_mismatch;
            }
            var match$27 = type_format_gen(fmt[2], fmtty[1]);
            return /* Fmt_fmtty_EBB */[
                    /* Format_arg */Block.__(13, [
                        fmt[0],
                        sub_fmtty$prime,
                        match$27[0]
                      ]),
                    match$27[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 14 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 9) {
            var sub_fmtty1 = fmtty[0];
            if (Caml_obj.caml_notequal(/* Fmtty_EBB */[CamlinternalFormatBasics.erase_rel(fmt[1])], /* Fmtty_EBB */[CamlinternalFormatBasics.erase_rel(sub_fmtty1)])) {
              throw Type_mismatch;
            }
            var match$28 = type_format_gen(fmt[2], CamlinternalFormatBasics.erase_rel(fmtty[2]));
            return /* Fmt_fmtty_EBB */[
                    /* Format_subst */Block.__(14, [
                        fmt[0],
                        sub_fmtty1,
                        match$28[0]
                      ]),
                    match$28[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 15 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 10) {
            var match$29 = type_format_gen(fmt[0], fmtty[0]);
            return /* Fmt_fmtty_EBB */[
                    /* Alpha */Block.__(15, [match$29[0]]),
                    match$29[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 16 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 11) {
            var match$30 = type_format_gen(fmt[0], fmtty[0]);
            return /* Fmt_fmtty_EBB */[
                    /* Theta */Block.__(16, [match$30[0]]),
                    match$30[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 17 : 
          var match$31 = type_format_gen(fmt[1], fmtty);
          return /* Fmt_fmtty_EBB */[
                  /* Formatting_lit */Block.__(17, [
                      fmt[0],
                      match$31[0]
                    ]),
                  match$31[1]
                ];
      case 18 : 
          var formatting_gen = fmt[0];
          var fmt0 = fmt[1];
          var fmtty0 = fmtty;
          if (formatting_gen.tag) {
            var match$32 = formatting_gen[0];
            var match$33 = type_format_gen(match$32[0], fmtty0);
            var match$34 = type_format_gen(fmt0, match$33[1]);
            return /* Fmt_fmtty_EBB */[
                    /* Formatting_gen */Block.__(18, [
                        /* Open_box */Block.__(1, [/* Format */[
                              match$33[0],
                              match$32[1]
                            ]]),
                        match$34[0]
                      ]),
                    match$34[1]
                  ];
          } else {
            var match$35 = formatting_gen[0];
            var match$36 = type_format_gen(match$35[0], fmtty0);
            var match$37 = type_format_gen(fmt0, match$36[1]);
            return /* Fmt_fmtty_EBB */[
                    /* Formatting_gen */Block.__(18, [
                        /* Open_tag */Block.__(0, [/* Format */[
                              match$36[0],
                              match$35[1]
                            ]]),
                        match$37[0]
                      ]),
                    match$37[1]
                  ];
          }
      case 19 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 13) {
            var match$38 = type_format_gen(fmt[0], fmtty[0]);
            return /* Fmt_fmtty_EBB */[
                    /* Reader */Block.__(19, [match$38[0]]),
                    match$38[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 20 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 1) {
            var match$39 = type_format_gen(fmt[2], fmtty[0]);
            return /* Fmt_fmtty_EBB */[
                    /* Scan_char_set */Block.__(20, [
                        fmt[0],
                        fmt[1],
                        match$39[0]
                      ]),
                    match$39[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 21 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 2) {
            var match$40 = type_format_gen(fmt[1], fmtty[0]);
            return /* Fmt_fmtty_EBB */[
                    /* Scan_get_counter */Block.__(21, [
                        fmt[0],
                        match$40[0]
                      ]),
                    match$40[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 23 : 
          var ign = fmt[0];
          var fmt$1 = fmt[1];
          var fmtty$1 = fmtty;
          if (typeof ign === "number") {
            if (ign === 3) {
              if (typeof fmtty$1 === "number") {
                throw Type_mismatch;
              } else if (fmtty$1.tag === 14) {
                var match$41 = type_format_gen(fmt$1, fmtty$1[0]);
                return /* Fmt_fmtty_EBB */[
                        /* Ignored_param */Block.__(23, [
                            /* Ignored_reader */3,
                            match$41[0]
                          ]),
                        match$41[1]
                      ];
              } else {
                throw Type_mismatch;
              }
            } else {
              return type_ignored_param_one(ign, fmt$1, fmtty$1);
            }
          } else {
            switch (ign.tag | 0) {
              case 7 : 
                  return type_ignored_param_one(/* Ignored_format_arg */Block.__(7, [
                                ign[0],
                                ign[1]
                              ]), fmt$1, fmtty$1);
              case 8 : 
                  var match$42 = type_ignored_format_substitution(ign[1], fmt$1, fmtty$1);
                  var match$43 = match$42[1];
                  return /* Fmt_fmtty_EBB */[
                          /* Ignored_param */Block.__(23, [
                              /* Ignored_format_subst */Block.__(8, [
                                  ign[0],
                                  match$42[0]
                                ]),
                              match$43[0]
                            ]),
                          match$43[1]
                        ];
              default:
                return type_ignored_param_one(ign, fmt$1, fmtty$1);
            }
          }
      case 22 : 
      case 24 : 
          throw Type_mismatch;
      
    }
  }
}

function type_ignored_format_substitution(sub_fmtty, fmt, fmtty) {
  if (typeof sub_fmtty === "number") {
    return /* Fmtty_fmt_EBB */[
            /* End_of_fmtty */0,
            type_format_gen(fmt, fmtty)
          ];
  } else {
    switch (sub_fmtty.tag | 0) {
      case 0 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag) {
            throw Type_mismatch;
          } else {
            var match = type_ignored_format_substitution(sub_fmtty[0], fmt, fmtty[0]);
            return /* Fmtty_fmt_EBB */[
                    /* Char_ty */Block.__(0, [match[0]]),
                    match[1]
                  ];
          }
      case 1 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 1) {
            var match$1 = type_ignored_format_substitution(sub_fmtty[0], fmt, fmtty[0]);
            return /* Fmtty_fmt_EBB */[
                    /* String_ty */Block.__(1, [match$1[0]]),
                    match$1[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 2 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 2) {
            var match$2 = type_ignored_format_substitution(sub_fmtty[0], fmt, fmtty[0]);
            return /* Fmtty_fmt_EBB */[
                    /* Int_ty */Block.__(2, [match$2[0]]),
                    match$2[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 3 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 3) {
            var match$3 = type_ignored_format_substitution(sub_fmtty[0], fmt, fmtty[0]);
            return /* Fmtty_fmt_EBB */[
                    /* Int32_ty */Block.__(3, [match$3[0]]),
                    match$3[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 4 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 4) {
            var match$4 = type_ignored_format_substitution(sub_fmtty[0], fmt, fmtty[0]);
            return /* Fmtty_fmt_EBB */[
                    /* Nativeint_ty */Block.__(4, [match$4[0]]),
                    match$4[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 5 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 5) {
            var match$5 = type_ignored_format_substitution(sub_fmtty[0], fmt, fmtty[0]);
            return /* Fmtty_fmt_EBB */[
                    /* Int64_ty */Block.__(5, [match$5[0]]),
                    match$5[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 6 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 6) {
            var match$6 = type_ignored_format_substitution(sub_fmtty[0], fmt, fmtty[0]);
            return /* Fmtty_fmt_EBB */[
                    /* Float_ty */Block.__(6, [match$6[0]]),
                    match$6[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 7 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 7) {
            var match$7 = type_ignored_format_substitution(sub_fmtty[0], fmt, fmtty[0]);
            return /* Fmtty_fmt_EBB */[
                    /* Bool_ty */Block.__(7, [match$7[0]]),
                    match$7[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 8 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 8) {
            var sub2_fmtty$prime = fmtty[0];
            if (Caml_obj.caml_notequal(/* Fmtty_EBB */[sub_fmtty[0]], /* Fmtty_EBB */[sub2_fmtty$prime])) {
              throw Type_mismatch;
            }
            var match$8 = type_ignored_format_substitution(sub_fmtty[1], fmt, fmtty[1]);
            return /* Fmtty_fmt_EBB */[
                    /* Format_arg_ty */Block.__(8, [
                        sub2_fmtty$prime,
                        match$8[0]
                      ]),
                    match$8[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 9 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 9) {
            var sub2_fmtty$prime$1 = fmtty[1];
            var sub1_fmtty$prime = fmtty[0];
            if (Caml_obj.caml_notequal(/* Fmtty_EBB */[CamlinternalFormatBasics.erase_rel(sub_fmtty[0])], /* Fmtty_EBB */[CamlinternalFormatBasics.erase_rel(sub1_fmtty$prime)])) {
              throw Type_mismatch;
            }
            if (Caml_obj.caml_notequal(/* Fmtty_EBB */[CamlinternalFormatBasics.erase_rel(sub_fmtty[1])], /* Fmtty_EBB */[CamlinternalFormatBasics.erase_rel(sub2_fmtty$prime$1)])) {
              throw Type_mismatch;
            }
            var sub_fmtty$prime = trans(symm(sub1_fmtty$prime), sub2_fmtty$prime$1);
            var match$9 = fmtty_rel_det(sub_fmtty$prime);
            Curry._1(match$9[1], /* Refl */0);
            Curry._1(match$9[3], /* Refl */0);
            var match$10 = type_ignored_format_substitution(CamlinternalFormatBasics.erase_rel(sub_fmtty[2]), fmt, fmtty[2]);
            return /* Fmtty_fmt_EBB */[
                    /* Format_subst_ty */Block.__(9, [
                        sub1_fmtty$prime,
                        sub2_fmtty$prime$1,
                        symm(match$10[0])
                      ]),
                    match$10[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 10 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 10) {
            var match$11 = type_ignored_format_substitution(sub_fmtty[0], fmt, fmtty[0]);
            return /* Fmtty_fmt_EBB */[
                    /* Alpha_ty */Block.__(10, [match$11[0]]),
                    match$11[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 11 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 11) {
            var match$12 = type_ignored_format_substitution(sub_fmtty[0], fmt, fmtty[0]);
            return /* Fmtty_fmt_EBB */[
                    /* Theta_ty */Block.__(11, [match$12[0]]),
                    match$12[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 12 : 
          throw Type_mismatch;
      case 13 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 13) {
            var match$13 = type_ignored_format_substitution(sub_fmtty[0], fmt, fmtty[0]);
            return /* Fmtty_fmt_EBB */[
                    /* Reader_ty */Block.__(13, [match$13[0]]),
                    match$13[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      case 14 : 
          if (typeof fmtty === "number") {
            throw Type_mismatch;
          } else if (fmtty.tag === 14) {
            var match$14 = type_ignored_format_substitution(sub_fmtty[0], fmt, fmtty[0]);
            return /* Fmtty_fmt_EBB */[
                    /* Ignored_reader_ty */Block.__(14, [match$14[0]]),
                    match$14[1]
                  ];
          } else {
            throw Type_mismatch;
          }
      
    }
  }
}

function type_format(fmt, fmtty) {
  var match = type_format_gen(fmt, fmtty);
  if (typeof match[1] === "number") {
    return match[0];
  } else {
    throw Type_mismatch;
  }
}

function recast(fmt, fmtty) {
  return type_format(fmt, CamlinternalFormatBasics.erase_rel(symm(fmtty)));
}

function fix_padding(padty, width, str) {
  var len = str.length;
  var width$1 = Pervasives.abs(width);
  var padty$1 = width < 0 ? /* Left */0 : padty;
  if (width$1 <= len) {
    return str;
  } else {
    var res = Bytes.make(width$1, padty$1 === /* Zeros */2 ? /* "0" */48 : /* " " */32);
    switch (padty$1) {
      case 0 : 
          $$String.blit(str, 0, res, 0, len);
          break;
      case 1 : 
          $$String.blit(str, 0, res, width$1 - len | 0, len);
          break;
      case 2 : 
          if (len > 0 && (Caml_string.get(str, 0) === /* "+" */43 || Caml_string.get(str, 0) === /* "-" */45 || Caml_string.get(str, 0) === /* " " */32)) {
            res[0] = Caml_string.get(str, 0);
            $$String.blit(str, 1, res, (width$1 - len | 0) + 1 | 0, len - 1 | 0);
          } else if (len > 1 && Caml_string.get(str, 0) === /* "0" */48 && (Caml_string.get(str, 1) === /* "x" */120 || Caml_string.get(str, 1) === /* "X" */88)) {
            res[1] = Caml_string.get(str, 1);
            $$String.blit(str, 2, res, (width$1 - len | 0) + 2 | 0, len - 2 | 0);
          } else {
            $$String.blit(str, 0, res, width$1 - len | 0, len);
          }
          break;
      
    }
    return Caml_string.bytes_to_string(res);
  }
}

function fix_int_precision(prec, str) {
  var prec$1 = Pervasives.abs(prec);
  var len = str.length;
  var c = Caml_string.get(str, 0);
  var exit = 0;
  if (c >= 58) {
    if (c >= 71) {
      if (c > 102 || c < 97) {
        return str;
      } else {
        exit = 2;
      }
    } else if (c >= 65) {
      exit = 2;
    } else {
      return str;
    }
  } else if (c !== 32) {
    if (c >= 43) {
      switch (c - 43 | 0) {
        case 0 : 
        case 2 : 
            exit = 1;
            break;
        case 1 : 
        case 3 : 
        case 4 : 
            return str;
        case 5 : 
            if ((prec$1 + 2 | 0) > len && len > 1 && (Caml_string.get(str, 1) === /* "x" */120 || Caml_string.get(str, 1) === /* "X" */88)) {
              var res = Bytes.make(prec$1 + 2 | 0, /* "0" */48);
              res[1] = Caml_string.get(str, 1);
              $$String.blit(str, 2, res, (prec$1 - len | 0) + 4 | 0, len - 2 | 0);
              return Caml_string.bytes_to_string(res);
            } else {
              exit = 2;
            }
            break;
        case 6 : 
        case 7 : 
        case 8 : 
        case 9 : 
        case 10 : 
        case 11 : 
        case 12 : 
        case 13 : 
        case 14 : 
            exit = 2;
            break;
        
      }
    } else {
      return str;
    }
  } else {
    exit = 1;
  }
  switch (exit) {
    case 1 : 
        if ((prec$1 + 1 | 0) > len) {
          var res$1 = Bytes.make(prec$1 + 1 | 0, /* "0" */48);
          res$1[0] = c;
          $$String.blit(str, 1, res$1, (prec$1 - len | 0) + 2 | 0, len - 1 | 0);
          return Caml_string.bytes_to_string(res$1);
        } else {
          return str;
        }
    case 2 : 
        if (prec$1 > len) {
          var res$2 = Bytes.make(prec$1, /* "0" */48);
          $$String.blit(str, 0, res$2, prec$1 - len | 0, len);
          return Caml_string.bytes_to_string(res$2);
        } else {
          return str;
        }
    
  }
}

function string_to_caml_string(str) {
  return $$String.concat($$String.escaped(str), /* :: */[
              "\"",
              /* :: */[
                "\"",
                /* [] */0
              ]
            ]);
}

function format_of_iconv(iconv) {
  switch (iconv) {
    case 0 : 
        return "%d";
    case 1 : 
        return "%+d";
    case 2 : 
        return "% d";
    case 3 : 
        return "%i";
    case 4 : 
        return "%+i";
    case 5 : 
        return "% i";
    case 6 : 
        return "%x";
    case 7 : 
        return "%#x";
    case 8 : 
        return "%X";
    case 9 : 
        return "%#X";
    case 10 : 
        return "%o";
    case 11 : 
        return "%#o";
    case 12 : 
        return "%u";
    
  }
}

function format_of_aconv(iconv, c) {
  var seps;
  switch (iconv) {
    case 0 : 
        seps = /* :: */[
          "%",
          /* :: */[
            "d",
            /* [] */0
          ]
        ];
        break;
    case 1 : 
        seps = /* :: */[
          "%+",
          /* :: */[
            "d",
            /* [] */0
          ]
        ];
        break;
    case 2 : 
        seps = /* :: */[
          "% ",
          /* :: */[
            "d",
            /* [] */0
          ]
        ];
        break;
    case 3 : 
        seps = /* :: */[
          "%",
          /* :: */[
            "i",
            /* [] */0
          ]
        ];
        break;
    case 4 : 
        seps = /* :: */[
          "%+",
          /* :: */[
            "i",
            /* [] */0
          ]
        ];
        break;
    case 5 : 
        seps = /* :: */[
          "% ",
          /* :: */[
            "i",
            /* [] */0
          ]
        ];
        break;
    case 6 : 
        seps = /* :: */[
          "%",
          /* :: */[
            "x",
            /* [] */0
          ]
        ];
        break;
    case 7 : 
        seps = /* :: */[
          "%#",
          /* :: */[
            "x",
            /* [] */0
          ]
        ];
        break;
    case 8 : 
        seps = /* :: */[
          "%",
          /* :: */[
            "X",
            /* [] */0
          ]
        ];
        break;
    case 9 : 
        seps = /* :: */[
          "%#",
          /* :: */[
            "X",
            /* [] */0
          ]
        ];
        break;
    case 10 : 
        seps = /* :: */[
          "%",
          /* :: */[
            "o",
            /* [] */0
          ]
        ];
        break;
    case 11 : 
        seps = /* :: */[
          "%#",
          /* :: */[
            "o",
            /* [] */0
          ]
        ];
        break;
    case 12 : 
        seps = /* :: */[
          "%",
          /* :: */[
            "u",
            /* [] */0
          ]
        ];
        break;
    
  }
  return $$String.concat(Caml_string.bytes_to_string(Bytes.make(1, c)), seps);
}

function format_of_fconv(fconv, prec) {
  if (fconv === /* Float_F */15) {
    return "%.12g";
  } else {
    var prec$1 = Pervasives.abs(prec);
    var symb = char_of_fconv(fconv);
    var buf = /* record */[
      /* ind */0,
      /* bytes */Caml_string.caml_create_string(16)
    ];
    buffer_add_char(buf, /* "%" */37);
    bprint_fconv_flag(buf, fconv);
    buffer_add_char(buf, /* "." */46);
    buffer_add_string(buf, String(prec$1));
    buffer_add_char(buf, symb);
    return buffer_contents(buf);
  }
}

function convert_int(iconv, n) {
  return Caml_format.caml_format_int(format_of_iconv(iconv), n);
}

function convert_int32(iconv, n) {
  return Caml_format.caml_int32_format(format_of_aconv(iconv, /* "l" */108), n);
}

function convert_nativeint(iconv, n) {
  return Caml_format.caml_nativeint_format(format_of_aconv(iconv, /* "n" */110), n);
}

function convert_int64(iconv, n) {
  return Caml_format.caml_int64_format(format_of_aconv(iconv, /* "L" */76), n);
}

function convert_float(fconv, prec, x) {
  var prec$1 = Pervasives.abs(prec);
  var str = Caml_format.caml_format_float(format_of_fconv(fconv, prec$1), x);
  if (fconv !== /* Float_F */15) {
    return str;
  } else {
    var len = str.length;
    var is_valid = function (_i) {
      while(true) {
        var i = _i;
        if (i === len) {
          return /* false */0;
        } else {
          var match = Caml_string.get(str, i);
          var switcher = match - 46 | 0;
          if (switcher > 23 || switcher < 0) {
            if (switcher !== 55) {
              _i = i + 1 | 0;
              continue ;
              
            } else {
              return /* true */1;
            }
          } else if (switcher > 22 || switcher < 1) {
            return /* true */1;
          } else {
            _i = i + 1 | 0;
            continue ;
            
          }
        }
      };
    };
    var match = Caml_float.caml_classify_float(x);
    if (match !== 3) {
      if (match >= 4) {
        return "nan";
      } else if (is_valid(0)) {
        return str;
      } else {
        return str + ".";
      }
    } else if (x < 0.0) {
      return "neg_infinity";
    } else {
      return "infinity";
    }
  }
}

function format_caml_char(c) {
  return $$String.concat(Char.escaped(c), /* :: */[
              "'",
              /* :: */[
                "'",
                /* [] */0
              ]
            ]);
}

function string_of_fmtty(fmtty) {
  var buf = /* record */[
    /* ind */0,
    /* bytes */Caml_string.caml_create_string(16)
  ];
  bprint_fmtty(buf, fmtty);
  return buffer_contents(buf);
}

function make_printf(_k, o, _acc, _fmt) {
  while(true) {
    var fmt = _fmt;
    var acc = _acc;
    var k = _k;
    if (typeof fmt === "number") {
      return Curry._2(k, o, acc);
    } else {
      switch (fmt.tag | 0) {
        case 0 : 
            var rest = fmt[0];
            return (function(k,acc,rest){
            return function (c) {
              var new_acc = /* Acc_data_char */Block.__(5, [
                  acc,
                  c
                ]);
              return make_printf(k, o, new_acc, rest);
            }
            }(k,acc,rest));
        case 1 : 
            var rest$1 = fmt[0];
            return (function(k,acc,rest$1){
            return function (c) {
              var new_acc_001 = format_caml_char(c);
              var new_acc = /* Acc_data_string */Block.__(4, [
                  acc,
                  new_acc_001
                ]);
              return make_printf(k, o, new_acc, rest$1);
            }
            }(k,acc,rest$1));
        case 2 : 
            return make_string_padding(k, o, acc, fmt[1], fmt[0], (function (str) {
                          return str;
                        }));
        case 3 : 
            return make_string_padding(k, o, acc, fmt[1], fmt[0], string_to_caml_string);
        case 4 : 
            return make_int_padding_precision(k, o, acc, fmt[3], fmt[1], fmt[2], convert_int, fmt[0]);
        case 5 : 
            return make_int_padding_precision(k, o, acc, fmt[3], fmt[1], fmt[2], convert_int32, fmt[0]);
        case 6 : 
            return make_int_padding_precision(k, o, acc, fmt[3], fmt[1], fmt[2], convert_nativeint, fmt[0]);
        case 7 : 
            return make_int_padding_precision(k, o, acc, fmt[3], fmt[1], fmt[2], convert_int64, fmt[0]);
        case 8 : 
            var k$1 = k;
            var o$1 = o;
            var acc$1 = acc;
            var fmt$1 = fmt[3];
            var pad = fmt[1];
            var prec = fmt[2];
            var fconv = fmt[0];
            if (typeof pad === "number") {
              if (typeof prec === "number") {
                if (prec !== 0) {
                  return (function(k$1,o$1,acc$1,fmt$1,fconv){
                  return function (p, x) {
                    var str = convert_float(fconv, p, x);
                    return make_printf(k$1, o$1, /* Acc_data_string */Block.__(4, [
                                  acc$1,
                                  str
                                ]), fmt$1);
                  }
                  }(k$1,o$1,acc$1,fmt$1,fconv));
                } else {
                  return (function(k$1,o$1,acc$1,fmt$1,fconv){
                  return function (x) {
                    var str = convert_float(fconv, 6, x);
                    return make_printf(k$1, o$1, /* Acc_data_string */Block.__(4, [
                                  acc$1,
                                  str
                                ]), fmt$1);
                  }
                  }(k$1,o$1,acc$1,fmt$1,fconv));
                }
              } else {
                var p = prec[0];
                return (function(k$1,o$1,acc$1,fmt$1,fconv,p){
                return function (x) {
                  var str = convert_float(fconv, p, x);
                  return make_printf(k$1, o$1, /* Acc_data_string */Block.__(4, [
                                acc$1,
                                str
                              ]), fmt$1);
                }
                }(k$1,o$1,acc$1,fmt$1,fconv,p));
              }
            } else if (pad.tag) {
              var padty = pad[0];
              if (typeof prec === "number") {
                if (prec !== 0) {
                  return (function(k$1,o$1,acc$1,fmt$1,fconv,padty){
                  return function (w, p, x) {
                    var str = fix_padding(padty, w, convert_float(fconv, p, x));
                    return make_printf(k$1, o$1, /* Acc_data_string */Block.__(4, [
                                  acc$1,
                                  str
                                ]), fmt$1);
                  }
                  }(k$1,o$1,acc$1,fmt$1,fconv,padty));
                } else {
                  return (function(k$1,o$1,acc$1,fmt$1,fconv,padty){
                  return function (w, x) {
                    var str = convert_float(fconv, 6, x);
                    var str$prime = fix_padding(padty, w, str);
                    return make_printf(k$1, o$1, /* Acc_data_string */Block.__(4, [
                                  acc$1,
                                  str$prime
                                ]), fmt$1);
                  }
                  }(k$1,o$1,acc$1,fmt$1,fconv,padty));
                }
              } else {
                var p$1 = prec[0];
                return (function(k$1,o$1,acc$1,fmt$1,fconv,padty,p$1){
                return function (w, x) {
                  var str = fix_padding(padty, w, convert_float(fconv, p$1, x));
                  return make_printf(k$1, o$1, /* Acc_data_string */Block.__(4, [
                                acc$1,
                                str
                              ]), fmt$1);
                }
                }(k$1,o$1,acc$1,fmt$1,fconv,padty,p$1));
              }
            } else {
              var w = pad[1];
              var padty$1 = pad[0];
              if (typeof prec === "number") {
                if (prec !== 0) {
                  return (function(k$1,o$1,acc$1,fmt$1,fconv,padty$1,w){
                  return function (p, x) {
                    var str = fix_padding(padty$1, w, convert_float(fconv, p, x));
                    return make_printf(k$1, o$1, /* Acc_data_string */Block.__(4, [
                                  acc$1,
                                  str
                                ]), fmt$1);
                  }
                  }(k$1,o$1,acc$1,fmt$1,fconv,padty$1,w));
                } else {
                  return (function(k$1,o$1,acc$1,fmt$1,fconv,padty$1,w){
                  return function (x) {
                    var str = convert_float(fconv, 6, x);
                    var str$prime = fix_padding(padty$1, w, str);
                    return make_printf(k$1, o$1, /* Acc_data_string */Block.__(4, [
                                  acc$1,
                                  str$prime
                                ]), fmt$1);
                  }
                  }(k$1,o$1,acc$1,fmt$1,fconv,padty$1,w));
                }
              } else {
                var p$2 = prec[0];
                return (function(k$1,o$1,acc$1,fmt$1,fconv,padty$1,w,p$2){
                return function (x) {
                  var str = fix_padding(padty$1, w, convert_float(fconv, p$2, x));
                  return make_printf(k$1, o$1, /* Acc_data_string */Block.__(4, [
                                acc$1,
                                str
                              ]), fmt$1);
                }
                }(k$1,o$1,acc$1,fmt$1,fconv,padty$1,w,p$2));
              }
            }
        case 9 : 
            var rest$2 = fmt[0];
            return (function(k,acc,rest$2){
            return function (b) {
              return make_printf(k, o, /* Acc_data_string */Block.__(4, [
                            acc,
                            b ? "true" : "false"
                          ]), rest$2);
            }
            }(k,acc,rest$2));
        case 10 : 
            _fmt = fmt[0];
            _acc = /* Acc_flush */Block.__(7, [acc]);
            continue ;
            case 11 : 
            _fmt = fmt[1];
            _acc = /* Acc_string_literal */Block.__(2, [
                acc,
                fmt[0]
              ]);
            continue ;
            case 12 : 
            _fmt = fmt[1];
            _acc = /* Acc_char_literal */Block.__(3, [
                acc,
                fmt[0]
              ]);
            continue ;
            case 13 : 
            var rest$3 = fmt[2];
            var ty = string_of_fmtty(fmt[1]);
            return (function(k,acc,rest$3,ty){
            return function () {
              return make_printf(k, o, /* Acc_data_string */Block.__(4, [
                            acc,
                            ty
                          ]), rest$3);
            }
            }(k,acc,rest$3,ty));
        case 14 : 
            var rest$4 = fmt[2];
            var fmtty = fmt[1];
            return (function(k,acc,fmtty,rest$4){
            return function (param) {
              return make_printf(k, o, acc, CamlinternalFormatBasics.concat_fmt(recast(param[0], fmtty), rest$4));
            }
            }(k,acc,fmtty,rest$4));
        case 15 : 
            var rest$5 = fmt[0];
            return (function(k,acc,rest$5){
            return function (f, x) {
              return make_printf(k, o, /* Acc_delay */Block.__(6, [
                            acc,
                            (function (o) {
                                return Curry._2(f, o, x);
                              })
                          ]), rest$5);
            }
            }(k,acc,rest$5));
        case 16 : 
            var rest$6 = fmt[0];
            return (function(k,acc,rest$6){
            return function (f) {
              return make_printf(k, o, /* Acc_delay */Block.__(6, [
                            acc,
                            f
                          ]), rest$6);
            }
            }(k,acc,rest$6));
        case 17 : 
            _fmt = fmt[1];
            _acc = /* Acc_formatting_lit */Block.__(0, [
                acc,
                fmt[0]
              ]);
            continue ;
            case 18 : 
            var match = fmt[0];
            if (match.tag) {
              var rest$7 = fmt[1];
              var k$prime = (function(k,acc,rest$7){
              return function k$prime(koc, kacc) {
                return make_printf(k, koc, /* Acc_formatting_gen */Block.__(1, [
                              acc,
                              /* Acc_open_box */Block.__(1, [kacc])
                            ]), rest$7);
              }
              }(k,acc,rest$7));
              _fmt = match[0][0];
              _acc = /* End_of_acc */0;
              _k = k$prime;
              continue ;
              
            } else {
              var rest$8 = fmt[1];
              var k$prime$1 = (function(k,acc,rest$8){
              return function k$prime$1(koc, kacc) {
                return make_printf(k, koc, /* Acc_formatting_gen */Block.__(1, [
                              acc,
                              /* Acc_open_tag */Block.__(0, [kacc])
                            ]), rest$8);
              }
              }(k,acc,rest$8));
              _fmt = match[0][0];
              _acc = /* End_of_acc */0;
              _k = k$prime$1;
              continue ;
              
            }
        case 19 : 
            throw [
                  Caml_builtin_exceptions.assert_failure,
                  [
                    "camlinternalFormat.ml",
                    1449,
                    4
                  ]
                ];
        case 20 : 
            var rest$9 = fmt[2];
            var new_acc = /* Acc_invalid_arg */Block.__(8, [
                acc,
                "Printf: bad conversion %["
              ]);
            return (function(k,rest$9,new_acc){
            return function () {
              return make_printf(k, o, new_acc, rest$9);
            }
            }(k,rest$9,new_acc));
        case 21 : 
            var rest$10 = fmt[1];
            return (function(k,acc,rest$10){
            return function (n) {
              var new_acc_001 = Caml_format.caml_format_int("%u", n);
              var new_acc = /* Acc_data_string */Block.__(4, [
                  acc,
                  new_acc_001
                ]);
              return make_printf(k, o, new_acc, rest$10);
            }
            }(k,acc,rest$10));
        case 22 : 
            var rest$11 = fmt[0];
            return (function(k,acc,rest$11){
            return function (c) {
              var new_acc = /* Acc_data_char */Block.__(5, [
                  acc,
                  c
                ]);
              return make_printf(k, o, new_acc, rest$11);
            }
            }(k,acc,rest$11));
        case 23 : 
            var k$2 = k;
            var o$2 = o;
            var acc$2 = acc;
            var ign = fmt[0];
            var fmt$2 = fmt[1];
            if (typeof ign === "number") {
              if (ign === 3) {
                throw [
                      Caml_builtin_exceptions.assert_failure,
                      [
                        "camlinternalFormat.ml",
                        1517,
                        39
                      ]
                    ];
              } else {
                return make_invalid_arg(k$2, o$2, acc$2, fmt$2);
              }
            } else if (ign.tag === 8) {
              return make_from_fmtty(k$2, o$2, acc$2, ign[1], fmt$2);
            } else {
              return make_invalid_arg(k$2, o$2, acc$2, fmt$2);
            }
        case 24 : 
            return make_custom(k, o, acc, fmt[2], fmt[0], Curry._1(fmt[1], /* () */0));
        
      }
    }
  };
}

function make_from_fmtty(k, o, acc, fmtty, fmt) {
  if (typeof fmtty === "number") {
    return make_invalid_arg(k, o, acc, fmt);
  } else {
    switch (fmtty.tag | 0) {
      case 0 : 
          var rest = fmtty[0];
          return (function () {
              return make_from_fmtty(k, o, acc, rest, fmt);
            });
      case 1 : 
          var rest$1 = fmtty[0];
          return (function () {
              return make_from_fmtty(k, o, acc, rest$1, fmt);
            });
      case 2 : 
          var rest$2 = fmtty[0];
          return (function () {
              return make_from_fmtty(k, o, acc, rest$2, fmt);
            });
      case 3 : 
          var rest$3 = fmtty[0];
          return (function () {
              return make_from_fmtty(k, o, acc, rest$3, fmt);
            });
      case 4 : 
          var rest$4 = fmtty[0];
          return (function () {
              return make_from_fmtty(k, o, acc, rest$4, fmt);
            });
      case 5 : 
          var rest$5 = fmtty[0];
          return (function () {
              return make_from_fmtty(k, o, acc, rest$5, fmt);
            });
      case 6 : 
          var rest$6 = fmtty[0];
          return (function () {
              return make_from_fmtty(k, o, acc, rest$6, fmt);
            });
      case 7 : 
          var rest$7 = fmtty[0];
          return (function () {
              return make_from_fmtty(k, o, acc, rest$7, fmt);
            });
      case 8 : 
          var rest$8 = fmtty[1];
          return (function () {
              return make_from_fmtty(k, o, acc, rest$8, fmt);
            });
      case 9 : 
          var rest$9 = fmtty[2];
          var ty = trans(symm(fmtty[0]), fmtty[1]);
          return (function () {
              return make_from_fmtty(k, o, acc, CamlinternalFormatBasics.concat_fmtty(ty, rest$9), fmt);
            });
      case 10 : 
          var rest$10 = fmtty[0];
          return (function (_, _$1) {
              return make_from_fmtty(k, o, acc, rest$10, fmt);
            });
      case 11 : 
          var rest$11 = fmtty[0];
          return (function () {
              return make_from_fmtty(k, o, acc, rest$11, fmt);
            });
      case 12 : 
          var rest$12 = fmtty[0];
          return (function () {
              return make_from_fmtty(k, o, acc, rest$12, fmt);
            });
      case 13 : 
          throw [
                Caml_builtin_exceptions.assert_failure,
                [
                  "camlinternalFormat.ml",
                  1540,
                  31
                ]
              ];
      case 14 : 
          throw [
                Caml_builtin_exceptions.assert_failure,
                [
                  "camlinternalFormat.ml",
                  1541,
                  31
                ]
              ];
      
    }
  }
}

function make_invalid_arg(k, o, acc, fmt) {
  return make_printf(k, o, /* Acc_invalid_arg */Block.__(8, [
                acc,
                "Printf: bad conversion %_"
              ]), fmt);
}

function make_string_padding(k, o, acc, fmt, pad, trans) {
  if (typeof pad === "number") {
    return (function (x) {
        var new_acc_001 = Curry._1(trans, x);
        var new_acc = /* Acc_data_string */Block.__(4, [
            acc,
            new_acc_001
          ]);
        return make_printf(k, o, new_acc, fmt);
      });
  } else if (pad.tag) {
    var padty = pad[0];
    return (function (w, x) {
        var new_acc_001 = fix_padding(padty, w, Curry._1(trans, x));
        var new_acc = /* Acc_data_string */Block.__(4, [
            acc,
            new_acc_001
          ]);
        return make_printf(k, o, new_acc, fmt);
      });
  } else {
    var width = pad[1];
    var padty$1 = pad[0];
    return (function (x) {
        var new_acc_001 = fix_padding(padty$1, width, Curry._1(trans, x));
        var new_acc = /* Acc_data_string */Block.__(4, [
            acc,
            new_acc_001
          ]);
        return make_printf(k, o, new_acc, fmt);
      });
  }
}

function make_int_padding_precision(k, o, acc, fmt, pad, prec, trans, iconv) {
  if (typeof pad === "number") {
    if (typeof prec === "number") {
      if (prec !== 0) {
        return (function (p, x) {
            var str = fix_int_precision(p, Curry._2(trans, iconv, x));
            return make_printf(k, o, /* Acc_data_string */Block.__(4, [
                          acc,
                          str
                        ]), fmt);
          });
      } else {
        return (function (x) {
            var str = Curry._2(trans, iconv, x);
            return make_printf(k, o, /* Acc_data_string */Block.__(4, [
                          acc,
                          str
                        ]), fmt);
          });
      }
    } else {
      var p = prec[0];
      return (function (x) {
          var str = fix_int_precision(p, Curry._2(trans, iconv, x));
          return make_printf(k, o, /* Acc_data_string */Block.__(4, [
                        acc,
                        str
                      ]), fmt);
        });
    }
  } else if (pad.tag) {
    var padty = pad[0];
    if (typeof prec === "number") {
      if (prec !== 0) {
        return (function (w, p, x) {
            var str = fix_padding(padty, w, fix_int_precision(p, Curry._2(trans, iconv, x)));
            return make_printf(k, o, /* Acc_data_string */Block.__(4, [
                          acc,
                          str
                        ]), fmt);
          });
      } else {
        return (function (w, x) {
            var str = fix_padding(padty, w, Curry._2(trans, iconv, x));
            return make_printf(k, o, /* Acc_data_string */Block.__(4, [
                          acc,
                          str
                        ]), fmt);
          });
      }
    } else {
      var p$1 = prec[0];
      return (function (w, x) {
          var str = fix_padding(padty, w, fix_int_precision(p$1, Curry._2(trans, iconv, x)));
          return make_printf(k, o, /* Acc_data_string */Block.__(4, [
                        acc,
                        str
                      ]), fmt);
        });
    }
  } else {
    var w = pad[1];
    var padty$1 = pad[0];
    if (typeof prec === "number") {
      if (prec !== 0) {
        return (function (p, x) {
            var str = fix_padding(padty$1, w, fix_int_precision(p, Curry._2(trans, iconv, x)));
            return make_printf(k, o, /* Acc_data_string */Block.__(4, [
                          acc,
                          str
                        ]), fmt);
          });
      } else {
        return (function (x) {
            var str = fix_padding(padty$1, w, Curry._2(trans, iconv, x));
            return make_printf(k, o, /* Acc_data_string */Block.__(4, [
                          acc,
                          str
                        ]), fmt);
          });
      }
    } else {
      var p$2 = prec[0];
      return (function (x) {
          var str = fix_padding(padty$1, w, fix_int_precision(p$2, Curry._2(trans, iconv, x)));
          return make_printf(k, o, /* Acc_data_string */Block.__(4, [
                        acc,
                        str
                      ]), fmt);
        });
    }
  }
}

function make_custom(k, o, acc, rest, arity, f) {
  if (arity) {
    var arity$1 = arity[0];
    return (function (x) {
        return make_custom(k, o, acc, rest, arity$1, Curry._1(f, x));
      });
  } else {
    return make_printf(k, o, /* Acc_data_string */Block.__(4, [
                  acc,
                  f
                ]), rest);
  }
}

function output_acc(o, _acc) {
  while(true) {
    var acc = _acc;
    var exit = 0;
    if (typeof acc === "number") {
      return /* () */0;
    } else {
      switch (acc.tag | 0) {
        case 0 : 
            var s = string_of_formatting_lit(acc[1]);
            output_acc(o, acc[0]);
            return Pervasives.output_string(o, s);
        case 1 : 
            var match = acc[1];
            var p = acc[0];
            output_acc(o, p);
            if (match.tag) {
              Pervasives.output_string(o, "@[");
              _acc = match[0];
              continue ;
              
            } else {
              Pervasives.output_string(o, "@{");
              _acc = match[0];
              continue ;
              
            }
        case 2 : 
        case 4 : 
            exit = 1;
            break;
        case 3 : 
        case 5 : 
            exit = 2;
            break;
        case 6 : 
            output_acc(o, acc[0]);
            return Curry._1(acc[1], o);
        case 7 : 
            output_acc(o, acc[0]);
            return Caml_io.caml_ml_flush(o);
        case 8 : 
            output_acc(o, acc[0]);
            throw [
                  Caml_builtin_exceptions.invalid_argument,
                  acc[1]
                ];
        
      }
    }
    switch (exit) {
      case 1 : 
          output_acc(o, acc[0]);
          return Pervasives.output_string(o, acc[1]);
      case 2 : 
          output_acc(o, acc[0]);
          return Caml_io.caml_ml_output_char(o, acc[1]);
      
    }
  };
}

function bufput_acc(b, _acc) {
  while(true) {
    var acc = _acc;
    var exit = 0;
    if (typeof acc === "number") {
      return /* () */0;
    } else {
      switch (acc.tag | 0) {
        case 0 : 
            var s = string_of_formatting_lit(acc[1]);
            bufput_acc(b, acc[0]);
            return Buffer.add_string(b, s);
        case 1 : 
            var match = acc[1];
            var p = acc[0];
            bufput_acc(b, p);
            if (match.tag) {
              Buffer.add_string(b, "@[");
              _acc = match[0];
              continue ;
              
            } else {
              Buffer.add_string(b, "@{");
              _acc = match[0];
              continue ;
              
            }
        case 2 : 
        case 4 : 
            exit = 1;
            break;
        case 3 : 
        case 5 : 
            exit = 2;
            break;
        case 6 : 
            bufput_acc(b, acc[0]);
            return Curry._1(acc[1], b);
        case 7 : 
            _acc = acc[0];
            continue ;
            case 8 : 
            bufput_acc(b, acc[0]);
            throw [
                  Caml_builtin_exceptions.invalid_argument,
                  acc[1]
                ];
        
      }
    }
    switch (exit) {
      case 1 : 
          bufput_acc(b, acc[0]);
          return Buffer.add_string(b, acc[1]);
      case 2 : 
          bufput_acc(b, acc[0]);
          return Buffer.add_char(b, acc[1]);
      
    }
  };
}

function strput_acc(b, _acc) {
  while(true) {
    var acc = _acc;
    var exit = 0;
    if (typeof acc === "number") {
      return /* () */0;
    } else {
      switch (acc.tag | 0) {
        case 0 : 
            var s = string_of_formatting_lit(acc[1]);
            strput_acc(b, acc[0]);
            return Buffer.add_string(b, s);
        case 1 : 
            var match = acc[1];
            var p = acc[0];
            strput_acc(b, p);
            if (match.tag) {
              Buffer.add_string(b, "@[");
              _acc = match[0];
              continue ;
              
            } else {
              Buffer.add_string(b, "@{");
              _acc = match[0];
              continue ;
              
            }
        case 2 : 
        case 4 : 
            exit = 1;
            break;
        case 3 : 
        case 5 : 
            exit = 2;
            break;
        case 6 : 
            strput_acc(b, acc[0]);
            return Buffer.add_string(b, Curry._1(acc[1], /* () */0));
        case 7 : 
            _acc = acc[0];
            continue ;
            case 8 : 
            strput_acc(b, acc[0]);
            throw [
                  Caml_builtin_exceptions.invalid_argument,
                  acc[1]
                ];
        
      }
    }
    switch (exit) {
      case 1 : 
          strput_acc(b, acc[0]);
          return Buffer.add_string(b, acc[1]);
      case 2 : 
          strput_acc(b, acc[0]);
          return Buffer.add_char(b, acc[1]);
      
    }
  };
}

function failwith_message(param) {
  var buf = Buffer.create(256);
  var k = function (_, acc) {
    strput_acc(buf, acc);
    var s = Buffer.contents(buf);
    throw [
          Caml_builtin_exceptions.failure,
          s
        ];
  };
  return make_printf(k, /* () */0, /* End_of_acc */0, param[0]);
}

function open_box_of_string(str) {
  if (str === "") {
    return /* tuple */[
            0,
            /* Pp_box */4
          ];
  } else {
    var len = str.length;
    var invalid_box = function () {
      return Curry._1(failwith_message(/* Format */[
                      /* String_literal */Block.__(11, [
                          "invalid box description ",
                          /* Caml_string */Block.__(3, [
                              /* No_padding */0,
                              /* End_of_format */0
                            ])
                        ]),
                      "invalid box description %S"
                    ]), str);
    };
    var parse_spaces = function (_i) {
      while(true) {
        var i = _i;
        if (i === len) {
          return i;
        } else {
          var match = Caml_string.get(str, i);
          if (match !== 9) {
            if (match !== 32) {
              return i;
            } else {
              _i = i + 1 | 0;
              continue ;
              
            }
          } else {
            _i = i + 1 | 0;
            continue ;
            
          }
        }
      };
    };
    var parse_lword = function (_, _j) {
      while(true) {
        var j = _j;
        if (j === len) {
          return j;
        } else {
          var match = Caml_string.get(str, j);
          if (match > 122 || match < 97) {
            return j;
          } else {
            _j = j + 1 | 0;
            continue ;
            
          }
        }
      };
    };
    var parse_int = function (_, _j) {
      while(true) {
        var j = _j;
        if (j === len) {
          return j;
        } else {
          var match = Caml_string.get(str, j);
          if (match >= 48) {
            if (match >= 58) {
              return j;
            } else {
              _j = j + 1 | 0;
              continue ;
              
            }
          } else if (match !== 45) {
            return j;
          } else {
            _j = j + 1 | 0;
            continue ;
            
          }
        }
      };
    };
    var wstart = parse_spaces(0);
    var wend = parse_lword(wstart, wstart);
    var box_name = $$String.sub(str, wstart, wend - wstart | 0);
    var nstart = parse_spaces(wend);
    var nend = parse_int(nstart, nstart);
    var indent;
    if (nstart === nend) {
      indent = 0;
    } else {
      try {
        indent = Caml_format.caml_int_of_string($$String.sub(str, nstart, nend - nstart | 0));
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === Caml_builtin_exceptions.failure) {
          indent = invalid_box(/* () */0);
        } else {
          throw exn;
        }
      }
    }
    var exp_end = parse_spaces(nend);
    if (exp_end !== len) {
      invalid_box(/* () */0);
    }
    var box_type;
    switch (box_name) {
      case "" : 
      case "b" : 
          box_type = /* Pp_box */4;
          break;
      case "h" : 
          box_type = /* Pp_hbox */0;
          break;
      case "hov" : 
          box_type = /* Pp_hovbox */3;
          break;
      case "hv" : 
          box_type = /* Pp_hvbox */2;
          break;
      case "v" : 
          box_type = /* Pp_vbox */1;
          break;
      default:
        box_type = invalid_box(/* () */0);
    }
    return /* tuple */[
            indent,
            box_type
          ];
  }
}

function make_padding_fmt_ebb(pad, fmt) {
  if (typeof pad === "number") {
    return /* Padding_fmt_EBB */[
            /* No_padding */0,
            fmt
          ];
  } else if (pad.tag) {
    return /* Padding_fmt_EBB */[
            /* Arg_padding */Block.__(1, [pad[0]]),
            fmt
          ];
  } else {
    return /* Padding_fmt_EBB */[
            /* Lit_padding */Block.__(0, [
                pad[0],
                pad[1]
              ]),
            fmt
          ];
  }
}

function make_precision_fmt_ebb(prec, fmt) {
  if (typeof prec === "number") {
    if (prec !== 0) {
      return /* Precision_fmt_EBB */[
              /* Arg_precision */1,
              fmt
            ];
    } else {
      return /* Precision_fmt_EBB */[
              /* No_precision */0,
              fmt
            ];
    }
  } else {
    return /* Precision_fmt_EBB */[
            /* Lit_precision */[prec[0]],
            fmt
          ];
  }
}

function make_padprec_fmt_ebb(pad, prec, fmt) {
  var match = make_precision_fmt_ebb(prec, fmt);
  var fmt$prime = match[1];
  var prec$1 = match[0];
  if (typeof pad === "number") {
    return /* Padprec_fmt_EBB */[
            /* No_padding */0,
            prec$1,
            fmt$prime
          ];
  } else if (pad.tag) {
    return /* Padprec_fmt_EBB */[
            /* Arg_padding */Block.__(1, [pad[0]]),
            prec$1,
            fmt$prime
          ];
  } else {
    return /* Padprec_fmt_EBB */[
            /* Lit_padding */Block.__(0, [
                pad[0],
                pad[1]
              ]),
            prec$1,
            fmt$prime
          ];
  }
}

function fmt_ebb_of_string(legacy_behavior, str) {
  var legacy_behavior$1 = legacy_behavior ? legacy_behavior[0] : /* true */1;
  var invalid_format_message = function (str_ind, msg) {
    return Curry._3(failwith_message(/* Format */[
                    /* String_literal */Block.__(11, [
                        "invalid format ",
                        /* Caml_string */Block.__(3, [
                            /* No_padding */0,
                            /* String_literal */Block.__(11, [
                                ": at character number ",
                                /* Int */Block.__(4, [
                                    /* Int_d */0,
                                    /* No_padding */0,
                                    /* No_precision */0,
                                    /* String_literal */Block.__(11, [
                                        ", ",
                                        /* String */Block.__(2, [
                                            /* No_padding */0,
                                            /* End_of_format */0
                                          ])
                                      ])
                                  ])
                              ])
                          ])
                      ]),
                    "invalid format %S: at character number %d, %s"
                  ]), str, str_ind, msg);
  };
  var invalid_format_without = function (str_ind, c, s) {
    return Curry._4(failwith_message(/* Format */[
                    /* String_literal */Block.__(11, [
                        "invalid format ",
                        /* Caml_string */Block.__(3, [
                            /* No_padding */0,
                            /* String_literal */Block.__(11, [
                                ": at character number ",
                                /* Int */Block.__(4, [
                                    /* Int_d */0,
                                    /* No_padding */0,
                                    /* No_precision */0,
                                    /* String_literal */Block.__(11, [
                                        ", '",
                                        /* Char */Block.__(0, [/* String_literal */Block.__(11, [
                                                "' without ",
                                                /* String */Block.__(2, [
                                                    /* No_padding */0,
                                                    /* End_of_format */0
                                                  ])
                                              ])])
                                      ])
                                  ])
                              ])
                          ])
                      ]),
                    "invalid format %S: at character number %d, '%c' without %s"
                  ]), str, str_ind, c, s);
  };
  var expected_character = function (str_ind, expected, read) {
    return Curry._4(failwith_message(/* Format */[
                    /* String_literal */Block.__(11, [
                        "invalid format ",
                        /* Caml_string */Block.__(3, [
                            /* No_padding */0,
                            /* String_literal */Block.__(11, [
                                ": at character number ",
                                /* Int */Block.__(4, [
                                    /* Int_d */0,
                                    /* No_padding */0,
                                    /* No_precision */0,
                                    /* String_literal */Block.__(11, [
                                        ", ",
                                        /* String */Block.__(2, [
                                            /* No_padding */0,
                                            /* String_literal */Block.__(11, [
                                                " expected, read ",
                                                /* Caml_char */Block.__(1, [/* End_of_format */0])
                                              ])
                                          ])
                                      ])
                                  ])
                              ])
                          ])
                      ]),
                    "invalid format %S: at character number %d, %s expected, read %C"
                  ]), str, str_ind, expected, read);
  };
  var compute_int_conv = function (pct_ind, str_ind, _plus, _sharp, _space, symb) {
    while(true) {
      var space = _space;
      var sharp = _sharp;
      var plus = _plus;
      var exit = 0;
      var exit$1 = 0;
      if (plus !== 0) {
        if (sharp !== 0) {
          exit$1 = 2;
        } else if (space !== 0) {
          exit = 1;
        } else if (symb !== 100) {
          if (symb !== 105) {
            exit = 1;
          } else {
            return /* Int_pi */4;
          }
        } else {
          return /* Int_pd */1;
        }
      } else if (sharp !== 0) {
        if (space !== 0) {
          exit$1 = 2;
        } else if (symb !== 88) {
          if (symb !== 111) {
            if (symb !== 120) {
              exit$1 = 2;
            } else {
              return /* Int_Cx */7;
            }
          } else {
            return /* Int_Co */11;
          }
        } else {
          return /* Int_CX */9;
        }
      } else if (space !== 0) {
        if (symb !== 100) {
          if (symb !== 105) {
            exit = 1;
          } else {
            return /* Int_si */5;
          }
        } else {
          return /* Int_sd */2;
        }
      } else {
        var switcher = symb - 88 | 0;
        if (switcher > 32 || switcher < 0) {
          exit = 1;
        } else {
          switch (switcher) {
            case 0 : 
                return /* Int_X */8;
            case 12 : 
                return /* Int_d */0;
            case 17 : 
                return /* Int_i */3;
            case 23 : 
                return /* Int_o */10;
            case 29 : 
                return /* Int_u */12;
            case 1 : 
            case 2 : 
            case 3 : 
            case 4 : 
            case 5 : 
            case 6 : 
            case 7 : 
            case 8 : 
            case 9 : 
            case 10 : 
            case 11 : 
            case 13 : 
            case 14 : 
            case 15 : 
            case 16 : 
            case 18 : 
            case 19 : 
            case 20 : 
            case 21 : 
            case 22 : 
            case 24 : 
            case 25 : 
            case 26 : 
            case 27 : 
            case 28 : 
            case 30 : 
            case 31 : 
                exit = 1;
                break;
            case 32 : 
                return /* Int_x */6;
            
          }
        }
      }
      if (exit$1 === 2) {
        var exit$2 = 0;
        var switcher$1 = symb - 88 | 0;
        if (switcher$1 > 32 || switcher$1 < 0) {
          exit = 1;
        } else {
          switch (switcher$1) {
            case 0 : 
                if (legacy_behavior$1) {
                  return /* Int_CX */9;
                } else {
                  exit = 1;
                }
                break;
            case 23 : 
                if (legacy_behavior$1) {
                  return /* Int_Co */11;
                } else {
                  exit = 1;
                }
                break;
            case 12 : 
            case 17 : 
            case 29 : 
                exit$2 = 3;
                break;
            case 1 : 
            case 2 : 
            case 3 : 
            case 4 : 
            case 5 : 
            case 6 : 
            case 7 : 
            case 8 : 
            case 9 : 
            case 10 : 
            case 11 : 
            case 13 : 
            case 14 : 
            case 15 : 
            case 16 : 
            case 18 : 
            case 19 : 
            case 20 : 
            case 21 : 
            case 22 : 
            case 24 : 
            case 25 : 
            case 26 : 
            case 27 : 
            case 28 : 
            case 30 : 
            case 31 : 
                exit = 1;
                break;
            case 32 : 
                if (legacy_behavior$1) {
                  return /* Int_Cx */7;
                } else {
                  exit = 1;
                }
                break;
            
          }
        }
        if (exit$2 === 3) {
          if (legacy_behavior$1) {
            _sharp = /* false */0;
            continue ;
            
          } else {
            return incompatible_flag(pct_ind, str_ind, symb, "'#'");
          }
        }
        
      }
      if (exit === 1) {
        if (plus !== 0) {
          if (space !== 0) {
            if (legacy_behavior$1) {
              _space = /* false */0;
              continue ;
              
            } else {
              return incompatible_flag(pct_ind, str_ind, /* " " */32, "'+'");
            }
          } else if (legacy_behavior$1) {
            _plus = /* false */0;
            continue ;
            
          } else {
            return incompatible_flag(pct_ind, str_ind, symb, "'+'");
          }
        } else if (space !== 0) {
          if (legacy_behavior$1) {
            _space = /* false */0;
            continue ;
            
          } else {
            return incompatible_flag(pct_ind, str_ind, symb, "' '");
          }
        } else {
          throw [
                Caml_builtin_exceptions.assert_failure,
                [
                  "camlinternalFormat.ml",
                  2719,
                  28
                ]
              ];
        }
      }
      
    };
  };
  var incompatible_flag = function (pct_ind, str_ind, symb, option) {
    var subfmt = $$String.sub(str, pct_ind, str_ind - pct_ind | 0);
    return Curry._5(failwith_message(/* Format */[
                    /* String_literal */Block.__(11, [
                        "invalid format ",
                        /* Caml_string */Block.__(3, [
                            /* No_padding */0,
                            /* String_literal */Block.__(11, [
                                ": at character number ",
                                /* Int */Block.__(4, [
                                    /* Int_d */0,
                                    /* No_padding */0,
                                    /* No_precision */0,
                                    /* String_literal */Block.__(11, [
                                        ", ",
                                        /* String */Block.__(2, [
                                            /* No_padding */0,
                                            /* String_literal */Block.__(11, [
                                                " is incompatible with '",
                                                /* Char */Block.__(0, [/* String_literal */Block.__(11, [
                                                        "' in sub-format ",
                                                        /* Caml_string */Block.__(3, [
                                                            /* No_padding */0,
                                                            /* End_of_format */0
                                                          ])
                                                      ])])
                                              ])
                                          ])
                                      ])
                                  ])
                              ])
                          ])
                      ]),
                    "invalid format %S: at character number %d, %s is incompatible with '%c' in sub-format %S"
                  ]), str, pct_ind, option, symb, subfmt);
  };
  var parse_positive = function (_str_ind, end_ind, _acc) {
    while(true) {
      var acc = _acc;
      var str_ind = _str_ind;
      if (str_ind === end_ind) {
        invalid_format_message(end_ind, "unexpected end of format");
      }
      var c = Caml_string.get(str, str_ind);
      if (c > 57 || c < 48) {
        return /* tuple */[
                str_ind,
                acc
              ];
      } else {
        var new_acc = Caml_int32.imul(acc, 10) + (c - /* "0" */48 | 0) | 0;
        _acc = new_acc;
        _str_ind = str_ind + 1 | 0;
        continue ;
        
      }
    };
  };
  var parse_after_precision = function (pct_ind, str_ind, end_ind, minus, plus, sharp, space, ign, pad, prec) {
    if (str_ind === end_ind) {
      invalid_format_message(end_ind, "unexpected end of format");
    }
    var parse_conv = function (padprec) {
      return parse_conversion(pct_ind, str_ind + 1 | 0, end_ind, plus, sharp, space, ign, pad, prec, padprec, Caml_string.get(str, str_ind));
    };
    if (typeof pad === "number") {
      var exit = 0;
      if (typeof prec === "number" && prec === 0) {
        return parse_conv(/* No_padding */0);
      } else {
        exit = 1;
      }
      if (exit === 1) {
        if (minus !== 0) {
          if (typeof prec === "number") {
            return parse_conv(/* Arg_padding */Block.__(1, [/* Left */0]));
          } else {
            return parse_conv(/* Lit_padding */Block.__(0, [
                          /* Left */0,
                          prec[0]
                        ]));
          }
        } else if (typeof prec === "number") {
          return parse_conv(/* Arg_padding */Block.__(1, [/* Right */1]));
        } else {
          return parse_conv(/* Lit_padding */Block.__(0, [
                        /* Right */1,
                        prec[0]
                      ]));
        }
      }
      
    } else {
      return parse_conv(pad);
    }
  };
  var parse_after_padding = function (pct_ind, str_ind, end_ind, minus, plus, sharp, space, ign, pad) {
    if (str_ind === end_ind) {
      invalid_format_message(end_ind, "unexpected end of format");
    }
    var symb = Caml_string.get(str, str_ind);
    if (symb !== 46) {
      return parse_conversion(pct_ind, str_ind + 1 | 0, end_ind, plus, sharp, space, ign, pad, /* No_precision */0, pad, symb);
    } else {
      var pct_ind$1 = pct_ind;
      var str_ind$1 = str_ind + 1 | 0;
      var end_ind$1 = end_ind;
      var minus$1 = minus;
      var plus$1 = plus;
      var sharp$1 = sharp;
      var space$1 = space;
      var ign$1 = ign;
      var pad$1 = pad;
      if (str_ind$1 === end_ind$1) {
        invalid_format_message(end_ind$1, "unexpected end of format");
      }
      var parse_literal = function (minus, str_ind) {
        var match = parse_positive(str_ind, end_ind$1, 0);
        return parse_after_precision(pct_ind$1, match[0], end_ind$1, minus, plus$1, sharp$1, space$1, ign$1, pad$1, /* Lit_precision */[match[1]]);
      };
      var symb$1 = Caml_string.get(str, str_ind$1);
      var exit = 0;
      var exit$1 = 0;
      if (symb$1 >= 48) {
        if (symb$1 >= 58) {
          exit = 1;
        } else {
          return parse_literal(minus$1, str_ind$1);
        }
      } else if (symb$1 >= 42) {
        switch (symb$1 - 42 | 0) {
          case 0 : 
              return parse_after_precision(pct_ind$1, str_ind$1 + 1 | 0, end_ind$1, minus$1, plus$1, sharp$1, space$1, ign$1, pad$1, /* Arg_precision */1);
          case 1 : 
          case 3 : 
              exit$1 = 2;
              break;
          case 2 : 
          case 4 : 
          case 5 : 
              exit = 1;
              break;
          
        }
      } else {
        exit = 1;
      }
      if (exit$1 === 2) {
        if (legacy_behavior$1) {
          return parse_literal(minus$1 || +(symb$1 === /* "-" */45), str_ind$1 + 1 | 0);
        } else {
          exit = 1;
        }
      }
      if (exit === 1) {
        if (legacy_behavior$1) {
          return parse_after_precision(pct_ind$1, str_ind$1, end_ind$1, minus$1, plus$1, sharp$1, space$1, ign$1, pad$1, /* Lit_precision */[0]);
        } else {
          return invalid_format_without(str_ind$1 - 1 | 0, /* "." */46, "precision");
        }
      }
      
    }
  };
  var parse_literal = function (lit_start, _str_ind, end_ind) {
    while(true) {
      var str_ind = _str_ind;
      if (str_ind === end_ind) {
        return add_literal(lit_start, str_ind, /* End_of_format */0);
      } else {
        var match = Caml_string.get(str, str_ind);
        if (match !== 37) {
          if (match !== 64) {
            _str_ind = str_ind + 1 | 0;
            continue ;
            
          } else {
            var match$1 = parse_after_at(str_ind + 1 | 0, end_ind);
            return add_literal(lit_start, str_ind, match$1[0]);
          }
        } else {
          var match$2 = parse_format(str_ind, end_ind);
          return add_literal(lit_start, str_ind, match$2[0]);
        }
      }
    };
  };
  var parse_format = function (pct_ind, end_ind) {
    var pct_ind$1 = pct_ind;
    var str_ind = pct_ind + 1 | 0;
    var end_ind$1 = end_ind;
    if (str_ind === end_ind$1) {
      invalid_format_message(end_ind$1, "unexpected end of format");
    }
    var match = Caml_string.get(str, str_ind);
    if (match !== 95) {
      return parse_flags(pct_ind$1, str_ind, end_ind$1, /* false */0);
    } else {
      return parse_flags(pct_ind$1, str_ind + 1 | 0, end_ind$1, /* true */1);
    }
  };
  var parse_after_at = function (str_ind, end_ind) {
    if (str_ind === end_ind) {
      return /* Fmt_EBB */[/* Char_literal */Block.__(12, [
                  /* "@" */64,
                  /* End_of_format */0
                ])];
    } else {
      var c = Caml_string.get(str, str_ind);
      var exit = 0;
      if (c >= 65) {
        if (c >= 94) {
          var switcher = c - 123 | 0;
          if (switcher > 2 || switcher < 0) {
            exit = 1;
          } else {
            switch (switcher) {
              case 0 : 
                  return parse_tag(/* true */1, str_ind + 1 | 0, end_ind);
              case 1 : 
                  exit = 1;
                  break;
              case 2 : 
                  var beg_ind = str_ind + 1 | 0;
                  var match = parse_literal(beg_ind, beg_ind, end_ind);
                  return /* Fmt_EBB */[/* Formatting_lit */Block.__(17, [
                              /* Close_tag */1,
                              match[0]
                            ])];
              
            }
          }
        } else if (c >= 91) {
          switch (c - 91 | 0) {
            case 0 : 
                return parse_tag(/* false */0, str_ind + 1 | 0, end_ind);
            case 1 : 
                exit = 1;
                break;
            case 2 : 
                var beg_ind$1 = str_ind + 1 | 0;
                var match$1 = parse_literal(beg_ind$1, beg_ind$1, end_ind);
                return /* Fmt_EBB */[/* Formatting_lit */Block.__(17, [
                            /* Close_box */0,
                            match$1[0]
                          ])];
            
          }
        } else {
          exit = 1;
        }
      } else if (c !== 10) {
        if (c >= 32) {
          switch (c - 32 | 0) {
            case 0 : 
                var beg_ind$2 = str_ind + 1 | 0;
                var match$2 = parse_literal(beg_ind$2, beg_ind$2, end_ind);
                return /* Fmt_EBB */[/* Formatting_lit */Block.__(17, [
                            /* Break */Block.__(0, [
                                "@ ",
                                1,
                                0
                              ]),
                            match$2[0]
                          ])];
            case 5 : 
                if ((str_ind + 1 | 0) < end_ind && Caml_string.get(str, str_ind + 1 | 0) === /* "%" */37) {
                  var beg_ind$3 = str_ind + 2 | 0;
                  var match$3 = parse_literal(beg_ind$3, beg_ind$3, end_ind);
                  return /* Fmt_EBB */[/* Formatting_lit */Block.__(17, [
                              /* Escaped_percent */6,
                              match$3[0]
                            ])];
                } else {
                  var match$4 = parse_literal(str_ind, str_ind, end_ind);
                  return /* Fmt_EBB */[/* Char_literal */Block.__(12, [
                              /* "@" */64,
                              match$4[0]
                            ])];
                }
            case 12 : 
                var beg_ind$4 = str_ind + 1 | 0;
                var match$5 = parse_literal(beg_ind$4, beg_ind$4, end_ind);
                return /* Fmt_EBB */[/* Formatting_lit */Block.__(17, [
                            /* Break */Block.__(0, [
                                "@,",
                                0,
                                0
                              ]),
                            match$5[0]
                          ])];
            case 14 : 
                var beg_ind$5 = str_ind + 1 | 0;
                var match$6 = parse_literal(beg_ind$5, beg_ind$5, end_ind);
                return /* Fmt_EBB */[/* Formatting_lit */Block.__(17, [
                            /* Flush_newline */4,
                            match$6[0]
                          ])];
            case 27 : 
                var str_ind$1 = str_ind + 1 | 0;
                var end_ind$1 = end_ind;
                var match$7;
                try {
                  if (str_ind$1 === end_ind$1 || Caml_string.get(str, str_ind$1) !== /* "<" */60) {
                    throw Caml_builtin_exceptions.not_found;
                  }
                  var str_ind_1 = parse_spaces(str_ind$1 + 1 | 0, end_ind$1);
                  var match$8 = Caml_string.get(str, str_ind_1);
                  var exit$1 = 0;
                  if (match$8 >= 48) {
                    if (match$8 >= 58) {
                      throw Caml_builtin_exceptions.not_found;
                    } else {
                      exit$1 = 1;
                    }
                  } else if (match$8 !== 45) {
                    throw Caml_builtin_exceptions.not_found;
                  } else {
                    exit$1 = 1;
                  }
                  if (exit$1 === 1) {
                    var match$9 = parse_integer(str_ind_1, end_ind$1);
                    var width = match$9[1];
                    var str_ind_3 = parse_spaces(match$9[0], end_ind$1);
                    var match$10 = Caml_string.get(str, str_ind_3);
                    var switcher$1 = match$10 - 45 | 0;
                    if (switcher$1 > 12 || switcher$1 < 0) {
                      if (switcher$1 !== 17) {
                        throw Caml_builtin_exceptions.not_found;
                      } else {
                        var s = $$String.sub(str, str_ind$1 - 2 | 0, (str_ind_3 - str_ind$1 | 0) + 3 | 0);
                        match$7 = /* tuple */[
                          str_ind_3 + 1 | 0,
                          /* Break */Block.__(0, [
                              s,
                              width,
                              0
                            ])
                        ];
                      }
                    } else if (switcher$1 === 2 || switcher$1 === 1) {
                      throw Caml_builtin_exceptions.not_found;
                    } else {
                      var match$11 = parse_integer(str_ind_3, end_ind$1);
                      var str_ind_5 = parse_spaces(match$11[0], end_ind$1);
                      if (Caml_string.get(str, str_ind_5) !== /* ">" */62) {
                        throw Caml_builtin_exceptions.not_found;
                      }
                      var s$1 = $$String.sub(str, str_ind$1 - 2 | 0, (str_ind_5 - str_ind$1 | 0) + 3 | 0);
                      match$7 = /* tuple */[
                        str_ind_5 + 1 | 0,
                        /* Break */Block.__(0, [
                            s$1,
                            width,
                            match$11[1]
                          ])
                      ];
                    }
                  }
                  
                }
                catch (raw_exn){
                  var exn = Js_exn.internalToOCamlException(raw_exn);
                  if (exn === Caml_builtin_exceptions.not_found) {
                    match$7 = /* tuple */[
                      str_ind$1,
                      /* Break */Block.__(0, [
                          "@;",
                          1,
                          0
                        ])
                    ];
                  } else if (exn[0] === Caml_builtin_exceptions.failure) {
                    match$7 = /* tuple */[
                      str_ind$1,
                      /* Break */Block.__(0, [
                          "@;",
                          1,
                          0
                        ])
                    ];
                  } else {
                    throw exn;
                  }
                }
                var next_ind = match$7[0];
                var match$12 = parse_literal(next_ind, next_ind, end_ind$1);
                return /* Fmt_EBB */[/* Formatting_lit */Block.__(17, [
                            match$7[1],
                            match$12[0]
                          ])];
            case 28 : 
                var str_ind$2 = str_ind + 1 | 0;
                var end_ind$2 = end_ind;
                var match$13;
                try {
                  var str_ind_1$1 = parse_spaces(str_ind$2, end_ind$2);
                  var match$14 = Caml_string.get(str, str_ind_1$1);
                  var exit$2 = 0;
                  if (match$14 >= 48) {
                    if (match$14 >= 58) {
                      match$13 = /* None */0;
                    } else {
                      exit$2 = 1;
                    }
                  } else if (match$14 !== 45) {
                    match$13 = /* None */0;
                  } else {
                    exit$2 = 1;
                  }
                  if (exit$2 === 1) {
                    var match$15 = parse_integer(str_ind_1$1, end_ind$2);
                    var str_ind_3$1 = parse_spaces(match$15[0], end_ind$2);
                    if (Caml_string.get(str, str_ind_3$1) !== /* ">" */62) {
                      throw Caml_builtin_exceptions.not_found;
                    }
                    var s$2 = $$String.sub(str, str_ind$2 - 2 | 0, (str_ind_3$1 - str_ind$2 | 0) + 3 | 0);
                    match$13 = /* Some */[/* tuple */[
                        str_ind_3$1 + 1 | 0,
                        /* Magic_size */Block.__(1, [
                            s$2,
                            match$15[1]
                          ])
                      ]];
                  }
                  
                }
                catch (raw_exn$1){
                  var exn$1 = Js_exn.internalToOCamlException(raw_exn$1);
                  if (exn$1 === Caml_builtin_exceptions.not_found || exn$1[0] === Caml_builtin_exceptions.failure) {
                    match$13 = /* None */0;
                  } else {
                    throw exn$1;
                  }
                }
                if (match$13) {
                  var match$16 = match$13[0];
                  var next_ind$1 = match$16[0];
                  var match$17 = parse_literal(next_ind$1, next_ind$1, end_ind$2);
                  return /* Fmt_EBB */[/* Formatting_lit */Block.__(17, [
                              match$16[1],
                              match$17[0]
                            ])];
                } else {
                  var match$18 = parse_literal(str_ind$2, str_ind$2, end_ind$2);
                  return /* Fmt_EBB */[/* Formatting_lit */Block.__(17, [
                              /* Scan_indic */Block.__(2, [/* "<" */60]),
                              match$18[0]
                            ])];
                }
            case 1 : 
            case 2 : 
            case 3 : 
            case 4 : 
            case 6 : 
            case 7 : 
            case 8 : 
            case 9 : 
            case 10 : 
            case 11 : 
            case 13 : 
            case 15 : 
            case 16 : 
            case 17 : 
            case 18 : 
            case 19 : 
            case 20 : 
            case 21 : 
            case 22 : 
            case 23 : 
            case 24 : 
            case 25 : 
            case 26 : 
            case 29 : 
            case 30 : 
                exit = 1;
                break;
            case 31 : 
                var beg_ind$6 = str_ind + 1 | 0;
                var match$19 = parse_literal(beg_ind$6, beg_ind$6, end_ind);
                return /* Fmt_EBB */[/* Formatting_lit */Block.__(17, [
                            /* FFlush */2,
                            match$19[0]
                          ])];
            case 32 : 
                var beg_ind$7 = str_ind + 1 | 0;
                var match$20 = parse_literal(beg_ind$7, beg_ind$7, end_ind);
                return /* Fmt_EBB */[/* Formatting_lit */Block.__(17, [
                            /* Escaped_at */5,
                            match$20[0]
                          ])];
            
          }
        } else {
          exit = 1;
        }
      } else {
        var beg_ind$8 = str_ind + 1 | 0;
        var match$21 = parse_literal(beg_ind$8, beg_ind$8, end_ind);
        return /* Fmt_EBB */[/* Formatting_lit */Block.__(17, [
                    /* Force_newline */3,
                    match$21[0]
                  ])];
      }
      if (exit === 1) {
        var beg_ind$9 = str_ind + 1 | 0;
        var match$22 = parse_literal(beg_ind$9, beg_ind$9, end_ind);
        return /* Fmt_EBB */[/* Formatting_lit */Block.__(17, [
                    /* Scan_indic */Block.__(2, [c]),
                    match$22[0]
                  ])];
      }
      
    }
  };
  var add_literal = function (lit_start, str_ind, fmt) {
    var size = str_ind - lit_start | 0;
    if (size !== 0) {
      if (size !== 1) {
        return /* Fmt_EBB */[/* String_literal */Block.__(11, [
                    $$String.sub(str, lit_start, size),
                    fmt
                  ])];
      } else {
        return /* Fmt_EBB */[/* Char_literal */Block.__(12, [
                    Caml_string.get(str, lit_start),
                    fmt
                  ])];
      }
    } else {
      return /* Fmt_EBB */[fmt];
    }
  };
  var parse_spaces = function (_str_ind, end_ind) {
    while(true) {
      var str_ind = _str_ind;
      if (str_ind === end_ind) {
        invalid_format_message(end_ind, "unexpected end of format");
      }
      if (Caml_string.get(str, str_ind) === /* " " */32) {
        _str_ind = str_ind + 1 | 0;
        continue ;
        
      } else {
        return str_ind;
      }
    };
  };
  var parse_integer = function (str_ind, end_ind) {
    if (str_ind === end_ind) {
      invalid_format_message(end_ind, "unexpected end of format");
    }
    var match = Caml_string.get(str, str_ind);
    if (match >= 48) {
      if (match >= 58) {
        throw [
              Caml_builtin_exceptions.assert_failure,
              [
                "camlinternalFormat.ml",
                2624,
                11
              ]
            ];
      } else {
        return parse_positive(str_ind, end_ind, 0);
      }
    } else if (match !== 45) {
      throw [
            Caml_builtin_exceptions.assert_failure,
            [
              "camlinternalFormat.ml",
              2624,
              11
            ]
          ];
    } else {
      if ((str_ind + 1 | 0) === end_ind) {
        invalid_format_message(end_ind, "unexpected end of format");
      }
      var c = Caml_string.get(str, str_ind + 1 | 0);
      if (c > 57 || c < 48) {
        return expected_character(str_ind + 1 | 0, "digit", c);
      } else {
        var match$1 = parse_positive(str_ind + 1 | 0, end_ind, 0);
        return /* tuple */[
                match$1[0],
                -match$1[1] | 0
              ];
      }
    }
  };
  var compute_float_conv = function (pct_ind, str_ind, _plus, _space, symb) {
    while(true) {
      var space = _space;
      var plus = _plus;
      if (plus !== 0) {
        if (space !== 0) {
          if (legacy_behavior$1) {
            _space = /* false */0;
            continue ;
            
          } else {
            return incompatible_flag(pct_ind, str_ind, /* " " */32, "'+'");
          }
        } else {
          var exit = 0;
          if (symb >= 72) {
            var switcher = symb - 101 | 0;
            if (switcher > 2 || switcher < 0) {
              exit = 1;
            } else {
              switch (switcher) {
                case 0 : 
                    return /* Float_pe */4;
                case 1 : 
                    return /* Float_pf */1;
                case 2 : 
                    return /* Float_pg */10;
                
              }
            }
          } else if (symb >= 69) {
            switch (symb - 69 | 0) {
              case 0 : 
                  return /* Float_pE */7;
              case 1 : 
                  exit = 1;
                  break;
              case 2 : 
                  return /* Float_pG */13;
              
            }
          } else {
            exit = 1;
          }
          if (exit === 1) {
            if (legacy_behavior$1) {
              _plus = /* false */0;
              continue ;
              
            } else {
              return incompatible_flag(pct_ind, str_ind, symb, "'+'");
            }
          }
          
        }
      } else if (space !== 0) {
        var exit$1 = 0;
        if (symb >= 72) {
          var switcher$1 = symb - 101 | 0;
          if (switcher$1 > 2 || switcher$1 < 0) {
            exit$1 = 1;
          } else {
            switch (switcher$1) {
              case 0 : 
                  return /* Float_se */5;
              case 1 : 
                  return /* Float_sf */2;
              case 2 : 
                  return /* Float_sg */11;
              
            }
          }
        } else if (symb >= 69) {
          switch (symb - 69 | 0) {
            case 0 : 
                return /* Float_sE */8;
            case 1 : 
                exit$1 = 1;
                break;
            case 2 : 
                return /* Float_sG */14;
            
          }
        } else {
          exit$1 = 1;
        }
        if (exit$1 === 1) {
          if (legacy_behavior$1) {
            _space = /* false */0;
            continue ;
            
          } else {
            return incompatible_flag(pct_ind, str_ind, symb, "' '");
          }
        }
        
      } else if (symb >= 72) {
        var switcher$2 = symb - 101 | 0;
        if (switcher$2 > 2 || switcher$2 < 0) {
          throw [
                Caml_builtin_exceptions.assert_failure,
                [
                  "camlinternalFormat.ml",
                  2747,
                  25
                ]
              ];
        } else {
          switch (switcher$2) {
            case 0 : 
                return /* Float_e */3;
            case 1 : 
                return /* Float_f */0;
            case 2 : 
                return /* Float_g */9;
            
          }
        }
      } else if (symb >= 69) {
        switch (symb - 69 | 0) {
          case 0 : 
              return /* Float_E */6;
          case 1 : 
              return /* Float_F */15;
          case 2 : 
              return /* Float_G */12;
          
        }
      } else {
        throw [
              Caml_builtin_exceptions.assert_failure,
              [
                "camlinternalFormat.ml",
                2747,
                25
              ]
            ];
      }
    };
  };
  var search_subformat_end = function (_str_ind, end_ind, c) {
    while(true) {
      var str_ind = _str_ind;
      if (str_ind === end_ind) {
        Curry._3(failwith_message(/* Format */[
                  /* String_literal */Block.__(11, [
                      "invalid format ",
                      /* Caml_string */Block.__(3, [
                          /* No_padding */0,
                          /* String_literal */Block.__(11, [
                              ": unclosed sub-format, expected \"",
                              /* Char_literal */Block.__(12, [
                                  /* "%" */37,
                                  /* Char */Block.__(0, [/* String_literal */Block.__(11, [
                                          "\" at character number ",
                                          /* Int */Block.__(4, [
                                              /* Int_d */0,
                                              /* No_padding */0,
                                              /* No_precision */0,
                                              /* End_of_format */0
                                            ])
                                        ])])
                                ])
                            ])
                        ])
                    ]),
                  "invalid format %S: unclosed sub-format, expected \"%%%c\" at character number %d"
                ]), str, c, end_ind);
      }
      var match = Caml_string.get(str, str_ind);
      if (match !== 37) {
        _str_ind = str_ind + 1 | 0;
        continue ;
        
      } else {
        if ((str_ind + 1 | 0) === end_ind) {
          invalid_format_message(end_ind, "unexpected end of format");
        }
        if (Caml_string.get(str, str_ind + 1 | 0) === c) {
          return str_ind;
        } else {
          var match$1 = Caml_string.get(str, str_ind + 1 | 0);
          var exit = 0;
          if (match$1 >= 95) {
            if (match$1 >= 123) {
              if (match$1 >= 126) {
                exit = 1;
              } else {
                switch (match$1 - 123 | 0) {
                  case 0 : 
                      var sub_end = search_subformat_end(str_ind + 2 | 0, end_ind, /* "}" */125);
                      _str_ind = sub_end + 2 | 0;
                      continue ;
                      case 1 : 
                      exit = 1;
                      break;
                  case 2 : 
                      return expected_character(str_ind + 1 | 0, "character ')'", /* "}" */125);
                  
                }
              }
            } else if (match$1 >= 96) {
              exit = 1;
            } else {
              if ((str_ind + 2 | 0) === end_ind) {
                invalid_format_message(end_ind, "unexpected end of format");
              }
              var match$2 = Caml_string.get(str, str_ind + 2 | 0);
              if (match$2 !== 40) {
                if (match$2 !== 123) {
                  _str_ind = str_ind + 3 | 0;
                  continue ;
                  
                } else {
                  var sub_end$1 = search_subformat_end(str_ind + 3 | 0, end_ind, /* "}" */125);
                  _str_ind = sub_end$1 + 2 | 0;
                  continue ;
                  
                }
              } else {
                var sub_end$2 = search_subformat_end(str_ind + 3 | 0, end_ind, /* ")" */41);
                _str_ind = sub_end$2 + 2 | 0;
                continue ;
                
              }
            }
          } else if (match$1 !== 40) {
            if (match$1 !== 41) {
              exit = 1;
            } else {
              return expected_character(str_ind + 1 | 0, "character '}'", /* ")" */41);
            }
          } else {
            var sub_end$3 = search_subformat_end(str_ind + 2 | 0, end_ind, /* ")" */41);
            _str_ind = sub_end$3 + 2 | 0;
            continue ;
            
          }
          if (exit === 1) {
            _str_ind = str_ind + 2 | 0;
            continue ;
            
          }
          
        }
      }
    };
  };
  var parse_conversion = function (pct_ind, str_ind, end_ind, plus, sharp, space, ign, pad, prec, padprec, symb) {
    var plus_used = /* false */0;
    var sharp_used = /* false */0;
    var space_used = /* false */0;
    var ign_used = [/* false */0];
    var pad_used = /* false */0;
    var prec_used = [/* false */0];
    var check_no_0 = function (symb, pad) {
      if (typeof pad === "number") {
        return pad;
      } else if (pad.tag) {
        if (pad[0] >= 2) {
          if (legacy_behavior$1) {
            return /* Arg_padding */Block.__(1, [/* Right */1]);
          } else {
            return incompatible_flag(pct_ind, str_ind, symb, "0");
          }
        } else {
          return pad;
        }
      } else if (pad[0] >= 2) {
        if (legacy_behavior$1) {
          return /* Lit_padding */Block.__(0, [
                    /* Right */1,
                    pad[1]
                  ]);
        } else {
          return incompatible_flag(pct_ind, str_ind, symb, "0");
        }
      } else {
        return pad;
      }
    };
    var opt_of_pad = function (c, pad) {
      if (typeof pad === "number") {
        return /* None */0;
      } else if (pad.tag) {
        return incompatible_flag(pct_ind, str_ind, c, "'*'");
      } else {
        switch (pad[0]) {
          case 0 : 
              if (legacy_behavior$1) {
                return /* Some */[pad[1]];
              } else {
                return incompatible_flag(pct_ind, str_ind, c, "'-'");
              }
          case 1 : 
              return /* Some */[pad[1]];
          case 2 : 
              if (legacy_behavior$1) {
                return /* Some */[pad[1]];
              } else {
                return incompatible_flag(pct_ind, str_ind, c, "'0'");
              }
          
        }
      }
    };
    var get_prec_opt = function () {
      prec_used[0] = /* true */1;
      if (typeof prec === "number") {
        if (prec !== 0) {
          return incompatible_flag(pct_ind, str_ind, /* "_" */95, "'*'");
        } else {
          return /* None */0;
        }
      } else {
        return /* Some */[prec[0]];
      }
    };
    var fmt_result;
    var exit = 0;
    var exit$1 = 0;
    var exit$2 = 0;
    if (symb >= 124) {
      exit$1 = 6;
    } else {
      switch (symb) {
        case 33 : 
            var match = parse_literal(str_ind, str_ind, end_ind);
            fmt_result = /* Fmt_EBB */[/* Flush */Block.__(10, [match[0]])];
            break;
        case 40 : 
            var sub_end = search_subformat_end(str_ind, end_ind, /* ")" */41);
            var beg_ind = sub_end + 2 | 0;
            var match$1 = parse_literal(beg_ind, beg_ind, end_ind);
            var fmt_rest = match$1[0];
            var match$2 = parse_literal(str_ind, str_ind, sub_end);
            var sub_fmtty = fmtty_of_fmt(match$2[0]);
            if (ign_used[0] = /* true */1, ign) {
              pad_used = /* true */1;
              var ignored_000 = opt_of_pad(/* "_" */95, pad);
              var ignored = /* Ignored_format_subst */Block.__(8, [
                  ignored_000,
                  sub_fmtty
                ]);
              fmt_result = /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                    ignored,
                    fmt_rest
                  ])];
            } else {
              pad_used = /* true */1;
              fmt_result = /* Fmt_EBB */[/* Format_subst */Block.__(14, [
                    opt_of_pad(/* "(" */40, pad),
                    sub_fmtty,
                    fmt_rest
                  ])];
            }
            break;
        case 44 : 
            fmt_result = parse_literal(str_ind, str_ind, end_ind);
            break;
        case 37 : 
        case 64 : 
            exit$1 = 4;
            break;
        case 67 : 
            var match$3 = parse_literal(str_ind, str_ind, end_ind);
            var fmt_rest$1 = match$3[0];
            fmt_result = (ign_used[0] = /* true */1, ign) ? /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                    /* Ignored_caml_char */1,
                    fmt_rest$1
                  ])] : /* Fmt_EBB */[/* Caml_char */Block.__(1, [fmt_rest$1])];
            break;
        case 78 : 
            var match$4 = parse_literal(str_ind, str_ind, end_ind);
            var fmt_rest$2 = match$4[0];
            if (ign_used[0] = /* true */1, ign) {
              var ignored$1 = /* Ignored_scan_get_counter */Block.__(10, [/* Token_counter */2]);
              fmt_result = /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                    ignored$1,
                    fmt_rest$2
                  ])];
            } else {
              fmt_result = /* Fmt_EBB */[/* Scan_get_counter */Block.__(21, [
                    /* Token_counter */2,
                    fmt_rest$2
                  ])];
            }
            break;
        case 83 : 
            pad_used = /* true */1;
            var pad$1 = check_no_0(symb, padprec);
            var match$5 = parse_literal(str_ind, str_ind, end_ind);
            var fmt_rest$3 = match$5[0];
            if (ign_used[0] = /* true */1, ign) {
              pad_used = /* true */1;
              var ignored$2 = /* Ignored_caml_string */Block.__(1, [opt_of_pad(/* "_" */95, padprec)]);
              fmt_result = /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                    ignored$2,
                    fmt_rest$3
                  ])];
            } else {
              var match$6 = make_padding_fmt_ebb(pad$1, fmt_rest$3);
              fmt_result = /* Fmt_EBB */[/* Caml_string */Block.__(3, [
                    match$6[0],
                    match$6[1]
                  ])];
            }
            break;
        case 91 : 
            var match$7 = parse_char_set(str_ind, end_ind);
            var char_set = match$7[1];
            var next_ind = match$7[0];
            var match$8 = parse_literal(next_ind, next_ind, end_ind);
            var fmt_rest$4 = match$8[0];
            if (ign_used[0] = /* true */1, ign) {
              pad_used = /* true */1;
              var ignored_000$1 = opt_of_pad(/* "_" */95, pad);
              var ignored$3 = /* Ignored_scan_char_set */Block.__(9, [
                  ignored_000$1,
                  char_set
                ]);
              fmt_result = /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                    ignored$3,
                    fmt_rest$4
                  ])];
            } else {
              pad_used = /* true */1;
              fmt_result = /* Fmt_EBB */[/* Scan_char_set */Block.__(20, [
                    opt_of_pad(/* "[" */91, pad),
                    char_set,
                    fmt_rest$4
                  ])];
            }
            break;
        case 32 : 
        case 35 : 
        case 43 : 
        case 45 : 
        case 95 : 
            exit$1 = 5;
            break;
        case 97 : 
            var match$9 = parse_literal(str_ind, str_ind, end_ind);
            fmt_result = /* Fmt_EBB */[/* Alpha */Block.__(15, [match$9[0]])];
            break;
        case 66 : 
        case 98 : 
            exit$1 = 3;
            break;
        case 99 : 
            var char_format = function (fmt_rest) {
              if (ign_used[0] = /* true */1, ign) {
                return /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                            /* Ignored_char */0,
                            fmt_rest
                          ])];
              } else {
                return /* Fmt_EBB */[/* Char */Block.__(0, [fmt_rest])];
              }
            };
            var scan_format = function (fmt_rest) {
              if (ign_used[0] = /* true */1, ign) {
                return /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                            /* Ignored_scan_next_char */4,
                            fmt_rest
                          ])];
              } else {
                return /* Fmt_EBB */[/* Scan_next_char */Block.__(22, [fmt_rest])];
              }
            };
            var match$10 = parse_literal(str_ind, str_ind, end_ind);
            var fmt_rest$5 = match$10[0];
            pad_used = /* true */1;
            var match$11 = opt_of_pad(/* "c" */99, pad);
            fmt_result = match$11 ? (
                match$11[0] !== 0 ? (
                    legacy_behavior$1 ? char_format(fmt_rest$5) : invalid_format_message(str_ind, "non-zero widths are unsupported for %c conversions")
                  ) : scan_format(fmt_rest$5)
              ) : char_format(fmt_rest$5);
            break;
        case 69 : 
        case 70 : 
        case 71 : 
        case 101 : 
        case 102 : 
        case 103 : 
            exit$1 = 2;
            break;
        case 76 : 
        case 108 : 
        case 110 : 
            exit$2 = 8;
            break;
        case 114 : 
            var match$12 = parse_literal(str_ind, str_ind, end_ind);
            var fmt_rest$6 = match$12[0];
            fmt_result = (ign_used[0] = /* true */1, ign) ? /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                    /* Ignored_reader */3,
                    fmt_rest$6
                  ])] : /* Fmt_EBB */[/* Reader */Block.__(19, [fmt_rest$6])];
            break;
        case 115 : 
            pad_used = /* true */1;
            var pad$2 = check_no_0(symb, padprec);
            var match$13 = parse_literal(str_ind, str_ind, end_ind);
            var fmt_rest$7 = match$13[0];
            if (ign_used[0] = /* true */1, ign) {
              pad_used = /* true */1;
              var ignored$4 = /* Ignored_string */Block.__(0, [opt_of_pad(/* "_" */95, padprec)]);
              fmt_result = /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                    ignored$4,
                    fmt_rest$7
                  ])];
            } else {
              var match$14 = make_padding_fmt_ebb(pad$2, fmt_rest$7);
              fmt_result = /* Fmt_EBB */[/* String */Block.__(2, [
                    match$14[0],
                    match$14[1]
                  ])];
            }
            break;
        case 116 : 
            var match$15 = parse_literal(str_ind, str_ind, end_ind);
            fmt_result = /* Fmt_EBB */[/* Theta */Block.__(16, [match$15[0]])];
            break;
        case 88 : 
        case 100 : 
        case 105 : 
        case 111 : 
        case 117 : 
        case 120 : 
            exit$2 = 7;
            break;
        case 0 : 
        case 1 : 
        case 2 : 
        case 3 : 
        case 4 : 
        case 5 : 
        case 6 : 
        case 7 : 
        case 8 : 
        case 9 : 
        case 10 : 
        case 11 : 
        case 12 : 
        case 13 : 
        case 14 : 
        case 15 : 
        case 16 : 
        case 17 : 
        case 18 : 
        case 19 : 
        case 20 : 
        case 21 : 
        case 22 : 
        case 23 : 
        case 24 : 
        case 25 : 
        case 26 : 
        case 27 : 
        case 28 : 
        case 29 : 
        case 30 : 
        case 31 : 
        case 34 : 
        case 36 : 
        case 38 : 
        case 39 : 
        case 41 : 
        case 42 : 
        case 46 : 
        case 47 : 
        case 48 : 
        case 49 : 
        case 50 : 
        case 51 : 
        case 52 : 
        case 53 : 
        case 54 : 
        case 55 : 
        case 56 : 
        case 57 : 
        case 58 : 
        case 59 : 
        case 60 : 
        case 61 : 
        case 62 : 
        case 63 : 
        case 65 : 
        case 68 : 
        case 72 : 
        case 73 : 
        case 74 : 
        case 75 : 
        case 77 : 
        case 79 : 
        case 80 : 
        case 81 : 
        case 82 : 
        case 84 : 
        case 85 : 
        case 86 : 
        case 87 : 
        case 89 : 
        case 90 : 
        case 92 : 
        case 93 : 
        case 94 : 
        case 96 : 
        case 104 : 
        case 106 : 
        case 107 : 
        case 109 : 
        case 112 : 
        case 113 : 
        case 118 : 
        case 119 : 
        case 121 : 
        case 122 : 
            exit$1 = 6;
            break;
        case 123 : 
            var sub_end$1 = search_subformat_end(str_ind, end_ind, /* "}" */125);
            var match$16 = parse_literal(str_ind, str_ind, sub_end$1);
            var beg_ind$1 = sub_end$1 + 2 | 0;
            var match$17 = parse_literal(beg_ind$1, beg_ind$1, end_ind);
            var fmt_rest$8 = match$17[0];
            var sub_fmtty$1 = fmtty_of_fmt(match$16[0]);
            if (ign_used[0] = /* true */1, ign) {
              pad_used = /* true */1;
              var ignored_000$2 = opt_of_pad(/* "_" */95, pad);
              var ignored$5 = /* Ignored_format_arg */Block.__(7, [
                  ignored_000$2,
                  sub_fmtty$1
                ]);
              fmt_result = /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                    ignored$5,
                    fmt_rest$8
                  ])];
            } else {
              pad_used = /* true */1;
              fmt_result = /* Fmt_EBB */[/* Format_arg */Block.__(13, [
                    opt_of_pad(/* "{" */123, pad),
                    sub_fmtty$1,
                    fmt_rest$8
                  ])];
            }
            break;
        
      }
    }
    switch (exit$2) {
      case 7 : 
          plus_used = /* true */1;
          sharp_used = /* true */1;
          space_used = /* true */1;
          var iconv = compute_int_conv(pct_ind, str_ind, plus, sharp, space, symb);
          var match$18 = parse_literal(str_ind, str_ind, end_ind);
          var fmt_rest$9 = match$18[0];
          if (ign_used[0] = /* true */1, ign) {
            pad_used = /* true */1;
            var ignored_001 = opt_of_pad(/* "_" */95, pad);
            var ignored$6 = /* Ignored_int */Block.__(2, [
                iconv,
                ignored_001
              ]);
            fmt_result = /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                  ignored$6,
                  fmt_rest$9
                ])];
          } else {
            pad_used = /* true */1;
            prec_used[0] = /* true */1;
            var pad$3;
            var exit$3 = 0;
            if (typeof prec === "number" && prec === 0) {
              pad$3 = pad;
            } else {
              exit$3 = 9;
            }
            if (exit$3 === 9) {
              pad$3 = typeof pad === "number" ? /* No_padding */0 : (
                  pad.tag ? (
                      pad[0] >= 2 ? (
                          legacy_behavior$1 ? /* Arg_padding */Block.__(1, [/* Right */1]) : incompatible_flag(pct_ind, str_ind, /* "0" */48, "precision")
                        ) : pad
                    ) : (
                      pad[0] >= 2 ? (
                          legacy_behavior$1 ? /* Lit_padding */Block.__(0, [
                                /* Right */1,
                                pad[1]
                              ]) : incompatible_flag(pct_ind, str_ind, /* "0" */48, "precision")
                        ) : pad
                    )
                );
            }
            var match$19 = make_padprec_fmt_ebb(pad$3, (prec_used[0] = /* true */1, prec), fmt_rest$9);
            fmt_result = /* Fmt_EBB */[/* Int */Block.__(4, [
                  iconv,
                  match$19[0],
                  match$19[1],
                  match$19[2]
                ])];
          }
          break;
      case 8 : 
          if (str_ind === end_ind || !is_int_base(Caml_string.get(str, str_ind))) {
            var match$20 = parse_literal(str_ind, str_ind, end_ind);
            var fmt_rest$10 = match$20[0];
            var counter = counter_of_char(symb);
            if (ign_used[0] = /* true */1, ign) {
              var ignored$7 = /* Ignored_scan_get_counter */Block.__(10, [counter]);
              fmt_result = /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                    ignored$7,
                    fmt_rest$10
                  ])];
            } else {
              fmt_result = /* Fmt_EBB */[/* Scan_get_counter */Block.__(21, [
                    counter,
                    fmt_rest$10
                  ])];
            }
          } else {
            exit$1 = 6;
          }
          break;
      
    }
    switch (exit$1) {
      case 2 : 
          plus_used = /* true */1;
          space_used = /* true */1;
          var fconv = compute_float_conv(pct_ind, str_ind, plus, space, symb);
          var match$21 = parse_literal(str_ind, str_ind, end_ind);
          var fmt_rest$11 = match$21[0];
          if (ign_used[0] = /* true */1, ign) {
            pad_used = /* true */1;
            var ignored_000$3 = opt_of_pad(/* "_" */95, pad);
            var ignored_001$1 = get_prec_opt(/* () */0);
            var ignored$8 = /* Ignored_float */Block.__(6, [
                ignored_000$3,
                ignored_001$1
              ]);
            fmt_result = /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                  ignored$8,
                  fmt_rest$11
                ])];
          } else {
            pad_used = /* true */1;
            var match$22 = make_padprec_fmt_ebb(pad, (prec_used[0] = /* true */1, prec), fmt_rest$11);
            fmt_result = /* Fmt_EBB */[/* Float */Block.__(8, [
                  fconv,
                  match$22[0],
                  match$22[1],
                  match$22[2]
                ])];
          }
          break;
      case 3 : 
          var match$23 = parse_literal(str_ind, str_ind, end_ind);
          var fmt_rest$12 = match$23[0];
          fmt_result = (ign_used[0] = /* true */1, ign) ? /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                  /* Ignored_bool */2,
                  fmt_rest$12
                ])] : /* Fmt_EBB */[/* Bool */Block.__(9, [fmt_rest$12])];
          break;
      case 4 : 
          var match$24 = parse_literal(str_ind, str_ind, end_ind);
          fmt_result = /* Fmt_EBB */[/* Char_literal */Block.__(12, [
                symb,
                match$24[0]
              ])];
          break;
      case 5 : 
          fmt_result = Curry._3(failwith_message(/* Format */[
                    /* String_literal */Block.__(11, [
                        "invalid format ",
                        /* Caml_string */Block.__(3, [
                            /* No_padding */0,
                            /* String_literal */Block.__(11, [
                                ": at character number ",
                                /* Int */Block.__(4, [
                                    /* Int_d */0,
                                    /* No_padding */0,
                                    /* No_precision */0,
                                    /* String_literal */Block.__(11, [
                                        ", flag ",
                                        /* Caml_char */Block.__(1, [/* String_literal */Block.__(11, [
                                                " is only allowed after the '",
                                                /* Char_literal */Block.__(12, [
                                                    /* "%" */37,
                                                    /* String_literal */Block.__(11, [
                                                        "', before padding and precision",
                                                        /* End_of_format */0
                                                      ])
                                                  ])
                                              ])])
                                      ])
                                  ])
                              ])
                          ])
                      ]),
                    "invalid format %S: at character number %d, flag %C is only allowed after the '%%', before padding and precision"
                  ]), str, pct_ind, symb);
          break;
      case 6 : 
          if (symb >= 108) {
            if (symb >= 111) {
              exit = 1;
            } else {
              switch (symb - 108 | 0) {
                case 0 : 
                    plus_used = /* true */1;
                    sharp_used = /* true */1;
                    space_used = /* true */1;
                    var iconv$1 = compute_int_conv(pct_ind, str_ind + 1 | 0, plus, sharp, space, Caml_string.get(str, str_ind));
                    var beg_ind$2 = str_ind + 1 | 0;
                    var match$25 = parse_literal(beg_ind$2, beg_ind$2, end_ind);
                    var fmt_rest$13 = match$25[0];
                    if (ign_used[0] = /* true */1, ign) {
                      pad_used = /* true */1;
                      var ignored_001$2 = opt_of_pad(/* "_" */95, pad);
                      var ignored$9 = /* Ignored_int32 */Block.__(3, [
                          iconv$1,
                          ignored_001$2
                        ]);
                      fmt_result = /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                            ignored$9,
                            fmt_rest$13
                          ])];
                    } else {
                      pad_used = /* true */1;
                      var match$26 = make_padprec_fmt_ebb(pad, (prec_used[0] = /* true */1, prec), fmt_rest$13);
                      fmt_result = /* Fmt_EBB */[/* Int32 */Block.__(5, [
                            iconv$1,
                            match$26[0],
                            match$26[1],
                            match$26[2]
                          ])];
                    }
                    break;
                case 1 : 
                    exit = 1;
                    break;
                case 2 : 
                    plus_used = /* true */1;
                    sharp_used = /* true */1;
                    space_used = /* true */1;
                    var iconv$2 = compute_int_conv(pct_ind, str_ind + 1 | 0, plus, sharp, space, Caml_string.get(str, str_ind));
                    var beg_ind$3 = str_ind + 1 | 0;
                    var match$27 = parse_literal(beg_ind$3, beg_ind$3, end_ind);
                    var fmt_rest$14 = match$27[0];
                    if (ign_used[0] = /* true */1, ign) {
                      pad_used = /* true */1;
                      var ignored_001$3 = opt_of_pad(/* "_" */95, pad);
                      var ignored$10 = /* Ignored_nativeint */Block.__(4, [
                          iconv$2,
                          ignored_001$3
                        ]);
                      fmt_result = /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                            ignored$10,
                            fmt_rest$14
                          ])];
                    } else {
                      pad_used = /* true */1;
                      var match$28 = make_padprec_fmt_ebb(pad, (prec_used[0] = /* true */1, prec), fmt_rest$14);
                      fmt_result = /* Fmt_EBB */[/* Nativeint */Block.__(6, [
                            iconv$2,
                            match$28[0],
                            match$28[1],
                            match$28[2]
                          ])];
                    }
                    break;
                
              }
            }
          } else if (symb !== 76) {
            exit = 1;
          } else {
            plus_used = /* true */1;
            sharp_used = /* true */1;
            space_used = /* true */1;
            var iconv$3 = compute_int_conv(pct_ind, str_ind + 1 | 0, plus, sharp, space, Caml_string.get(str, str_ind));
            var beg_ind$4 = str_ind + 1 | 0;
            var match$29 = parse_literal(beg_ind$4, beg_ind$4, end_ind);
            var fmt_rest$15 = match$29[0];
            if (ign_used[0] = /* true */1, ign) {
              pad_used = /* true */1;
              var ignored_001$4 = opt_of_pad(/* "_" */95, pad);
              var ignored$11 = /* Ignored_int64 */Block.__(5, [
                  iconv$3,
                  ignored_001$4
                ]);
              fmt_result = /* Fmt_EBB */[/* Ignored_param */Block.__(23, [
                    ignored$11,
                    fmt_rest$15
                  ])];
            } else {
              pad_used = /* true */1;
              var match$30 = make_padprec_fmt_ebb(pad, (prec_used[0] = /* true */1, prec), fmt_rest$15);
              fmt_result = /* Fmt_EBB */[/* Int64 */Block.__(7, [
                    iconv$3,
                    match$30[0],
                    match$30[1],
                    match$30[2]
                  ])];
            }
          }
          break;
      
    }
    if (exit === 1) {
      fmt_result = Curry._3(failwith_message(/* Format */[
                /* String_literal */Block.__(11, [
                    "invalid format ",
                    /* Caml_string */Block.__(3, [
                        /* No_padding */0,
                        /* String_literal */Block.__(11, [
                            ": at character number ",
                            /* Int */Block.__(4, [
                                /* Int_d */0,
                                /* No_padding */0,
                                /* No_precision */0,
                                /* String_literal */Block.__(11, [
                                    ", invalid conversion \"",
                                    /* Char_literal */Block.__(12, [
                                        /* "%" */37,
                                        /* Char */Block.__(0, [/* Char_literal */Block.__(12, [
                                                /* "\"" */34,
                                                /* End_of_format */0
                                              ])])
                                      ])
                                  ])
                              ])
                          ])
                      ])
                  ]),
                "invalid format %S: at character number %d, invalid conversion \"%%%c\""
              ]), str, str_ind - 1 | 0, symb);
    }
    if (!legacy_behavior$1) {
      if (!plus_used && plus) {
        incompatible_flag(pct_ind, str_ind, symb, "'+'");
      }
      if (!sharp_used && sharp) {
        incompatible_flag(pct_ind, str_ind, symb, "'#'");
      }
      if (!space_used && space) {
        incompatible_flag(pct_ind, str_ind, symb, "' '");
      }
      if (!pad_used && Caml_obj.caml_notequal(/* Padding_EBB */[pad], /* Padding_EBB */[/* No_padding */0])) {
        incompatible_flag(pct_ind, str_ind, symb, "`padding'");
      }
      if (!prec_used[0] && Caml_obj.caml_notequal(/* Precision_EBB */[prec], /* Precision_EBB */[/* No_precision */0])) {
        incompatible_flag(pct_ind, str_ind, ign ? /* "_" */95 : symb, "`precision'");
      }
      if (ign && plus) {
        incompatible_flag(pct_ind, str_ind, /* "_" */95, "'+'");
      }
      
    }
    if (!ign_used[0] && ign) {
      var exit$4 = 0;
      if (symb >= 38) {
        if (symb !== 44) {
          if (symb !== 64) {
            exit$4 = 1;
          } else if (!legacy_behavior$1) {
            exit$4 = 1;
          }
          
        } else if (!legacy_behavior$1) {
          exit$4 = 1;
        }
        
      } else if (symb !== 33) {
        if (symb >= 37) {
          if (!legacy_behavior$1) {
            exit$4 = 1;
          }
          
        } else {
          exit$4 = 1;
        }
      } else if (!legacy_behavior$1) {
        exit$4 = 1;
      }
      if (exit$4 === 1) {
        incompatible_flag(pct_ind, str_ind, symb, "'_'");
      }
      
    }
    return fmt_result;
  };
  var parse_flags = function (pct_ind, str_ind, end_ind, ign) {
    var zero = [/* false */0];
    var minus = [/* false */0];
    var plus = [/* false */0];
    var space = [/* false */0];
    var sharp = [/* false */0];
    var set_flag = function (str_ind, flag) {
      if (flag[0] && !legacy_behavior$1) {
        Curry._3(failwith_message(/* Format */[
                  /* String_literal */Block.__(11, [
                      "invalid format ",
                      /* Caml_string */Block.__(3, [
                          /* No_padding */0,
                          /* String_literal */Block.__(11, [
                              ": at character number ",
                              /* Int */Block.__(4, [
                                  /* Int_d */0,
                                  /* No_padding */0,
                                  /* No_precision */0,
                                  /* String_literal */Block.__(11, [
                                      ", duplicate flag ",
                                      /* Caml_char */Block.__(1, [/* End_of_format */0])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                  "invalid format %S: at character number %d, duplicate flag %C"
                ]), str, str_ind, Caml_string.get(str, str_ind));
      }
      flag[0] = /* true */1;
      return /* () */0;
    };
    var _str_ind = str_ind;
    while(true) {
      var str_ind$1 = _str_ind;
      if (str_ind$1 === end_ind) {
        invalid_format_message(end_ind, "unexpected end of format");
      }
      var match = Caml_string.get(str, str_ind$1);
      var exit = 0;
      var switcher = match - 32 | 0;
      if (switcher > 16 || switcher < 0) {
        exit = 1;
      } else {
        switch (switcher) {
          case 0 : 
              set_flag(str_ind$1, space);
              _str_ind = str_ind$1 + 1 | 0;
              continue ;
              case 3 : 
              set_flag(str_ind$1, sharp);
              _str_ind = str_ind$1 + 1 | 0;
              continue ;
              case 11 : 
              set_flag(str_ind$1, plus);
              _str_ind = str_ind$1 + 1 | 0;
              continue ;
              case 13 : 
              set_flag(str_ind$1, minus);
              _str_ind = str_ind$1 + 1 | 0;
              continue ;
              case 1 : 
          case 2 : 
          case 4 : 
          case 5 : 
          case 6 : 
          case 7 : 
          case 8 : 
          case 9 : 
          case 10 : 
          case 12 : 
          case 14 : 
          case 15 : 
              exit = 1;
              break;
          case 16 : 
              set_flag(str_ind$1, zero);
              _str_ind = str_ind$1 + 1 | 0;
              continue ;
              
        }
      }
      if (exit === 1) {
        var pct_ind$1 = pct_ind;
        var str_ind$2 = str_ind$1;
        var end_ind$1 = end_ind;
        var zero$1 = zero[0];
        var minus$1 = minus[0];
        var plus$1 = plus[0];
        var sharp$1 = sharp[0];
        var space$1 = space[0];
        var ign$1 = ign;
        if (str_ind$2 === end_ind$1) {
          invalid_format_message(end_ind$1, "unexpected end of format");
        }
        var padty = zero$1 !== 0 ? (
            minus$1 !== 0 ? (
                legacy_behavior$1 ? /* Left */0 : incompatible_flag(pct_ind$1, str_ind$2, /* "-" */45, "0")
              ) : /* Zeros */2
          ) : (
            minus$1 !== 0 ? /* Left */0 : /* Right */1
          );
        var match$1 = Caml_string.get(str, str_ind$2);
        var exit$1 = 0;
        if (match$1 >= 48) {
          if (match$1 >= 58) {
            exit$1 = 1;
          } else {
            var match$2 = parse_positive(str_ind$2, end_ind$1, 0);
            return parse_after_padding(pct_ind$1, match$2[0], end_ind$1, minus$1, plus$1, sharp$1, space$1, ign$1, /* Lit_padding */Block.__(0, [
                          padty,
                          match$2[1]
                        ]));
          }
        } else if (match$1 !== 42) {
          exit$1 = 1;
        } else {
          return parse_after_padding(pct_ind$1, str_ind$2 + 1 | 0, end_ind$1, minus$1, plus$1, sharp$1, space$1, ign$1, /* Arg_padding */Block.__(1, [padty]));
        }
        if (exit$1 === 1) {
          switch (padty) {
            case 0 : 
                if (!legacy_behavior$1) {
                  invalid_format_without(str_ind$2 - 1 | 0, /* "-" */45, "padding");
                }
                return parse_after_padding(pct_ind$1, str_ind$2, end_ind$1, minus$1, plus$1, sharp$1, space$1, ign$1, /* No_padding */0);
            case 1 : 
                return parse_after_padding(pct_ind$1, str_ind$2, end_ind$1, minus$1, plus$1, sharp$1, space$1, ign$1, /* No_padding */0);
            case 2 : 
                return parse_after_padding(pct_ind$1, str_ind$2, end_ind$1, minus$1, plus$1, sharp$1, space$1, ign$1, /* Lit_padding */Block.__(0, [
                              /* Right */1,
                              0
                            ]));
            
          }
        }
        
      }
      
    };
  };
  var is_int_base = function (symb) {
    var switcher = symb - 88 | 0;
    if (switcher > 32 || switcher < 0) {
      return /* false */0;
    } else {
      switch (switcher) {
        case 1 : 
        case 2 : 
        case 3 : 
        case 4 : 
        case 5 : 
        case 6 : 
        case 7 : 
        case 8 : 
        case 9 : 
        case 10 : 
        case 11 : 
        case 13 : 
        case 14 : 
        case 15 : 
        case 16 : 
        case 18 : 
        case 19 : 
        case 20 : 
        case 21 : 
        case 22 : 
        case 24 : 
        case 25 : 
        case 26 : 
        case 27 : 
        case 28 : 
        case 30 : 
        case 31 : 
            return /* false */0;
        case 0 : 
        case 12 : 
        case 17 : 
        case 23 : 
        case 29 : 
        case 32 : 
            return /* true */1;
        
      }
    }
  };
  var counter_of_char = function (symb) {
    var exit = 0;
    if (symb >= 108) {
      if (symb >= 111) {
        exit = 1;
      } else {
        switch (symb - 108 | 0) {
          case 0 : 
              return /* Line_counter */0;
          case 1 : 
              exit = 1;
              break;
          case 2 : 
              return /* Char_counter */1;
          
        }
      }
    } else if (symb !== 76) {
      exit = 1;
    } else {
      return /* Token_counter */2;
    }
    if (exit === 1) {
      throw [
            Caml_builtin_exceptions.assert_failure,
            [
              "camlinternalFormat.ml",
              2686,
              34
            ]
          ];
    }
    
  };
  var parse_char_set = function (str_ind, end_ind) {
    if (str_ind === end_ind) {
      invalid_format_message(end_ind, "unexpected end of format");
    }
    var char_set = Bytes.make(32, /* "\000" */0);
    var add_range = function (c, c$prime) {
      for(var i = c; i <= c$prime; ++i){
        add_in_char_set(char_set, Pervasives.char_of_int(i));
      }
      return /* () */0;
    };
    var fail_single_percent = function (str_ind) {
      return Curry._2(failwith_message(/* Format */[
                      /* String_literal */Block.__(11, [
                          "invalid format ",
                          /* Caml_string */Block.__(3, [
                              /* No_padding */0,
                              /* String_literal */Block.__(11, [
                                  ": '",
                                  /* Char_literal */Block.__(12, [
                                      /* "%" */37,
                                      /* String_literal */Block.__(11, [
                                          "' alone is not accepted in character sets, use ",
                                          /* Char_literal */Block.__(12, [
                                              /* "%" */37,
                                              /* Char_literal */Block.__(12, [
                                                  /* "%" */37,
                                                  /* String_literal */Block.__(11, [
                                                      " instead at position ",
                                                      /* Int */Block.__(4, [
                                                          /* Int_d */0,
                                                          /* No_padding */0,
                                                          /* No_precision */0,
                                                          /* Char_literal */Block.__(12, [
                                                              /* "." */46,
                                                              /* End_of_format */0
                                                            ])
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                      "invalid format %S: '%%' alone is not accepted in character sets, use %%%% instead at position %d."
                    ]), str, str_ind);
    };
    var parse_char_set_after_char = function (_str_ind, end_ind, _c) {
      while(true) {
        var c = _c;
        var str_ind = _str_ind;
        if (str_ind === end_ind) {
          invalid_format_message(end_ind, "unexpected end of format");
        }
        var c$prime = Caml_string.get(str, str_ind);
        var exit = 0;
        var exit$1 = 0;
        if (c$prime >= 46) {
          if (c$prime !== 64) {
            if (c$prime !== 93) {
              exit = 1;
            } else {
              add_in_char_set(char_set, c);
              return str_ind + 1 | 0;
            }
          } else {
            exit$1 = 2;
          }
        } else if (c$prime !== 37) {
          if (c$prime >= 45) {
            var str_ind$1 = str_ind + 1 | 0;
            var end_ind$1 = end_ind;
            var c$1 = c;
            if (str_ind$1 === end_ind$1) {
              invalid_format_message(end_ind$1, "unexpected end of format");
            }
            var c$prime$1 = Caml_string.get(str, str_ind$1);
            if (c$prime$1 !== 37) {
              if (c$prime$1 !== 93) {
                add_range(c$1, c$prime$1);
                return parse_char_set_content(str_ind$1 + 1 | 0, end_ind$1);
              } else {
                add_in_char_set(char_set, c$1);
                add_in_char_set(char_set, /* "-" */45);
                return str_ind$1 + 1 | 0;
              }
            } else {
              if ((str_ind$1 + 1 | 0) === end_ind$1) {
                invalid_format_message(end_ind$1, "unexpected end of format");
              }
              var c$prime$2 = Caml_string.get(str, str_ind$1 + 1 | 0);
              var exit$2 = 0;
              if (c$prime$2 !== 37 && c$prime$2 !== 64) {
                return fail_single_percent(str_ind$1);
              } else {
                exit$2 = 1;
              }
              if (exit$2 === 1) {
                add_range(c$1, c$prime$2);
                return parse_char_set_content(str_ind$1 + 2 | 0, end_ind$1);
              }
              
            }
          } else {
            exit = 1;
          }
        } else {
          exit$1 = 2;
        }
        if (exit$1 === 2) {
          if (c === /* "%" */37) {
            add_in_char_set(char_set, c$prime);
            return parse_char_set_content(str_ind + 1 | 0, end_ind);
          } else {
            exit = 1;
          }
        }
        if (exit === 1) {
          if (c === /* "%" */37) {
            fail_single_percent(str_ind);
          }
          add_in_char_set(char_set, c);
          _c = c$prime;
          _str_ind = str_ind + 1 | 0;
          continue ;
          
        }
        
      };
    };
    var parse_char_set_content = function (_str_ind, end_ind) {
      while(true) {
        var str_ind = _str_ind;
        if (str_ind === end_ind) {
          invalid_format_message(end_ind, "unexpected end of format");
        }
        var c = Caml_string.get(str, str_ind);
        if (c !== 45) {
          if (c !== 93) {
            return parse_char_set_after_char(str_ind + 1 | 0, end_ind, c);
          } else {
            return str_ind + 1 | 0;
          }
        } else {
          add_in_char_set(char_set, /* "-" */45);
          _str_ind = str_ind + 1 | 0;
          continue ;
          
        }
      };
    };
    var parse_char_set_start = function (str_ind, end_ind) {
      if (str_ind === end_ind) {
        invalid_format_message(end_ind, "unexpected end of format");
      }
      var c = Caml_string.get(str, str_ind);
      return parse_char_set_after_char(str_ind + 1 | 0, end_ind, c);
    };
    if (str_ind === end_ind) {
      invalid_format_message(end_ind, "unexpected end of format");
    }
    var match = Caml_string.get(str, str_ind);
    var match$1 = match !== 94 ? /* tuple */[
        str_ind,
        /* false */0
      ] : /* tuple */[
        str_ind + 1 | 0,
        /* true */1
      ];
    var next_ind = parse_char_set_start(match$1[0], end_ind);
    var char_set$1 = Bytes.to_string(char_set);
    return /* tuple */[
            next_ind,
            match$1[1] ? rev_char_set(char_set$1) : char_set$1
          ];
  };
  var check_open_box = function (fmt) {
    if (typeof fmt === "number" || !(fmt.tag === 11 && typeof fmt[1] === "number")) {
      return /* () */0;
    } else {
      try {
        open_box_of_string(fmt[0]);
        return /* () */0;
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === Caml_builtin_exceptions.failure) {
          return /* () */0;
        } else {
          throw exn;
        }
      }
    }
  };
  var parse_tag = function (is_open_tag, str_ind, end_ind) {
    try {
      if (str_ind === end_ind) {
        throw Caml_builtin_exceptions.not_found;
      }
      var match = Caml_string.get(str, str_ind);
      if (match !== 60) {
        throw Caml_builtin_exceptions.not_found;
      } else {
        var ind = $$String.index_from(str, str_ind + 1 | 0, /* ">" */62);
        if (ind >= end_ind) {
          throw Caml_builtin_exceptions.not_found;
        }
        var sub_str = $$String.sub(str, str_ind, (ind - str_ind | 0) + 1 | 0);
        var beg_ind = ind + 1 | 0;
        var match$1 = parse_literal(beg_ind, beg_ind, end_ind);
        var match$2 = parse_literal(str_ind, str_ind, ind + 1 | 0);
        var sub_fmt = match$2[0];
        var sub_format = /* Format */[
          sub_fmt,
          sub_str
        ];
        var formatting = is_open_tag ? /* Open_tag */Block.__(0, [sub_format]) : (check_open_box(sub_fmt), /* Open_box */Block.__(1, [sub_format]));
        return /* Fmt_EBB */[/* Formatting_gen */Block.__(18, [
                    formatting,
                    match$1[0]
                  ])];
      }
    }
    catch (exn){
      if (exn === Caml_builtin_exceptions.not_found) {
        var match$3 = parse_literal(str_ind, str_ind, end_ind);
        var sub_format$1 = /* Format */[
          /* End_of_format */0,
          ""
        ];
        var formatting$1 = is_open_tag ? /* Open_tag */Block.__(0, [sub_format$1]) : /* Open_box */Block.__(1, [sub_format$1]);
        return /* Fmt_EBB */[/* Formatting_gen */Block.__(18, [
                    formatting$1,
                    match$3[0]
                  ])];
      } else {
        throw exn;
      }
    }
  };
  return parse_literal(0, 0, str.length);
}

function format_of_string_fmtty(str, fmtty) {
  var match = fmt_ebb_of_string(/* None */0, str);
  try {
    return /* Format */[
            type_format(match[0], fmtty),
            str
          ];
  }
  catch (exn){
    if (exn === Type_mismatch) {
      return Curry._2(failwith_message(/* Format */[
                      /* String_literal */Block.__(11, [
                          "bad input: format type mismatch between ",
                          /* Caml_string */Block.__(3, [
                              /* No_padding */0,
                              /* String_literal */Block.__(11, [
                                  " and ",
                                  /* Caml_string */Block.__(3, [
                                      /* No_padding */0,
                                      /* End_of_format */0
                                    ])
                                ])
                            ])
                        ]),
                      "bad input: format type mismatch between %S and %S"
                    ]), str, string_of_fmtty(fmtty));
    } else {
      throw exn;
    }
  }
}

function format_of_string_format(str, param) {
  var match = fmt_ebb_of_string(/* None */0, str);
  try {
    return /* Format */[
            type_format(match[0], fmtty_of_fmt(param[0])),
            str
          ];
  }
  catch (exn){
    if (exn === Type_mismatch) {
      return Curry._2(failwith_message(/* Format */[
                      /* String_literal */Block.__(11, [
                          "bad input: format type mismatch between ",
                          /* Caml_string */Block.__(3, [
                              /* No_padding */0,
                              /* String_literal */Block.__(11, [
                                  " and ",
                                  /* Caml_string */Block.__(3, [
                                      /* No_padding */0,
                                      /* End_of_format */0
                                    ])
                                ])
                            ])
                        ]),
                      "bad input: format type mismatch between %S and %S"
                    ]), str, param[1]);
    } else {
      throw exn;
    }
  }
}

exports.is_in_char_set = is_in_char_set;
exports.rev_char_set = rev_char_set;
exports.create_char_set = create_char_set;
exports.add_in_char_set = add_in_char_set;
exports.freeze_char_set = freeze_char_set;
exports.param_format_of_ignored_format = param_format_of_ignored_format;
exports.make_printf = make_printf;
exports.output_acc = output_acc;
exports.bufput_acc = bufput_acc;
exports.strput_acc = strput_acc;
exports.type_format = type_format;
exports.fmt_ebb_of_string = fmt_ebb_of_string;
exports.format_of_string_fmtty = format_of_string_fmtty;
exports.format_of_string_format = format_of_string_format;
exports.char_of_iconv = char_of_iconv;
exports.string_of_formatting_lit = string_of_formatting_lit;
exports.string_of_formatting_gen = string_of_formatting_gen;
exports.string_of_fmtty = string_of_fmtty;
exports.string_of_fmt = string_of_fmt;
exports.open_box_of_string = open_box_of_string;
exports.symm = symm;
exports.trans = trans;
exports.recast = recast;
/* No side effect */


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Caml_builtin_exceptions = __webpack_require__(3);

function get(s, i) {
  if (i < 0 || i >= s.length) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "index out of bounds"
        ];
  } else {
    return s[i];
  }
}

exports.get = get;
/* No side effect */


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



function caml_int32_float_of_bits(x) {
  var int32 = new Int32Array(/* array */[x]);
  var float32 = new Float32Array(int32.buffer);
  return float32[0];
}

function caml_int32_bits_of_float(x) {
  var float32 = new Float32Array(/* float array */[x]);
  return new Int32Array(float32.buffer)[0];
}

function caml_classify_float(x) {
  if (isFinite(x)) {
    if (Math.abs(x) >= 2.2250738585072014e-308) {
      return /* FP_normal */0;
    } else if (x !== 0) {
      return /* FP_subnormal */1;
    } else {
      return /* FP_zero */2;
    }
  } else if (isNaN(x)) {
    return /* FP_nan */4;
  } else {
    return /* FP_infinite */3;
  }
}

function caml_modf_float(x) {
  if (isFinite(x)) {
    var neg = +(1 / x < 0);
    var x$1 = Math.abs(x);
    var i = Math.floor(x$1);
    var f = x$1 - i;
    if (neg) {
      return /* tuple */[
              -f,
              -i
            ];
    } else {
      return /* tuple */[
              f,
              i
            ];
    }
  } else if (isNaN(x)) {
    return /* tuple */[
            NaN,
            NaN
          ];
  } else {
    return /* tuple */[
            1 / x,
            x
          ];
  }
}

function caml_ldexp_float(x, exp) {
  var x$prime = x;
  var exp$prime = exp;
  if (exp$prime > 1023) {
    exp$prime -= 1023;
    x$prime = x$prime * Math.pow(2, 1023);
    if (exp$prime > 1023) {
      exp$prime -= 1023;
      x$prime = x$prime * Math.pow(2, 1023);
    }
    
  } else if (exp$prime < -1023) {
    exp$prime += 1023;
    x$prime = x$prime * Math.pow(2, -1023);
  }
  return x$prime * Math.pow(2, exp$prime);
}

function caml_frexp_float(x) {
  if (x === 0 || !isFinite(x)) {
    return /* tuple */[
            x,
            0
          ];
  } else {
    var neg = +(x < 0);
    var x$prime = Math.abs(x);
    var exp = Math.floor(Math.LOG2E * Math.log(x$prime)) + 1;
    x$prime = x$prime * Math.pow(2, -exp);
    if (x$prime < 0.5) {
      x$prime = x$prime * 2;
      exp -= 1;
    }
    if (neg) {
      x$prime = -x$prime;
    }
    return /* tuple */[
            x$prime,
            exp | 0
          ];
  }
}

function caml_copysign_float(x, y) {
  var x$1 = Math.abs(x);
  var y$1 = y === 0 ? 1 / y : y;
  if (y$1 < 0) {
    return -x$1;
  } else {
    return x$1;
  }
}

function caml_expm1_float(x) {
  var y = Math.exp(x);
  var z = y - 1;
  if (Math.abs(x) > 1) {
    return z;
  } else if (z === 0) {
    return x;
  } else {
    return x * z / Math.log(y);
  }
}

function caml_hypot_float(x, y) {
  var x0 = Math.abs(x);
  var y0 = Math.abs(y);
  var a = Math.max(x0, y0);
  var b = Math.min(x0, y0) / (
    a !== 0 ? a : 1
  );
  return a * Math.sqrt(1 + b * b);
}

function caml_log10_float(x) {
  return Math.LOG10E * Math.log(x);
}

exports.caml_int32_float_of_bits = caml_int32_float_of_bits;
exports.caml_int32_bits_of_float = caml_int32_bits_of_float;
exports.caml_classify_float = caml_classify_float;
exports.caml_modf_float = caml_modf_float;
exports.caml_ldexp_float = caml_ldexp_float;
exports.caml_frexp_float = caml_frexp_float;
exports.caml_copysign_float = caml_copysign_float;
exports.caml_expm1_float = caml_expm1_float;
exports.caml_hypot_float = caml_hypot_float;
exports.caml_log10_float = caml_log10_float;
/* No side effect */


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Link = __webpack_require__(13);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Fetch = __webpack_require__(25);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Network = __webpack_require__(7);
var Storage = __webpack_require__(14);
var Json_encode = __webpack_require__(23);
var ReasonReact = __webpack_require__(2);
var Login_iconSvg = __webpack_require__(109);
var Mail_inputSvg = __webpack_require__(29);
var Password_inputSvg = __webpack_require__(51);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var login = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var loginHeadBox = Css.style(/* :: */[
      Css.position(Css.relative),
      /* :: */[
        Css.textAlign(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.flexDirection(Css.column),
                /* :: */[
                  Css.margin4(Css.px(20), Css.px(0), Css.px(0), Css.px(0)),
                  /* :: */[
                    Css.fontSize(Css.px(24)),
                    /* :: */[
                      Css.width(Css.px(110)),
                      /* :: */[
                        Css.height(Css.px(110)),
                        /* :: */[
                          Css.borderRadius(/* `percent */[
                                -119887163,
                                50.0
                              ]),
                          /* :: */[
                            Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var loginIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.1,
                  1.1
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      -50.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(/* `percent */[
                  -119887163,
                  52.0
                ]),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(35)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var inputBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.padding(Css.px(10)),
                /* :: */[
                  Css.boxSizing(/* borderBox */9307263),
                  /* :: */[
                    Css.position(Css.relative),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var inputFieldBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.position(Css.relative),
            /* :: */[
              Css.boxSizing(/* borderBox */9307263),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding4(Css.px(5), Css.px(10), Css.px(5), Css.px(50)),
        /* :: */[
          Css.fontSize(Css.px(18)),
          /* :: */[
            Css.minHeight(Css.px(40)),
            /* :: */[
              Css.maxWidth(Css.px(300)),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.minWidth(Css.px(220)),
                  /* :: */[
                    Css.borderRadius(/* `px */[
                          25096,
                          50
                        ]),
                    /* :: */[
                      Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                            5194459,
                            "F492BD"
                          ]),
                      /* :: */[
                        Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                        /* :: */[
                          Css.boxSizing(/* borderBox */9307263),
                          /* :: */[
                            Css.position(Css.relative),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var mailInput = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.2,
                  1.2
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      0.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.left(Css.px(18)),
          /* :: */[
            Css.position(/* absolute */-1013592457),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(25)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var passwordInput = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.05,
                  1.05
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      0.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.left(Css.px(18)),
          /* :: */[
            Css.position(/* absolute */-1013592457),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(21)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* login */login,
  /* loginHeadBox */loginHeadBox,
  /* loginIcon */loginIcon,
  /* inputBox */inputBox,
  /* inputFieldBox */inputFieldBox,
  /* inputField */inputField,
  /* mailInput */mailInput,
  /* passwordInput */passwordInput,
  /* someLink */someLink
];

function text(prim) {
  return prim;
}

function validateEmail(value) {
  var emailRegex = (/.*@.*\..+/);
  if (value === "") {
    return /* Some */["Email Feld leer"];
  } else if (emailRegex.test(value)) {
    return /* None */0;
  } else {
    return /* Some */["Email Adresse enthält Fehler"];
  }
}

function validatePassword(value) {
  var match = +(value.length > 5);
  if (match !== 0) {
    return /* PassValid */0;
  } else {
    return /* PassNotValid */["Password zu kurz"];
  }
}

function logUserIn(data) {
  return Promise.resolve(data).then((function (prim) {
                      return prim.json();
                    })).then((function (json) {
                    Network.initializeSyncStatus2(Storage.setAccessTokenandExpiry(Storage.decodedTokenData(json)));
                    Network.pullData("", Network.successSyncAll);
                    return Promise.resolve(/* () */0);
                  })).then((function () {
                  console.log("all done for login !!!!!!");
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("Login response parse error", err), /* () */0));
              }));
}

function showPasswordError(data, self) {
  return Promise.resolve(data).then((function () {
                  console.log("Login error!");
                  Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, ["Logindaten nicht korrekt"]));
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("Login error exception", err), /* () */0));
              }));
}

function showOtherError(data) {
  return Promise.resolve(data).then((function () {
                  console.log("Other error!");
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("Other http error exception", err), /* () */0));
              }));
}

var component = ReasonReact.reducerComponent("Login");

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      var send = param[/* send */4];
      var state = param[/* state */2];
      var match = state[/* localStorageSupported */4];
      if (match !== 0) {
        var match$1 = state[/* error */2];
        var match$2 = state[/* loading */3];
        return React.createElement("div", {
                    className: login
                  }, React.createElement("div", {
                        className: loginHeadBox
                      }, React.createElement("img", {
                            className: loginIcon,
                            alt: "icon",
                            src: Login_iconSvg
                          })), React.createElement("h1", undefined, "Login"), React.createElement("div", {
                        className: inputBox
                      }, React.createElement("div", {
                            className: inputFieldBox
                          }, React.createElement("input", {
                                className: inputField,
                                autoFocus: true,
                                placeholder: "Email",
                                type: "email",
                                value: state[/* email */0],
                                onChange: (function ($$event) {
                                    return Curry._1(send, /* ChangeEmail */Block.__(0, [$$event.target.value]));
                                  })
                              }), React.createElement("img", {
                                className: mailInput,
                                alt: "mail",
                                src: Mail_inputSvg
                              })), React.createElement("div", {
                            className: inputFieldBox
                          }, React.createElement("input", {
                                className: inputField,
                                placeholder: "Passwort",
                                type: "password",
                                value: state[/* password */1],
                                onKeyDown: (function ($$event) {
                                    if ($$event.keyCode === 13) {
                                      $$event.preventDefault();
                                      return Curry._1(send, /* NewLoginEnterKeyDown */1);
                                    } else {
                                      return Curry._1(send, /* NewLoginOtherKeyDown */0);
                                    }
                                  }),
                                onChange: (function ($$event) {
                                    return Curry._1(send, /* ChangePassword */Block.__(1, [$$event.target.value]));
                                  })
                              }), React.createElement("img", {
                                className: passwordInput,
                                alt: "pass",
                                src: Password_inputSvg
                              }))), match$1 ? React.createElement("div", {
                          className: "failure"
                        }, match$1[0]) : null, React.createElement("button", {
                        className: Theme.simpleButton(/* () */0),
                        onClick: (function () {
                            return Curry._1(send, /* Login */2);
                          })
                      }, match$2 !== 0 ? React.createElement("div", {
                              className: "button-spinner"
                            }) : "Login"), ReasonReact.element(/* None */0, /* None */0, Link.make("/register", "zur Registrierung", someLink, /* array */[])), ReasonReact.element(/* None */0, /* None */0, Link.make("/reset", "zum Passwort Reset", someLink, /* array */[])));
      } else {
        return React.createElement("div", {
                    className: login
                  }, React.createElement("h1", undefined, "Bitte LocalStorage und Cookies zulassen"));
      }
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* email */Network.getUrlParamCode(/* Email */1),
              /* password */"",
              /* error : None */0,
              /* loading : false */0,
              /* localStorageSupported */Storage.localStorageSupported(/* () */0)
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* SideEffects */Block.__(2, [(function (self) {
                            return Curry._1(self[/* send */4], /* Login */2);
                          })]);
          case 2 : 
              var emailValid = validateEmail(state[/* email */0]);
              if (emailValid) {
                var error = emailValid[0];
                return /* SideEffects */Block.__(2, [(function (self) {
                              return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, [error]));
                            })]);
              } else {
                var passwordValid = validatePassword(state[/* password */1]);
                if (passwordValid) {
                  var error$1 = passwordValid[0];
                  return /* SideEffects */Block.__(2, [(function (self) {
                                return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, [error$1]));
                              })]);
                } else {
                  return /* UpdateWithSideEffects */Block.__(3, [
                            /* record */[
                              /* email */state[/* email */0],
                              /* password */state[/* password */1],
                              /* error */state[/* error */2],
                              /* loading : true */1,
                              /* localStorageSupported */state[/* localStorageSupported */4]
                            ],
                            (function (self) {
                                var requestPayload = Json_encode.object_(/* :: */[
                                      /* tuple */[
                                        "client_id",
                                        Network.mBBClientId
                                      ],
                                      /* :: */[
                                        /* tuple */[
                                          "client_secret",
                                          Network.mBBClientSecret
                                        ],
                                        /* :: */[
                                          /* tuple */[
                                            "grant_type",
                                            Network.grantType
                                          ],
                                          /* :: */[
                                            /* tuple */[
                                              "username",
                                              self[/* state */2][/* email */0]
                                            ],
                                            /* :: */[
                                              /* tuple */[
                                                "password",
                                                self[/* state */2][/* password */1]
                                              ],
                                              /* [] */0
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]);
                                fetch(Network.loginUrl, Fetch.RequestInit[/* make */0](/* Some */[/* Post */2], /* Some */[{
                                                  "Content-Type": "application/json",
                                                  Accept: "application.json"
                                                }], /* Some */[JSON.stringify(requestPayload)], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0)).then((function (data) {
                                          var statusCode = data.status;
                                          console.log("https status: ", statusCode);
                                          if (statusCode !== 200) {
                                            if (statusCode !== 400) {
                                              Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, ["Loginfehler"]));
                                              return showOtherError(data);
                                            } else {
                                              return showPasswordError(data, self);
                                            }
                                          } else {
                                            return logUserIn(data);
                                          }
                                        })).catch((function (err) {
                                        return Promise.resolve((console.log("api error login", err), Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, ["Netzwerkfehler"]))));
                                      }));
                                return /* () */0;
                              })
                          ]);
                }
              }
          case 3 : 
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* email */state[/* email */0],
                          /* password */state[/* password */1],
                          /* error */state[/* error */2],
                          /* loading : false */0,
                          /* localStorageSupported */state[/* localStorageSupported */4]
                        ],
                        (function () {
                            return ReasonReact.Router[/* push */0]("/dashboard");
                          })
                      ]);
          case 4 : 
              return /* Update */Block.__(0, [/* record */[
                          /* email */state[/* email */0],
                          /* password */state[/* password */1],
                          /* error : None */0,
                          /* loading */state[/* loading */3],
                          /* localStorageSupported */state[/* localStorageSupported */4]
                        ]]);
          
        }
      } else {
        switch (action.tag | 0) {
          case 0 : 
              return /* Update */Block.__(0, [/* record */[
                          /* email */action[0],
                          /* password */state[/* password */1],
                          /* error */state[/* error */2],
                          /* loading */state[/* loading */3],
                          /* localStorageSupported */state[/* localStorageSupported */4]
                        ]]);
          case 1 : 
              return /* Update */Block.__(0, [/* record */[
                          /* email */state[/* email */0],
                          /* password */action[0],
                          /* error */state[/* error */2],
                          /* loading */state[/* loading */3],
                          /* localStorageSupported */state[/* localStorageSupported */4]
                        ]]);
          case 2 : 
              var text = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* email */state[/* email */0],
                          /* password */state[/* password */1],
                          /* error : Some */[text],
                          /* loading : false */0,
                          /* localStorageSupported */state[/* localStorageSupported */4]
                        ],
                        (function (self) {
                            console.log("ShowErrorMessage Reducer:", text);
                            setTimeout((function () {
                                    return Curry._1(self[/* send */4], /* ClearError */4);
                                  }), 2500);
                            return /* () */0;
                          })
                      ]);
          
        }
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.validateEmail = validateEmail;
exports.validatePassword = validatePassword;
exports.logUserIn = logUserIn;
exports.showPasswordError = showPasswordError;
exports.showOtherError = showOtherError;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/login_icon.f6d2b47a.svg";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Link = __webpack_require__(13);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Fetch = __webpack_require__(25);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Network = __webpack_require__(7);
var Json_encode = __webpack_require__(23);
var ReasonReact = __webpack_require__(2);
var Mail_inputSvg = __webpack_require__(29);
var Password_resetSvg = __webpack_require__(111);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var reset = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var resetHeadBox = Css.style(/* :: */[
      Css.position(Css.relative),
      /* :: */[
        Css.textAlign(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.flexDirection(Css.column),
                /* :: */[
                  Css.margin4(Css.px(20), Css.px(0), Css.px(0), Css.px(0)),
                  /* :: */[
                    Css.fontSize(Css.px(24)),
                    /* :: */[
                      Css.width(Css.px(110)),
                      /* :: */[
                        Css.height(Css.px(110)),
                        /* :: */[
                          Css.borderRadius(/* `percent */[
                                -119887163,
                                50.0
                              ]),
                          /* :: */[
                            Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var resetIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.1,
                  1.1
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      -50.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(/* `percent */[
                  -119887163,
                  52.0
                ]),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(35)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var resetText = Css.style(/* :: */[
      Css.padding(Css.px(10)),
      /* :: */[
        Css.textAlign(/* center */98248149),
        /* :: */[
          Css.color(/* `hex */[
                5194459,
                "F66297"
              ]),
          /* [] */0
        ]
      ]
    ]);

var inputBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.padding(Css.px(10)),
                /* :: */[
                  Css.boxSizing(/* borderBox */9307263),
                  /* :: */[
                    Css.position(Css.relative),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var inputFieldBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.position(Css.relative),
            /* :: */[
              Css.boxSizing(/* borderBox */9307263),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding4(Css.px(5), Css.px(10), Css.px(5), Css.px(50)),
        /* :: */[
          Css.fontSize(Css.px(18)),
          /* :: */[
            Css.minHeight(Css.px(40)),
            /* :: */[
              Css.maxWidth(Css.px(300)),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.minWidth(Css.px(220)),
                  /* :: */[
                    Css.borderRadius(/* `px */[
                          25096,
                          50
                        ]),
                    /* :: */[
                      Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                            5194459,
                            "F492BD"
                          ]),
                      /* :: */[
                        Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                        /* :: */[
                          Css.boxSizing(/* borderBox */9307263),
                          /* :: */[
                            Css.position(Css.relative),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var mailInput = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.2,
                  1.2
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      0.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.left(Css.px(18)),
          /* :: */[
            Css.position(/* absolute */-1013592457),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(25)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* reset */reset,
  /* resetHeadBox */resetHeadBox,
  /* resetIcon */resetIcon,
  /* resetText */resetText,
  /* inputBox */inputBox,
  /* inputFieldBox */inputFieldBox,
  /* inputField */inputField,
  /* mailInput */mailInput,
  /* someLink */someLink
];

function text(prim) {
  return prim;
}

function validateEmail(value) {
  var emailRegex = (/.*@.*\..+/);
  if (value === "") {
    return /* Some */["Email Feld leer"];
  } else if (emailRegex.test(value)) {
    return /* None */0;
  } else {
    return /* Some */["Email Adresse enthält Fehler"];
  }
}

function showApiError(data, self, message) {
  return Promise.resolve(data).then((function () {
                  console.log("Login error!");
                  Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(1, [message]));
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("API error exception", err), /* () */0));
              }));
}

var component = ReasonReact.reducerComponent("Reset");

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      var send = param[/* send */4];
      var state = param[/* state */2];
      var match = state[/* error */1];
      var match$1 = state[/* success */2];
      var match$2 = state[/* loading */3];
      return React.createElement("div", {
                  className: reset
                }, React.createElement("div", {
                      className: resetHeadBox
                    }, React.createElement("img", {
                          className: resetIcon,
                          alt: "icon",
                          src: Password_resetSvg
                        })), React.createElement("h1", undefined, "Passwort Reset"), React.createElement("div", {
                      className: resetText
                    }, "Bitte gebe zum Reset deines Passworts deine Email Adresse ein. Wir senden dir einen Reset Link zu."), React.createElement("div", {
                      className: inputBox
                    }, React.createElement("div", {
                          className: inputFieldBox
                        }, React.createElement("input", {
                              className: inputField,
                              autoFocus: true,
                              placeholder: "Email",
                              type: "email",
                              value: state[/* email */0],
                              onKeyDown: (function ($$event) {
                                  if ($$event.keyCode === 13) {
                                    $$event.preventDefault();
                                    return Curry._1(send, /* ResetEnterKeyDown */1);
                                  } else {
                                    return Curry._1(send, /* ResetOtherKeyDown */0);
                                  }
                                }),
                              onChange: (function ($$event) {
                                  return Curry._1(send, /* ChangeEmail */Block.__(0, [$$event.target.value]));
                                })
                            }), React.createElement("img", {
                              className: mailInput,
                              alt: "mail",
                              src: Mail_inputSvg
                            }))), match ? React.createElement("div", {
                        className: "failure"
                      }, match[0]) : null, match$1 ? React.createElement("div", {
                        className: "success"
                      }, match$1[0]) : null, React.createElement("button", {
                      className: Theme.simpleButton(/* () */0),
                      onClick: (function () {
                          return Curry._1(send, /* Reset */2);
                        })
                    }, match$2 !== 0 ? React.createElement("div", {
                            className: "button-spinner"
                          }) : "Absenden"), ReasonReact.element(/* None */0, /* None */0, Link.make("/login", "zum Login", someLink, /* array */[])));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* email */"",
              /* error : None */0,
              /* success : None */0,
              /* loading : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* SideEffects */Block.__(2, [(function (self) {
                            return Curry._1(self[/* send */4], /* Reset */2);
                          })]);
          case 2 : 
              var emailValid = validateEmail(state[/* email */0]);
              if (emailValid) {
                var error = emailValid[0];
                return /* SideEffects */Block.__(2, [(function (self) {
                              return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(1, [error]));
                            })]);
              } else {
                return /* UpdateWithSideEffects */Block.__(3, [
                          /* record */[
                            /* email */state[/* email */0],
                            /* error */state[/* error */1],
                            /* success */state[/* success */2],
                            /* loading : true */1
                          ],
                          (function (self) {
                              var requestPayload = Json_encode.object_(/* :: */[
                                    /* tuple */[
                                      "email",
                                      self[/* state */2][/* email */0]
                                    ],
                                    /* [] */0
                                  ]);
                              fetch(Network.resetUrl, Fetch.RequestInit[/* make */0](/* Some */[/* Post */2], /* Some */[{
                                                "Content-Type": "application/json",
                                                Accept: "application.json"
                                              }], /* Some */[JSON.stringify(requestPayload)], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0)).then((function (data) {
                                        var statusCode = data.status;
                                        console.log("https status: ", statusCode);
                                        if (statusCode !== 201) {
                                          return showApiError(data, self, "Http Fehler: " + String(statusCode));
                                        } else {
                                          console.log("Reset initiated");
                                          Curry._1(self[/* send */4], /* ShowSuccessMessage */Block.__(2, ["Wir haben dir eine Email gesendet. Bitte prüfe deinen Posteingang."]));
                                          return Promise.resolve(/* () */0);
                                        }
                                      })).catch((function (err) {
                                      return Promise.resolve((console.log("Api error", err), Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(1, ["Netzwerkfehler"]))));
                                    }));
                              return /* () */0;
                            })
                        ]);
              }
          case 3 : 
              return /* Update */Block.__(0, [/* record */[
                          /* email */state[/* email */0],
                          /* error : None */0,
                          /* success */state[/* success */2],
                          /* loading */state[/* loading */3]
                        ]]);
          case 4 : 
              return /* Update */Block.__(0, [/* record */[
                          /* email */state[/* email */0],
                          /* error */state[/* error */1],
                          /* success : None */0,
                          /* loading */state[/* loading */3]
                        ]]);
          
        }
      } else {
        switch (action.tag | 0) {
          case 0 : 
              return /* Update */Block.__(0, [/* record */[
                          /* email */action[0],
                          /* error */state[/* error */1],
                          /* success */state[/* success */2],
                          /* loading */state[/* loading */3]
                        ]]);
          case 1 : 
              var text = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* email */state[/* email */0],
                          /* error : Some */[text],
                          /* success */state[/* success */2],
                          /* loading : false */0
                        ],
                        (function (self) {
                            console.log("ShowErrorMessage Reducer:", text);
                            setTimeout((function () {
                                    return Curry._1(self[/* send */4], /* ClearError */3);
                                  }), 2500);
                            return /* () */0;
                          })
                      ]);
          case 2 : 
              var text$1 = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* email */"",
                          /* error */state[/* error */1],
                          /* success : Some */[text$1],
                          /* loading : false */0
                        ],
                        (function () {
                            console.log("ShowSuccessMessage Reducer:", text$1);
                            setTimeout((function () {
                                    return ReasonReact.Router[/* push */0]("/");
                                  }), 3000);
                            return /* () */0;
                          })
                      ]);
          
        }
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.validateEmail = validateEmail;
exports.showApiError = showApiError;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/password_reset.1710e8a4.svg";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Js_exn = __webpack_require__(10);
var Network = __webpack_require__(7);
var Caml_format = __webpack_require__(8);
var ReasonReact = __webpack_require__(2);
var Cta_arrowSvg = __webpack_require__(52);
var Typ1_iconSvg = __webpack_require__(113);
var Typ2_iconSvg = __webpack_require__(114);
var Start_iconSvg = __webpack_require__(115);
var Caml_builtin_exceptions = __webpack_require__(3);
var Start_gas_bgSvg = __webpack_require__(116);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var wizard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.fontWeight(700),
        /* [] */0
      ]
    ]);

var inputHeaderHead = Css.style(/* :: */[
      Css.margin4(Css.px(30), Css.px(0), Css.px(25), Css.px(0)),
      /* [] */0
    ]);

var inputHeaderText = Css.style(/* :: */[
      Css.fontWeight(700),
      /* :: */[
        Css.color(/* `hex */[
              5194459,
              "F66297"
            ]),
        /* :: */[
          Css.margin4(Css.px(15), Css.px(20), Css.px(25), Css.px(20)),
          /* :: */[
            Css.zIndex(2),
            /* [] */0
          ]
        ]
      ]
    ]);

var initialBody = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.justifyContent(/* center */98248149),
          /* [] */0
        ]
      ]
    ]);

var initialBodyImg = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(10), Css.px(5), Css.px(10)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* [] */0
        ]
      ]
    ]);

var initialBodyImgHigh = Css.style(/* :: */[
      Css.margin4(Css.px(2), Css.px(7), Css.px(2), Css.px(7)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.borderStyle(Css.solid),
          /* :: */[
            Css.cursor(/* pointer */-786317123),
            /* [] */0
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(15), Css.px(0), Css.px(15), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(20)),
        /* :: */[
          Css.fontSize(Css.px(28)),
          /* :: */[
            Css.maxWidth(Css.px(140)),
            /* :: */[
              Css.borderRadius(/* `px */[
                    25096,
                    50
                  ]),
              /* :: */[
                Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                      5194459,
                      "F492BD"
                    ]),
                /* :: */[
                  Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                  /* :: */[
                    Css.boxSizing(/* borderBox */9307263),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var smallArrow = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.margin2(Css.px(0), Css.px(8)),
        /* :: */[
          Css.transform(/* `scale */[
                -120664438,
                /* tuple */[
                  1.2,
                  1.2
                ]
              ]),
          /* [] */0
        ]
      ]
    ]);

var typIcons = Css.style(/* :: */[
      Css.margin2(Css.px(10), Css.px(8)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.2,
                1.2
              ]
            ]),
        /* [] */0
      ]
    ]);

var horizonBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.margin4(Css.px(30), Css.px(8), Css.px(0), Css.px(0)),
              /* :: */[
                Css.width(Css.px(140)),
                /* :: */[
                  Css.justifyContent(/* spaceAround */-485895757),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBoxEl = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(0), Css.px(0)),
      /* :: */[
        Css.fontSize(Css.px(24)),
        /* :: */[
          Css.width(Css.px(22)),
          /* :: */[
            Css.height(Css.px(22)),
            /* :: */[
              Css.borderRadius(/* `percent */[
                    -119887163,
                    50.0
                  ]),
              /* :: */[
                Css.background(/* `hex */[
                      5194459,
                      "FCEBEC"
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBoxElSmall = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(0), Css.px(0)),
      /* :: */[
        Css.fontSize(Css.px(24)),
        /* :: */[
          Css.width(Css.px(10)),
          /* :: */[
            Css.height(Css.px(10)),
            /* :: */[
              Css.borderRadius(/* `percent */[
                    -119887163,
                    50.0
                  ]),
              /* :: */[
                Css.background(/* `hex */[
                      5194459,
                      "FCEBEC"
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var rocketBox = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.position(Css.relative),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(/* center */98248149),
            /* [] */0
          ]
        ]
      ]
    ]);

var rocket = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
        /* :: */[
          Css.fontSize(Css.px(24)),
          /* :: */[
            Css.width(Css.px(160)),
            /* :: */[
              Css.height(Css.px(160)),
              /* :: */[
                Css.borderRadius(/* `percent */[
                      -119887163,
                      50.0
                    ]),
                /* :: */[
                  Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var startIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.2,
                  1.2
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      -50.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(/* `percent */[
                  -119887163,
                  50.0
                ]),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(30)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var startGas = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.0,
                  1.0
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      -50.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(/* `percent */[
                  -119887163,
                  50.0
                ]),
            /* :: */[
              Css.top(Css.px(163)),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var selectorBox = Css.style(/* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.height(Css.px(200)),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.maxWidth(Css.px(150)),
            /* :: */[
              Css.justifyContent(/* center */98248149),
              /* :: */[
                Css.border(Css.px(4), /* solid */12956715, /* `hex */[
                      5194459,
                      "FFEEEF"
                    ]),
                /* :: */[
                  Css.borderRadius(Css.px(10)),
                  /* :: */[
                    Css.margin(Css.px(10)),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var selectorBoxHigh = Css.style(/* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.height(Css.px(200)),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.maxWidth(Css.px(150)),
            /* :: */[
              Css.justifyContent(/* center */98248149),
              /* :: */[
                Css.border(Css.px(4), /* solid */12956715, /* `hex */[
                      5194459,
                      "EEBFC2"
                    ]),
                /* :: */[
                  Css.borderRadius(Css.px(10)),
                  /* :: */[
                    Css.margin(Css.px(10)),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

function nextButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(160)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(35), Css.px(18), Css.px(10), Css.px(18)),
                  Theme.greenButtonRaw
                ]
              ]
            ]);
}

function nextButton2() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(160)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(5), Css.px(18), Css.px(10), Css.px(18)),
                  /* :: */[
                    Css.zIndex(2),
                    Theme.greenButtonRaw
                  ]
                ]
              ]
            ]);
}

function selectButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(200)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(20), Css.px(18), Css.px(10), Css.px(18)),
                  Theme.greenButtonRaw
                ]
              ]
            ]);
}

var Styles = /* module */[
  /* card */card,
  /* wizard */wizard,
  /* inputHeader */inputHeader,
  /* inputHeaderHead */inputHeaderHead,
  /* inputHeaderText */inputHeaderText,
  /* initialBody */initialBody,
  /* initialBodyImg */initialBodyImg,
  /* initialBodyImgHigh */initialBodyImgHigh,
  /* flexList */flexList,
  /* inputField */inputField,
  /* someLink */someLink,
  /* smallArrow */smallArrow,
  /* typIcons */typIcons,
  /* horizonBox */horizonBox,
  /* horizonBoxEl */horizonBoxEl,
  /* horizonBoxElSmall */horizonBoxElSmall,
  /* rocketBox */rocketBox,
  /* rocket */rocket,
  /* startIcon */startIcon,
  /* startGas */startGas,
  /* selectorBox */selectorBox,
  /* selectorBoxHigh */selectorBoxHigh,
  /* nextButton */nextButton,
  /* nextButton2 */nextButton2,
  /* selectButton */selectButton
];

function text(prim) {
  return prim;
}

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      return 0;
    } else {
      throw exn;
    }
  }
}

function checkForInt(x) {
  var x2 = convToInt(x);
  if (x2 > 0 && x2 < 200) {
    return x2;
  } else {
    return 0;
  }
}

function turnBackToString(theInt) {
  if (theInt !== 0) {
    return String(theInt);
  } else {
    return "0";
  }
}

var component = ReasonReact.reducerComponent("ResetExec");

function make(step, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      var match = +(self[/* state */2][/* levelSelect */3] > 0);
      if (match !== 0) {
        ReasonReact.Router[/* push */0]("/wizard/4");
      }
      var match$1 = +(self[/* state */2][/* imageSelect */2] > 0);
      if (match$1 !== 0) {
        ReasonReact.Router[/* push */0]("/wizard/3");
      }
      var match$2 = +(self[/* state */2][/* weight */1] > 0);
      if (match$2 !== 0) {
        ReasonReact.Router[/* push */0]("/wizard/2");
      }
      window.scrollTo(0, 0);
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (param) {
      var send = param[/* send */4];
      var state = param[/* state */2];
      var match = state[/* error */5];
      var step1 = React.createElement("div", {
            className: flexList
          }, React.createElement("h1", {
                className: inputHeaderHead
              }, "Aktuelles Gewicht"), React.createElement("div", {
                className: inputHeaderText
              }, "Hey, trage jetzt dein aktuelles Gewicht ein:"), React.createElement("input", {
                className: inputField,
                autoFocus: true,
                pattern: "[0-9]*",
                placeholder: "Kg",
                type: "number",
                value: state[/* weightInput */0],
                onKeyDown: (function ($$event) {
                    if ($$event.keyCode === 13) {
                      $$event.preventDefault();
                      return Curry._1(send, /* Step1InputEnterKeyDown */1);
                    } else {
                      return Curry._1(send, /* Step1InputOtherKeyDown */0);
                    }
                  }),
                onChange: (function ($$event) {
                    return Curry._1(send, /* ChangeWeight */Block.__(0, [$$event.target.value]));
                  })
              }), match ? React.createElement("div", {
                  className: "failure"
                }, match[0]) : null, React.createElement("button", {
                className: nextButton(/* () */0),
                onClick: (function () {
                    return Curry._1(send, /* Step1Exec */2);
                  })
              }, "Weiter", React.createElement("img", {
                    className: smallArrow,
                    alt: "arrow",
                    src: Cta_arrowSvg
                  })), React.createElement("div", {
                className: horizonBox
              }, React.createElement("div", {
                    className: horizonBoxEl
                  }), React.createElement("div", {
                    className: horizonBoxElSmall
                  }), React.createElement("div", {
                    className: horizonBoxElSmall
                  })));
      var match$1 = state[/* imageSelect */2];
      var className21 = match$1 !== 1500 ? selectorBox : selectorBoxHigh;
      var match$2 = +(state[/* imageSelect */2] === 1300);
      var x = match$2 !== 0 ? selectorBoxHigh : selectorBox;
      var match$3 = state[/* error */5];
      var step2 = React.createElement("div", {
            className: flexList
          }, React.createElement("h1", {
                className: inputHeaderHead
              }, "Ausgangsform"), React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: className21,
                    onClick: (function () {
                        return Curry._1(send, /* Step2ImageSelect */Block.__(1, [1500]));
                      })
                  }, React.createElement("img", {
                        className: typIcons,
                        alt: "typ1",
                        src: Typ1_iconSvg
                      })), React.createElement("div", {
                    className: x,
                    onClick: (function () {
                        return Curry._1(send, /* Step2ImageSelect */Block.__(1, [1300]));
                      })
                  }, React.createElement("img", {
                        className: typIcons,
                        alt: "typ2",
                        src: Typ2_iconSvg
                      }))), React.createElement("div", {
                className: inputHeaderText
              }, "Schätze nun anhand der Skizzen deine Ausgangsform ein."), match$3 ? React.createElement("div", {
                  className: "failure"
                }, match$3[0]) : null, React.createElement("button", {
                className: nextButton2(/* () */0),
                onClick: (function () {
                    return Curry._1(send, /* Step2Exec */3);
                  })
              }, "Weiter", React.createElement("img", {
                    className: smallArrow,
                    alt: "arrow",
                    src: Cta_arrowSvg
                  })), React.createElement("div", {
                className: horizonBox
              }, React.createElement("div", {
                    className: horizonBoxElSmall
                  }), React.createElement("div", {
                    className: horizonBoxEl
                  }), React.createElement("div", {
                    className: horizonBoxElSmall
                  })));
      var step3 = React.createElement("div", {
            className: flexList
          }, React.createElement("h1", {
                className: inputHeaderHead
              }, "Belastungsumfang"), React.createElement("div", {
                className: inputHeaderText
              }, "Wähle deinen Belastungsumfang aus."), React.createElement("button", {
                className: selectButton(/* () */0),
                onClick: (function () {
                    return Curry._1(send, /* Step3LevelSelect */Block.__(2, [30]));
                  })
              }, "Anfänger"), React.createElement("button", {
                className: selectButton(/* () */0),
                onClick: (function () {
                    return Curry._1(send, /* Step3LevelSelect */Block.__(2, [45]));
                  })
              }, "Fortgeschritten"), React.createElement("button", {
                className: selectButton(/* () */0),
                onClick: (function () {
                    return Curry._1(send, /* Step3LevelSelect */Block.__(2, [60]));
                  })
              }, "Profi"), React.createElement("div", {
                className: inputHeaderText
              }, "Je nach Stufe liegt die Belastungszeit pro Übung bei 30, 45 oder 60 Sekunden."), React.createElement("div", {
                className: horizonBox
              }, React.createElement("div", {
                    className: horizonBoxElSmall
                  }), React.createElement("div", {
                    className: horizonBoxElSmall
                  }), React.createElement("div", {
                    className: horizonBoxEl
                  })));
      var step4 = React.createElement("div", {
            className: flexList
          }, React.createElement("h1", {
                className: inputHeaderHead
              }, "Jetzt kann's losgehen"), React.createElement("div", {
                className: rocketBox
              }, React.createElement("div", {
                    className: rocket
                  }, React.createElement("img", {
                        className: startIcon,
                        alt: "icon",
                        src: Start_iconSvg
                      }), React.createElement("img", {
                        className: startGas,
                        alt: "gas",
                        src: Start_gas_bgSvg
                      }))), React.createElement("div", {
                className: inputHeaderText
              }, "Du hast es geschafft. Dein Trainingsplan wurde nun erstellt. Im nächsten Step wird dir dieser mit den zugehörigen Workouts angezeigt."), React.createElement("button", {
                className: nextButton2(/* () */0),
                onClick: (function () {
                    return ReasonReact.Router[/* push */0]("/dashboard");
                  })
              }, "Starten"));
      var tmp;
      switch (step) {
        case "1" : 
            tmp = step1;
            break;
        case "2" : 
            tmp = step2;
            break;
        case "3" : 
            tmp = step3;
            break;
        case "4" : 
            tmp = step4;
            break;
        default:
          tmp = React.createElement("p", undefined, "no mapping");
      }
      return React.createElement("div", {
                  className: wizard
                }, tmp);
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* weightInput */"",
              /* weight */0,
              /* imageSelect */0,
              /* levelSelect */0,
              /* loading : false */0,
              /* error : None */0,
              /* mySectionRef */[/* None */0]
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* SideEffects */Block.__(2, [(function () {
                            return ReasonReact.Router[/* push */0]("/wizard/2");
                          })]);
          case 2 : 
              return /* SideEffects */Block.__(2, [(function (self) {
                            var match = +(state[/* weight */1] > 36 && state[/* weight */1] < 200);
                            if (match !== 0) {
                              window.scrollTo(0, 0);
                              return ReasonReact.Router[/* push */0]("/wizard/2");
                            } else {
                              return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(3, ["Bitte Gewicht korrigieren"]));
                            }
                          })]);
          case 3 : 
              return /* SideEffects */Block.__(2, [(function (self) {
                            var match = +(state[/* imageSelect */2] > 0);
                            if (match !== 0) {
                              window.scrollTo(0, 0);
                              return ReasonReact.Router[/* push */0]("/wizard/3");
                            } else {
                              return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(3, ["Bitte Form selektieren"]));
                            }
                          })]);
          case 4 : 
              var newrecord = state.slice();
              return /* Update */Block.__(0, [(newrecord[/* error */5] = /* None */0, newrecord)]);
          
        }
      } else {
        switch (action.tag | 0) {
          case 0 : 
              var validInt = checkForInt(action[0]);
              return /* Update */Block.__(0, [/* record */[
                          /* weightInput */turnBackToString(validInt),
                          /* weight */validInt,
                          /* imageSelect */state[/* imageSelect */2],
                          /* levelSelect */state[/* levelSelect */3],
                          /* loading */state[/* loading */4],
                          /* error */state[/* error */5],
                          /* mySectionRef */state[/* mySectionRef */6]
                        ]]);
          case 1 : 
              var newrecord$1 = state.slice();
              return /* Update */Block.__(0, [(newrecord$1[/* imageSelect */2] = action[0], newrecord$1)]);
          case 2 : 
              var newrecord$2 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$2[/* levelSelect */3] = action[0], newrecord$2),
                        (function (self) {
                            Network.safeWizardResultToLs(/* tuple */[
                                  self[/* state */2][/* weight */1],
                                  self[/* state */2][/* imageSelect */2],
                                  self[/* state */2][/* levelSelect */3]
                                ]);
                            window.scrollTo(0, 0);
                            return ReasonReact.Router[/* push */0]("/wizard/4");
                          })
                      ]);
          case 3 : 
              var text = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* weightInput */state[/* weightInput */0],
                          /* weight */state[/* weight */1],
                          /* imageSelect */state[/* imageSelect */2],
                          /* levelSelect */state[/* levelSelect */3],
                          /* loading : false */0,
                          /* error : Some */[text],
                          /* mySectionRef */state[/* mySectionRef */6]
                        ],
                        (function (self) {
                            console.log("ShowErrorMessage Reducer:", text);
                            setTimeout((function () {
                                    return Curry._1(self[/* send */4], /* ClearError */4);
                                  }), 2500);
                            return /* () */0;
                          })
                      ]);
          
        }
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.convToInt = convToInt;
exports.checkForInt = checkForInt;
exports.turnBackToString = turnBackToString;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/typ1_icon.4c23ffba.svg";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/typ2_icon.32b71ce1.svg";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/start_icon.8b8c0ffa.svg";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/start_gas_bg.163eb387.svg";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Link = __webpack_require__(13);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Js_exn = __webpack_require__(10);
var Caml_format = __webpack_require__(8);
var ReasonReact = __webpack_require__(2);
var Lunch_iconSvg = __webpack_require__(53);
var Snack_iconSvg = __webpack_require__(54);
var Caml_builtin_exceptions = __webpack_require__(3);
var Dinner_iconSvg = __webpack_require__(55);
var Breakfast_iconSvg = __webpack_require__(56);
var Mahlzeiten_patternPng = __webpack_require__(118);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.backgroundImage(/* `url */[
            5843823,
            Mahlzeiten_patternPng
          ]),
      /* :: */[
        Css.textAlign(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.borderRadius(Css.px(8)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var contentContainer = Css.style(/* :: */[
      Css.background(Css.white),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.width(/* `percent */[
                  -119887163,
                  100.0
                ]),
            /* :: */[
              Css.margin4(Css.px(14), Css.px(0), Css.px(10), Css.px(0)),
              /* :: */[
                Css.borderTopLeftRadius(Css.px(10)),
                /* :: */[
                  Css.borderTopRightRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomLeftRadius(Css.px(10)),
                    /* :: */[
                      Css.borderBottomRightRadius(Css.px(10)),
                      /* :: */[
                        Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 44, 123, 0.25)),
                        /* [] */0
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var contentHeaderBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.row),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.justifyContent(Css.center),
            /* :: */[
              Css.background(Css.hex("FFFAFA")),
              /* :: */[
                Css.borderBottom(Css.px(2), /* solid */12956715, /* `hex */[
                      5194459,
                      "FCEBEC"
                    ]),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.borderTopLeftRadius(Css.px(10)),
                    /* :: */[
                      Css.borderTopRightRadius(Css.px(10)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var contentHeaderMiddleEl = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* [] */0
      ]
    ]);

var infoHeaderH1 = Css.style(/* :: */[
      Css.lineHeight(1.1),
      /* :: */[
        Css.margin4(Css.px(18), Css.px(0), Css.px(0), Css.px(0)),
        /* :: */[
          Css.zIndex(2),
          /* [] */0
        ]
      ]
    ]);

var infoHeaderH3 = Css.style(/* :: */[
      Css.fontWeight(400),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(6), Css.px(0)),
          /* :: */[
            Css.zIndex(2),
            /* [] */0
          ]
        ]
      ]
    ]);

var horizonBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var horizonBoxEl = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(0), Css.px(8)),
      /* :: */[
        Css.fontSize(Css.px(24)),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.cursor(/* pointer */-786317123),
            /* [] */0
          ]
        ]
      ]
    ]);

var linkArrow = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(6), Css.px(8)),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* :: */[
            Css.color(/* `hex */[
                  5194459,
                  "F66297"
                ]),
            /* :: */[
              Css.textDecoration(/* none */-922086728),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.justifyContent(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.row),
            /* :: */[
              Css.flexWrap(Css.wrap),
              /* :: */[
                Css.alignItems(Css.center),
                /* :: */[
                  Css.boxSizing(/* borderBox */9307263),
                  /* :: */[
                    Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var contentElBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.margin4(Css.px(4), Css.px(2), Css.px(4), Css.px(2)),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* [] */0
        ]
      ]
    ]);

var contentEl = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.textAlign(Css.center),
          /* :: */[
            Css.width(Css.px(130)),
            /* :: */[
              Css.height(Css.px(140)),
              /* :: */[
                Css.margin4(Css.px(4), Css.px(4), Css.px(4), Css.px(4)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var contentElInnerFrame = Css.style(/* :: */[
      Css.justifyContent(Css.center),
      /* :: */[
        Css.width(Css.px(100)),
        /* :: */[
          Css.height(Css.px(100)),
          /* :: */[
            Css.border(Css.px(2), /* solid */12956715, /* `hex */[
                  5194459,
                  "FFEEEF"
                ]),
            /* :: */[
              Css.borderRadius(Css.px(10)),
              /* :: */[
                Css.margin4(Css.px(4), Css.px(4), Css.px(4), Css.px(4)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var subText = Css.style(/* :: */[
      Css.color(/* `hex */[
            5194459,
            "FF328C"
          ]),
      /* :: */[
        Css.fontWeight(700),
        /* :: */[
          Css.alignSelf(Css.center),
          /* :: */[
            Css.fontSize(Css.px(16)),
            /* :: */[
              Css.margin2(Css.px(5), Css.px(0)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.marginTop(Css.px(5)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

function settingButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(12.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(22), Css.px(8), Css.px(40), Css.px(8)),
                  /* :: */[
                    Css.maxWidth(Css.em(13.0)),
                    Theme.greenButtonRaw
                  ]
                ]
              ]
            ]);
}

var centerIcon = Css.style(/* :: */[
      Css.margin2(Css.px(2), Css.px(6)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.0,
                1.0
              ]
            ]),
        /* :: */[
          Css.padding4(Css.px(2), Css.px(2), Css.px(2), Css.px(2)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* contentContainer */contentContainer,
  /* contentHeaderBox */contentHeaderBox,
  /* contentHeaderMiddleEl */contentHeaderMiddleEl,
  /* infoHeaderH1 */infoHeaderH1,
  /* infoHeaderH3 */infoHeaderH3,
  /* horizonBox */horizonBox,
  /* horizonBoxEl */horizonBoxEl,
  /* linkArrow */linkArrow,
  /* contentBox */contentBox,
  /* contentElBox */contentElBox,
  /* contentEl */contentEl,
  /* contentElInnerFrame */contentElInnerFrame,
  /* subText */subText,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* settingButton */settingButton,
  /* centerIcon */centerIcon
];

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      console.log("Issue with int conversion in food router");
      return 2;
    } else {
      throw exn;
    }
  }
}

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponentWithRetainedProps("FoodDay");

function make(day, _) {
  var newrecord = component.slice();
  newrecord[/* willReceiveProps */3] = (function (self) {
      if (self[/* retainedProps */3] !== day) {
        console.log("day changed");
        return /* () */0;
      } else {
        return 0;
      }
    });
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function () {
      var previousDay = String(convToInt(day) - 1 | 0);
      var nextDay = String(convToInt(day) + 1 | 0);
      var actualDay = String(convToInt(day));
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("div", {
                          className: contentBox
                        }, React.createElement("div", {
                              className: contentContainer
                            }, React.createElement("div", {
                                  className: contentHeaderBox
                                }, React.createElement("div", {
                                      className: contentHeaderMiddleEl
                                    }, React.createElement("h1", {
                                          className: infoHeaderH1
                                        }, "Mahlzeiten"), React.createElement("div", {
                                          className: horizonBox
                                        }, ReasonReact.element(/* None */0, /* None */0, Link.make("/foodday/" + previousDay, "<", linkArrow, /* array */[])), React.createElement("h3", {
                                              className: infoHeaderH3
                                            }, "Tag " + actualDay), ReasonReact.element(/* None */0, /* None */0, Link.make("/foodday/" + nextDay, ">", linkArrow, /* array */[]))))), React.createElement("div", {
                                  className: contentBox
                                }, React.createElement("div", {
                                      className: contentElBox
                                    }, React.createElement("div", {
                                          className: contentEl,
                                          onClick: (function () {
                                              return ReasonReact.Router[/* push */0]("/foodday/" + (day + "/breakfast"));
                                            })
                                        }, React.createElement("div", {
                                              className: contentElInnerFrame
                                            }, React.createElement("img", {
                                                  className: centerIcon,
                                                  alt: "Breakfast",
                                                  src: Breakfast_iconSvg
                                                })), React.createElement("div", {
                                              className: subText
                                            }, "Frühstück")), React.createElement("div", {
                                          className: contentEl,
                                          onClick: (function () {
                                              return ReasonReact.Router[/* push */0]("/foodday/" + (day + "/snack"));
                                            })
                                        }, React.createElement("div", {
                                              className: contentElInnerFrame
                                            }, React.createElement("img", {
                                                  className: centerIcon,
                                                  alt: "Snack",
                                                  src: Snack_iconSvg
                                                })), React.createElement("div", {
                                              className: subText
                                            }, "Snack"))), React.createElement("div", {
                                      className: contentElBox
                                    }, React.createElement("div", {
                                          className: contentEl,
                                          onClick: (function () {
                                              return ReasonReact.Router[/* push */0]("/foodday/" + (day + "/lunch"));
                                            })
                                        }, React.createElement("div", {
                                              className: contentElInnerFrame
                                            }, React.createElement("img", {
                                                  className: centerIcon,
                                                  alt: "Lunch",
                                                  src: Lunch_iconSvg
                                                })), React.createElement("div", {
                                              className: subText
                                            }, "Mittagessen")), React.createElement("div", {
                                          className: contentEl,
                                          onClick: (function () {
                                              return ReasonReact.Router[/* push */0]("/foodday/" + (day + "/dinner"));
                                            })
                                        }, React.createElement("div", {
                                              className: contentElInnerFrame
                                            }, React.createElement("img", {
                                                  className: centerIcon,
                                                  alt: "Dinner",
                                                  src: Dinner_iconSvg
                                                })), React.createElement("div", {
                                              className: subText
                                            }, "Abendessen"))))))), React.createElement("button", {
                      className: settingButton(/* () */0),
                      onClick: (function () {
                          return ReasonReact.Router[/* push */0]("/dashboard");
                        })
                    }, "Dashboard"));
    });
  newrecord[/* retainedProps */11] = day;
  return newrecord;
}

exports.Styles = Styles;
exports.convToInt = convToInt;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mahlzeiten_pattern.08ea7e2b.png";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Network = __webpack_require__(7);
var SvgAnim = __webpack_require__(57);
var ReasonReact = __webpack_require__(2);
var BeepMp3 = __webpack_require__(58);

((__webpack_require__(120)));

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.padding4(Css.px(0), Css.px(20), Css.px(2), Css.px(20)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var topIcon = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(20)),
      /* [] */0
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

function widerSecondaryGreenButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(180)),
              /* :: */[
                Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
                Theme.greenSecondaryButtonRaw
              ]
            ]);
}

var centerIcon = Css.style(/* :: */[
      Css.margin4(Css.px(30), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.2,
                1.2
              ]
            ]),
        /* [] */0
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* topIcon */topIcon,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* widerSecondaryGreenButton */widerSecondaryGreenButton,
  /* centerIcon */centerIcon
];

var JsAudio = /* module */[];

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("Testing");

function make() {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("div", {
                          className: topIcon
                        }, ReasonReact.element(/* None */0, /* None */0, SvgAnim.make(/* array */[]))), React.createElement("h2", undefined, "Testing"), React.createElement("p", {
                          className: inputHeader
                        }, "Hier kannst du dein Trainingslevel ändern. Genaue Informationen zum Level und dem Punktemultiplikator findest du in deinem eBook."), React.createElement("button", {
                          className: widerSecondaryGreenButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* PlaySound */Block.__(1, [5]));
                            })
                        }, "Play Sound"), React.createElement("button", {
                          className: widerSecondaryGreenButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* LevelSelect */Block.__(0, [45]));
                            })
                        }, "Fortgeschritten"), React.createElement("button", {
                          className: widerSecondaryGreenButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* LevelSelect */Block.__(0, [60]));
                            })
                        }, "Profi"), React.createElement("a", {
                          className: someLink,
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* Reset */0);
                            })
                        }, "Reset"), React.createElement("button", {
                          className: Theme.simpleButton(/* () */0),
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/dashboard");
                            })
                        }, "Zurück")));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[/* levelSelect */0];
    });
  newrecord[/* reducer */12] = (function (action, _) {
      if (typeof action === "number") {
        return /* SideEffects */Block.__(2, [(function () {
                      Network.resetAll(/* () */0);
                      return ReasonReact.Router[/* push */0]("/wizard/1");
                    })]);
      } else if (action.tag) {
        return /* UpdateWithSideEffects */Block.__(3, [
                  /* record */[/* levelSelect */action[0]],
                  (function () {
                      var x = new Audio(BeepMp3);
                      x.play();
                      x.pause();
                      setTimeout((function () {
                              x.play();
                              return /* () */0;
                            }), 5000);
                      return /* () */0;
                    })
                ]);
      } else {
        var value = action[0];
        return /* UpdateWithSideEffects */Block.__(3, [
                  /* record */[/* levelSelect */value],
                  (function () {
                      Network.updateWizardResultToLS(value);
                      return ReasonReact.Router[/* push */0]("/dashboard");
                    })
                ]);
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.JsAudio = JsAudio;
exports.text = text;
exports.component = component;
exports.make = make;
/*  Not a pure module */


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Seed = __webpack_require__(17);
var $$Array = __webpack_require__(12);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Js_exn = __webpack_require__(10);
var Counter = __webpack_require__(122);
var Network = __webpack_require__(7);
var Storage = __webpack_require__(14);
var SvgAnim = __webpack_require__(57);
var Counter2 = __webpack_require__(123);
var Counter3 = __webpack_require__(124);
var Step5box = __webpack_require__(125);
var Caml_array = __webpack_require__(9);
var Caml_int32 = __webpack_require__(11);
var Caml_format = __webpack_require__(8);
var ReasonReact = __webpack_require__(2);
var BeepMp3 = __webpack_require__(58);
var Round_bgSvg = __webpack_require__(126);
var Info_iconSvg = __webpack_require__(30);
var Round_iconSvg = __webpack_require__(61);
var Caml_builtin_exceptions = __webpack_require__(3);
var Congratulation_bgSvg = __webpack_require__(60);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var workout = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* [] */0
        ]
      ]
    ]);

var selectHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(24)),
      /* :: */[
        Css.margin4(Css.px(10), Css.px(0), Css.px(2), Css.px(0)),
        /* [] */0
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.center),
          /* [] */0
        ]
      ]
    ]);

var fullBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.boxSizing(/* borderBox */9307263),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var fullContainer = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.margin4(Css.px(14), Css.px(0), Css.px(10), Css.px(0)),
            /* :: */[
              Css.borderTopLeftRadius(Css.px(10)),
              /* :: */[
                Css.borderTopRightRadius(Css.px(10)),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 44, 123, 0.25)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var repEntryBox = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.margin4(Css.px(15), Css.px(0), Css.px(15), Css.px(0)),
            /* [] */0
          ]
        ]
      ]
    ]);

var flexList2 = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.backgroundImage(/* `url */[
              5843823,
              Round_bgSvg
            ]),
        /* :: */[
          Css.backgroundSize(Css.size(/* `percent */[
                    -119887163,
                    100.0
                  ], /* `percent */[
                    -119887163,
                    100.0
                  ])),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.marginTop(Css.px(20)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var headBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.background(Css.hex("fffafa")),
              /* :: */[
                Css.marginBottom(Css.px(0)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var infoHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.margin4(Css.px(18), Css.px(0), Css.px(6), Css.px(0)),
        /* [] */0
      ]
    ]);

var infoButton = Css.style(/* :: */[
      Css.position(/* absolute */-1013592457),
      /* :: */[
        Css.right(Css.px(12)),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(10)),
            /* [] */0
          ]
        ]
      ]
    ]);

var infoIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var infoHeaderH1 = Css.style(/* :: */[
      Css.margin4(Css.px(18), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.lineHeight(1.2),
        /* [] */0
      ]
    ]);

var repEntryText = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(25), Css.px(0), Css.px(25)),
      /* [] */0
    ]);

var weightEntryText = Css.style(/* :: */[
      Css.margin4(Css.px(20), Css.px(25), Css.px(20), Css.px(25)),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* [] */0
      ]
    ]);

var finalText = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(10), Css.px(20), Css.px(10)),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.maxWidth(Css.px(300)),
          /* [] */0
        ]
      ]
    ]);

var infoHeaderH2 = Css.style(/* :: */[
      Css.margin4(Css.px(3), Css.px(38), Css.px(3), Css.px(38)),
      /* :: */[
        Css.lineHeight(1.3),
        /* [] */0
      ]
    ]);

var infoHeaderH4 = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(2), Css.px(0)),
        /* [] */0
      ]
    ]);

var roundIconBox = Css.style(/* :: */[
      Css.top(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.transforms(/* :: */[
              /* `translate */[
                -914368690,
                /* tuple */[
                  Css.px(0),
                  /* `percent */[
                    -119887163,
                    -50.0
                  ]
                ]
              ],
              /* :: */[
                /* `scale */[
                  -120664438,
                  /* tuple */[
                    1.4,
                    1.4
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(Css.px(0)),
            /* :: */[
              Css.top(Css.px(8)),
              /* :: */[
                Css.cursor(/* pointer */-786317123),
                /* :: */[
                  Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var roundIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var vertBox = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.fontSize(Css.px(24)),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.margin4(Css.px(4), Css.px(0), Css.px(8), Css.px(0)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var horizonBox = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.fontSize(Css.px(24)),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.justifyContent(Css.spaceAround),
            /* :: */[
              Css.margin4(Css.px(4), Css.px(0), Css.px(8), Css.px(0)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var horizonBoxEl = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(0), Css.px(8)),
      /* :: */[
        Css.fontWeight(700),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* [] */0
        ]
      ]
    ]);

var horizonBoxSmallEl = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(0), Css.px(8)),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* [] */0
      ]
    ]);

var initialBodyFrame = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.marginBottom(Css.px(5)),
          /* [] */0
        ]
      ]
    ]);

var initialBody = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var initialBodyVert = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var initialBodyImgContainer = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(3), Css.px(1), Css.px(3)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.minWidth(Css.px(0)),
          /* :: */[
            Css.alignItems(/* center */98248149),
            /* [] */0
          ]
        ]
      ]
    ]);

var initialBodyImg = Css.style(/* :: */[
      Css.maxWidth(/* `percent */[
            -119887163,
            100.0
          ]),
      /* [] */0
    ]);

var workoutNameHeader = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.justifyContent(Css.center),
          /* :: */[
            Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
            /* :: */[
              Css.margin4(Css.px(8), Css.px(8), Css.px(10), Css.px(8)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var countDown = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.fontSize(Css.px(36)),
            /* :: */[
              Css.fontWeight(700),
              /* :: */[
                Css.margin4(Css.px(8), Css.px(8), Css.px(10), Css.px(8)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var spanEl = Css.style(/* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(10)),
        /* [] */0
      ]
    ]);

var inputHeaderContainer = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.justifyContent(Css.center),
        /* :: */[
          Css.background(/* `hex */[
                5194459,
                "FFFAFA"
              ]),
          /* [] */0
        ]
      ]
    ]);

var weightInputHeaderContainer = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.justifyContent(Css.center),
        /* [] */0
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(10)),
      /* :: */[
        Css.marginTop(Css.px(10)),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.background(/* `hex */[
                  5194459,
                  "FFFAFA"
                ]),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(0), Css.px(8), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(15)),
        /* :: */[
          Css.maxWidth(Css.px(120)),
          /* :: */[
            Css.fontSize(Css.px(28)),
            /* :: */[
              Css.borderRadius(/* `px */[
                    25096,
                    50
                  ]),
              /* :: */[
                Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                      5194459,
                      "F492BD"
                    ]),
                /* :: */[
                  Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                  /* :: */[
                    Css.boxSizing(/* borderBox */9307263),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var buttonContainer = Css.style(/* :: */[
      Css.marginBottom(Css.px(30)),
      /* :: */[
        Css.marginTop(Css.px(10)),
        /* [] */0
      ]
    ]);

var buttonContainerCentered = Css.style(/* :: */[
      Css.marginBottom(Css.px(30)),
      /* :: */[
        Css.marginTop(Css.px(10)),
        /* :: */[
          Css.justifyContent(/* center */98248149),
          /* [] */0
        ]
      ]
    ]);

var step5Box = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignSelf(/* stretch */-162316795),
          /* :: */[
            Css.borderRadius(Css.px(10)),
            /* :: */[
              Css.boxShadow(/* Some */[Css.px(2)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(255, 191, 194, 0.29)),
              /* :: */[
                Css.boxSizing(Css.borderBox),
                /* :: */[
                  Css.margin4(Css.px(10), Css.px(10), Css.px(20), Css.px(10)),
                  /* :: */[
                    Css.background(/* `linearGradient */[
                          616379637,
                          /* tuple */[
                            /* `deg */[
                              4995526,
                              180
                            ],
                            /* :: */[
                              /* tuple */[
                                0,
                                Css.hex("FFF8F9")
                              ],
                              /* :: */[
                                /* tuple */[
                                  50,
                                  Css.rgba(255, 255, 255, 0.0)
                                ],
                                /* :: */[
                                  /* tuple */[
                                    98,
                                    Css.hex("FFF8F9")
                                  ],
                                  /* [] */0
                                ]
                              ]
                            ]
                          ]
                        ]),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var step5BoxInner1 = Css.style(/* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
        /* :: */[
          Css.padding2(Css.px(0), Css.px(16)),
          /* :: */[
            Css.justifyContent(/* center */98248149),
            /* [] */0
          ]
        ]
      ]
    ]);

var step5BoxInner2 = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.background(/* `hex */[
                5194459,
                "FFFAFA"
              ]),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
            /* :: */[
              Css.padding2(Css.px(0), Css.px(10)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var middleText = Css.style(/* :: */[
      Css.margin2(Css.px(5), Css.px(0)),
      /* [] */0
    ]);

var step5BoxInner3 = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.position(/* relative */903134412),
            /* :: */[
              Css.marginTop(Css.px(20)),
              /* :: */[
                Css.marginBottom(Css.px(0)),
                /* :: */[
                  Css.paddingBottom(Css.px(20)),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var congratsIcon = Css.style(/* :: */[
      Css.margin4(Css.px(4), Css.px(0), Css.px(20), Css.px(0)),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var finalVal = Css.style(/* :: */[
      Css.margin4(Css.px(4), Css.px(0), Css.px(20), Css.px(0)),
      /* :: */[
        Css.position(/* absolute */-1013592457),
        /* :: */[
          Css.top(Css.px(218)),
          /* :: */[
            Css.color(Css.white),
            /* :: */[
              Css.fontWeight(700),
              /* :: */[
                Css.fontSize(Css.px(22)),
                /* :: */[
                  Css.justifyContent(/* center */98248149),
                  /* :: */[
                    Css.width(/* `percent */[
                          -119887163,
                          100.0
                        ]),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var someText = Css.style(/* :: */[
      Css.textAlign(/* left */-944764921),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* :: */[
            Css.margin2(Css.px(10), Css.px(10)),
            /* :: */[
              Css.color(/* `hex */[
                    5194459,
                    "FF328C"
                  ]),
              /* :: */[
                Css.fontWeight(700),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* workout */workout,
  /* selectHeader */selectHeader,
  /* flexList */flexList,
  /* fullBox */fullBox,
  /* fullContainer */fullContainer,
  /* repEntryBox */repEntryBox,
  /* flexList2 */flexList2,
  /* headBox */headBox,
  /* infoHeader */infoHeader,
  /* infoButton */infoButton,
  /* infoIcon */infoIcon,
  /* infoHeaderH1 */infoHeaderH1,
  /* repEntryText */repEntryText,
  /* weightEntryText */weightEntryText,
  /* finalText */finalText,
  /* infoHeaderH2 */infoHeaderH2,
  /* infoHeaderH4 */infoHeaderH4,
  /* roundIconBox */roundIconBox,
  /* roundIcon */roundIcon,
  /* vertBox */vertBox,
  /* horizonBox */horizonBox,
  /* horizonBoxEl */horizonBoxEl,
  /* horizonBoxSmallEl */horizonBoxSmallEl,
  /* initialBodyFrame */initialBodyFrame,
  /* initialBody */initialBody,
  /* initialBodyVert */initialBodyVert,
  /* initialBodyImgContainer */initialBodyImgContainer,
  /* initialBodyImg */initialBodyImg,
  /* workoutNameHeader */workoutNameHeader,
  /* countDown */countDown,
  /* spanEl */spanEl,
  /* inputHeaderContainer */inputHeaderContainer,
  /* weightInputHeaderContainer */weightInputHeaderContainer,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* buttonContainer */buttonContainer,
  /* buttonContainerCentered */buttonContainerCentered,
  /* step5Box */step5Box,
  /* step5BoxInner1 */step5BoxInner1,
  /* step5BoxInner2 */step5BoxInner2,
  /* middleText */middleText,
  /* step5BoxInner3 */step5BoxInner3,
  /* congratsIcon */congratsIcon,
  /* finalVal */finalVal,
  /* someText */someText
];

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      console.log("Issue with int conversion in workout component");
      return 0;
    } else {
      throw exn;
    }
  }
}

function checkForInt(x) {
  var x2 = convToInt(x);
  if (x2 >= 0 && x2 < 100) {
    return x2;
  } else {
    return 0;
  }
}

function checkForWeightInt(x) {
  var x2 = convToInt(x);
  if (x2 >= 0 && x2 < 200) {
    return x2;
  } else {
    return 0;
  }
}

function checkForWeightIntOpt(x) {
  var x2 = convToInt(x);
  if (x2 >= 0 && x2 < 220) {
    return /* Some */[x2];
  } else {
    return /* None */0;
  }
}

function turnBackToString(theInt) {
  if (theInt !== 0) {
    return String(theInt);
  } else {
    return "0";
  }
}

function text(prim) {
  return prim;
}

var $$window = (window);

var $$document = (document);

var JsAudio = /* module */[];

var component = ReasonReact.reducerComponent("Workout");

function make(week, workout$1, round, pair, step, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      window.scrollTo(0, 0);
      $$window.addEventListener("keydown", (function (ev) {
              var keyInt = ev.which;
              console.log("ev: ", ev.which);
              if (keyInt === 13) {
                console.log("ev13: ", ev.which);
                return Curry._1(self[/* send */4], /* EnterPress */1);
              } else {
                return 0;
              }
            }));
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var intPair = Caml_format.caml_int_of_string(pair);
      var currentEx1 = (intPair << 1) - 1 | 0;
      var currentEx2 = (intPair << 1);
      var exId = String(Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */7], (intPair << 1) - 2 | 0));
      var exIdInt = Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */7], (intPair << 1) - 2 | 0);
      var exLev = String(Caml_array.caml_array_get(self[/* state */2][/* levels */1], (intPair << 1) - 2 | 0));
      var exLevInt = Caml_array.caml_array_get(self[/* state */2][/* levels */1], (intPair << 1) - 2 | 0);
      var block22 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_b.jpg")))
                      }))));
      var block23 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_b.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId + ("_l" + (exLev + "_c.jpg"))),
                        onError: (function () {
                            return Curry._1(self[/* send */4], /* HideEl */Block.__(8, [1]));
                          })
                      }))));
      var block24 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_b.jpg")))
                      }))), React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId + ("_l" + (exLev + "_c.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId + ("_l" + (exLev + "_d.jpg")))
                      }))));
      var block26 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_b.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId + ("_l" + (exLev + "_c.jpg")))
                      }))), React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId + ("_l" + (exLev + "_d.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId + ("_l" + (exLev + "_e.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId + ("_l" + (exLev + "_f.jpg")))
                      }))));
      var match = self[/* state */2][/* running */26];
      var tmp;
      if (match !== 0) {
        var match$1 = self[/* state */2][/* showDetails23 */29];
        var tmp$1;
        if (match$1 !== 0) {
          var match$2 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exIdInt - 1 | 0), exLevInt - 1 | 0);
          var switcher = match$2 - 2 | 0;
          if (switcher > 4 || switcher < 0) {
            tmp$1 = block26;
          } else {
            switch (switcher) {
              case 0 : 
                  tmp$1 = block22;
                  break;
              case 1 : 
                  tmp$1 = block23;
                  break;
              case 2 : 
                  tmp$1 = block24;
                  break;
              case 3 : 
              case 4 : 
                  tmp$1 = block26;
                  break;
              
            }
          }
        } else {
          tmp$1 = null;
        }
        var match$3 = self[/* state */2][/* preRunning */27];
        tmp = React.createElement("div", {
              className: flexList
            }, React.createElement("div", {
                  className: initialBody
                }, tmp$1), React.createElement("div", {
                  className: flexList2
                }, React.createElement("div", {
                      className: countDown
                    }, match$3 !== 0 ? ReasonReact.element(/* None */0, /* None */0, Counter.make(self[/* state */2][/* preRunningCount */28], self[/* state */2][/* preRunningCount */28], /* true */1, /* array */[])) : ReasonReact.element(/* None */0, /* None */0, Counter3.make(self[/* state */2][/* duration */2], "Timer: ", self[/* state */2][/* count */30], /* false */0, /* array */[]))), React.createElement("div", {
                      className: buttonContainer
                    }, React.createElement("button", {
                          className: Theme.simpleButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* SecondPair */6);
                            })
                        }, "Weiter"))));
      } else {
        var match$4 = self[/* state */2][/* showDetails23 */29];
        var tmp$2;
        if (match$4 !== 0) {
          var match$5 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exIdInt - 1 | 0), exLevInt - 1 | 0);
          var switcher$1 = match$5 - 2 | 0;
          if (switcher$1 > 4 || switcher$1 < 0) {
            tmp$2 = block26;
          } else {
            switch (switcher$1) {
              case 0 : 
                  tmp$2 = block22;
                  break;
              case 1 : 
                  tmp$2 = block23;
                  break;
              case 2 : 
                  tmp$2 = block24;
                  break;
              case 3 : 
              case 4 : 
                  tmp$2 = block26;
                  break;
              
            }
          }
        } else {
          tmp$2 = null;
        }
        var match$6 = self[/* state */2][/* showDetails23 */29];
        tmp = React.createElement("div", {
              className: flexList
            }, React.createElement("div", {
                  className: initialBodyVert
                }, tmp$2, match$6 !== 0 ? React.createElement("div", {
                        className: someText
                      }, React.createElement("span", {
                            dangerouslySetInnerHTML: {
                              __html: Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseDescriptions, exIdInt - 1 | 0)[/* description */1], exLevInt - 1 | 0)
                            }
                          })) : null), React.createElement("div", {
                  className: flexList2
                }, React.createElement("div", {
                      className: countDown
                    }, ReasonReact.element(/* None */0, /* None */0, Counter.make(self[/* state */2][/* duration */2], self[/* state */2][/* count */30], /* true */1, /* array */[]))), React.createElement("div", {
                      className: buttonContainer
                    }, React.createElement("button", {
                          className: Theme.simpleButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* SetRunning */3);
                            })
                        }, "Start"))));
      }
      var step2 = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: fullBox
              }, React.createElement("div", {
                    className: fullContainer
                  }, React.createElement("div", {
                        className: headBox
                      }, React.createElement("div", {
                            className: roundIconBox
                          }, React.createElement("img", {
                                className: roundIcon,
                                alt: "round",
                                src: Round_iconSvg
                              })), React.createElement("h1", {
                            className: infoHeaderH1
                          }, "Runde " + round), React.createElement("h4", {
                            className: infoHeaderH4
                          }, "Übungspaar " + (String(intPair) + " / 3")), React.createElement("h4", {
                            className: infoHeaderH4
                          }, "Übung " + (String(currentEx1) + ""))), React.createElement("div", {
                        className: workoutNameHeader
                      }, React.createElement("h2", {
                            className: infoHeaderH2
                          }, Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 2 | 0)), React.createElement("div", {
                            className: infoButton,
                            onClick: (function () {
                                return Curry._1(self[/* send */4], /* ToggleDetails23 */0);
                              })
                          }, React.createElement("img", {
                                className: infoIcon,
                                alt: "info",
                                src: Info_iconSvg
                              }))), tmp)));
      var exId2 = String(Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */7], (intPair << 1) - 1 | 0));
      var exId2Int = Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */7], (intPair << 1) - 1 | 0);
      var exLev2 = String(Caml_array.caml_array_get(self[/* state */2][/* levels */1], (intPair << 1) - 1 | 0));
      var exLev2Int = Caml_array.caml_array_get(self[/* state */2][/* levels */1], (intPair << 1) - 1 | 0);
      var block32 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_b.jpg")))
                      }))));
      var block33 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_b.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_c.jpg"))),
                        onError: (function () {
                            return Curry._1(self[/* send */4], /* HideEl */Block.__(8, [1]));
                          })
                      }))));
      var block34 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_b.jpg")))
                      }))), React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_c.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_d.jpg")))
                      }))));
      var block36 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_b.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_c.jpg")))
                      }))), React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_d.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_e.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_f.jpg")))
                      }))));
      var match$7 = self[/* state */2][/* running */26];
      var tmp$3;
      if (match$7 !== 0) {
        var match$8 = self[/* state */2][/* showDetails23 */29];
        var tmp$4;
        if (match$8 !== 0) {
          var match$9 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId2Int - 1 | 0), exLev2Int - 1 | 0);
          var switcher$2 = match$9 - 2 | 0;
          if (switcher$2 > 2 || switcher$2 < 0) {
            tmp$4 = block36;
          } else {
            switch (switcher$2) {
              case 0 : 
                  tmp$4 = block32;
                  break;
              case 1 : 
                  tmp$4 = block33;
                  break;
              case 2 : 
                  tmp$4 = block34;
                  break;
              
            }
          }
        } else {
          tmp$4 = null;
        }
        var match$10 = self[/* state */2][/* preRunning */27];
        tmp$3 = React.createElement("div", {
              className: flexList
            }, React.createElement("div", {
                  className: initialBody
                }, tmp$4), React.createElement("div", {
                  className: flexList2
                }, React.createElement("div", {
                      className: countDown
                    }, match$10 !== 0 ? ReasonReact.element(/* None */0, /* None */0, Counter.make(self[/* state */2][/* preRunningCount */28], self[/* state */2][/* preRunningCount */28], /* true */1, /* array */[])) : ReasonReact.element(/* None */0, /* None */0, Counter3.make(self[/* state */2][/* duration */2], "Timer: ", self[/* state */2][/* count */30], /* false */0, /* array */[]))), React.createElement("div", {
                      className: buttonContainer
                    }, React.createElement("button", {
                          className: Theme.simpleButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* FinishPair */7);
                            })
                        }, "Weiter"))));
      } else {
        var match$11 = self[/* state */2][/* showDetails23 */29];
        var tmp$5;
        if (match$11 !== 0) {
          var match$12 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId2Int - 1 | 0), exLev2Int - 1 | 0);
          var switcher$3 = match$12 - 2 | 0;
          if (switcher$3 > 2 || switcher$3 < 0) {
            tmp$5 = block36;
          } else {
            switch (switcher$3) {
              case 0 : 
                  tmp$5 = block32;
                  break;
              case 1 : 
                  tmp$5 = block33;
                  break;
              case 2 : 
                  tmp$5 = block34;
                  break;
              
            }
          }
        } else {
          tmp$5 = null;
        }
        tmp$3 = React.createElement("div", {
              className: flexList
            }, React.createElement("div", {
                  className: initialBody
                }, tmp$5), React.createElement("div", {
                  className: flexList2
                }, React.createElement("div", {
                      className: countDown
                    }, ReasonReact.element(/* None */0, /* None */0, Counter.make(self[/* state */2][/* duration */2], self[/* state */2][/* count */30], /* true */1, /* array */[]))), React.createElement("div", {
                      className: buttonContainer
                    }, React.createElement("button", {
                          className: Theme.simpleButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* SetRunning */3);
                            })
                        }, "Start"))));
      }
      var step3 = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: fullBox
              }, React.createElement("div", {
                    className: fullContainer
                  }, React.createElement("div", {
                        className: headBox
                      }, React.createElement("div", {
                            className: roundIconBox
                          }, React.createElement("img", {
                                className: roundIcon,
                                alt: "round",
                                src: Round_iconSvg
                              })), React.createElement("h1", {
                            className: infoHeaderH1
                          }, "Runde " + round), React.createElement("h4", {
                            className: infoHeaderH4
                          }, "Übungspaar " + (String(intPair) + " / 3")), React.createElement("h4", {
                            className: infoHeaderH4
                          }, "Übung " + (String(currentEx2) + ""))), React.createElement("div", {
                        className: workoutNameHeader
                      }, React.createElement("h2", {
                            className: infoHeaderH2
                          }, Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 1 | 0)), React.createElement("div", {
                            className: infoButton,
                            onClick: (function () {
                                return Curry._1(self[/* send */4], /* ToggleDetails23 */0);
                              })
                          }, React.createElement("img", {
                                className: infoIcon,
                                alt: "info",
                                src: Info_iconSvg
                              }))), tmp$3)));
      var weightEntryA = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: inputHeaderContainer
              }, React.createElement("h4", {
                    className: inputHeader
                  }, "Übung " + (String(currentEx1) + " "), Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 2 | 0))), React.createElement("input", {
                className: inputField,
                pattern: "[0-9]*",
                placeholder: "WDH",
                type: "number",
                value: self[/* state */2][/* exAInput */12],
                onInput: (function ($$event) {
                    return Curry._1(self[/* send */4], /* ChangeExA */Block.__(2, [$$event.target.value]));
                  })
              }));
      var match$13 = self[/* state */2][/* error */32];
      var weightEntryB = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: inputHeaderContainer
              }, React.createElement("h4", {
                    className: inputHeader
                  }, "Übung " + (String(currentEx2) + " "), Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 1 | 0))), React.createElement("input", {
                className: inputField,
                pattern: "[0-9]*",
                placeholder: "WDH",
                type: "number",
                value: self[/* state */2][/* exBInput */14],
                onInput: (function ($$event) {
                    return Curry._1(self[/* send */4], /* ChangeExB */Block.__(3, [$$event.target.value]));
                  })
              }), match$13 ? React.createElement("div", {
                  className: "failure"
                }, match$13[0]) : null);
      var weightEntryC = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: inputHeaderContainer
              }, React.createElement("h4", {
                    className: inputHeader
                  }, "Übung " + (String(currentEx1) + " "), Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 2 | 0))), React.createElement("input", {
                className: inputField,
                pattern: "[0-9]*",
                placeholder: "WDH",
                type: "number",
                value: self[/* state */2][/* exCInput */16],
                onInput: (function ($$event) {
                    return Curry._1(self[/* send */4], /* ChangeExC */Block.__(4, [$$event.target.value]));
                  })
              }));
      var match$14 = self[/* state */2][/* error */32];
      var weightEntryD = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: inputHeaderContainer
              }, React.createElement("h4", {
                    className: inputHeader
                  }, "Übung " + (String(currentEx2) + " "), Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 1 | 0))), React.createElement("input", {
                className: inputField,
                pattern: "[0-9]*",
                placeholder: "WDH",
                type: "number",
                value: self[/* state */2][/* exDInput */18],
                onInput: (function ($$event) {
                    return Curry._1(self[/* send */4], /* ChangeExD */Block.__(5, [$$event.target.value]));
                  })
              }), match$14 ? React.createElement("div", {
                  className: "failure"
                }, match$14[0]) : null);
      var weightEntryE = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: inputHeaderContainer
              }, React.createElement("h4", {
                    className: inputHeader
                  }, "Übung " + (String(currentEx1) + " "), Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 2 | 0))), React.createElement("input", {
                className: inputField,
                pattern: "[0-9]*",
                placeholder: "WDH",
                type: "number",
                value: self[/* state */2][/* exEInput */20],
                onInput: (function ($$event) {
                    return Curry._1(self[/* send */4], /* ChangeExE */Block.__(6, [$$event.target.value]));
                  })
              }));
      var match$15 = self[/* state */2][/* error */32];
      var weightEntryF = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: inputHeaderContainer
              }, React.createElement("h4", {
                    className: inputHeader
                  }, "Übung " + (String(currentEx2) + " "), Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 1 | 0))), React.createElement("input", {
                className: inputField,
                pattern: "[0-9]*",
                placeholder: "WDH",
                type: "number",
                value: self[/* state */2][/* exFInput */22],
                onInput: (function ($$event) {
                    return Curry._1(self[/* send */4], /* ChangeExF */Block.__(7, [$$event.target.value]));
                  })
              }), match$15 ? React.createElement("div", {
                  className: "failure"
                }, match$15[0]) : null);
      var switcher$4 = intPair - 1 | 0;
      var tmp$6;
      if (switcher$4 > 2 || switcher$4 < 0) {
        tmp$6 = weightEntryA;
      } else {
        switch (switcher$4) {
          case 0 : 
              tmp$6 = weightEntryA;
              break;
          case 1 : 
              tmp$6 = weightEntryC;
              break;
          case 2 : 
              tmp$6 = weightEntryE;
              break;
          
        }
      }
      var switcher$5 = intPair - 1 | 0;
      var tmp$7;
      if (switcher$5 > 2 || switcher$5 < 0) {
        tmp$7 = weightEntryB;
      } else {
        switch (switcher$5) {
          case 0 : 
              tmp$7 = weightEntryB;
              break;
          case 1 : 
              tmp$7 = weightEntryD;
              break;
          case 2 : 
              tmp$7 = weightEntryF;
              break;
          
        }
      }
      var step4 = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: fullBox
              }, React.createElement("div", {
                    className: fullContainer
                  }, React.createElement("div", {
                        className: headBox
                      }, React.createElement("div", {
                            className: roundIconBox
                          }, React.createElement("img", {
                                className: roundIcon,
                                alt: "round",
                                src: Round_iconSvg
                              })), React.createElement("h1", {
                            className: infoHeaderH1
                          }, "Runde " + round), React.createElement("h4", {
                            className: infoHeaderH4
                          }, "Übungspaar " + (String(intPair) + " / 3"))), React.createElement("div", {
                        className: workoutNameHeader
                      }, React.createElement("div", {
                            className: repEntryBox
                          }, React.createElement("h2", {
                                className: infoHeaderH2
                              }, "Super gemacht!"), React.createElement("div", {
                                className: repEntryText
                              }, "Wie viele Wiederholungen hast du in der gegebenen Zeit geschafft?"))), tmp$6, tmp$7, React.createElement("div", {
                        className: horizonBox
                      }, React.createElement("div", {
                            className: countDown
                          }, ReasonReact.element(/* None */0, /* None */0, Counter2.make((function () {
                                      return Curry._1(self[/* send */4], /* NextPairOrRoundOrFinish */8);
                                    }), 30, "Pause: ", /* array */[])))), React.createElement("div", {
                        className: buttonContainer
                      }, React.createElement("button", {
                            className: Theme.simpleButton(/* () */0),
                            onClick: (function () {
                                return Curry._1(self[/* send */4], /* NextPairOrRoundOrFinish */8);
                              })
                          }, "Weiter")))));
      var step5 = React.createElement("div", {
            className: flexList
          }, ReasonReact.element(/* None */0, /* None */0, Step5box.make(self[/* state */2][/* points */31], /* array */[])), React.createElement("div", {
                className: buttonContainer
              }, React.createElement("button", {
                    className: Theme.simpleButton(/* () */0),
                    onClick: (function () {
                        return ReasonReact.Router[/* push */0]("/dashboard");
                      })
                  }, "Dashboard")));
      var step6 = React.createElement("div", {
            className: step5Box
          }, React.createElement("div", {
                className: step5BoxInner1
              }, React.createElement("img", {
                    className: congratsIcon,
                    alt: "",
                    src: Congratulation_bgSvg
                  })), React.createElement("div", {
                className: step5BoxInner2
              }, React.createElement("h2", {
                    className: middleText
                  }, "Du hast soeben dein finales Workout\n          erfolgreich absolviert.")), React.createElement("div", {
                className: step5BoxInner3
              }, React.createElement("div", {
                    className: weightInputHeaderContainer
                  }, React.createElement("div", {
                        className: weightEntryText
                      }, "Trage jetzt dein aktuelles Gewicht ein!")), React.createElement("input", {
                    className: inputField,
                    pattern: "[0-9]*",
                    placeholder: "KG",
                    type: "number",
                    value: self[/* state */2][/* weightReductionInput */35],
                    onInput: (function ($$event) {
                        return Curry._1(self[/* send */4], /* ChangeFinalWeight */Block.__(0, [$$event.target.value]));
                      })
                  })), React.createElement("div", {
                className: buttonContainerCentered
              }, React.createElement("button", {
                    className: Theme.simpleButton(/* () */0),
                    onClick: (function () {
                        return Curry._1(self[/* send */4], /* FinalScreen */9);
                      })
                  }, "Weiter")));
      var match$16 = self[/* state */2][/* weightReduction */36];
      var tmp$8;
      if (match$16) {
        var value = match$16[0];
        tmp$8 = value >= 0 ? React.createElement("div", {
                className: finalVal
              }, "-" + (String(value) + " KG")) : null;
      } else {
        tmp$8 = null;
      }
      var step7 = React.createElement("div", {
            className: step5Box
          }, React.createElement("div", {
                className: step5BoxInner1
              }, ReasonReact.element(/* None */0, /* None */0, SvgAnim.make(/* array */[]))), tmp$8, React.createElement("div", {
                className: step5BoxInner2
              }, React.createElement("h2", {
                    className: middleText
                  }, "Super!"), React.createElement("div", {
                    className: weightInputHeaderContainer
                  }, React.createElement("div", {
                        className: finalText
                      }, "Herzlichen Glückwunsch zu deinem neuen Bikini-Body!"))), React.createElement("div", {
                className: buttonContainerCentered
              }, React.createElement("button", {
                    className: Theme.simpleButton(/* () */0),
                    onClick: (function () {
                        return ReasonReact.Router[/* push */0]("/dashboard");
                      })
                  }, "Dashboard")));
      var tmp$9;
      switch (step) {
        case "2" : 
            tmp$9 = step2;
            break;
        case "3" : 
            tmp$9 = step3;
            break;
        case "4" : 
            tmp$9 = step4;
            break;
        case "5" : 
            tmp$9 = step5;
            break;
        case "6" : 
            tmp$9 = step6;
            break;
        case "7" : 
            tmp$9 = step7;
            break;
        default:
          tmp$9 = step2;
      }
      return React.createElement("div", {
                  className: workout
                }, tmp$9);
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* workoutIndex */Caml_int32.imul(Caml_format.caml_int_of_string(week) - 1 | 0, 6) + (Caml_format.caml_int_of_string(workout$1) - 1 | 0) | 0,
              /* levels */Caml_array.caml_array_get(Network.pullLevelConfig(/* () */0), Caml_int32.imul(Caml_format.caml_int_of_string(week) - 1 | 0, 6) + (Caml_format.caml_int_of_string(workout$1) - 1 | 0) | 0),
              /* duration */Storage.getDuration(/* () */0),
              /* allLevels */Network.pullLevelConfig(/* () */0),
              /* pairList : array */[
                "1",
                "1",
                "2",
                "2",
                "3",
                "3"
              ],
              /* showDetails : int array */[
                /* false */0,
                /* false */0
              ],
              /* currentWorkoutExercises */Seed.getWorkoutTitles(week, workout$1),
              /* currentWorkoutExercisesIds */Seed.getWorkoutIds(week, workout$1),
              /* exCur1Input */"",
              /* exCur1 */0,
              /* exCur2Input */"",
              /* exCur2 */0,
              /* exAInput */"",
              /* exA */0,
              /* exBInput */"",
              /* exB */0,
              /* exCInput */"",
              /* exC */0,
              /* exDInput */"",
              /* exD */0,
              /* exEInput */"",
              /* exE */0,
              /* exFInput */"",
              /* exF */0,
              /* hide1 : false */0,
              /* hide2 : false */0,
              /* running : false */0,
              /* preRunning : false */0,
              /* preRunningCount */-1,
              /* showDetails23 : false */0,
              /* count */Storage.getDuration(/* () */0),
              /* points */Network.calcPointsOverall(Network.pullPointsConfig(/* () */0)),
              /* error : None */0,
              /* intervalId */[/* None */0],
              /* interval2Id */[/* None */0],
              /* weightReductionInput */"",
              /* weightReduction */Storage.getWeightDiff(/* () */0)
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              var newrecord = state.slice();
              return /* Update */Block.__(0, [(newrecord[/* showDetails23 */29] = 1 - state[/* showDetails23 */29], newrecord)]);
          case 1 : 
              return /* SideEffects */Block.__(2, [(function (self) {
                            var match = state[/* running */26];
                            switch (step) {
                              case "2" : 
                                  if (match !== 0) {
                                    console.log("enter press 2 true");
                                    return Curry._1(self[/* send */4], /* SecondPair */6);
                                  } else {
                                    console.log("enter press 2");
                                    return Curry._1(self[/* send */4], /* SetRunning */3);
                                  }
                              case "3" : 
                                  if (match !== 0) {
                                    return Curry._1(self[/* send */4], /* FinishPair */7);
                                  } else {
                                    console.log("enter press 3");
                                    return Curry._1(self[/* send */4], /* SetRunning */3);
                                  }
                              case "4" : 
                                  if (match !== 0) {
                                    return /* () */0;
                                  } else {
                                    return Curry._1(self[/* send */4], /* NextPairOrRoundOrFinish */8);
                                  }
                              default:
                                return /* () */0;
                            }
                          })]);
          case 2 : 
              var newrecord$1 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$1[/* showDetails */5] = /* int array */[
                            /* false */0,
                            /* false */0
                          ], newrecord$1[/* showDetails23 */29] = /* false */0, newrecord$1),
                        (function () {
                            return ReasonReact.Router[/* push */0]("/week/" + (week + ("/workout/" + (workout$1 + ("/" + (round + ("/" + (pair + "/2"))))))));
                          })
                      ]);
          case 3 : 
              var newrecord$2 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$2[/* running */26] = /* true */1, newrecord$2[/* preRunning */27] = /* true */1, newrecord$2[/* preRunningCount */28] = 3, newrecord$2[/* showDetails23 */29] = /* false */0, newrecord$2[/* count */30] = state[/* duration */2] + 3 | 0, newrecord$2),
                        (function (self) {
                            var x = new Audio(BeepMp3);
                            state[/* interval2Id */34][0] = /* Some */[setInterval((function () {
                                      return Curry._1(self[/* send */4], /* Tick */10);
                                    }), 1000)];
                            console.log("interval2id", state[/* interval2Id */34]);
                            state[/* intervalId */33][0] = /* Some */[setTimeout((function () {
                                      if (document.hidden) {
                                        return 0;
                                      } else {
                                        var playing2 = x.play();
                                        if (!(playing2 == null)) {
                                          playing2.then((function () {
                                                    console.log("promise2 returned");
                                                    return Promise.resolve(/* () */0);
                                                  })).catch((function (err) {
                                                  console.log("Audio promise2 failure ", err);
                                                  return Promise.resolve(/* () */0);
                                                }));
                                        }
                                        return /* () */0;
                                      }
                                    }), Caml_int32.imul(state[/* duration */2], 1000) + 3000 | 0)];
                            return /* () */0;
                          })
                      ]);
          case 4 : 
              var newrecord$3 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$3[/* running */26] = /* true */1, newrecord$3[/* preRunning */27] = /* true */1, newrecord$3[/* preRunningCount */28] = 3, newrecord$3[/* showDetails23 */29] = /* false */0, newrecord$3),
                        (function () {
                            console.log("setting prerunning");
                            return /* () */0;
                          })
                      ]);
          case 5 : 
              var newrecord$4 = state.slice();
              return /* Update */Block.__(0, [(newrecord$4[/* count */30] = 0, newrecord$4)]);
          case 6 : 
              var newrecord$5 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$5[/* running */26] = /* false */0, newrecord$5[/* preRunning */27] = /* false */0, newrecord$5[/* showDetails23 */29] = /* false */0, newrecord$5),
                        (function () {
                            console.log("Second Pair starting");
                            var match = state[/* intervalId */33][0];
                            if (match) {
                              clearTimeout(match[0]);
                              state[/* intervalId */33][0] = /* None */0;
                            }
                            var match$1 = state[/* interval2Id */34][0];
                            if (match$1) {
                              clearInterval(match$1[0]);
                              state[/* interval2Id */34][0] = /* None */0;
                            }
                            return ReasonReact.Router[/* push */0]("/week/" + (week + ("/workout/" + (workout$1 + ("/" + (round + ("/" + (pair + "/3"))))))));
                          })
                      ]);
          case 7 : 
              var newrecord$6 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$6[/* hide1 */24] = /* false */0, newrecord$6[/* hide2 */25] = /* false */0, newrecord$6),
                        (function () {
                            var match = state[/* intervalId */33][0];
                            if (match) {
                              clearTimeout(match[0]);
                              state[/* intervalId */33][0] = /* None */0;
                            }
                            var match$1 = state[/* interval2Id */34][0];
                            if (match$1) {
                              clearInterval(match$1[0]);
                              state[/* interval2Id */34][0] = /* None */0;
                            }
                            return ReasonReact.Router[/* push */0]("/week/" + (week + ("/workout/" + (workout$1 + ("/" + (round + ("/" + (pair + "/4"))))))));
                          })
                      ]);
          case 8 : 
              var routeStart = "/week/" + (week + ("/workout/" + (workout$1 + "/")));
              var reps1;
              switch (pair) {
                case "1" : 
                    var match = +(state[/* exCur1 */9] === 0);
                    reps1 = match !== 0 ? state[/* exA */13] : state[/* exCur1 */9];
                    break;
                case "2" : 
                    var match$1 = +(state[/* exCur1 */9] === 0);
                    reps1 = match$1 !== 0 ? state[/* exC */17] : state[/* exCur1 */9];
                    break;
                case "3" : 
                    var match$2 = +(state[/* exCur1 */9] === 0);
                    reps1 = match$2 !== 0 ? state[/* exE */21] : state[/* exCur1 */9];
                    break;
                default:
                  var match$3 = +(state[/* exCur1 */9] === 0);
                  reps1 = match$3 !== 0 ? state[/* exA */13] : state[/* exCur1 */9];
              }
              var reps2;
              switch (pair) {
                case "1" : 
                    var match$4 = +(state[/* exCur2 */11] === 0);
                    reps2 = match$4 !== 0 ? state[/* exB */15] : state[/* exCur2 */11];
                    break;
                case "2" : 
                    var match$5 = +(state[/* exCur2 */11] === 0);
                    reps2 = match$5 !== 0 ? state[/* exD */19] : state[/* exCur2 */11];
                    break;
                case "3" : 
                    var match$6 = +(state[/* exCur2 */11] === 0);
                    reps2 = match$6 !== 0 ? state[/* exF */23] : state[/* exCur2 */11];
                    break;
                default:
                  var match$7 = +(state[/* exCur1 */9] === 0);
                  reps2 = match$7 !== 0 ? state[/* exA */13] : state[/* exCur2 */11];
              }
              Network.storePointsAndReps(state[/* workoutIndex */0], Caml_format.caml_int_of_string(round), Caml_format.caml_int_of_string(pair), reps1, reps2, state[/* levels */1]);
              var nextRoute;
              var exit = 0;
              if (round === "4" && pair === "3") {
                Storage.clearLoc(/* () */0);
                Network.storeCompletedWorkout(state[/* workoutIndex */0]);
                if (Storage.calculateProgramDay(/* () */0) === -1) {
                  console.log("saving first workout date");
                  Network.saveFirstWorkoutDate(/* () */0);
                }
                nextRoute = week === "4" && Network.check16Completed(/* () */0) ? routeStart + "4/3/6" : routeStart + "4/3/5";
              } else {
                exit = 1;
              }
              if (exit === 1) {
                nextRoute = pair === "3" ? routeStart + (String(Caml_format.caml_int_of_string(round) + 1 | 0) + "/1/2") : routeStart + (round + ("/" + (String(Caml_format.caml_int_of_string(pair) + 1 | 0) + "/2")));
              }
              var newrecord$7 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$7[/* exCur1Input */8] = turnBackToString(0), newrecord$7[/* exCur1 */9] = 0, newrecord$7[/* exCur2Input */10] = turnBackToString(0), newrecord$7[/* exCur2 */11] = 0, newrecord$7[/* count */30] = state[/* duration */2], newrecord$7[/* points */31] = Network.calcPointsOverall(Network.pullPointsConfig(/* () */0)), newrecord$7),
                        (function () {
                            console.log("nextroute", nextRoute);
                            return ReasonReact.Router[/* push */0](nextRoute);
                          })
                      ]);
          case 9 : 
              var routeStart$1 = "/week/" + (week + ("/workout/" + (workout$1 + "/")));
              var nextRoute$1 = routeStart$1 + "4/3/7";
              Storage.clearLoc(/* () */0);
              var newrecord$8 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$8[/* exCur1 */9] = 0, newrecord$8),
                        (function () {
                            var match = state[/* weightReduction */36];
                            if (match) {
                              Storage.storeWeightDiff(match[0]);
                            }
                            return ReasonReact.Router[/* push */0](nextRoute$1);
                          })
                      ]);
          case 10 : 
              var match$8 = state[/* count */30];
              if (match$8 !== 0) {
                var newrecord$9 = state.slice();
                return /* UpdateWithSideEffects */Block.__(3, [
                          (newrecord$9[/* count */30] = state[/* count */30] - 1 | 0, newrecord$9),
                          (function (self) {
                              return Curry._1(self[/* send */4], /* Tick2 */11);
                            })
                        ]);
              } else {
                var newrecord$10 = state.slice();
                return /* UpdateWithSideEffects */Block.__(3, [
                          (newrecord$10[/* preRunning */27] = /* false */0, newrecord$10),
                          (function () {
                              var match = state[/* interval2Id */34][0];
                              if (match) {
                                clearInterval(match[0]);
                                state[/* interval2Id */34][0] = /* None */0;
                                return /* () */0;
                              } else {
                                return /* () */0;
                              }
                            })
                        ]);
              }
          case 11 : 
              var match$9 = state[/* preRunningCount */28];
              var exit$1 = 0;
              var switcher = match$9 + 1 | 0;
              if (switcher > 2 || switcher < 0) {
                exit$1 = 1;
              } else {
                switch (switcher) {
                  case 0 : 
                      return /* NoUpdate */0;
                  case 1 : 
                      exit$1 = 1;
                      break;
                  case 2 : 
                      var newrecord$11 = state.slice();
                      return /* Update */Block.__(0, [(newrecord$11[/* running */26] = /* true */1, newrecord$11[/* preRunning */27] = /* false */0, newrecord$11[/* preRunningCount */28] = -1, newrecord$11)]);
                  
                }
              }
              if (exit$1 === 1) {
                var newrecord$12 = state.slice();
                return /* Update */Block.__(0, [(newrecord$12[/* preRunningCount */28] = state[/* preRunningCount */28] - 1 | 0, newrecord$12)]);
              }
              break;
          case 12 : 
              var newrecord$13 = state.slice();
              return /* Update */Block.__(0, [(newrecord$13[/* running */26] = /* false */0, newrecord$13[/* showDetails23 */29] = /* false */0, newrecord$13[/* count */30] = state[/* duration */2], newrecord$13)]);
          
        }
      } else {
        switch (action.tag | 0) {
          case 0 : 
              var text = action[0];
              var validInt = checkForWeightInt(text);
              var validIntOpt = checkForWeightIntOpt(text);
              var oldWeight = Storage.getWeight(/* () */0);
              var weightReduction = validIntOpt ? /* Some */[oldWeight - validIntOpt[0] | 0] : /* None */0;
              var newrecord$14 = state.slice();
              return /* Update */Block.__(0, [(newrecord$14[/* weightReductionInput */35] = turnBackToString(validInt), newrecord$14[/* weightReduction */36] = weightReduction, newrecord$14)]);
          case 1 : 
              var item = action[0];
              var showDetailsNew = $$Array.mapi((function (index, oldEntry) {
                      var match = +(index === item);
                      if (match !== 0) {
                        return 1 - oldEntry;
                      } else {
                        return /* false */0;
                      }
                    }), state[/* showDetails */5]);
              var newrecord$15 = state.slice();
              return /* Update */Block.__(0, [(newrecord$15[/* showDetails */5] = showDetailsNew, newrecord$15)]);
          case 2 : 
              var validInt$1 = checkForInt(action[0]);
              var newrecord$16 = state.slice();
              return /* Update */Block.__(0, [(newrecord$16[/* exCur1Input */8] = turnBackToString(validInt$1), newrecord$16[/* exCur1 */9] = validInt$1, newrecord$16[/* exAInput */12] = turnBackToString(validInt$1), newrecord$16[/* exA */13] = validInt$1, newrecord$16)]);
          case 3 : 
              var validInt$2 = checkForInt(action[0]);
              var newrecord$17 = state.slice();
              return /* Update */Block.__(0, [(newrecord$17[/* exCur2Input */10] = turnBackToString(validInt$2), newrecord$17[/* exCur2 */11] = validInt$2, newrecord$17[/* exBInput */14] = turnBackToString(validInt$2), newrecord$17[/* exB */15] = validInt$2, newrecord$17)]);
          case 4 : 
              var validInt$3 = checkForInt(action[0]);
              var newrecord$18 = state.slice();
              return /* Update */Block.__(0, [(newrecord$18[/* exCur1Input */8] = turnBackToString(validInt$3), newrecord$18[/* exCur1 */9] = validInt$3, newrecord$18[/* exCInput */16] = turnBackToString(validInt$3), newrecord$18[/* exC */17] = validInt$3, newrecord$18)]);
          case 5 : 
              var validInt$4 = checkForInt(action[0]);
              var newrecord$19 = state.slice();
              return /* Update */Block.__(0, [(newrecord$19[/* exCur2Input */10] = turnBackToString(validInt$4), newrecord$19[/* exCur2 */11] = validInt$4, newrecord$19[/* exDInput */18] = turnBackToString(validInt$4), newrecord$19[/* exD */19] = validInt$4, newrecord$19)]);
          case 6 : 
              var validInt$5 = checkForInt(action[0]);
              var newrecord$20 = state.slice();
              return /* Update */Block.__(0, [(newrecord$20[/* exCur1Input */8] = turnBackToString(validInt$5), newrecord$20[/* exCur1 */9] = validInt$5, newrecord$20[/* exEInput */20] = turnBackToString(validInt$5), newrecord$20[/* exE */21] = validInt$5, newrecord$20)]);
          case 7 : 
              var validInt$6 = checkForInt(action[0]);
              var newrecord$21 = state.slice();
              return /* Update */Block.__(0, [(newrecord$21[/* exCur2Input */10] = turnBackToString(validInt$6), newrecord$21[/* exCur2 */11] = validInt$6, newrecord$21[/* exFInput */22] = turnBackToString(validInt$6), newrecord$21[/* exF */23] = validInt$6, newrecord$21)]);
          case 8 : 
              var item$1 = action[0];
              console.log("hiding: ", item$1);
              if (item$1 !== 1) {
                var newrecord$22 = state.slice();
                return /* Update */Block.__(0, [(newrecord$22[/* hide2 */25] = /* true */1, newrecord$22)]);
              } else {
                var newrecord$23 = state.slice();
                return /* Update */Block.__(0, [(newrecord$23[/* hide1 */24] = /* true */1, newrecord$23)]);
              }
          
        }
      }
    });
  newrecord[/* subscriptions */13] = (function (self) {
      return /* :: */[
              /* Sub */[
                (function () {
                    return ReasonReact.Router[/* watchUrl */1]((function () {
                                  return Curry._1(self[/* send */4], /* ClearState */12);
                                }));
                  }),
                ReasonReact.Router[/* unwatchUrl */2]
              ],
              /* [] */0
            ];
    });
  return newrecord;
}

exports.Styles = Styles;
exports.convToInt = convToInt;
exports.checkForInt = checkForInt;
exports.checkForWeightInt = checkForWeightInt;
exports.checkForWeightIntOpt = checkForWeightIntOpt;
exports.turnBackToString = turnBackToString;
exports.text = text;
exports.$$window = $$window;
exports.$$document = $$document;
exports.JsAudio = JsAudio;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var React = __webpack_require__(1);
var ReasonReact = __webpack_require__(2);

var initialBodyImgFrame = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.justifyContent(Css.center),
          /* :: */[
            Css.width(Css.px(160)),
            /* :: */[
              Css.height(Css.px(160)),
              /* :: */[
                Css.margin4(Css.px(5), Css.px(0), Css.px(15), Css.px(0)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var initialBodyImg = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.justifyContent(Css.center),
          /* :: */[
            Css.width(Css.px(148)),
            /* :: */[
              Css.height(Css.px(148)),
              /* :: */[
                Css.background(Css.white),
                /* :: */[
                  Css.borderRadius(/* `percent */[
                        -119887163,
                        50.0
                      ]),
                  /* :: */[
                    Css.padding2(Css.px(0), Css.px(0)),
                    /* :: */[
                      Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var roundIconBox = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var roundIcon = Css.style(/* :: */[
      Css.margin2(Css.px(20), Css.px(0)),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var countNumber = Css.style(/* :: */[
      Css.fontSize(Css.px(40)),
      /* :: */[
        Css.margin2(Css.px(20), Css.px(8)),
        /* [] */0
      ]
    ]);

var Styles = /* module */[
  /* initialBodyImgFrame */initialBodyImgFrame,
  /* initialBodyImg */initialBodyImg,
  /* roundIconBox */roundIconBox,
  /* roundIcon */roundIcon,
  /* countNumber */countNumber
];

var component = ReasonReact.reducerComponent("Counter");

function make(countdownTime, time, fixed, _) {
  var newrecord = component.slice();
  newrecord[/* willReceiveProps */3] = (function () {
      return /* record */[/* count */countdownTime];
    });
  newrecord[/* render */9] = (function () {
      var match = +(fixed !== /* true */1);
      return React.createElement("div", {
                  className: initialBodyImgFrame
                }, React.createElement("div", {
                      className: initialBodyImg
                    }, React.createElement("h1", {
                          className: countNumber
                        }, match !== 0 ? String(time) : String(countdownTime))));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[/* count */countdownTime];
    });
  newrecord[/* reducer */12] = (function (_, state) {
      var match = state[/* count */0];
      if (match !== 0) {
        return /* Update */Block.__(0, [/* record */[/* count */state[/* count */0] - 1 | 0]]);
      } else {
        return /* SideEffects */Block.__(2, [(function () {
                      return /* () */0;
                    })]);
      }
    });
  newrecord[/* subscriptions */13] = (function (self) {
      return /* :: */[
              /* Sub */[
                (function () {
                    return setInterval((function () {
                                  return Curry._1(self[/* send */4], /* Tick */0);
                                }), 1000);
                  }),
                (function (prim) {
                    clearInterval(prim);
                    return /* () */0;
                  })
              ],
              /* [] */0
            ];
    });
  return newrecord;
}

exports.Styles = Styles;
exports.component = component;
exports.make = make;
/* initialBodyImgFrame Not a pure module */


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var React = __webpack_require__(1);
var ReasonReact = __webpack_require__(2);

var initialBodyImg = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.justifyContent(Css.center),
          /* :: */[
            Css.width(Css.px(150)),
            /* :: */[
              Css.height(Css.px(150)),
              /* :: */[
                Css.background(Css.white),
                /* :: */[
                  Css.borderRadius(/* `percent */[
                        -119887163,
                        50.0
                      ]),
                  /* :: */[
                    Css.margin4(Css.px(5), Css.px(0), Css.px(5), Css.px(0)),
                    /* :: */[
                      Css.padding2(Css.px(0), Css.px(0)),
                      /* :: */[
                        Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                        /* [] */0
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var countNumberH4 = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var countNumber = Css.style(/* :: */[
      Css.fontSize(Css.px(40)),
      /* :: */[
        Css.margin2(Css.px(0), Css.px(8)),
        /* [] */0
      ]
    ]);

var Styles = /* module */[
  /* initialBodyImg */initialBodyImg,
  /* countNumberH4 */countNumberH4,
  /* countNumber */countNumber
];

var component = ReasonReact.reducerComponent("Counter");

function make(next, countdownTime, title, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      return React.createElement("div", {
                  className: initialBodyImg
                }, React.createElement("h4", {
                      className: countNumberH4
                    }, title), React.createElement("h1", {
                      className: countNumber
                    }, String(param[/* state */2][/* count */0])));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[/* count */countdownTime];
    });
  newrecord[/* reducer */12] = (function (_, state) {
      var match = state[/* count */0];
      if (match !== 0) {
        return /* Update */Block.__(0, [/* record */[/* count */state[/* count */0] - 1 | 0]]);
      } else {
        return /* SideEffects */Block.__(2, [(function () {
                      return Curry._1(next, /* () */0);
                    })]);
      }
    });
  newrecord[/* subscriptions */13] = (function (self) {
      return /* :: */[
              /* Sub */[
                (function () {
                    return setInterval((function () {
                                  return Curry._1(self[/* send */4], /* Tick */0);
                                }), 1000);
                  }),
                (function (prim) {
                    clearInterval(prim);
                    return /* () */0;
                  })
              ],
              /* [] */0
            ];
    });
  return newrecord;
}

exports.Styles = Styles;
exports.component = component;
exports.make = make;
/* initialBodyImg Not a pure module */


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var React = __webpack_require__(1);
var ReasonReact = __webpack_require__(2);

var initialBodyImg = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.justifyContent(Css.center),
          /* :: */[
            Css.margin4(Css.px(5), Css.px(0), Css.px(15), Css.px(0)),
            /* :: */[
              Css.padding2(Css.px(0), Css.px(0)),
              /* :: */[
                Css.position(/* relative */903134412),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

function d(property, value) {
  return /* `declaration */[
          -434952966,
          /* tuple */[
            property,
            value
          ]
        ];
}

function strokeDashArray(x) {
  return d("strokeDasharray", String(x) + "px");
}

function strokeDashOffset(x) {
  return d("strokeDashoffset", String(x) + "px");
}

function circleAnimation(deg) {
  return Css.style(/* :: */[
              strokeDashArray(440),
              /* :: */[
                strokeDashOffset(deg),
                /* :: */[
                  Css.transition(/* Some */[1], /* None */0, /* Some */[/* linear */-325037595], "all"),
                  /* [] */0
                ]
              ]
            ]);
}

var roundIconBox = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var roundIcon = Css.style(/* :: */[
      Css.margin2(Css.px(20), Css.px(0)),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var svg = Css.style(/* :: */[
      Css.transform(Css.rotate(/* `deg */[
                4995526,
                -90
              ])),
      /* [] */0
    ]);

var countNumber = Css.style(/* :: */[
      Css.fontSize(Css.px(40)),
      /* :: */[
        Css.position(/* absolute */-1013592457),
        /* :: */[
          Css.color(/* `hex */[
                5194459,
                "FF328C"
              ]),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* initialBodyImg */initialBodyImg,
  /* d */d,
  /* strokeDashArray */strokeDashArray,
  /* strokeDashOffset */strokeDashOffset,
  /* circleAnimation */circleAnimation,
  /* roundIconBox */roundIconBox,
  /* roundIcon */roundIcon,
  /* svg */svg,
  /* countNumber */countNumber
];

var component = ReasonReact.statelessComponent("Counter");

function make(countdownTime, _, time, fixed, _$1) {
  var i = -time;
  var res = i + countdownTime - 1.0;
  var degreesFloat = 440.0 - (res + 1.0) * (440.0 / countdownTime);
  var degrees = degreesFloat | 0;
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      var match = +(fixed !== /* true */1);
      return React.createElement("div", {
                  className: initialBodyImg
                }, React.createElement("svg", {
                      className: svg,
                      height: "160",
                      width: "160",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("g", undefined, React.createElement("circle", {
                              className: circleAnimation(degrees),
                              id: "circle",
                              cx: "81",
                              cy: "81",
                              fill: "#FFF",
                              r: "69.85699",
                              stroke: "#FF328C",
                              strokeWidth: "8"
                            }))), React.createElement("div", {
                      className: countNumber
                    }, match !== 0 ? String(time) : String(countdownTime)));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.component = component;
exports.make = make;
/* initialBodyImg Not a pure module */


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var React = __webpack_require__(1);
var ReasonReact = __webpack_require__(2);
var Points_shieldSvg = __webpack_require__(59);
var Congratulation_bgSvg = __webpack_require__(60);

var step5Box = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.borderRadius(Css.px(10)),
        /* :: */[
          Css.boxShadow(/* Some */[Css.px(2)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(255, 191, 194, 0.29)),
          /* :: */[
            Css.boxSizing(Css.borderBox),
            /* :: */[
              Css.margin4(Css.px(10), Css.px(10), Css.px(20), Css.px(10)),
              /* :: */[
                Css.background(/* `linearGradient */[
                      616379637,
                      /* tuple */[
                        /* `deg */[
                          4995526,
                          180
                        ],
                        /* :: */[
                          /* tuple */[
                            0,
                            Css.hex("FFF8F9")
                          ],
                          /* :: */[
                            /* tuple */[
                              50,
                              Css.rgba(255, 255, 255, 0.0)
                            ],
                            /* :: */[
                              /* tuple */[
                                98,
                                Css.hex("FFF8F9")
                              ],
                              /* [] */0
                            ]
                          ]
                        ]
                      ]
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var step5BoxInner1 = Css.style(/* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
        /* :: */[
          Css.padding2(Css.px(0), Css.px(16)),
          /* [] */0
        ]
      ]
    ]);

var step5BoxInner2 = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.background(/* `hex */[
                5194459,
                "FFFAFA"
              ]),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
            /* :: */[
              Css.padding2(Css.px(0), Css.px(10)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var middleText = Css.style(/* :: */[
      Css.margin2(Css.px(5), Css.px(0)),
      /* [] */0
    ]);

var step5BoxInner3 = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.position(/* relative */903134412),
            /* :: */[
              Css.marginTop(Css.px(20)),
              /* :: */[
                Css.marginBottom(Css.px(25)),
                /* :: */[
                  Css.paddingBottom(Css.px(20)),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var congratsIcon = Css.style(/* :: */[
      Css.margin4(Css.px(4), Css.px(0), Css.px(20), Css.px(0)),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var pointsShield = Css.style(/* :: */[
      Css.margin2(Css.px(20), Css.px(0)),
      /* :: */[
        Css.position(/* absolute */-1013592457),
        /* :: */[
          Css.transform(/* `scale */[
                -120664438,
                /* tuple */[
                  1.6,
                  1.6
                ]
              ]),
          /* [] */0
        ]
      ]
    ]);

var pointsShieldH1 = Css.style(/* :: */[
      Css.margin4(Css.px(68), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.zIndex(2),
        /* :: */[
          Css.lineHeight(1.0),
          /* [] */0
        ]
      ]
    ]);

var pointsShieldH3 = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.zIndex(2),
        /* :: */[
          Css.lineHeight(1.0),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* step5Box */step5Box,
  /* step5BoxInner1 */step5BoxInner1,
  /* step5BoxInner2 */step5BoxInner2,
  /* middleText */middleText,
  /* step5BoxInner3 */step5BoxInner3,
  /* congratsIcon */congratsIcon,
  /* pointsShield */pointsShield,
  /* pointsShieldH1 */pointsShieldH1,
  /* pointsShieldH3 */pointsShieldH3
];

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("Counter");

function make(points, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: step5Box
                }, React.createElement("div", {
                      className: step5BoxInner1
                    }, React.createElement("img", {
                          className: congratsIcon,
                          alt: "Congratulations",
                          src: Congratulation_bgSvg
                        })), React.createElement("div", {
                      className: step5BoxInner2
                    }, React.createElement("h2", {
                          className: middleText
                        }, "Du hast  dein  Workout\n            erfolgreich absolviert."), React.createElement("h2", {
                          className: middleText
                        }, "\n               Dein aktueller Punktestand:")), React.createElement("div", {
                      className: step5BoxInner3
                    }, React.createElement("img", {
                          className: pointsShield,
                          alt: "pointsShield",
                          src: Points_shieldSvg
                        }), React.createElement("h1", {
                          className: pointsShieldH1
                        }, "" + (String(points) + "")), React.createElement("h3", {
                          className: pointsShieldH3
                        }, "pts.")));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* step5Box Not a pure module */


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/round_bg.26f93aaa.svg";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Link = __webpack_require__(13);
var $$Array = __webpack_require__(12);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Storage = __webpack_require__(14);
var Caml_int32 = __webpack_require__(11);
var Caml_format = __webpack_require__(8);
var ReasonReact = __webpack_require__(2);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.fontWeight(700),
        /* [] */0
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink
];

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("FoodWeek");

function make(week, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("h1", undefined, "Mahlzeiten Woche " + week), React.createElement("p", undefined, "current week: " + String(self[/* state */2][/* week */0])), $$Array.map((function (param) {
                            var day = param[1];
                            var el = param[0];
                            return React.createElement("button", {
                                        key: el,
                                        className: Theme.simpleButton(/* () */0),
                                        onClick: (function () {
                                            return ReasonReact.Router[/* push */0]("/foodday/" + String(day + Caml_int32.imul(Caml_format.caml_int_of_string(week) - 1 | 0, 7) | 0));
                                          })
                                      }, "Mahlzeiten Tag " + (String(el) + ""));
                          }), /* array */[
                          /* tuple */[
                            "1",
                            1
                          ],
                          /* tuple */[
                            "2",
                            2
                          ],
                          /* tuple */[
                            "3",
                            3
                          ],
                          /* tuple */[
                            "4",
                            4
                          ],
                          /* tuple */[
                            "5",
                            5
                          ],
                          /* tuple */[
                            "6",
                            6
                          ],
                          /* tuple */[
                            "7",
                            7
                          ]
                        ])), ReasonReact.element(/* None */0, /* None */0, Link.make("/dashboard", "Dashboard", someLink, /* array */[])));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* week */Storage.weekOfDay(/* () */0),
              /* day */Storage.weekDay(/* () */0)
            ];
    });
  newrecord[/* reducer */12] = (function (_, _$1) {
      return /* NoUpdate */0;
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Block = __webpack_require__(5);

function reify_type(x) {
  if (typeof x === "undefined") {
    return /* tuple */[
            /* Undefined */0,
            x
          ];
  } else if (x === null) {
    return /* tuple */[
            /* Null */1,
            x
          ];
  } else if (typeof x === "number") {
    return /* tuple */[
            /* Number */3,
            x
          ];
  } else if (typeof x === "string") {
    return /* tuple */[
            /* String */4,
            x
          ];
  } else if (typeof x === "boolean") {
    return /* tuple */[
            /* Boolean */2,
            x
          ];
  } else if (typeof x === "function") {
    return /* tuple */[
            /* Function */5,
            x
          ];
  } else if (typeof x === "object") {
    return /* tuple */[
            /* Object */6,
            x
          ];
  } else {
    return /* tuple */[
            /* Symbol */7,
            x
          ];
  }
}

function classify(x) {
  var ty = typeof x;
  if (ty === "undefined") {
    return /* JSUndefined */3;
  } else if (x === null) {
    return /* JSNull */2;
  } else if (ty === "number") {
    return /* JSNumber */Block.__(0, [x]);
  } else if (ty === "string") {
    return /* JSString */Block.__(1, [x]);
  } else if (ty === "boolean") {
    if (x === true) {
      return /* JSTrue */1;
    } else {
      return /* JSFalse */0;
    }
  } else if (ty === "function") {
    return /* JSFunction */Block.__(2, [x]);
  } else if (ty === "object") {
    return /* JSObject */Block.__(3, [x]);
  } else {
    return /* JSSymbol */Block.__(4, [x]);
  }
}

function test(x, v) {
  switch (v) {
    case 0 : 
        return +(typeof x === "undefined");
    case 1 : 
        return +(x === null);
    case 2 : 
        return +(typeof x === "boolean");
    case 3 : 
        return +(typeof x === "number");
    case 4 : 
        return +(typeof x === "string");
    case 5 : 
        return +(typeof x === "function");
    case 6 : 
        return +(typeof x === "object");
    case 7 : 
        return +(typeof x === "symbol");
    
  }
}

exports.reify_type = reify_type;
exports.test = test;
exports.classify = classify;
/* No side effect */


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Link = __webpack_require__(13);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Fetch = __webpack_require__(25);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Network = __webpack_require__(7);
var Json_encode = __webpack_require__(23);
var ReasonReact = __webpack_require__(2);
var Code_inputSvg = __webpack_require__(130);
var Mail_inputSvg = __webpack_require__(29);
var Register_iconSvg = __webpack_require__(131);
var Password_inputSvg = __webpack_require__(51);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var register = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var registerHeadBox = Css.style(/* :: */[
      Css.position(Css.relative),
      /* :: */[
        Css.textAlign(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.flexDirection(Css.column),
                /* :: */[
                  Css.margin4(Css.px(20), Css.px(0), Css.px(0), Css.px(0)),
                  /* :: */[
                    Css.fontSize(Css.px(24)),
                    /* :: */[
                      Css.width(Css.px(110)),
                      /* :: */[
                        Css.height(Css.px(110)),
                        /* :: */[
                          Css.borderRadius(/* `percent */[
                                -119887163,
                                50.0
                              ]),
                          /* :: */[
                            Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var registerIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.1,
                  1.1
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      -50.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(/* `percent */[
                  -119887163,
                  53.0
                ]),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(35)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var inputBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.padding(Css.px(10)),
                /* :: */[
                  Css.boxSizing(/* borderBox */9307263),
                  /* :: */[
                    Css.position(Css.relative),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var inputFieldBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.position(Css.relative),
            /* :: */[
              Css.boxSizing(/* borderBox */9307263),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding4(Css.px(5), Css.px(10), Css.px(5), Css.px(50)),
        /* :: */[
          Css.fontSize(Css.px(18)),
          /* :: */[
            Css.minHeight(Css.px(40)),
            /* :: */[
              Css.maxWidth(Css.px(300)),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.minWidth(Css.px(220)),
                  /* :: */[
                    Css.borderRadius(/* `px */[
                          25096,
                          50
                        ]),
                    /* :: */[
                      Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                            5194459,
                            "F492BD"
                          ]),
                      /* :: */[
                        Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                        /* :: */[
                          Css.boxSizing(/* borderBox */9307263),
                          /* :: */[
                            Css.position(Css.relative),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var mailInput = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.2,
                  1.2
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      0.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.left(Css.px(18)),
          /* :: */[
            Css.position(/* absolute */-1013592457),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(25)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var codeInput = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.05,
                  1.05
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      0.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.left(Css.px(18)),
          /* :: */[
            Css.position(/* absolute */-1013592457),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(21)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var passwordInput = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.05,
                  1.05
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      0.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.left(Css.px(18)),
          /* :: */[
            Css.position(/* absolute */-1013592457),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(21)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* register */register,
  /* registerHeadBox */registerHeadBox,
  /* registerIcon */registerIcon,
  /* inputBox */inputBox,
  /* inputFieldBox */inputFieldBox,
  /* inputField */inputField,
  /* mailInput */mailInput,
  /* codeInput */codeInput,
  /* passwordInput */passwordInput,
  /* someLink */someLink
];

function text(prim) {
  return prim;
}

function validatePassword(value) {
  var match = +(value.length > 5);
  if (match !== 0) {
    return /* PassValid */0;
  } else {
    return /* PassNotValid */["Password zu kurz"];
  }
}

function validateEmail(value) {
  var emailRegex = (/.*@.*\..+/);
  if (value === "") {
    return /* Some */["Email Feld leer"];
  } else if (emailRegex.test(value)) {
    return /* None */0;
  } else {
    return /* Some */["Email Adresse enthält Fehler"];
  }
}

function showApiError(data, self, message) {
  return Promise.resolve(data).then((function () {
                  console.log("Login error!");
                  Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(3, [message]));
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("API error exception", err), /* () */0));
              }));
}

var component = ReasonReact.reducerComponent("Register");

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      var send = param[/* send */4];
      var state = param[/* state */2];
      var match = state[/* error */3];
      var match$1 = state[/* success */4];
      var match$2 = state[/* loading */5];
      return React.createElement("div", {
                  className: register
                }, React.createElement("div", {
                      className: registerHeadBox
                    }, React.createElement("img", {
                          className: registerIcon,
                          alt: "icon",
                          src: Register_iconSvg
                        })), React.createElement("h1", undefined, "Registrieren"), React.createElement("div", {
                      className: inputBox
                    }, React.createElement("div", {
                          className: inputFieldBox
                        }, React.createElement("input", {
                              className: inputField,
                              autoFocus: true,
                              placeholder: "Email",
                              type: "email",
                              value: state[/* email */0],
                              onChange: (function ($$event) {
                                  return Curry._1(send, /* ChangeEmail */Block.__(0, [$$event.target.value]));
                                })
                            }), React.createElement("img", {
                              className: mailInput,
                              alt: "mail",
                              src: Mail_inputSvg
                            })), React.createElement("div", {
                          className: inputFieldBox
                        }, React.createElement("input", {
                              className: inputField,
                              placeholder: "Code",
                              type: "text",
                              value: state[/* code */2],
                              onChange: (function ($$event) {
                                  return Curry._1(send, /* ChangeCode */Block.__(1, [$$event.target.value]));
                                })
                            }), React.createElement("img", {
                              className: codeInput,
                              alt: "pass",
                              src: Code_inputSvg
                            })), React.createElement("div", {
                          className: inputFieldBox
                        }, React.createElement("input", {
                              className: inputField,
                              placeholder: "Passwort",
                              type: "password",
                              value: state[/* password */1],
                              onKeyDown: (function ($$event) {
                                  if ($$event.keyCode === 13) {
                                    $$event.preventDefault();
                                    return Curry._1(send, /* RegisterEnterKeyDown */1);
                                  } else {
                                    return Curry._1(send, /* RegisterOtherKeyDown */0);
                                  }
                                }),
                              onChange: (function ($$event) {
                                  return Curry._1(send, /* ChangePassword */Block.__(2, [$$event.target.value]));
                                })
                            }), React.createElement("img", {
                              className: passwordInput,
                              alt: "mail",
                              src: Password_inputSvg
                            }))), match ? React.createElement("div", {
                        className: "failure"
                      }, match[0]) : null, match$1 ? React.createElement("div", {
                        className: "success"
                      }, match$1[0]) : null, React.createElement("button", {
                      className: Theme.simpleButton(/* () */0),
                      onClick: (function () {
                          return Curry._1(send, /* Register */2);
                        })
                    }, match$2 !== 0 ? React.createElement("div", {
                            className: "button-spinner"
                          }) : "Registrieren"), ReasonReact.element(/* None */0, /* None */0, Link.make("/login", "zum Login", someLink, /* array */[])));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* email */Network.getUrlParamCode(/* Email */1),
              /* password */"",
              /* code */Network.getUrlParamCode(/* Code */0),
              /* error : None */0,
              /* success : None */0,
              /* loading : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* SideEffects */Block.__(2, [(function (self) {
                            return Curry._1(self[/* send */4], /* Register */2);
                          })]);
          case 2 : 
              var emailValid = validateEmail(state[/* email */0]);
              if (emailValid) {
                var error = emailValid[0];
                return /* SideEffects */Block.__(2, [(function (self) {
                              return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(3, [error]));
                            })]);
              } else {
                var passwordValid = validatePassword(state[/* password */1]);
                if (passwordValid) {
                  var error$1 = passwordValid[0];
                  return /* SideEffects */Block.__(2, [(function (self) {
                                return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(3, [error$1]));
                              })]);
                } else {
                  var newrecord = state.slice();
                  return /* UpdateWithSideEffects */Block.__(3, [
                            (newrecord[/* loading */5] = /* true */1, newrecord),
                            (function (self) {
                                var requestPayload = Json_encode.object_(/* :: */[
                                      /* tuple */[
                                        "email",
                                        self[/* state */2][/* email */0]
                                      ],
                                      /* :: */[
                                        /* tuple */[
                                          "password",
                                          self[/* state */2][/* password */1]
                                        ],
                                        /* :: */[
                                          /* tuple */[
                                            "token",
                                            self[/* state */2][/* code */2]
                                          ],
                                          /* [] */0
                                        ]
                                      ]
                                    ]);
                                fetch(Network.registerUrl, Fetch.RequestInit[/* make */0](/* Some */[/* Post */2], /* Some */[{
                                                  "Content-Type": "application/json",
                                                  Accept: "application.json"
                                                }], /* Some */[JSON.stringify(requestPayload)], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0)).then((function (data) {
                                          console.log("breakpoint");
                                          var statusCode = data.status;
                                          console.log("https status: ", statusCode);
                                          var exit = 0;
                                          if (statusCode >= 401) {
                                            if (statusCode >= 413) {
                                              exit = 1;
                                            } else {
                                              switch (statusCode - 401 | 0) {
                                                case 0 : 
                                                    return showApiError(data, self, "Registrierungscode fehlerhaft");
                                                case 8 : 
                                                    return showApiError(data, self, "Email Adresse bereits registriert!");
                                                case 1 : 
                                                case 2 : 
                                                case 3 : 
                                                case 4 : 
                                                case 5 : 
                                                case 6 : 
                                                case 7 : 
                                                case 9 : 
                                                case 10 : 
                                                    exit = 1;
                                                    break;
                                                case 11 : 
                                                    return showApiError(data, self, "Registrierungscode bereits verwendet");
                                                
                                              }
                                            }
                                          } else if (statusCode !== 201) {
                                            exit = 1;
                                          } else {
                                            console.log("Registration success");
                                            Curry._1(self[/* send */4], /* ShowSuccessMessage */Block.__(4, ["Registrierung erfolgreich"]));
                                            return Promise.resolve(/* () */0);
                                          }
                                          if (exit === 1) {
                                            return showApiError(data, self, "Http Fehler: " + String(statusCode));
                                          }
                                          
                                        })).catch((function (err) {
                                        return Promise.resolve((console.log("Api error", err), Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(3, ["Netzwerkfehler"]))));
                                      }));
                                return /* () */0;
                              })
                          ]);
                }
              }
          case 3 : 
              var newrecord$1 = state.slice();
              return /* Update */Block.__(0, [(newrecord$1[/* error */3] = /* None */0, newrecord$1)]);
          
        }
      } else {
        switch (action.tag | 0) {
          case 0 : 
              var newrecord$2 = state.slice();
              return /* Update */Block.__(0, [(newrecord$2[/* email */0] = action[0], newrecord$2)]);
          case 1 : 
              var newrecord$3 = state.slice();
              return /* Update */Block.__(0, [(newrecord$3[/* code */2] = action[0], newrecord$3)]);
          case 2 : 
              var newrecord$4 = state.slice();
              return /* Update */Block.__(0, [(newrecord$4[/* password */1] = action[0], newrecord$4)]);
          case 3 : 
              var text = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* email */state[/* email */0],
                          /* password */state[/* password */1],
                          /* code */state[/* code */2],
                          /* error : Some */[text],
                          /* success */state[/* success */4],
                          /* loading : false */0
                        ],
                        (function (self) {
                            console.log("ShowErrorMessage Reducer:", text);
                            setTimeout((function () {
                                    return Curry._1(self[/* send */4], /* ClearError */3);
                                  }), 2500);
                            return /* () */0;
                          })
                      ]);
          case 4 : 
              var text$1 = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* email */state[/* email */0],
                          /* password */state[/* password */1],
                          /* code */state[/* code */2],
                          /* error */state[/* error */3],
                          /* success : Some */[text$1],
                          /* loading : false */0
                        ],
                        (function (self) {
                            console.log("ShowSuccessMessage Reducer:", text$1);
                            setTimeout((function () {
                                    return ReasonReact.Router[/* push */0]("/?email=" + self[/* state */2][/* email */0]);
                                  }), 2500);
                            return /* () */0;
                          })
                      ]);
          
        }
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.validatePassword = validatePassword;
exports.validateEmail = validateEmail;
exports.showApiError = showApiError;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/code_input.4262e1f4.svg";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/register_icon.c9a53ff2.svg";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Network = __webpack_require__(7);
var ReasonReact = __webpack_require__(2);
var Trainingslevel_iconSvg = __webpack_require__(133);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.padding4(Css.px(0), Css.px(20), Css.px(2), Css.px(20)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var resetBox = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* [] */0
    ]);

var resetButtonBox = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* [] */0
    ]);

var topIcon = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(20)),
      /* [] */0
    ]);

var resetHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(5)),
      /* [] */0
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.standardFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(10), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

function widerSecondaryGreenButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(180)),
              /* :: */[
                Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
                Theme.greenSecondaryButtonRaw
              ]
            ]);
}

var centerIcon = Css.style(/* :: */[
      Css.margin4(Css.px(30), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.2,
                1.2
              ]
            ]),
        /* [] */0
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* resetBox */resetBox,
  /* resetButtonBox */resetButtonBox,
  /* topIcon */topIcon,
  /* inputHeader */inputHeader,
  /* resetHeader */resetHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* widerSecondaryGreenButton */widerSecondaryGreenButton,
  /* centerIcon */centerIcon
];

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("Settings");

function make() {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var match = self[/* state */2][/* resetActive */1];
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("div", {
                          className: topIcon
                        }, React.createElement("img", {
                              className: centerIcon,
                              alt: "centerIcon",
                              src: Trainingslevel_iconSvg
                            })), React.createElement("h2", undefined, "Belastungsumfang ändern"), React.createElement("p", {
                          className: inputHeader
                        }, "Hier kannst du dein Trainingslevel ändern. Genaue Informationen zum Level und dem Punktemultiplikator findest du in deinem eBook."), React.createElement("button", {
                          className: widerSecondaryGreenButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* LevelSelect */[30]);
                            })
                        }, "Anfänger"), React.createElement("button", {
                          className: widerSecondaryGreenButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* LevelSelect */[45]);
                            })
                        }, "Fortgeschritten"), React.createElement("button", {
                          className: widerSecondaryGreenButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* LevelSelect */[60]);
                            })
                        }, "Profi"), match !== 0 ? React.createElement("div", {
                            className: resetBox
                          }, React.createElement("p", {
                                className: resetHeader
                              }, "Reset wirklich durchführen?"), React.createElement("div", {
                                className: resetButtonBox
                              }, React.createElement("button", {
                                    className: Theme.verySlimButton(/* () */0),
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* Reset */2);
                                      })
                                  }, "Ja"), React.createElement("button", {
                                    className: Theme.verySlimButton(/* () */0),
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* ResetDeactivate */1);
                                      })
                                  }, "Nein"))) : React.createElement("a", {
                            className: someLink,
                            onClick: (function () {
                                return Curry._1(self[/* send */4], /* ResetActivate */0);
                              })
                          }, "Reset"), React.createElement("button", {
                          className: Theme.simpleButton(/* () */0),
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/dashboard");
                            })
                        }, "Zurück")));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* levelSelect */0,
              /* resetActive : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* Update */Block.__(0, [/* record */[
                          /* levelSelect */state[/* levelSelect */0],
                          /* resetActive : true */1
                        ]]);
          case 1 : 
              return /* Update */Block.__(0, [/* record */[
                          /* levelSelect */state[/* levelSelect */0],
                          /* resetActive : false */0
                        ]]);
          case 2 : 
              return /* SideEffects */Block.__(2, [(function () {
                            Network.resetAll(/* () */0);
                            return ReasonReact.Router[/* push */0]("/wizard/1");
                          })]);
          case 3 : 
              return /* SideEffects */Block.__(2, [(function () {
                            Network.resetAll(/* () */0);
                            return ReasonReact.Router[/* push */0]("/testing");
                          })]);
          
        }
      } else {
        var value = action[0];
        return /* UpdateWithSideEffects */Block.__(3, [
                  /* record */[
                    /* levelSelect */value,
                    /* resetActive */state[/* resetActive */1]
                  ],
                  (function () {
                      Network.updateWizardResultToLS(value);
                      return ReasonReact.Router[/* push */0]("/dashboard");
                    })
                ]);
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/trainingslevel_icon.0090973c.svg";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var $$Array = __webpack_require__(12);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Network = __webpack_require__(7);
var Storage = __webpack_require__(14);
var Caml_obj = __webpack_require__(15);
var Caml_array = __webpack_require__(9);
var ReasonReact = __webpack_require__(2);
var Calendar_iconSvg = __webpack_require__(135);
var Points_shieldSvg = __webpack_require__(59);
var Tipps_cta_iconSvg = __webpack_require__(136);
var Points_star_iconSvg = __webpack_require__(137);
var Mahlzeit_cta_iconSvg = __webpack_require__(138);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.position(/* relative */903134412),
            /* [] */0
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.stretch),
          /* [] */0
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.boxSizing(/* borderBox */9307263),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var vertBlock = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
            /* :: */[
              Css.borderTopLeftRadius(Css.px(10)),
              /* :: */[
                Css.borderTopRightRadius(Css.px(10)),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 44, 123, 0.25)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var headerBlock = Css.style(/* :: */[
      Css.margin4(Css.px(20), Css.px(0), Css.px(10), Css.px(0)),
      /* [] */0
    ]);

var horizontalBlock = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.justifyContent(Css.spaceAround),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* [] */0
        ]
      ]
    ]);

var horizontalBlockTop = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.row),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.justifyContent(Css.spaceAround),
            /* :: */[
              Css.background(Css.hex("FFFAFA")),
              /* :: */[
                Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.borderTopLeftRadius(Css.px(10)),
                    /* :: */[
                      Css.borderTopRightRadius(Css.px(10)),
                      /* :: */[
                        Css.height(Css.px(50)),
                        /* [] */0
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var horizontalBlockBottom = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
          /* :: */[
            Css.justifyContent(Css.spaceAround),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.background(Css.hex("00")),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.padding2(Css.px(8), Css.px(0)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var horizontalBlockInner = Css.style(/* :: */[
      Css.marginBottom(Css.px(3)),
      /* :: */[
        Css.marginTop(Css.px(8)),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.fontSize(Css.px(22)),
            /* [] */0
          ]
        ]
      ]
    ]);

var horizontalBlockInnerLeft = Css.style(/* :: */[
      Css.textTransform(/* uppercase */-415330030),
      /* [] */0
    ]);

var horizontalBlockInnerRight = Css.style(/* [] */0);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.fontWeight(700),
        /* [] */0
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

function optButton(week, el) {
  var match = Caml_obj.caml_equal(week, el);
  return Css.style(/* :: */[
              match !== 0 ? Css.opacity(1.0) : Css.opacity(0.4),
              /* :: */[
                Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
                Theme.greenButtonRaw
              ]
            ]);
}

function settingButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(12.0)),
              /* :: */[
                Css.margin4(Css.px(10), Css.px(8), Css.px(10), Css.px(8)),
                Theme.greenButtonRaw
              ]
            ]);
}

var buttonBox = Css.style(/* :: */[
      Css.justifyContent(Css.center),
      /* :: */[
        Css.flexWrap(Css.wrap),
        /* [] */0
      ]
    ]);

var dashboardPointsBg = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* [] */0
        ]
      ]
    ]);

function smallerRedSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(100)),
              /* :: */[
                Css.maxWidth(Css.px(140)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.height(Css.px(35)),
                    /* :: */[
                      Css.color(/* `hex */[
                            5194459,
                            "FF328C"
                          ]),
                      /* :: */[
                        Css.margin4(Css.px(2), Css.px(0), Css.px(2), Css.px(0)),
                        /* :: */[
                          Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                5194459,
                                "FF328C"
                              ]),
                          Theme.redButtonNarrowRaw
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function smallerRedSecondaryButtonHigh() {
  return Css.style(/* :: */[
              Css.background(/* `hex */[
                    5194459,
                    "FFEEEF"
                  ]),
              /* :: */[
                Css.selector("&:hover", /* :: */[
                      Css.background(/* `hex */[
                            5194459,
                            "F8CDD0"
                          ]),
                      /* [] */0
                    ]),
                /* :: */[
                  Css.minWidth(Css.px(100)),
                  /* :: */[
                    Css.maxWidth(Css.px(140)),
                    /* :: */[
                      Css.width(/* `percent */[
                            -119887163,
                            100.0
                          ]),
                      /* :: */[
                        Css.height(Css.px(35)),
                        /* :: */[
                          Css.color(/* `hex */[
                                5194459,
                                "FF328C"
                              ]),
                          /* :: */[
                            Css.margin4(Css.px(2), Css.px(0), Css.px(2), Css.px(0)),
                            /* :: */[
                              Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                    5194459,
                                    "FF328C"
                                  ]),
                              Theme.redButtonNarrowRaw
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function mediumGreenSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(170)),
              /* :: */[
                Css.margin4(Css.px(8), Css.px(8), Css.px(8), Css.px(8)),
                /* :: */[
                  Css.flexGrow(1),
                  /* :: */[
                    Css.color(/* `hex */[
                          5194459,
                          "00C9C8"
                        ]),
                    /* :: */[
                      Css.height(Css.px(40)),
                      /* :: */[
                        Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                              5194459,
                              "00C9C8"
                            ]),
                        Theme.greenSecondaryButtonRaw
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var knowledgeWrapper = Css.style(/* :: */[
      Css.maxWidth(Css.px(180)),
      /* :: */[
        Css.flexGrow(1),
        /* :: */[
          Css.position(/* relative */903134412),
          /* [] */0
        ]
      ]
    ]);

var knowledgeInfo = Css.style(/* :: */[
      Css.borderRadius(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.background(/* `hex */[
              5194459,
              "00C9C8"
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.height(Css.px(17)),
            /* :: */[
              Css.width(Css.px(17)),
              /* :: */[
                Css.top(Css.px(5)),
                /* :: */[
                  Css.right(Css.px(2)),
                  /* :: */[
                    Css.alignItems(/* center */98248149),
                    /* :: */[
                      Css.justifyContent(/* center */98248149),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var knowledgeInfoContent = Css.style(/* :: */[
      Css.textAlign(/* center */98248149),
      /* :: */[
        Css.fontSize(Css.px(12)),
        /* :: */[
          Css.color(Css.white),
          /* :: */[
            Css.fontWeight(700),
            /* :: */[
              Css.marginRight(Css.px(0)),
              /* :: */[
                Css.marginTop(Css.px(0)),
                /* :: */[
                  Css.alignSelf(/* center */98248149),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var headText = Css.style(/* :: */[
      Css.color(/* `hex */[
            5194459,
            "FF328C"
          ]),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

var questionText = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.fontWeight(400),
          /* [] */0
        ]
      ]
    ]);

var pointsStarIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.paddingRight(Css.px(8)),
        /* [] */0
      ]
    ]);

var calendarIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.paddingBottom(Css.px(4)),
        /* :: */[
          Css.paddingRight(Css.px(8)),
          /* [] */0
        ]
      ]
    ]);

var pointsShield = Css.style(/* :: */[
      Css.margin2(Css.px(20), Css.px(0)),
      /* :: */[
        Css.position(/* absolute */-1013592457),
        /* :: */[
          Css.transform(/* `scale */[
                -120664438,
                /* tuple */[
                  1.6,
                  1.6
                ]
              ]),
          /* [] */0
        ]
      ]
    ]);

var pointsShieldH1 = Css.style(/* :: */[
      Css.margin4(Css.px(68), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.zIndex(2),
        /* :: */[
          Css.lineHeight(1.0),
          /* [] */0
        ]
      ]
    ]);

var pointsShieldH3 = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.zIndex(2),
        /* :: */[
          Css.lineHeight(1.0),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* contentBox */contentBox,
  /* vertBlock */vertBlock,
  /* headerBlock */headerBlock,
  /* horizontalBlock */horizontalBlock,
  /* horizontalBlockTop */horizontalBlockTop,
  /* horizontalBlockBottom */horizontalBlockBottom,
  /* horizontalBlockInner */horizontalBlockInner,
  /* horizontalBlockInnerLeft */horizontalBlockInnerLeft,
  /* horizontalBlockInnerRight */horizontalBlockInnerRight,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* optButton */optButton,
  /* settingButton */settingButton,
  /* buttonBox */buttonBox,
  /* dashboardPointsBg */dashboardPointsBg,
  /* smallerRedSecondaryButton */smallerRedSecondaryButton,
  /* smallerRedSecondaryButtonHigh */smallerRedSecondaryButtonHigh,
  /* mediumGreenSecondaryButton */mediumGreenSecondaryButton,
  /* knowledgeWrapper */knowledgeWrapper,
  /* knowledgeInfo */knowledgeInfo,
  /* knowledgeInfoContent */knowledgeInfoContent,
  /* headText */headText,
  /* questionText */questionText,
  /* pointsStarIcon */pointsStarIcon,
  /* calendarIcon */calendarIcon,
  /* pointsShield */pointsShield,
  /* pointsShieldH1 */pointsShieldH1,
  /* pointsShieldH3 */pointsShieldH3
];

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("Dashboard");

function make() {
  var syncNetworkData = function (param) {
    var send = param[/* send */4];
    var state = param[/* state */2];
    Network.initializeSyncStatus2(/* () */0);
    Network.pullData("", (function (data) {
            return Network.successSyncAllNoRedirect(data, (function () {
                          var match = state[/* isMounted */7][0];
                          if (match !== 0) {
                            return Curry._1(send, /* Loaded */1);
                          } else {
                            return /* () */0;
                          }
                        }));
          }));
    return Curry._1(send, /* Loading */2);
  };
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      var match = +(Network.pullWizardConfig(/* () */0) !== /* None */0);
      if (match === 0) {
        ReasonReact.Router[/* push */0]("/wizard/1");
      }
      syncNetworkData(self);
      return /* NoUpdate */0;
    });
  newrecord[/* willUnmount */6] = (function (self) {
      self[/* state */2][/* isMounted */7][0] = /* false */0;
      return /* () */0;
    });
  newrecord[/* render */9] = (function (self) {
      var week = String(self[/* state */2][/* week */0]);
      var points = String(self[/* state */2][/* points */3]);
      var pointsWeek = /* array */[
        String(Caml_array.caml_array_get(self[/* state */2][/* pointsWeek */4], 0)),
        String(Caml_array.caml_array_get(self[/* state */2][/* pointsWeek */4], 1)),
        String(Caml_array.caml_array_get(self[/* state */2][/* pointsWeek */4], 2)),
        String(Caml_array.caml_array_get(self[/* state */2][/* pointsWeek */4], 3))
      ];
      var showReset = Network.check16Completed(/* () */0) || +(Storage.fullDay(/* () */0) > 28);
      var x = self[/* state */2][/* fullDay */2];
      var match = self[/* state */2][/* show14 */8];
      var match$1 = self[/* state */2][/* show24 */9];
      var match$2 = 1 - self[/* state */2][/* knowledgeFresh */6];
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("img", {
                      className: pointsShield,
                      alt: "",
                      src: Points_shieldSvg
                    }), React.createElement("h1", {
                      className: pointsShieldH1
                    }, "" + (String(points) + "")), React.createElement("h3", {
                      className: pointsShieldH3
                    }, "pts."), React.createElement("div", {
                      className: headerBlock
                    }, x !== 0 ? (
                        x > 28 ? React.createElement("h3", {
                                className: horizontalBlockInner
                              }, "Programm abgeschlossen") : React.createElement("h3", {
                                className: horizontalBlockInner
                              }, "Woche " + (String(self[/* state */2][/* week */0]) + (", Tag " + String(self[/* state */2][/* day */1]))))
                      ) : React.createElement("h3", {
                            className: horizontalBlockInner
                          }, "Programm nicht gestartet")), React.createElement("div", {
                      className: contentBox
                    }, showReset !== 0 ? React.createElement("div", {
                            className: vertBlock
                          }, React.createElement("div", {
                                className: horizontalBlockTop
                              }, React.createElement("div", {
                                    className: headText
                                  }, "Programm beendet")), React.createElement("div", {
                                className: questionText
                              }, "Du hast das Programm abgeschlossen. Möchtest du deine Daten zurücksetzen und nochmals anfangen?"), React.createElement("div", {
                                className: horizontalBlockBottom
                              }, React.createElement("button", {
                                    className: smallerRedSecondaryButton(/* () */0),
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* Reset */3);
                                      })
                                  }, "Reset"))) : null, match !== 0 ? React.createElement("div", {
                            className: vertBlock
                          }, React.createElement("div", {
                                className: horizontalBlockTop
                              }, React.createElement("div", {
                                    className: headText
                                  }, "Anpassung Kalorienbedarf?")), React.createElement("div", {
                                className: questionText
                              }, "14 Tage sind geschafft! Du kannst nun deine tägliche Nahrungsaufnahme um 200 Kalorien reduzieren. Möchtest du die Änderung vornehmen?"), React.createElement("div", {
                                className: horizontalBlockBottom
                              }, React.createElement("button", {
                                    className: smallerRedSecondaryButton(/* () */0),
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* Send14 */Block.__(0, [/* true */1]));
                                      })
                                  }, "Ja"), React.createElement("button", {
                                    className: smallerRedSecondaryButton(/* () */0),
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* Send14 */Block.__(0, [/* false */0]));
                                      })
                                  }, "Nein"))) : null, match$1 !== 0 ? React.createElement("div", {
                            className: vertBlock
                          }, React.createElement("div", {
                                className: horizontalBlockTop
                              }, React.createElement("div", {
                                    className: headText
                                  }, "Anpassung Kalorienbedarf?")), React.createElement("div", {
                                className: questionText
                              }, "24 Tage sind geschaftt! Du kannst nun deine tägliche Nahrungsaufnahme um 200 Kalorien reduzieren. Möchtest du die Änderung vornehmen?"), React.createElement("div", {
                                className: horizontalBlockBottom
                              }, React.createElement("button", {
                                    className: smallerRedSecondaryButton(/* () */0),
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* Send24 */Block.__(1, [/* true */1]));
                                      })
                                  }, "Ja"), React.createElement("button", {
                                    className: smallerRedSecondaryButton(/* () */0),
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* Send24 */Block.__(1, [/* false */0]));
                                      })
                                  }, "Nein"))) : null, $$Array.mapi((function (i, param) {
                            var el = param[0];
                            var pointsWeekCur = Caml_array.caml_array_get(pointsWeek, i);
                            var match = +(week === el);
                            return React.createElement("div", {
                                        key: el,
                                        className: vertBlock
                                      }, React.createElement("div", {
                                            className: horizontalBlockTop
                                          }, React.createElement("div", {
                                                className: horizontalBlockInnerLeft
                                              }, React.createElement("img", {
                                                    className: calendarIcon,
                                                    alt: "",
                                                    src: Calendar_iconSvg
                                                  }), React.createElement("div", undefined, React.createElement("div", {
                                                        className: headText
                                                      }, "Woche " + (String(el) + "")))), React.createElement("div", {
                                                className: horizontalBlockInnerRight
                                              }, React.createElement("img", {
                                                    className: pointsStarIcon,
                                                    alt: "",
                                                    src: Points_star_iconSvg
                                                  }), React.createElement("div", {
                                                    className: headText
                                                  }, "" + (String(pointsWeekCur) + " pts.")))), React.createElement("div", {
                                            className: horizontalBlockBottom
                                          }, match !== 0 ? React.createElement("button", {
                                                  key: el + "1",
                                                  className: smallerRedSecondaryButtonHigh(/* () */0),
                                                  onClick: (function () {
                                                      return ReasonReact.Router[/* push */0]("/week/" + (el + "/workoutweek"));
                                                    })
                                                }, "Workouts") : React.createElement("button", {
                                                  key: el + "1",
                                                  className: smallerRedSecondaryButton(/* () */0),
                                                  onClick: (function () {
                                                      return ReasonReact.Router[/* push */0]("/week/" + (el + "/workoutweek"));
                                                    })
                                                }, "Workouts")));
                          }), /* array */[
                          /* tuple */[
                            "1",
                            "1"
                          ],
                          /* tuple */[
                            "2",
                            "8"
                          ],
                          /* tuple */[
                            "3",
                            "15"
                          ],
                          /* tuple */[
                            "4",
                            "21"
                          ]
                        ])), React.createElement("div", {
                      className: buttonBox
                    }, React.createElement("div", {
                          className: knowledgeWrapper
                        }, React.createElement("button", {
                              className: mediumGreenSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return ReasonReact.Router[/* push */0]("/foodday/" + String(self[/* state */2][/* fullDay */2]));
                                })
                            }, React.createElement("img", {
                                  className: pointsStarIcon,
                                  alt: "",
                                  src: Mahlzeit_cta_iconSvg
                                }), "Mahlzeiten")), React.createElement("div", {
                          className: knowledgeWrapper
                        }, React.createElement("button", {
                              className: mediumGreenSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return ReasonReact.Router[/* push */0]("/knowledge");
                                })
                            }, React.createElement("img", {
                                  className: pointsStarIcon,
                                  alt: "",
                                  src: Tipps_cta_iconSvg
                                }), "Tipps und Tricks", match$2 !== 0 ? React.createElement("div", {
                                    className: knowledgeInfo
                                  }, React.createElement("div", {
                                        className: knowledgeInfoContent
                                      }, "1")) : null)), React.createElement("div", {
                          className: knowledgeWrapper
                        }, React.createElement("button", {
                              className: mediumGreenSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return ReasonReact.Router[/* push */0]("/settings");
                                })
                            }, "Einstellungen"))));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* week */Storage.weekOfDay(/* () */0),
              /* day */Storage.weekDay(/* () */0),
              /* fullDay */Storage.fullDay(/* () */0),
              /* points */Network.calcPointsOverall(Network.pullPointsConfig(/* () */0)),
              /* pointsWeek : int array */[
                Network.calcPointsWeek(1),
                Network.calcPointsWeek(2),
                Network.calcPointsWeek(3),
                Network.calcPointsWeek(4)
              ],
              /* loading : false */0,
              /* knowledgeFresh */Caml_array.caml_array_get(Network.pullKnowledgeConfig(/* () */0), Storage.fullDayMax28(/* () */0)),
              /* isMounted */[/* true */1],
              /* show14 */Storage.show14(/* () */0),
              /* show24 */Storage.show24(/* () */0)
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* week */Storage.weekOfDay(/* () */0),
                          /* day */Storage.weekDay(/* () */0),
                          /* fullDay */Storage.fullDay(/* () */0),
                          /* points */Network.calcPointsOverall(Network.pullPointsConfig(/* () */0)),
                          /* pointsWeek : int array */[
                            Network.calcPointsWeek(1),
                            Network.calcPointsWeek(2),
                            Network.calcPointsWeek(3),
                            Network.calcPointsWeek(4)
                          ],
                          /* loading : false */0,
                          /* knowledgeFresh */Caml_array.caml_array_get(Network.pullKnowledgeConfig(/* () */0), Storage.fullDayMax28(/* () */0)),
                          /* isMounted */[/* true */1],
                          /* show14 */Storage.show14(/* () */0),
                          /* show24 */Storage.show24(/* () */0)
                        ],
                        (function () {
                            console.log("loaded");
                            return /* () */0;
                          })
                      ]);
          case 2 : 
              var newrecord = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord[/* loading */5] = /* true */1, newrecord),
                        (function () {
                            console.log("loading");
                            return /* () */0;
                          })
                      ]);
          case 3 : 
              return /* SideEffects */Block.__(2, [(function () {
                            Network.resetAll(/* () */0);
                            return ReasonReact.Router[/* push */0]("/wizard/1");
                          })]);
          
        }
      } else if (action.tag) {
        var answer = action[0];
        var newrecord$1 = state.slice();
        return /* UpdateWithSideEffects */Block.__(3, [
                  (newrecord$1[/* show24 */9] = /* false */0, newrecord$1),
                  (function () {
                      if (answer !== 0) {
                        console.log("switch type");
                        Network.updateWizardCalsResultToLS(1100);
                        return Storage.store24(/* () */0);
                      } else {
                        return Storage.store24(/* () */0);
                      }
                    })
                ]);
      } else {
        var answer$1 = action[0];
        var newrecord$2 = state.slice();
        return /* UpdateWithSideEffects */Block.__(3, [
                  (newrecord$2[/* show14 */8] = /* false */0, newrecord$2),
                  (function () {
                      if (answer$1 !== 0) {
                        console.log("switch type");
                        Network.updateWizardCalsResultToLS(1500);
                        return Storage.store14(/* () */0);
                      } else {
                        return Storage.store14(/* () */0);
                      }
                    })
                ]);
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/calendar_icon.d5595487.svg";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tipps_cta_icon.bf8cd544.svg";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/points_star_icon.a0cee909.svg";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mahlzeit_cta_icon.dc311df7.svg";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Seed = __webpack_require__(17);
var $$Array = __webpack_require__(12);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Network = __webpack_require__(7);
var Storage = __webpack_require__(14);
var Caml_obj = __webpack_require__(15);
var Caml_array = __webpack_require__(9);
var ReasonReact = __webpack_require__(2);
var Caml_primitive = __webpack_require__(20);
var X_iconSvg = __webpack_require__(140);
var Tipps_iconSvg = __webpack_require__(141);
var Dropdown_arrowSvg = __webpack_require__(142);
var Tipps_tricks_patternPng = __webpack_require__(143);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.textAlign(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.backgroundImage(/* `url */[
                      5843823,
                      Tipps_tricks_patternPng
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.textAlign(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.column),
            /* [] */0
          ]
        ]
      ]
    ]);

var knowledgeBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.boxSizing(Css.borderBox),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
                  /* :: */[
                    Css.margin4(Css.px(40), Css.px(0), Css.px(20), Css.px(0)),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutBoxInner = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.borderRadius(Css.px(10)),
              /* :: */[
                Css.boxShadow(/* Some */[Css.px(2)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(255, 191, 194, 0.29)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutBoxHeader = Css.style(/* :: */[
      Css.minHeight(Css.px(80)),
      /* :: */[
        Css.position(Css.relative),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.justifyContent(Css.center),
                /* :: */[
                  Css.background(/* `hex */[
                        5194459,
                        "FFFAFA"
                      ]),
                  /* :: */[
                    Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
                    /* :: */[
                      Css.padding2(Css.px(0), Css.px(0)),
                      /* :: */[
                        Css.width(/* `percent */[
                              -119887163,
                              100.0
                            ]),
                        /* :: */[
                          Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                          /* [] */0
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var tipps = Css.style(/* :: */[
      Css.top(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.transforms(/* :: */[
              /* `translate */[
                -914368690,
                /* tuple */[
                  Css.px(0),
                  /* `percent */[
                    -119887163,
                    -50.0
                  ]
                ]
              ],
              /* :: */[
                /* `scale */[
                  -120664438,
                  /* tuple */[
                    1.4,
                    1.4
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(Css.px(14)),
            /* [] */0
          ]
        ]
      ]
    ]);

var headHeader = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(52), Css.px(0), Css.px(52)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(5)),
        /* [] */0
      ]
    ]);

var subHeader = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.fontSize(Css.px(22)),
          /* [] */0
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(10)),
      /* :: */[
        Css.fontWeight(700),
        /* [] */0
      ]
    ]);

var entryHeader = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.justifyContent(/* spaceBetween */516682146),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.cursor(/* pointer */-786317123),
            /* :: */[
              Css.background(/* `hex */[
                    5194459,
                    "FFF"
                  ]),
              /* :: */[
                Css.padding4(Css.px(10), Css.px(10), Css.px(10), Css.px(10)),
                /* :: */[
                  Css.boxSizing(/* borderBox */9307263),
                  /* :: */[
                    Css.borderBottom(Css.px(1), /* solid */12956715, /* `hex */[
                          5194459,
                          "FCEBEC"
                        ]),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var entryHeaderWhite = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.justifyContent(/* spaceBetween */516682146),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.cursor(/* pointer */-786317123),
            /* :: */[
              Css.background(/* `hex */[
                    5194459,
                    "FFFAFA"
                  ]),
              /* :: */[
                Css.padding4(Css.px(10), Css.px(10), Css.px(10), Css.px(10)),
                /* :: */[
                  Css.boxSizing(/* borderBox */9307263),
                  /* :: */[
                    Css.borderBottom(Css.px(1), /* solid */12956715, /* `hex */[
                          5194459,
                          "FCEBEC"
                        ]),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.textAlign(/* left */-944764921),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* :: */[
            Css.margin2(Css.px(10), Css.px(0)),
            /* :: */[
              Css.color(/* `hex */[
                    5194459,
                    "FF328C"
                  ]),
              /* :: */[
                Css.fontWeight(700),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var someText = Css.style(/* :: */[
      Css.textAlign(/* center */98248149),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* :: */[
            Css.margin2(Css.px(10), Css.px(0)),
            /* :: */[
              Css.color(/* `hex */[
                    5194459,
                    "FF328C"
                  ]),
              /* :: */[
                Css.fontWeight(700),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

function settingButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(12.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(30), Css.px(8), Css.px(10), Css.px(8)),
                  /* :: */[
                    Css.maxWidth(Css.em(13.0)),
                    Theme.greenButtonRaw
                  ]
                ]
              ]
            ]);
}

var arrowIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var xIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var entryBox = Css.style(/* :: */[
      Css.padding2(Css.px(18), Css.px(10)),
      /* :: */[
        Css.background(Css.white),
        /* :: */[
          Css.borderBottom(Css.px(1), /* solid */12956715, /* `hex */[
                5194459,
                "FCEBEC"
              ]),
          /* :: */[
            Css.textAlign(/* left */-944764921),
            /* :: */[
              Css.whiteSpace(/* preLine */538440119),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* knowledgeBox */knowledgeBox,
  /* workoutBoxInner */workoutBoxInner,
  /* workoutBoxHeader */workoutBoxHeader,
  /* tipps */tipps,
  /* headHeader */headHeader,
  /* subHeader */subHeader,
  /* inputHeader */inputHeader,
  /* entryHeader */entryHeader,
  /* entryHeaderWhite */entryHeaderWhite,
  /* inputField */inputField,
  /* someLink */someLink,
  /* someText */someText,
  /* settingButton */settingButton,
  /* arrowIcon */arrowIcon,
  /* xIcon */xIcon,
  /* entryBox */entryBox
];

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("Knowledge");

function make() {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      Curry._1(self[/* send */4], /* MarkSeen */2);
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var newArr = $$Array.copy(Seed.knowledgeEntries);
      $$Array.sort((function (x, y) {
              return Caml_primitive.caml_int_compare(y[/* id */0], x[/* id */0]);
            }), newArr);
      var match = +(self[/* state */2][/* fullDay */0] === 0);
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: knowledgeBox
                    }, React.createElement("div", {
                          className: workoutBoxInner
                        }, React.createElement("div", {
                              className: workoutBoxHeader
                            }, React.createElement("img", {
                                  className: tipps,
                                  alt: "Tipps",
                                  src: Tipps_iconSvg
                                }), React.createElement("h1", {
                                  className: headHeader
                                }, "Tipps & Tricks")), $$Array.mapi((function (i, el) {
                                var match = +(i % 2 === 0);
                                var styleCheck = match !== 0 ? entryHeader : entryHeaderWhite;
                                var match$1 = +((28 - self[/* state */2][/* fullDay */0] | 0) <= i);
                                if (match$1 !== 0) {
                                  var match$2 = Caml_obj.caml_equal(/* Some */[i], self[/* state */2][/* openEntry */1]);
                                  return React.createElement("div", {
                                              key: String(i),
                                              className: flexList
                                            }, match$2 !== 0 ? React.createElement("div", {
                                                    className: flexList
                                                  }, React.createElement("div", {
                                                        className: styleCheck,
                                                        onClick: (function () {
                                                            return Curry._1(self[/* send */4], /* CloseEntry */1);
                                                          })
                                                      }, React.createElement("div", {
                                                            className: someLink
                                                          }, "Tag " + (String(el[/* id */0]) + (": " + el[/* title */1]))), React.createElement("img", {
                                                            className: xIcon,
                                                            alt: "x",
                                                            src: X_iconSvg
                                                          })), React.createElement("div", {
                                                        className: entryBox
                                                      }, React.createElement("span", {
                                                            dangerouslySetInnerHTML: {
                                                              __html: Caml_array.caml_array_get(Seed.knowledgeEntries, (28 - i | 0) - 1 | 0)[/* content */2]
                                                            }
                                                          }))) : React.createElement("div", {
                                                    className: styleCheck,
                                                    onClick: (function () {
                                                        return Curry._1(self[/* send */4], /* OpenEntry */[i]);
                                                      })
                                                  }, React.createElement("div", {
                                                        className: someLink
                                                      }, "Tag " + (String(el[/* id */0]) + (": " + el[/* title */1]))), React.createElement("img", {
                                                        className: arrowIcon,
                                                        alt: "arrow",
                                                        src: Dropdown_arrowSvg
                                                      })));
                                } else {
                                  return null;
                                }
                              }), newArr), match !== 0 ? React.createElement("div", {
                                className: someText
                              }, "Anzeige der Wissenseinheiten erfolgt nach Programmstart. Bitte absolviere dafür das erste Workout. Täglich wird dir hier ein neuer Praxistipp freigeschaltet!") : null), React.createElement("button", {
                          className: settingButton(/* () */0),
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/dashboard");
                            })
                        }, "Dashboard")));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* fullDay */Storage.fullDayMax28(/* () */0),
              /* openEntry : None */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* Update */Block.__(0, [/* record */[
                          /* fullDay */state[/* fullDay */0],
                          /* openEntry : None */0
                        ]]);
          case 2 : 
              return /* SideEffects */Block.__(2, [(function () {
                            return Network.storeKnowledgeRead(Storage.fullDayMax28(/* () */0));
                          })]);
          
        }
      } else {
        return /* Update */Block.__(0, [/* record */[
                    /* fullDay */state[/* fullDay */0],
                    /* openEntry : Some */[action[0]]
                  ]]);
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/x_icon.e094d34f.svg";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tipps_icon.66f080e4.svg";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dropdown_arrow.f4ce3591.svg";

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAABACAYAAABItWqnAAAACXBIWXMAAAsSAAALEgHS3X78AAAE70lEQVR4Ae1c0XHaQBBdMXzoRxN3YFKBlQpMByEVmFQQOrDcAakguAI7FQR3gDuADgx8wBfKrPKWWZ8PYZvc3kTKm2EAnQS657d7e7uLk91qkxNRQUQzIrpPspSfW4lyvT0jogER9Yioz+T0ieiXYuOBiEZtI6lcb1kgIyL6IMeSsix5gNXDjyERXWLsa5Klk3i3awOo5V7N+5aIJpUlVeSox261Ge5Wm6fdalPuVpuBO960x261ucdcZ7vVpqfnVynHRbnest3dEdGS7S/J0qeGqoYt5QcRPVY+xplnx3dRkqUss1vY38Dsbu0xwjeOfALwkgOM8dxIcuBrLlg1SZZOfed0nAtyXMTqkdXqzOJmIyDHV+6J0fMnTU653k7htYuGklELkMIczMv1lsMb6vBBrPE5BjkA4pN7+LBGOmMEvaQUJPNlgUyYoA4OsmOaY3CIZ/E1Xnv81wEHvOD4hgUCNzIEH2eVz8Vaz2t834l35lj/ew2OcQrMsXCOT5kP8TkXSmYSSp/zcp5k6byJygHGiOVGyo0QuNiTIzITx8Rmtmy6c8acx4jn9FwrLnxxjmy+xg1XTYUkSwv4nitHPV5yhlDN2DPWVBRq7n5ywNw58jpNXcJ9uMexvh7ripTghEVWrcrlsBDK9fYRy3ohJHUVIdfq/DZmA8VS9jx0EfzdOCc23hF7MHEDXlHOtXNutceIeacRwNuIb/pru5DTg3MvbVTOzOXBt5TP2xDfePDCz/rIaWXKAhvPZwWFDnagOcyraKlqKqDaMgUnl94E+3/8QV0OufXoxiYAKck+Qgodoc+xjYlm5lHMSqVFnpVfD+ABvtA8I2lODgqGEw8pSyhGSiYumKSB5YbYlBxVYRQskBp5YT4gkR9X6vASlUmTvZ8ZOR5ibpBoOnZdD0qTQj8TlFv4IhNy4HSlzWUJ83iTDynX24lSEVcp8yOXnAyrpVxHnsP3ONckS1l5P/H2AnmXoAhODszpHG+/o0nhvZAULqkmgGCwUI5uRDjpr42VSj7jA5x2MFiQ8xnPP//SMqxNtF9z3skISo6nUHYyQPAjPieoUw6tHE3OMyfMvog7O9ix6rYPNT7AuM9HmQSCocnRk3D/ygWi4Ws3j4Kl/05aXkP7lkMISo4Tye5VhMmew1lze91ndLQKCgn2sAEdOh8tAWHQQNBiV74AEdp5iqJmaoJjNFARJr+EKbpNDprEoNsIi9VKJnwhDhpB4BeMSZ9MDgJFJTOM3TgxzdDz2WFg0APTRw8MP8Z1fTLq9dOB885Uj/Q89L0HVw5UspC/utvJAGjzyGvMRed/gjc6WO2t9lHtgShZeoPyQ92rKkFG8EfBf3pgQg6y+lIwu5JuTQ+EGJ8vGSvVFBZJL8sEu3aqrnpqJwpT1OkKk94hM3IQ89zi7aVWzysye5rM4LtxgXVpZnTg9UE4qrm1TLSbkgM/IeqR3bq7QXWhtw6n5ILejBhFPf1bAzGtOnK0+bWHnJp8TM/z2m2TCY5YRb33fCmnWM2cMUWslS9ecY4L8+7WWLXywTt+x2VeM49lVlOVk3ktXlUE/Jv434JSg1jKObjBrMHMuqs+ps9x23uP4aO1U45FzuSNNadZjCamaD2BqqPrKKwdsSBm29sMu+1jq9ZXo/t5gWirFTvXJEtZOTx5qWAKONPHG9RP0f7ZCBH9BmuQYqfriq1bAAAAAElFTkSuQmCC"

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Link = __webpack_require__(13);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Fetch = __webpack_require__(25);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Network = __webpack_require__(7);
var Json_encode = __webpack_require__(23);
var ReasonReact = __webpack_require__(2);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var resetExec = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.fontWeight(700),
        /* [] */0
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(0), Css.px(8), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* resetExec */resetExec,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink
];

function text(prim) {
  return prim;
}

function validatePassword(value) {
  var match = +(value.length > 5);
  if (match !== 0) {
    return /* PassValid */0;
  } else {
    return /* PassNotValid */["Password zu kurz"];
  }
}

function showApiError(data, self, message) {
  return Promise.resolve(data).then((function () {
                  console.log("Login error!");
                  Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, [message]));
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("API error exception", err), /* () */0));
              }));
}

var component = ReasonReact.reducerComponent("ResetExec");

function make(resetCode, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      var send = param[/* send */4];
      var state = param[/* state */2];
      var match = state[/* error */2];
      var match$1 = state[/* success */3];
      var match$2 = state[/* loading */4];
      return React.createElement("div", {
                  className: resetExec
                }, React.createElement("h1", undefined, "Passwort Reset"), React.createElement("p", undefined, "Bitte gebe zum Reset deines Passworts deine Email Adresse ein. Wir senden dir einen Reset Link zu."), React.createElement("p", {
                      className: inputHeader
                    }, "Token"), React.createElement("input", {
                      className: inputField,
                      placeholder: "Token",
                      type: "text",
                      value: state[/* token */1],
                      onChange: (function ($$event) {
                          return Curry._1(send, /* ChangeToken */Block.__(0, [$$event.target.value]));
                        })
                    }), React.createElement("p", {
                      className: inputHeader
                    }, "Passwort"), React.createElement("input", {
                      className: inputField,
                      autoFocus: true,
                      placeholder: "Passwort",
                      type: "password",
                      value: state[/* password */0],
                      onKeyDown: (function ($$event) {
                          if ($$event.keyCode === 13) {
                            $$event.preventDefault();
                            return Curry._1(send, /* ResetExecEnterKeyDown */1);
                          } else {
                            return Curry._1(send, /* ResetExecOtherKeyDown */0);
                          }
                        }),
                      onChange: (function ($$event) {
                          return Curry._1(send, /* ChangePassword */Block.__(1, [$$event.target.value]));
                        })
                    }), match ? React.createElement("div", {
                        className: "failure"
                      }, match[0]) : null, match$1 ? React.createElement("div", {
                        className: "success"
                      }, match$1[0]) : null, React.createElement("button", {
                      className: "login-button",
                      onClick: (function () {
                          return Curry._1(send, /* ResetExec */2);
                        })
                    }, match$2 !== 0 ? React.createElement("div", {
                            className: "button-spinner"
                          }) : "Absenden"), ReasonReact.element(/* None */0, /* None */0, Link.make("/login", "zum Login", someLink, /* array */[])));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* password */"",
              /* token */resetCode,
              /* error : None */0,
              /* success : None */0,
              /* loading : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* SideEffects */Block.__(2, [(function (self) {
                            return Curry._1(self[/* send */4], /* ResetExec */2);
                          })]);
          case 2 : 
              var passwordValid = validatePassword(state[/* password */0]);
              if (passwordValid) {
                var error = passwordValid[0];
                return /* SideEffects */Block.__(2, [(function (self) {
                              return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, [error]));
                            })]);
              } else {
                return /* UpdateWithSideEffects */Block.__(3, [
                          /* record */[
                            /* password */state[/* password */0],
                            /* token */state[/* token */1],
                            /* error */state[/* error */2],
                            /* success */state[/* success */3],
                            /* loading : true */1
                          ],
                          (function (self) {
                              var requestPayload = Json_encode.object_(/* :: */[
                                    /* tuple */[
                                      "password",
                                      self[/* state */2][/* password */0]
                                    ],
                                    /* :: */[
                                      /* tuple */[
                                        "password_reset_token",
                                        self[/* state */2][/* token */1]
                                      ],
                                      /* [] */0
                                    ]
                                  ]);
                              fetch(Network.resetExecUrl, Fetch.RequestInit[/* make */0](/* Some */[/* Put */3], /* Some */[{
                                                "Content-Type": "application/json",
                                                Accept: "application.json"
                                              }], /* Some */[JSON.stringify(requestPayload)], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0)).then((function (data) {
                                        var statusCode = data.status;
                                        console.log("https status: ", statusCode);
                                        if (statusCode !== 200) {
                                          if (statusCode !== 404) {
                                            return showApiError(data, self, "Http Fehler: " + String(statusCode));
                                          } else {
                                            return showApiError(data, self, "Token nicht gültig");
                                          }
                                        } else {
                                          console.log("ResetExec executed");
                                          Curry._1(self[/* send */4], /* ShowSuccessMessage */Block.__(3, ["Dein Password wurde erfolgreich zurückgesetzt"]));
                                          return Promise.resolve(/* () */0);
                                        }
                                      })).catch((function (err) {
                                      return Promise.resolve((console.log("Api error", err), Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, ["Netzwerkfehler"]))));
                                    }));
                              return /* () */0;
                            })
                        ]);
              }
          case 3 : 
              return /* Update */Block.__(0, [/* record */[
                          /* password */state[/* password */0],
                          /* token */state[/* token */1],
                          /* error : None */0,
                          /* success */state[/* success */3],
                          /* loading */state[/* loading */4]
                        ]]);
          
        }
      } else {
        switch (action.tag | 0) {
          case 0 : 
              return /* Update */Block.__(0, [/* record */[
                          /* password */state[/* password */0],
                          /* token */action[0],
                          /* error */state[/* error */2],
                          /* success */state[/* success */3],
                          /* loading */state[/* loading */4]
                        ]]);
          case 1 : 
              return /* Update */Block.__(0, [/* record */[
                          /* password */action[0],
                          /* token */state[/* token */1],
                          /* error */state[/* error */2],
                          /* success */state[/* success */3],
                          /* loading */state[/* loading */4]
                        ]]);
          case 2 : 
              var text = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* password */state[/* password */0],
                          /* token */state[/* token */1],
                          /* error : Some */[text],
                          /* success */state[/* success */3],
                          /* loading : false */0
                        ],
                        (function (self) {
                            console.log("ShowErrorMessage Reducer:", text);
                            setTimeout((function () {
                                    return Curry._1(self[/* send */4], /* ClearError */3);
                                  }), 2500);
                            return /* () */0;
                          })
                      ]);
          case 3 : 
              var text$1 = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* password */state[/* password */0],
                          /* token */state[/* token */1],
                          /* error */state[/* error */2],
                          /* success : Some */[text$1],
                          /* loading : false */0
                        ],
                        (function () {
                            console.log("ShowSuccessMessage Reducer:", text$1);
                            setTimeout((function () {
                                    return ReasonReact.Router[/* push */0]("/");
                                  }), 3000);
                            return /* () */0;
                          })
                      ]);
          
        }
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.validatePassword = validatePassword;
exports.showApiError = showApiError;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Curry = __webpack_require__(0);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var ReasonReact = __webpack_require__(2);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var modal = Css.style(/* :: */[
      Css.position(/* fixed */10615156),
      /* :: */[
        Css.zIndex(3),
        /* :: */[
          Css.left(Css.px(0)),
          /* :: */[
            Css.top(Css.px(0)),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.height(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.overflow(/* auto */-1065951377),
                  /* :: */[
                    Css.backgroundColor(Css.rgb(68, 68, 68)),
                    /* :: */[
                      Css.opacity(50.0),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.zIndex(4),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.background(Css.white),
                /* :: */[
                  Css.marginTop(Css.px(100)),
                  /* :: */[
                    Css.marginLeft(/* auto */-1065951377),
                    /* :: */[
                      Css.marginRight(/* auto */-1065951377),
                      /* :: */[
                        Css.width(/* `percent */[
                              -119887163,
                              80.0
                            ]),
                        /* :: */[
                          Css.maxWidth(Css.px(360)),
                          /* :: */[
                            Css.minWidth(Css.px(260)),
                            /* :: */[
                              Css.maxHeight(Css.px(160)),
                              /* :: */[
                                Css.borderRadius(Css.px(10)),
                                /* [] */0
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var headerBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.background(/* `hex */[
              5194459,
              "FFFAFA"
            ]),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.flexDirection(Css.column),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                  /* :: */[
                    Css.flexShrink(0),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var selectHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(24)),
      /* :: */[
        Css.color(/* `hex */[
              5194459,
              "FF328C"
            ]),
        /* :: */[
          Css.lineHeight(1.1),
          /* :: */[
            Css.fontWeight(700),
            /* :: */[
              Css.textTransform(Css.uppercase),
              /* :: */[
                Css.margin4(Css.px(10), Css.px(0), Css.px(0), Css.px(0)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var selectHeader2 = Css.style(/* :: */[
      Css.fontSize(Css.px(16)),
      /* :: */[
        Css.color(/* `hex */[
              5194459,
              "FF328C"
            ]),
        /* :: */[
          Css.margin4(Css.px(2), Css.px(0), Css.px(4), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.top(Css.px(0)),
            /* :: */[
              Css.left(Css.px(0)),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.height(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.overflow(/* auto */-1065951377),
                    /* :: */[
                      Css.justifyContent(/* spaceAround */-485895757),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var spanEl = Css.style(/* :: */[
      Css.marginLeft(Css.px(6)),
      /* :: */[
        Css.fontWeight(400),
        /* [] */0
      ]
    ]);

var entry = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.fontSize(Css.px(18)),
          /* :: */[
            Css.background(/* `hex */[
                  5194459,
                  "FFFAFA"
                ]),
            /* :: */[
              Css.fontWeight(400),
              /* :: */[
                Css.flexDirection(Css.row),
                /* :: */[
                  Css.alignItems(Css.center),
                  /* :: */[
                    Css.justifyContent(/* spaceAround */-485895757),
                    /* :: */[
                      Css.width(/* `percent */[
                            -119887163,
                            100.0
                          ]),
                      /* :: */[
                        Css.flexShrink(0),
                        /* [] */0
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var entryText = Css.style(/* :: */[
      Css.textAlign(/* left */-944764921),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(14)),
        /* :: */[
          Css.color(Css.hex("3D2D34")),
          /* [] */0
        ]
      ]
    ]);

function smallerRedSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(100)),
              /* :: */[
                Css.maxWidth(Css.px(140)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.height(Css.px(35)),
                    /* :: */[
                      Css.color(/* `hex */[
                            5194459,
                            "FF328C"
                          ]),
                      /* :: */[
                        Css.margin4(Css.px(10), Css.px(8), Css.px(10), Css.px(8)),
                        /* :: */[
                          Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                5194459,
                                "FF328C"
                              ]),
                          Theme.redButtonNarrowRaw
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var Styles = /* module */[
  /* dashboard */dashboard,
  /* modal */modal,
  /* flexList */flexList,
  /* headerBox */headerBox,
  /* selectHeader */selectHeader,
  /* selectHeader2 */selectHeader2,
  /* contentBox */contentBox,
  /* spanEl */spanEl,
  /* entry */entry,
  /* entryText */entryText,
  /* smallerRedSecondaryButton */smallerRedSecondaryButton
];

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("Modal");

function make(onClose, onSelect, _) {
  var handleCloseClick = function (_, _$1) {
    return Curry._1(onClose, /* () */0);
  };
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      return React.createElement("div", {
                  className: modal,
                  onClick: Curry._1(self[/* handle */0], handleCloseClick)
                }, React.createElement("div", {
                      className: flexList,
                      onClick: (function ($$event) {
                          $$event.stopPropagation();
                          return /* () */0;
                        })
                    }, React.createElement("div", {
                          className: headerBox
                        }, React.createElement("div", {
                              className: selectHeader
                            }, "Logout"), React.createElement("div", {
                              className: selectHeader2
                            }, "Möchtest du dich wirklich ausloggen?")), React.createElement("div", {
                          className: contentBox
                        }, React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(onClose, /* () */0);
                                })
                            }, "Nein"), React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: Curry._1(self[/* handle */0], (function (_, _$1) {
                                      return Curry._1(onSelect, "dd");
                                    }))
                            }, "Ja"))));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* dashboard Not a pure module */


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Seed = __webpack_require__(17);
var $$Array = __webpack_require__(12);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Js_exn = __webpack_require__(10);
var Network = __webpack_require__(7);
var Caml_array = __webpack_require__(9);
var Caml_int32 = __webpack_require__(11);
var Caml_format = __webpack_require__(8);
var ReasonReact = __webpack_require__(2);
var Plan_iconSvg = __webpack_require__(62);
var Round_iconSvg = __webpack_require__(61);
var Caml_builtin_exceptions = __webpack_require__(3);

var flexList = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.alignItems(Css.center),
          /* [] */0
        ]
      ]
    ]);

var headBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.background(Css.hex("fffafa")),
              /* :: */[
                Css.marginBottom(Css.px(10)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.boxSizing(/* borderBox */9307263),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var infoHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.margin4(Css.px(18), Css.px(0), Css.px(6), Css.px(0)),
        /* [] */0
      ]
    ]);

var infoHeaderH1 = Css.style(/* :: */[
      Css.margin4(Css.px(18), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.zIndex(2),
        /* [] */0
      ]
    ]);

var infoHeaderH4 = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(6), Css.px(0)),
        /* :: */[
          Css.zIndex(2),
          /* [] */0
        ]
      ]
    ]);

var mapElement = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.alignItems(Css.center),
          /* [] */0
        ]
      ]
    ]);

var workoutContainer = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
            /* :: */[
              Css.borderTopLeftRadius(Css.px(10)),
              /* :: */[
                Css.borderTopRightRadius(Css.px(10)),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 44, 123, 0.25)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutHeaderBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.row),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.justifyContent(Css.center),
            /* :: */[
              Css.background(Css.hex("FFFAFA")),
              /* :: */[
                Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.borderTopLeftRadius(Css.px(10)),
                    /* :: */[
                      Css.borderTopRightRadius(Css.px(10)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutHeaderMiddleEl = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* [] */0
      ]
    ]);

var workoutNameHeader = Css.style(/* :: */[
      Css.lineHeight(1.2),
      /* :: */[
        Css.margin4(Css.px(5), Css.px(48), Css.px(0), Css.px(48)),
        /* [] */0
      ]
    ]);

var pairBox = Css.style(/* :: */[
      Css.fontSize(Css.px(12)),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(8), Css.px(2), Css.px(8)),
        /* [] */0
      ]
    ]);

var spanEl = Css.style(/* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(10)),
        /* [] */0
      ]
    ]);

var tableHead = Css.style(/* :: */[
      Css.fontSize(Css.px(20)),
      /* :: */[
        Css.fontWeight(700),
        /* :: */[
          Css.paddingBottom(Css.px(10)),
          /* :: */[
            Css.paddingTop(Css.px(10)),
            /* [] */0
          ]
        ]
      ]
    ]);

var initialBody = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var initialBodyImg = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(10), Css.px(15), Css.px(10)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* [] */0
        ]
      ]
    ]);

var tableDiv = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var horizonBox = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
          /* :: */[
            Css.justifyContent(Css.spaceAround),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.background(Css.hex("00")),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.padding2(Css.px(0), Css.px(0)),
                      /* :: */[
                        Css.height(Css.px(45)),
                        /* :: */[
                          Css.borderBottom(Css.px(1), /* solid */12956715, /* `hex */[
                                5194459,
                                "FCEBEC"
                              ]),
                          /* [] */0
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBoxEl = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.flexGrow(1),
        /* :: */[
          Css.background(Css.lightgreen),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(10), Css.px(0), Css.px(10)),
            /* :: */[
              Css.fontSize(Css.px(24)),
              /* :: */[
                Css.minHeight(Css.px(40)),
                /* :: */[
                  Css.borderLeft(Css.px(1), /* solid */12956715, /* `hex */[
                        5194459,
                        "FCEBEC"
                      ]),
                  /* :: */[
                    Css.justifyContent(Css.center),
                    /* :: */[
                      Css.alignItems(Css.center),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.marginTop(Css.px(5)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

var firstCol = Css.style(/* :: */[
      Css.justifyContent(Css.center),
      /* :: */[
        Css.fontWeight(700),
        /* :: */[
          Css.textAlign(/* center */98248149),
          /* :: */[
            Css.width(/* `percent */[
                  -119887163,
                  20.0
                ]),
            /* :: */[
              Css.color(/* `hex */[
                    5194459,
                    "FFBFC2"
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var otherCols = Css.style(/* :: */[
      Css.alignItems(Css.center),
      /* :: */[
        Css.justifyContent(Css.center),
        /* :: */[
          Css.marginBottom(Css.px(0)),
          /* :: */[
            Css.borderLeft(Css.px(1), /* solid */12956715, /* `hex */[
                  5194459,
                  "FCEBEC"
                ]),
            /* :: */[
              Css.textAlign(/* center */98248149),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      20.0
                    ]),
                /* :: */[
                  Css.color(/* `hex */[
                        5194459,
                        "80D0D0"
                      ]),
                  /* :: */[
                    Css.fontWeight(700),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var otherColsUp = Css.style(/* :: */[
      Css.alignItems(Css.center),
      /* :: */[
        Css.justifyContent(Css.center),
        /* :: */[
          Css.marginBottom(Css.px(0)),
          /* :: */[
            Css.borderLeft(Css.px(1), /* solid */12956715, /* `hex */[
                  5194459,
                  "FCEBEC"
                ]),
            /* :: */[
              Css.textAlign(/* center */98248149),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      20.0
                    ]),
                /* :: */[
                  Css.color(/* `hex */[
                        5194459,
                        "FFBFC2"
                      ]),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var planIconBox = Css.style(/* :: */[
      Css.top(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.transform(/* `translate */[
              -914368690,
              /* tuple */[
                Css.px(0),
                /* `percent */[
                  -119887163,
                  -50.0
                ]
              ]
            ]),
        /* :: */[
          Css.transform(/* `scale */[
                -120664438,
                /* tuple */[
                  1.2,
                  1.2
                ]
              ]),
          /* :: */[
            Css.position(/* absolute */-1013592457),
            /* :: */[
              Css.left(Css.px(0)),
              /* :: */[
                Css.top(Css.px(8)),
                /* :: */[
                  Css.cursor(/* pointer */-786317123),
                  /* :: */[
                    Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var planIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var roundIcon = Css.style(/* :: */[
      Css.marginBottom(Css.px(6)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                0.5,
                0.5
              ]
            ]),
        /* [] */0
      ]
    ]);

var Styles = /* module */[
  /* flexList */flexList,
  /* headBox */headBox,
  /* contentBox */contentBox,
  /* infoHeader */infoHeader,
  /* infoHeaderH1 */infoHeaderH1,
  /* infoHeaderH4 */infoHeaderH4,
  /* mapElement */mapElement,
  /* workoutContainer */workoutContainer,
  /* workoutHeaderBox */workoutHeaderBox,
  /* workoutHeaderMiddleEl */workoutHeaderMiddleEl,
  /* workoutNameHeader */workoutNameHeader,
  /* pairBox */pairBox,
  /* spanEl */spanEl,
  /* tableHead */tableHead,
  /* initialBody */initialBody,
  /* initialBodyImg */initialBodyImg,
  /* tableDiv */tableDiv,
  /* horizonBox */horizonBox,
  /* horizonBoxEl */horizonBoxEl,
  /* inputHeader */inputHeader,
  /* firstCol */firstCol,
  /* otherCols */otherCols,
  /* otherColsUp */otherColsUp,
  /* inputField */inputField,
  /* someLink */someLink,
  /* planIconBox */planIconBox,
  /* planIcon */planIcon,
  /* roundIcon */roundIcon
];

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      console.log("Issue with int conversion in workout configuration component");
      return 2;
    } else {
      throw exn;
    }
  }
}

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("WorkoutView");

function make(week, workout, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      var currentWorkoutExercises = Seed.getWorkoutTitles(week, workout);
      var reps = Network.pullRepsConfig(/* () */0);
      var workoutId = ((Caml_int32.imul(Caml_format.caml_int_of_string(week), 6) - 6 | 0) + Caml_format.caml_int_of_string(workout) | 0) - 1 | 0;
      return React.createElement("div", {
                  className: flexList
                }, React.createElement("div", {
                      className: headBox
                    }, React.createElement("div", {
                          className: planIconBox
                        }, React.createElement("img", {
                              className: planIcon,
                              alt: "",
                              src: Plan_iconSvg
                            })), React.createElement("h1", {
                          className: infoHeaderH1
                        }, "Workout " + workout), React.createElement("h4", {
                          className: infoHeaderH4
                        }, "Woche " + (String(week) + ""))), React.createElement("div", {
                      className: contentBox
                    }, $$Array.mapi((function (index, _) {
                            return React.createElement("div", {
                                        key: String(index),
                                        className: mapElement
                                      }, React.createElement("div", {
                                            className: workoutContainer
                                          }, React.createElement("div", {
                                                className: workoutHeaderBox
                                              }, React.createElement("div", {
                                                    className: workoutHeaderMiddleEl
                                                  }, React.createElement("h4", {
                                                        className: workoutNameHeader
                                                      }, Caml_array.caml_array_get(currentWorkoutExercises, index)), React.createElement("div", {
                                                        className: pairBox
                                                      }, "Übungspaar ", Caml_array.caml_array_get(/* array */[
                                                            "1",
                                                            "1",
                                                            "2",
                                                            "2",
                                                            "3",
                                                            "3"
                                                          ], index) + "/3"))), React.createElement("div", {
                                                className: horizonBox
                                              }, React.createElement("div", {
                                                    className: firstCol
                                                  }, "Runde"), React.createElement("div", {
                                                    className: otherColsUp
                                                  }, React.createElement("img", {
                                                        className: roundIcon,
                                                        alt: "",
                                                        src: Round_iconSvg
                                                      }), "1"), React.createElement("div", {
                                                    className: otherColsUp
                                                  }, React.createElement("img", {
                                                        className: roundIcon,
                                                        alt: "",
                                                        src: Round_iconSvg
                                                      }), "2"), React.createElement("div", {
                                                    className: otherColsUp
                                                  }, React.createElement("img", {
                                                        className: roundIcon,
                                                        alt: "",
                                                        src: Round_iconSvg
                                                      }), "3"), React.createElement("div", {
                                                    className: otherColsUp
                                                  }, React.createElement("img", {
                                                        className: roundIcon,
                                                        alt: "",
                                                        src: Round_iconSvg
                                                      }), "4")), React.createElement("div", {
                                                className: horizonBox
                                              }, React.createElement("div", {
                                                    className: firstCol
                                                  }, "Wdh"), React.createElement("div", {
                                                    className: otherCols
                                                  }, String(Caml_array.caml_array_get(Caml_array.caml_array_get(Caml_array.caml_array_get(reps, workoutId), 0), index))), React.createElement("div", {
                                                    className: otherCols
                                                  }, String(Caml_array.caml_array_get(Caml_array.caml_array_get(Caml_array.caml_array_get(reps, workoutId), 1), index))), React.createElement("div", {
                                                    className: otherCols
                                                  }, String(Caml_array.caml_array_get(Caml_array.caml_array_get(Caml_array.caml_array_get(reps, workoutId), 2), index))), React.createElement("div", {
                                                    className: otherCols
                                                  }, String(Caml_array.caml_array_get(Caml_array.caml_array_get(Caml_array.caml_array_get(reps, workoutId), 3), index))))));
                          }), /* array */[
                          1,
                          1,
                          1,
                          1,
                          1,
                          1
                        ])), React.createElement("button", {
                      className: Theme.simpleButtonReset(/* () */0),
                      onClick: (function () {
                          console.log("resetting: ", workoutId);
                          Network.resetSingleCompletedWorkout(workoutId);
                          Network.resetSinglePoints(workoutId);
                          Network.resetSingleReps(workoutId);
                          return ReasonReact.Router[/* push */0]("/week/" + (week + "/workoutweek/"));
                        })
                    }, "Reset"), React.createElement("button", {
                      className: Theme.simpleButtonWhiteSpaceBelow(/* () */0),
                      onClick: (function () {
                          return ReasonReact.Router[/* push */0]("/week/" + (week + "/workoutweek/"));
                        })
                    }, "Zurück"));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.convToInt = convToInt;
exports.text = text;
exports.component = component;
exports.make = make;
/* flexList Not a pure module */


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Link = __webpack_require__(13);
var $$Array = __webpack_require__(12);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Network = __webpack_require__(7);
var Storage = __webpack_require__(14);
var Caml_array = __webpack_require__(9);
var Caml_int32 = __webpack_require__(11);
var Caml_format = __webpack_require__(8);
var ReasonReact = __webpack_require__(2);
var Plan_iconSvg = __webpack_require__(62);
var Checkbox_iconSvg = __webpack_require__(148);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var headBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.background(Css.hex("fffafa")),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.boxSizing(/* borderBox */9307263),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var contentContainer = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.margin4(Css.px(14), Css.px(0), Css.px(10), Css.px(0)),
            /* :: */[
              Css.borderTopLeftRadius(Css.px(10)),
              /* :: */[
                Css.borderTopRightRadius(Css.px(10)),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 44, 123, 0.25)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var contentHeaderBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.row),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.justifyContent(Css.center),
            /* :: */[
              Css.background(Css.hex("FFFAFA")),
              /* :: */[
                Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.borderTopLeftRadius(Css.px(10)),
                    /* :: */[
                      Css.borderTopRightRadius(Css.px(10)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var contentHeaderMiddleEl = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* [] */0
      ]
    ]);

var infoHeaderH1 = Css.style(/* :: */[
      Css.lineHeight(1.1),
      /* :: */[
        Css.fontSize(Css.px(28)),
        /* :: */[
          Css.margin4(Css.px(18), Css.px(0), Css.px(0), Css.px(0)),
          /* :: */[
            Css.zIndex(2),
            /* [] */0
          ]
        ]
      ]
    ]);

var infoHeaderH3 = Css.style(/* :: */[
      Css.fontWeight(400),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(6), Css.px(0)),
          /* :: */[
            Css.zIndex(2),
            /* [] */0
          ]
        ]
      ]
    ]);

var planIconBox = Css.style(/* :: */[
      Css.top(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.transform(/* `translate */[
              -914368690,
              /* tuple */[
                Css.px(0),
                /* `percent */[
                  -119887163,
                  -50.0
                ]
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(Css.px(14)),
            /* :: */[
              Css.top(Css.px(8)),
              /* :: */[
                Css.cursor(/* pointer */-786317123),
                /* :: */[
                  Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var planIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(6)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.3,
                1.3
              ]
            ]),
        /* [] */0
      ]
    ]);

var checkboxIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(6)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.4,
                1.4
              ]
            ]),
        /* [] */0
      ]
    ]);

function horizonBox(el) {
  var match = +(el % 2 === 0);
  return Css.style(/* :: */[
              Css.textAlign(Css.center),
              /* :: */[
                Css.display(Css.flexBox),
                /* :: */[
                  match !== 0 ? Css.background(/* `hex */[
                          5194459,
                          "FFFAFA"
                        ]) : Css.background(Css.white),
                  /* :: */[
                    Css.flexDirection(Css.row),
                    /* :: */[
                      Css.alignItems(Css.center),
                      /* :: */[
                        Css.justifyContent(/* spaceBetween */516682146),
                        /* :: */[
                          Css.width(/* `percent */[
                                -119887163,
                                100.0
                              ]),
                          /* :: */[
                            Css.borderBottomLeftRadius(Css.px(10)),
                            /* :: */[
                              Css.borderBottomRightRadius(Css.px(10)),
                              /* [] */0
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var horizonBoxLinks = Css.style(/* :: */[
      Css.marginTop(Css.px(20)),
      /* :: */[
        Css.textAlign(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.row),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.justifyContent(/* spaceAround */-485895757),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.flexWrap(/* wrap */-822134326),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutName = Css.style(/* :: */[
      Css.marginLeft(Css.px(10)),
      /* :: */[
        Css.marginRight(Css.px(4)),
        /* :: */[
          Css.textAlign(/* left */-944764921),
          /* :: */[
            Css.media("(min-width: 420px)", /* :: */[
                  Css.marginLeft(Css.px(30)),
                  /* [] */0
                ]),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.fontWeight(700),
        /* [] */0
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var doubleButton = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.marginRight(Css.px(10)),
        /* [] */0
      ]
    ]);

function smallerGreenSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(104)),
              /* :: */[
                Css.maxWidth(Css.px(120)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.color(/* `hex */[
                          5194459,
                          "00C9C8"
                        ]),
                    /* :: */[
                      Css.height(Css.px(30)),
                      /* :: */[
                        Css.margin4(Css.px(2), Css.px(8), Css.px(6), Css.px(0)),
                        /* :: */[
                          Css.media("(min-width: 420px)", /* :: */[
                                Css.margin4(Css.px(2), Css.px(28), Css.px(2), Css.px(0)),
                                /* [] */0
                              ]),
                          /* :: */[
                            Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                  5194459,
                                  "00C9C8"
                                ]),
                            Theme.greenSecondaryButtonRaw
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function smallerGreenSecondaryButtonReset() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(104)),
              /* :: */[
                Css.maxWidth(Css.px(120)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.color(/* `hex */[
                          5194459,
                          "00C9C8"
                        ]),
                    /* :: */[
                      Css.height(Css.px(30)),
                      /* :: */[
                        Css.margin4(Css.px(6), Css.px(8), Css.px(6), Css.px(0)),
                        /* :: */[
                          Css.media("(min-width: 420px)", /* :: */[
                                Css.margin4(Css.px(2), Css.px(8), Css.px(2), Css.px(0)),
                                /* [] */0
                              ]),
                          /* :: */[
                            Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                  5194459,
                                  "00C9C8"
                                ]),
                            Theme.greenSecondaryButtonRaw
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function smallerRedSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(90)),
              /* :: */[
                Css.maxWidth(Css.px(120)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.height(Css.px(30)),
                    /* :: */[
                      Css.color(/* `hex */[
                            5194459,
                            "FF328C"
                          ]),
                      /* :: */[
                        Css.margin4(Css.px(2), Css.px(8), Css.px(2), Css.px(0)),
                        /* :: */[
                          Css.media("(min-width: 420px)", /* :: */[
                                Css.margin4(Css.px(2), Css.px(28), Css.px(2), Css.px(0)),
                                /* [] */0
                              ]),
                          /* :: */[
                            Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                  5194459,
                                  "FF328C"
                                ]),
                            Theme.redButtonNarrowRaw
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function mediumGreenSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(140)),
              /* :: */[
                Css.maxWidth(Css.px(170)),
                /* :: */[
                  Css.flexGrow(1),
                  /* :: */[
                    Css.color(/* `hex */[
                          5194459,
                          "00C9C8"
                        ]),
                    /* :: */[
                      Css.height(Css.px(40)),
                      /* :: */[
                        Css.margin4(Css.px(8), Css.px(8), Css.px(8), Css.px(8)),
                        /* :: */[
                          Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                5194459,
                                "00C9C8"
                              ]),
                          Theme.greenSecondaryButtonRaw
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function mediumGreenSecondaryButtonLight() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(140)),
              /* :: */[
                Css.maxWidth(Css.px(170)),
                /* :: */[
                  Css.flexGrow(1),
                  /* :: */[
                    Css.color(/* `hex */[
                          5194459,
                          "FABCD2"
                        ]),
                    /* :: */[
                      Css.height(Css.px(40)),
                      /* :: */[
                        Css.margin4(Css.px(8), Css.px(8), Css.px(8), Css.px(8)),
                        /* :: */[
                          Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                5194459,
                                "FABCD2"
                              ]),
                          /* :: */[
                            Css.selector("&:hover", /* :: */[
                                  Css.background(/* `hex */[
                                        5194459,
                                        "FFF"
                                      ]),
                                  /* [] */0
                                ]),
                            /* :: */[
                              Css.cursor(/* default */465819841),
                              Theme.greenSecondaryButtonRaw
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function slimButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(8.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.minHeight(Css.em(2.0)),
                  /* :: */[
                    Css.backgroundColor(Css.white),
                    /* :: */[
                      Css.color(Css.hex("fa3468")),
                      Theme.greenButtonRaw
                    ]
                  ]
                ]
              ]
            ]);
}

function slimButtonBlue() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(8.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.minHeight(Css.em(2.0)),
                  /* :: */[
                    Css.backgroundColor(Css.white),
                    /* :: */[
                      Css.color(Css.hex("71b0f9")),
                      /* :: */[
                        Css.borderColor(Css.hex("71b0f9")),
                        Theme.greenButtonRaw
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function slimButtonLink() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(11.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.maxWidth(Css.em(20.0)),
                  /* :: */[
                    Css.minHeight(Css.em(2.0)),
                    /* :: */[
                      Css.backgroundColor(Css.white),
                      /* :: */[
                        Css.color(Css.hex("fa3468")),
                        Theme.greenButtonRaw
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* headBox */headBox,
  /* contentBox */contentBox,
  /* contentContainer */contentContainer,
  /* contentHeaderBox */contentHeaderBox,
  /* contentHeaderMiddleEl */contentHeaderMiddleEl,
  /* infoHeaderH1 */infoHeaderH1,
  /* infoHeaderH3 */infoHeaderH3,
  /* planIconBox */planIconBox,
  /* planIcon */planIcon,
  /* checkboxIcon */checkboxIcon,
  /* horizonBox */horizonBox,
  /* horizonBoxLinks */horizonBoxLinks,
  /* workoutName */workoutName,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* doubleButton */doubleButton,
  /* smallerGreenSecondaryButton */smallerGreenSecondaryButton,
  /* smallerGreenSecondaryButtonReset */smallerGreenSecondaryButtonReset,
  /* smallerRedSecondaryButton */smallerRedSecondaryButton,
  /* mediumGreenSecondaryButton */mediumGreenSecondaryButton,
  /* mediumGreenSecondaryButtonLight */mediumGreenSecondaryButtonLight,
  /* slimButton */slimButton,
  /* slimButtonBlue */slimButtonBlue,
  /* slimButtonLink */slimButtonLink
];

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("WorkoutWeek");

function make(week, _) {
  var syncNetworkData = function (param) {
    var send = param[/* send */4];
    var state = param[/* state */2];
    Network.initializeSyncStatus2(/* () */0);
    Network.pullData("", (function (data) {
            return Network.successSyncAllNoRedirect(data, (function () {
                          var match = state[/* isMounted */5][0];
                          if (match !== 0) {
                            return Curry._1(send, /* Loaded */1);
                          } else {
                            return /* () */0;
                          }
                        }));
          }));
    return Curry._1(send, /* Loading */2);
  };
  var checkCompleted = function () {
    var intWeek = Caml_format.caml_int_of_string(week);
    var compArr = Network.pullCompletedConfig(/* () */0);
    var one = Caml_array.caml_array_get(compArr, (1 + Caml_int32.imul(6, intWeek - 1 | 0) | 0) - 1 | 0);
    var two = Caml_array.caml_array_get(compArr, (2 + Caml_int32.imul(6, intWeek - 1 | 0) | 0) - 1 | 0);
    var three = Caml_array.caml_array_get(compArr, (3 + Caml_int32.imul(6, intWeek - 1 | 0) | 0) - 1 | 0);
    var four = Caml_array.caml_array_get(compArr, (4 + Caml_int32.imul(6, intWeek - 1 | 0) | 0) - 1 | 0);
    var match = one && two && three && four;
    if (match !== 0) {
      return /* true */1;
    } else {
      return /* false */0;
    }
  };
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      var match = +(Network.pullWizardConfig(/* () */0) !== /* None */0);
      if (match === 0) {
        ReasonReact.Router[/* push */0]("/wizard/1");
      }
      syncNetworkData(self);
      return /* NoUpdate */0;
    });
  newrecord[/* willUnmount */6] = (function (self) {
      self[/* state */2][/* isMounted */5][0] = /* false */0;
      return /* () */0;
    });
  newrecord[/* render */9] = (function (self) {
      var match = self[/* state */2][/* allCompleted */4];
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("div", {
                          className: contentBox
                        }, React.createElement("div", {
                              className: contentContainer
                            }, React.createElement("div", {
                                  className: contentHeaderBox
                                }, React.createElement("div", {
                                      className: planIconBox
                                    }, React.createElement("img", {
                                          className: planIcon,
                                          alt: "",
                                          src: Plan_iconSvg
                                        })), React.createElement("div", {
                                      className: contentHeaderMiddleEl
                                    }, React.createElement("h1", {
                                          className: infoHeaderH1
                                        }, "Workouts"), React.createElement("h3", {
                                          className: infoHeaderH3
                                        }, "Woche " + week))), $$Array.map((function (el) {
                                    var dayString = String(el);
                                    var intWeek = Caml_format.caml_int_of_string(week);
                                    var names = /* array */[
                                      "Upper Body Burn",
                                      "Leg Killer",
                                      "Upper Body & Cardio",
                                      "Lower Body Blast"
                                    ];
                                    var workoutId = (el + Caml_int32.imul(6, intWeek - 1 | 0) | 0) - 1 | 0;
                                    var match = +(Caml_array.caml_array_get(self[/* state */2][/* completed */2], workoutId) === /* true */1);
                                    if (match !== 0) {
                                      return React.createElement("div", {
                                                  key: "id" + dayString,
                                                  className: horizonBox(el)
                                                }, React.createElement("h4", {
                                                      className: workoutName
                                                    }, Caml_array.caml_array_get(names, el - 1 | 0)), React.createElement("div", {
                                                      className: doubleButton
                                                    }, React.createElement("button", {
                                                          className: smallerGreenSecondaryButtonReset(/* () */0),
                                                          onClick: (function () {
                                                              return Curry._1(self[/* send */4], /* Reset */[workoutId]);
                                                            })
                                                        }, "Reset"), React.createElement("button", {
                                                          className: smallerGreenSecondaryButton(/* () */0),
                                                          onClick: (function () {
                                                              return ReasonReact.Router[/* push */0]("/week/" + (week + ("/workout/" + (dayString + "/view"))));
                                                            })
                                                        }, React.createElement("img", {
                                                              className: checkboxIcon,
                                                              alt: "",
                                                              src: Checkbox_iconSvg
                                                            }), "Ansehen")));
                                    } else {
                                      return React.createElement("div", {
                                                  key: "id" + dayString,
                                                  className: horizonBox(el)
                                                }, React.createElement("h4", {
                                                      className: workoutName
                                                    }, Caml_array.caml_array_get(names, el - 1 | 0)), React.createElement("button", {
                                                      key: "id" + dayString,
                                                      className: smallerRedSecondaryButton(/* () */0),
                                                      onClick: (function () {
                                                          return ReasonReact.Router[/* push */0]("/week/" + (week + ("/workout/" + (dayString + "/config"))));
                                                        })
                                                    }, "Starten "));
                                    }
                                  }), /* int array */[
                                  1,
                                  2,
                                  3,
                                  4
                                ]))), React.createElement("div", {
                          className: horizonBoxLinks
                        }, React.createElement("button", {
                              className: mediumGreenSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return ReasonReact.Router[/* push */0]("/week/" + (week + "/cardio/"));
                                })
                            }, "Cardio-Workout"), match !== 0 ? React.createElement("button", {
                                className: mediumGreenSecondaryButton(/* () */0),
                                onClick: (function () {
                                    return ReasonReact.Router[/* push */0]("/week/" + (week + "/bonus/"));
                                  })
                              }, "Bonus-Workout") : React.createElement("button", {
                                className: mediumGreenSecondaryButtonLight(/* () */0)
                              }, "Bonus-Workout")), ReasonReact.element(/* None */0, /* None */0, Link.make("/dashboard", "Dashboard", someLink, /* array */[]))));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* week */Storage.weekOfDay(/* () */0),
              /* day */Storage.weekDay(/* () */0),
              /* completed */Network.pullCompletedConfig(/* () */0),
              /* loading : false */0,
              /* allCompleted */checkCompleted(/* () */0),
              /* isMounted */[/* true */1]
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* week */Storage.weekOfDay(/* () */0),
                          /* day */Storage.weekDay(/* () */0),
                          /* completed */Network.pullCompletedConfig(/* () */0),
                          /* loading : false */0,
                          /* allCompleted */checkCompleted(/* () */0),
                          /* isMounted */[/* true */1]
                        ],
                        (function () {
                            console.log("loaded");
                            return /* () */0;
                          })
                      ]);
          case 2 : 
              var newrecord = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord[/* loading */3] = /* true */1, newrecord),
                        (function () {
                            console.log("loading");
                            return /* () */0;
                          })
                      ]);
          
        }
      } else {
        var workoutId = action[0];
        var completedArr = Network.pullCompletedConfig(/* () */0);
        Caml_array.caml_array_set(completedArr, workoutId, /* false */0);
        var newrecord$1 = state.slice();
        return /* UpdateWithSideEffects */Block.__(3, [
                  (newrecord$1[/* completed */2] = completedArr, newrecord$1),
                  (function () {
                      console.log("resetting: ", workoutId);
                      Network.resetSingleCompletedWorkout(workoutId);
                      Network.resetSinglePoints(workoutId);
                      return Network.resetSingleReps(workoutId);
                    })
                ]);
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checkbox_icon.3a4a6ed5.svg";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Link = __webpack_require__(13);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Modal = __webpack_require__(150);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Js_exn = __webpack_require__(10);
var Network = __webpack_require__(7);
var Storage = __webpack_require__(14);
var FoodSeed = __webpack_require__(47);
var Caml_array = __webpack_require__(9);
var Caml_format = __webpack_require__(8);
var ReasonReact = __webpack_require__(2);
var Fat_iconSvg = __webpack_require__(151);
var Obst_iconSvg = __webpack_require__(152);
var Carbs_iconSvg = __webpack_require__(153);
var Lunch_iconSvg = __webpack_require__(53);
var Snack_iconSvg = __webpack_require__(54);
var Caml_builtin_exceptions = __webpack_require__(3);
var Dinner_iconSvg = __webpack_require__(55);
var Proteine_iconSvg = __webpack_require__(154);
var Breakfast_iconSvg = __webpack_require__(56);
var Vegetables_iconSvg = __webpack_require__(155);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var contentContainer = Css.style(/* :: */[
      Css.boxSizing(/* borderBox */9307263),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.width(/* `percent */[
                  -119887163,
                  100.0
                ]),
            /* :: */[
              Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.margin4(Css.px(18), Css.px(0), Css.px(6), Css.px(0)),
              /* :: */[
                Css.borderTopLeftRadius(Css.px(10)),
                /* :: */[
                  Css.borderTopRightRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomLeftRadius(Css.px(10)),
                    /* :: */[
                      Css.borderBottomRightRadius(Css.px(10)),
                      /* :: */[
                        Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 44, 123, 0.25)),
                        /* [] */0
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var selectHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(24)),
      /* :: */[
        Css.margin4(Css.px(10), Css.px(0), Css.px(2), Css.px(0)),
        /* [] */0
      ]
    ]);

var selectEl = Css.style(/* :: */[
      Css.fontSize(Css.px(24)),
      /* :: */[
        Css.margin4(Css.px(4), Css.px(0), Css.px(10), Css.px(0)),
        /* [] */0
      ]
    ]);

var foodHeader = Css.style(/* :: */[
      Css.color(/* `hex */[
            5194459,
            "FF328C"
          ]),
      /* :: */[
        Css.fontSize(Css.px(22)),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.margin4(Css.px(2), Css.px(0), Css.px(2), Css.px(14)),
            /* [] */0
          ]
        ]
      ]
    ]);

var foodHeaderH1 = Css.style(/* :: */[
      Css.lineHeight(1.1),
      /* :: */[
        Css.margin4(Css.px(18), Css.px(0), Css.px(0), Css.px(0)),
        /* [] */0
      ]
    ]);

var foodHeaderH3 = Css.style(/* :: */[
      Css.fontWeight(400),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(6), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var foodContent = Css.style(/* :: */[
      Css.color(/* `hex */[
            5194459,
            "00C9C8"
          ]),
      /* :: */[
        Css.fontSize(Css.px(22)),
        /* :: */[
          Css.margin4(Css.px(10), Css.px(0), Css.px(18), Css.px(20)),
          /* :: */[
            Css.alignSelf(/* flexStart */662439529),
            /* [] */0
          ]
        ]
      ]
    ]);

var horizonBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.justifyContent(/* spaceBetween */516682146),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBoxHeader = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.justifyContent(/* spaceBetween */516682146),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.background(/* `hex */[
                        5194459,
                        "FFFAFA"
                      ]),
                  /* :: */[
                    Css.borderBottom(Css.px(1), /* solid */12956715, /* `hex */[
                          5194459,
                          "FFEEEF"
                        ]),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBoxLeftEl = Css.style(/* [] */0);

var horizonBoxEl = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(0), Css.px(8)),
      /* :: */[
        Css.fontSize(Css.px(24)),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.cursor(/* pointer */-786317123),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.marginTop(Css.px(5)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var contentElInnerFrame = Css.style(/* :: */[
      Css.justifyContent(Css.center),
      /* :: */[
        Css.width(Css.px(100)),
        /* :: */[
          Css.height(Css.px(100)),
          /* :: */[
            Css.border(Css.px(2), /* solid */12956715, Css.hex("FFEEEF")),
            /* :: */[
              Css.borderRadius(Css.px(10)),
              /* :: */[
                Css.margin4(Css.px(34), Css.px(4), Css.px(4), Css.px(4)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var centerIcon = Css.style(/* :: */[
      Css.margin2(Css.px(2), Css.px(6)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.0,
                1.0
              ]
            ]),
        /* :: */[
          Css.padding4(Css.px(2), Css.px(2), Css.px(2), Css.px(2)),
          /* [] */0
        ]
      ]
    ]);

var smallIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.0,
                1.0
              ]
            ]),
        /* :: */[
          Css.padding4(Css.px(0), Css.px(2), Css.px(0), Css.px(12)),
          /* [] */0
        ]
      ]
    ]);

function smallerRedSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(100)),
              /* :: */[
                Css.maxWidth(Css.px(140)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.height(Css.px(35)),
                    /* :: */[
                      Css.color(/* `hex */[
                            5194459,
                            "FF328C"
                          ]),
                      /* :: */[
                        Css.margin4(Css.px(10), Css.px(8), Css.px(10), Css.px(0)),
                        /* :: */[
                          Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                5194459,
                                "FF328C"
                              ]),
                          Theme.redButtonNarrowRaw
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* contentContainer */contentContainer,
  /* contentBox */contentBox,
  /* selectHeader */selectHeader,
  /* selectEl */selectEl,
  /* foodHeader */foodHeader,
  /* foodHeaderH1 */foodHeaderH1,
  /* foodHeaderH3 */foodHeaderH3,
  /* foodContent */foodContent,
  /* horizonBox */horizonBox,
  /* horizonBoxHeader */horizonBoxHeader,
  /* horizonBoxLeftEl */horizonBoxLeftEl,
  /* horizonBoxEl */horizonBoxEl,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* contentElInnerFrame */contentElInnerFrame,
  /* centerIcon */centerIcon,
  /* smallIcon */smallIcon,
  /* smallerRedSecondaryButton */smallerRedSecondaryButton
];

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      console.log("Issue with int conversion in food router");
      return 2;
    } else {
      throw exn;
    }
  }
}

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("FoodDayStage");

function make(day, stage, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var stageText;
      switch (stage) {
        case "breakfast" : 
            stageText = "Frühstück";
            break;
        case "dinner" : 
            stageText = "Abendessen";
            break;
        case "lunch" : 
            stageText = "Mittagessen";
            break;
        case "snack" : 
            stageText = "Snack";
            break;
        default:
          stageText = "no food";
      }
      var stageIcon;
      switch (stage) {
        case "breakfast" : 
            stageIcon = Breakfast_iconSvg;
            break;
        case "dinner" : 
            stageIcon = Dinner_iconSvg;
            break;
        case "lunch" : 
            stageIcon = Lunch_iconSvg;
            break;
        case "snack" : 
            stageIcon = Snack_iconSvg;
            break;
        default:
          stageIcon = Breakfast_iconSvg;
      }
      var match = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 0) === "");
      var match$1 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 0) !== "");
      var match$2 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 1) === "");
      var match$3 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 1) !== "");
      var match$4 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 2) === "");
      var match$5 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 2) !== "");
      var match$6 = +(stage !== "breakfast");
      var tmp;
      if (match$6 !== 0) {
        var match$7 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 3) === "");
        tmp = React.createElement("div", {
              className: horizonBoxHeader
            }, React.createElement("div", {
                  className: horizonBoxLeftEl
                }, React.createElement("img", {
                      className: smallIcon,
                      alt: "",
                      src: Vegetables_iconSvg
                    }), React.createElement("div", {
                      className: foodHeader
                    }, "Gemüse")), match$7 !== 0 ? React.createElement("button", {
                    className: smallerRedSecondaryButton(/* () */0),
                    onClick: (function () {
                        return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [4]));
                      })
                  }, "Auswählen") : React.createElement("button", {
                    className: smallerRedSecondaryButton(/* () */0),
                    onClick: (function () {
                        return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [4]));
                      })
                  }, "Ändern"));
      } else {
        tmp = null;
      }
      var match$8 = +(stage !== "breakfast");
      var tmp$1;
      if (match$8 !== 0) {
        var match$9 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 3) !== "");
        tmp$1 = match$9 !== 0 ? React.createElement("div", {
                className: foodContent
              }, Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 3)) : null;
      } else {
        tmp$1 = null;
      }
      var foodView = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: contentContainer
              }, React.createElement("div", {
                    className: contentBox
                  }, React.createElement("div", {
                        className: horizonBoxHeader
                      }, React.createElement("div", {
                            className: horizonBoxLeftEl
                          }, React.createElement("img", {
                                className: smallIcon,
                                alt: "Icon",
                                src: Carbs_iconSvg
                              }), React.createElement("div", {
                                className: foodHeader
                              }, "Carbs")), match !== 0 ? React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [1]));
                                })
                            }, "Auswählen") : React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [1]));
                                })
                            }, "Ändern")), match$1 !== 0 ? React.createElement("div", {
                          className: foodContent
                        }, Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 0)) : null, React.createElement("div", {
                        className: horizonBoxHeader
                      }, React.createElement("div", {
                            className: horizonBoxLeftEl
                          }, React.createElement("img", {
                                className: smallIcon,
                                alt: "",
                                src: Proteine_iconSvg
                              }), React.createElement("div", {
                                className: foodHeader
                              }, "Proteine")), match$2 !== 0 ? React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [2]));
                                })
                            }, "Auswählen") : React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [2]));
                                })
                            }, "Ändern")), match$3 !== 0 ? React.createElement("div", {
                          className: foodContent
                        }, Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 1)) : null, React.createElement("div", {
                        className: horizonBoxHeader
                      }, React.createElement("div", {
                            className: horizonBoxLeftEl
                          }, React.createElement("img", {
                                className: smallIcon,
                                alt: "",
                                src: Fat_iconSvg
                              }), React.createElement("div", {
                                className: foodHeader
                              }, "Fette")), match$4 !== 0 ? React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [3]));
                                })
                            }, "Auswählen") : React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [3]));
                                })
                            }, "Ändern")), match$5 !== 0 ? React.createElement("div", {
                          className: foodContent
                        }, Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 2)) : null, tmp, tmp$1)));
      var match$10 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 1) === "");
      var match$11 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 1) !== "");
      var match$12 = +(self[/* state */2][/* calsLevel */0] !== 2);
      var tmp$2;
      if (match$12 !== 0) {
        var match$13 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 0) === "");
        tmp$2 = React.createElement("div", {
              className: horizonBoxHeader
            }, React.createElement("div", {
                  className: horizonBoxLeftEl
                }, React.createElement("img", {
                      className: smallIcon,
                      alt: "",
                      src: Obst_iconSvg
                    }), React.createElement("div", {
                      className: foodHeader
                    }, "Obst")), match$13 !== 0 ? React.createElement("button", {
                    className: smallerRedSecondaryButton(/* () */0),
                    onClick: (function () {
                        return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [6]));
                      })
                  }, "Auswählen") : React.createElement("button", {
                    className: smallerRedSecondaryButton(/* () */0),
                    onClick: (function () {
                        return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [6]));
                      })
                  }, "Ändern"));
      } else {
        tmp$2 = null;
      }
      var match$14 = +(self[/* state */2][/* calsLevel */0] !== 2);
      var tmp$3;
      if (match$14 !== 0) {
        var match$15 = +(Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 0) !== "");
        tmp$3 = match$15 !== 0 ? React.createElement("div", {
                className: foodContent
              }, Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 0)) : null;
      } else {
        tmp$3 = null;
      }
      var snackView = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: contentContainer
              }, React.createElement("div", {
                    className: contentBox
                  }, React.createElement("div", {
                        className: horizonBoxHeader
                      }, React.createElement("div", {
                            className: horizonBoxLeftEl
                          }, React.createElement("img", {
                                className: smallIcon,
                                alt: "",
                                src: Proteine_iconSvg
                              }), React.createElement("div", {
                                className: foodHeader
                              }, "Proteine")), match$10 !== 0 ? React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [5]));
                                })
                            }, "Auswählen") : React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(self[/* send */4], /* ChangeFood */Block.__(1, [5]));
                                })
                            }, "Ändern")), match$11 !== 0 ? React.createElement("div", {
                          className: foodContent
                        }, Caml_array.caml_array_get(self[/* state */2][/* stageFood */1], 1)) : null, tmp$2, tmp$3)));
      var match$16 = self[/* state */2][/* openModal */2];
      var match$17 = +(stage === "snack");
      return React.createElement("div", {
                  className: dashboard
                }, match$16 !== 0 ? ReasonReact.element(/* None */0, /* None */0, Modal.make(self[/* state */2][/* calsLevel */0], self[/* state */2][/* foodTypeName */4], self[/* state */2][/* foodTypeList */5], stageText, (function () {
                              return Curry._1(self[/* send */4], /* CloseModal */0);
                            }), (function (data) {
                              return Curry._1(self[/* send */4], /* SaveFood */Block.__(0, [data]));
                            }), /* array */[])) : null, React.createElement("div", {
                      className: flexList
                    }, React.createElement("div", {
                          className: contentElInnerFrame
                        }, React.createElement("img", {
                              className: centerIcon,
                              alt: "Icon",
                              src: stageIcon
                            })), React.createElement("h1", {
                          className: foodHeaderH1
                        }, stageText), React.createElement("h3", {
                          className: foodHeaderH3
                        }, "Tag " + day), match$17 !== 0 ? snackView : foodView, React.createElement("button", {
                          className: Theme.slimButton(/* () */0),
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/foodday/" + day);
                            })
                        }, "Zurück"), ReasonReact.element(/* None */0, /* None */0, Link.make("/dashboard", "Dashboard", someLink, /* array */[]))));
    });
  newrecord[/* initialState */10] = (function () {
      var stageFood = Network.getStageFood(Caml_format.caml_int_of_string(day), stage);
      return /* record */[
              /* calsLevel */Storage.getCalsLevel(/* () */0),
              /* stageFood */stageFood,
              /* openModal : false */0,
              /* foodType */1,
              /* foodTypeName */"Carbs",
              /* foodTypeList */FoodSeed.carbs
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        var newrecord = state.slice();
        return /* Update */Block.__(0, [(newrecord[/* openModal */2] = /* false */0, newrecord)]);
      } else if (action.tag) {
        var foodType = action[0];
        var switcher = foodType - 1 | 0;
        var foodTypeName;
        if (switcher > 5 || switcher < 0) {
          foodTypeName = "Gemüse";
        } else {
          switch (switcher) {
            case 0 : 
                foodTypeName = "Carbs";
                break;
            case 2 : 
                foodTypeName = "Fette";
                break;
            case 3 : 
                foodTypeName = "Gemüse";
                break;
            case 1 : 
            case 4 : 
                foodTypeName = "Proteine";
                break;
            case 5 : 
                foodTypeName = "Obst";
                break;
            
          }
        }
        var switcher$1 = foodType - 1 | 0;
        var foodTypeList;
        if (switcher$1 > 5 || switcher$1 < 0) {
          foodTypeList = FoodSeed.veggies;
        } else {
          switch (switcher$1) {
            case 0 : 
                foodTypeList = FoodSeed.carbs;
                break;
            case 1 : 
                foodTypeList = FoodSeed.protein;
                break;
            case 2 : 
                foodTypeList = FoodSeed.fat;
                break;
            case 3 : 
                foodTypeList = FoodSeed.veggies;
                break;
            case 4 : 
                foodTypeList = FoodSeed.snacks;
                break;
            case 5 : 
                foodTypeList = FoodSeed.fruits;
                break;
            
          }
        }
        return /* Update */Block.__(0, [/* record */[
                    /* calsLevel */state[/* calsLevel */0],
                    /* stageFood */state[/* stageFood */1],
                    /* openModal : true */1,
                    /* foodType */foodType,
                    /* foodTypeName */foodTypeName,
                    /* foodTypeList */foodTypeList
                  ]]);
      } else {
        var selectedFood = action[0];
        var stageFoodUpdate = state[/* stageFood */1];
        var match = +(state[/* foodType */3] === 5);
        var foodTypeSave;
        if (match !== 0) {
          foodTypeSave = 2;
        } else {
          var match$1 = +(state[/* foodType */3] === 6);
          foodTypeSave = match$1 !== 0 ? 1 : state[/* foodType */3];
        }
        Caml_array.caml_array_set(stageFoodUpdate, foodTypeSave - 1 | 0, selectedFood);
        return /* UpdateWithSideEffects */Block.__(3, [
                  /* record */[
                    /* calsLevel */state[/* calsLevel */0],
                    /* stageFood */stageFoodUpdate,
                    /* openModal : false */0,
                    /* foodType */state[/* foodType */3],
                    /* foodTypeName */state[/* foodTypeName */4],
                    /* foodTypeList */state[/* foodTypeList */5]
                  ],
                  (function () {
                      Network.writeFoodToLs(convToInt(day), stage, foodTypeSave, selectedFood);
                      return /* () */0;
                    })
                ]);
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.convToInt = convToInt;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var $$Array = __webpack_require__(12);
var Curry = __webpack_require__(0);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Caml_array = __webpack_require__(9);
var ReasonReact = __webpack_require__(2);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var modal = Css.style(/* :: */[
      Css.position(/* fixed */10615156),
      /* :: */[
        Css.zIndex(1),
        /* :: */[
          Css.left(Css.px(0)),
          /* :: */[
            Css.top(Css.px(0)),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.height(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.overflow(/* auto */-1065951377),
                  /* :: */[
                    Css.backgroundColor(Css.rgb(68, 68, 68)),
                    /* :: */[
                      Css.opacity(50.0),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.zIndex(2),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.background(Css.white),
                /* :: */[
                  Css.margin2(/* `percent */[
                        -119887163,
                        10.0
                      ], /* auto */-1065951377),
                  /* :: */[
                    Css.width(/* `percent */[
                          -119887163,
                          90.0
                        ]),
                    /* :: */[
                      Css.maxWidth(Css.px(400)),
                      /* :: */[
                        Css.minWidth(Css.px(260)),
                        /* :: */[
                          Css.maxHeight(/* `vh */[
                                26418,
                                80.0
                              ]),
                          /* :: */[
                            Css.borderRadius(Css.px(10)),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var headerBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.background(/* `hex */[
              5194459,
              "FFFAFA"
            ]),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.flexDirection(Css.column),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                  /* :: */[
                    Css.flexShrink(0),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var selectHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(24)),
      /* :: */[
        Css.color(/* `hex */[
              5194459,
              "FF328C"
            ]),
        /* :: */[
          Css.lineHeight(1.1),
          /* :: */[
            Css.fontWeight(700),
            /* :: */[
              Css.textTransform(Css.uppercase),
              /* :: */[
                Css.margin4(Css.px(10), Css.px(0), Css.px(0), Css.px(0)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var selectHeader2 = Css.style(/* :: */[
      Css.fontSize(Css.px(20)),
      /* :: */[
        Css.color(/* `hex */[
              5194459,
              "FF328C"
            ]),
        /* :: */[
          Css.margin4(Css.px(2), Css.px(0), Css.px(4), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.top(Css.px(0)),
            /* :: */[
              Css.left(Css.px(0)),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.height(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.overflow(/* auto */-1065951377),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var spanEl = Css.style(/* :: */[
      Css.marginLeft(Css.px(6)),
      /* :: */[
        Css.fontWeight(400),
        /* [] */0
      ]
    ]);

var entry = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.fontSize(Css.px(18)),
          /* :: */[
            Css.background(/* `hex */[
                  5194459,
                  "FFFAFA"
                ]),
            /* :: */[
              Css.fontWeight(400),
              /* :: */[
                Css.flexDirection(Css.row),
                /* :: */[
                  Css.alignItems(Css.center),
                  /* :: */[
                    Css.justifyContent(/* spaceBetween */516682146),
                    /* :: */[
                      Css.width(/* `percent */[
                            -119887163,
                            100.0
                          ]),
                      /* :: */[
                        Css.flexShrink(0),
                        /* [] */0
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var entryWhite = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.fontSize(Css.px(18)),
          /* :: */[
            Css.fontWeight(400),
            /* :: */[
              Css.background(/* `hex */[
                    5194459,
                    "FFF"
                  ]),
              /* :: */[
                Css.flexDirection(Css.row),
                /* :: */[
                  Css.alignItems(Css.center),
                  /* :: */[
                    Css.justifyContent(/* spaceBetween */516682146),
                    /* :: */[
                      Css.width(/* `percent */[
                            -119887163,
                            100.0
                          ]),
                      /* :: */[
                        Css.flexShrink(0),
                        /* [] */0
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var entryText = Css.style(/* :: */[
      Css.textAlign(/* left */-944764921),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(14)),
        /* :: */[
          Css.color(Css.hex("3D2D34")),
          /* [] */0
        ]
      ]
    ]);

function smallerRedSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(100)),
              /* :: */[
                Css.maxWidth(Css.px(140)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.height(Css.px(35)),
                    /* :: */[
                      Css.color(/* `hex */[
                            5194459,
                            "FF328C"
                          ]),
                      /* :: */[
                        Css.margin4(Css.px(10), Css.px(8), Css.px(10), Css.px(0)),
                        /* :: */[
                          Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                5194459,
                                "FF328C"
                              ]),
                          Theme.redButtonNarrowRaw
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var Styles = /* module */[
  /* dashboard */dashboard,
  /* modal */modal,
  /* flexList */flexList,
  /* headerBox */headerBox,
  /* selectHeader */selectHeader,
  /* selectHeader2 */selectHeader2,
  /* contentBox */contentBox,
  /* spanEl */spanEl,
  /* entry */entry,
  /* entryWhite */entryWhite,
  /* entryText */entryText,
  /* smallerRedSecondaryButton */smallerRedSecondaryButton
];

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("Modal");

function make(calsLevel, foodTypeName, foodTypeList, stageText, onClose, onSelect, _) {
  var handleCloseClick = function (_, _$1) {
    return Curry._1(onClose, /* () */0);
  };
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      return React.createElement("div", {
                  className: modal,
                  onClick: Curry._1(self[/* handle */0], handleCloseClick)
                }, React.createElement("div", {
                      className: flexList,
                      onClick: (function ($$event) {
                          $$event.stopPropagation();
                          return /* () */0;
                        })
                    }, React.createElement("div", {
                          className: headerBox
                        }, React.createElement("div", {
                              className: selectHeader
                            }, foodTypeName), React.createElement("div", {
                              className: selectHeader2
                            }, stageText)), React.createElement("div", {
                          className: contentBox
                        }, $$Array.mapi((function (i, el) {
                                var match = +(i % 2 === 1);
                                var myStyle = match !== 0 ? entry : entryWhite;
                                var partial_arg = el[/* name */1] + (" " + Caml_array.caml_array_get(el[/* quantity */2], calsLevel));
                                return React.createElement("div", {
                                            key: String(i),
                                            className: myStyle
                                          }, React.createElement("div", {
                                                className: entryText
                                              }, el[/* name */1] + (" " + Caml_array.caml_array_get(el[/* quantity */2], calsLevel))), React.createElement("button", {
                                                className: smallerRedSecondaryButton(/* () */0),
                                                onClick: Curry._1(self[/* handle */0], (function (_, _$1) {
                                                        return Curry._1(onSelect, partial_arg);
                                                      }))
                                              }, "Verwenden"));
                              }), foodTypeList))));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* dashboard Not a pure module */


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fat_icon.18e8beac.svg";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/obst_icon.ecb59cb2.svg";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/carbs_icon.a8d37c25.svg";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/proteine_icon.c30cbdc3.svg";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/vegetables_icon.677a2b3b.svg";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Seed = __webpack_require__(17);
var $$Array = __webpack_require__(12);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Js_exn = __webpack_require__(10);
var Network = __webpack_require__(7);
var Caml_obj = __webpack_require__(15);
var Caml_array = __webpack_require__(9);
var Caml_int32 = __webpack_require__(11);
var Caml_format = __webpack_require__(8);
var ReasonReact = __webpack_require__(2);
var Cta_arrowSvg = __webpack_require__(52);
var Info_iconSvg = __webpack_require__(30);
var Caml_builtin_exceptions = __webpack_require__(3);
var Jogging_iconSvg = __webpack_require__(157);

var flexList = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.alignItems(Css.center),
          /* [] */0
        ]
      ]
    ]);

var mapElement = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.alignItems(Css.center),
          /* [] */0
        ]
      ]
    ]);

var headBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.background(Css.hex("fffafa")),
              /* :: */[
                Css.marginBottom(Css.px(10)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.boxSizing(/* borderBox */9307263),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var infoHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.margin4(Css.px(18), Css.px(0), Css.px(6), Css.px(0)),
        /* [] */0
      ]
    ]);

var infoHeaderH1 = Css.style(/* :: */[
      Css.margin4(Css.px(18), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.zIndex(2),
        /* [] */0
      ]
    ]);

var infoHeaderH4 = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(6), Css.px(0)),
        /* :: */[
          Css.zIndex(2),
          /* [] */0
        ]
      ]
    ]);

var infoButton = Css.style(/* :: */[
      Css.position(/* absolute */-1013592457),
      /* :: */[
        Css.right(Css.px(12)),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(10)),
            /* [] */0
          ]
        ]
      ]
    ]);

var workoutContainer = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
            /* :: */[
              Css.borderTopLeftRadius(Css.px(10)),
              /* :: */[
                Css.borderTopRightRadius(Css.px(10)),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 44, 123, 0.25)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutHeaderBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.row),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.justifyContent(Css.center),
            /* :: */[
              Css.background(Css.hex("FFFAFA")),
              /* :: */[
                Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.borderTopLeftRadius(Css.px(10)),
                    /* :: */[
                      Css.borderTopRightRadius(Css.px(10)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutHeaderMiddleEl = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* [] */0
      ]
    ]);

var workoutNameHeader = Css.style(/* :: */[
      Css.lineHeight(1.2),
      /* :: */[
        Css.margin4(Css.px(5), Css.px(48), Css.px(0), Css.px(48)),
        /* [] */0
      ]
    ]);

var pairBox = Css.style(/* :: */[
      Css.fontSize(Css.px(12)),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(8), Css.px(2), Css.px(8)),
        /* [] */0
      ]
    ]);

var initialBodyFrame = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.marginBottom(Css.px(5)),
          /* [] */0
        ]
      ]
    ]);

var initialBodyFrameBox = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var initialBody = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var initialBodyImgContainer = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.margin4(Css.px(5), Css.px(3), Css.px(1), Css.px(3)),
        /* :: */[
          Css.padding2(Css.px(0), Css.px(0)),
          /* :: */[
            Css.minWidth(Css.px(0)),
            /* :: */[
              Css.alignItems(/* center */98248149),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var hiddenImgContainer = Css.style(/* :: */[
      Css.visibility(/* hidden */-862584982),
      /* :: */[
        Css.height(Css.px(0)),
        /* [] */0
      ]
    ]);

var imgType = Css.style(/* :: */[
      Css.position(/* absolute */-1013592457),
      /* :: */[
        Css.top(Css.px(0)),
        /* :: */[
          Css.left(Css.px(4)),
          /* :: */[
            Css.color(/* `hex */[
                  5194459,
                  "E02C7B"
                ]),
            /* :: */[
              Css.fontWeight(700),
              /* :: */[
                Css.fontSize(Css.px(14)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var initialBodyImg = Css.style(/* :: */[
      Css.maxWidth(/* `percent */[
            -119887163,
            100.0
          ]),
      /* [] */0
    ]);

var horizonBox = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
          /* :: */[
            Css.justifyContent(Css.spaceAround),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.background(Css.hex("00")),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.padding2(Css.px(8), Css.px(0)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

function horizonBoxEl(el, value) {
  var match = Caml_obj.caml_equal(el, value);
  return Css.style(/* :: */[
              Css.display(Css.flexBox),
              /* :: */[
                Css.flexGrow(1),
                /* :: */[
                  match !== 0 ? Css.background(Css.lightgreen) : Css.background(Css.lightblue),
                  /* :: */[
                    Css.margin4(Css.px(0), Css.px(10), Css.px(0), Css.px(10)),
                    /* :: */[
                      Css.fontSize(Css.px(24)),
                      /* :: */[
                        Css.minHeight(Css.px(40)),
                        /* :: */[
                          Css.maxWidth(Css.px(100)),
                          /* :: */[
                            Css.fontWeight(700),
                            /* :: */[
                              Css.cursor(/* pointer */-786317123),
                              /* :: */[
                                Css.justifyContent(Css.center),
                                /* :: */[
                                  Css.alignItems(Css.center),
                                  /* [] */0
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function smallerGreenSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(80)),
              /* :: */[
                Css.maxWidth(Css.px(100)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.height(Css.px(30)),
                    /* :: */[
                      Css.margin4(Css.px(2), Css.px(0), Css.px(2), Css.px(0)),
                      Theme.greenSecondaryButtonRaw
                    ]
                  ]
                ]
              ]
            ]);
}

function smallerRedSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(80)),
              /* :: */[
                Css.maxWidth(Css.px(100)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.height(Css.px(30)),
                    /* :: */[
                      Css.color(/* `hex */[
                            5194459,
                            "FFBFC2"
                          ]),
                      /* :: */[
                        Css.margin4(Css.px(2), Css.px(0), Css.px(2), Css.px(0)),
                        /* :: */[
                          Css.border(Css.px(1), /* solid */12956715, Css.rgba(255, 191, 194, 0.5)),
                          Theme.redButtonNarrowRaw
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.marginTop(Css.px(5)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var smallArrow = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.margin2(Css.px(0), Css.px(8)),
        /* :: */[
          Css.transform(/* `scale */[
                -120664438,
                /* tuple */[
                  1.2,
                  1.2
                ]
              ]),
          /* [] */0
        ]
      ]
    ]);

var infoIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var runnerIconBox = Css.style(/* :: */[
      Css.position(/* absolute */-1013592457),
      /* :: */[
        Css.left(Css.px(0)),
        /* :: */[
          Css.top(Css.px(8)),
          /* :: */[
            Css.cursor(/* pointer */-786317123),
            /* :: */[
              Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var runnerIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var Styles = /* module */[
  /* flexList */flexList,
  /* mapElement */mapElement,
  /* headBox */headBox,
  /* contentBox */contentBox,
  /* infoHeader */infoHeader,
  /* infoHeaderH1 */infoHeaderH1,
  /* infoHeaderH4 */infoHeaderH4,
  /* infoButton */infoButton,
  /* workoutContainer */workoutContainer,
  /* workoutHeaderBox */workoutHeaderBox,
  /* workoutHeaderMiddleEl */workoutHeaderMiddleEl,
  /* workoutNameHeader */workoutNameHeader,
  /* pairBox */pairBox,
  /* initialBodyFrame */initialBodyFrame,
  /* initialBodyFrameBox */initialBodyFrameBox,
  /* initialBody */initialBody,
  /* initialBodyImgContainer */initialBodyImgContainer,
  /* hiddenImgContainer */hiddenImgContainer,
  /* imgType */imgType,
  /* initialBodyImg */initialBodyImg,
  /* horizonBox */horizonBox,
  /* horizonBoxEl */horizonBoxEl,
  /* smallerGreenSecondaryButton */smallerGreenSecondaryButton,
  /* smallerRedSecondaryButton */smallerRedSecondaryButton,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* smallArrow */smallArrow,
  /* infoIcon */infoIcon,
  /* runnerIconBox */runnerIconBox,
  /* runnerIcon */runnerIcon
];

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      console.log("Issue with int conversion in workout configuration component");
      return 2;
    } else {
      throw exn;
    }
  }
}

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("WorkoutConfig");

function plc(exId) {
  var res = /* int array */[
    0,
    0,
    0
  ];
  var match = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId - 1 | 0), 0);
  if (match !== 2) {
    Caml_array.caml_array_set(res, 0, 3);
  } else {
    Caml_array.caml_array_set(res, 0, 2);
  }
  var match$1 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId - 1 | 0), 1);
  if (match$1 !== 2) {
    Caml_array.caml_array_set(res, 1, 3);
  } else {
    Caml_array.caml_array_set(res, 1, 2);
  }
  var match$2 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId - 1 | 0), 2);
  var switcher = match$2 - 2 | 0;
  if (switcher > 2 || switcher < 0) {
    Caml_array.caml_array_set(res, 2, 6);
  } else {
    switch (switcher) {
      case 0 : 
          Caml_array.caml_array_set(res, 2, 2);
          break;
      case 1 : 
          Caml_array.caml_array_set(res, 2, 3);
          break;
      case 2 : 
          Caml_array.caml_array_set(res, 2, 4);
          break;
      
    }
  }
  console.log("preset", res);
  return res;
}

function make(week, workout, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      var newrecord = self[/* state */2].slice();
      return /* Update */Block.__(0, [(newrecord[/* levels */2] = Caml_array.caml_array_get(self[/* state */2][/* allLevels */3], self[/* state */2][/* workoutIndex */0]), newrecord)]);
    });
  newrecord[/* render */9] = (function (self) {
      return React.createElement("div", {
                  className: flexList
                }, React.createElement("div", {
                      className: headBox
                    }, React.createElement("div", {
                          className: runnerIconBox
                        }, React.createElement("img", {
                              className: runnerIcon,
                              alt: "runner",
                              src: Jogging_iconSvg
                            })), React.createElement("h1", {
                          className: infoHeaderH1
                        }, "Workout " + workout), React.createElement("h4", {
                          className: infoHeaderH4
                        }, "Wähle deinen Schwierigkeitsgrad")), React.createElement("div", {
                      className: contentBox
                    }, $$Array.mapi((function (index, _) {
                            var exId = Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */8], index);
                            var match = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 0) === 0);
                            var block12 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match !== 0 ? React.createElement("div", {
                                        className: initialBody
                                      }, React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("div", {
                                                className: imgType
                                              }, "leicht"), React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l1_a.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l1_b.jpg")
                                              }))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l1_a.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [0]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l1_b.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [0]));
                                                })
                                            }))));
                            var match$1 = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 0) === 0);
                            var block13 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match$1 !== 0 ? React.createElement("div", {
                                        className: initialBody
                                      }, React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("div", {
                                                className: imgType
                                              }, "leicht"), React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l1_a.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l1_b.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l1_c.jpg")
                                              }))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l1_a.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [0]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l1_b.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [0]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l1_c.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [0]));
                                                })
                                            }))));
                            var match$2 = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 1) === 0);
                            var block22 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match$2 !== 0 ? React.createElement("div", {
                                        className: initialBody
                                      }, React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("div", {
                                                className: imgType
                                              }, "mittel"), React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */8], index)) + "_l2_a.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l2_b.jpg")
                                              }))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */8], index)) + "_l2_a.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [1]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l2_b.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [1]));
                                                })
                                            }))));
                            var match$3 = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 1) === 0);
                            var block23 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match$3 !== 0 ? React.createElement("div", {
                                        className: initialBody
                                      }, React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("div", {
                                                className: imgType
                                              }, "mittel"), React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */8], index)) + "_l2_a.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l2_b.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l2_c.jpg")
                                              }))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */8], index)) + "_l2_a.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [1]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l2_b.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [1]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l2_c.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [1]));
                                                })
                                            }))));
                            var match$4 = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 2) === 0);
                            var block32 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match$4 !== 0 ? React.createElement("div", {
                                        className: initialBody
                                      }, React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("div", {
                                                className: imgType
                                              }, "schwer"), React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l3_a.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l3_b.jpg")
                                              }))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l3_a.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l3_b.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                })
                                            }))));
                            var match$5 = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 2) === 0);
                            var block33 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match$5 !== 0 ? React.createElement("div", {
                                        className: initialBody
                                      }, React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("div", {
                                                className: imgType
                                              }, "schwer"), React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l3_a.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l3_b.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l3_c.jpg")
                                              }))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l3_a.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l3_b.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l3_c.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                })
                                            }))));
                            var match$6 = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 2) === 0);
                            var block34 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match$6 !== 0 ? React.createElement("div", {
                                        className: initialBodyFrameBox
                                      }, React.createElement("div", {
                                            className: initialBody
                                          }, React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("div", {
                                                    className: imgType
                                                  }, "schwer"), React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_a.jpg")
                                                  })), React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_b.jpg")
                                                  }))), React.createElement("div", {
                                            className: initialBody
                                          }, React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_c.jpg")
                                                  })), React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_d.jpg")
                                                  })))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBody
                                        }, React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_a.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })), React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_b.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                }))), React.createElement("div", {
                                          className: initialBody
                                        }, React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_c.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })), React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_d.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })))));
                            var match$7 = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 2) === 0);
                            var block36 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match$7 !== 0 ? React.createElement("div", {
                                        className: initialBodyFrameBox
                                      }, React.createElement("div", {
                                            className: initialBody
                                          }, React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("div", {
                                                    className: imgType
                                                  }, "schwer"), React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_a.jpg")
                                                  })), React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_b.jpg")
                                                  })), React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_c.jpg")
                                                  }))), React.createElement("div", {
                                            className: initialBody
                                          }, React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_d.jpg")
                                                  })), React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_e.jpg")
                                                  })), React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_f.jpg")
                                                  })))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBody
                                        }, React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_a.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })), React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_b.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })), React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_c.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                }))), React.createElement("div", {
                                          className: initialBody
                                        }, React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_d.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })), React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_e.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })), React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_f.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })))));
                            var match$8 = Caml_array.caml_array_get(self[/* state */2][/* showDetails */5], index);
                            var tmp;
                            if (match$8 !== 0) {
                              var match$9 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId - 1 | 0), 0);
                              var match$10 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId - 1 | 0), 1);
                              var match$11 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId - 1 | 0), 2);
                              var switcher = match$11 - 2 | 0;
                              var tmp$1;
                              if (switcher > 2 || switcher < 0) {
                                tmp$1 = block36;
                              } else {
                                switch (switcher) {
                                  case 0 : 
                                      tmp$1 = block32;
                                      break;
                                  case 1 : 
                                      tmp$1 = block33;
                                      break;
                                  case 2 : 
                                      tmp$1 = block34;
                                      break;
                                  
                                }
                              }
                              tmp = React.createElement("div", {
                                    className: flexList
                                  }, match$9 !== 2 ? block13 : block12, match$10 !== 2 ? block23 : block22, tmp$1);
                            } else {
                              tmp = null;
                            }
                            var match$12 = +(1 !== Caml_array.caml_array_get(self[/* state */2][/* levels */2], index));
                            var match$13 = +(2 !== Caml_array.caml_array_get(self[/* state */2][/* levels */2], index));
                            var match$14 = +(3 !== Caml_array.caml_array_get(self[/* state */2][/* levels */2], index));
                            return React.createElement("div", {
                                        key: String(index),
                                        className: mapElement
                                      }, React.createElement("div", {
                                            className: workoutContainer
                                          }, React.createElement("div", {
                                                className: workoutHeaderBox
                                              }, React.createElement("div", {
                                                    className: workoutHeaderMiddleEl
                                                  }, React.createElement("h4", {
                                                        className: workoutNameHeader
                                                      }, Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */7], index)), React.createElement("div", {
                                                        className: pairBox
                                                      }, "Übungspaar ", Caml_array.caml_array_get(self[/* state */2][/* pair */4], index) + "/3")), React.createElement("div", {
                                                    className: infoButton,
                                                    onClick: (function () {
                                                        return Curry._1(self[/* send */4], /* ToggleDetails */Block.__(1, [
                                                                      index,
                                                                      exId
                                                                    ]));
                                                      })
                                                  }, React.createElement("img", {
                                                        className: infoIcon,
                                                        alt: "info",
                                                        src: Info_iconSvg
                                                      }))), tmp, React.createElement("div", {
                                                className: horizonBox
                                              }, match$12 !== 0 ? React.createElement("div", {
                                                      className: smallerRedSecondaryButton(/* () */0),
                                                      onClick: (function () {
                                                          return Curry._1(self[/* send */4], /* SetLevel */Block.__(0, [
                                                                        1,
                                                                        index
                                                                      ]));
                                                        })
                                                    }, "leicht") : React.createElement("div", {
                                                      className: smallerGreenSecondaryButton(/* () */0),
                                                      onClick: (function () {
                                                          return Curry._1(self[/* send */4], /* SetLevel */Block.__(0, [
                                                                        1,
                                                                        index
                                                                      ]));
                                                        })
                                                    }, "leicht"), match$13 !== 0 ? React.createElement("div", {
                                                      className: smallerRedSecondaryButton(/* () */0),
                                                      onClick: (function () {
                                                          return Curry._1(self[/* send */4], /* SetLevel */Block.__(0, [
                                                                        2,
                                                                        index
                                                                      ]));
                                                        })
                                                    }, "mittel") : React.createElement("div", {
                                                      className: smallerGreenSecondaryButton(/* () */0),
                                                      onClick: (function () {
                                                          return Curry._1(self[/* send */4], /* SetLevel */Block.__(0, [
                                                                        2,
                                                                        index
                                                                      ]));
                                                        })
                                                    }, "mittel"), match$14 !== 0 ? React.createElement("div", {
                                                      className: smallerRedSecondaryButton(/* () */0),
                                                      onClick: (function () {
                                                          return Curry._1(self[/* send */4], /* SetLevel */Block.__(0, [
                                                                        3,
                                                                        index
                                                                      ]));
                                                        })
                                                    }, "schwer") : React.createElement("div", {
                                                      className: smallerGreenSecondaryButton(/* () */0),
                                                      onClick: (function () {
                                                          return Curry._1(self[/* send */4], /* SetLevel */Block.__(0, [
                                                                        3,
                                                                        index
                                                                      ]));
                                                        })
                                                    }, "schwer"))));
                          }), self[/* state */2][/* levels */2]), React.createElement("button", {
                          className: Theme.greenButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* StoreResults */0);
                            })
                        }, "Weiter", React.createElement("img", {
                              className: smallArrow,
                              alt: "arrow",
                              src: Cta_arrowSvg
                            }))));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* workoutIndex */Caml_int32.imul(Caml_format.caml_int_of_string(week) - 1 | 0, 6) + (Caml_format.caml_int_of_string(workout) - 1 | 0) | 0,
              /* workoutConfigured : false */0,
              /* levels : array */[
                1,
                1,
                1,
                1,
                1,
                1
              ],
              /* allLevels */Network.pullLevelConfig(/* () */0),
              /* pair : array */[
                "1",
                "1",
                "2",
                "2",
                "3",
                "3"
              ],
              /* showDetails : array */[
                /* false */0,
                /* false */0,
                /* false */0,
                /* false */0,
                /* false */0,
                /* false */0
              ],
              /* blockLoaded : int array */[
                0,
                0,
                0
              ],
              /* currentWorkoutExercises */Seed.getWorkoutTitles(week, workout),
              /* currentWorkoutExercisesIds */Seed.getWorkoutIds(week, workout),
              /* hide1 : false */0,
              /* hide2 : false */0,
              /* hide3 : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        var newrecord = state.slice();
        return /* UpdateWithSideEffects */Block.__(3, [
                  (newrecord[/* workoutConfigured */1] = /* true */1, newrecord),
                  (function () {
                      Network.safeLevelSettingsToLs(state[/* levels */2], state[/* allLevels */3], state[/* workoutIndex */0]);
                      return ReasonReact.Router[/* push */0]("/week/" + (week + ("/workout/" + (workout + "/1/1/2"))));
                    })
                ]);
      } else {
        switch (action.tag | 0) {
          case 0 : 
              var newL = state[/* levels */2];
              Caml_array.caml_array_set(newL, action[1], action[0]);
              var newrecord$1 = state.slice();
              return /* Update */Block.__(0, [(newrecord$1[/* levels */2] = newL, newrecord$1)]);
          case 1 : 
              var item = action[0];
              var presetLoadedCount = plc(action[1]);
              var showDetailsNew = $$Array.mapi((function (index, oldEntry) {
                      var match = +(index === item);
                      if (match !== 0) {
                        return 1 - oldEntry;
                      } else {
                        return /* false */0;
                      }
                    }), state[/* showDetails */5]);
              var newrecord$2 = state.slice();
              return /* Update */Block.__(0, [(newrecord$2[/* showDetails */5] = showDetailsNew, newrecord$2[/* blockLoaded */6] = presetLoadedCount, newrecord$2)]);
          case 2 : 
              var item$1 = action[0];
              console.log("hiding: ", item$1);
              if (item$1 !== 1) {
                if (item$1 !== 2) {
                  var newrecord$3 = state.slice();
                  return /* Update */Block.__(0, [(newrecord$3[/* hide3 */11] = /* true */1, newrecord$3)]);
                } else {
                  var newrecord$4 = state.slice();
                  return /* Update */Block.__(0, [(newrecord$4[/* hide2 */10] = /* true */1, newrecord$4)]);
                }
              } else {
                var newrecord$5 = state.slice();
                return /* Update */Block.__(0, [(newrecord$5[/* hide1 */9] = /* true */1, newrecord$5)]);
              }
          case 3 : 
              var pos = action[0];
              console.log("Loaded");
              var bl = state[/* blockLoaded */6];
              Caml_array.caml_array_set(bl, pos, Caml_array.caml_array_get(bl, pos) - 1 | 0);
              var newrecord$6 = state.slice();
              return /* Update */Block.__(0, [(newrecord$6[/* blockLoaded */6] = bl, newrecord$6)]);
          
        }
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.convToInt = convToInt;
exports.text = text;
exports.component = component;
exports.plc = plc;
exports.make = make;
/* flexList Not a pure module */


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jogging_icon.5ed118ed.svg";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Seed = __webpack_require__(17);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Caml_array = __webpack_require__(9);
var Caml_format = __webpack_require__(8);
var ReasonReact = __webpack_require__(2);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.fontWeight(700),
        /* :: */[
          Css.whiteSpace(/* preLine */538440119),
          /* [] */0
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

function settingButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(12.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(20), Css.px(8), Css.px(10), Css.px(8)),
                  /* :: */[
                    Css.maxWidth(Css.em(13.0)),
                    Theme.greenButtonRaw
                  ]
                ]
              ]
            ]);
}

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* settingButton */settingButton
];

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("KonwledgeEntry");

function make(entry, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("h1", undefined, "Wissenseintrag"), React.createElement("h1", undefined, Caml_array.caml_array_get(Seed.knowledgeEntries, Caml_format.caml_int_of_string(entry) - 1 | 0)[/* title */1]), React.createElement("p", {
                          className: inputHeader
                        }, Caml_array.caml_array_get(Seed.knowledgeEntries, Caml_format.caml_int_of_string(entry) - 1 | 0)[/* content */2]), React.createElement("button", {
                          className: settingButton(/* () */0),
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/knowledge");
                            })
                        }, "Zurück")));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Seed = __webpack_require__(17);
var $$Array = __webpack_require__(12);
var Block = __webpack_require__(5);
var Curry = __webpack_require__(0);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var Js_exn = __webpack_require__(10);
var Network = __webpack_require__(7);
var Caml_obj = __webpack_require__(15);
var Caml_array = __webpack_require__(9);
var Caml_int32 = __webpack_require__(11);
var Caml_format = __webpack_require__(8);
var ReasonReact = __webpack_require__(2);
var Check_onSvg = __webpack_require__(160);
var Check_offSvg = __webpack_require__(161);
var Info_iconSvg = __webpack_require__(30);
var Caml_builtin_exceptions = __webpack_require__(3);
var Present_iconSvg = __webpack_require__(162);
var Bonus_workout_patternPng = __webpack_require__(163);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var workout = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.backgroundImage(/* `url */[
                  5843823,
                  Bonus_workout_patternPng
                ]),
            /* [] */0
          ]
        ]
      ]
    ]);

var workoutBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.boxSizing(Css.borderBox),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
                  /* :: */[
                    Css.margin4(Css.px(40), Css.px(0), Css.px(20), Css.px(0)),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutBoxInner = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.borderRadius(Css.px(10)),
              /* :: */[
                Css.boxShadow(/* Some */[Css.px(2)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(255, 191, 194, 0.29)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutBoxHeader = Css.style(/* :: */[
      Css.position(Css.relative),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.background(/* `hex */[
                    5194459,
                    "FFFAFA"
                  ]),
              /* :: */[
                Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
                /* :: */[
                  Css.padding2(Css.px(0), Css.px(0)),
                  /* :: */[
                    Css.width(/* `percent */[
                          -119887163,
                          100.0
                        ]),
                    /* :: */[
                      Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var present = Css.style(/* :: */[
      Css.top(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.transforms(/* :: */[
              /* `translate */[
                -914368690,
                /* tuple */[
                  Css.px(0),
                  /* `percent */[
                    -119887163,
                    -50.0
                  ]
                ]
              ],
              /* :: */[
                /* `scale */[
                  -120664438,
                  /* tuple */[
                    1.4,
                    1.4
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(Css.px(14)),
            /* [] */0
          ]
        ]
      ]
    ]);

var selectHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(24)),
      /* :: */[
        Css.margin4(Css.px(10), Css.px(0), Css.px(2), Css.px(0)),
        /* [] */0
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.center),
          /* [] */0
        ]
      ]
    ]);

var mapElement = Css.style(/* :: */[
      Css.background(/* `hex */[
            5194459,
            "FFFAFA"
          ]),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.paddingLeft(Css.px(12)),
              /* :: */[
                Css.paddingRight(Css.px(12)),
                /* :: */[
                  Css.boxSizing(Css.borderBox),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var mapElementCol = Css.style(/* :: */[
      Css.background(/* `hex */[
            5194459,
            "FFF"
          ]),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.paddingLeft(Css.px(12)),
              /* :: */[
                Css.paddingRight(Css.px(12)),
                /* :: */[
                  Css.boxSizing(Css.borderBox),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var infoHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.margin4(Css.px(18), Css.px(0), Css.px(6), Css.px(0)),
        /* [] */0
      ]
    ]);

var vertBox = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.fontSize(Css.px(24)),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.margin4(Css.px(4), Css.px(0), Css.px(8), Css.px(0)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var horizonBox = Css.style(/* :: */[
      Css.position(Css.relative),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.justifyContent(Css.spaceBetween),
            /* :: */[
              Css.margin4(Css.px(14), Css.px(0), Css.px(14), Css.px(0)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var horizonBoxEl = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.flexDirection(Css.row),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.paddingRight(Css.px(82)),
            /* :: */[
              Css.textAlign(/* left */-944764921),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var horizonBoxElRight = Css.style(/* :: */[
      Css.top(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.transform(/* `translate */[
              -914368690,
              /* tuple */[
                Css.px(0),
                /* `percent */[
                  -119887163,
                  -50.0
                ]
              ]
            ]),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.cursor(/* pointer */-786317123),
            /* :: */[
              Css.position(Css.absolute),
              /* :: */[
                Css.right(Css.px(0)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBoxSmallEl = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(0), Css.px(8)),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* [] */0
      ]
    ]);

var initialBody = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.justifyContent(/* center */98248149),
          /* :: */[
            Css.marginBottom(Css.px(5)),
            /* [] */0
          ]
        ]
      ]
    ]);

var initialBodyImgContainer1 = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(10), Css.px(3), Css.px(10)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.minWidth(Css.px(0)),
          /* :: */[
            Css.alignItems(/* center */98248149),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    50.0
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var initialBodyImgContainer = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(3), Css.px(3), Css.px(3)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.minWidth(Css.px(0)),
          /* :: */[
            Css.alignItems(/* center */98248149),
            /* [] */0
          ]
        ]
      ]
    ]);

var initialBodyImg = Css.style(/* :: */[
      Css.maxWidth(/* `percent */[
            -119887163,
            100.0
          ]),
      /* [] */0
    ]);

var workoutNameHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.fontWeight(400),
        /* :: */[
          Css.margin4(Css.px(8), Css.px(8), Css.px(10), Css.px(8)),
          /* [] */0
        ]
      ]
    ]);

var headHeader = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(5)),
        /* [] */0
      ]
    ]);

var subHeader = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.fontSize(Css.px(22)),
          /* [] */0
        ]
      ]
    ]);

var countDown = Css.style(/* :: */[
      Css.fontSize(Css.px(36)),
      /* :: */[
        Css.fontWeight(700),
        /* :: */[
          Css.margin4(Css.px(8), Css.px(8), Css.px(10), Css.px(8)),
          /* [] */0
        ]
      ]
    ]);

var spanEl = Css.style(/* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(10)),
        /* [] */0
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(10)),
      /* :: */[
        Css.marginTop(Css.px(10)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(0), Css.px(8), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* :: */[
          Css.maxWidth(Css.px(120)),
          /* :: */[
            Css.fontSize(Css.px(30)),
            /* [] */0
          ]
        ]
      ]
    ]);

function horizonBoxElPlus(el, value) {
  var match = Caml_obj.caml_equal(el, value);
  return Css.style(/* :: */[
              Css.display(Css.flexBox),
              /* :: */[
                Css.flexGrow(1),
                /* :: */[
                  match !== 0 ? Css.background(Css.lightgreen) : Css.background(Css.lightblue),
                  /* :: */[
                    Css.margin4(Css.px(0), Css.px(10), Css.px(0), Css.px(10)),
                    /* :: */[
                      Css.fontSize(Css.px(24)),
                      /* :: */[
                        Css.minHeight(Css.px(40)),
                        /* :: */[
                          Css.maxWidth(Css.px(100)),
                          /* :: */[
                            Css.fontWeight(700),
                            /* :: */[
                              Css.cursor(/* pointer */-786317123),
                              /* :: */[
                                Css.justifyContent(Css.center),
                                /* :: */[
                                  Css.alignItems(Css.center),
                                  /* [] */0
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function settingButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(12.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(50), Css.px(8), Css.px(10), Css.px(8)),
                  /* :: */[
                    Css.maxWidth(Css.em(13.0)),
                    Theme.greenButtonRaw
                  ]
                ]
              ]
            ]);
}

var infoButton = Css.style(/* :: */[
      Css.top(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.transform(/* `translate */[
              -914368690,
              /* tuple */[
                Css.px(0),
                /* `percent */[
                  -119887163,
                  -50.0
                ]
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.right(Css.px(42)),
            /* :: */[
              Css.cursor(/* pointer */-786317123),
              /* :: */[
                Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(10)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var infoIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var checkIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var someText = Css.style(/* :: */[
      Css.textAlign(/* left */-944764921),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* :: */[
            Css.margin2(Css.px(10), Css.px(10)),
            /* :: */[
              Css.color(/* `hex */[
                    5194459,
                    "FF328C"
                  ]),
              /* :: */[
                Css.fontWeight(700),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* workout */workout,
  /* workoutBox */workoutBox,
  /* workoutBoxInner */workoutBoxInner,
  /* workoutBoxHeader */workoutBoxHeader,
  /* present */present,
  /* selectHeader */selectHeader,
  /* flexList */flexList,
  /* mapElement */mapElement,
  /* mapElementCol */mapElementCol,
  /* infoHeader */infoHeader,
  /* vertBox */vertBox,
  /* horizonBox */horizonBox,
  /* horizonBoxEl */horizonBoxEl,
  /* horizonBoxElRight */horizonBoxElRight,
  /* horizonBoxSmallEl */horizonBoxSmallEl,
  /* initialBody */initialBody,
  /* initialBodyImgContainer1 */initialBodyImgContainer1,
  /* initialBodyImgContainer */initialBodyImgContainer,
  /* initialBodyImg */initialBodyImg,
  /* workoutNameHeader */workoutNameHeader,
  /* headHeader */headHeader,
  /* subHeader */subHeader,
  /* countDown */countDown,
  /* spanEl */spanEl,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* horizonBoxElPlus */horizonBoxElPlus,
  /* settingButton */settingButton,
  /* infoButton */infoButton,
  /* infoIcon */infoIcon,
  /* checkIcon */checkIcon,
  /* someText */someText
];

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      console.log("Issue with int conversion in workout component");
      return 0;
    } else {
      throw exn;
    }
  }
}

function checkForInt(x) {
  var x2 = convToInt(x);
  if (x2 >= 0 && x2 < 100) {
    return x2;
  } else {
    return 0;
  }
}

function turnBackToString(theInt) {
  if (theInt !== 0) {
    return String(theInt);
  } else {
    return "0";
  }
}

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("Workout");

function make(week, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var repeater = $$Array.mapi((function (index, _) {
              var match = +(index % 2 === 1);
              var theStyle = match !== 0 ? mapElement : mapElementCol;
              var exId = Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */3], index);
              var block1 = React.createElement("div", {
                    className: initialBody
                  }, React.createElement("div", {
                        className: initialBodyImgContainer1
                      }, React.createElement("img", {
                            className: initialBodyImg,
                            alt: "image",
                            src: "/" + (String(exId) + "_l1_a.jpg")
                          })));
              var block2 = React.createElement("div", {
                    className: initialBody
                  }, React.createElement("div", {
                        className: initialBodyImgContainer
                      }, React.createElement("img", {
                            className: initialBodyImg,
                            alt: "image",
                            src: "/" + (String(exId) + "_l1_a.jpg")
                          })), React.createElement("div", {
                        className: initialBodyImgContainer
                      }, React.createElement("img", {
                            className: initialBodyImg,
                            alt: "image",
                            src: "/" + (String(exId) + "_l1_b.jpg")
                          })));
              var block3 = React.createElement("div", {
                    className: initialBody
                  }, React.createElement("div", {
                        className: initialBodyImgContainer
                      }, React.createElement("img", {
                            className: initialBodyImg,
                            alt: "",
                            src: "/" + (String(exId) + "_l1_a.jpg")
                          })), React.createElement("div", {
                        className: initialBodyImgContainer
                      }, React.createElement("img", {
                            className: initialBodyImg,
                            alt: "",
                            src: "/" + (String(exId) + "_l1_b.jpg")
                          })), React.createElement("div", {
                        className: initialBodyImgContainer
                      }, React.createElement("img", {
                            className: initialBodyImg,
                            alt: "",
                            src: "/" + (String(exId) + "_l1_c.jpg")
                          })));
              var match$1 = +(Caml_array.caml_array_get(self[/* state */2][/* bonusDoneWeek */4], index) === /* true */1);
              var match$2 = Caml_array.caml_array_get(self[/* state */2][/* showDetails */1], index);
              var tmp;
              if (match$2 !== 0) {
                var match$3 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId - 1 | 0), 0);
                tmp = React.createElement("div", {
                      className: flexList
                    }, match$3 !== 1 ? (
                        match$3 !== 2 ? block3 : block2
                      ) : block1);
              } else {
                tmp = null;
              }
              var match$4 = Caml_array.caml_array_get(self[/* state */2][/* showDetails */1], index);
              return React.createElement("div", {
                          key: String(index),
                          className: theStyle
                        }, React.createElement("div", {
                              className: horizonBox
                            }, React.createElement("div", {
                                  className: horizonBoxEl
                                }, Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */2], index)), React.createElement("div", {
                                  className: infoButton,
                                  onClick: (function () {
                                      return Curry._1(self[/* send */4], /* ToggleDetails */Block.__(3, [index]));
                                    })
                                }, React.createElement("img", {
                                      className: infoIcon,
                                      alt: "info",
                                      src: Info_iconSvg
                                    })), match$1 !== 0 ? React.createElement("div", {
                                    className: horizonBoxElRight,
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* UnCheckOne */Block.__(2, [index]));
                                      })
                                  }, React.createElement("img", {
                                        className: checkIcon,
                                        alt: "checkon",
                                        src: Check_onSvg
                                      })) : React.createElement("div", {
                                    className: horizonBoxElRight,
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* CheckOne */Block.__(1, [index]));
                                      })
                                  }, React.createElement("img", {
                                        className: checkIcon,
                                        alt: "checkoff",
                                        src: Check_offSvg
                                      }))), tmp, match$4 !== 0 ? React.createElement("div", {
                                className: someText
                              }, React.createElement("span", {
                                    dangerouslySetInnerHTML: {
                                      __html: Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseDescriptions, exId - 1 | 0)[/* description */1], 0)
                                    }
                                  })) : null);
            }), /* array */[
            1,
            1,
            1,
            1,
            1,
            1
          ]);
      return React.createElement("div", {
                  className: workout
                }, React.createElement("div", {
                      className: workoutBox
                    }, React.createElement("div", {
                          className: workoutBoxInner
                        }, React.createElement("div", {
                              className: workoutBoxHeader
                            }, React.createElement("img", {
                                  className: present,
                                  alt: "Present",
                                  src: Present_iconSvg
                                }), React.createElement("h1", {
                                  className: headHeader
                                }, "Bonus"), React.createElement("h2", {
                                  className: subHeader
                                }, "Workout")), repeater)), React.createElement("button", {
                      className: settingButton(/* () */0),
                      onClick: (function () {
                          return ReasonReact.Router[/* push */0]("/week/" + (week + "/workoutweek/"));
                        })
                    }, "Zurück"));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* workoutIndex */Caml_int32.imul(Caml_format.caml_int_of_string(week) - 1 | 0, 6) + (Caml_format.caml_int_of_string("6") - 1 | 0) | 0,
              /* showDetails : array */[
                /* false */0,
                /* false */0,
                /* false */0,
                /* false */0,
                /* false */0,
                /* false */0
              ],
              /* currentWorkoutExercises */Seed.getWorkoutTitles(week, "6"),
              /* currentWorkoutExercisesIds */Seed.getWorkoutIds(week, "6"),
              /* bonusDoneWeek */Caml_array.caml_array_get(Network.pullBonusConfig(/* () */0), Caml_format.caml_int_of_string(week) - 1 | 0),
              /* error : None */0,
              /* hide1 : false */0,
              /* hide2 : false */0,
              /* hide3 : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        var details = /* array */[
          /* false */0,
          /* false */0,
          /* false */0,
          /* false */0,
          /* false */0,
          /* false */0
        ];
        var newrecord = state.slice();
        return /* UpdateWithSideEffects */Block.__(3, [
                  (newrecord[/* showDetails */1] = details, newrecord),
                  (function () {
                      console.log("nextroute", "nextRoute");
                      return ReasonReact.Router[/* push */0]("/dashboard/");
                    })
                ]);
      } else {
        switch (action.tag | 0) {
          case 0 : 
              var item = action[0];
              console.log("hiding: ", item);
              if (item !== 1) {
                if (item !== 2) {
                  var newrecord$1 = state.slice();
                  return /* Update */Block.__(0, [(newrecord$1[/* hide3 */8] = /* true */1, newrecord$1)]);
                } else {
                  var newrecord$2 = state.slice();
                  return /* Update */Block.__(0, [(newrecord$2[/* hide2 */7] = /* true */1, newrecord$2)]);
                }
              } else {
                var newrecord$3 = state.slice();
                return /* Update */Block.__(0, [(newrecord$3[/* hide1 */6] = /* true */1, newrecord$3)]);
              }
          case 1 : 
              var newBonusDoneWeek = state[/* bonusDoneWeek */4];
              Caml_array.caml_array_set(newBonusDoneWeek, action[0], /* true */1);
              var newrecord$4 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$4[/* bonusDoneWeek */4] = newBonusDoneWeek, newrecord$4),
                        (function () {
                            return Network.writeBonusToLs(week, newBonusDoneWeek);
                          })
                      ]);
          case 2 : 
              var newBonusDoneWeek$1 = state[/* bonusDoneWeek */4];
              Caml_array.caml_array_set(newBonusDoneWeek$1, action[0], /* false */0);
              var newrecord$5 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$5[/* bonusDoneWeek */4] = newBonusDoneWeek$1, newrecord$5),
                        (function () {
                            return Network.writeBonusToLs(week, newBonusDoneWeek$1);
                          })
                      ]);
          case 3 : 
              var item$1 = action[0];
              var showDetailsNew = $$Array.mapi((function (index, oldEntry) {
                      var match = +(index === item$1);
                      if (match !== 0) {
                        return 1 - oldEntry;
                      } else {
                        return /* false */0;
                      }
                    }), state[/* showDetails */1]);
              var newrecord$6 = state.slice();
              return /* Update */Block.__(0, [(newrecord$6[/* showDetails */1] = showDetailsNew, newrecord$6)]);
          
        }
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.convToInt = convToInt;
exports.checkForInt = checkForInt;
exports.turnBackToString = turnBackToString;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/check_on.06f13f28.svg";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/check_off.ef0d4ed4.svg";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/present_icon.d2610ab1.svg";

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bonus_workout_pattern.05477bca.png";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE


var Css = __webpack_require__(4);
var Theme = __webpack_require__(6);
var React = __webpack_require__(1);
var ReasonReact = __webpack_require__(2);
var CardioPng = __webpack_require__(165);
var Heart_iconSvg = __webpack_require__(166);

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.backgroundImage(/* `url */[
                    5843823,
                    CardioPng
                  ]),
              /* :: */[
                Css.backgroundRepeat(/* repeat */108828507),
                /* :: */[
                  Css.background(Css.white),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var container = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.borderRadius(Css.px(10)),
              /* :: */[
                Css.boxShadow(/* Some */[Css.px(2)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(255, 191, 194, 0.29)),
                /* :: */[
                  Css.boxSizing(Css.borderBox),
                  /* :: */[
                    Css.margin4(Css.px(60), Css.px(10), Css.px(20), Css.px(10)),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var headerBox = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.background(/* `hex */[
                  5194459,
                  "FFFAFA"
                ]),
            /* :: */[
              Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
              /* :: */[
                Css.padding2(Css.px(0), Css.px(0)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.justifyContent(/* spaceAround */-485895757),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBoxEl = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.center),
          /* [] */0
        ]
      ]
    ]);

var heart = Css.style(/* :: */[
      Css.transform(/* `scale */[
            -120664438,
            /* tuple */[
              1.4,
              1.4
            ]
          ]),
      /* [] */0
    ]);

var placeHolder = Css.style(/* :: */[
      Css.width(Css.px(50)),
      /* [] */0
    ]);

var headHeader = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(4), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(5)),
        /* [] */0
      ]
    ]);

var subHeader = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.fontSize(Css.px(22)),
          /* [] */0
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.color(/* `hex */[
            5194459,
            "F66297"
          ]),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.margin4(Css.px(20), Css.px(0), Css.px(20), Css.px(0)),
          /* :: */[
            Css.padding2(Css.px(0), /* `percent */[
                  -119887163,
                  10.0
                ]),
            /* [] */0
          ]
        ]
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

function settingButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(12.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(50), Css.px(8), Css.px(10), Css.px(8)),
                  /* :: */[
                    Css.maxWidth(Css.em(13.0)),
                    Theme.greenButtonRaw
                  ]
                ]
              ]
            ]);
}

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* container */container,
  /* inputField */inputField,
  /* headerBox */headerBox,
  /* horizonBox */horizonBox,
  /* horizonBoxEl */horizonBoxEl,
  /* heart */heart,
  /* placeHolder */placeHolder,
  /* headHeader */headHeader,
  /* subHeader */subHeader,
  /* contentBox */contentBox,
  /* someLink */someLink,
  /* settingButton */settingButton
];

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("WorkoutWeekCardio");

function make(week, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("div", {
                          className: container
                        }, React.createElement("div", {
                              className: headerBox
                            }, React.createElement("div", {
                                  className: horizonBox
                                }, React.createElement("img", {
                                      className: heart,
                                      alt: "logo",
                                      src: Heart_iconSvg
                                    }), React.createElement("div", {
                                      className: horizonBoxEl
                                    }, React.createElement("h1", {
                                          className: headHeader
                                        }, "Cardio"), React.createElement("h2", {
                                          className: subHeader
                                        }, "Workout")), React.createElement("div", {
                                      className: placeHolder
                                    }))), React.createElement("div", {
                              className: contentBox
                            }, "Absolviere eine moderate Cardio-Einheit deiner Wahl oder pausiere optional einen Tag. Achte darauf, dass du bei der Wahl deiner Cardio-Einheit keine Belastung wählst, die deine Regeneration zu stark beeinflussen würde.")), React.createElement("button", {
                          className: settingButton(/* () */0),
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/week/" + (week + "/workoutweek/"));
                            })
                        }, "Zurück")));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cardio.712dfd9c.png";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/heart_icon.eb99d664.svg";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logout_icon.93278c56.svg";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mbb_logo_384.9e3475aa.png";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dashboard_icon.267f178a.svg";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logout_icon_hover.eef3b823.svg";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dashboard_icon_hover.757d1db5.svg";

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ReactDom = __webpack_require__(174);
var Caml_builtin_exceptions = __webpack_require__(3);

function renderToElementWithClassName(reactElement, className) {
  var elements = document.getElementsByClassName(className);
  if (elements.length !== 0) {
    ReactDom.render(reactElement, elements[0]);
    return /* () */0;
  } else {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "ReactDOMRe.renderToElementWithClassName: no element of class " + (className + " found in the HTML.")
        ];
  }
}

function renderToElementWithId(reactElement, id) {
  var match = document.getElementById(id);
  if (match == null) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "ReactDOMRe.renderToElementWithId : no element of id " + (id + " found in the HTML.")
        ];
  } else {
    ReactDom.render(reactElement, match);
    return /* () */0;
  }
}

function hydrateToElementWithClassName(reactElement, className) {
  var elements = document.getElementsByClassName(className);
  if (elements.length !== 0) {
    ReactDom.hydrate(reactElement, elements[0]);
    return /* () */0;
  } else {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "ReactDOMRe.hydrateToElementWithClassName: no element of class " + (className + " found in the HTML.")
        ];
  }
}

function hydrateToElementWithId(reactElement, id) {
  var match = document.getElementById(id);
  if (match == null) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "ReactDOMRe.hydrateToElementWithId : no element of id " + (id + " found in the HTML.")
        ];
  } else {
    ReactDom.hydrate(reactElement, match);
    return /* () */0;
  }
}

function combine(a, b) {
  return Object.assign(Object.assign({ }, a), b);
}

function unsafeAddProp(style, property, value) {
  var dict = { };
  dict[property] = value;
  return combine(style, dict);
}

var Style = /* module */[
  /* combine */combine,
  /* unsafeAddProp */unsafeAddProp
];

exports.renderToElementWithClassName = renderToElementWithClassName;
exports.renderToElementWithId = renderToElementWithId;
exports.hydrateToElementWithClassName = hydrateToElementWithClassName;
exports.hydrateToElementWithId = hydrateToElementWithId;
exports.Style = Style;
/* react-dom Not a pure module */


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(175);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(1),l=__webpack_require__(176),B=__webpack_require__(18),C=__webpack_require__(26),ba=__webpack_require__(177),da=__webpack_require__(178),ea=__webpack_require__(179),fa=__webpack_require__(180),ia=__webpack_require__(183),D=__webpack_require__(41);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(26);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(181);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(182);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = register;
/* harmony export (immutable) */ __webpack_exports__["unregister"] = unregister;
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.1cdff698.js